import * as React from 'react';
import React__default, { forwardRef, useContext, createContext, createElement as createElement$3, Fragment, useRef, useLayoutEffect, Component, useState, useEffect, useCallback, useMemo, useImperativeHandle } from 'react';
import ReactDOM, { createPortal } from 'react-dom';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$1o =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$$ = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$_ = fails$$;

// Detect IE8's incomplete defineProperty implementation
var descriptors$1 = !fails$_(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var call$r = Function.prototype.call;

var functionCall = call$r.bind ? call$r.bind(call$r) : function () {
  return call$r.apply(call$r, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable$2 = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$8 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$8 && !$propertyIsEnumerable$2.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$8(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable$2;

var createPropertyDescriptor$8 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var FunctionPrototype$4 = Function.prototype;
var bind$f = FunctionPrototype$4.bind;
var call$q = FunctionPrototype$4.call;
var uncurryThis$W = bind$f && bind$f.bind(call$q, call$q);

var functionUncurryThis = bind$f ? function (fn) {
  return fn && uncurryThis$W(fn);
} : function (fn) {
  return fn && function () {
    return call$q.apply(fn, arguments);
  };
};

var uncurryThis$V = functionUncurryThis;

var toString$o = uncurryThis$V({}.toString);
var stringSlice$c = uncurryThis$V(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice$c(toString$o(it), 8, -1);
};

var global$1n = global$1o;
var uncurryThis$U = functionUncurryThis;
var fails$Z = fails$$;
var classof$g = classofRaw$1;

var Object$5 = global$1n.Object;
var split$3 = uncurryThis$U(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$Z(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object$5('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$g(it) == 'String' ? split$3(it, '') : Object$5(it);
} : Object$5;

var global$1m = global$1o;

var TypeError$p = global$1m.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$e = function (it) {
  if (it == undefined) throw TypeError$p("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$4 = indexedObject;
var requireObjectCoercible$d = requireObjectCoercible$e;

var toIndexedObject$f = function (it) {
  return IndexedObject$4(requireObjectCoercible$d(it));
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$r = function (argument) {
  return typeof argument == 'function';
};

var isCallable$q = isCallable$r;

var isObject$z = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$q(it);
};

var global$1l = global$1o;
var isCallable$p = isCallable$r;

var aFunction = function (argument) {
  return isCallable$p(argument) ? argument : undefined;
};

var getBuiltIn$c = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$1l[namespace]) : global$1l[namespace] && global$1l[namespace][method];
};

var uncurryThis$T = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$T({}.isPrototypeOf);

var getBuiltIn$b = getBuiltIn$c;

var engineUserAgent = getBuiltIn$b('navigator', 'userAgent') || '';

var global$1k = global$1o;
var userAgent$7 = engineUserAgent;

var process$5 = global$1k.process;
var Deno = global$1k.Deno;
var versions = process$5 && process$5.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match$1, version;

if (v8) {
  match$1 = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match$1[0] > 0 && match$1[0] < 4 ? 1 : +(match$1[0] + match$1[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$7) {
  match$1 = userAgent$7.match(/Edge\/(\d+)/);
  if (!match$1 || match$1[1] >= 74) {
    match$1 = userAgent$7.match(/Chrome\/(\d+)/);
    if (match$1) version = +match$1[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION$3 = engineV8Version;
var fails$Y = fails$$;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$Y(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$3 && V8_VERSION$3 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$3 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$3
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var global$1j = global$1o;
var getBuiltIn$a = getBuiltIn$c;
var isCallable$o = isCallable$r;
var isPrototypeOf$9 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var Object$4 = global$1j.Object;

var isSymbol$6 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$a('Symbol');
  return isCallable$o($Symbol) && isPrototypeOf$9($Symbol.prototype, Object$4(it));
};

var global$1i = global$1o;

var String$6 = global$1i.String;

var tryToString$5 = function (argument) {
  try {
    return String$6(argument);
  } catch (error) {
    return 'Object';
  }
};

var global$1h = global$1o;
var isCallable$n = isCallable$r;
var tryToString$4 = tryToString$5;

var TypeError$o = global$1h.TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$d = function (argument) {
  if (isCallable$n(argument)) return argument;
  throw TypeError$o(tryToString$4(argument) + ' is not a function');
};

var aCallable$c = aCallable$d;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$7 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable$c(func);
};

var global$1g = global$1o;
var call$p = functionCall;
var isCallable$m = isCallable$r;
var isObject$y = isObject$z;

var TypeError$n = global$1g.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$2 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$m(fn = input.toString) && !isObject$y(val = call$p(fn, input))) return val;
  if (isCallable$m(fn = input.valueOf) && !isObject$y(val = call$p(fn, input))) return val;
  if (pref !== 'string' && isCallable$m(fn = input.toString) && !isObject$y(val = call$p(fn, input))) return val;
  throw TypeError$n("Can't convert object to primitive value");
};

var shared$5 = {exports: {}};

var isPure = false;

var global$1f = global$1o;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$c = Object.defineProperty;

var setGlobal$3 = function (key, value) {
  try {
    defineProperty$c(global$1f, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$1f[key] = value;
  } return value;
};

var global$1e = global$1o;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$1e[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$5.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.20.2',
  mode: 'global',
  copyright: '© 2022 Denis Pushkarev (zloirock.ru)'
});

var global$1d = global$1o;
var requireObjectCoercible$c = requireObjectCoercible$e;

var Object$3 = global$1d.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$o = function (argument) {
  return Object$3(requireObjectCoercible$c(argument));
};

var uncurryThis$S = functionUncurryThis;
var toObject$n = toObject$o;

var hasOwnProperty$3 = uncurryThis$S({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty$3(toObject$n(it), key);
};

var uncurryThis$R = functionUncurryThis;

var id$2 = 0;
var postfix = Math.random();
var toString$n = uncurryThis$R(1.0.toString);

var uid$5 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$n(++id$2 + postfix, 36);
};

var global$1c = global$1o;
var shared$4 = shared$5.exports;
var hasOwn$n = hasOwnProperty_1;
var uid$4 = uid$5;
var NATIVE_SYMBOL$2 = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore$1 = shared$4('wks');
var Symbol$3 = global$1c.Symbol;
var symbolFor = Symbol$3 && Symbol$3['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$3 : Symbol$3 && Symbol$3.withoutSetter || uid$4;

var wellKnownSymbol$v = function (name) {
  if (!hasOwn$n(WellKnownSymbolsStore$1, name) || !(NATIVE_SYMBOL$2 || typeof WellKnownSymbolsStore$1[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL$2 && hasOwn$n(Symbol$3, name)) {
      WellKnownSymbolsStore$1[name] = Symbol$3[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore$1[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore$1[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore$1[name];
};

var global$1b = global$1o;
var call$o = functionCall;
var isObject$x = isObject$z;
var isSymbol$5 = isSymbol$6;
var getMethod$6 = getMethod$7;
var ordinaryToPrimitive$1 = ordinaryToPrimitive$2;
var wellKnownSymbol$u = wellKnownSymbol$v;

var TypeError$m = global$1b.TypeError;
var TO_PRIMITIVE$2 = wellKnownSymbol$u('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$2 = function (input, pref) {
  if (!isObject$x(input) || isSymbol$5(input)) return input;
  var exoticToPrim = getMethod$6(input, TO_PRIMITIVE$2);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$o(exoticToPrim, input, pref);
    if (!isObject$x(result) || isSymbol$5(result)) return result;
    throw TypeError$m("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive$1(input, pref);
};

var toPrimitive$1 = toPrimitive$2;
var isSymbol$4 = isSymbol$6;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$8 = function (argument) {
  var key = toPrimitive$1(argument, 'string');
  return isSymbol$4(key) ? key : key + '';
};

var global$1a = global$1o;
var isObject$w = isObject$z;

var document$3 = global$1a.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$w(document$3) && isObject$w(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$t = descriptors$1;
var fails$X = fails$$;
var createElement$2 = documentCreateElement$2;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !DESCRIPTORS$t && !fails$X(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$2('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$s = descriptors$1;
var call$n = functionCall;
var propertyIsEnumerableModule$2 = objectPropertyIsEnumerable;
var createPropertyDescriptor$7 = createPropertyDescriptor$8;
var toIndexedObject$e = toIndexedObject$f;
var toPropertyKey$7 = toPropertyKey$8;
var hasOwn$m = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$s ? $getOwnPropertyDescriptor$2 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$e(O);
  P = toPropertyKey$7(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$2(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$m(O, P)) return createPropertyDescriptor$7(!call$n(propertyIsEnumerableModule$2.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$r = descriptors$1;
var fails$W = fails$$;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$r && fails$W(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var global$19 = global$1o;
var isObject$v = isObject$z;

var String$5 = global$19.String;
var TypeError$l = global$19.TypeError;

// `Assert: Type(argument) is Object`
var anObject$y = function (argument) {
  if (isObject$v(argument)) return argument;
  throw TypeError$l(String$5(argument) + ' is not an object');
};

var global$18 = global$1o;
var DESCRIPTORS$q = descriptors$1;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$x = anObject$y;
var toPropertyKey$6 = toPropertyKey$8;

var TypeError$k = global$18.TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty$1 = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$q ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$x(O);
  P = toPropertyKey$6(P);
  anObject$x(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor$1(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty$1(O, P, Attributes);
} : $defineProperty$1 : function defineProperty(O, P, Attributes) {
  anObject$x(O);
  P = toPropertyKey$6(P);
  anObject$x(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty$1(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError$k('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$p = descriptors$1;
var definePropertyModule$c = objectDefineProperty;
var createPropertyDescriptor$6 = createPropertyDescriptor$8;

var createNonEnumerableProperty$b = DESCRIPTORS$p ? function (object, key, value) {
  return definePropertyModule$c.f(object, key, createPropertyDescriptor$6(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var redefine$h = {exports: {}};

var uncurryThis$Q = functionUncurryThis;
var isCallable$l = isCallable$r;
var store$1 = sharedStore;

var functionToString$1 = uncurryThis$Q(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$l(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString$1(it);
  };
}

var inspectSource$4 = store$1.inspectSource;

var global$17 = global$1o;
var isCallable$k = isCallable$r;
var inspectSource$3 = inspectSource$4;

var WeakMap$2 = global$17.WeakMap;

var nativeWeakMap = isCallable$k(WeakMap$2) && /native code/.test(inspectSource$3(WeakMap$2));

var shared$3 = shared$5.exports;
var uid$3 = uid$5;

var keys$3 = shared$3('keys');

var sharedKey$4 = function (key) {
  return keys$3[key] || (keys$3[key] = uid$3(key));
};

var hiddenKeys$6 = {};

var NATIVE_WEAK_MAP$1 = nativeWeakMap;
var global$16 = global$1o;
var uncurryThis$P = functionUncurryThis;
var isObject$u = isObject$z;
var createNonEnumerableProperty$a = createNonEnumerableProperty$b;
var hasOwn$l = hasOwnProperty_1;
var shared$2 = sharedStore;
var sharedKey$3 = sharedKey$4;
var hiddenKeys$5 = hiddenKeys$6;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$j = global$16.TypeError;
var WeakMap$1 = global$16.WeakMap;
var set$3, get$2, has$3;

var enforce = function (it) {
  return has$3(it) ? get$2(it) : set$3(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$u(it) || (state = get$2(it)).type !== TYPE) {
      throw TypeError$j('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP$1 || shared$2.state) {
  var store = shared$2.state || (shared$2.state = new WeakMap$1());
  var wmget = uncurryThis$P(store.get);
  var wmhas = uncurryThis$P(store.has);
  var wmset = uncurryThis$P(store.set);
  set$3 = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError$j(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get$2 = function (it) {
    return wmget(store, it) || {};
  };
  has$3 = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey$3('state');
  hiddenKeys$5[STATE] = true;
  set$3 = function (it, metadata) {
    if (hasOwn$l(it, STATE)) throw new TypeError$j(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$a(it, STATE, metadata);
    return metadata;
  };
  get$2 = function (it) {
    return hasOwn$l(it, STATE) ? it[STATE] : {};
  };
  has$3 = function (it) {
    return hasOwn$l(it, STATE);
  };
}

var internalState = {
  set: set$3,
  get: get$2,
  has: has$3,
  enforce: enforce,
  getterFor: getterFor
};

var DESCRIPTORS$o = descriptors$1;
var hasOwn$k = hasOwnProperty_1;

var FunctionPrototype$3 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$o && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$k(FunctionPrototype$3, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$o || (DESCRIPTORS$o && getDescriptor(FunctionPrototype$3, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var global$15 = global$1o;
var isCallable$j = isCallable$r;
var hasOwn$j = hasOwnProperty_1;
var createNonEnumerableProperty$9 = createNonEnumerableProperty$b;
var setGlobal$1 = setGlobal$3;
var inspectSource$2 = inspectSource$4;
var InternalStateModule$a = internalState;
var CONFIGURABLE_FUNCTION_NAME$2 = functionName.CONFIGURABLE;

var getInternalState$7 = InternalStateModule$a.get;
var enforceInternalState$2 = InternalStateModule$a.enforce;
var TEMPLATE = String(String).split('String');

(redefine$h.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable$j(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!hasOwn$j(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$2 && value.name !== name)) {
      createNonEnumerableProperty$9(value, 'name', name);
    }
    state = enforceInternalState$2(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global$15) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$9(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable$j(this) && getInternalState$7(this).source || inspectSource$2(this);
});

var objectGetOwnPropertyNames = {};

var ceil$2 = Math.ceil;
var floor$a = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$c = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor$a : ceil$2)(number);
};

var toIntegerOrInfinity$b = toIntegerOrInfinity$c;

var max$5 = Math.max;
var min$9 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$9 = function (index, length) {
  var integer = toIntegerOrInfinity$b(index);
  return integer < 0 ? max$5(integer + length, 0) : min$9(integer, length);
};

var toIntegerOrInfinity$a = toIntegerOrInfinity$c;

var min$8 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$c = function (argument) {
  return argument > 0 ? min$8(toIntegerOrInfinity$a(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$b = toLength$c;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$k = function (obj) {
  return toLength$b(obj.length);
};

var toIndexedObject$d = toIndexedObject$f;
var toAbsoluteIndex$8 = toAbsoluteIndex$9;
var lengthOfArrayLike$j = lengthOfArrayLike$k;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$6 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$d($this);
    var length = lengthOfArrayLike$j(O);
    var index = toAbsoluteIndex$8(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$6(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$6(false)
};

var uncurryThis$O = functionUncurryThis;
var hasOwn$i = hasOwnProperty_1;
var toIndexedObject$c = toIndexedObject$f;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$4 = hiddenKeys$6;

var push$b = uncurryThis$O([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$c(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$i(hiddenKeys$4, key) && hasOwn$i(O, key) && push$b(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$i(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$b(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$3 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$3);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$9 = getBuiltIn$c;
var uncurryThis$N = functionUncurryThis;
var getOwnPropertyNamesModule$2 = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$2 = objectGetOwnPropertySymbols;
var anObject$w = anObject$y;

var concat$3 = uncurryThis$N([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$8 = getBuiltIn$9('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule$2.f(anObject$w(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$2.f;
  return getOwnPropertySymbols ? concat$3(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$h = hasOwnProperty_1;
var ownKeys$7 = ownKeys$8;
var getOwnPropertyDescriptorModule$6 = objectGetOwnPropertyDescriptor;
var definePropertyModule$b = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys$7(source);
  var defineProperty = definePropertyModule$b.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule$6.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$h(target, key) && !(exceptions && hasOwn$h(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$V = fails$$;
var isCallable$i = isCallable$r;

var replacement = /#|\.prototype\./;

var isForced$5 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$i(detection) ? fails$V(detection)
    : !!detection;
};

var normalize = isForced$5.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$5.data = {};
var NATIVE = isForced$5.NATIVE = 'N';
var POLYFILL = isForced$5.POLYFILL = 'P';

var isForced_1 = isForced$5;

var global$14 = global$1o;
var getOwnPropertyDescriptor$7 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$8 = createNonEnumerableProperty$b;
var redefine$g = redefine$h.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced$4 = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$14;
  } else if (STATIC) {
    target = global$14[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$14[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$7(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$4(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$8(sourceProperty, 'sham', true);
    }
    // extend global
    redefine$g(target, key, sourceProperty, options);
  }
};

var FunctionPrototype$2 = Function.prototype;
var apply$8 = FunctionPrototype$2.apply;
var bind$e = FunctionPrototype$2.bind;
var call$m = FunctionPrototype$2.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply$1 = typeof Reflect == 'object' && Reflect.apply || (bind$e ? call$m.bind(apply$8) : function () {
  return call$m.apply(apply$8, arguments);
});

var classof$f = classofRaw$1;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$8 = Array.isArray || function isArray(argument) {
  return classof$f(argument) == 'Array';
};

var wellKnownSymbol$t = wellKnownSymbol$v;

var TO_STRING_TAG$4 = wellKnownSymbol$t('toStringTag');
var test$2 = {};

test$2[TO_STRING_TAG$4] = 'z';

var toStringTagSupport = String(test$2) === '[object z]';

var global$13 = global$1o;
var TO_STRING_TAG_SUPPORT$2 = toStringTagSupport;
var isCallable$h = isCallable$r;
var classofRaw = classofRaw$1;
var wellKnownSymbol$s = wellKnownSymbol$v;

var TO_STRING_TAG$3 = wellKnownSymbol$s('toStringTag');
var Object$2 = global$13.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$e = TO_STRING_TAG_SUPPORT$2 ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object$2(it), TO_STRING_TAG$3)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$h(O.callee) ? 'Arguments' : result;
};

var global$12 = global$1o;
var classof$d = classof$e;

var String$4 = global$12.String;

var toString$m = function (argument) {
  if (classof$d(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String$4(argument);
};

var objectDefineProperties = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$4 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$n = descriptors$1;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$a = objectDefineProperty;
var anObject$v = anObject$y;
var toIndexedObject$b = toIndexedObject$f;
var objectKeys$3 = objectKeys$4;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$n && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$v(O);
  var props = toIndexedObject$b(Properties);
  var keys = objectKeys$3(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$a.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$8 = getBuiltIn$c;

var html$2 = getBuiltIn$8('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */

var anObject$u = anObject$y;
var definePropertiesModule$1 = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys$2 = hiddenKeys$6;
var html$1 = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$2 = sharedKey$4;

var GT = '>';
var LT = '<';
var PROTOTYPE$2 = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$2('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE$2][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys$2[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE$2] = anObject$u(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE$2] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule$1.f(result, Properties);
};

var objectGetOwnPropertyNamesExternal = {};

var toPropertyKey$5 = toPropertyKey$8;
var definePropertyModule$9 = objectDefineProperty;
var createPropertyDescriptor$5 = createPropertyDescriptor$8;

var createProperty$8 = function (object, key, value) {
  var propertyKey = toPropertyKey$5(key);
  if (propertyKey in object) definePropertyModule$9.f(object, propertyKey, createPropertyDescriptor$5(0, value));
  else object[propertyKey] = value;
};

var global$11 = global$1o;
var toAbsoluteIndex$7 = toAbsoluteIndex$9;
var lengthOfArrayLike$i = lengthOfArrayLike$k;
var createProperty$7 = createProperty$8;

var Array$8 = global$11.Array;
var max$4 = Math.max;

var arraySliceSimple = function (O, start, end) {
  var length = lengthOfArrayLike$i(O);
  var k = toAbsoluteIndex$7(start, length);
  var fin = toAbsoluteIndex$7(end === undefined ? length : end, length);
  var result = Array$8(max$4(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty$7(result, n, O[k]);
  result.length = n;
  return result;
};

/* eslint-disable es/no-object-getownpropertynames -- safe */

var classof$c = classofRaw$1;
var toIndexedObject$a = toIndexedObject$f;
var $getOwnPropertyNames$1 = objectGetOwnPropertyNames.f;
var arraySlice$b = arraySliceSimple;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames$1(it);
  } catch (error) {
    return arraySlice$b(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
objectGetOwnPropertyNamesExternal.f = function getOwnPropertyNames(it) {
  return windowNames && classof$c(it) == 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames$1(toIndexedObject$a(it));
};

var uncurryThis$M = functionUncurryThis;

var arraySlice$a = uncurryThis$M([].slice);

var wellKnownSymbolWrapped = {};

var wellKnownSymbol$r = wellKnownSymbol$v;

wellKnownSymbolWrapped.f = wellKnownSymbol$r;

var global$10 = global$1o;

var path$1 = global$10;

var path = path$1;
var hasOwn$g = hasOwnProperty_1;
var wrappedWellKnownSymbolModule$1 = wellKnownSymbolWrapped;
var defineProperty$b = objectDefineProperty.f;

var defineWellKnownSymbol$d = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn$g(Symbol, NAME)) defineProperty$b(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule$1.f(NAME)
  });
};

var defineProperty$a = objectDefineProperty.f;
var hasOwn$f = hasOwnProperty_1;
var wellKnownSymbol$q = wellKnownSymbol$v;

var TO_STRING_TAG$2 = wellKnownSymbol$q('toStringTag');

var setToStringTag$a = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$f(target, TO_STRING_TAG$2)) {
    defineProperty$a(target, TO_STRING_TAG$2, { configurable: true, value: TAG });
  }
};

var uncurryThis$L = functionUncurryThis;
var aCallable$b = aCallable$d;

var bind$d = uncurryThis$L(uncurryThis$L.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$b(fn);
  return that === undefined ? fn : bind$d ? bind$d(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var uncurryThis$K = functionUncurryThis;
var fails$U = fails$$;
var isCallable$g = isCallable$r;
var classof$b = classof$e;
var getBuiltIn$7 = getBuiltIn$c;
var inspectSource$1 = inspectSource$4;

var noop$7 = function () { /* empty */ };
var empty = [];
var construct$1 = getBuiltIn$7('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$6 = uncurryThis$K(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop$7);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$g(argument)) return false;
  try {
    construct$1(noop$7, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$g(argument)) return false;
  switch (classof$b(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$6(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$5 = !construct$1 || fails$U(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var global$$ = global$1o;
var isArray$7 = isArray$8;
var isConstructor$4 = isConstructor$5;
var isObject$t = isObject$z;
var wellKnownSymbol$p = wellKnownSymbol$v;

var SPECIES$6 = wellKnownSymbol$p('species');
var Array$7 = global$$.Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray$7(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor$4(C) && (C === Array$7 || isArray$7(C.prototype))) C = undefined;
    else if (isObject$t(C)) {
      C = C[SPECIES$6];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array$7 : C;
};

var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$5 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var bind$c = functionBindContext;
var uncurryThis$J = functionUncurryThis;
var IndexedObject$3 = indexedObject;
var toObject$m = toObject$o;
var lengthOfArrayLike$h = lengthOfArrayLike$k;
var arraySpeciesCreate$4 = arraySpeciesCreate$5;

var push$a = uncurryThis$J([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod$5 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject$m($this);
    var self = IndexedObject$3(O);
    var boundFunction = bind$c(callbackfn, that);
    var length = lengthOfArrayLike$h(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate$4;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push$a(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push$a(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$5(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$5(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$5(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$5(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$5(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$5(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$5(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod$5(7)
};

var $$1V = _export;
var global$_ = global$1o;
var getBuiltIn$6 = getBuiltIn$c;
var apply$7 = functionApply$1;
var call$l = functionCall;
var uncurryThis$I = functionUncurryThis;
var DESCRIPTORS$m = descriptors$1;
var NATIVE_SYMBOL$1 = nativeSymbol;
var fails$T = fails$$;
var hasOwn$e = hasOwnProperty_1;
var isArray$6 = isArray$8;
var isCallable$f = isCallable$r;
var isObject$s = isObject$z;
var isPrototypeOf$8 = objectIsPrototypeOf;
var isSymbol$3 = isSymbol$6;
var anObject$t = anObject$y;
var toObject$l = toObject$o;
var toIndexedObject$9 = toIndexedObject$f;
var toPropertyKey$4 = toPropertyKey$8;
var $toString$3 = toString$m;
var createPropertyDescriptor$4 = createPropertyDescriptor$8;
var nativeObjectCreate = objectCreate;
var objectKeys$2 = objectKeys$4;
var getOwnPropertyNamesModule$1 = objectGetOwnPropertyNames;
var getOwnPropertyNamesExternal = objectGetOwnPropertyNamesExternal;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var getOwnPropertyDescriptorModule$5 = objectGetOwnPropertyDescriptor;
var definePropertyModule$8 = objectDefineProperty;
var definePropertiesModule = objectDefineProperties;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var arraySlice$9 = arraySlice$a;
var redefine$f = redefine$h.exports;
var shared$1 = shared$5.exports;
var sharedKey$1 = sharedKey$4;
var hiddenKeys$1 = hiddenKeys$6;
var uid$2 = uid$5;
var wellKnownSymbol$o = wellKnownSymbol$v;
var wrappedWellKnownSymbolModule = wellKnownSymbolWrapped;
var defineWellKnownSymbol$c = defineWellKnownSymbol$d;
var setToStringTag$9 = setToStringTag$a;
var InternalStateModule$9 = internalState;
var $forEach$2 = arrayIteration.forEach;

var HIDDEN = sharedKey$1('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE$1 = 'prototype';
var TO_PRIMITIVE$1 = wellKnownSymbol$o('toPrimitive');

var setInternalState$9 = InternalStateModule$9.set;
var getInternalState$6 = InternalStateModule$9.getterFor(SYMBOL);

var ObjectPrototype$4 = Object[PROTOTYPE$1];
var $Symbol = global$_.Symbol;
var SymbolPrototype$1 = $Symbol && $Symbol[PROTOTYPE$1];
var TypeError$i = global$_.TypeError;
var QObject = global$_.QObject;
var $stringify = getBuiltIn$6('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor$2 = getOwnPropertyDescriptorModule$5.f;
var nativeDefineProperty$1 = definePropertyModule$8.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule$1.f;
var push$9 = uncurryThis$I([].push);

var AllSymbols = shared$1('symbols');
var ObjectPrototypeSymbols = shared$1('op-symbols');
var StringToSymbolRegistry = shared$1('string-to-symbol-registry');
var SymbolToStringRegistry = shared$1('symbol-to-string-registry');
var WellKnownSymbolsStore = shared$1('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE$1] || !QObject[PROTOTYPE$1].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS$m && fails$T(function () {
  return nativeObjectCreate(nativeDefineProperty$1({}, 'a', {
    get: function () { return nativeDefineProperty$1(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor$2(ObjectPrototype$4, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype$4[P];
  nativeDefineProperty$1(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype$4) {
    nativeDefineProperty$1(ObjectPrototype$4, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty$1;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype$1);
  setInternalState$9(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS$m) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype$4) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject$t(O);
  var key = toPropertyKey$4(P);
  anObject$t(Attributes);
  if (hasOwn$e(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn$e(O, HIDDEN)) nativeDefineProperty$1(O, HIDDEN, createPropertyDescriptor$4(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn$e(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor$4(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty$1(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject$t(O);
  var properties = toIndexedObject$9(Properties);
  var keys = objectKeys$2(properties).concat($getOwnPropertySymbols(properties));
  $forEach$2(keys, function (key) {
    if (!DESCRIPTORS$m || call$l($propertyIsEnumerable$1, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable$1 = function propertyIsEnumerable(V) {
  var P = toPropertyKey$4(V);
  var enumerable = call$l(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype$4 && hasOwn$e(AllSymbols, P) && !hasOwn$e(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn$e(this, P) || !hasOwn$e(AllSymbols, P) || hasOwn$e(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject$9(O);
  var key = toPropertyKey$4(P);
  if (it === ObjectPrototype$4 && hasOwn$e(AllSymbols, key) && !hasOwn$e(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor$2(it, key);
  if (descriptor && hasOwn$e(AllSymbols, key) && !(hasOwn$e(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject$9(O));
  var result = [];
  $forEach$2(names, function (key) {
    if (!hasOwn$e(AllSymbols, key) && !hasOwn$e(hiddenKeys$1, key)) push$9(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype$4;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject$9(O));
  var result = [];
  $forEach$2(names, function (key) {
    if (hasOwn$e(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn$e(ObjectPrototype$4, key))) {
      push$9(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL$1) {
  $Symbol = function Symbol() {
    if (isPrototypeOf$8(SymbolPrototype$1, this)) throw TypeError$i('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString$3(arguments[0]);
    var tag = uid$2(description);
    var setter = function (value) {
      if (this === ObjectPrototype$4) call$l(setter, ObjectPrototypeSymbols, value);
      if (hasOwn$e(this, HIDDEN) && hasOwn$e(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor$4(1, value));
    };
    if (DESCRIPTORS$m && USE_SETTER) setSymbolDescriptor(ObjectPrototype$4, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype$1 = $Symbol[PROTOTYPE$1];

  redefine$f(SymbolPrototype$1, 'toString', function toString() {
    return getInternalState$6(this).tag;
  });

  redefine$f($Symbol, 'withoutSetter', function (description) {
    return wrap(uid$2(description), description);
  });

  propertyIsEnumerableModule$1.f = $propertyIsEnumerable$1;
  definePropertyModule$8.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule$5.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule$1.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule$1.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol$o(name), name);
  };

  if (DESCRIPTORS$m) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty$1(SymbolPrototype$1, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState$6(this).description;
      }
    });
    {
      redefine$f(ObjectPrototype$4, 'propertyIsEnumerable', $propertyIsEnumerable$1, { unsafe: true });
    }
  }
}

$$1V({ global: true, wrap: true, forced: !NATIVE_SYMBOL$1, sham: !NATIVE_SYMBOL$1 }, {
  Symbol: $Symbol
});

$forEach$2(objectKeys$2(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol$c(name);
});

$$1V({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL$1 }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = $toString$3(key);
    if (hasOwn$e(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol$3(sym)) throw TypeError$i(sym + ' is not a symbol');
    if (hasOwn$e(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$$1V({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL$1, sham: !DESCRIPTORS$m }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$$1V({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL$1 }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$$1V({ target: 'Object', stat: true, forced: fails$T(function () { getOwnPropertySymbolsModule$1.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule$1.f(toObject$l(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL$1 || fails$T(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $$1V({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice$9(arguments);
      var $replacer = replacer;
      if (!isObject$s(replacer) && it === undefined || isSymbol$3(it)) return; // IE8 returns string on undefined
      if (!isArray$6(replacer)) replacer = function (key, value) {
        if (isCallable$f($replacer)) value = call$l($replacer, this, key, value);
        if (!isSymbol$3(value)) return value;
      };
      args[1] = replacer;
      return apply$7($stringify, null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!SymbolPrototype$1[TO_PRIMITIVE$1]) {
  var valueOf = SymbolPrototype$1.valueOf;
  // eslint-disable-next-line no-unused-vars -- required for .length
  redefine$f(SymbolPrototype$1, TO_PRIMITIVE$1, function (hint) {
    // TODO: improve hint logic
    return call$l(valueOf, this);
  });
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag$9($Symbol, SYMBOL);

hiddenKeys$1[HIDDEN] = true;

var $$1U = _export;
var DESCRIPTORS$l = descriptors$1;
var global$Z = global$1o;
var uncurryThis$H = functionUncurryThis;
var hasOwn$d = hasOwnProperty_1;
var isCallable$e = isCallable$r;
var isPrototypeOf$7 = objectIsPrototypeOf;
var toString$l = toString$m;
var defineProperty$9 = objectDefineProperty.f;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = global$Z.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS$l && isCallable$e(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString$l(arguments[0]);
    var result = isPrototypeOf$7(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var symbolToString = uncurryThis$H(SymbolPrototype.toString);
  var symbolValueOf = uncurryThis$H(SymbolPrototype.valueOf);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace$a = uncurryThis$H(''.replace);
  var stringSlice$b = uncurryThis$H(''.slice);

  defineProperty$9(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = symbolValueOf(this);
      var string = symbolToString(symbol);
      if (hasOwn$d(EmptyStringDescriptionStore, symbol)) return '';
      var desc = NATIVE_SYMBOL ? stringSlice$b(string, 7, -1) : replace$a(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $$1U({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

var defineWellKnownSymbol$b = defineWellKnownSymbol$d;

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol$b('asyncIterator');

var defineWellKnownSymbol$a = defineWellKnownSymbol$d;

// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
defineWellKnownSymbol$a('hasInstance');

var defineWellKnownSymbol$9 = defineWellKnownSymbol$d;

// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
defineWellKnownSymbol$9('isConcatSpreadable');

var defineWellKnownSymbol$8 = defineWellKnownSymbol$d;

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol$8('iterator');

var defineWellKnownSymbol$7 = defineWellKnownSymbol$d;

// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
defineWellKnownSymbol$7('match');

var defineWellKnownSymbol$6 = defineWellKnownSymbol$d;

// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
defineWellKnownSymbol$6('replace');

var defineWellKnownSymbol$5 = defineWellKnownSymbol$d;

// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
defineWellKnownSymbol$5('search');

var defineWellKnownSymbol$4 = defineWellKnownSymbol$d;

// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
defineWellKnownSymbol$4('species');

var defineWellKnownSymbol$3 = defineWellKnownSymbol$d;

// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
defineWellKnownSymbol$3('split');

var defineWellKnownSymbol$2 = defineWellKnownSymbol$d;

// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol$2('toPrimitive');

var defineWellKnownSymbol$1 = defineWellKnownSymbol$d;

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol$1('toStringTag');

var defineWellKnownSymbol = defineWellKnownSymbol$d;

// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
defineWellKnownSymbol('unscopables');

var fails$S = fails$$;
var wellKnownSymbol$n = wellKnownSymbol$v;
var V8_VERSION$2 = engineV8Version;

var SPECIES$5 = wellKnownSymbol$n('species');

var arrayMethodHasSpeciesSupport$5 = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION$2 >= 51 || !fails$S(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$5] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var $$1T = _export;
var global$Y = global$1o;
var fails$R = fails$$;
var isArray$5 = isArray$8;
var isObject$r = isObject$z;
var toObject$k = toObject$o;
var lengthOfArrayLike$g = lengthOfArrayLike$k;
var createProperty$6 = createProperty$8;
var arraySpeciesCreate$3 = arraySpeciesCreate$5;
var arrayMethodHasSpeciesSupport$4 = arrayMethodHasSpeciesSupport$5;
var wellKnownSymbol$m = wellKnownSymbol$v;
var V8_VERSION$1 = engineV8Version;

var IS_CONCAT_SPREADABLE = wellKnownSymbol$m('isConcatSpreadable');
var MAX_SAFE_INTEGER$1 = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';
var TypeError$h = global$Y.TypeError;

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION$1 >= 51 || !fails$R(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport$4('concat');

var isConcatSpreadable = function (O) {
  if (!isObject$r(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray$5(O);
};

var FORCED$l = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$$1T({ target: 'Array', proto: true, forced: FORCED$l }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject$k(this);
    var A = arraySpeciesCreate$3(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike$g(E);
        if (n + len > MAX_SAFE_INTEGER$1) throw TypeError$h(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty$6(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER$1) throw TypeError$h(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty$6(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});

var toObject$j = toObject$o;
var toAbsoluteIndex$6 = toAbsoluteIndex$9;
var lengthOfArrayLike$f = lengthOfArrayLike$k;

var min$7 = Math.min;

// `Array.prototype.copyWithin` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
// eslint-disable-next-line es/no-array-prototype-copywithin -- safe
var arrayCopyWithin = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject$j(this);
  var len = lengthOfArrayLike$f(O);
  var to = toAbsoluteIndex$6(target, len);
  var from = toAbsoluteIndex$6(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = min$7((end === undefined ? len : toAbsoluteIndex$6(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};

var wellKnownSymbol$l = wellKnownSymbol$v;
var create$6 = objectCreate;
var definePropertyModule$7 = objectDefineProperty;

var UNSCOPABLES = wellKnownSymbol$l('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] == undefined) {
  definePropertyModule$7.f(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$6(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$8 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var $$1S = _export;
var copyWithin = arrayCopyWithin;
var addToUnscopables$7 = addToUnscopables$8;

// `Array.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
$$1S({ target: 'Array', proto: true }, {
  copyWithin: copyWithin
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$7('copyWithin');

var toObject$i = toObject$o;
var toAbsoluteIndex$5 = toAbsoluteIndex$9;
var lengthOfArrayLike$e = lengthOfArrayLike$k;

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
var arrayFill$1 = function fill(value /* , start = 0, end = @length */) {
  var O = toObject$i(this);
  var length = lengthOfArrayLike$e(O);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex$5(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex$5(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

var $$1R = _export;
var fill$1 = arrayFill$1;
var addToUnscopables$6 = addToUnscopables$8;

// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$$1R({ target: 'Array', proto: true }, {
  fill: fill$1
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$6('fill');

var $$1Q = _export;
var $filter$1 = arrayIteration.filter;
var arrayMethodHasSpeciesSupport$3 = arrayMethodHasSpeciesSupport$5;

var HAS_SPECIES_SUPPORT$3 = arrayMethodHasSpeciesSupport$3('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$$1Q({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$3 }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var $$1P = _export;
var $find$1 = arrayIteration.find;
var addToUnscopables$5 = addToUnscopables$8;

var FIND = 'find';
var SKIPS_HOLES$1 = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES$1 = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$$1P({ target: 'Array', proto: true, forced: SKIPS_HOLES$1 }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$5(FIND);

var $$1O = _export;
var $findIndex$1 = arrayIteration.findIndex;
var addToUnscopables$4 = addToUnscopables$8;

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$$1O({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$4(FIND_INDEX);

var global$X = global$1o;
var isArray$4 = isArray$8;
var lengthOfArrayLike$d = lengthOfArrayLike$k;
var bind$b = functionBindContext;

var TypeError$g = global$X.TypeError;

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray$2 = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind$b(mapper, thisArg) : false;
  var element, elementLen;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray$4(element)) {
        elementLen = lengthOfArrayLike$d(element);
        targetIndex = flattenIntoArray$2(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError$g('Exceed the acceptable array length');
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

var flattenIntoArray_1 = flattenIntoArray$2;

var $$1N = _export;
var flattenIntoArray$1 = flattenIntoArray_1;
var toObject$h = toObject$o;
var lengthOfArrayLike$c = lengthOfArrayLike$k;
var toIntegerOrInfinity$9 = toIntegerOrInfinity$c;
var arraySpeciesCreate$2 = arraySpeciesCreate$5;

// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$$1N({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject$h(this);
    var sourceLen = lengthOfArrayLike$c(O);
    var A = arraySpeciesCreate$2(O, 0);
    A.length = flattenIntoArray$1(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toIntegerOrInfinity$9(depthArg));
    return A;
  }
});

var $$1M = _export;
var flattenIntoArray = flattenIntoArray_1;
var aCallable$a = aCallable$d;
var toObject$g = toObject$o;
var lengthOfArrayLike$b = lengthOfArrayLike$k;
var arraySpeciesCreate$1 = arraySpeciesCreate$5;

// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$$1M({ target: 'Array', proto: true }, {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject$g(this);
    var sourceLen = lengthOfArrayLike$b(O);
    var A;
    aCallable$a(callbackfn);
    A = arraySpeciesCreate$1(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});

var call$k = functionCall;
var anObject$s = anObject$y;
var getMethod$5 = getMethod$7;

var iteratorClose$2 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$s(iterator);
  try {
    innerResult = getMethod$5(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$k(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$s(innerResult);
  return value;
};

var anObject$r = anObject$y;
var iteratorClose$1 = iteratorClose$2;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$1 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$r(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose$1(iterator, 'throw', error);
  }
};

var iterators = {};

var wellKnownSymbol$k = wellKnownSymbol$v;
var Iterators$4 = iterators;

var ITERATOR$a = wellKnownSymbol$k('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$3 = function (it) {
  return it !== undefined && (Iterators$4.Array === it || ArrayPrototype[ITERATOR$a] === it);
};

var classof$a = classof$e;
var getMethod$4 = getMethod$7;
var Iterators$3 = iterators;
var wellKnownSymbol$j = wellKnownSymbol$v;

var ITERATOR$9 = wellKnownSymbol$j('iterator');

var getIteratorMethod$5 = function (it) {
  if (it != undefined) return getMethod$4(it, ITERATOR$9)
    || getMethod$4(it, '@@iterator')
    || Iterators$3[classof$a(it)];
};

var global$W = global$1o;
var call$j = functionCall;
var aCallable$9 = aCallable$d;
var anObject$q = anObject$y;
var tryToString$3 = tryToString$5;
var getIteratorMethod$4 = getIteratorMethod$5;

var TypeError$f = global$W.TypeError;

var getIterator$4 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$4(argument) : usingIterator;
  if (aCallable$9(iteratorMethod)) return anObject$q(call$j(iteratorMethod, argument));
  throw TypeError$f(tryToString$3(argument) + ' is not iterable');
};

var global$V = global$1o;
var bind$a = functionBindContext;
var call$i = functionCall;
var toObject$f = toObject$o;
var callWithSafeIterationClosing = callWithSafeIterationClosing$1;
var isArrayIteratorMethod$2 = isArrayIteratorMethod$3;
var isConstructor$3 = isConstructor$5;
var lengthOfArrayLike$a = lengthOfArrayLike$k;
var createProperty$5 = createProperty$8;
var getIterator$3 = getIterator$4;
var getIteratorMethod$3 = getIteratorMethod$5;

var Array$6 = global$V.Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var arrayFrom$1 = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject$f(arrayLike);
  var IS_CONSTRUCTOR = isConstructor$3(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind$a(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod$3(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this == Array$6 && isArrayIteratorMethod$2(iteratorMethod))) {
    iterator = getIterator$3(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = call$i(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty$5(result, index, value);
    }
  } else {
    length = lengthOfArrayLike$a(O);
    result = IS_CONSTRUCTOR ? new this(length) : Array$6(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty$5(result, index, value);
    }
  }
  result.length = index;
  return result;
};

var wellKnownSymbol$i = wellKnownSymbol$v;

var ITERATOR$8 = wellKnownSymbol$i('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$8] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$4 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$8] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var $$1L = _export;
var from$1 = arrayFrom$1;
var checkCorrectnessOfIteration$3 = checkCorrectnessOfIteration$4;

var INCORRECT_ITERATION$1 = !checkCorrectnessOfIteration$3(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$$1L({ target: 'Array', stat: true, forced: INCORRECT_ITERATION$1 }, {
  from: from$1
});

var $$1K = _export;
var $includes$1 = arrayIncludes.includes;
var addToUnscopables$3 = addToUnscopables$8;

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$1K({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes$1(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$3('includes');

var fails$Q = fails$$;

var correctPrototypeGetter = !fails$Q(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var global$U = global$1o;
var hasOwn$c = hasOwnProperty_1;
var isCallable$d = isCallable$r;
var toObject$e = toObject$o;
var sharedKey = sharedKey$4;
var CORRECT_PROTOTYPE_GETTER$2 = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var Object$1 = global$U.Object;
var ObjectPrototype$3 = Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf$1 = CORRECT_PROTOTYPE_GETTER$2 ? Object$1.getPrototypeOf : function (O) {
  var object = toObject$e(O);
  if (hasOwn$c(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$d(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object$1 ? ObjectPrototype$3 : null;
};

var fails$P = fails$$;
var isCallable$c = isCallable$r;
var getPrototypeOf$9 = objectGetPrototypeOf$1;
var redefine$e = redefine$h.exports;
var wellKnownSymbol$h = wellKnownSymbol$v;

var ITERATOR$7 = wellKnownSymbol$h('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$9(getPrototypeOf$9(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == undefined || fails$P(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$7].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$c(IteratorPrototype$2[ITERATOR$7])) {
  redefine$e(IteratorPrototype$2, ITERATOR$7, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$5 = objectCreate;
var createPropertyDescriptor$3 = createPropertyDescriptor$8;
var setToStringTag$8 = setToStringTag$a;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$2 = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$5(IteratorPrototype$1, { next: createPropertyDescriptor$3(+!ENUMERABLE_NEXT, next) });
  setToStringTag$8(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var global$T = global$1o;
var isCallable$b = isCallable$r;

var String$3 = global$T.String;
var TypeError$e = global$T.TypeError;

var aPossiblePrototype$2 = function (argument) {
  if (typeof argument == 'object' || isCallable$b(argument)) return argument;
  throw TypeError$e("Can't set " + String$3(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThis$G = functionUncurryThis;
var anObject$p = anObject$y;
var aPossiblePrototype$1 = aPossiblePrototype$2;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf$1 = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis$G(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$p(O);
    aPossiblePrototype$1(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$1J = _export;
var call$h = functionCall;
var FunctionName$1 = functionName;
var isCallable$a = isCallable$r;
var createIteratorConstructor$1 = createIteratorConstructor$2;
var getPrototypeOf$8 = objectGetPrototypeOf$1;
var setPrototypeOf$5 = objectSetPrototypeOf$1;
var setToStringTag$7 = setToStringTag$a;
var createNonEnumerableProperty$7 = createNonEnumerableProperty$b;
var redefine$d = redefine$h.exports;
var wellKnownSymbol$g = wellKnownSymbol$v;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$3 = FunctionName$1.PROPER;
var CONFIGURABLE_FUNCTION_NAME$1 = FunctionName$1.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$6 = wellKnownSymbol$g('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$3 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor$1(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$6]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf$8(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf$8(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$5) {
          setPrototypeOf$5(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$a(CurrentIteratorPrototype[ITERATOR$6])) {
          redefine$d(CurrentIteratorPrototype, ITERATOR$6, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$7(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$3 && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME$1) {
      createNonEnumerableProperty$7(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$h(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine$d(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$1J({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$6] !== defaultIterator) {
    redefine$d(IterablePrototype, ITERATOR$6, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME] = defaultIterator;

  return methods;
};

var toIndexedObject$8 = toIndexedObject$f;
var addToUnscopables$2 = addToUnscopables$8;
var Iterators = iterators;
var InternalStateModule$8 = internalState;
var defineProperty$8 = objectDefineProperty.f;
var defineIterator$2 = defineIterator$3;
var DESCRIPTORS$k = descriptors$1;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$8 = InternalStateModule$8.set;
var getInternalState$5 = InternalStateModule$8.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator$2(Array, 'Array', function (iterated, kind) {
  setInternalState$8(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject$8(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$5(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$2('keys');
addToUnscopables$2('values');
addToUnscopables$2('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$k && values.name !== 'values') try {
  defineProperty$8(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

var fails$O = fails$$;

var arrayMethodIsStrict$6 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$O(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var $$1I = _export;
var uncurryThis$F = functionUncurryThis;
var IndexedObject$2 = indexedObject;
var toIndexedObject$7 = toIndexedObject$f;
var arrayMethodIsStrict$5 = arrayMethodIsStrict$6;

var un$Join = uncurryThis$F([].join);

var ES3_STRINGS = IndexedObject$2 != Object;
var STRICT_METHOD$5 = arrayMethodIsStrict$5('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$$1I({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD$5 }, {
  join: function join(separator) {
    return un$Join(toIndexedObject$7(this), separator === undefined ? ',' : separator);
  }
});

var $$1H = _export;
var $map$1 = arrayIteration.map;
var arrayMethodHasSpeciesSupport$2 = arrayMethodHasSpeciesSupport$5;

var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport$2('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$$1H({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$2 }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var $$1G = _export;
var global$S = global$1o;
var fails$N = fails$$;
var isConstructor$2 = isConstructor$5;
var createProperty$4 = createProperty$8;

var Array$5 = global$S.Array;

var ISNT_GENERIC = fails$N(function () {
  function F() { /* empty */ }
  return !(Array$5.of.call(F) instanceof F);
});

// `Array.of` method
// https://tc39.es/ecma262/#sec-array.of
// WebKit Array.of isn't generic
$$1G({ target: 'Array', stat: true, forced: ISNT_GENERIC }, {
  of: function of(/* ...args */) {
    var index = 0;
    var argumentsLength = arguments.length;
    var result = new (isConstructor$2(this) ? this : Array$5)(argumentsLength);
    while (argumentsLength > index) createProperty$4(result, index, arguments[index++]);
    result.length = argumentsLength;
    return result;
  }
});

var global$R = global$1o;
var aCallable$8 = aCallable$d;
var toObject$d = toObject$o;
var IndexedObject$1 = indexedObject;
var lengthOfArrayLike$9 = lengthOfArrayLike$k;

var TypeError$d = global$R.TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$4 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable$8(callbackfn);
    var O = toObject$d(that);
    var self = IndexedObject$1(O);
    var length = lengthOfArrayLike$9(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError$d('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$4(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$4(true)
};

var classof$9 = classofRaw$1;
var global$Q = global$1o;

var engineIsNode = classof$9(global$Q.process) == 'process';

var $$1F = _export;
var $reduce$1 = arrayReduce.left;
var arrayMethodIsStrict$4 = arrayMethodIsStrict$6;
var CHROME_VERSION$1 = engineV8Version;
var IS_NODE$5 = engineIsNode;

var STRICT_METHOD$4 = arrayMethodIsStrict$4('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG$1 = !IS_NODE$5 && CHROME_VERSION$1 > 79 && CHROME_VERSION$1 < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$1F({ target: 'Array', proto: true, forced: !STRICT_METHOD$4 || CHROME_BUG$1 }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce$1(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

var $$1E = _export;
var $reduceRight$1 = arrayReduce.right;
var arrayMethodIsStrict$3 = arrayMethodIsStrict$6;
var CHROME_VERSION = engineV8Version;
var IS_NODE$4 = engineIsNode;

var STRICT_METHOD$3 = arrayMethodIsStrict$3('reduceRight');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE$4 && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-array.prototype.reduceright
$$1E({ target: 'Array', proto: true, forced: !STRICT_METHOD$3 || CHROME_BUG }, {
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduceRight$1(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var $$1D = _export;
var uncurryThis$E = functionUncurryThis;
var isArray$3 = isArray$8;

var un$Reverse = uncurryThis$E([].reverse);
var test$1 = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$$1D({ target: 'Array', proto: true, forced: String(test$1) === String(test$1.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray$3(this)) this.length = this.length;
    return un$Reverse(this);
  }
});

var $$1C = _export;
var global$P = global$1o;
var isArray$2 = isArray$8;
var isConstructor$1 = isConstructor$5;
var isObject$q = isObject$z;
var toAbsoluteIndex$4 = toAbsoluteIndex$9;
var lengthOfArrayLike$8 = lengthOfArrayLike$k;
var toIndexedObject$6 = toIndexedObject$f;
var createProperty$3 = createProperty$8;
var wellKnownSymbol$f = wellKnownSymbol$v;
var arrayMethodHasSpeciesSupport$1 = arrayMethodHasSpeciesSupport$5;
var un$Slice = arraySlice$a;

var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport$1('slice');

var SPECIES$4 = wellKnownSymbol$f('species');
var Array$4 = global$P.Array;
var max$3 = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$$1C({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$1 }, {
  slice: function slice(start, end) {
    var O = toIndexedObject$6(this);
    var length = lengthOfArrayLike$8(O);
    var k = toAbsoluteIndex$4(start, length);
    var fin = toAbsoluteIndex$4(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray$2(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor$1(Constructor) && (Constructor === Array$4 || isArray$2(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject$q(Constructor)) {
        Constructor = Constructor[SPECIES$4];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array$4 || Constructor === undefined) {
        return un$Slice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array$4 : Constructor)(max$3(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty$3(result, n, O[k]);
    result.length = n;
    return result;
  }
});

var arraySlice$8 = arraySliceSimple;

var floor$9 = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor$9(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge$2(
    array,
    mergeSort(arraySlice$8(array, 0, middle), comparefn),
    mergeSort(arraySlice$8(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge$2 = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

var arraySort$1 = mergeSort;

var userAgent$6 = engineUserAgent;

var firefox = userAgent$6.match(/firefox\/(\d+)/i);

var engineFfVersion = !!firefox && +firefox[1];

var UA = engineUserAgent;

var engineIsIeOrEdge = /MSIE|Trident/.test(UA);

var userAgent$5 = engineUserAgent;

var webkit = userAgent$5.match(/AppleWebKit\/(\d+)\./);

var engineWebkitVersion = !!webkit && +webkit[1];

var $$1B = _export;
var uncurryThis$D = functionUncurryThis;
var aCallable$7 = aCallable$d;
var toObject$c = toObject$o;
var lengthOfArrayLike$7 = lengthOfArrayLike$k;
var toString$k = toString$m;
var fails$M = fails$$;
var internalSort$1 = arraySort$1;
var arrayMethodIsStrict$2 = arrayMethodIsStrict$6;
var FF$1 = engineFfVersion;
var IE_OR_EDGE$1 = engineIsIeOrEdge;
var V8$1 = engineV8Version;
var WEBKIT$3 = engineWebkitVersion;

var test = [];
var un$Sort$1 = uncurryThis$D(test.sort);
var push$8 = uncurryThis$D(test.push);

// IE8-
var FAILS_ON_UNDEFINED = fails$M(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails$M(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD$2 = arrayMethodIsStrict$2('sort');

var STABLE_SORT$1 = !fails$M(function () {
  // feature detection can be too slow, so check engines versions
  if (V8$1) return V8$1 < 70;
  if (FF$1 && FF$1 > 3) return;
  if (IE_OR_EDGE$1) return true;
  if (WEBKIT$3) return WEBKIT$3 < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED$k = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD$2 || !STABLE_SORT$1;

var getSortCompare$1 = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString$k(x) > toString$k(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$$1B({ target: 'Array', proto: true, forced: FORCED$k }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable$7(comparefn);

    var array = toObject$c(this);

    if (STABLE_SORT$1) return comparefn === undefined ? un$Sort$1(array) : un$Sort$1(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike$7(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push$8(items, array[index]);
    }

    internalSort$1(items, getSortCompare$1(comparefn));

    itemsLength = items.length;
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) delete array[index++];

    return array;
  }
});

var getBuiltIn$5 = getBuiltIn$c;
var definePropertyModule$6 = objectDefineProperty;
var wellKnownSymbol$e = wellKnownSymbol$v;
var DESCRIPTORS$j = descriptors$1;

var SPECIES$3 = wellKnownSymbol$e('species');

var setSpecies$6 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$5(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule$6.f;

  if (DESCRIPTORS$j && Constructor && !Constructor[SPECIES$3]) {
    defineProperty(Constructor, SPECIES$3, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var setSpecies$5 = setSpecies$6;

// `Array[@@species]` getter
// https://tc39.es/ecma262/#sec-get-array-@@species
setSpecies$5('Array');

var $$1A = _export;
var global$O = global$1o;
var toAbsoluteIndex$3 = toAbsoluteIndex$9;
var toIntegerOrInfinity$8 = toIntegerOrInfinity$c;
var lengthOfArrayLike$6 = lengthOfArrayLike$k;
var toObject$b = toObject$o;
var arraySpeciesCreate = arraySpeciesCreate$5;
var createProperty$2 = createProperty$8;
var arrayMethodHasSpeciesSupport = arrayMethodHasSpeciesSupport$5;

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var TypeError$c = global$O.TypeError;
var max$2 = Math.max;
var min$6 = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$$1A({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject$b(this);
    var len = lengthOfArrayLike$6(O);
    var actualStart = toAbsoluteIndex$3(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min$6(max$2(toIntegerOrInfinity$8(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError$c(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty$2(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables$1 = addToUnscopables$8;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('flat');

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = addToUnscopables$8;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flatMap');

// eslint-disable-next-line es/no-typed-arrays -- safe
var arrayBufferNative = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';

var redefine$c = redefine$h.exports;

var redefineAll$6 = function (target, src, options) {
  for (var key in src) redefine$c(target, key, src[key], options);
  return target;
};

var global$N = global$1o;
var isPrototypeOf$6 = objectIsPrototypeOf;

var TypeError$b = global$N.TypeError;

var anInstance$8 = function (it, Prototype) {
  if (isPrototypeOf$6(Prototype, it)) return it;
  throw TypeError$b('Incorrect invocation');
};

var global$M = global$1o;
var toIntegerOrInfinity$7 = toIntegerOrInfinity$c;
var toLength$a = toLength$c;

var RangeError$9 = global$M.RangeError;

// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
var toIndex$2 = function (it) {
  if (it === undefined) return 0;
  var number = toIntegerOrInfinity$7(it);
  var length = toLength$a(number);
  if (number !== length) throw RangeError$9('Wrong length or index');
  return length;
};

// IEEE754 conversions based on https://github.com/feross/ieee754
var global$L = global$1o;

var Array$3 = global$L.Array;
var abs$7 = Math.abs;
var pow$4 = Math.pow;
var floor$8 = Math.floor;
var log$9 = Math.log;
var LN2$2 = Math.LN2;

var pack = function (number, mantissaLength, bytes) {
  var buffer = Array$3(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow$4(2, -24) - pow$4(2, -77) : 0;
  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs$7(number);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (number != number || number === Infinity) {
    // eslint-disable-next-line no-self-compare -- NaN check
    mantissa = number != number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor$8(log$9(number) / LN2$2);
    c = pow$4(2, -exponent);
    if (number * c < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow$4(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow$4(2, mantissaLength);
      exponent = exponent + eBias;
    } else {
      mantissa = number * pow$4(2, eBias - 1) * pow$4(2, mantissaLength);
      exponent = 0;
    }
  }
  while (mantissaLength >= 8) {
    buffer[index++] = mantissa & 255;
    mantissa /= 256;
    mantissaLength -= 8;
  }
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  while (exponentLength > 0) {
    buffer[index++] = exponent & 255;
    exponent /= 256;
    exponentLength -= 8;
  }
  buffer[--index] |= sign * 128;
  return buffer;
};

var unpack = function (buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var sign = buffer[index--];
  var exponent = sign & 127;
  var mantissa;
  sign >>= 7;
  while (nBits > 0) {
    exponent = exponent * 256 + buffer[index--];
    nBits -= 8;
  }
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  while (nBits > 0) {
    mantissa = mantissa * 256 + buffer[index--];
    nBits -= 8;
  }
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign ? -Infinity : Infinity;
  } else {
    mantissa = mantissa + pow$4(2, mantissaLength);
    exponent = exponent - eBias;
  } return (sign ? -1 : 1) * mantissa * pow$4(2, exponent - mantissaLength);
};

var ieee754 = {
  pack: pack,
  unpack: unpack
};

var global$K = global$1o;
var uncurryThis$C = functionUncurryThis;
var DESCRIPTORS$i = descriptors$1;
var NATIVE_ARRAY_BUFFER$1 = arrayBufferNative;
var FunctionName = functionName;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$b;
var redefineAll$5 = redefineAll$6;
var fails$L = fails$$;
var anInstance$7 = anInstance$8;
var toIntegerOrInfinity$6 = toIntegerOrInfinity$c;
var toLength$9 = toLength$c;
var toIndex$1 = toIndex$2;
var IEEE754 = ieee754;
var getPrototypeOf$7 = objectGetPrototypeOf$1;
var setPrototypeOf$4 = objectSetPrototypeOf$1;
var getOwnPropertyNames$4 = objectGetOwnPropertyNames.f;
var defineProperty$7 = objectDefineProperty.f;
var arrayFill = arrayFill$1;
var arraySlice$7 = arraySliceSimple;
var setToStringTag$6 = setToStringTag$a;
var InternalStateModule$7 = internalState;

var PROPER_FUNCTION_NAME$2 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var getInternalState$4 = InternalStateModule$7.get;
var setInternalState$7 = InternalStateModule$7.set;
var ARRAY_BUFFER$1 = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH$1 = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var NativeArrayBuffer$1 = global$K[ARRAY_BUFFER$1];
var $ArrayBuffer = NativeArrayBuffer$1;
var ArrayBufferPrototype$1 = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
var $DataView = global$K[DATA_VIEW];
var DataViewPrototype$1 = $DataView && $DataView[PROTOTYPE];
var ObjectPrototype$2 = Object.prototype;
var Array$2 = global$K.Array;
var RangeError$8 = global$K.RangeError;
var fill = uncurryThis$C(arrayFill);
var reverse = uncurryThis$C([].reverse);

var packIEEE754 = IEEE754.pack;
var unpackIEEE754 = IEEE754.unpack;

var packInt8 = function (number) {
  return [number & 0xFF];
};

var packInt16 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF];
};

var packInt32 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
};

var unpackInt32 = function (buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};

var packFloat32 = function (number) {
  return packIEEE754(number, 23, 4);
};

var packFloat64 = function (number) {
  return packIEEE754(number, 52, 8);
};

var addGetter$1 = function (Constructor, key) {
  defineProperty$7(Constructor[PROTOTYPE], key, { get: function () { return getInternalState$4(this)[key]; } });
};

var get$1 = function (view, count, index, isLittleEndian) {
  var intIndex = toIndex$1(index);
  var store = getInternalState$4(view);
  if (intIndex + count > store.byteLength) throw RangeError$8(WRONG_INDEX);
  var bytes = getInternalState$4(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack = arraySlice$7(bytes, start, start + count);
  return isLittleEndian ? pack : reverse(pack);
};

var set$2 = function (view, count, index, conversion, value, isLittleEndian) {
  var intIndex = toIndex$1(index);
  var store = getInternalState$4(view);
  if (intIndex + count > store.byteLength) throw RangeError$8(WRONG_INDEX);
  var bytes = getInternalState$4(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack = conversion(+value);
  for (var i = 0; i < count; i++) bytes[start + i] = pack[isLittleEndian ? i : count - i - 1];
};

if (!NATIVE_ARRAY_BUFFER$1) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance$7(this, ArrayBufferPrototype$1);
    var byteLength = toIndex$1(length);
    setInternalState$7(this, {
      bytes: fill(Array$2(byteLength), 0),
      byteLength: byteLength
    });
    if (!DESCRIPTORS$i) this.byteLength = byteLength;
  };

  ArrayBufferPrototype$1 = $ArrayBuffer[PROTOTYPE];

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance$7(this, DataViewPrototype$1);
    anInstance$7(buffer, ArrayBufferPrototype$1);
    var bufferLength = getInternalState$4(buffer).byteLength;
    var offset = toIntegerOrInfinity$6(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError$8('Wrong offset');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength$9(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError$8(WRONG_LENGTH$1);
    setInternalState$7(this, {
      buffer: buffer,
      byteLength: byteLength,
      byteOffset: offset
    });
    if (!DESCRIPTORS$i) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };

  DataViewPrototype$1 = $DataView[PROTOTYPE];

  if (DESCRIPTORS$i) {
    addGetter$1($ArrayBuffer, 'byteLength');
    addGetter$1($DataView, 'buffer');
    addGetter$1($DataView, 'byteLength');
    addGetter$1($DataView, 'byteOffset');
  }

  redefineAll$5(DataViewPrototype$1, {
    getInt8: function getInt8(byteOffset) {
      return get$1(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get$1(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get$1(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get$1(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackInt32(get$1(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackInt32(get$1(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get$1(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 23);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get$1(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set$2(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set$2(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set$2(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set$2(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set$2(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set$2(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set$2(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set$2(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : undefined);
    }
  });
} else {
  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME$2 && NativeArrayBuffer$1.name !== ARRAY_BUFFER$1;
  /* eslint-disable no-new -- required for testing */
  if (!fails$L(function () {
    NativeArrayBuffer$1(1);
  }) || !fails$L(function () {
    new NativeArrayBuffer$1(-1);
  }) || fails$L(function () {
    new NativeArrayBuffer$1();
    new NativeArrayBuffer$1(1.5);
    new NativeArrayBuffer$1(NaN);
    return INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
  })) {
  /* eslint-enable no-new -- required for testing */
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance$7(this, ArrayBufferPrototype$1);
      return new NativeArrayBuffer$1(toIndex$1(length));
    };

    $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype$1;

    for (var keys$2 = getOwnPropertyNames$4(NativeArrayBuffer$1), j$2 = 0, key$1; keys$2.length > j$2;) {
      if (!((key$1 = keys$2[j$2++]) in $ArrayBuffer)) {
        createNonEnumerableProperty$6($ArrayBuffer, key$1, NativeArrayBuffer$1[key$1]);
      }
    }

    ArrayBufferPrototype$1.constructor = $ArrayBuffer;
  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
    createNonEnumerableProperty$6(NativeArrayBuffer$1, 'name', ARRAY_BUFFER$1);
  }

  // WebKit bug - the same parent prototype for typed arrays and data view
  if (setPrototypeOf$4 && getPrototypeOf$7(DataViewPrototype$1) !== ObjectPrototype$2) {
    setPrototypeOf$4(DataViewPrototype$1, ObjectPrototype$2);
  }

  // iOS Safari 7.x bug
  var testView = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = uncurryThis$C(DataViewPrototype$1.setInt8);
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1)) redefineAll$5(DataViewPrototype$1, {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    }
  }, { unsafe: true });
}

setToStringTag$6($ArrayBuffer, ARRAY_BUFFER$1);
setToStringTag$6($DataView, DATA_VIEW);

var arrayBuffer = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};

var $$1z = _export;
var global$J = global$1o;
var arrayBufferModule = arrayBuffer;
var setSpecies$4 = setSpecies$6;

var ARRAY_BUFFER = 'ArrayBuffer';
var ArrayBuffer$4 = arrayBufferModule[ARRAY_BUFFER];
var NativeArrayBuffer = global$J[ARRAY_BUFFER];

// `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor
$$1z({ global: true, forced: NativeArrayBuffer !== ArrayBuffer$4 }, {
  ArrayBuffer: ArrayBuffer$4
});

setSpecies$4(ARRAY_BUFFER);

var global$I = global$1o;
var isConstructor = isConstructor$5;
var tryToString$2 = tryToString$5;

var TypeError$a = global$I.TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$3 = function (argument) {
  if (isConstructor(argument)) return argument;
  throw TypeError$a(tryToString$2(argument) + ' is not a constructor');
};

var anObject$o = anObject$y;
var aConstructor$2 = aConstructor$3;
var wellKnownSymbol$d = wellKnownSymbol$v;

var SPECIES$2 = wellKnownSymbol$d('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$5 = function (O, defaultConstructor) {
  var C = anObject$o(O).constructor;
  var S;
  return C === undefined || (S = anObject$o(C)[SPECIES$2]) == undefined ? defaultConstructor : aConstructor$2(S);
};

var $$1y = _export;
var uncurryThis$B = functionUncurryThis;
var fails$K = fails$$;
var ArrayBufferModule$1 = arrayBuffer;
var anObject$n = anObject$y;
var toAbsoluteIndex$2 = toAbsoluteIndex$9;
var toLength$8 = toLength$c;
var speciesConstructor$4 = speciesConstructor$5;

var ArrayBuffer$3 = ArrayBufferModule$1.ArrayBuffer;
var DataView$2 = ArrayBufferModule$1.DataView;
var DataViewPrototype = DataView$2.prototype;
var un$ArrayBufferSlice = uncurryThis$B(ArrayBuffer$3.prototype.slice);
var getUint8 = uncurryThis$B(DataViewPrototype.getUint8);
var setUint8 = uncurryThis$B(DataViewPrototype.setUint8);

var INCORRECT_SLICE = fails$K(function () {
  return !new ArrayBuffer$3(2).slice(1, undefined).byteLength;
});

// `ArrayBuffer.prototype.slice` method
// https://tc39.es/ecma262/#sec-arraybuffer.prototype.slice
$$1y({ target: 'ArrayBuffer', proto: true, unsafe: true, forced: INCORRECT_SLICE }, {
  slice: function slice(start, end) {
    if (un$ArrayBufferSlice && end === undefined) {
      return un$ArrayBufferSlice(anObject$n(this), start); // FF fix
    }
    var length = anObject$n(this).byteLength;
    var first = toAbsoluteIndex$2(start, length);
    var fin = toAbsoluteIndex$2(end === undefined ? length : end, length);
    var result = new (speciesConstructor$4(this, ArrayBuffer$3))(toLength$8(fin - first));
    var viewSource = new DataView$2(this);
    var viewTarget = new DataView$2(result);
    var index = 0;
    while (first < fin) {
      setUint8(viewTarget, index++, getUint8(viewSource, first++));
    } return result;
  }
});

var global$H = global$1o;
var anObject$m = anObject$y;
var ordinaryToPrimitive = ordinaryToPrimitive$2;

var TypeError$9 = global$H.TypeError;

// `Date.prototype[@@toPrimitive](hint)` method implementation
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
var dateToPrimitive$1 = function (hint) {
  anObject$m(this);
  if (hint === 'string' || hint === 'default') hint = 'string';
  else if (hint !== 'number') throw TypeError$9('Incorrect hint');
  return ordinaryToPrimitive(this, hint);
};

var hasOwn$b = hasOwnProperty_1;
var redefine$b = redefine$h.exports;
var dateToPrimitive = dateToPrimitive$1;
var wellKnownSymbol$c = wellKnownSymbol$v;

var TO_PRIMITIVE = wellKnownSymbol$c('toPrimitive');
var DatePrototype = Date.prototype;

// `Date.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
if (!hasOwn$b(DatePrototype, TO_PRIMITIVE)) {
  redefine$b(DatePrototype, TO_PRIMITIVE, dateToPrimitive);
}

var isCallable$9 = isCallable$r;
var isObject$p = isObject$z;
var definePropertyModule$5 = objectDefineProperty;
var getPrototypeOf$6 = objectGetPrototypeOf$1;
var wellKnownSymbol$b = wellKnownSymbol$v;

var HAS_INSTANCE = wellKnownSymbol$b('hasInstance');
var FunctionPrototype$1 = Function.prototype;

// `Function.prototype[@@hasInstance]` method
// https://tc39.es/ecma262/#sec-function.prototype-@@hasinstance
if (!(HAS_INSTANCE in FunctionPrototype$1)) {
  definePropertyModule$5.f(FunctionPrototype$1, HAS_INSTANCE, { value: function (O) {
    if (!isCallable$9(this) || !isObject$p(O)) return false;
    var P = this.prototype;
    if (!isObject$p(P)) return O instanceof this;
    // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
    while (O = getPrototypeOf$6(O)) if (P === O) return true;
    return false;
  } });
}

var DESCRIPTORS$h = descriptors$1;
var FUNCTION_NAME_EXISTS = functionName.EXISTS;
var uncurryThis$A = functionUncurryThis;
var defineProperty$6 = objectDefineProperty.f;

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis$A(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec$3 = uncurryThis$A(nameRE.exec);
var NAME$1 = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS$h && !FUNCTION_NAME_EXISTS) {
  defineProperty$6(FunctionPrototype, NAME$1, {
    configurable: true,
    get: function () {
      try {
        return regExpExec$3(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}

var global$G = global$1o;
var setToStringTag$5 = setToStringTag$a;

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag$5(global$G.JSON, 'JSON', true);

var internalMetadata = {exports: {}};

// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails$J = fails$$;

var arrayBufferNonExtensible = fails$J(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8);
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
  }
});

var fails$I = fails$$;
var isObject$o = isObject$z;
var classof$8 = classofRaw$1;
var ARRAY_BUFFER_NON_EXTENSIBLE$2 = arrayBufferNonExtensible;

// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible$2 = Object.isExtensible;
var FAILS_ON_PRIMITIVES$9 = fails$I(function () { $isExtensible$2(1); });

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
var objectIsExtensible = (FAILS_ON_PRIMITIVES$9 || ARRAY_BUFFER_NON_EXTENSIBLE$2) ? function isExtensible(it) {
  if (!isObject$o(it)) return false;
  if (ARRAY_BUFFER_NON_EXTENSIBLE$2 && classof$8(it) == 'ArrayBuffer') return false;
  return $isExtensible$2 ? $isExtensible$2(it) : true;
} : $isExtensible$2;

var fails$H = fails$$;

var freezing = !fails$H(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});

var $$1x = _export;
var uncurryThis$z = functionUncurryThis;
var hiddenKeys = hiddenKeys$6;
var isObject$n = isObject$z;
var hasOwn$a = hasOwnProperty_1;
var defineProperty$5 = objectDefineProperty.f;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertyNamesExternalModule = objectGetOwnPropertyNamesExternal;
var isExtensible$1 = objectIsExtensible;
var uid$1 = uid$5;
var FREEZING$4 = freezing;

var REQUIRED = false;
var METADATA = uid$1('meta');
var id$1 = 0;

var setMetadata = function (it) {
  defineProperty$5(it, METADATA, { value: {
    objectID: 'O' + id$1++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey$1 = function (it, create) {
  // return a primitive with prefix
  if (!isObject$n(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!hasOwn$a(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible$1(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData$1 = function (it, create) {
  if (!hasOwn$a(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible$1(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze$3 = function (it) {
  if (FREEZING$4 && REQUIRED && isExtensible$1(it) && !hasOwn$a(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = uncurryThis$z([].splice);
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice(result, i, 1);
          break;
        }
      } return result;
    };

    $$1x({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = internalMetadata.exports = {
  enable: enable,
  fastKey: fastKey$1,
  getWeakData: getWeakData$1,
  onFreeze: onFreeze$3
};

hiddenKeys[METADATA] = true;

var global$F = global$1o;
var bind$9 = functionBindContext;
var call$g = functionCall;
var anObject$l = anObject$y;
var tryToString$1 = tryToString$5;
var isArrayIteratorMethod$1 = isArrayIteratorMethod$3;
var lengthOfArrayLike$5 = lengthOfArrayLike$k;
var isPrototypeOf$5 = objectIsPrototypeOf;
var getIterator$2 = getIterator$4;
var getIteratorMethod$2 = getIteratorMethod$5;
var iteratorClose = iteratorClose$2;

var TypeError$8 = global$F.TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$5 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$9(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$l(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$2(iterable);
    if (!iterFn) throw TypeError$8(tryToString$1(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod$1(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$5(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$5(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator$2(iterable, iterFn);
  }

  next = iterator.next;
  while (!(step = call$g(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf$5(ResultPrototype, result)) return result;
  } return new Result(false);
};

var isCallable$8 = isCallable$r;
var isObject$m = isObject$z;
var setPrototypeOf$3 = objectSetPrototypeOf$1;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$4 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf$3 &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable$8(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject$m(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf$3($this, NewTargetPrototype);
  return $this;
};

var $$1w = _export;
var global$E = global$1o;
var uncurryThis$y = functionUncurryThis;
var isForced$3 = isForced_1;
var redefine$a = redefine$h.exports;
var InternalMetadataModule$1 = internalMetadata.exports;
var iterate$4 = iterate$5;
var anInstance$6 = anInstance$8;
var isCallable$7 = isCallable$r;
var isObject$l = isObject$z;
var fails$G = fails$$;
var checkCorrectnessOfIteration$2 = checkCorrectnessOfIteration$4;
var setToStringTag$4 = setToStringTag$a;
var inheritIfRequired$3 = inheritIfRequired$4;

var collection$4 = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global$E[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var uncurriedNativeMethod = uncurryThis$y(NativePrototype[KEY]);
    redefine$a(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        uncurriedNativeMethod(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject$l(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject$l(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject$l(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced$3(
    CONSTRUCTOR_NAME,
    !isCallable$7(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails$G(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule$1.enable();
  } else if (isForced$3(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails$G(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration$2(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails$G(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance$6(dummy, NativePrototype);
        var that = inheritIfRequired$3(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate$4(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $$1w({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag$4(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};

var defineProperty$4 = objectDefineProperty.f;
var create$4 = objectCreate;
var redefineAll$4 = redefineAll$6;
var bind$8 = functionBindContext;
var anInstance$5 = anInstance$8;
var iterate$3 = iterate$5;
var defineIterator$1 = defineIterator$3;
var setSpecies$3 = setSpecies$6;
var DESCRIPTORS$g = descriptors$1;
var fastKey = internalMetadata.exports.fastKey;
var InternalStateModule$6 = internalState;

var setInternalState$6 = InternalStateModule$6.set;
var internalStateGetterFor$1 = InternalStateModule$6.getterFor;

var collectionStrong$2 = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance$5(that, Prototype);
      setInternalState$6(that, {
        type: CONSTRUCTOR_NAME,
        index: create$4(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS$g) that.size = 0;
      if (iterable != undefined) iterate$3(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor$1(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS$g) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll$4(Prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS$g) state.size = 0;
        else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS$g) state.size--;
          else that.size--;
        } return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind$8(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll$4(Prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS$g) defineProperty$4(Prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return Constructor;
  },
  setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor$1(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor$1(ITERATOR_NAME);
    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
    defineIterator$1(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState$6(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species
    setSpecies$3(CONSTRUCTOR_NAME);
  }
};

var collection$3 = collection$4;
var collectionStrong$1 = collectionStrong$2;

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
collection$3('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong$1);

var log$8 = Math.log;

// `Math.log1p` method implementation
// https://tc39.es/ecma262/#sec-math.log1p
// eslint-disable-next-line es/no-math-log1p -- safe
var mathLog1p = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : log$8(1 + x);
};

var $$1v = _export;
var log1p$1 = mathLog1p;

// eslint-disable-next-line es/no-math-acosh -- required for testing
var $acosh = Math.acosh;
var log$7 = Math.log;
var sqrt$2 = Math.sqrt;
var LN2$1 = Math.LN2;

var FORCED$j = !$acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  || Math.floor($acosh(Number.MAX_VALUE)) != 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  || $acosh(Infinity) != Infinity;

// `Math.acosh` method
// https://tc39.es/ecma262/#sec-math.acosh
$$1v({ target: 'Math', stat: true, forced: FORCED$j }, {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? log$7(x) + LN2$1
      : log1p$1(x - 1 + sqrt$2(x - 1) * sqrt$2(x + 1));
  }
});

var $$1u = _export;

// eslint-disable-next-line es/no-math-asinh -- required for testing
var $asinh = Math.asinh;
var log$6 = Math.log;
var sqrt$1 = Math.sqrt;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : log$6(x + sqrt$1(x * x + 1));
}

// `Math.asinh` method
// https://tc39.es/ecma262/#sec-math.asinh
// Tor Browser bug: Math.asinh(0) -> -0
$$1u({ target: 'Math', stat: true, forced: !($asinh && 1 / $asinh(0) > 0) }, {
  asinh: asinh
});

var $$1t = _export;

// eslint-disable-next-line es/no-math-atanh -- required for testing
var $atanh = Math.atanh;
var log$5 = Math.log;

// `Math.atanh` method
// https://tc39.es/ecma262/#sec-math.atanh
// Tor Browser bug: Math.atanh(-0) -> 0
$$1t({ target: 'Math', stat: true, forced: !($atanh && 1 / $atanh(-0) < 0) }, {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : log$5((1 + x) / (1 - x)) / 2;
  }
});

// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe
var mathSign = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

var $$1s = _export;
var sign$2 = mathSign;

var abs$6 = Math.abs;
var pow$3 = Math.pow;

// `Math.cbrt` method
// https://tc39.es/ecma262/#sec-math.cbrt
$$1s({ target: 'Math', stat: true }, {
  cbrt: function cbrt(x) {
    return sign$2(x = +x) * pow$3(abs$6(x), 1 / 3);
  }
});

var $$1r = _export;

var floor$7 = Math.floor;
var log$4 = Math.log;
var LOG2E = Math.LOG2E;

// `Math.clz32` method
// https://tc39.es/ecma262/#sec-math.clz32
$$1r({ target: 'Math', stat: true }, {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - floor$7(log$4(x + 0.5) * LOG2E) : 32;
  }
});

// eslint-disable-next-line es/no-math-expm1 -- safe
var $expm1 = Math.expm1;
var exp$2 = Math.exp;

// `Math.expm1` method implementation
// https://tc39.es/ecma262/#sec-math.expm1
var mathExpm1 = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : exp$2(x) - 1;
} : $expm1;

var $$1q = _export;
var expm1$3 = mathExpm1;

// eslint-disable-next-line es/no-math-cosh -- required for testing
var $cosh = Math.cosh;
var abs$5 = Math.abs;
var E$1 = Math.E;

// `Math.cosh` method
// https://tc39.es/ecma262/#sec-math.cosh
$$1q({ target: 'Math', stat: true, forced: !$cosh || $cosh(710) === Infinity }, {
  cosh: function cosh(x) {
    var t = expm1$3(abs$5(x) - 1) + 1;
    return (t + 1 / (t * E$1 * E$1)) * (E$1 / 2);
  }
});

var $$1p = _export;
var expm1$2 = mathExpm1;

// `Math.expm1` method
// https://tc39.es/ecma262/#sec-math.expm1
// eslint-disable-next-line es/no-math-expm1 -- required for testing
$$1p({ target: 'Math', stat: true, forced: expm1$2 != Math.expm1 }, { expm1: expm1$2 });

var sign$1 = mathSign;

var abs$4 = Math.abs;
var pow$2 = Math.pow;
var EPSILON = pow$2(2, -52);
var EPSILON32 = pow$2(2, -23);
var MAX32 = pow$2(2, 127) * (2 - EPSILON32);
var MIN32 = pow$2(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

// `Math.fround` method implementation
// https://tc39.es/ecma262/#sec-math.fround
// eslint-disable-next-line es/no-math-fround -- safe
var mathFround = Math.fround || function fround(x) {
  var $abs = abs$4(x);
  var $sign = sign$1(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};

var $$1o = _export;
var fround = mathFround;

// `Math.fround` method
// https://tc39.es/ecma262/#sec-math.fround
$$1o({ target: 'Math', stat: true }, { fround: fround });

var $$1n = _export;

// eslint-disable-next-line es/no-math-hypot -- required for testing
var $hypot = Math.hypot;
var abs$3 = Math.abs;
var sqrt = Math.sqrt;

// Chrome 77 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=9546
var BUGGY = !!$hypot && $hypot(Infinity, NaN) !== Infinity;

// `Math.hypot` method
// https://tc39.es/ecma262/#sec-math.hypot
$$1n({ target: 'Math', stat: true, forced: BUGGY }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  hypot: function hypot(value1, value2) {
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs$3(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * sqrt(sum);
  }
});

var $$1m = _export;
var fails$F = fails$$;

// eslint-disable-next-line es/no-math-imul -- required for testing
var $imul = Math.imul;

var FORCED$i = fails$F(function () {
  return $imul(0xFFFFFFFF, 5) != -5 || $imul.length != 2;
});

// `Math.imul` method
// https://tc39.es/ecma262/#sec-math.imul
// some WebKit versions fails with big numbers, some has wrong arity
$$1m({ target: 'Math', stat: true, forced: FORCED$i }, {
  imul: function imul(x, y) {
    var UINT16 = 0xFFFF;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

var log$3 = Math.log;
var LOG10E = Math.LOG10E;

// eslint-disable-next-line es/no-math-log10 -- safe
var mathLog10 = Math.log10 || function log10(x) {
  return log$3(x) * LOG10E;
};

var $$1l = _export;
var log10 = mathLog10;

// `Math.log10` method
// https://tc39.es/ecma262/#sec-math.log10
$$1l({ target: 'Math', stat: true }, {
  log10: log10
});

var $$1k = _export;
var log1p = mathLog1p;

// `Math.log1p` method
// https://tc39.es/ecma262/#sec-math.log1p
$$1k({ target: 'Math', stat: true }, { log1p: log1p });

var $$1j = _export;

var log$2 = Math.log;
var LN2 = Math.LN2;

// `Math.log2` method
// https://tc39.es/ecma262/#sec-math.log2
$$1j({ target: 'Math', stat: true }, {
  log2: function log2(x) {
    return log$2(x) / LN2;
  }
});

var $$1i = _export;
var sign = mathSign;

// `Math.sign` method
// https://tc39.es/ecma262/#sec-math.sign
$$1i({ target: 'Math', stat: true }, {
  sign: sign
});

var $$1h = _export;
var fails$E = fails$$;
var expm1$1 = mathExpm1;

var abs$2 = Math.abs;
var exp$1 = Math.exp;
var E = Math.E;

var FORCED$h = fails$E(function () {
  // eslint-disable-next-line es/no-math-sinh -- required for testing
  return Math.sinh(-2e-17) != -2e-17;
});

// `Math.sinh` method
// https://tc39.es/ecma262/#sec-math.sinh
// V8 near Chromium 38 has a problem with very small numbers
$$1h({ target: 'Math', stat: true, forced: FORCED$h }, {
  sinh: function sinh(x) {
    return abs$2(x = +x) < 1 ? (expm1$1(x) - expm1$1(-x)) / 2 : (exp$1(x - 1) - exp$1(-x - 1)) * (E / 2);
  }
});

var $$1g = _export;
var expm1 = mathExpm1;

var exp = Math.exp;

// `Math.tanh` method
// https://tc39.es/ecma262/#sec-math.tanh
$$1g({ target: 'Math', stat: true }, {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});

var setToStringTag$3 = setToStringTag$a;

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
setToStringTag$3(Math, 'Math', true);

var $$1f = _export;

var ceil$1 = Math.ceil;
var floor$6 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
$$1f({ target: 'Math', stat: true }, {
  trunc: function trunc(it) {
    return (it > 0 ? floor$6 : ceil$1)(it);
  }
});

var uncurryThis$x = functionUncurryThis;

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
var thisNumberValue$2 = uncurryThis$x(1.0.valueOf);

// a string of all valid unicode whitespaces
var whitespaces$4 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$w = functionUncurryThis;
var requireObjectCoercible$b = requireObjectCoercible$e;
var toString$j = toString$m;
var whitespaces$3 = whitespaces$4;

var replace$9 = uncurryThis$w(''.replace);
var whitespace$1 = '[' + whitespaces$3 + ']';
var ltrim = RegExp('^' + whitespace$1 + whitespace$1 + '*');
var rtrim = RegExp(whitespace$1 + whitespace$1 + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$3 = function (TYPE) {
  return function ($this) {
    var string = toString$j(requireObjectCoercible$b($this));
    if (TYPE & 1) string = replace$9(string, ltrim, '');
    if (TYPE & 2) string = replace$9(string, rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$3(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$3(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$3(3)
};

var DESCRIPTORS$f = descriptors$1;
var global$D = global$1o;
var uncurryThis$v = functionUncurryThis;
var isForced$2 = isForced_1;
var redefine$9 = redefine$h.exports;
var hasOwn$9 = hasOwnProperty_1;
var inheritIfRequired$2 = inheritIfRequired$4;
var isPrototypeOf$4 = objectIsPrototypeOf;
var isSymbol$2 = isSymbol$6;
var toPrimitive = toPrimitive$2;
var fails$D = fails$$;
var getOwnPropertyNames$3 = objectGetOwnPropertyNames.f;
var getOwnPropertyDescriptor$6 = objectGetOwnPropertyDescriptor.f;
var defineProperty$3 = objectDefineProperty.f;
var thisNumberValue$1 = thisNumberValue$2;
var trim$4 = stringTrim.trim;

var NUMBER = 'Number';
var NativeNumber = global$D[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError$7 = global$D.TypeError;
var arraySlice$6 = uncurryThis$v(''.slice);
var charCodeAt$2 = uncurryThis$v(''.charCodeAt);

// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function (value) {
  var primValue = toPrimitive(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber$1(primValue);
};

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber$1 = function (argument) {
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol$2(it)) throw TypeError$7('Cannot convert a Symbol value to a number');
  if (typeof it == 'string' && it.length > 2) {
    it = trim$4(it);
    first = charCodeAt$2(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt$2(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt$2(it, 1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = arraySlice$6(it, 2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = charCodeAt$2(digits, index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced$2(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
    var dummy = this;
    // check on 1..constructor(foo) case
    return isPrototypeOf$4(NumberPrototype, dummy) && fails$D(function () { thisNumberValue$1(dummy); })
      ? inheritIfRequired$2(Object(n), dummy, NumberWrapper) : n;
  };
  for (var keys$1 = DESCRIPTORS$f ? getOwnPropertyNames$3(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
    // ESNext
    'fromString,range'
  ).split(','), j$1 = 0, key; keys$1.length > j$1; j$1++) {
    if (hasOwn$9(NativeNumber, key = keys$1[j$1]) && !hasOwn$9(NumberWrapper, key)) {
      defineProperty$3(NumberWrapper, key, getOwnPropertyDescriptor$6(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine$9(global$D, NUMBER, NumberWrapper);
}

var $$1e = _export;

// `Number.EPSILON` constant
// https://tc39.es/ecma262/#sec-number.epsilon
$$1e({ target: 'Number', stat: true }, {
  EPSILON: Math.pow(2, -52)
});

var global$C = global$1o;

var globalIsFinite = global$C.isFinite;

// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
// eslint-disable-next-line es/no-number-isfinite -- safe
var numberIsFinite$1 = Number.isFinite || function isFinite(it) {
  return typeof it == 'number' && globalIsFinite(it);
};

var $$1d = _export;
var numberIsFinite = numberIsFinite$1;

// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
$$1d({ target: 'Number', stat: true }, { isFinite: numberIsFinite });

var isObject$k = isObject$z;

var floor$5 = Math.floor;

// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
var isIntegralNumber$3 = Number.isInteger || function isInteger(it) {
  return !isObject$k(it) && isFinite(it) && floor$5(it) === it;
};

var $$1c = _export;
var isIntegralNumber$2 = isIntegralNumber$3;

// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$$1c({ target: 'Number', stat: true }, {
  isInteger: isIntegralNumber$2
});

var $$1b = _export;

// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
$$1b({ target: 'Number', stat: true }, {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return number != number;
  }
});

var $$1a = _export;
var isIntegralNumber$1 = isIntegralNumber$3;

var abs$1 = Math.abs;

// `Number.isSafeInteger` method
// https://tc39.es/ecma262/#sec-number.issafeinteger
$$1a({ target: 'Number', stat: true }, {
  isSafeInteger: function isSafeInteger(number) {
    return isIntegralNumber$1(number) && abs$1(number) <= 0x1FFFFFFFFFFFFF;
  }
});

var $$19 = _export;

// `Number.MAX_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.max_safe_integer
$$19({ target: 'Number', stat: true }, {
  MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
});

var $$18 = _export;

// `Number.MIN_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.min_safe_integer
$$18({ target: 'Number', stat: true }, {
  MIN_SAFE_INTEGER: -0x1FFFFFFFFFFFFF
});

var global$B = global$1o;
var fails$C = fails$$;
var uncurryThis$u = functionUncurryThis;
var toString$i = toString$m;
var trim$3 = stringTrim.trim;
var whitespaces$2 = whitespaces$4;

var charAt$8 = uncurryThis$u(''.charAt);
var n$ParseFloat = global$B.parseFloat;
var Symbol$2 = global$B.Symbol;
var ITERATOR$5 = Symbol$2 && Symbol$2.iterator;
var FORCED$g = 1 / n$ParseFloat(whitespaces$2 + '-0') !== -Infinity
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR$5 && !fails$C(function () { n$ParseFloat(Object(ITERATOR$5)); }));

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
var numberParseFloat = FORCED$g ? function parseFloat(string) {
  var trimmedString = trim$3(toString$i(string));
  var result = n$ParseFloat(trimmedString);
  return result === 0 && charAt$8(trimmedString, 0) == '-' ? -0 : result;
} : n$ParseFloat;

var $$17 = _export;
var parseFloat$1 = numberParseFloat;

// `Number.parseFloat` method
// https://tc39.es/ecma262/#sec-number.parseFloat
// eslint-disable-next-line es/no-number-parsefloat -- required for testing
$$17({ target: 'Number', stat: true, forced: Number.parseFloat != parseFloat$1 }, {
  parseFloat: parseFloat$1
});

var global$A = global$1o;
var fails$B = fails$$;
var uncurryThis$t = functionUncurryThis;
var toString$h = toString$m;
var trim$2 = stringTrim.trim;
var whitespaces$1 = whitespaces$4;

var $parseInt$1 = global$A.parseInt;
var Symbol$1 = global$A.Symbol;
var ITERATOR$4 = Symbol$1 && Symbol$1.iterator;
var hex = /^[+-]?0x/i;
var exec$5 = uncurryThis$t(hex.exec);
var FORCED$f = $parseInt$1(whitespaces$1 + '08') !== 8 || $parseInt$1(whitespaces$1 + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR$4 && !fails$B(function () { $parseInt$1(Object(ITERATOR$4)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED$f ? function parseInt(string, radix) {
  var S = trim$2(toString$h(string));
  return $parseInt$1(S, (radix >>> 0) || (exec$5(hex, S) ? 16 : 10));
} : $parseInt$1;

var $$16 = _export;
var parseInt$2 = numberParseInt;

// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing
$$16({ target: 'Number', stat: true, forced: Number.parseInt != parseInt$2 }, {
  parseInt: parseInt$2
});

var global$z = global$1o;
var toIntegerOrInfinity$5 = toIntegerOrInfinity$c;
var toString$g = toString$m;
var requireObjectCoercible$a = requireObjectCoercible$e;

var RangeError$7 = global$z.RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
var stringRepeat = function repeat(count) {
  var str = toString$g(requireObjectCoercible$a(this));
  var result = '';
  var n = toIntegerOrInfinity$5(count);
  if (n < 0 || n == Infinity) throw RangeError$7('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};

var $$15 = _export;
var global$y = global$1o;
var uncurryThis$s = functionUncurryThis;
var toIntegerOrInfinity$4 = toIntegerOrInfinity$c;
var thisNumberValue = thisNumberValue$2;
var $repeat$1 = stringRepeat;
var fails$A = fails$$;

var RangeError$6 = global$y.RangeError;
var String$2 = global$y.String;
var floor$4 = Math.floor;
var repeat$2 = uncurryThis$s($repeat$1);
var stringSlice$a = uncurryThis$s(''.slice);
var un$ToFixed = uncurryThis$s(1.0.toFixed);

var pow$1 = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow$1(x, n - 1, acc * x) : pow$1(x * x, n / 2, acc);
};

var log$1 = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor$4(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor$4(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = String$2(data[index]);
      s = s === '' ? t : s + repeat$2('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED$e = fails$A(function () {
  return un$ToFixed(0.00008, 3) !== '0.000' ||
    un$ToFixed(0.9, 0) !== '1' ||
    un$ToFixed(1.255, 2) !== '1.25' ||
    un$ToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails$A(function () {
  // V8 ~ Android 4.3-
  un$ToFixed({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$$15({ target: 'Number', proto: true, forced: FORCED$e }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toIntegerOrInfinity$4(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
    if (fractDigits < 0 || fractDigits > 20) throw RangeError$6('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return String$2(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log$1(number * pow$1(2, 69, 1)) - 69;
      z = e < 0 ? number * pow$1(2, -e, 1) : number / pow$1(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow$1(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat$2('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat$2('0', fractDigits - k) + result
        : stringSlice$a(result, 0, k - fractDigits) + '.' + stringSlice$a(result, k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});

var DESCRIPTORS$e = descriptors$1;
var uncurryThis$r = functionUncurryThis;
var call$f = functionCall;
var fails$z = fails$$;
var objectKeys$1 = objectKeys$4;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$a = toObject$o;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$2 = Object.defineProperty;
var concat$2 = uncurryThis$r([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign$1 = !$assign || fails$z(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$e && $assign({ b: 1 }, $assign(defineProperty$2({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$2(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys$1($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$a(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$2(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$e || call$f(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$14 = _export;
var assign$3 = objectAssign$1;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$14({ target: 'Object', stat: true, forced: Object.assign !== assign$3 }, {
  assign: assign$3
});

var global$x = global$1o;
var fails$y = fails$$;
var WEBKIT$2 = engineWebkitVersion;

// Forced replacement object prototype accessors methods
var objectPrototypeAccessorsForced = !fails$y(function () {
  // This feature detection crashes old WebKit
  // https://github.com/zloirock/core-js/issues/232
  if (WEBKIT$2 && WEBKIT$2 < 535) return;
  var key = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call -- required for testing
  __defineSetter__.call(null, key, function () { /* empty */ });
  delete global$x[key];
});

var $$13 = _export;
var DESCRIPTORS$d = descriptors$1;
var FORCED$d = objectPrototypeAccessorsForced;
var aCallable$6 = aCallable$d;
var toObject$9 = toObject$o;
var definePropertyModule$4 = objectDefineProperty;

// `Object.prototype.__defineGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineGetter__
if (DESCRIPTORS$d) {
  $$13({ target: 'Object', proto: true, forced: FORCED$d }, {
    __defineGetter__: function __defineGetter__(P, getter) {
      definePropertyModule$4.f(toObject$9(this), P, { get: aCallable$6(getter), enumerable: true, configurable: true });
    }
  });
}

var $$12 = _export;
var DESCRIPTORS$c = descriptors$1;
var FORCED$c = objectPrototypeAccessorsForced;
var aCallable$5 = aCallable$d;
var toObject$8 = toObject$o;
var definePropertyModule$3 = objectDefineProperty;

// `Object.prototype.__defineSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineSetter__
if (DESCRIPTORS$c) {
  $$12({ target: 'Object', proto: true, forced: FORCED$c }, {
    __defineSetter__: function __defineSetter__(P, setter) {
      definePropertyModule$3.f(toObject$8(this), P, { set: aCallable$5(setter), enumerable: true, configurable: true });
    }
  });
}

var DESCRIPTORS$b = descriptors$1;
var uncurryThis$q = functionUncurryThis;
var objectKeys = objectKeys$4;
var toIndexedObject$5 = toIndexedObject$f;
var $propertyIsEnumerable = objectPropertyIsEnumerable.f;

var propertyIsEnumerable = uncurryThis$q($propertyIsEnumerable);
var push$7 = uncurryThis$q([].push);

// `Object.{ entries, values }` methods implementation
var createMethod$2 = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject$5(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS$b || propertyIsEnumerable(O, key)) {
        push$7(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

var objectToArray = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod$2(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod$2(false)
};

var $$11 = _export;
var $entries = objectToArray.entries;

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$$11({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});

var $$10 = _export;
var FREEZING$3 = freezing;
var fails$x = fails$$;
var isObject$j = isObject$z;
var onFreeze$2 = internalMetadata.exports.onFreeze;

// eslint-disable-next-line es/no-object-freeze -- safe
var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES$8 = fails$x(function () { $freeze(1); });

// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$$10({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES$8, sham: !FREEZING$3 }, {
  freeze: function freeze(it) {
    return $freeze && isObject$j(it) ? $freeze(onFreeze$2(it)) : it;
  }
});

var $$$ = _export;
var iterate$2 = iterate$5;
var createProperty$1 = createProperty$8;

// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$$$({ target: 'Object', stat: true }, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate$2(iterable, function (k, v) {
      createProperty$1(obj, k, v);
    }, { AS_ENTRIES: true });
    return obj;
  }
});

var $$_ = _export;
var fails$w = fails$$;
var toIndexedObject$4 = toIndexedObject$f;
var nativeGetOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var DESCRIPTORS$a = descriptors$1;

var FAILS_ON_PRIMITIVES$7 = fails$w(function () { nativeGetOwnPropertyDescriptor$1(1); });
var FORCED$b = !DESCRIPTORS$a || FAILS_ON_PRIMITIVES$7;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$$_({ target: 'Object', stat: true, forced: FORCED$b, sham: !DESCRIPTORS$a }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor$1(toIndexedObject$4(it), key);
  }
});

var $$Z = _export;
var DESCRIPTORS$9 = descriptors$1;
var ownKeys$6 = ownKeys$8;
var toIndexedObject$3 = toIndexedObject$f;
var getOwnPropertyDescriptorModule$4 = objectGetOwnPropertyDescriptor;
var createProperty = createProperty$8;

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$$Z({ target: 'Object', stat: true, sham: !DESCRIPTORS$9 }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject$3(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule$4.f;
    var keys = ownKeys$6(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});

var $$Y = _export;
var fails$v = fails$$;
var getOwnPropertyNames$2 = objectGetOwnPropertyNamesExternal.f;

// eslint-disable-next-line es/no-object-getownpropertynames -- required for testing
var FAILS_ON_PRIMITIVES$6 = fails$v(function () { return !Object.getOwnPropertyNames(1); });

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
$$Y({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES$6 }, {
  getOwnPropertyNames: getOwnPropertyNames$2
});

var $$X = _export;
var fails$u = fails$$;
var toObject$7 = toObject$o;
var nativeGetPrototypeOf = objectGetPrototypeOf$1;
var CORRECT_PROTOTYPE_GETTER$1 = correctPrototypeGetter;

var FAILS_ON_PRIMITIVES$5 = fails$u(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$$X({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES$5, sham: !CORRECT_PROTOTYPE_GETTER$1 }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject$7(it));
  }
});

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

var $$W = _export;
var is = sameValue$1;

// `Object.is` method
// https://tc39.es/ecma262/#sec-object.is
$$W({ target: 'Object', stat: true }, {
  is: is
});

var $$V = _export;
var $isExtensible$1 = objectIsExtensible;

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
// eslint-disable-next-line es/no-object-isextensible -- safe
$$V({ target: 'Object', stat: true, forced: Object.isExtensible !== $isExtensible$1 }, {
  isExtensible: $isExtensible$1
});

var $$U = _export;
var fails$t = fails$$;
var isObject$i = isObject$z;
var classof$7 = classofRaw$1;
var ARRAY_BUFFER_NON_EXTENSIBLE$1 = arrayBufferNonExtensible;

// eslint-disable-next-line es/no-object-isfrozen -- safe
var $isFrozen = Object.isFrozen;
var FAILS_ON_PRIMITIVES$4 = fails$t(function () { $isFrozen(1); });

// `Object.isFrozen` method
// https://tc39.es/ecma262/#sec-object.isfrozen
$$U({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES$4 || ARRAY_BUFFER_NON_EXTENSIBLE$1 }, {
  isFrozen: function isFrozen(it) {
    if (!isObject$i(it)) return true;
    if (ARRAY_BUFFER_NON_EXTENSIBLE$1 && classof$7(it) == 'ArrayBuffer') return true;
    return $isFrozen ? $isFrozen(it) : false;
  }
});

var $$T = _export;
var fails$s = fails$$;
var isObject$h = isObject$z;
var classof$6 = classofRaw$1;
var ARRAY_BUFFER_NON_EXTENSIBLE = arrayBufferNonExtensible;

// eslint-disable-next-line es/no-object-issealed -- safe
var $isSealed = Object.isSealed;
var FAILS_ON_PRIMITIVES$3 = fails$s(function () { $isSealed(1); });

// `Object.isSealed` method
// https://tc39.es/ecma262/#sec-object.issealed
$$T({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES$3 || ARRAY_BUFFER_NON_EXTENSIBLE }, {
  isSealed: function isSealed(it) {
    if (!isObject$h(it)) return true;
    if (ARRAY_BUFFER_NON_EXTENSIBLE && classof$6(it) == 'ArrayBuffer') return true;
    return $isSealed ? $isSealed(it) : false;
  }
});

var $$S = _export;
var toObject$6 = toObject$o;
var nativeKeys = objectKeys$4;
var fails$r = fails$$;

var FAILS_ON_PRIMITIVES$2 = fails$r(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$$S({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES$2 }, {
  keys: function keys(it) {
    return nativeKeys(toObject$6(it));
  }
});

var $$R = _export;
var DESCRIPTORS$8 = descriptors$1;
var FORCED$a = objectPrototypeAccessorsForced;
var toObject$5 = toObject$o;
var toPropertyKey$3 = toPropertyKey$8;
var getPrototypeOf$5 = objectGetPrototypeOf$1;
var getOwnPropertyDescriptor$5 = objectGetOwnPropertyDescriptor.f;

// `Object.prototype.__lookupGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupGetter__
if (DESCRIPTORS$8) {
  $$R({ target: 'Object', proto: true, forced: FORCED$a }, {
    __lookupGetter__: function __lookupGetter__(P) {
      var O = toObject$5(this);
      var key = toPropertyKey$3(P);
      var desc;
      do {
        if (desc = getOwnPropertyDescriptor$5(O, key)) return desc.get;
      } while (O = getPrototypeOf$5(O));
    }
  });
}

var $$Q = _export;
var DESCRIPTORS$7 = descriptors$1;
var FORCED$9 = objectPrototypeAccessorsForced;
var toObject$4 = toObject$o;
var toPropertyKey$2 = toPropertyKey$8;
var getPrototypeOf$4 = objectGetPrototypeOf$1;
var getOwnPropertyDescriptor$4 = objectGetOwnPropertyDescriptor.f;

// `Object.prototype.__lookupSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupSetter__
if (DESCRIPTORS$7) {
  $$Q({ target: 'Object', proto: true, forced: FORCED$9 }, {
    __lookupSetter__: function __lookupSetter__(P) {
      var O = toObject$4(this);
      var key = toPropertyKey$2(P);
      var desc;
      do {
        if (desc = getOwnPropertyDescriptor$4(O, key)) return desc.set;
      } while (O = getPrototypeOf$4(O));
    }
  });
}

var $$P = _export;
var isObject$g = isObject$z;
var onFreeze$1 = internalMetadata.exports.onFreeze;
var FREEZING$2 = freezing;
var fails$q = fails$$;

// eslint-disable-next-line es/no-object-preventextensions -- safe
var $preventExtensions = Object.preventExtensions;
var FAILS_ON_PRIMITIVES$1 = fails$q(function () { $preventExtensions(1); });

// `Object.preventExtensions` method
// https://tc39.es/ecma262/#sec-object.preventextensions
$$P({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES$1, sham: !FREEZING$2 }, {
  preventExtensions: function preventExtensions(it) {
    return $preventExtensions && isObject$g(it) ? $preventExtensions(onFreeze$1(it)) : it;
  }
});

var $$O = _export;
var isObject$f = isObject$z;
var onFreeze = internalMetadata.exports.onFreeze;
var FREEZING$1 = freezing;
var fails$p = fails$$;

// eslint-disable-next-line es/no-object-seal -- safe
var $seal = Object.seal;
var FAILS_ON_PRIMITIVES = fails$p(function () { $seal(1); });

// `Object.seal` method
// https://tc39.es/ecma262/#sec-object.seal
$$O({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING$1 }, {
  seal: function seal(it) {
    return $seal && isObject$f(it) ? $seal(onFreeze(it)) : it;
  }
});

var TO_STRING_TAG_SUPPORT$1 = toStringTagSupport;
var classof$5 = classof$e;

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
var objectToString$1 = TO_STRING_TAG_SUPPORT$1 ? {}.toString : function toString() {
  return '[object ' + classof$5(this) + ']';
};

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var redefine$8 = redefine$h.exports;
var toString$f = objectToString$1;

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine$8(Object.prototype, 'toString', toString$f, { unsafe: true });
}

var $$N = _export;
var $values = objectToArray.values;

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$$N({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});

var $$M = _export;
var $parseFloat = numberParseFloat;

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$$M({ global: true, forced: parseFloat != $parseFloat }, {
  parseFloat: $parseFloat
});

var $$L = _export;
var $parseInt = numberParseInt;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$$L({ global: true, forced: parseInt != $parseInt }, {
  parseInt: $parseInt
});

var global$w = global$1o;

var nativePromiseConstructor = global$w.Promise;

var userAgent$4 = engineUserAgent;

var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$4);

var global$v = global$1o;
var apply$6 = functionApply$1;
var bind$7 = functionBindContext;
var isCallable$6 = isCallable$r;
var hasOwn$8 = hasOwnProperty_1;
var fails$o = fails$$;
var html = html$2;
var arraySlice$5 = arraySlice$a;
var createElement$1 = documentCreateElement$2;
var IS_IOS$1 = engineIsIos;
var IS_NODE$3 = engineIsNode;

var set$1 = global$v.setImmediate;
var clear = global$v.clearImmediate;
var process$4 = global$v.process;
var Dispatch = global$v.Dispatch;
var Function$2 = global$v.Function;
var MessageChannel$1 = global$v.MessageChannel;
var String$1 = global$v.String;
var counter = 0;
var queue$1 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var location$1, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  location$1 = global$v.location;
} catch (error) { /* empty */ }

var run = function (id) {
  if (hasOwn$8(queue$1, id)) {
    var fn = queue$1[id];
    delete queue$1[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener$1 = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global$v.postMessage(String$1(id), location$1.protocol + '//' + location$1.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set$1 || !clear) {
  set$1 = function setImmediate(fn) {
    var args = arraySlice$5(arguments, 1);
    queue$1[++counter] = function () {
      apply$6(isCallable$6(fn) ? fn : Function$2(fn), undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$1[id];
  };
  // Node.js 0.8-
  if (IS_NODE$3) {
    defer = function (id) {
      process$4.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel$1 && !IS_IOS$1) {
    channel = new MessageChannel$1();
    port = channel.port2;
    channel.port1.onmessage = listener$1;
    defer = bind$7(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$v.addEventListener &&
    isCallable$6(global$v.postMessage) &&
    !global$v.importScripts &&
    location$1 && location$1.protocol !== 'file:' &&
    !fails$o(post)
  ) {
    defer = post;
    global$v.addEventListener('message', listener$1, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement$1('script')) {
    defer = function (id) {
      html.appendChild(createElement$1('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$2 = {
  set: set$1,
  clear: clear
};

var userAgent$3 = engineUserAgent;
var global$u = global$1o;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$3) && global$u.Pebble !== undefined;

var userAgent$2 = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent$2);

var global$t = global$1o;
var bind$6 = functionBindContext;
var getOwnPropertyDescriptor$3 = objectGetOwnPropertyDescriptor.f;
var macrotask = task$2.set;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$2 = engineIsNode;

var MutationObserver$2 = global$t.MutationObserver || global$t.WebKitMutationObserver;
var document$2 = global$t.document;
var process$3 = global$t.process;
var Promise$1 = global$t.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor$3(global$t, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last$1, notify$1, toggle, node$1, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$3.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify$1();
        else last$1 = undefined;
        throw error;
      }
    } last$1 = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver$2 && document$2) {
    toggle = true;
    node$1 = document$2.createTextNode('');
    new MutationObserver$2(flush).observe(node$1, { characterData: true });
    notify$1 = function () {
      node$1.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$6(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$2) {
    notify$1 = function () {
      process$3.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = bind$6(macrotask, global$t);
    notify$1 = function () {
      macrotask(flush);
    };
  }
}

var microtask$2 = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last$1) last$1.next = task;
  if (!head) {
    head = task;
    notify$1();
  } last$1 = task;
};

var newPromiseCapability$2 = {};

var aCallable$4 = aCallable$d;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$4(resolve);
  this.reject = aCallable$4(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var anObject$k = anObject$y;
var isObject$e = isObject$z;
var newPromiseCapability$1 = newPromiseCapability$2;

var promiseResolve$2 = function (C, x) {
  anObject$k(C);
  if (isObject$e(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability$1.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var global$s = global$1o;

var hostReportErrors$1 = function (a, b) {
  var console = global$s.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};

var perform$2 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var Queue$1 = function () {
  this.head = null;
  this.tail = null;
};

Queue$1.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    if (this.head) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};

var queue = Queue$1;

var engineIsBrowser = typeof window == 'object';

var $$K = _export;
var global$r = global$1o;
var getBuiltIn$4 = getBuiltIn$c;
var call$e = functionCall;
var NativePromise$1 = nativePromiseConstructor;
var redefine$7 = redefine$h.exports;
var redefineAll$3 = redefineAll$6;
var setPrototypeOf$2 = objectSetPrototypeOf$1;
var setToStringTag$2 = setToStringTag$a;
var setSpecies$2 = setSpecies$6;
var aCallable$3 = aCallable$d;
var isCallable$5 = isCallable$r;
var isObject$d = isObject$z;
var anInstance$4 = anInstance$8;
var inspectSource = inspectSource$4;
var iterate$1 = iterate$5;
var checkCorrectnessOfIteration$1 = checkCorrectnessOfIteration$4;
var speciesConstructor$3 = speciesConstructor$5;
var task$1 = task$2.set;
var microtask$1 = microtask$2;
var promiseResolve$1 = promiseResolve$2;
var hostReportErrors = hostReportErrors$1;
var newPromiseCapabilityModule = newPromiseCapability$2;
var perform$1 = perform$2;
var Queue = queue;
var InternalStateModule$5 = internalState;
var isForced$1 = isForced_1;
var wellKnownSymbol$a = wellKnownSymbol$v;
var IS_BROWSER = engineIsBrowser;
var IS_NODE$1 = engineIsNode;
var V8_VERSION = engineV8Version;

var SPECIES$1 = wellKnownSymbol$a('species');
var PROMISE = 'Promise';

var getInternalState$3 = InternalStateModule$5.getterFor(PROMISE);
var setInternalState$5 = InternalStateModule$5.set;
var getInternalPromiseState = InternalStateModule$5.getterFor(PROMISE);
var NativePromisePrototype = NativePromise$1 && NativePromise$1.prototype;
var PromiseConstructor = NativePromise$1;
var PromisePrototype = NativePromisePrototype;
var TypeError$6 = global$r.TypeError;
var document$1 = global$r.document;
var process$2 = global$r.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$r.dispatchEvent);
var NATIVE_REJECTION_EVENT = isCallable$5(global$r.PromiseRejectionEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var SUBCLASSING = false;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED$8 = isForced$1(PROMISE, function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = new PromiseConstructor(function (resolve) { resolve(1); });
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES$1] = FakePromise;
  SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
  if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
});

var INCORRECT_ITERATION = FORCED$8 || !checkCorrectnessOfIteration$1(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable$1 = function (it) {
  var then;
  return isObject$d(it) && isCallable$5(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError$6('Promise-chain cycle'));
      } else if (then = isThenable$1(result)) {
        call$e(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask$1(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$r.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global$r['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$e(task$1, global$r, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$1(function () {
        if (IS_NODE$1) {
          process$2.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE$1 || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$e(task$1, global$r, function () {
    var promise = state.facade;
    if (IS_NODE$1) {
      process$2.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$5 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$6("Promise can't be resolved itself");
    var then = isThenable$1(value);
    if (then) {
      microtask$1(function () {
        var wrapper = { done: false };
        try {
          call$e(then, value,
            bind$5(internalResolve, wrapper, state),
            bind$5(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED$8) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance$4(this, PromisePrototype);
    aCallable$3(executor);
    call$e(Internal, this);
    var state = getInternalState$3(this);
    try {
      executor(bind$5(internalResolve, state), bind$5(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  PromisePrototype = PromiseConstructor.prototype;
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState$5(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll$3(PromisePrototype, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    // eslint-disable-next-line unicorn/no-thenable -- safe
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor$3(this, PromiseConstructor));
      state.parent = true;
      reaction.ok = isCallable$5(onFulfilled) ? onFulfilled : true;
      reaction.fail = isCallable$5(onRejected) && onRejected;
      reaction.domain = IS_NODE$1 ? process$2.domain : undefined;
      if (state.state == PENDING) state.reactions.add(reaction);
      else microtask$1(function () {
        callReaction(reaction, state);
      });
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState$3(promise);
    this.promise = promise;
    this.resolve = bind$5(internalResolve, state);
    this.reject = bind$5(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$5(NativePromise$1) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      redefine$7(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$e(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });

      // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
      redefine$7(NativePromisePrototype, 'catch', PromisePrototype['catch'], { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf$2) {
      setPrototypeOf$2(NativePromisePrototype, PromisePrototype);
    }
  }
}

$$K({ global: true, wrap: true, forced: FORCED$8 }, {
  Promise: PromiseConstructor
});

setToStringTag$2(PromiseConstructor, PROMISE, false);
setSpecies$2(PROMISE);

PromiseWrapper = getBuiltIn$4(PROMISE);

// statics
$$K({ target: PROMISE, stat: true, forced: FORCED$8 }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    call$e(capability.reject, undefined, r);
    return capability.promise;
  }
});

$$K({ target: PROMISE, stat: true, forced: FORCED$8 }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve$1(this, x);
  }
});

$$K({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$3(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$e($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$3(C.resolve);
      iterate$1(iterable, function (promise) {
        call$e($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$J = _export;
var NativePromise = nativePromiseConstructor;
var fails$n = fails$$;
var getBuiltIn$3 = getBuiltIn$c;
var isCallable$4 = isCallable$r;
var speciesConstructor$2 = speciesConstructor$5;
var promiseResolve = promiseResolve$2;
var redefine$6 = redefine$h.exports;

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromise && fails$n(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromise.prototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$$J({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor$2(this, getBuiltIn$3('Promise'));
    var isFunction = isCallable$4(onFinally);
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (isCallable$4(NativePromise)) {
  var method = getBuiltIn$3('Promise').prototype['finally'];
  if (NativePromise.prototype['finally'] !== method) {
    redefine$6(NativePromise.prototype, 'finally', method, { unsafe: true });
  }
}

var $$I = _export;
var functionApply = functionApply$1;
var aCallable$2 = aCallable$d;
var anObject$j = anObject$y;
var fails$m = fails$$;

// MS Edge argumentsList argument is optional
var OPTIONAL_ARGUMENTS_LIST = !fails$m(function () {
  // eslint-disable-next-line es/no-reflect -- required for testing
  Reflect.apply(function () { /* empty */ });
});

// `Reflect.apply` method
// https://tc39.es/ecma262/#sec-reflect.apply
$$I({ target: 'Reflect', stat: true, forced: OPTIONAL_ARGUMENTS_LIST }, {
  apply: function apply(target, thisArgument, argumentsList) {
    return functionApply(aCallable$2(target), thisArgument, anObject$j(argumentsList));
  }
});

var global$q = global$1o;
var uncurryThis$p = functionUncurryThis;
var aCallable$1 = aCallable$d;
var isObject$c = isObject$z;
var hasOwn$7 = hasOwnProperty_1;
var arraySlice$4 = arraySlice$a;

var Function$1 = global$q.Function;
var concat$1 = uncurryThis$p([].concat);
var join$6 = uncurryThis$p([].join);
var factories = {};

var construct = function (C, argsLength, args) {
  if (!hasOwn$7(factories, argsLength)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    factories[argsLength] = Function$1('C,a', 'return new C(' + join$6(list, ',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
var functionBind = Function$1.bind || function bind(that /* , ...args */) {
  var F = aCallable$1(this);
  var Prototype = F.prototype;
  var partArgs = arraySlice$4(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = concat$1(partArgs, arraySlice$4(arguments));
    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
  };
  if (isObject$c(Prototype)) boundFunction.prototype = Prototype;
  return boundFunction;
};

var $$H = _export;
var getBuiltIn$2 = getBuiltIn$c;
var apply$5 = functionApply$1;
var bind$4 = functionBind;
var aConstructor$1 = aConstructor$3;
var anObject$i = anObject$y;
var isObject$b = isObject$z;
var create$3 = objectCreate;
var fails$l = fails$$;

var nativeConstruct = getBuiltIn$2('Reflect', 'construct');
var ObjectPrototype$1 = Object.prototype;
var push$6 = [].push;

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails$l(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});

var ARGS_BUG = !fails$l(function () {
  nativeConstruct(function () { /* empty */ });
});

var FORCED$7 = NEW_TARGET_BUG || ARGS_BUG;

$$H({ target: 'Reflect', stat: true, forced: FORCED$7, sham: FORCED$7 }, {
  construct: function construct(Target, args /* , newTarget */) {
    aConstructor$1(Target);
    anObject$i(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor$1(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      apply$5(push$6, $args, args);
      return new (apply$5(bind$4, Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create$3(isObject$b(proto) ? proto : ObjectPrototype$1);
    var result = apply$5(Target, instance, args);
    return isObject$b(result) ? result : instance;
  }
});

var $$G = _export;
var DESCRIPTORS$6 = descriptors$1;
var anObject$h = anObject$y;
var toPropertyKey$1 = toPropertyKey$8;
var definePropertyModule$2 = objectDefineProperty;
var fails$k = fails$$;

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
var ERROR_INSTEAD_OF_FALSE = fails$k(function () {
  // eslint-disable-next-line es/no-reflect -- required for testing
  Reflect.defineProperty(definePropertyModule$2.f({}, 1, { value: 1 }), 1, { value: 2 });
});

// `Reflect.defineProperty` method
// https://tc39.es/ecma262/#sec-reflect.defineproperty
$$G({ target: 'Reflect', stat: true, forced: ERROR_INSTEAD_OF_FALSE, sham: !DESCRIPTORS$6 }, {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject$h(target);
    var key = toPropertyKey$1(propertyKey);
    anObject$h(attributes);
    try {
      definePropertyModule$2.f(target, key, attributes);
      return true;
    } catch (error) {
      return false;
    }
  }
});

var $$F = _export;
var anObject$g = anObject$y;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;

// `Reflect.deleteProperty` method
// https://tc39.es/ecma262/#sec-reflect.deleteproperty
$$F({ target: 'Reflect', stat: true }, {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var descriptor = getOwnPropertyDescriptor$2(anObject$g(target), propertyKey);
    return descriptor && !descriptor.configurable ? false : delete target[propertyKey];
  }
});

var hasOwn$6 = hasOwnProperty_1;

var isDataDescriptor$2 = function (descriptor) {
  return descriptor !== undefined && (hasOwn$6(descriptor, 'value') || hasOwn$6(descriptor, 'writable'));
};

var $$E = _export;
var call$d = functionCall;
var isObject$a = isObject$z;
var anObject$f = anObject$y;
var isDataDescriptor$1 = isDataDescriptor$2;
var getOwnPropertyDescriptorModule$3 = objectGetOwnPropertyDescriptor;
var getPrototypeOf$3 = objectGetPrototypeOf$1;

// `Reflect.get` method
// https://tc39.es/ecma262/#sec-reflect.get
function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var descriptor, prototype;
  if (anObject$f(target) === receiver) return target[propertyKey];
  descriptor = getOwnPropertyDescriptorModule$3.f(target, propertyKey);
  if (descriptor) return isDataDescriptor$1(descriptor)
    ? descriptor.value
    : descriptor.get === undefined ? undefined : call$d(descriptor.get, receiver);
  if (isObject$a(prototype = getPrototypeOf$3(target))) return get(prototype, propertyKey, receiver);
}

$$E({ target: 'Reflect', stat: true }, {
  get: get
});

var $$D = _export;
var DESCRIPTORS$5 = descriptors$1;
var anObject$e = anObject$y;
var getOwnPropertyDescriptorModule$2 = objectGetOwnPropertyDescriptor;

// `Reflect.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-reflect.getownpropertydescriptor
$$D({ target: 'Reflect', stat: true, sham: !DESCRIPTORS$5 }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return getOwnPropertyDescriptorModule$2.f(anObject$e(target), propertyKey);
  }
});

var $$C = _export;
var anObject$d = anObject$y;
var objectGetPrototypeOf = objectGetPrototypeOf$1;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

// `Reflect.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.getprototypeof
$$C({ target: 'Reflect', stat: true, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(target) {
    return objectGetPrototypeOf(anObject$d(target));
  }
});

var $$B = _export;

// `Reflect.has` method
// https://tc39.es/ecma262/#sec-reflect.has
$$B({ target: 'Reflect', stat: true }, {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});

var $$A = _export;
var anObject$c = anObject$y;
var $isExtensible = objectIsExtensible;

// `Reflect.isExtensible` method
// https://tc39.es/ecma262/#sec-reflect.isextensible
$$A({ target: 'Reflect', stat: true }, {
  isExtensible: function isExtensible(target) {
    anObject$c(target);
    return $isExtensible(target);
  }
});

var $$z = _export;
var ownKeys$5 = ownKeys$8;

// `Reflect.ownKeys` method
// https://tc39.es/ecma262/#sec-reflect.ownkeys
$$z({ target: 'Reflect', stat: true }, {
  ownKeys: ownKeys$5
});

var $$y = _export;
var getBuiltIn$1 = getBuiltIn$c;
var anObject$b = anObject$y;
var FREEZING = freezing;

// `Reflect.preventExtensions` method
// https://tc39.es/ecma262/#sec-reflect.preventextensions
$$y({ target: 'Reflect', stat: true, sham: !FREEZING }, {
  preventExtensions: function preventExtensions(target) {
    anObject$b(target);
    try {
      var objectPreventExtensions = getBuiltIn$1('Object', 'preventExtensions');
      if (objectPreventExtensions) objectPreventExtensions(target);
      return true;
    } catch (error) {
      return false;
    }
  }
});

var $$x = _export;
var call$c = functionCall;
var anObject$a = anObject$y;
var isObject$9 = isObject$z;
var isDataDescriptor = isDataDescriptor$2;
var fails$j = fails$$;
var definePropertyModule$1 = objectDefineProperty;
var getOwnPropertyDescriptorModule$1 = objectGetOwnPropertyDescriptor;
var getPrototypeOf$2 = objectGetPrototypeOf$1;
var createPropertyDescriptor$2 = createPropertyDescriptor$8;

// `Reflect.set` method
// https://tc39.es/ecma262/#sec-reflect.set
function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDescriptor = getOwnPropertyDescriptorModule$1.f(anObject$a(target), propertyKey);
  var existingDescriptor, prototype, setter;
  if (!ownDescriptor) {
    if (isObject$9(prototype = getPrototypeOf$2(target))) {
      return set(prototype, propertyKey, V, receiver);
    }
    ownDescriptor = createPropertyDescriptor$2(0);
  }
  if (isDataDescriptor(ownDescriptor)) {
    if (ownDescriptor.writable === false || !isObject$9(receiver)) return false;
    if (existingDescriptor = getOwnPropertyDescriptorModule$1.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      definePropertyModule$1.f(receiver, propertyKey, existingDescriptor);
    } else definePropertyModule$1.f(receiver, propertyKey, createPropertyDescriptor$2(0, V));
  } else {
    setter = ownDescriptor.set;
    if (setter === undefined) return false;
    call$c(setter, receiver, V);
  } return true;
}

// MS Edge 17-18 Reflect.set allows setting the property to object
// with non-writable property on the prototype
var MS_EDGE_BUG = fails$j(function () {
  var Constructor = function () { /* empty */ };
  var object = definePropertyModule$1.f(new Constructor(), 'a', { configurable: true });
  // eslint-disable-next-line es/no-reflect -- required for testing
  return Reflect.set(Constructor.prototype, 'a', 1, object) !== false;
});

$$x({ target: 'Reflect', stat: true, forced: MS_EDGE_BUG }, {
  set: set
});

var $$w = _export;
var anObject$9 = anObject$y;
var aPossiblePrototype = aPossiblePrototype$2;
var objectSetPrototypeOf = objectSetPrototypeOf$1;

// `Reflect.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.setprototypeof
if (objectSetPrototypeOf) $$w({ target: 'Reflect', stat: true }, {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    anObject$9(target);
    aPossiblePrototype(proto);
    try {
      objectSetPrototypeOf(target, proto);
      return true;
    } catch (error) {
      return false;
    }
  }
});

var isObject$8 = isObject$z;
var classof$4 = classofRaw$1;
var wellKnownSymbol$9 = wellKnownSymbol$v;

var MATCH$2 = wellKnownSymbol$9('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$8(it) && ((isRegExp = it[MATCH$2]) !== undefined ? !!isRegExp : classof$4(it) == 'RegExp');
};

var anObject$8 = anObject$y;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$8(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var fails$i = fails$$;
var global$p = global$1o;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$p.RegExp;

var UNSUPPORTED_Y$3 = fails$i(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY$1 = UNSUPPORTED_Y$3 || fails$i(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$3 || fails$i(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY$1,
  UNSUPPORTED_Y: UNSUPPORTED_Y$3
};

var fails$h = fails$$;
var global$o = global$1o;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$o.RegExp;

var regexpUnsupportedDotAll = fails$h(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

var fails$g = fails$$;
var global$n = global$1o;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$n.RegExp;

var regexpUnsupportedNcg = fails$g(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

var DESCRIPTORS$4 = descriptors$1;
var global$m = global$1o;
var uncurryThis$o = functionUncurryThis;
var isForced = isForced_1;
var inheritIfRequired$1 = inheritIfRequired$4;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$b;
var defineProperty$1 = objectDefineProperty.f;
var getOwnPropertyNames$1 = objectGetOwnPropertyNames.f;
var isPrototypeOf$3 = objectIsPrototypeOf;
var isRegExp$3 = isRegexp;
var toString$e = toString$m;
var regExpFlags$2 = regexpFlags$1;
var stickyHelpers$2 = regexpStickyHelpers;
var redefine$5 = redefine$h.exports;
var fails$f = fails$$;
var hasOwn$5 = hasOwnProperty_1;
var enforceInternalState$1 = internalState.enforce;
var setSpecies$1 = setSpecies$6;
var wellKnownSymbol$8 = wellKnownSymbol$v;
var UNSUPPORTED_DOT_ALL$1 = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG$1 = regexpUnsupportedNcg;

var MATCH$1 = wellKnownSymbol$8('match');
var NativeRegExp = global$m.RegExp;
var RegExpPrototype$3 = NativeRegExp.prototype;
var SyntaxError = global$m.SyntaxError;
var getFlags$1 = uncurryThis$o(regExpFlags$2);
var exec$4 = uncurryThis$o(RegExpPrototype$3.exec);
var charAt$7 = uncurryThis$o(''.charAt);
var replace$8 = uncurryThis$o(''.replace);
var stringIndexOf$2 = uncurryThis$o(''.indexOf);
var stringSlice$9 = uncurryThis$o(''.slice);
// TODO: Use only propper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY = stickyHelpers$2.MISSED_STICKY;
var UNSUPPORTED_Y$2 = stickyHelpers$2.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS$4 &&
  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL$1 || UNSUPPORTED_NCG$1 || fails$f(function () {
    re2[MATCH$1] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt$7(string, index);
    if (chr === '\\') {
      result += chr + charAt$7(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt$7(string, index);
    if (chr === '\\') {
      chr = chr + charAt$7(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (exec$4(IS_NCG, stringSlice$9(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn$5(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = isPrototypeOf$3(RegExpPrototype$3, this);
    var patternIsRegExp = isRegExp$3(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || isPrototypeOf$3(RegExpPrototype$3, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = 'flags' in rawPattern ? rawPattern.flags : getFlags$1(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString$e(pattern);
    flags = flags === undefined ? '' : toString$e(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL$1 && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf$2(flags, 's') > -1;
      if (dotAll) flags = replace$8(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf$2(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y$2) flags = replace$8(flags, /y/g, '');
    }

    if (UNSUPPORTED_NCG$1) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired$1(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype$3, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState$1(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty$5(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  var proxy = function (key) {
    key in RegExpWrapper || defineProperty$1(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };

  for (var keys = getOwnPropertyNames$1(NativeRegExp), index = 0; keys.length > index;) {
    proxy(keys[index++]);
  }

  RegExpPrototype$3.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype$3;
  redefine$5(global$m, 'RegExp', RegExpWrapper);
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies$1('RegExp');

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$b = functionCall;
var uncurryThis$n = functionUncurryThis;
var toString$d = toString$m;
var regexpFlags = regexpFlags$1;
var stickyHelpers$1 = regexpStickyHelpers;
var shared = shared$5.exports;
var create$2 = objectCreate;
var getInternalState$2 = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$6 = uncurryThis$n(''.charAt);
var indexOf = uncurryThis$n(''.indexOf);
var replace$7 = uncurryThis$n(''.replace);
var stringSlice$8 = uncurryThis$n(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$b(nativeExec, re1, 'a');
  call$b(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$1 = stickyHelpers$1.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1 || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState$2(re);
    var str = toString$d(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$b(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = call$b(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$7(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$8(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$6(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$b(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$8(match.input, charsAdded);
        match[0] = stringSlice$8(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      call$b(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create$2(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$3 = patchedExec;

var $$v = _export;
var exec$3 = regexpExec$3;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$v({ target: 'RegExp', proto: true, forced: /./.exec !== exec$3 }, {
  exec: exec$3
});

var DESCRIPTORS$3 = descriptors$1;
var objectDefinePropertyModule = objectDefineProperty;
var regExpFlags$1 = regexpFlags$1;
var fails$e = fails$$;

var RegExpPrototype$2 = RegExp.prototype;

var FORCED$6 = DESCRIPTORS$3 && fails$e(function () {
  // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
  return Object.getOwnPropertyDescriptor(RegExpPrototype$2, 'flags').get.call({ dotAll: true, sticky: true }) !== 'sy';
});

// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if (FORCED$6) objectDefinePropertyModule.f(RegExpPrototype$2, 'flags', {
  configurable: true,
  get: regExpFlags$1
});

var uncurryThis$m = functionUncurryThis;
var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var redefine$4 = redefine$h.exports;
var anObject$7 = anObject$y;
var isPrototypeOf$2 = objectIsPrototypeOf;
var $toString$2 = toString$m;
var fails$d = fails$$;
var regExpFlags = regexpFlags$1;

var TO_STRING = 'toString';
var RegExpPrototype$1 = RegExp.prototype;
var n$ToString = RegExpPrototype$1[TO_STRING];
var getFlags = uncurryThis$m(regExpFlags);

var NOT_GENERIC = fails$d(function () { return n$ToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME$1 && n$ToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine$4(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject$7(this);
    var p = $toString$2(R.source);
    var rf = R.flags;
    var f = $toString$2(rf === undefined && isPrototypeOf$2(RegExpPrototype$1, R) && !('flags' in RegExpPrototype$1) ? getFlags(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}

var collection$2 = collection$4;
var collectionStrong = collectionStrong$2;

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
collection$2('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);

var uncurryThis$l = functionUncurryThis;
var toIntegerOrInfinity$3 = toIntegerOrInfinity$c;
var toString$c = toString$m;
var requireObjectCoercible$9 = requireObjectCoercible$e;

var charAt$5 = uncurryThis$l(''.charAt);
var charCodeAt$1 = uncurryThis$l(''.charCodeAt);
var stringSlice$7 = uncurryThis$l(''.slice);

var createMethod$1 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$c(requireObjectCoercible$9($this));
    var position = toIntegerOrInfinity$3(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt$1(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt$1(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$5(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$7(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$1(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$1(true)
};

var $$u = _export;
var codeAt$1 = stringMultibyte.codeAt;

// `String.prototype.codePointAt` method
// https://tc39.es/ecma262/#sec-string.prototype.codepointat
$$u({ target: 'String', proto: true }, {
  codePointAt: function codePointAt(pos) {
    return codeAt$1(this, pos);
  }
});

var global$l = global$1o;
var isRegExp$2 = isRegexp;

var TypeError$5 = global$l.TypeError;

var notARegexp = function (it) {
  if (isRegExp$2(it)) {
    throw TypeError$5("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$7 = wellKnownSymbol$v;

var MATCH = wellKnownSymbol$7('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$t = _export;
var uncurryThis$k = functionUncurryThis;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var toLength$7 = toLength$c;
var toString$b = toString$m;
var notARegExp$2 = notARegexp;
var requireObjectCoercible$8 = requireObjectCoercible$e;
var correctIsRegExpLogic$2 = correctIsRegexpLogic;

// eslint-disable-next-line es/no-string-prototype-endswith -- safe
var un$EndsWith = uncurryThis$k(''.endsWith);
var slice$1 = uncurryThis$k(''.slice);
var min$5 = Math.min;

var CORRECT_IS_REGEXP_LOGIC$1 = correctIsRegExpLogic$2('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG$1 = !CORRECT_IS_REGEXP_LOGIC$1 && !!function () {
  var descriptor = getOwnPropertyDescriptor$1(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$$t({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG$1 && !CORRECT_IS_REGEXP_LOGIC$1 }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = toString$b(requireObjectCoercible$8(this));
    notARegExp$2(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = that.length;
    var end = endPosition === undefined ? len : min$5(toLength$7(endPosition), len);
    var search = toString$b(searchString);
    return un$EndsWith
      ? un$EndsWith(that, search, end)
      : slice$1(that, end - search.length, end) === search;
  }
});

var $$s = _export;
var global$k = global$1o;
var uncurryThis$j = functionUncurryThis;
var toAbsoluteIndex$1 = toAbsoluteIndex$9;

var RangeError$5 = global$k.RangeError;
var fromCharCode$1 = String.fromCharCode;
// eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
var $fromCodePoint = String.fromCodePoint;
var join$5 = uncurryThis$j([].join);

// length should be 1, old FF problem
var INCORRECT_LENGTH = !!$fromCodePoint && $fromCodePoint.length != 1;

// `String.fromCodePoint` method
// https://tc39.es/ecma262/#sec-string.fromcodepoint
$$s({ target: 'String', stat: true, forced: INCORRECT_LENGTH }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  fromCodePoint: function fromCodePoint(x) {
    var elements = [];
    var length = arguments.length;
    var i = 0;
    var code;
    while (length > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex$1(code, 0x10FFFF) !== code) throw RangeError$5(code + ' is not a valid code point');
      elements[i] = code < 0x10000
        ? fromCharCode$1(code)
        : fromCharCode$1(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
    } return join$5(elements, '');
  }
});

var $$r = _export;
var uncurryThis$i = functionUncurryThis;
var notARegExp$1 = notARegexp;
var requireObjectCoercible$7 = requireObjectCoercible$e;
var toString$a = toString$m;
var correctIsRegExpLogic$1 = correctIsRegexpLogic;

var stringIndexOf$1 = uncurryThis$i(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$r({ target: 'String', proto: true, forced: !correctIsRegExpLogic$1('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf$1(
      toString$a(requireObjectCoercible$7(this)),
      toString$a(notARegExp$1(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

var charAt$4 = stringMultibyte.charAt;
var toString$9 = toString$m;
var InternalStateModule$4 = internalState;
var defineIterator = defineIterator$3;

var STRING_ITERATOR = 'String Iterator';
var setInternalState$4 = InternalStateModule$4.set;
var getInternalState$1 = InternalStateModule$4.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState$4(this, {
    type: STRING_ITERATOR,
    string: toString$9(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$1(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt$4(string, index);
  state.index += point.length;
  return { value: point, done: false };
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var uncurryThis$h = functionUncurryThis;
var redefine$3 = redefine$h.exports;
var regexpExec$2 = regexpExec$3;
var fails$c = fails$$;
var wellKnownSymbol$6 = wellKnownSymbol$v;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$b;

var SPECIES = wellKnownSymbol$6('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$6(KEY);

  var DELEGATES_TO_SYMBOL = !fails$c(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$c(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis$h(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis$h(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec$2 || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    redefine$3(String.prototype, KEY, methods[0]);
    redefine$3(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty$4(RegExpPrototype[SYMBOL], 'sham', true);
};

var charAt$3 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$3 = function (S, index, unicode) {
  return index + (unicode ? charAt$3(S, index).length : 1);
};

var global$j = global$1o;
var call$a = functionCall;
var anObject$6 = anObject$y;
var isCallable$3 = isCallable$r;
var classof$3 = classofRaw$1;
var regexpExec$1 = regexpExec$3;

var TypeError$4 = global$j.TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$3(exec)) {
    var result = call$a(exec, R, S);
    if (result !== null) anObject$6(result);
    return result;
  }
  if (classof$3(R) === 'RegExp') return call$a(regexpExec$1, R, S);
  throw TypeError$4('RegExp#exec called on incompatible receiver');
};

var call$9 = functionCall;
var fixRegExpWellKnownSymbolLogic$3 = fixRegexpWellKnownSymbolLogic;
var anObject$5 = anObject$y;
var toLength$6 = toLength$c;
var toString$8 = toString$m;
var requireObjectCoercible$6 = requireObjectCoercible$e;
var getMethod$3 = getMethod$7;
var advanceStringIndex$2 = advanceStringIndex$3;
var regExpExec$2 = regexpExecAbstract;

// @@match logic
fixRegExpWellKnownSymbolLogic$3('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible$6(this);
      var matcher = regexp == undefined ? undefined : getMethod$3(regexp, MATCH);
      return matcher ? call$9(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString$8(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject$5(this);
      var S = toString$8(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec$2(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec$2(rx, S)) !== null) {
        var matchStr = toString$8(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex$2(S, toLength$6(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

// https://github.com/tc39/proposal-string-pad-start-end
var uncurryThis$g = functionUncurryThis;
var toLength$5 = toLength$c;
var toString$7 = toString$m;
var $repeat = stringRepeat;
var requireObjectCoercible$5 = requireObjectCoercible$e;

var repeat$1 = uncurryThis$g($repeat);
var stringSlice$6 = uncurryThis$g(''.slice);
var ceil = Math.ceil;

// `String.prototype.{ padStart, padEnd }` methods implementation
var createMethod = function (IS_END) {
  return function ($this, maxLength, fillString) {
    var S = toString$7(requireObjectCoercible$5($this));
    var intMaxLength = toLength$5(maxLength);
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : toString$7(fillString);
    var fillLen, stringFiller;
    if (intMaxLength <= stringLength || fillStr == '') return S;
    fillLen = intMaxLength - stringLength;
    stringFiller = repeat$1(fillStr, ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringSlice$6(stringFiller, 0, fillLen);
    return IS_END ? S + stringFiller : stringFiller + S;
  };
};

var stringPad = {
  // `String.prototype.padStart` method
  // https://tc39.es/ecma262/#sec-string.prototype.padstart
  start: createMethod(false),
  // `String.prototype.padEnd` method
  // https://tc39.es/ecma262/#sec-string.prototype.padend
  end: createMethod(true)
};

// https://github.com/zloirock/core-js/issues/280
var userAgent$1 = engineUserAgent;

var stringPadWebkitBug = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(userAgent$1);

var $$q = _export;
var $padEnd = stringPad.end;
var WEBKIT_BUG$1 = stringPadWebkitBug;

// `String.prototype.padEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.padend
$$q({ target: 'String', proto: true, forced: WEBKIT_BUG$1 }, {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var $$p = _export;
var $padStart = stringPad.start;
var WEBKIT_BUG = stringPadWebkitBug;

// `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart
$$p({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var $$o = _export;
var uncurryThis$f = functionUncurryThis;
var toIndexedObject$2 = toIndexedObject$f;
var toObject$3 = toObject$o;
var toString$6 = toString$m;
var lengthOfArrayLike$4 = lengthOfArrayLike$k;

var push$5 = uncurryThis$f([].push);
var join$4 = uncurryThis$f([].join);

// `String.raw` method
// https://tc39.es/ecma262/#sec-string.raw
$$o({ target: 'String', stat: true }, {
  raw: function raw(template) {
    var rawTemplate = toIndexedObject$2(toObject$3(template).raw);
    var literalSegments = lengthOfArrayLike$4(rawTemplate);
    var argumentsLength = arguments.length;
    var elements = [];
    var i = 0;
    while (literalSegments > i) {
      push$5(elements, toString$6(rawTemplate[i++]));
      if (i === literalSegments) return join$4(elements, '');
      if (i < argumentsLength) push$5(elements, toString$6(arguments[i]));
    }
  }
});

var $$n = _export;
var repeat = stringRepeat;

// `String.prototype.repeat` method
// https://tc39.es/ecma262/#sec-string.prototype.repeat
$$n({ target: 'String', proto: true }, {
  repeat: repeat
});

var uncurryThis$e = functionUncurryThis;
var toObject$2 = toObject$o;

var floor$3 = Math.floor;
var charAt$2 = uncurryThis$e(''.charAt);
var replace$6 = uncurryThis$e(''.replace);
var stringSlice$5 = uncurryThis$e(''.slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject$2(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$6(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt$2(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$5(str, 0, position);
      case "'": return stringSlice$5(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$5(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor$3(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt$2(ch, 1) : captures[f - 1] + charAt$2(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var apply$4 = functionApply$1;
var call$8 = functionCall;
var uncurryThis$d = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic$2 = fixRegexpWellKnownSymbolLogic;
var fails$b = fails$$;
var anObject$4 = anObject$y;
var isCallable$2 = isCallable$r;
var toIntegerOrInfinity$2 = toIntegerOrInfinity$c;
var toLength$4 = toLength$c;
var toString$5 = toString$m;
var requireObjectCoercible$4 = requireObjectCoercible$e;
var advanceStringIndex$1 = advanceStringIndex$3;
var getMethod$2 = getMethod$7;
var getSubstitution = getSubstitution$1;
var regExpExec$1 = regexpExecAbstract;
var wellKnownSymbol$5 = wellKnownSymbol$v;

var REPLACE = wellKnownSymbol$5('replace');
var max$1 = Math.max;
var min$4 = Math.min;
var concat = uncurryThis$d([].concat);
var push$4 = uncurryThis$d([].push);
var stringIndexOf = uncurryThis$d(''.indexOf);
var stringSlice$4 = uncurryThis$d(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$b(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic$2('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$4(this);
      var replacer = searchValue == undefined ? undefined : getMethod$2(searchValue, REPLACE);
      return replacer
        ? call$8(replacer, searchValue, O, replaceValue)
        : call$8(nativeReplace, toString$5(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject$4(this);
      var S = toString$5(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable$2(replaceValue);
      if (!functionalReplace) replaceValue = toString$5(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec$1(rx, S);
        if (result === null) break;

        push$4(results, result);
        if (!global) break;

        var matchStr = toString$5(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex$1(S, toLength$4(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString$5(result[0]);
        var position = max$1(min$4(toIntegerOrInfinity$2(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push$4(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push$4(replacerArgs, namedCaptures);
          var replacement = toString$5(apply$4(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice$4(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice$4(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

var call$7 = functionCall;
var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var anObject$3 = anObject$y;
var requireObjectCoercible$3 = requireObjectCoercible$e;
var sameValue = sameValue$1;
var toString$4 = toString$m;
var getMethod$1 = getMethod$7;
var regExpExec = regexpExecAbstract;

// @@search logic
fixRegExpWellKnownSymbolLogic$1('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible$3(this);
      var searcher = regexp == undefined ? undefined : getMethod$1(regexp, SEARCH);
      return searcher ? call$7(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString$4(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject$3(this);
      var S = toString$4(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

var apply$3 = functionApply$1;
var call$6 = functionCall;
var uncurryThis$c = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var isRegExp$1 = isRegexp;
var anObject$2 = anObject$y;
var requireObjectCoercible$2 = requireObjectCoercible$e;
var speciesConstructor$1 = speciesConstructor$5;
var advanceStringIndex = advanceStringIndex$3;
var toLength$3 = toLength$c;
var toString$3 = toString$m;
var getMethod = getMethod$7;
var arraySlice$3 = arraySliceSimple;
var callRegExpExec = regexpExecAbstract;
var regexpExec = regexpExec$3;
var stickyHelpers = regexpStickyHelpers;
var fails$a = fails$$;

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min$3 = Math.min;
var $push = [].push;
var exec$2 = uncurryThis$c(/./.exec);
var push$3 = uncurryThis$c($push);
var stringSlice$3 = uncurryThis$c(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails$a(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString$3(requireObjectCoercible$2(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp$1(separator)) {
        return call$6(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = call$6(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push$3(output, stringSlice$3(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) apply$3($push, output, arraySlice$3(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec$2(separatorCopy, '')) push$3(output, '');
      } else push$3(output, stringSlice$3(string, lastLastIndex));
      return output.length > lim ? arraySlice$3(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : call$6(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible$2(this);
      var splitter = separator == undefined ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? call$6(splitter, separator, O, limit)
        : call$6(internalSplit, toString$3(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject$2(this);
      var S = toString$3(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor$1(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice$3(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min$3(toLength$3(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push$3(A, stringSlice$3(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push$3(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push$3(A, stringSlice$3(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);

var $$m = _export;
var uncurryThis$b = functionUncurryThis;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var toLength$2 = toLength$c;
var toString$2 = toString$m;
var notARegExp = notARegexp;
var requireObjectCoercible$1 = requireObjectCoercible$e;
var correctIsRegExpLogic = correctIsRegexpLogic;

// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var un$StartsWith = uncurryThis$b(''.startsWith);
var stringSlice$2 = uncurryThis$b(''.slice);
var min$2 = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$$m({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString$2(requireObjectCoercible$1(this));
    notARegExp(searchString);
    var index = toLength$2(min$2(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString$2(searchString);
    return un$StartsWith
      ? un$StartsWith(that, search, index)
      : stringSlice$2(that, index, index + search.length) === search;
  }
});

var PROPER_FUNCTION_NAME = functionName.PROPER;
var fails$9 = fails$$;
var whitespaces = whitespaces$4;

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails$9(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $$l = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod$2 = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$$l({ target: 'String', proto: true, forced: forcedStringTrimMethod$2('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

var $$k = _export;
var $trimEnd = stringTrim.end;
var forcedStringTrimMethod$1 = stringTrimForced;

var FORCED$5 = forcedStringTrimMethod$1('trimEnd');

var trimEnd = FORCED$5 ? function trimEnd() {
  return $trimEnd(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : ''.trimEnd;

// `String.prototype.{ trimEnd, trimRight }` methods
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// https://tc39.es/ecma262/#String.prototype.trimright
$$k({ target: 'String', proto: true, name: 'trimEnd', forced: FORCED$5 }, {
  trimEnd: trimEnd,
  trimRight: trimEnd
});

var $$j = _export;
var $trimStart = stringTrim.start;
var forcedStringTrimMethod = stringTrimForced;

var FORCED$4 = forcedStringTrimMethod('trimStart');

var trimStart = FORCED$4 ? function trimStart() {
  return $trimStart(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : ''.trimStart;

// `String.prototype.{ trimStart, trimLeft }` methods
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// https://tc39.es/ecma262/#String.prototype.trimleft
$$j({ target: 'String', proto: true, name: 'trimStart', forced: FORCED$4 }, {
  trimStart: trimStart,
  trimLeft: trimStart
});

var uncurryThis$a = functionUncurryThis;
var requireObjectCoercible = requireObjectCoercible$e;
var toString$1 = toString$m;

var quot = /"/g;
var replace$5 = uncurryThis$a(''.replace);

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
var createHtml = function (string, tag, attribute, value) {
  var S = toString$1(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + replace$5(toString$1(value), quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};

var fails$8 = fails$$;

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
var stringHtmlForced = function (METHOD_NAME) {
  return fails$8(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};

var $$i = _export;
var createHTML$c = createHtml;
var forcedStringHTMLMethod$c = stringHtmlForced;

// `String.prototype.anchor` method
// https://tc39.es/ecma262/#sec-string.prototype.anchor
$$i({ target: 'String', proto: true, forced: forcedStringHTMLMethod$c('anchor') }, {
  anchor: function anchor(name) {
    return createHTML$c(this, 'a', 'name', name);
  }
});

var $$h = _export;
var createHTML$b = createHtml;
var forcedStringHTMLMethod$b = stringHtmlForced;

// `String.prototype.big` method
// https://tc39.es/ecma262/#sec-string.prototype.big
$$h({ target: 'String', proto: true, forced: forcedStringHTMLMethod$b('big') }, {
  big: function big() {
    return createHTML$b(this, 'big', '', '');
  }
});

var $$g = _export;
var createHTML$a = createHtml;
var forcedStringHTMLMethod$a = stringHtmlForced;

// `String.prototype.blink` method
// https://tc39.es/ecma262/#sec-string.prototype.blink
$$g({ target: 'String', proto: true, forced: forcedStringHTMLMethod$a('blink') }, {
  blink: function blink() {
    return createHTML$a(this, 'blink', '', '');
  }
});

var $$f = _export;
var createHTML$9 = createHtml;
var forcedStringHTMLMethod$9 = stringHtmlForced;

// `String.prototype.bold` method
// https://tc39.es/ecma262/#sec-string.prototype.bold
$$f({ target: 'String', proto: true, forced: forcedStringHTMLMethod$9('bold') }, {
  bold: function bold() {
    return createHTML$9(this, 'b', '', '');
  }
});

var $$e = _export;
var createHTML$8 = createHtml;
var forcedStringHTMLMethod$8 = stringHtmlForced;

// `String.prototype.fixed` method
// https://tc39.es/ecma262/#sec-string.prototype.fixed
$$e({ target: 'String', proto: true, forced: forcedStringHTMLMethod$8('fixed') }, {
  fixed: function fixed() {
    return createHTML$8(this, 'tt', '', '');
  }
});

var $$d = _export;
var createHTML$7 = createHtml;
var forcedStringHTMLMethod$7 = stringHtmlForced;

// `String.prototype.fontcolor` method
// https://tc39.es/ecma262/#sec-string.prototype.fontcolor
$$d({ target: 'String', proto: true, forced: forcedStringHTMLMethod$7('fontcolor') }, {
  fontcolor: function fontcolor(color) {
    return createHTML$7(this, 'font', 'color', color);
  }
});

var $$c = _export;
var createHTML$6 = createHtml;
var forcedStringHTMLMethod$6 = stringHtmlForced;

// `String.prototype.fontsize` method
// https://tc39.es/ecma262/#sec-string.prototype.fontsize
$$c({ target: 'String', proto: true, forced: forcedStringHTMLMethod$6('fontsize') }, {
  fontsize: function fontsize(size) {
    return createHTML$6(this, 'font', 'size', size);
  }
});

var $$b = _export;
var createHTML$5 = createHtml;
var forcedStringHTMLMethod$5 = stringHtmlForced;

// `String.prototype.italics` method
// https://tc39.es/ecma262/#sec-string.prototype.italics
$$b({ target: 'String', proto: true, forced: forcedStringHTMLMethod$5('italics') }, {
  italics: function italics() {
    return createHTML$5(this, 'i', '', '');
  }
});

var $$a = _export;
var createHTML$4 = createHtml;
var forcedStringHTMLMethod$4 = stringHtmlForced;

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$$a({ target: 'String', proto: true, forced: forcedStringHTMLMethod$4('link') }, {
  link: function link(url) {
    return createHTML$4(this, 'a', 'href', url);
  }
});

var $$9 = _export;
var createHTML$3 = createHtml;
var forcedStringHTMLMethod$3 = stringHtmlForced;

// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$$9({ target: 'String', proto: true, forced: forcedStringHTMLMethod$3('small') }, {
  small: function small() {
    return createHTML$3(this, 'small', '', '');
  }
});

var $$8 = _export;
var createHTML$2 = createHtml;
var forcedStringHTMLMethod$2 = stringHtmlForced;

// `String.prototype.strike` method
// https://tc39.es/ecma262/#sec-string.prototype.strike
$$8({ target: 'String', proto: true, forced: forcedStringHTMLMethod$2('strike') }, {
  strike: function strike() {
    return createHTML$2(this, 'strike', '', '');
  }
});

var $$7 = _export;
var createHTML$1 = createHtml;
var forcedStringHTMLMethod$1 = stringHtmlForced;

// `String.prototype.sub` method
// https://tc39.es/ecma262/#sec-string.prototype.sub
$$7({ target: 'String', proto: true, forced: forcedStringHTMLMethod$1('sub') }, {
  sub: function sub() {
    return createHTML$1(this, 'sub', '', '');
  }
});

var $$6 = _export;
var createHTML = createHtml;
var forcedStringHTMLMethod = stringHtmlForced;

// `String.prototype.sup` method
// https://tc39.es/ecma262/#sec-string.prototype.sup
$$6({ target: 'String', proto: true, forced: forcedStringHTMLMethod('sup') }, {
  sup: function sup() {
    return createHTML(this, 'sup', '', '');
  }
});

var typedArrayConstructor = {exports: {}};

var NATIVE_ARRAY_BUFFER = arrayBufferNative;
var DESCRIPTORS$2 = descriptors$1;
var global$i = global$1o;
var isCallable$1 = isCallable$r;
var isObject$7 = isObject$z;
var hasOwn$4 = hasOwnProperty_1;
var classof$2 = classof$e;
var tryToString = tryToString$5;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$b;
var redefine$2 = redefine$h.exports;
var defineProperty = objectDefineProperty.f;
var isPrototypeOf$1 = objectIsPrototypeOf;
var getPrototypeOf$1 = objectGetPrototypeOf$1;
var setPrototypeOf$1 = objectSetPrototypeOf$1;
var wellKnownSymbol$4 = wellKnownSymbol$v;
var uid = uid$5;

var Int8Array$4 = global$i.Int8Array;
var Int8ArrayPrototype$1 = Int8Array$4 && Int8Array$4.prototype;
var Uint8ClampedArray$1 = global$i.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray$1 && Uint8ClampedArray$1.prototype;
var TypedArray$1 = Int8Array$4 && getPrototypeOf$1(Int8Array$4);
var TypedArrayPrototype$2 = Int8ArrayPrototype$1 && getPrototypeOf$1(Int8ArrayPrototype$1);
var ObjectPrototype = Object.prototype;
var TypeError$3 = global$i.TypeError;

var TO_STRING_TAG$1 = wellKnownSymbol$4('toStringTag');
var TYPED_ARRAY_TAG$1 = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR$2 = uid('TYPED_ARRAY_CONSTRUCTOR');
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS$2 = NATIVE_ARRAY_BUFFER && !!setPrototypeOf$1 && classof$2(global$i.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject$7(it)) return false;
  var klass = classof$2(it);
  return klass === 'DataView'
    || hasOwn$4(TypedArrayConstructorsList, klass)
    || hasOwn$4(BigIntArrayConstructorsList, klass);
};

var isTypedArray$2 = function (it) {
  if (!isObject$7(it)) return false;
  var klass = classof$2(it);
  return hasOwn$4(TypedArrayConstructorsList, klass)
    || hasOwn$4(BigIntArrayConstructorsList, klass);
};

var aTypedArray$m = function (it) {
  if (isTypedArray$2(it)) return it;
  throw TypeError$3('Target is not a typed array');
};

var aTypedArrayConstructor$4 = function (C) {
  if (isCallable$1(C) && (!setPrototypeOf$1 || isPrototypeOf$1(TypedArray$1, C))) return C;
  throw TypeError$3(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod$n = function (KEY, property, forced, options) {
  if (!DESCRIPTORS$2) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global$i[ARRAY];
    if (TypedArrayConstructor && hasOwn$4(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
      // old WebKit bug - some methods are non-configurable
      try {
        TypedArrayConstructor.prototype[KEY] = property;
      } catch (error2) { /* empty */ }
    }
  }
  if (!TypedArrayPrototype$2[KEY] || forced) {
    redefine$2(TypedArrayPrototype$2, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS$2 && Int8ArrayPrototype$1[KEY] || property, options);
  }
};

var exportTypedArrayStaticMethod$2 = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS$2) return;
  if (setPrototypeOf$1) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global$i[ARRAY];
      if (TypedArrayConstructor && hasOwn$4(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray$1[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return redefine$2(TypedArray$1, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS$2 && TypedArray$1[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global$i[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      redefine$2(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = global$i[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) createNonEnumerableProperty$3(Prototype, TYPED_ARRAY_CONSTRUCTOR$2, Constructor);
  else NATIVE_ARRAY_BUFFER_VIEWS$2 = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = global$i[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) createNonEnumerableProperty$3(Prototype, TYPED_ARRAY_CONSTRUCTOR$2, Constructor);
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS$2 || !isCallable$1(TypedArray$1) || TypedArray$1 === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray$1 = function TypedArray() {
    throw TypeError$3('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS$2) for (NAME in TypedArrayConstructorsList) {
    if (global$i[NAME]) setPrototypeOf$1(global$i[NAME], TypedArray$1);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS$2 || !TypedArrayPrototype$2 || TypedArrayPrototype$2 === ObjectPrototype) {
  TypedArrayPrototype$2 = TypedArray$1.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS$2) for (NAME in TypedArrayConstructorsList) {
    if (global$i[NAME]) setPrototypeOf$1(global$i[NAME].prototype, TypedArrayPrototype$2);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS$2 && getPrototypeOf$1(Uint8ClampedArrayPrototype) !== TypedArrayPrototype$2) {
  setPrototypeOf$1(Uint8ClampedArrayPrototype, TypedArrayPrototype$2);
}

if (DESCRIPTORS$2 && !hasOwn$4(TypedArrayPrototype$2, TO_STRING_TAG$1)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineProperty(TypedArrayPrototype$2, TO_STRING_TAG$1, { get: function () {
    return isObject$7(this) ? this[TYPED_ARRAY_TAG$1] : undefined;
  } });
  for (NAME in TypedArrayConstructorsList) if (global$i[NAME]) {
    createNonEnumerableProperty$3(global$i[NAME], TYPED_ARRAY_TAG$1, NAME);
  }
}

var arrayBufferViewCore = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS$2,
  TYPED_ARRAY_CONSTRUCTOR: TYPED_ARRAY_CONSTRUCTOR$2,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG$1,
  aTypedArray: aTypedArray$m,
  aTypedArrayConstructor: aTypedArrayConstructor$4,
  exportTypedArrayMethod: exportTypedArrayMethod$n,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod$2,
  isView: isView,
  isTypedArray: isTypedArray$2,
  TypedArray: TypedArray$1,
  TypedArrayPrototype: TypedArrayPrototype$2
};

/* eslint-disable no-new -- required for testing */

var global$h = global$1o;
var fails$7 = fails$$;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$4;
var NATIVE_ARRAY_BUFFER_VIEWS$1 = arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;

var ArrayBuffer$2 = global$h.ArrayBuffer;
var Int8Array$3 = global$h.Int8Array;

var typedArrayConstructorsRequireWrappers = !NATIVE_ARRAY_BUFFER_VIEWS$1 || !fails$7(function () {
  Int8Array$3(1);
}) || !fails$7(function () {
  new Int8Array$3(-1);
}) || !checkCorrectnessOfIteration(function (iterable) {
  new Int8Array$3();
  new Int8Array$3(null);
  new Int8Array$3(1.5);
  new Int8Array$3(iterable);
}, true) || fails$7(function () {
  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
  return new Int8Array$3(new ArrayBuffer$2(2), 1, undefined).length !== 1;
});

var global$g = global$1o;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$c;

var RangeError$4 = global$g.RangeError;

var toPositiveInteger$1 = function (it) {
  var result = toIntegerOrInfinity$1(it);
  if (result < 0) throw RangeError$4("The argument can't be less than 0");
  return result;
};

var global$f = global$1o;
var toPositiveInteger = toPositiveInteger$1;

var RangeError$3 = global$f.RangeError;

var toOffset$2 = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw RangeError$3('Wrong offset');
  return offset;
};

var bind$3 = functionBindContext;
var call$5 = functionCall;
var aConstructor = aConstructor$3;
var toObject$1 = toObject$o;
var lengthOfArrayLike$3 = lengthOfArrayLike$k;
var getIterator$1 = getIterator$4;
var getIteratorMethod$1 = getIteratorMethod$5;
var isArrayIteratorMethod = isArrayIteratorMethod$3;
var aTypedArrayConstructor$3 = arrayBufferViewCore.aTypedArrayConstructor;

var typedArrayFrom$2 = function from(source /* , mapfn, thisArg */) {
  var C = aConstructor(this);
  var O = toObject$1(source);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod$1(O);
  var i, length, result, step, iterator, next;
  if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
    iterator = getIterator$1(O, iteratorMethod);
    next = iterator.next;
    O = [];
    while (!(step = call$5(next, iterator)).done) {
      O.push(step.value);
    }
  }
  if (mapping && argumentsLength > 2) {
    mapfn = bind$3(mapfn, arguments[2]);
  }
  length = lengthOfArrayLike$3(O);
  result = new (aTypedArrayConstructor$3(C))(length);
  for (i = 0; length > i; i++) {
    result[i] = mapping ? mapfn(O[i], i) : O[i];
  }
  return result;
};

var $$5 = _export;
var global$e = global$1o;
var call$4 = functionCall;
var DESCRIPTORS$1 = descriptors$1;
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS$2 = typedArrayConstructorsRequireWrappers;
var ArrayBufferViewCore$o = arrayBufferViewCore;
var ArrayBufferModule = arrayBuffer;
var anInstance$3 = anInstance$8;
var createPropertyDescriptor$1 = createPropertyDescriptor$8;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$b;
var isIntegralNumber = isIntegralNumber$3;
var toLength$1 = toLength$c;
var toIndex = toIndex$2;
var toOffset$1 = toOffset$2;
var toPropertyKey = toPropertyKey$8;
var hasOwn$3 = hasOwnProperty_1;
var classof$1 = classof$e;
var isObject$6 = isObject$z;
var isSymbol$1 = isSymbol$6;
var create$1 = objectCreate;
var isPrototypeOf = objectIsPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf$1;
var getOwnPropertyNames = objectGetOwnPropertyNames.f;
var typedArrayFrom$1 = typedArrayFrom$2;
var forEach$2 = arrayIteration.forEach;
var setSpecies = setSpecies$6;
var definePropertyModule = objectDefineProperty;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var InternalStateModule$3 = internalState;
var inheritIfRequired = inheritIfRequired$4;

var getInternalState = InternalStateModule$3.get;
var setInternalState$3 = InternalStateModule$3.set;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var round$1 = Math.round;
var RangeError$2 = global$e.RangeError;
var ArrayBuffer$1 = ArrayBufferModule.ArrayBuffer;
var ArrayBufferPrototype = ArrayBuffer$1.prototype;
var DataView$1 = ArrayBufferModule.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore$o.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_CONSTRUCTOR$1 = ArrayBufferViewCore$o.TYPED_ARRAY_CONSTRUCTOR;
var TYPED_ARRAY_TAG = ArrayBufferViewCore$o.TYPED_ARRAY_TAG;
var TypedArray = ArrayBufferViewCore$o.TypedArray;
var TypedArrayPrototype$1 = ArrayBufferViewCore$o.TypedArrayPrototype;
var aTypedArrayConstructor$2 = ArrayBufferViewCore$o.aTypedArrayConstructor;
var isTypedArray$1 = ArrayBufferViewCore$o.isTypedArray;
var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var WRONG_LENGTH = 'Wrong length';

var fromList = function (C, list) {
  aTypedArrayConstructor$2(C);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var addGetter = function (it, key) {
  nativeDefineProperty(it, key, { get: function () {
    return getInternalState(this)[key];
  } });
};

var isArrayBuffer$1 = function (it) {
  var klass;
  return isPrototypeOf(ArrayBufferPrototype, it) || (klass = classof$1(it)) == 'ArrayBuffer' || klass == 'SharedArrayBuffer';
};

var isTypedArrayIndex = function (target, key) {
  return isTypedArray$1(target)
    && !isSymbol$1(key)
    && key in target
    && isIntegralNumber(+key)
    && key >= 0;
};

var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
  key = toPropertyKey(key);
  return isTypedArrayIndex(target, key)
    ? createPropertyDescriptor$1(2, target[key])
    : nativeGetOwnPropertyDescriptor(target, key);
};

var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
  key = toPropertyKey(key);
  if (isTypedArrayIndex(target, key)
    && isObject$6(descriptor)
    && hasOwn$3(descriptor, 'value')
    && !hasOwn$3(descriptor, 'get')
    && !hasOwn$3(descriptor, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable
    && (!hasOwn$3(descriptor, 'writable') || descriptor.writable)
    && (!hasOwn$3(descriptor, 'enumerable') || descriptor.enumerable)
  ) {
    target[key] = descriptor.value;
    return target;
  } return nativeDefineProperty(target, key, descriptor);
};

if (DESCRIPTORS$1) {
  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
    getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
    definePropertyModule.f = wrappedDefineProperty;
    addGetter(TypedArrayPrototype$1, 'buffer');
    addGetter(TypedArrayPrototype$1, 'byteOffset');
    addGetter(TypedArrayPrototype$1, 'byteLength');
    addGetter(TypedArrayPrototype$1, 'length');
  }

  $$5({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
    defineProperty: wrappedDefineProperty
  });

  typedArrayConstructor.exports = function (TYPE, wrapper, CLAMPED) {
    var BYTES = TYPE.match(/\d+$/)[0] / 8;
    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + TYPE;
    var SETTER = 'set' + TYPE;
    var NativeTypedArrayConstructor = global$e[CONSTRUCTOR_NAME];
    var TypedArrayConstructor = NativeTypedArrayConstructor;
    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
    var exported = {};

    var getter = function (that, index) {
      var data = getInternalState(that);
      return data.view[GETTER](index * BYTES + data.byteOffset, true);
    };

    var setter = function (that, index, value) {
      var data = getInternalState(that);
      if (CLAMPED) value = (value = round$1(value)) < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
      data.view[SETTER](index * BYTES + data.byteOffset, value, true);
    };

    var addElement = function (that, index) {
      nativeDefineProperty(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };

    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
        anInstance$3(that, TypedArrayConstructorPrototype);
        var index = 0;
        var byteOffset = 0;
        var buffer, byteLength, length;
        if (!isObject$6(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new ArrayBuffer$1(byteLength);
        } else if (isArrayBuffer$1(data)) {
          buffer = data;
          byteOffset = toOffset$1(offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError$2(WRONG_LENGTH);
            byteLength = $len - byteOffset;
            if (byteLength < 0) throw RangeError$2(WRONG_LENGTH);
          } else {
            byteLength = toLength$1($length) * BYTES;
            if (byteLength + byteOffset > $len) throw RangeError$2(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (isTypedArray$1(data)) {
          return fromList(TypedArrayConstructor, data);
        } else {
          return call$4(typedArrayFrom$1, TypedArrayConstructor, data);
        }
        setInternalState$3(that, {
          buffer: buffer,
          byteOffset: byteOffset,
          byteLength: byteLength,
          length: length,
          view: new DataView$1(buffer)
        });
        while (index < length) addElement(that, index++);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create$1(TypedArrayPrototype$1);
    } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS$2) {
      TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
        anInstance$3(dummy, TypedArrayConstructorPrototype);
        return inheritIfRequired(function () {
          if (!isObject$6(data)) return new NativeTypedArrayConstructor(toIndex(data));
          if (isArrayBuffer$1(data)) return $length !== undefined
            ? new NativeTypedArrayConstructor(data, toOffset$1(typedArrayOffset, BYTES), $length)
            : typedArrayOffset !== undefined
              ? new NativeTypedArrayConstructor(data, toOffset$1(typedArrayOffset, BYTES))
              : new NativeTypedArrayConstructor(data);
          if (isTypedArray$1(data)) return fromList(TypedArrayConstructor, data);
          return call$4(typedArrayFrom$1, TypedArrayConstructor, data);
        }(), dummy, TypedArrayConstructor);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      forEach$2(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
        if (!(key in TypedArrayConstructor)) {
          createNonEnumerableProperty$2(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
        }
      });
      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
    }

    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
      createNonEnumerableProperty$2(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
    }

    createNonEnumerableProperty$2(TypedArrayConstructorPrototype, TYPED_ARRAY_CONSTRUCTOR$1, TypedArrayConstructor);

    if (TYPED_ARRAY_TAG) {
      createNonEnumerableProperty$2(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
    }

    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;

    $$5({
      global: true, forced: TypedArrayConstructor != NativeTypedArrayConstructor, sham: !NATIVE_ARRAY_BUFFER_VIEWS
    }, exported);

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
      createNonEnumerableProperty$2(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
    }

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
      createNonEnumerableProperty$2(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
    }

    setSpecies(CONSTRUCTOR_NAME);
  };
} else typedArrayConstructor.exports = function () { /* empty */ };

var createTypedArrayConstructor$8 = typedArrayConstructor.exports;

// `Float32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor$8('Float32', function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

var createTypedArrayConstructor$7 = typedArrayConstructor.exports;

// `Float64Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor$7('Float64', function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

var createTypedArrayConstructor$6 = typedArrayConstructor.exports;

// `Int8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor$6('Int8', function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

var createTypedArrayConstructor$5 = typedArrayConstructor.exports;

// `Int16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor$5('Int16', function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

var createTypedArrayConstructor$4 = typedArrayConstructor.exports;

// `Int32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor$4('Int32', function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

var createTypedArrayConstructor$3 = typedArrayConstructor.exports;

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor$3('Uint8', function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

var createTypedArrayConstructor$2 = typedArrayConstructor.exports;

// `Uint8ClampedArray` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor$2('Uint8', function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);

var createTypedArrayConstructor$1 = typedArrayConstructor.exports;

// `Uint16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor$1('Uint16', function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

var createTypedArrayConstructor = typedArrayConstructor.exports;

// `Uint32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint32', function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

var uncurryThis$9 = functionUncurryThis;
var ArrayBufferViewCore$n = arrayBufferViewCore;
var $ArrayCopyWithin = arrayCopyWithin;

var u$ArrayCopyWithin = uncurryThis$9($ArrayCopyWithin);
var aTypedArray$l = ArrayBufferViewCore$n.aTypedArray;
var exportTypedArrayMethod$m = ArrayBufferViewCore$n.exportTypedArrayMethod;

// `%TypedArray%.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
exportTypedArrayMethod$m('copyWithin', function copyWithin(target, start /* , end */) {
  return u$ArrayCopyWithin(aTypedArray$l(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
});

var ArrayBufferViewCore$m = arrayBufferViewCore;
var $every = arrayIteration.every;

var aTypedArray$k = ArrayBufferViewCore$m.aTypedArray;
var exportTypedArrayMethod$l = ArrayBufferViewCore$m.exportTypedArrayMethod;

// `%TypedArray%.prototype.every` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
exportTypedArrayMethod$l('every', function every(callbackfn /* , thisArg */) {
  return $every(aTypedArray$k(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});

var ArrayBufferViewCore$l = arrayBufferViewCore;
var call$3 = functionCall;
var $fill = arrayFill$1;

var aTypedArray$j = ArrayBufferViewCore$l.aTypedArray;
var exportTypedArrayMethod$k = ArrayBufferViewCore$l.exportTypedArrayMethod;

// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
exportTypedArrayMethod$k('fill', function fill(value /* , start, end */) {
  var length = arguments.length;
  return call$3(
    $fill,
    aTypedArray$j(this),
    value,
    length > 1 ? arguments[1] : undefined,
    length > 2 ? arguments[2] : undefined
  );
});

var lengthOfArrayLike$2 = lengthOfArrayLike$k;

var arrayFromConstructorAndList$1 = function (Constructor, list) {
  var index = 0;
  var length = lengthOfArrayLike$2(list);
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var ArrayBufferViewCore$k = arrayBufferViewCore;
var speciesConstructor = speciesConstructor$5;

var TYPED_ARRAY_CONSTRUCTOR = ArrayBufferViewCore$k.TYPED_ARRAY_CONSTRUCTOR;
var aTypedArrayConstructor$1 = ArrayBufferViewCore$k.aTypedArrayConstructor;

// a part of `TypedArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#typedarray-species-create
var typedArraySpeciesConstructor$4 = function (originalArray) {
  return aTypedArrayConstructor$1(speciesConstructor(originalArray, originalArray[TYPED_ARRAY_CONSTRUCTOR]));
};

var arrayFromConstructorAndList = arrayFromConstructorAndList$1;
var typedArraySpeciesConstructor$3 = typedArraySpeciesConstructor$4;

var typedArrayFromSpeciesAndList = function (instance, list) {
  return arrayFromConstructorAndList(typedArraySpeciesConstructor$3(instance), list);
};

var ArrayBufferViewCore$j = arrayBufferViewCore;
var $filter = arrayIteration.filter;
var fromSpeciesAndList = typedArrayFromSpeciesAndList;

var aTypedArray$i = ArrayBufferViewCore$j.aTypedArray;
var exportTypedArrayMethod$j = ArrayBufferViewCore$j.exportTypedArrayMethod;

// `%TypedArray%.prototype.filter` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
exportTypedArrayMethod$j('filter', function filter(callbackfn /* , thisArg */) {
  var list = $filter(aTypedArray$i(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  return fromSpeciesAndList(this, list);
});

var ArrayBufferViewCore$i = arrayBufferViewCore;
var $find = arrayIteration.find;

var aTypedArray$h = ArrayBufferViewCore$i.aTypedArray;
var exportTypedArrayMethod$i = ArrayBufferViewCore$i.exportTypedArrayMethod;

// `%TypedArray%.prototype.find` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
exportTypedArrayMethod$i('find', function find(predicate /* , thisArg */) {
  return $find(aTypedArray$h(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});

var ArrayBufferViewCore$h = arrayBufferViewCore;
var $findIndex = arrayIteration.findIndex;

var aTypedArray$g = ArrayBufferViewCore$h.aTypedArray;
var exportTypedArrayMethod$h = ArrayBufferViewCore$h.exportTypedArrayMethod;

// `%TypedArray%.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
exportTypedArrayMethod$h('findIndex', function findIndex(predicate /* , thisArg */) {
  return $findIndex(aTypedArray$g(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});

var ArrayBufferViewCore$g = arrayBufferViewCore;
var $forEach$1 = arrayIteration.forEach;

var aTypedArray$f = ArrayBufferViewCore$g.aTypedArray;
var exportTypedArrayMethod$g = ArrayBufferViewCore$g.exportTypedArrayMethod;

// `%TypedArray%.prototype.forEach` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
exportTypedArrayMethod$g('forEach', function forEach(callbackfn /* , thisArg */) {
  $forEach$1(aTypedArray$f(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});

var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS$1 = typedArrayConstructorsRequireWrappers;
var exportTypedArrayStaticMethod$1 = arrayBufferViewCore.exportTypedArrayStaticMethod;
var typedArrayFrom = typedArrayFrom$2;

// `%TypedArray%.from` method
// https://tc39.es/ecma262/#sec-%typedarray%.from
exportTypedArrayStaticMethod$1('from', typedArrayFrom, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS$1);

var ArrayBufferViewCore$f = arrayBufferViewCore;
var $includes = arrayIncludes.includes;

var aTypedArray$e = ArrayBufferViewCore$f.aTypedArray;
var exportTypedArrayMethod$f = ArrayBufferViewCore$f.exportTypedArrayMethod;

// `%TypedArray%.prototype.includes` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
exportTypedArrayMethod$f('includes', function includes(searchElement /* , fromIndex */) {
  return $includes(aTypedArray$e(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});

var ArrayBufferViewCore$e = arrayBufferViewCore;
var $indexOf = arrayIncludes.indexOf;

var aTypedArray$d = ArrayBufferViewCore$e.aTypedArray;
var exportTypedArrayMethod$e = ArrayBufferViewCore$e.exportTypedArrayMethod;

// `%TypedArray%.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
exportTypedArrayMethod$e('indexOf', function indexOf(searchElement /* , fromIndex */) {
  return $indexOf(aTypedArray$d(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});

var global$d = global$1o;
var fails$6 = fails$$;
var uncurryThis$8 = functionUncurryThis;
var ArrayBufferViewCore$d = arrayBufferViewCore;
var ArrayIterators = es_array_iterator;
var wellKnownSymbol$3 = wellKnownSymbol$v;

var ITERATOR$3 = wellKnownSymbol$3('iterator');
var Uint8Array$2 = global$d.Uint8Array;
var arrayValues = uncurryThis$8(ArrayIterators.values);
var arrayKeys = uncurryThis$8(ArrayIterators.keys);
var arrayEntries = uncurryThis$8(ArrayIterators.entries);
var aTypedArray$c = ArrayBufferViewCore$d.aTypedArray;
var exportTypedArrayMethod$d = ArrayBufferViewCore$d.exportTypedArrayMethod;
var TypedArrayPrototype = Uint8Array$2 && Uint8Array$2.prototype;

var GENERIC = !fails$6(function () {
  TypedArrayPrototype[ITERATOR$3].call([1]);
});

var ITERATOR_IS_VALUES = !!TypedArrayPrototype
  && TypedArrayPrototype.values
  && TypedArrayPrototype[ITERATOR$3] === TypedArrayPrototype.values
  && TypedArrayPrototype.values.name === 'values';

var typedArrayValues = function values() {
  return arrayValues(aTypedArray$c(this));
};

// `%TypedArray%.prototype.entries` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
exportTypedArrayMethod$d('entries', function entries() {
  return arrayEntries(aTypedArray$c(this));
}, GENERIC);
// `%TypedArray%.prototype.keys` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
exportTypedArrayMethod$d('keys', function keys() {
  return arrayKeys(aTypedArray$c(this));
}, GENERIC);
// `%TypedArray%.prototype.values` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
exportTypedArrayMethod$d('values', typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });
// `%TypedArray%.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
exportTypedArrayMethod$d(ITERATOR$3, typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });

var ArrayBufferViewCore$c = arrayBufferViewCore;
var uncurryThis$7 = functionUncurryThis;

var aTypedArray$b = ArrayBufferViewCore$c.aTypedArray;
var exportTypedArrayMethod$c = ArrayBufferViewCore$c.exportTypedArrayMethod;
var $join = uncurryThis$7([].join);

// `%TypedArray%.prototype.join` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
exportTypedArrayMethod$c('join', function join(separator) {
  return $join(aTypedArray$b(this), separator);
});

/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var apply$2 = functionApply$1;
var toIndexedObject$1 = toIndexedObject$f;
var toIntegerOrInfinity = toIntegerOrInfinity$c;
var lengthOfArrayLike$1 = lengthOfArrayLike$k;
var arrayMethodIsStrict$1 = arrayMethodIsStrict$6;

var min$1 = Math.min;
var $lastIndexOf$1 = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf$1 && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD$1 = arrayMethodIsStrict$1('lastIndexOf');
var FORCED$3 = NEGATIVE_ZERO || !STRICT_METHOD$1;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
var arrayLastIndexOf = FORCED$3 ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return apply$2($lastIndexOf$1, this, arguments) || 0;
  var O = toIndexedObject$1(this);
  var length = lengthOfArrayLike$1(O);
  var index = length - 1;
  if (arguments.length > 1) index = min$1(index, toIntegerOrInfinity(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf$1;

var ArrayBufferViewCore$b = arrayBufferViewCore;
var apply$1 = functionApply$1;
var $lastIndexOf = arrayLastIndexOf;

var aTypedArray$a = ArrayBufferViewCore$b.aTypedArray;
var exportTypedArrayMethod$b = ArrayBufferViewCore$b.exportTypedArrayMethod;

// `%TypedArray%.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
exportTypedArrayMethod$b('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */) {
  var length = arguments.length;
  return apply$1($lastIndexOf, aTypedArray$a(this), length > 1 ? [searchElement, arguments[1]] : [searchElement]);
});

var ArrayBufferViewCore$a = arrayBufferViewCore;
var $map = arrayIteration.map;
var typedArraySpeciesConstructor$2 = typedArraySpeciesConstructor$4;

var aTypedArray$9 = ArrayBufferViewCore$a.aTypedArray;
var exportTypedArrayMethod$a = ArrayBufferViewCore$a.exportTypedArrayMethod;

// `%TypedArray%.prototype.map` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
exportTypedArrayMethod$a('map', function map(mapfn /* , thisArg */) {
  return $map(aTypedArray$9(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function (O, length) {
    return new (typedArraySpeciesConstructor$2(O))(length);
  });
});

var ArrayBufferViewCore$9 = arrayBufferViewCore;
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = typedArrayConstructorsRequireWrappers;

var aTypedArrayConstructor = ArrayBufferViewCore$9.aTypedArrayConstructor;
var exportTypedArrayStaticMethod = ArrayBufferViewCore$9.exportTypedArrayStaticMethod;

// `%TypedArray%.of` method
// https://tc39.es/ecma262/#sec-%typedarray%.of
exportTypedArrayStaticMethod('of', function of(/* ...items */) {
  var index = 0;
  var length = arguments.length;
  var result = new (aTypedArrayConstructor(this))(length);
  while (length > index) result[index] = arguments[index++];
  return result;
}, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);

var ArrayBufferViewCore$8 = arrayBufferViewCore;
var $reduce = arrayReduce.left;

var aTypedArray$8 = ArrayBufferViewCore$8.aTypedArray;
var exportTypedArrayMethod$9 = ArrayBufferViewCore$8.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduce` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
exportTypedArrayMethod$9('reduce', function reduce(callbackfn /* , initialValue */) {
  var length = arguments.length;
  return $reduce(aTypedArray$8(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});

var ArrayBufferViewCore$7 = arrayBufferViewCore;
var $reduceRight = arrayReduce.right;

var aTypedArray$7 = ArrayBufferViewCore$7.aTypedArray;
var exportTypedArrayMethod$8 = ArrayBufferViewCore$7.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduceRicht` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
exportTypedArrayMethod$8('reduceRight', function reduceRight(callbackfn /* , initialValue */) {
  var length = arguments.length;
  return $reduceRight(aTypedArray$7(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});

var ArrayBufferViewCore$6 = arrayBufferViewCore;

var aTypedArray$6 = ArrayBufferViewCore$6.aTypedArray;
var exportTypedArrayMethod$7 = ArrayBufferViewCore$6.exportTypedArrayMethod;
var floor$2 = Math.floor;

// `%TypedArray%.prototype.reverse` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
exportTypedArrayMethod$7('reverse', function reverse() {
  var that = this;
  var length = aTypedArray$6(that).length;
  var middle = floor$2(length / 2);
  var index = 0;
  var value;
  while (index < middle) {
    value = that[index];
    that[index++] = that[--length];
    that[length] = value;
  } return that;
});

var global$c = global$1o;
var call$2 = functionCall;
var ArrayBufferViewCore$5 = arrayBufferViewCore;
var lengthOfArrayLike = lengthOfArrayLike$k;
var toOffset = toOffset$2;
var toIndexedObject = toObject$o;
var fails$5 = fails$$;

var RangeError$1 = global$c.RangeError;
var Int8Array$2 = global$c.Int8Array;
var Int8ArrayPrototype = Int8Array$2 && Int8Array$2.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray$5 = ArrayBufferViewCore$5.aTypedArray;
var exportTypedArrayMethod$6 = ArrayBufferViewCore$5.exportTypedArrayMethod;

var WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS = !fails$5(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  var array = new Uint8ClampedArray(2);
  call$2($set, array, { length: 1, 0: 3 }, 1);
  return array[1] !== 3;
});

// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore$5.NATIVE_ARRAY_BUFFER_VIEWS && fails$5(function () {
  var array = new Int8Array$2(2);
  array.set(1);
  array.set('2', 1);
  return array[0] !== 0 || array[1] !== 2;
});

// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod$6('set', function set(arrayLike /* , offset */) {
  aTypedArray$5(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var src = toIndexedObject(arrayLike);
  if (WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS) return call$2($set, this, src, offset);
  var length = this.length;
  var len = lengthOfArrayLike(src);
  var index = 0;
  if (len + offset > length) throw RangeError$1('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, !WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);

var ArrayBufferViewCore$4 = arrayBufferViewCore;
var typedArraySpeciesConstructor$1 = typedArraySpeciesConstructor$4;
var fails$4 = fails$$;
var arraySlice$2 = arraySlice$a;

var aTypedArray$4 = ArrayBufferViewCore$4.aTypedArray;
var exportTypedArrayMethod$5 = ArrayBufferViewCore$4.exportTypedArrayMethod;

var FORCED$2 = fails$4(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  new Int8Array(1).slice();
});

// `%TypedArray%.prototype.slice` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
exportTypedArrayMethod$5('slice', function slice(start, end) {
  var list = arraySlice$2(aTypedArray$4(this), start, end);
  var C = typedArraySpeciesConstructor$1(this);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
}, FORCED$2);

var ArrayBufferViewCore$3 = arrayBufferViewCore;
var $some = arrayIteration.some;

var aTypedArray$3 = ArrayBufferViewCore$3.aTypedArray;
var exportTypedArrayMethod$4 = ArrayBufferViewCore$3.exportTypedArrayMethod;

// `%TypedArray%.prototype.some` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
exportTypedArrayMethod$4('some', function some(callbackfn /* , thisArg */) {
  return $some(aTypedArray$3(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});

var global$b = global$1o;
var uncurryThis$6 = functionUncurryThis;
var fails$3 = fails$$;
var aCallable = aCallable$d;
var internalSort = arraySort$1;
var ArrayBufferViewCore$2 = arrayBufferViewCore;
var FF = engineFfVersion;
var IE_OR_EDGE = engineIsIeOrEdge;
var V8 = engineV8Version;
var WEBKIT$1 = engineWebkitVersion;

var Array$1 = global$b.Array;
var aTypedArray$2 = ArrayBufferViewCore$2.aTypedArray;
var exportTypedArrayMethod$3 = ArrayBufferViewCore$2.exportTypedArrayMethod;
var Uint16Array = global$b.Uint16Array;
var un$Sort = Uint16Array && uncurryThis$6(Uint16Array.prototype.sort);

// WebKit
var ACCEPT_INCORRECT_ARGUMENTS = !!un$Sort && !(fails$3(function () {
  un$Sort(new Uint16Array(2), null);
}) && fails$3(function () {
  un$Sort(new Uint16Array(2), {});
}));

var STABLE_SORT = !!un$Sort && !fails$3(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 74;
  if (FF) return FF < 67;
  if (IE_OR_EDGE) return true;
  if (WEBKIT$1) return WEBKIT$1 < 602;

  var array = new Uint16Array(516);
  var expected = Array$1(516);
  var index, mod;

  for (index = 0; index < 516; index++) {
    mod = index % 4;
    array[index] = 515 - index;
    expected[index] = index - 2 * mod + 3;
  }

  un$Sort(array, function (a, b) {
    return (a / 4 | 0) - (b / 4 | 0);
  });

  for (index = 0; index < 516; index++) {
    if (array[index] !== expected[index]) return true;
  }
});

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (y !== y) return -1;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (x !== x) return 1;
    if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
    return x > y;
  };
};

// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
exportTypedArrayMethod$3('sort', function sort(comparefn) {
  if (comparefn !== undefined) aCallable(comparefn);
  if (STABLE_SORT) return un$Sort(this, comparefn);

  return internalSort(aTypedArray$2(this), getSortCompare(comparefn));
}, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);

var ArrayBufferViewCore$1 = arrayBufferViewCore;
var toLength = toLength$c;
var toAbsoluteIndex = toAbsoluteIndex$9;
var typedArraySpeciesConstructor = typedArraySpeciesConstructor$4;

var aTypedArray$1 = ArrayBufferViewCore$1.aTypedArray;
var exportTypedArrayMethod$2 = ArrayBufferViewCore$1.exportTypedArrayMethod;

// `%TypedArray%.prototype.subarray` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
exportTypedArrayMethod$2('subarray', function subarray(begin, end) {
  var O = aTypedArray$1(this);
  var length = O.length;
  var beginIndex = toAbsoluteIndex(begin, length);
  var C = typedArraySpeciesConstructor(O);
  return new C(
    O.buffer,
    O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT,
    toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex)
  );
});

var global$a = global$1o;
var apply = functionApply$1;
var ArrayBufferViewCore = arrayBufferViewCore;
var fails$2 = fails$$;
var arraySlice$1 = arraySlice$a;

var Int8Array$1 = global$a.Int8Array;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$1 = ArrayBufferViewCore.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString;

// iOS Safari 6.x fails here
var TO_LOCALE_STRING_BUG = !!Int8Array$1 && fails$2(function () {
  $toLocaleString.call(new Int8Array$1(1));
});

var FORCED$1 = fails$2(function () {
  return [1, 2].toLocaleString() != new Int8Array$1([1, 2]).toLocaleString();
}) || !fails$2(function () {
  Int8Array$1.prototype.toLocaleString.call([1, 2]);
});

// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
exportTypedArrayMethod$1('toLocaleString', function toLocaleString() {
  return apply(
    $toLocaleString,
    TO_LOCALE_STRING_BUG ? arraySlice$1(aTypedArray(this)) : aTypedArray(this),
    arraySlice$1(arguments)
  );
}, FORCED$1);

var exportTypedArrayMethod = arrayBufferViewCore.exportTypedArrayMethod;
var fails$1 = fails$$;
var global$9 = global$1o;
var uncurryThis$5 = functionUncurryThis;

var Uint8Array$1 = global$9.Uint8Array;
var Uint8ArrayPrototype = Uint8Array$1 && Uint8Array$1.prototype || {};
var arrayToString = [].toString;
var join$3 = uncurryThis$5([].join);

if (fails$1(function () { arrayToString.call({}); })) {
  arrayToString = function toString() {
    return join$3(this);
  };
}

var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString != arrayToString;

// `%TypedArray%.prototype.toString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
exportTypedArrayMethod('toString', arrayToString, IS_NOT_ARRAY_METHOD);

var uncurryThis$4 = functionUncurryThis;
var redefineAll$2 = redefineAll$6;
var getWeakData = internalMetadata.exports.getWeakData;
var anObject$1 = anObject$y;
var isObject$5 = isObject$z;
var anInstance$2 = anInstance$8;
var iterate = iterate$5;
var ArrayIterationModule = arrayIteration;
var hasOwn$2 = hasOwnProperty_1;
var InternalStateModule$2 = internalState;

var setInternalState$2 = InternalStateModule$2.set;
var internalStateGetterFor = InternalStateModule$2.getterFor;
var find$1 = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var splice$1 = uncurryThis$4([].splice);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (store) {
  return store.frozen || (store.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find$1(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) splice$1(this.entries, index, 1);
    return !!~index;
  }
};

var collectionWeak$2 = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance$2(that, Prototype);
      setInternalState$2(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject$1(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    redefineAll$2(Prototype, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject$5(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && hasOwn$2(data, state.id) && delete data[state.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject$5(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && hasOwn$2(data, state.id);
      }
    });

    redefineAll$2(Prototype, IS_MAP ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject$5(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return Constructor;
  }
};

var global$8 = global$1o;
var uncurryThis$3 = functionUncurryThis;
var redefineAll$1 = redefineAll$6;
var InternalMetadataModule = internalMetadata.exports;
var collection$1 = collection$4;
var collectionWeak$1 = collectionWeak$2;
var isObject$4 = isObject$z;
var isExtensible = objectIsExtensible;
var enforceInternalState = internalState.enforce;
var NATIVE_WEAK_MAP = nativeWeakMap;

var IS_IE11 = !global$8.ActiveXObject && 'ActiveXObject' in global$8;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $WeakMap = collection$1('WeakMap', wrapper, collectionWeak$1);

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalWeakMap = collectionWeak$1.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.enable();
  var WeakMapPrototype = $WeakMap.prototype;
  var nativeDelete = uncurryThis$3(WeakMapPrototype['delete']);
  var nativeHas = uncurryThis$3(WeakMapPrototype.has);
  var nativeGet = uncurryThis$3(WeakMapPrototype.get);
  var nativeSet = uncurryThis$3(WeakMapPrototype.set);
  redefineAll$1(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject$4(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete(this, key) || state.frozen['delete'](key);
      } return nativeDelete(this, key);
    },
    has: function has(key) {
      if (isObject$4(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) || state.frozen.has(key);
      } return nativeHas(this, key);
    },
    get: function get(key) {
      if (isObject$4(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) ? nativeGet(this, key) : state.frozen.get(key);
      } return nativeGet(this, key);
    },
    set: function set(key, value) {
      if (isObject$4(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas(this, key) ? nativeSet(this, key, value) : state.frozen.set(key, value);
      } else nativeSet(this, key, value);
      return this;
    }
  });
}

var collection = collection$4;
var collectionWeak = collectionWeak$2;

// `WeakSet` constructor
// https://tc39.es/ecma262/#sec-weakset-constructor
collection('WeakSet', function (init) {
  return function WeakSet() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionWeak);

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList$1 = documentCreateElement('span').classList;
var DOMTokenListPrototype$2 = classList$1 && classList$1.constructor && classList$1.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$2 === Object.prototype ? undefined : DOMTokenListPrototype$2;

var $forEach = arrayIteration.forEach;
var arrayMethodIsStrict = arrayMethodIsStrict$6;

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
var arrayForEach = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

var global$7 = global$1o;
var DOMIterables$1 = domIterables;
var DOMTokenListPrototype$1 = domTokenListPrototype;
var forEach$1 = arrayForEach;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$b;

var handlePrototype$1 = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach$1) try {
    createNonEnumerableProperty$1(CollectionPrototype, 'forEach', forEach$1);
  } catch (error) {
    CollectionPrototype.forEach = forEach$1;
  }
};

for (var COLLECTION_NAME$1 in DOMIterables$1) {
  if (DOMIterables$1[COLLECTION_NAME$1]) {
    handlePrototype$1(global$7[COLLECTION_NAME$1] && global$7[COLLECTION_NAME$1].prototype);
  }
}

handlePrototype$1(DOMTokenListPrototype$1);

var global$6 = global$1o;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty = createNonEnumerableProperty$b;
var wellKnownSymbol$2 = wellKnownSymbol$v;

var ITERATOR$2 = wellKnownSymbol$2('iterator');
var TO_STRING_TAG = wellKnownSymbol$2('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$2] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR$2, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$2] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$6[COLLECTION_NAME] && global$6[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

var $$4 = _export;
var global$5 = global$1o;
var task = task$2;

var FORCED = !global$5.setImmediate || !global$5.clearImmediate;

// http://w3c.github.io/setImmediate/
$$4({ global: true, bind: true, enumerable: true, forced: FORCED }, {
  // `setImmediate` method
  // http://w3c.github.io/setImmediate/#si-setImmediate
  setImmediate: task.set,
  // `clearImmediate` method
  // http://w3c.github.io/setImmediate/#si-clearImmediate
  clearImmediate: task.clear
});

var $$3 = _export;
var global$4 = global$1o;
var microtask = microtask$2;
var IS_NODE = engineIsNode;

var process$1 = global$4.process;

// `queueMicrotask` method
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-queuemicrotask
$$3({ global: true, enumerable: true, noTargetGet: true }, {
  queueMicrotask: function queueMicrotask(fn) {
    var domain = IS_NODE && process$1.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});

var fails = fails$$;
var wellKnownSymbol$1 = wellKnownSymbol$v;
var IS_PURE = isPure;

var ITERATOR$1 = wellKnownSymbol$1('iterator');

var nativeUrl = !fails(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR$1]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var global$3 = global$1o;
var uncurryThis$2 = functionUncurryThis;

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter$1 = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;

var RangeError = global$3.RangeError;
var exec$1 = uncurryThis$2(regexSeparators.exec);
var floor$1 = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt = uncurryThis$2(''.charCodeAt);
var join$2 = uncurryThis$2([].join);
var push$2 = uncurryThis$2([].push);
var replace$4 = uncurryThis$2(''.replace);
var split$2 = uncurryThis$2(''.split);
var toLowerCase$1 = uncurryThis$2(''.toLowerCase);

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode$1 = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = charCodeAt(string, counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt(string, counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        push$2(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push$2(output, value);
        counter--;
      }
    } else {
      push$2(output, value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor$1(delta / damp) : delta >> 1;
  delta += floor$1(delta / numPoints);
  while (delta > baseMinusTMin * tMax >> 1) {
    delta = floor$1(delta / baseMinusTMin);
    k += base;
  }
  return floor$1(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
var encode$2 = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode$1(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      push$2(output, fromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    push$2(output, delimiter$1);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor$1((maxInt - delta) / handledCPCountPlusOne)) {
      throw RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw RangeError(OVERFLOW_ERROR);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base;
        while (true) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          push$2(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor$1(qMinusT / baseMinusT);
          k += base;
        }

        push$2(output, fromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }
  return join$2(output, '');
};

var stringPunycodeToAscii = function (input) {
  var encoded = [];
  var labels = split$2(replace$4(toLowerCase$1(input), regexSeparators, '\u002E'), '.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push$2(encoded, exec$1(regexNonASCII, label) ? 'xn--' + encode$2(label) : label);
  }
  return join$2(encoded, '.');
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $$2 = _export;
var global$2 = global$1o;
var getBuiltIn = getBuiltIn$c;
var call$1 = functionCall;
var uncurryThis$1 = functionUncurryThis;
var USE_NATIVE_URL$1 = nativeUrl;
var redefine$1 = redefine$h.exports;
var redefineAll = redefineAll$6;
var setToStringTag$1 = setToStringTag$a;
var createIteratorConstructor = createIteratorConstructor$2;
var InternalStateModule$1 = internalState;
var anInstance$1 = anInstance$8;
var isCallable = isCallable$r;
var hasOwn$1 = hasOwnProperty_1;
var bind$2 = functionBindContext;
var classof = classof$e;
var anObject = anObject$y;
var isObject$3 = isObject$z;
var $toString$1 = toString$m;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$8;
var getIterator = getIterator$4;
var getIteratorMethod = getIteratorMethod$5;
var wellKnownSymbol = wellKnownSymbol$v;
var arraySort = arraySort$1;

var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalParamsState = InternalStateModule$1.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule$1.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var n$Fetch = getBuiltIn('fetch');
var N$Request = getBuiltIn('Request');
var Headers = getBuiltIn('Headers');
var RequestPrototype = N$Request && N$Request.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp$1 = global$2.RegExp;
var TypeError$2 = global$2.TypeError;
var decodeURIComponent$1 = global$2.decodeURIComponent;
var encodeURIComponent$1 = global$2.encodeURIComponent;
var charAt$1 = uncurryThis$1(''.charAt);
var join$1 = uncurryThis$1([].join);
var push$1 = uncurryThis$1([].push);
var replace$3 = uncurryThis$1(''.replace);
var shift$1 = uncurryThis$1([].shift);
var splice = uncurryThis$1([].splice);
var split$1 = uncurryThis$1(''.split);
var stringSlice$1 = uncurryThis$1(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp$1('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent$1(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace$3(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent$1(result);
  } catch (error) {
    while (bytes) {
      result = replace$3(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize$1 = function (it) {
  return replace$3(encodeURIComponent$1(it), find, replacer);
};

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw TypeError$2('Not enough arguments');
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState$1(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject$3(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt$1(init, 0) === '?' ? stringSlice$1(init, 1) : init : $toString$1(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call$1(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call$1(entryNext, entryIterator)).done ||
          (second = call$1(entryNext, entryIterator)).done ||
          !call$1(entryNext, entryIterator).done
        ) throw TypeError$2('Expected sequence with length 2');
        push$1(this.entries, { key: $toString$1(first.value), value: $toString$1(second.value) });
      }
    } else for (var key in object) if (hasOwn$1(object, key)) {
      push$1(this.entries, { key: key, value: $toString$1(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var attributes = split$1(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split$1(attribute, '=');
          push$1(this.entries, {
            key: deserialize(shift$1(entry)),
            value: deserialize(join$1(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push$1(result, serialize$1(entry.key) + '=' + serialize$1(entry.value));
    } return join$1(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance$1(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  setInternalState$1(this, new URLSearchParamsState(init));
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

redefineAll(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    push$1(state.entries, { key: $toString$1(name), value: $toString$1(value) });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = $toString$1(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) splice(entries, index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString$1(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString$1(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push$1(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString$1(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = $toString$1(name);
    var val = $toString$1(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push$1(entries, { key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind$2(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
redefine$1(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
redefine$1(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

setToStringTag$1(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$$2({ global: true, forced: !USE_NATIVE_URL$1 }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL$1 && isCallable(Headers)) {
  var headersHas = uncurryThis$1(HeadersPrototype.has);
  var headersSet = uncurryThis$1(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject$3(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, $toString$1(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(n$Fetch)) {
    $$2({ global: true, enumerable: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return n$Fetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(N$Request)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance$1(this, RequestPrototype);
      return new N$Request(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $$2({ global: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

var web_urlSearchParams = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $$1 = _export;
var DESCRIPTORS = descriptors$1;
var USE_NATIVE_URL = nativeUrl;
var global$1 = global$1o;
var bind$1 = functionBindContext;
var uncurryThis = functionUncurryThis;
var defineProperties = objectDefineProperties.f;
var redefine = redefine$h.exports;
var anInstance = anInstance$8;
var hasOwn = hasOwnProperty_1;
var assign$2 = objectAssign$1;
var arrayFrom = arrayFrom$1;
var arraySlice = arraySliceSimple;
var codeAt = stringMultibyte.codeAt;
var toASCII = stringPunycodeToAscii;
var $toString = toString$m;
var setToStringTag = setToStringTag$a;
var URLSearchParamsModule = web_urlSearchParams;
var InternalStateModule = internalState;

var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var URLSearchParams$2 = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;

var NativeURL = global$1.URL;
var TypeError$1 = global$1.TypeError;
var parseInt$1 = global$1.parseInt;
var floor = Math.floor;
var pow = Math.pow;
var charAt = uncurryThis(''.charAt);
var exec = uncurryThis(/./.exec);
var join = uncurryThis([].join);
var numberToString = uncurryThis(1.0.toString);
var pop = uncurryThis([].pop);
var push = uncurryThis([].push);
var replace$2 = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);
var toLowerCase = uncurryThis(''.toLowerCase);
var unshift = uncurryThis([].unshift);

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA$1 = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT$1 = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+|[\u0000-\u0020]+$/g;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */
var EOF;

// https://url.spec.whatwg.org/#ipv4-number-parser
var parseIPv4 = function (input) {
  var parts = split(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.length--;
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && charAt(part, 0) == '0') {
      radix = exec(HEX_START, part) ? 16 : 8;
      part = stringSlice(part, radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!exec(radix == 10 ? DEC : radix == 8 ? OCT : HEX, part)) return input;
      number = parseInt$1(part, radix);
    }
    push(numbers, number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = pop(numbers);
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return charAt(input, pointer);
  };

  if (chr() == ':') {
    if (charAt(input, 1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex == 8) return;
    if (chr() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && exec(HEX, chr())) {
      value = value * 16 + parseInt$1(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!exec(DIGIT$1, chr())) return;
        while (exec(DIGIT$1, chr())) {
          number = parseInt$1(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (chr() == ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

// https://url.spec.whatwg.org/#host-serializing
var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      unshift(result, host % 256);
      host = floor(host / 256);
    } return join(result, '.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString(host[index], 16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign$2({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign$2({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign$2({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwn(set, chr) ? chr : encodeURIComponent(chr);
};

// https://url.spec.whatwg.org/#special-scheme
var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

// https://url.spec.whatwg.org/#windows-drive-letter
var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && exec(ALPHA$1, charAt(string, 0))
    && ((second = charAt(string, 1)) == ':' || (!normalized && second == '|'));
};

// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice(string, 0, 2)) && (
    string.length == 2 ||
    ((third = charAt(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

// https://url.spec.whatwg.org/#single-dot-path-segment
var isSingleDot = function (segment) {
  return segment === '.' || toLowerCase(segment) === '%2e';
};

// https://url.spec.whatwg.org/#double-dot-path-segment
var isDoubleDot = function (segment) {
  segment = toLowerCase(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

var URLState = function (url, isBase, base) {
  var urlString = $toString(url);
  var baseState, failure, searchParams;
  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw TypeError$1(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw TypeError$1(failure);
    searchParams = getInternalSearchParamsState(new URLSearchParams$2());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function (input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;

    input = $toString(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace$2(input, LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
    }

    input = replace$2(input, TAB_AND_NEW_LINE, '');

    codePoints = arrayFrom(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];
      switch (state) {
        case SCHEME_START:
          if (chr && exec(ALPHA$1, chr)) {
            buffer += toLowerCase(chr);
            state = SCHEME;
          } else if (!stateOverride) {
            state = NO_SCHEME;
            continue;
          } else return INVALID_SCHEME;
          break;

        case SCHEME:
          if (chr && (exec(ALPHANUMERIC, chr) || chr == '+' || chr == '-' || chr == '.')) {
            buffer += toLowerCase(chr);
          } else if (chr == ':') {
            if (stateOverride && (
              (url.isSpecial() != hasOwn(specialSchemes, buffer)) ||
              (buffer == 'file' && (url.includesCredentials() || url.port !== null)) ||
              (url.scheme == 'file' && !url.host)
            )) return;
            url.scheme = buffer;
            if (stateOverride) {
              if (url.isSpecial() && specialSchemes[url.scheme] == url.port) url.port = null;
              return;
            }
            buffer = '';
            if (url.scheme == 'file') {
              state = FILE;
            } else if (url.isSpecial() && base && base.scheme == url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES;
            } else if (codePoints[pointer + 1] == '/') {
              state = PATH_OR_AUTHORITY;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME;
          break;

        case NO_SCHEME:
          if (!base || (base.cannotBeABaseURL && chr != '#')) return INVALID_SCHEME;
          if (base.cannotBeABaseURL && chr == '#') {
            url.scheme = base.scheme;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT;
            break;
          }
          state = base.scheme == 'file' ? FILE : RELATIVE;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY:
          if (chr == '/' && codePoints[pointer + 1] == '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            pointer++;
          } else {
            state = RELATIVE;
            continue;
          } break;

        case PATH_OR_AUTHORITY:
          if (chr == '/') {
            state = AUTHORITY;
            break;
          } else {
            state = PATH;
            continue;
          }

        case RELATIVE:
          url.scheme = base.scheme;
          if (chr == EOF) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
          } else if (chr == '/' || (chr == '\\' && url.isSpecial())) {
            state = RELATIVE_SLASH;
          } else if (chr == '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.path.length--;
            state = PATH;
            continue;
          } break;

        case RELATIVE_SLASH:
          if (url.isSpecial() && (chr == '/' || chr == '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          } else if (chr == '/') {
            state = AUTHORITY;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH;
            continue;
          } break;

        case SPECIAL_AUTHORITY_SLASHES:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          if (chr != '/' || charAt(buffer, pointer + 1) != '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
          if (chr != '/' && chr != '\\') {
            state = AUTHORITY;
            continue;
          } break;

        case AUTHORITY:
          if (chr == '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom(buffer);
            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];
              if (codePoint == ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }
              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
              if (seenPasswordToken) url.password += encodedCodePoints;
              else url.username += encodedCodePoints;
            }
            buffer = '';
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial())
          ) {
            if (seenAt && buffer == '') return INVALID_AUTHORITY;
            pointer -= arrayFrom(buffer).length + 1;
            buffer = '';
            state = HOST;
          } else buffer += chr;
          break;

        case HOST:
        case HOSTNAME:
          if (stateOverride && url.scheme == 'file') {
            state = FILE_HOST;
            continue;
          } else if (chr == ':' && !seenBracket) {
            if (buffer == '') return INVALID_HOST;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT;
            if (stateOverride == HOSTNAME) return;
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial())
          ) {
            if (url.isSpecial() && buffer == '') return INVALID_HOST;
            if (stateOverride && buffer == '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START;
            if (stateOverride) return;
            continue;
          } else {
            if (chr == '[') seenBracket = true;
            else if (chr == ']') seenBracket = false;
            buffer += chr;
          } break;

        case PORT:
          if (exec(DIGIT$1, chr)) {
            buffer += chr;
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial()) ||
            stateOverride
          ) {
            if (buffer != '') {
              var port = parseInt$1(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT;
              url.port = (url.isSpecial() && port === specialSchemes[url.scheme]) ? null : port;
              buffer = '';
            }
            if (stateOverride) return;
            state = PATH_START;
            continue;
          } else return INVALID_PORT;
          break;

        case FILE:
          url.scheme = 'file';
          if (chr == '/' || chr == '\\') state = FILE_SLASH;
          else if (base && base.scheme == 'file') {
            if (chr == EOF) {
              url.host = base.host;
              url.path = arraySlice(base.path);
              url.query = base.query;
            } else if (chr == '?') {
              url.host = base.host;
              url.path = arraySlice(base.path);
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.host = base.host;
              url.path = arraySlice(base.path);
              url.query = base.query;
              url.fragment = '';
              state = FRAGMENT;
            } else {
              if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.shortenPath();
              }
              state = PATH;
              continue;
            }
          } else {
            state = PATH;
            continue;
          } break;

        case FILE_SLASH:
          if (chr == '/' || chr == '\\') {
            state = FILE_HOST;
            break;
          }
          if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
            if (isWindowsDriveLetter(base.path[0], true)) push(url.path, base.path[0]);
            else url.host = base.host;
          }
          state = PATH;
          continue;

        case FILE_HOST:
          if (chr == EOF || chr == '/' || chr == '\\' || chr == '?' || chr == '#') {
            if (!stateOverride && isWindowsDriveLetter(buffer)) {
              state = PATH;
            } else if (buffer == '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host == 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START;
            } continue;
          } else buffer += chr;
          break;

        case PATH_START:
          if (url.isSpecial()) {
            state = PATH;
            if (chr != '/' && chr != '\\') continue;
          } else if (!stateOverride && chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            state = PATH;
            if (chr != '/') continue;
          } break;

        case PATH:
          if (
            chr == EOF || chr == '/' ||
            (chr == '\\' && url.isSpecial()) ||
            (!stateOverride && (chr == '?' || chr == '#'))
          ) {
            if (isDoubleDot(buffer)) {
              url.shortenPath();
              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else if (isSingleDot(buffer)) {
              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else {
              if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                if (url.host) url.host = '';
                buffer = charAt(buffer, 0) + ':'; // normalize windows drive letter
              }
              push(url.path, buffer);
            }
            buffer = '';
            if (url.scheme == 'file' && (chr == EOF || chr == '?' || chr == '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift(url.path);
              }
            }
            if (chr == '?') {
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.fragment = '';
              state = FRAGMENT;
            }
          } else {
            buffer += percentEncode(chr, pathPercentEncodeSet);
          } break;

        case CANNOT_BE_A_BASE_URL_PATH:
          if (chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case QUERY:
          if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            if (chr == "'" && url.isSpecial()) url.query += '%27';
            else if (chr == '#') url.query += '%23';
            else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case FRAGMENT:
          if (chr != EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function (input) {
    var result, codePoints, index;
    if (charAt(input, 0) == '[') {
      if (charAt(input, input.length - 1) != ']') return INVALID_HOST;
      result = parseIPv6(stringSlice(input, 1, -1));
      if (!result) return INVALID_HOST;
      this.host = result;
    // opaque host
    } else if (!this.isSpecial()) {
      if (exec(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
      result = '';
      codePoints = arrayFrom(input);
      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
      }
      this.host = result;
    } else {
      input = toASCII(input);
      if (exec(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
      result = parseIPv4(input);
      if (result === null) return INVALID_HOST;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function () {
    return !this.host || this.cannotBeABaseURL || this.scheme == 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function () {
    return this.username != '' || this.password != '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function () {
    return hasOwn(specialSchemes, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function () {
    var path = this.path;
    var pathSize = path.length;
    if (pathSize && (this.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function () {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';
    if (host !== null) {
      output += '//';
      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }
      output += serializeHost(host);
      if (port !== null) output += ':' + port;
    } else if (scheme == 'file') output += '//';
    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function (href) {
    var failure = this.parse(href);
    if (failure) throw TypeError$1(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function () {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme == 'blob') try {
      return new URLConstructor(scheme.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme == 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function () {
    return this.scheme + ':';
  },
  setProtocol: function (protocol) {
    this.parse($toString(protocol) + ':', SCHEME_START);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function () {
    return this.username;
  },
  setUsername: function (username) {
    var codePoints = arrayFrom($toString(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function () {
    return this.password;
  },
  setPassword: function (password) {
    var codePoints = arrayFrom($toString(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function () {
    var host = this.host;
    var port = this.port;
    return host === null ? ''
      : port === null ? serializeHost(host)
      : serializeHost(host) + ':' + port;
  },
  setHost: function (host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function () {
    var host = this.host;
    return host === null ? '' : serializeHost(host);
  },
  setHostname: function (hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function () {
    var port = this.port;
    return port === null ? '' : $toString(port);
  },
  setPort: function (port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = $toString(port);
    if (port == '') this.port = null;
    else this.parse(port, PORT);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function () {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
  },
  setPathname: function (pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function () {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function (search) {
    search = $toString(search);
    if (search == '') {
      this.query = null;
    } else {
      if ('?' == charAt(search, 0)) search = stringSlice(search, 1);
      this.query = '';
      this.parse(search, QUERY);
    }
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function () {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function () {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function (hash) {
    hash = $toString(hash);
    if (hash == '') {
      this.fragment = null;
      return;
    }
    if ('#' == charAt(hash, 0)) hash = stringSlice(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT);
  },
  update: function () {
    this.query = this.searchParams.serialize() || null;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLPrototype);
  var base = arguments.length > 1 ? arguments[1] : undefined;
  var state = setInternalState(that, new URLState(url, false, base));
  if (!DESCRIPTORS) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype = URLConstructor.prototype;

var accessorDescriptor = function (getter, setter) {
  return {
    get: function () {
      return getInternalURLState(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (DESCRIPTORS) {
  defineProperties(URLPrototype, {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    href: accessorDescriptor('serialize', 'setHref'),
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    origin: accessorDescriptor('getOrigin'),
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    protocol: accessorDescriptor('getProtocol', 'setProtocol'),
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    username: accessorDescriptor('getUsername', 'setUsername'),
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    password: accessorDescriptor('getPassword', 'setPassword'),
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    host: accessorDescriptor('getHost', 'setHost'),
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    hostname: accessorDescriptor('getHostname', 'setHostname'),
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    port: accessorDescriptor('getPort', 'setPort'),
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    pathname: accessorDescriptor('getPathname', 'setPathname'),
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    search: accessorDescriptor('getSearch', 'setSearch'),
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    searchParams: accessorDescriptor('getSearchParams'),
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    hash: accessorDescriptor('getHash', 'setHash')
  });
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
redefine(URLPrototype, 'toJSON', function toJSON() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
redefine(URLPrototype, 'toString', function toString() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  if (nativeCreateObjectURL) redefine(URLConstructor, 'createObjectURL', bind$1(nativeCreateObjectURL, NativeURL));
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  if (nativeRevokeObjectURL) redefine(URLConstructor, 'revokeObjectURL', bind$1(nativeRevokeObjectURL, NativeURL));
}

setToStringTag(URLConstructor, 'URL');

$$1({ global: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});

var $ = _export;
var call = functionCall;

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$({ target: 'URL', proto: true, enumerable: true }, {
  toJSON: function toJSON() {
    return call(URL.prototype.toString, this);
  }
});

var runtime = {exports: {}};

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (module) {
var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
  defineProperty(
    GeneratorFunctionPrototype,
    "constructor",
    { value: GeneratorFunction, configurable: true }
  );
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    defineProperty(this, "_invoke", { value: enqueue });
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method;
    var method = delegate.iterator[methodName];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method, or a missing .next mehtod, always terminate the
      // yield* loop.
      context.delegate = null;

      // Note: ["return"] must be used for ES3 parsing compatibility.
      if (methodName === "throw" && delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined$1;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }
      if (methodName !== "return") {
        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a '" + methodName + "' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(val) {
    var object = Object(val);
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
}(runtime));

function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) {
      _defineProperty$5(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof$3(obj) {
  "@babel/helpers - typeof";

  return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$3(obj);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _defineProperty$5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties$3(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$3(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _slicedToArray$2(arr, i) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$3(arr, i) || _nonIterableRest$2();
}
function _toConsumableArray$3(arr) {
  return _arrayWithoutHoles$3(arr) || _iterableToArray$3(arr) || _unsupportedIterableToArray$3(arr) || _nonIterableSpread$3();
}
function _arrayWithoutHoles$3(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$3(arr);
}
function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray$3(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit$2(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _unsupportedIterableToArray$3(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen);
}
function _arrayLikeToArray$3(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread$3() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "development" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    {
      var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

      if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
        // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
    }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (!/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear){/.test(rule)) {
          console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };

  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign$1 = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash$2 (value, length) {
	return (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3)
}

/**
 * @param {string} value
 * @return {string}
 */
function trim$1 (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace$1 (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return assign$1(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? charat(characters, --position) : 0;

	if (column--, character === 10)
		column = 1, line--;

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < length ? charat(characters, position++) : 0;

	if (column++, character === 10)
		column = 1, line++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim$1(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next();

	return slice(index, position)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse$2('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse$2 (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && characters.charCodeAt(length - 1) == 58) {
					if (indexof(characters += replace$1(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous);
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7);
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append(comment(commenter(next(), caret()), root, parent), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset:
						if (property > 0 && (strlen(characters) - length))
							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace$1(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

						if (character === 123)
							if (offset === 0)
								parse$2(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule) {
									// d m s
									case 100: case 109: case 115:
										parse$2(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse$2(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim$1(j > 0 ? rule[x] + ' ' + y : replace$1(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length)
}

/**
 * @param {string} value
 * @param {number} length
 * @return {string}
 */
function prefix (value, length) {
	switch (hash$2(value, length)) {
		// color-adjust
		case 5103:
			return WEBKIT + 'print-' + value + value
		// animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
		case 5737: case 4201: case 3177: case 3433: case 1641: case 4457: case 2921:
		// text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
		case 5572: case 6356: case 5844: case 3191: case 6645: case 3005:
		// mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
		case 6391: case 5879: case 5623: case 6135: case 4599: case 4855:
		// background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
		case 4215: case 6389: case 5109: case 5365: case 5621: case 3829:
			return WEBKIT + value + value
		// appearance, user-select, transform, hyphens, text-size-adjust
		case 5349: case 4246: case 4810: case 6968: case 2756:
			return WEBKIT + value + MOZ + value + MS + value + value
		// flex, flex-direction
		case 6828: case 4268:
			return WEBKIT + value + MS + value + value
		// order
		case 6165:
			return WEBKIT + value + MS + 'flex-' + value + value
		// align-items
		case 5187:
			return WEBKIT + value + replace$1(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value
		// align-self
		case 5443:
			return WEBKIT + value + MS + 'flex-item-' + replace$1(value, /flex-|-self/, '') + value
		// align-content
		case 4675:
			return WEBKIT + value + MS + 'flex-line-pack' + replace$1(value, /align-content|flex-|-self/, '') + value
		// flex-shrink
		case 5548:
			return WEBKIT + value + MS + replace$1(value, 'shrink', 'negative') + value
		// flex-basis
		case 5292:
			return WEBKIT + value + MS + replace$1(value, 'basis', 'preferred-size') + value
		// flex-grow
		case 6060:
			return WEBKIT + 'box-' + replace$1(value, '-grow', '') + WEBKIT + value + MS + replace$1(value, 'grow', 'positive') + value
		// transition
		case 4554:
			return WEBKIT + replace$1(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value
		// cursor
		case 6187:
			return replace$1(replace$1(replace$1(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value
		// background, background-image
		case 5495: case 3959:
			return replace$1(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1')
		// justify-content
		case 4968:
			return replace$1(replace$1(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value
		// (margin|padding)-inline-(start|end)
		case 4095: case 3583: case 4068: case 2532:
			return replace$1(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value
		// (min|max)?(width|height|inline-size|block-size)
		case 8116: case 7059: case 5753: case 5535:
		case 5445: case 5701: case 4933: case 4677:
		case 5533: case 5789: case 5021: case 4765:
			// stretch, max-content, min-content, fill-available
			if (strlen(value) - 1 - length > 6)
				switch (charat(value, length + 1)) {
					// (m)ax-content, (m)in-content
					case 109:
						// -
						if (charat(value, length + 4) !== 45)
							break
					// (f)ill-available, (f)it-content
					case 102:
						return replace$1(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value
					// (s)tretch
					case 115:
						return ~indexof(value, 'stretch') ? prefix(replace$1(value, 'stretch', 'fill-available'), length) + value : value
				}
			break
		// position: sticky
		case 4949:
			// (s)ticky?
			if (charat(value, length + 1) !== 115)
				break
		// display: (flex|inline-flex)
		case 6444:
			switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
				// stic(k)y
				case 107:
					return replace$1(value, ':', ':' + WEBKIT) + value
				// (inline-)?fl(e)x
				case 101:
					return replace$1(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value
			}
			break
		// writing-mode
		case 5936:
			switch (charat(value, length + 11)) {
				// vertical-l(r)
				case 114:
					return WEBKIT + value + MS + replace$1(value, /[svh]\w+-[tblr]{2}/, 'tb') + value
				// vertical-r(l)
				case 108:
					return WEBKIT + value + MS + replace$1(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value
				// horizontal(-)tb
				case 45:
					return WEBKIT + value + MS + replace$1(value, /[svh]\w+-[tblr]{2}/, 'lr') + value
			}

			return WEBKIT + value + MS + value + value
	}

	return value
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = '';
	var length = sizeof(children);

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case RULESET: element.value = element.props.join(',');
	}

	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length);
					break
				case KEYFRAMES:
					return serialize([copy(element, {value: replace$1(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace$1(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace$1(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace$1(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace$1(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

var last = function last(arr) {
  return arr.length ? arr[arr.length - 1] : null;
}; // based on https://github.com/thysultan/stylis.js/blob/e6843c373ebcbbfade25ebcc23f540ed8508da0a/src/Tokenizer.js#L239-L244


var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return !!element && element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule') return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses && cache.compat !== true) {
      var prevElement = index > 0 ? children[index - 1] : null;

      if (prevElement && isIgnoringComment(last(prevElement.children))) {
        return;
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (!key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }

  if ( key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }

    }), incorrectImportAlarm);
  }

  {
    var currentSheet;
    var finalizingPlugins = [stringify, function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== COMMENT) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } ];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (serialized.map !== undefined) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

var reactIs$2 = {exports: {}};

var reactIs_development$1 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



{
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development$1.AsyncMode = AsyncMode;
reactIs_development$1.ConcurrentMode = ConcurrentMode;
reactIs_development$1.ContextConsumer = ContextConsumer;
reactIs_development$1.ContextProvider = ContextProvider;
reactIs_development$1.Element = Element;
reactIs_development$1.ForwardRef = ForwardRef;
reactIs_development$1.Fragment = Fragment;
reactIs_development$1.Lazy = Lazy;
reactIs_development$1.Memo = Memo;
reactIs_development$1.Portal = Portal;
reactIs_development$1.Profiler = Profiler;
reactIs_development$1.StrictMode = StrictMode;
reactIs_development$1.Suspense = Suspense;
reactIs_development$1.isAsyncMode = isAsyncMode;
reactIs_development$1.isConcurrentMode = isConcurrentMode;
reactIs_development$1.isContextConsumer = isContextConsumer;
reactIs_development$1.isContextProvider = isContextProvider;
reactIs_development$1.isElement = isElement;
reactIs_development$1.isForwardRef = isForwardRef;
reactIs_development$1.isFragment = isFragment;
reactIs_development$1.isLazy = isLazy;
reactIs_development$1.isMemo = isMemo;
reactIs_development$1.isPortal = isPortal;
reactIs_development$1.isProfiler = isProfiler;
reactIs_development$1.isStrictMode = isStrictMode;
reactIs_development$1.isSuspense = isSuspense;
reactIs_development$1.isValidElementType = isValidElementType;
reactIs_development$1.typeOf = typeOf;
  })();
}

{
  reactIs$2.exports = reactIs_development$1;
}

var reactIs$1 = reactIs$2.exports;
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs$1.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$1.Memo] = MEMO_STATICS;

var isBrowser$1 = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$1 === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

{
  var contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "development" !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (_key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

{
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }
};

var hasOwnProperty$2 = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);

{
  EmotionCacheContext.displayName = 'EmotionCacheContext';
}

EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/forwardRef(function (props, ref) {
    // the cache will never be null in the browser
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

var ThemeContext = /* #__PURE__ */createContext({});

{
  ThemeContext.displayName = 'EmotionThemeContext';
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var useInsertionEffect$2 = React['useInsertion' + 'Effect'] ? React['useInsertion' + 'Effect'] : function useInsertionEffect(create) {
  create();
};
function useInsertionEffectMaybe$1(create) {

  useInsertionEffect$2(create);
}

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (typeof props.css === 'string' && // check if there is a css declaration
  props.css.indexOf(':') !== -1) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + props.css + "`");
  }

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty$2.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (!!props.css && (typeof props.css !== 'object' || typeof props.css.name !== 'string' || props.css.name.indexOf('-') === -1)) {
    var label = getLabelFromStackTrace(new Error().stack);
    if (label) newProps[labelPropName] = label;
  }

  return newProps;
};

var Insertion$2 = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  useInsertionEffectMaybe$1(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles, undefined, useContext(ThemeContext));

  if (serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty$2.call(props, key) && key !== 'css' && key !== typePropName && (key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/createElement$3(Fragment, null, /*#__PURE__*/createElement$3(Insertion$2, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/createElement$3(WrappedComponent, newProps));
});

{
  Emotion.displayName = 'EmotionCssPropInternal';
}

var pkg = {
	name: "@emotion/react",
	version: "11.8.2",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.js",
		"macro.d.ts",
		"macro.js.flow"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.13.10",
		"@emotion/babel-plugin": "^11.7.1",
		"@emotion/cache": "^11.7.1",
		"@emotion/serialize": "^1.0.2",
		"@emotion/utils": "^1.1.0",
		"@emotion/weak-memoize": "^0.2.5",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		"@babel/core": "^7.0.0",
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@babel/core": {
			optional: true
		},
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@babel/core": "^7.13.10",
		"@emotion/css": "11.7.1",
		"@emotion/css-prettifier": "1.0.1",
		"@emotion/server": "11.4.0",
		"@emotion/styled": "11.8.1",
		"@types/react": "^16.9.11",
		dtslint: "^4.2.1",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact"
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !hasOwnProperty$2.call(props, 'css')) {
    // $FlowFixMe
    return createElement$3.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return createElement$3.apply(null, createElementArgArray);
};

var useInsertionEffect$1 = React['useInsertion' + 'Effect'] ? React['useInsertion' + 'Effect'] : useLayoutEffect;
var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {
  if (!warnedAboutCssPropForGlobal && ( // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  props.className || props.css)) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }

  var styles = props.styles;
  var serialized = serializeStyles([styles], undefined, useContext(ThemeContext));
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = useRef();
  useInsertionEffect$1(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  useInsertionEffect$1(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      insertStyles(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

{
  Global.displayName = 'EmotionGlobal';
}

function css$3() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

var keyframes = function keyframes() {
  var insertable = css$3.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames$1 = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (arg.styles !== undefined && arg.name !== undefined) {
              console.error('You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n' + '`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.');
            }

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge$1(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion$1 = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  useInsertionEffectMaybe$1(function () {

    for (var i = 0; i < serializedArr.length; i++) {
      insertStyles(cache, serializedArr[i], false);
    }
  });

  return null;
};

var ClassNames = /* #__PURE__ */withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && "development" !== 'production') {
      throw new Error('css can only be used during render');
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && "development" !== 'production') {
      throw new Error('cx can only be used during render');
    }

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge$1(cache.registered, css, classnames$1(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/createElement$3(Fragment, null, /*#__PURE__*/createElement$3(Insertion$1, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
});

{
  ClassNames.displayName = 'EmotionClassNames';
}

{
  var isBrowser = "object" !== 'undefined'; // #1727 for some reason Jest evaluates modules twice if some consuming module gets mocked with jest.mock

  var isJest = typeof jest !== 'undefined';

  if (isBrowser && !isJest) {
    // globalThis has wide browser support - https://caniuse.com/?search=globalThis, Node.js 12 and later
    var globalContext = // $FlowIgnore
    typeof globalThis !== 'undefined' ? globalThis // eslint-disable-line no-undef
    : isBrowser ? window : global;
    var globalKey = "__EMOTION_REACT_" + pkg.version.split('.')[0] + "__";

    if (globalContext[globalKey]) {
      console.warn('You are loading @emotion/react when it is already loaded. Running ' + 'multiple instances may cause problems. This can happen if multiple ' + 'versions are used, or if multiple builds of the same version are ' + 'used.');
    }

    globalContext[globalKey] = true;
  }
}

var testOmitPropsOnStringTag = isPropValid;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var useInsertionEffect = React['useInsertion' + 'Effect'] ? React['useInsertion' + 'Effect'] : function useInsertionEffect(create) {
  create();
};
function useInsertionEffectMaybe(create) {

  useInsertionEffect(create);
}

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  useInsertionEffectMaybe(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  return null;
};

var createStyled = function createStyled(tag, options) {
  {
    if (tag === undefined) {
      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
    }
  }

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (args[0][0] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (args[0][i] === undefined) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        }

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = withEmotionCache(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = useContext(ThemeContext);
      }

      if (typeof props.className === 'string') {
        className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      return /*#__PURE__*/createElement$3(Fragment, null, /*#__PURE__*/createElement$3(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/createElement$3(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "development" !== 'production') {
          return 'NO_COMPONENT_SELECTOR';
        } // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, _extends$1({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



{
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

{
  reactIs.exports = reactIs_development;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty$1.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$2;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$2 = function() {};

{
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has$2;

  printWarning$2 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$2(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$2(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs.exports;
var assign = objectAssign;

var ReactPropTypesSecret = ReactPropTypesSecret_1;
var has = has$2;
var checkPropTypes = checkPropTypes_1;

var printWarning$1 = function() {};

{
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') ;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

{
  var ReactIs = reactIs.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
}

var PropTypes = propTypes.exports;

var classnames = {exports: {}};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
}(classnames));

var classNames$1 = classnames.exports;

var ManagerReferenceNodeContext = React.createContext();
var ManagerReferenceNodeSetterContext = React.createContext();
function Manager(_ref) {
  var children = _ref.children;

  var _React$useState = React.useState(null),
      referenceNode = _React$useState[0],
      setReferenceNode = _React$useState[1];

  var hasUnmounted = React.useRef(false);
  React.useEffect(function () {
    return function () {
      hasUnmounted.current = true;
    };
  }, []);
  var handleSetReferenceNode = React.useCallback(function (node) {
    if (!hasUnmounted.current) {
      setReferenceNode(node);
    }
  }, []);
  return /*#__PURE__*/React.createElement(ManagerReferenceNodeContext.Provider, {
    value: referenceNode
  }, /*#__PURE__*/React.createElement(ManagerReferenceNodeSetterContext.Provider, {
    value: handleSetReferenceNode
  }, children));
}

/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === 'function') {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};
/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end$1 = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end$1]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end$1]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (isHTMLElement(element) && includeScale) {
    var offsetHeight = element.offsetHeight;
    var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
    // Fallback to 1 in case both values are `0`

    if (offsetWidth > 0) {
      scaleX = round(rect.width) / offsetWidth || 1;
    }

    if (offsetHeight > 0) {
      scaleY = round(rect.height) / offsetHeight || 1;
    }
  }

  return {
    width: rect.width / scaleX,
    height: rect.height / scaleY,
    top: rect.top / scaleY,
    right: rect.right / scaleX,
    bottom: rect.bottom / scaleY,
    left: rect.left / scaleX,
    x: rect.left / scaleX,
    y: rect.top / scaleY
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
  var isIE = navigator.userAgent.indexOf('Trident') !== -1;

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$1(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
    }

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end$1) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end$1) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  {
    var transitionProperty = getComputedStyle$1(state.elements.popper).transitionProperty || '';

    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
    }
  }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent$1(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent$1(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent$1(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end$1:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;

    {
      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
    }
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce$1(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
    .filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).forEach(function (key) {
      switch (key) {
        case 'name':
          if (typeof modifier.name !== 'string') {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
          }

          break;

        case 'enabled':
          if (typeof modifier.enabled !== 'boolean') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
          }

          break;

        case 'phase':
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
          }

          break;

        case 'fn':
          if (typeof modifier.fn !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'effect':
          if (modifier.effect != null && typeof modifier.effect !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'requires':
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
          }

          break;

        case 'requiresIfExists':
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
          }

          break;

        case 'options':
        case 'data':
          break;

        default:
          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
            return "\"" + s + "\"";
          }).join(', ') + "; but \"" + key + "\" was provided.");
      }

      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);

          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === 'flip';
            });

            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
            }
          }

          var _getComputedStyle = getComputedStyle$1(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
          // cause bugs with positioning, so we'll warn the consumer


          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
          }
        }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          {
            console.error(INVALID_ELEMENT_ERROR);
          }

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          {
            __debug_loops__ += 1;

            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce$1(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      {
        console.error(INVALID_ELEMENT_ERROR);
      }

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

var EMPTY_MODIFIERS$1 = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = React.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS$1
  };

  var _React$useState = React.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = React.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        setState({
          styles: fromEntries(elements.map(function (element) {
            return [element, state.styles[element] || {}];
          })),
          attributes: fromEntries(elements.map(function (element) {
            return [element, state.attributes[element]];
          }))
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = React.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (reactFastCompare(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

var NOOP = function NOOP() {
  return void 0;
};

var NOOP_PROMISE = function NOOP_PROMISE() {
  return Promise.resolve(null);
};

var EMPTY_MODIFIERS = [];
function Popper(_ref) {
  var _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers,
      referenceElement = _ref.referenceElement,
      onFirstUpdate = _ref.onFirstUpdate,
      innerRef = _ref.innerRef,
      children = _ref.children;
  var referenceNode = React.useContext(ManagerReferenceNodeContext);

  var _React$useState = React.useState(null),
      popperElement = _React$useState[0],
      setPopperElement = _React$useState[1];

  var _React$useState2 = React.useState(null),
      arrowElement = _React$useState2[0],
      setArrowElement = _React$useState2[1];

  React.useEffect(function () {
    setRef(innerRef, popperElement);
  }, [innerRef, popperElement]);
  var options = React.useMemo(function () {
    return {
      placement: placement,
      strategy: strategy,
      onFirstUpdate: onFirstUpdate,
      modifiers: [].concat(modifiers, [{
        name: 'arrow',
        enabled: arrowElement != null,
        options: {
          element: arrowElement
        }
      }])
    };
  }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);

  var _usePopper = usePopper(referenceElement || referenceNode, popperElement, options),
      state = _usePopper.state,
      styles = _usePopper.styles,
      forceUpdate = _usePopper.forceUpdate,
      update = _usePopper.update;

  var childrenProps = React.useMemo(function () {
    return {
      ref: setPopperElement,
      style: styles.popper,
      placement: state ? state.placement : placement,
      hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: styles.arrow,
        ref: setArrowElement
      },
      forceUpdate: forceUpdate || NOOP,
      update: update || NOOP_PROMISE
    };
  }, [setPopperElement, setArrowElement, placement, state, styles, update, forceUpdate]);
  return unwrapArray(children)(childrenProps);
}

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var warning = function() {};

{
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;

function Reference(_ref) {
  var children = _ref.children,
      innerRef = _ref.innerRef;
  var setReferenceNode = React.useContext(ManagerReferenceNodeSetterContext);
  var refHandler = React.useCallback(function (node) {
    setRef(innerRef, node);
    safeInvoke(setReferenceNode, node);
  }, [innerRef, setReferenceNode]); // ran on unmount

  React.useEffect(function () {
    return function () {
      return setRef(innerRef, null);
    };
  });
  React.useEffect(function () {
    warning_1(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
  }, [setReferenceNode]);
  return unwrapArray(children)({
    ref: refHandler
  });
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

var config$1 = {
  disabled: false
};

var timeoutsShape = PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) ;
PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) ;

var TransitionGroupContext = React__default.createContext(null);

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config$1.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config$1.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = _objectWithoutPropertiesLoose$2(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} ; // Name the function so it is clearer in the documentation

function noop$6() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$6,
  onEntering: noop$6,
  onEntered: noop$6,
  onExit: noop$6,
  onExiting: noop$6,
  onExited: noop$6
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var Transition$1 = Transition;

function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$3(Object(source), true).forEach(function (key) {
        _defineProperty$4(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$3(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty$4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$1(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function getScrollbarWidth() {
  let scrollDiv = document.createElement('div'); // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113

  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.width = '50px';
  scrollDiv.style.height = '50px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}
function setScrollbarWidth(padding) {
  document.body.style.paddingRight = padding > 0 ? `${padding}px` : null;
}
function isBodyOverflowing() {
  return document.body.clientWidth < window.innerWidth;
}
function getOriginalBodyPadding() {
  const style = window.getComputedStyle(document.body, null);
  return parseInt(style && style.getPropertyValue('padding-right') || 0, 10);
}
function conditionallyUpdateScrollbar() {
  const scrollbarWidth = getScrollbarWidth(); // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433

  const fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
  const bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;

  if (isBodyOverflowing()) {
    setScrollbarWidth(bodyPadding + scrollbarWidth);
  }
}
let globalCssModule;
function mapToCssModules(className = '', cssModule = globalCssModule) {
  if (!cssModule) return className;
  return className.split(' ').map(c => cssModule[c] || c).join(' ');
}
/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */

function omit(obj, omitKeys) {
  const result = {};
  Object.keys(obj).forEach(key => {
    if (omitKeys.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}
/**
 * Returns a filtered copy of an object with only the specified keys.
 */

function pick(obj, keys) {
  const pickKeys = Array.isArray(keys) ? keys : [keys];
  let length = pickKeys.length;
  let key;
  const result = {};

  while (length > 0) {
    length -= 1;
    key = pickKeys[length];
    result[key] = obj[key];
  }

  return result;
}
let warned = {};
function warnOnce(message) {
  if (!warned[message]) {
    /* istanbul ignore else */
    if (typeof console !== 'undefined') {
      console.error(message); // eslint-disable-line no-console
    }

    warned[message] = true;
  }
}
function deprecated(propType, explanation) {
  return function validate(props, propName, componentName, ...rest) {
    if (props[propName] !== null && typeof props[propName] !== 'undefined') {
      warnOnce(`"${propName}" property of "${componentName}" has been deprecated.\n${explanation}`);
    }

    return propType(props, propName, componentName, ...rest);
  };
} // Shim Element if needed (e.g. in Node environment)

const Element$1 = typeof window === 'object' && window.Element || function () {};

function DOMElement(props, propName, componentName) {
  if (!(props[propName] instanceof Element$1)) {
    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Expected prop to be an instance of Element. Validation failed.');
  }
}
const targetPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, DOMElement, PropTypes.shape({
  current: PropTypes.any
})]);
const tagPropType = PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.shape({
  $$typeof: PropTypes.symbol,
  render: PropTypes.func
}), PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.shape({
  $$typeof: PropTypes.symbol,
  render: PropTypes.func
})]))]);
/* eslint key-spacing: ["error", { afterColon: true, align: "value" }] */
// These are all setup to match what is in the bootstrap _variables.scss
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss

const TransitionTimeouts = {
  Fade: 150,
  // $transition-fade
  Collapse: 350,
  // $transition-collapse
  Modal: 300,
  // $modal-transition
  Carousel: 600,
  // $carousel-transition
  Offcanvas: 300 // $offcanvas-transition

}; // Duplicated Transition.propType keys to ensure that Reactstrap builds
// for distribution properly exclude these keys for nested child HTML attributes
// since `react-transition-group` removes propTypes in production builds.

const TransitionPropTypeKeys = ['in', 'mountOnEnter', 'unmountOnExit', 'appear', 'enter', 'exit', 'timeout', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'];
const TransitionStatuses = {
  ENTERING: 'entering',
  ENTERED: 'entered',
  EXITING: 'exiting',
  EXITED: 'exited'
};
const keyCodes = {
  esc: 27,
  space: 32,
  enter: 13,
  tab: 9,
  up: 38,
  down: 40,
  home: 36,
  end: 35,
  n: 78,
  p: 80
};
const PopperPlacements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
const canUseDOM$1 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function isReactRefObj(target) {
  if (target && typeof target === 'object') {
    return 'current' in target;
  }

  return false;
}

function getTag(value) {
  if (value == null) {
    return value === undefined ? '[object Undefined]' : '[object Null]';
  }

  return Object.prototype.toString.call(value);
}
function isObject$2(value) {
  const type = typeof value;
  return value != null && (type === 'object' || type === 'function');
}
function isFunction$1(value) {
  if (!isObject$2(value)) {
    return false;
  }

  const tag = getTag(value);
  return tag === '[object Function]' || tag === '[object AsyncFunction]' || tag === '[object GeneratorFunction]' || tag === '[object Proxy]';
}
function findDOMElements(target) {
  if (isReactRefObj(target)) {
    return target.current;
  }

  if (isFunction$1(target)) {
    return target();
  }

  if (typeof target === 'string' && canUseDOM$1) {
    let selection = document.querySelectorAll(target);

    if (!selection.length) {
      selection = document.querySelectorAll(`#${target}`);
    }

    if (!selection.length) {
      throw new Error(`The target '${target}' could not be identified in the dom, tip: check spelling`);
    }

    return selection;
  }

  return target;
}
function isArrayOrNodeList(els) {
  if (els === null) {
    return false;
  }

  return Array.isArray(els) || canUseDOM$1 && typeof els.length === 'number';
}
function getTarget(target, allElements) {
  const els = findDOMElements(target);

  if (allElements) {
    if (isArrayOrNodeList(els)) {
      return els;
    }

    if (els === null) {
      return [];
    }

    return [els];
  } else {
    if (isArrayOrNodeList(els)) {
      return els[0];
    }

    return els;
  }
}
const defaultToggleEvents = ['touchstart', 'click'];
function addMultipleEventListeners(_els, handler, _events, useCapture) {
  let els = _els;

  if (!isArrayOrNodeList(els)) {
    els = [els];
  }

  let events = _events;

  if (typeof events === 'string') {
    events = events.split(/\s+/);
  }

  if (!isArrayOrNodeList(els) || typeof handler !== 'function' || !Array.isArray(events)) {
    throw new Error(`
      The first argument of this function must be DOM node or an array on DOM nodes or NodeList.
      The second must be a function.
      The third is a string or an array of strings that represents DOM events
    `);
  }

  Array.prototype.forEach.call(events, event => {
    Array.prototype.forEach.call(els, el => {
      el.addEventListener(event, handler, useCapture);
    });
  });
  return function removeEvents() {
    Array.prototype.forEach.call(events, event => {
      Array.prototype.forEach.call(els, el => {
        el.removeEventListener(event, handler, useCapture);
      });
    });
  };
}
const focusableElements = ['a[href]', 'area[href]', 'input:not([disabled]):not([type=hidden])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'object', 'embed', '[tabindex]:not(.modal)', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'];
({
  tag: tagPropType,
  fluid: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  className: PropTypes.string,
  cssModule: PropTypes.object
});
const rowColsPropType = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
({
  tag: tagPropType,
  noGutters: deprecated(PropTypes.bool, "Please use Bootstrap 5 gutter utility classes. https://getbootstrap.com/docs/5.0/layout/gutters/"),
  className: PropTypes.string,
  cssModule: PropTypes.object,
  form: PropTypes.bool,
  xs: rowColsPropType,
  sm: rowColsPropType,
  md: rowColsPropType,
  lg: rowColsPropType,
  xl: rowColsPropType,
  xxl: rowColsPropType
});

const _excluded$1c = ["className", "cssModule", "widths", "tag"];
const colWidths$1 = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
const stringOrNumberProp$1 = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
const columnProps$1 = PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string, PropTypes.shape({
  size: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  order: stringOrNumberProp$1,
  offset: stringOrNumberProp$1
})]);
const propTypes$1i = {
  tag: tagPropType,
  xs: columnProps$1,
  sm: columnProps$1,
  md: columnProps$1,
  lg: columnProps$1,
  xl: columnProps$1,
  xxl: columnProps$1,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  widths: PropTypes.array
};
const defaultProps$1g = {
  tag: 'div',
  widths: colWidths$1
};

const getColumnSizeClass$1 = (isXs, colWidth, colSize) => {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : `col-${colWidth}`;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : `col-${colWidth}-auto`;
  }

  return isXs ? `col-${colSize}` : `col-${colWidth}-${colSize}`;
};

const getColumnClasses = (attributes, cssModule, widths = colWidths$1) => {
  const colClasses = [];
  widths.forEach((colWidth, i) => {
    let columnProp = attributes[colWidth];
    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    const isXs = !i;

    if (isObject$2(columnProp)) {
      const colSizeInterfix = isXs ? '-' : `-${colWidth}-`;
      const colClass = getColumnSizeClass$1(isXs, colWidth, columnProp.size);
      colClasses.push(mapToCssModules(classNames$1({
        [colClass]: columnProp.size || columnProp.size === '',
        [`order${colSizeInterfix}${columnProp.order}`]: columnProp.order || columnProp.order === 0,
        [`offset${colSizeInterfix}${columnProp.offset}`]: columnProp.offset || columnProp.offset === 0
      }), cssModule));
    } else {
      const colClass = getColumnSizeClass$1(isXs, colWidth, columnProp);
      colClasses.push(colClass);
    }
  });
  return {
    colClasses,
    attributes
  };
};

const Col = props => {
  const {
    className,
    cssModule,
    widths,
    tag: Tag
  } = props,
        attributes = _objectWithoutProperties$2(props, _excluded$1c);

  let {
    attributes: modifiedAttributes,
    colClasses
  } = getColumnClasses(attributes, cssModule, widths);

  if (!colClasses.length) {
    colClasses.push('col');
  }

  const classes = mapToCssModules(classNames$1(className, colClasses), cssModule);
  return /*#__PURE__*/React__default.createElement(Tag, _extends({}, modifiedAttributes, {
    className: classes
  }));
};

Col.propTypes = propTypes$1i;
Col.defaultProps = defaultProps$1g;
var Col$1 = Col;
({
  light: PropTypes.bool,
  dark: PropTypes.bool,
  full: PropTypes.bool,
  fixed: PropTypes.string,
  sticky: PropTypes.string,
  color: PropTypes.string,
  role: PropTypes.string,
  tag: tagPropType,
  container: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  className: PropTypes.string,
  cssModule: PropTypes.object,
  expand: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  children: PropTypes.node
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  tag: tagPropType,
  type: PropTypes.string,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  children: PropTypes.node
});
({
  tabs: PropTypes.bool,
  pills: PropTypes.bool,
  vertical: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  horizontal: PropTypes.string,
  justified: PropTypes.bool,
  fill: PropTypes.bool,
  navbar: PropTypes.bool,
  card: PropTypes.bool,
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  tag: tagPropType,
  active: PropTypes.bool,
  className: PropTypes.string,
  cssModule: PropTypes.object
});

const _excluded$15 = ["className", "cssModule", "active", "tag", "innerRef"];
const propTypes$1b = {
  tag: tagPropType,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
  disabled: PropTypes.bool,
  active: PropTypes.bool,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  onClick: PropTypes.func,
  href: PropTypes.any
};
const defaultProps$19 = {
  tag: 'a'
};

class NavLink extends React__default.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.href === '#') {
      e.preventDefault();
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }
  }

  render() {
    let _this$props = this.props,
        {
      className,
      cssModule,
      active,
      tag: Tag,
      innerRef
    } = _this$props,
        attributes = _objectWithoutProperties$2(_this$props, _excluded$15);

    const classes = mapToCssModules(classNames$1(className, 'nav-link', {
      disabled: attributes.disabled,
      active: active
    }), cssModule);
    return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
      ref: innerRef,
      onClick: this.onClick,
      className: classes
    }));
  }

}

NavLink.propTypes = propTypes$1b;
NavLink.defaultProps = defaultProps$19;
({
  tag: tagPropType,
  listTag: tagPropType,
  className: PropTypes.string,
  listClassName: PropTypes.string,
  cssModule: PropTypes.object,
  children: PropTypes.node,
  'aria-label': PropTypes.string
});
({
  tag: tagPropType,
  active: PropTypes.bool,
  className: PropTypes.string,
  cssModule: PropTypes.object
});

const _excluded$12 = ["active", "aria-label", "block", "className", "close", "cssModule", "color", "outline", "size", "tag", "innerRef"];
const propTypes$18 = {
  active: PropTypes.bool,
  'aria-label': PropTypes.string,
  block: PropTypes.bool,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  outline: PropTypes.bool,
  tag: tagPropType,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
  onClick: PropTypes.func,
  size: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  close: PropTypes.bool
};
const defaultProps$16 = {
  color: 'secondary',
  tag: 'button'
};

class Button$1 extends React__default.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.onClick) {
      return this.props.onClick(e);
    }
  }

  render() {
    let _this$props = this.props,
        {
      active,
      'aria-label': ariaLabel,
      block,
      className,
      close,
      cssModule,
      color,
      outline,
      size,
      tag: Tag,
      innerRef
    } = _this$props,
        attributes = _objectWithoutProperties$2(_this$props, _excluded$12);

    const btnOutlineColor = `btn${outline ? '-outline' : ''}-${color}`;
    const classes = mapToCssModules(classNames$1(className, close && 'btn-close', close || 'btn', close || btnOutlineColor, size ? `btn-${size}` : false, block ? 'd-block w-100' : false, {
      active,
      disabled: this.props.disabled
    }), cssModule);

    if (attributes.href && Tag === 'button') {
      Tag = 'a';
    }

    const defaultAriaLabel = close ? 'Close' : null;
    return /*#__PURE__*/React__default.createElement(Tag, _extends({
      type: Tag === 'button' && attributes.onClick ? 'button' : undefined
    }, attributes, {
      className: classes,
      ref: innerRef,
      onClick: this.onClick,
      "aria-label": ariaLabel || defaultAriaLabel
    }));
  }

}

Button$1.propTypes = propTypes$18;
Button$1.defaultProps = defaultProps$16;
var Button$1$1 = Button$1;

const _excluded$11 = ["className"];
const propTypes$17 = {
  onClick: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  defaultValue: PropTypes.bool
};
const defaultProps$15 = {
  defaultValue: false
};

class ButtonToggle extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggled: props.defaultValue,
      focus: false
    };
    this.onBlur = this.onBlur.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onBlur(e) {
    if (this.props.onBlur) {
      this.props.onBlur(e);
    }

    this.setState({
      focus: false
    });
  }

  onFocus(e) {
    if (this.props.onFocus) {
      this.props.onFocus(e);
    }

    this.setState({
      focus: true
    });
  }

  onClick(e) {
    if (this.props.onClick) {
      this.props.onClick(e);
    }

    this.setState(({
      toggled
    }) => ({
      toggled: !toggled
    }));
  }

  render() {
    const _this$props = this.props,
          {
      className
    } = _this$props,
          attributes = _objectWithoutProperties$2(_this$props, _excluded$11);

    const classes = mapToCssModules(classNames$1(className, {
      focus: this.state.focus
    }), this.props.cssModule);
    return /*#__PURE__*/React__default.createElement(Button$1$1, _extends({
      active: this.state.toggled,
      onBlur: this.onBlur,
      onFocus: this.onFocus,
      onClick: this.onClick,
      className: classes
    }, attributes));
  }

}

ButtonToggle.propTypes = propTypes$17;
ButtonToggle.defaultProps = defaultProps$15;

/**
 * DropdownContext
 * {
 *  toggle: PropTypes.func.isRequired,
 *  isOpen: PropTypes.bool.isRequired,
 *  direction: PropTypes.oneOf(['up', 'down', 'start', 'end']).isRequired,
 *  inNavbar: PropTypes.bool.isRequired,
 *  disabled: PropTypes.bool
 * }
 */

const DropdownContext = React__default.createContext({});

const _excluded$10 = ["className", "cssModule", "direction", "isOpen", "group", "size", "nav", "setActiveFromChild", "active", "tag", "menuRole"];
const propTypes$16 = {
  a11y: PropTypes.bool,
  disabled: PropTypes.bool,
  direction: PropTypes.oneOf(['up', 'down', 'start', 'end', 'left', 'right']),
  group: PropTypes.bool,
  isOpen: PropTypes.bool,
  nav: PropTypes.bool,
  active: PropTypes.bool,
  size: PropTypes.string,
  tag: tagPropType,
  toggle: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  inNavbar: PropTypes.bool,
  setActiveFromChild: PropTypes.bool,
  menuRole: PropTypes.oneOf(['listbox', 'menu'])
};
const defaultProps$14 = {
  a11y: true,
  isOpen: false,
  direction: 'down',
  nav: false,
  active: false,
  inNavbar: false,
  setActiveFromChild: false
};
const preventDefaultKeys = [keyCodes.space, keyCodes.enter, keyCodes.up, keyCodes.down, keyCodes.end, keyCodes.home];

class Dropdown$1 extends React__default.Component {
  constructor(props) {
    super(props);
    this.addEvents = this.addEvents.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.removeEvents = this.removeEvents.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleMenuRef = this.handleMenuRef.bind(this);
    this.containerRef = React__default.createRef();
    this.menuRef = React__default.createRef();
  }

  handleMenuRef(menuRef) {
    this.menuRef.current = menuRef;
  }

  getContextValue() {
    return {
      toggle: this.toggle,
      isOpen: this.props.isOpen,
      direction: this.props.direction === 'down' && this.props.dropup ? 'up' : this.props.direction,
      inNavbar: this.props.inNavbar,
      disabled: this.props.disabled,
      // Callback that should be called by DropdownMenu to provide a ref to
      // a HTML tag that's used for the DropdownMenu
      onMenuRef: this.handleMenuRef,
      menuRole: this.props.menuRole
    };
  }

  componentDidMount() {
    this.handleProps();
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen !== prevProps.isOpen) {
      this.handleProps();
    }
  }

  componentWillUnmount() {
    this.removeEvents();
  }

  getContainer() {
    return this.containerRef.current;
  }

  getMenu() {
    return this.menuRef.current;
  }

  getMenuCtrl() {
    if (this._$menuCtrl) return this._$menuCtrl;
    this._$menuCtrl = this.getContainer().querySelector('[aria-expanded]');
    return this._$menuCtrl;
  }

  getItemType() {
    if (this.context.menuRole === 'listbox') {
      return 'option';
    }

    return 'menuitem';
  }

  getMenuItems() {
    // In a real menu with a child DropdownMenu, `this.getMenu()` should never
    // be null, but it is sometimes null in tests. To mitigate that, we just
    // use `this.getContainer()` as the fallback `menuContainer`.
    const menuContainer = this.getMenu() || this.getContainer();
    return [].slice.call(menuContainer.querySelectorAll(`[role="${this.getItemType()}"]`));
  }

  addEvents() {
    ['click', 'touchstart', 'keyup'].forEach(event => document.addEventListener(event, this.handleDocumentClick, true));
  }

  removeEvents() {
    ['click', 'touchstart', 'keyup'].forEach(event => document.removeEventListener(event, this.handleDocumentClick, true));
  }

  handleDocumentClick(e) {
    if (e && (e.which === 3 || e.type === 'keyup' && e.which !== keyCodes.tab)) return;
    const container = this.getContainer();
    const menu = this.getMenu();
    const clickIsInContainer = container.contains(e.target) && container !== e.target;
    const clickIsInInput = container.classList.contains('input-group') && container.classList.contains('dropdown') && e.target.tagName === 'INPUT';
    const clickIsInMenu = menu && menu.contains(e.target) && menu !== e.target;

    if ((clickIsInContainer && !clickIsInInput || clickIsInMenu) && (e.type !== 'keyup' || e.which === keyCodes.tab)) {
      return;
    }

    this.toggle(e);
  }

  handleKeyDown(e) {
    const isTargetMenuItem = e.target.getAttribute('role') === 'menuitem' || e.target.getAttribute('role') === 'option';
    const isTargetMenuCtrl = this.getMenuCtrl() === e.target;
    const isTab = keyCodes.tab === e.which;

    if (/input|textarea/i.test(e.target.tagName) || isTab && !this.props.a11y || isTab && !(isTargetMenuItem || isTargetMenuCtrl)) {
      return;
    }

    if (preventDefaultKeys.indexOf(e.which) !== -1 || e.which >= 48 && e.which <= 90) {
      e.preventDefault();
    }

    if (this.props.disabled) return;

    if (isTargetMenuCtrl) {
      if ([keyCodes.space, keyCodes.enter, keyCodes.up, keyCodes.down].indexOf(e.which) > -1) {
        // Open the menu (if not open) and focus the first menu item
        if (!this.props.isOpen) {
          this.toggle(e);
        }

        setTimeout(() => this.getMenuItems()[0].focus());
      } else if (this.props.isOpen && isTab) {
        // Focus the first menu item if tabbing from an open menu. We need this
        // for cases where the DropdownMenu sets a custom container, which may
        // not be the natural next item to tab to from the DropdownToggle.
        e.preventDefault();
        this.getMenuItems()[0].focus();
      } else if (this.props.isOpen && e.which === keyCodes.esc) {
        this.toggle(e);
      }
    }

    if (this.props.isOpen && isTargetMenuItem) {
      if ([keyCodes.tab, keyCodes.esc].indexOf(e.which) > -1) {
        this.toggle(e);
        this.getMenuCtrl().focus();
      } else if ([keyCodes.space, keyCodes.enter].indexOf(e.which) > -1) {
        e.target.click();
        this.getMenuCtrl().focus();
      } else if ([keyCodes.down, keyCodes.up].indexOf(e.which) > -1 || [keyCodes.n, keyCodes.p].indexOf(e.which) > -1 && e.ctrlKey) {
        const $menuitems = this.getMenuItems();
        let index = $menuitems.indexOf(e.target);

        if (keyCodes.up === e.which || keyCodes.p === e.which && e.ctrlKey) {
          index = index !== 0 ? index - 1 : $menuitems.length - 1;
        } else if (keyCodes.down === e.which || keyCodes.n === e.which && e.ctrlKey) {
          index = index === $menuitems.length - 1 ? 0 : index + 1;
        }

        $menuitems[index].focus();
      } else if (keyCodes.end === e.which) {
        const $menuitems = this.getMenuItems();
        $menuitems[$menuitems.length - 1].focus();
      } else if (keyCodes.home === e.which) {
        const $menuitems = this.getMenuItems();
        $menuitems[0].focus();
      } else if (e.which >= 48 && e.which <= 90) {
        const $menuitems = this.getMenuItems();
        const charPressed = String.fromCharCode(e.which).toLowerCase();

        for (let i = 0; i < $menuitems.length; i += 1) {
          const firstLetter = $menuitems[i].textContent && $menuitems[i].textContent[0].toLowerCase();

          if (firstLetter === charPressed) {
            $menuitems[i].focus();
            break;
          }
        }
      }
    }
  }

  handleProps() {
    if (this.props.isOpen) {
      this.addEvents();
    } else {
      this.removeEvents();
    }
  }

  toggle(e) {
    if (this.props.disabled) {
      return e && e.preventDefault();
    }

    return this.props.toggle(e);
  }

  render() {
    const _omit = omit(this.props, ['toggle', 'disabled', 'inNavbar', 'a11y']),
          {
      className,
      cssModule,
      direction,
      isOpen,
      group,
      size,
      nav,
      setActiveFromChild,
      active,
      tag,
      menuRole
    } = _omit,
          attrs = _objectWithoutProperties$2(_omit, _excluded$10);

    const Tag = tag || (nav ? 'li' : 'div');
    let subItemIsActive = false;

    if (setActiveFromChild) {
      React__default.Children.map(this.props.children[1].props.children, dropdownItem => {
        if (dropdownItem && dropdownItem.props.active) subItemIsActive = true;
      });
    }

    const classes = mapToCssModules(classNames$1(className, nav && active ? 'active' : false, setActiveFromChild && subItemIsActive ? 'active' : false, {
      'btn-group': group,
      [`btn-group-${size}`]: !!size,
      dropdown: !group,
      dropup: direction === 'up',
      dropstart: direction === 'start' || direction === 'left',
      dropend: direction === 'end' || direction === 'right',
      show: isOpen,
      'nav-item': nav
    }), cssModule);
    return /*#__PURE__*/React__default.createElement(DropdownContext.Provider, {
      value: this.getContextValue()
    }, /*#__PURE__*/React__default.createElement(Manager, null, /*#__PURE__*/React__default.createElement(Tag, _extends({}, attrs, {
      [typeof Tag === 'string' ? 'ref' : 'innerRef']: this.containerRef,
      onKeyDown: this.handleKeyDown,
      className: classes
    }))));
  }

}

Dropdown$1.propTypes = propTypes$16;
Dropdown$1.defaultProps = defaultProps$14;
var Dropdown$1$1 = Dropdown$1;

const propTypes$15 = {
  children: PropTypes.node
};

const ButtonDropdown = props => {
  return /*#__PURE__*/React__default.createElement(Dropdown$1$1, _extends({
    group: true
  }, props));
};

ButtonDropdown.propTypes = propTypes$15;
var ButtonDropdown$1 = ButtonDropdown;
({
  tag: tagPropType,
  'aria-label': PropTypes.string,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  role: PropTypes.string,
  size: PropTypes.string,
  vertical: PropTypes.bool
});
({
  tag: tagPropType,
  'aria-label': PropTypes.string,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  role: PropTypes.string
});

const _excluded$Z = ["className", "cssModule", "divider", "tag", "header", "active", "text"];
const propTypes$12 = {
  children: PropTypes.node,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  divider: PropTypes.bool,
  tag: tagPropType,
  header: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  toggle: PropTypes.bool,
  text: PropTypes.bool
};
const defaultProps$11 = {
  tag: 'button',
  toggle: true
};

class DropdownItem extends React__default.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.getTabIndex = this.getTabIndex.bind(this);
  }

  getRole() {
    if (this.context.menuRole === 'listbox') {
      return 'option';
    }

    return 'menuitem';
  }

  onClick(e) {
    const {
      disabled,
      header,
      divider,
      text
    } = this.props;

    if (disabled || header || divider || text) {
      e.preventDefault();
      return;
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }

    if (this.props.toggle) {
      this.context.toggle(e);
    }
  }

  getTabIndex() {
    const {
      disabled,
      header,
      divider,
      text
    } = this.props;

    if (disabled || header || divider || text) {
      return '-1';
    }

    return '0';
  }

  render() {
    const tabIndex = this.getTabIndex();
    const role = tabIndex > -1 ? this.getRole() : undefined;

    let _omit = omit(this.props, ['toggle']),
        {
      className,
      cssModule,
      divider,
      tag: Tag,
      header,
      active,
      text
    } = _omit,
        props = _objectWithoutProperties$2(_omit, _excluded$Z);

    const classes = mapToCssModules(classNames$1(className, {
      disabled: props.disabled,
      'dropdown-item': !divider && !header && !text,
      active: active,
      'dropdown-header': header,
      'dropdown-divider': divider,
      'dropdown-item-text': text
    }), cssModule);

    if (Tag === 'button') {
      if (header) {
        Tag = 'h6';
      } else if (divider) {
        Tag = 'div';
      } else if (props.href) {
        Tag = 'a';
      } else if (text) {
        Tag = 'span';
      }
    }

    return /*#__PURE__*/React__default.createElement(Tag, _extends({
      type: Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined
    }, props, {
      tabIndex: tabIndex,
      role: role,
      className: classes,
      onClick: this.onClick
    }));
  }

}

DropdownItem.propTypes = propTypes$12;
DropdownItem.defaultProps = defaultProps$11;
DropdownItem.contextType = DropdownContext;

const _excluded$Y = ["className", "cssModule", "dark", "end", "right", "tag", "flip", "modifiers", "persist", "strategy", "container"];
const propTypes$11 = {
  tag: tagPropType,
  children: PropTypes.node.isRequired,
  dark: PropTypes.bool,
  end: PropTypes.bool,
  flip: PropTypes.bool,
  modifiers: PropTypes.array,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  persist: PropTypes.bool,
  strategy: PropTypes.string,
  container: targetPropType,
  right: deprecated(PropTypes.bool, 'Please use "end" instead.')
};
const defaultProps$10 = {
  tag: 'div',
  flip: true,
  modifiers: []
};
const directionPositionMap = {
  up: 'top',
  left: 'left',
  right: 'right',
  start: 'left',
  end: 'right',
  down: 'bottom'
};

class DropdownMenu extends React__default.Component {
  getRole() {
    if (this.context.menuRole === 'listbox') {
      return 'listbox';
    }

    return 'menu';
  }

  render() {
    const _this$props = this.props,
          {
      className,
      cssModule,
      dark,
      end,
      right,
      tag,
      flip,
      modifiers,
      persist,
      strategy,
      container
    } = _this$props,
          attrs = _objectWithoutProperties$2(_this$props, _excluded$Y);

    const classes = mapToCssModules(classNames$1(className, 'dropdown-menu', {
      'dropdown-menu-dark': dark,
      'dropdown-menu-end': end || right,
      show: this.context.isOpen
    }), cssModule);
    const Tag = tag;

    if (persist || this.context.isOpen && !this.context.inNavbar) {
      const position1 = directionPositionMap[this.context.direction] || 'bottom';
      const position2 = end || right ? 'end' : 'start';
      const poperPlacement = `${position1}-${position2}`;
      const poperModifiers = [...modifiers, {
        name: 'flip',
        enabled: !!flip
      }];
      const popper = /*#__PURE__*/React__default.createElement(Popper, {
        placement: poperPlacement,
        modifiers: poperModifiers,
        strategy: strategy
      }, ({
        ref,
        style,
        placement
      }) => {
        let combinedStyle = _objectSpread2$3(_objectSpread2$3({}, this.props.style), style);

        const handleRef = tagRef => {
          // Send the ref to `react-popper`
          ref(tagRef); // Send the ref to the parent Dropdown so that clicks outside
          // it will cause it to close

          const {
            onMenuRef
          } = this.context;
          if (onMenuRef) onMenuRef(tagRef);
        };

        return /*#__PURE__*/React__default.createElement(Tag, _extends({
          tabIndex: "-1",
          role: this.getRole(),
          ref: handleRef
        }, attrs, {
          style: combinedStyle,
          "aria-hidden": !this.context.isOpen,
          className: classes,
          "data-popper-placement": placement
        }));
      });

      if (container) {
        return ReactDOM.createPortal(popper, getTarget(container));
      } else {
        return popper;
      }
    }

    return /*#__PURE__*/React__default.createElement(Tag, _extends({
      tabIndex: "-1",
      role: this.getRole()
    }, attrs, {
      "aria-hidden": !this.context.isOpen,
      className: classes,
      "data-popper-placement": attrs.placement
    }));
  }

}
DropdownMenu.propTypes = propTypes$11;
DropdownMenu.defaultProps = defaultProps$10;
DropdownMenu.contextType = DropdownContext;

const _excluded$X = ["className", "color", "cssModule", "caret", "split", "nav", "tag", "innerRef"];
const propTypes$10 = {
  caret: PropTypes.bool,
  color: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  'aria-haspopup': PropTypes.bool,
  split: PropTypes.bool,
  tag: tagPropType,
  nav: PropTypes.bool
};
const defaultProps$$ = {
  color: 'secondary',
  'aria-haspopup': true
};

class DropdownToggle extends React__default.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    if (this.props.disabled || this.context.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.nav && !this.props.tag) {
      e.preventDefault();
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }

    this.context.toggle(e);
  }

  getRole() {
    return this.context.menuRole || this.props['aria-haspopup'];
  }

  render() {
    const _this$props = this.props,
          {
      className,
      color,
      cssModule,
      caret,
      split,
      nav,
      tag,
      innerRef
    } = _this$props,
          props = _objectWithoutProperties$2(_this$props, _excluded$X);

    const ariaLabel = props['aria-label'] || 'Toggle Dropdown';
    const classes = mapToCssModules(classNames$1(className, {
      'dropdown-toggle': caret || split,
      'dropdown-toggle-split': split,
      'nav-link': nav
    }), cssModule);
    const children = typeof props.children !== 'undefined' ? props.children : /*#__PURE__*/React__default.createElement("span", {
      className: "visually-hidden"
    }, ariaLabel);
    let Tag;

    if (nav && !tag) {
      Tag = 'a';
      props.href = '#';
    } else if (!tag) {
      Tag = Button$1$1;
      props.color = color;
      props.cssModule = cssModule;
    } else {
      Tag = tag;
    }

    if (this.context.inNavbar) {
      return /*#__PURE__*/React__default.createElement(Tag, _extends({}, props, {
        className: classes,
        onClick: this.onClick,
        "aria-expanded": this.context.isOpen,
        "aria-haspopup": this.getRole(),
        children: children
      }));
    }

    return /*#__PURE__*/React__default.createElement(Reference, {
      innerRef: innerRef
    }, ({
      ref
    }) => /*#__PURE__*/React__default.createElement(Tag, _extends({}, props, {
      [typeof Tag === 'string' ? 'ref' : 'innerRef']: ref,
      className: classes,
      onClick: this.onClick,
      "aria-expanded": this.context.isOpen,
      "aria-haspopup": this.getRole(),
      children: children
    })));
  }

}

DropdownToggle.propTypes = propTypes$10;
DropdownToggle.defaultProps = defaultProps$$;
DropdownToggle.contextType = DropdownContext;

const _excluded$W = ["tag", "baseClass", "baseClassActive", "className", "cssModule", "children", "innerRef"];

const propTypes$$ = _objectSpread2$3(_objectSpread2$3({}, Transition$1.propTypes), {}, {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  tag: tagPropType,
  baseClass: PropTypes.string,
  baseClassActive: PropTypes.string,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func])
});

const defaultProps$_ = _objectSpread2$3(_objectSpread2$3({}, Transition$1.defaultProps), {}, {
  tag: 'div',
  baseClass: 'fade',
  baseClassActive: 'show',
  timeout: TransitionTimeouts.Fade,
  appear: true,
  enter: true,
  exit: true,
  in: true
});

function Fade(props) {
  const {
    tag: Tag,
    baseClass,
    baseClassActive,
    className,
    cssModule,
    children,
    innerRef
  } = props,
        otherProps = _objectWithoutProperties$2(props, _excluded$W);

  const transitionProps = pick(otherProps, TransitionPropTypeKeys);
  const childProps = omit(otherProps, TransitionPropTypeKeys);
  return /*#__PURE__*/React__default.createElement(Transition$1, transitionProps, status => {
    const isActive = status === 'entered';
    const classes = mapToCssModules(classNames$1(className, baseClass, isActive && baseClassActive), cssModule);
    return /*#__PURE__*/React__default.createElement(Tag, _extends({
      className: classes
    }, childProps, {
      ref: innerRef
    }), children);
  });
}

Fade.propTypes = propTypes$$;
Fade.defaultProps = defaultProps$_;

/**
 * AccordionContext
 * {
 *  toggle: PropTypes.func.isRequired,
 *  openId: PropTypes.string,    
 * }
 */

React__default.createContext({});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),
  children: PropTypes.node,
  flush: PropTypes.bool,
  open: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
  toggle: PropTypes.func.isRequired
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),
  children: PropTypes.node,
  defaultOpen: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  stayOpen: PropTypes.bool
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),
  children: PropTypes.node,
  targetId: PropTypes.string.isRequired
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),
  children: PropTypes.node
});

const _excluded$R = ["tag", "horizontal", "isOpen", "className", "navbar", "cssModule", "children", "innerRef"];

const propTypes$W = _objectSpread2$3(_objectSpread2$3({}, Transition$1.propTypes), {}, {
  horizontal: PropTypes.bool,
  isOpen: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  tag: tagPropType,
  className: PropTypes.node,
  navbar: PropTypes.bool,
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.object])
});

const defaultProps$V = _objectSpread2$3(_objectSpread2$3({}, Transition$1.defaultProps), {}, {
  horizontal: false,
  isOpen: false,
  appear: false,
  enter: true,
  exit: true,
  tag: 'div',
  timeout: TransitionTimeouts.Collapse
});

const transitionStatusToClassHash = {
  [TransitionStatuses.ENTERING]: 'collapsing',
  [TransitionStatuses.ENTERED]: 'collapse show',
  [TransitionStatuses.EXITING]: 'collapsing',
  [TransitionStatuses.EXITED]: 'collapse'
};

function getTransitionClass(status) {
  return transitionStatusToClassHash[status] || 'collapse';
}

class Collapse$1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dimension: null
    };
    ['onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].forEach(name => {
      this[name] = this[name].bind(this);
    });
  }

  getDimension(node) {
    return this.props.horizontal ? node.scrollWidth : node.scrollHeight;
  }

  onEntering(node, isAppearing) {
    this.setState({
      dimension: this.getDimension(node)
    });
    this.props.onEntering(node, isAppearing);
  }

  onEntered(node, isAppearing) {
    this.setState({
      dimension: null
    });
    this.props.onEntered(node, isAppearing);
  }

  onExit(node) {
    this.setState({
      dimension: this.getDimension(node)
    });
    this.props.onExit(node);
  }

  onExiting(node) {
    // getting this variable triggers a reflow
    this.getDimension(node); // eslint-disable-line no-unused-vars


    this.setState({
      dimension: 0
    });
    this.props.onExiting(node);
  }

  onExited(node) {
    this.setState({
      dimension: null
    });
    this.props.onExited(node);
  }

  render() {
    const _this$props = this.props,
          {
      tag: Tag,
      horizontal,
      isOpen,
      className,
      navbar,
      cssModule,
      children,
      innerRef
    } = _this$props,
          otherProps = _objectWithoutProperties$2(_this$props, _excluded$R);

    const {
      dimension
    } = this.state;
    const transitionProps = pick(otherProps, TransitionPropTypeKeys);
    const childProps = omit(otherProps, TransitionPropTypeKeys);
    return /*#__PURE__*/React__default.createElement(Transition$1, _extends({}, transitionProps, {
      in: isOpen,
      onEntering: this.onEntering,
      onEntered: this.onEntered,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }), status => {
      let collapseClass = getTransitionClass(status);
      const classes = mapToCssModules(classNames$1(className, horizontal && 'collapse-horizontal', collapseClass, navbar && 'navbar-collapse'), cssModule);
      const style = dimension === null ? null : {
        [horizontal ? 'width' : 'height']: dimension
      };
      return /*#__PURE__*/React__default.createElement(Tag, _extends({}, childProps, {
        style: _objectSpread2$3(_objectSpread2$3({}, childProps.style), style),
        className: classes,
        ref: this.props.innerRef
      }), children);
    });
  }

}

Collapse$1.propTypes = propTypes$W;
Collapse$1.defaultProps = defaultProps$V;
var Collapse$1$1 = Collapse$1;
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),
  children: PropTypes.node,
  accordionId: PropTypes.string.isRequired
});
({
  color: PropTypes.string,
  pill: PropTypes.bool,
  tag: tagPropType,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
  children: PropTypes.node,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  tag: tagPropType,
  inverse: PropTypes.bool,
  color: PropTypes.string,
  body: PropTypes.bool,
  outline: PropTypes.bool,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func])
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func])
});
({
  tag: tagPropType,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  tag: tagPropType,
  top: PropTypes.bool,
  bottom: PropTypes.bool,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});

const _excluded$E = ["in", "children", "cssModule", "slide", "tag", "className"];

class CarouselItem extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = {
      startAnimation: false
    };
    this.onEnter = this.onEnter.bind(this);
    this.onEntering = this.onEntering.bind(this);
    this.onExit = this.onExit.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
  }

  onEnter(node, isAppearing) {
    this.setState({
      startAnimation: false
    });
    this.props.onEnter(node, isAppearing);
  }

  onEntering(node, isAppearing) {
    // getting this variable triggers a reflow
    const offsetHeight = node.offsetHeight;
    this.setState({
      startAnimation: true
    });
    this.props.onEntering(node, isAppearing);
    return offsetHeight;
  }

  onExit(node) {
    this.setState({
      startAnimation: false
    });
    this.props.onExit(node);
  }

  onExiting(node) {
    this.setState({
      startAnimation: true
    });
    node.dispatchEvent(new CustomEvent('slide.bs.carousel'));
    this.props.onExiting(node);
  }

  onExited(node) {
    node.dispatchEvent(new CustomEvent('slid.bs.carousel'));
    this.props.onExited(node);
  }

  render() {
    const _this$props = this.props,
          {
      in: isIn,
      children,
      cssModule,
      slide,
      tag: Tag,
      className
    } = _this$props,
          transitionProps = _objectWithoutProperties$2(_this$props, _excluded$E);

    return /*#__PURE__*/React__default.createElement(Transition$1, _extends({}, transitionProps, {
      enter: slide,
      exit: slide,
      in: isIn,
      onEnter: this.onEnter,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }), status => {
      const {
        direction
      } = this.context;
      const isActive = status === TransitionStatuses.ENTERED || status === TransitionStatuses.EXITING;
      const directionClassName = (status === TransitionStatuses.ENTERING || status === TransitionStatuses.EXITING) && this.state.startAnimation && (direction === 'end' ? 'carousel-item-start' : 'carousel-item-end');
      const orderClassName = status === TransitionStatuses.ENTERING && (direction === 'end' ? 'carousel-item-next' : 'carousel-item-prev');
      const itemClasses = mapToCssModules(classNames$1(className, 'carousel-item', isActive && 'active', directionClassName, orderClassName), cssModule);
      return /*#__PURE__*/React__default.createElement(Tag, {
        className: itemClasses
      }, children);
    });
  }

}

CarouselItem.propTypes = _objectSpread2$3(_objectSpread2$3({}, Transition$1.propTypes), {}, {
  tag: tagPropType,
  in: PropTypes.bool,
  cssModule: PropTypes.object,
  children: PropTypes.node,
  slide: PropTypes.bool,
  className: PropTypes.string
});
CarouselItem.defaultProps = _objectSpread2$3(_objectSpread2$3({}, Transition$1.defaultProps), {}, {
  tag: 'div',
  timeout: TransitionTimeouts.Carousel,
  slide: true
});
CarouselItem.contextTypes = {
  direction: PropTypes.string
};
var CarouselItem$1 = CarouselItem;

/**
 * CarouselContext
 * {
 *  direction: PropTypes.oneOf(['start', 'end']).isRequired,
 * }
 */

const CarouselContext = React__default.createContext({});

const SWIPE_THRESHOLD = 40;

class Carousel extends React__default.Component {
  constructor(props) {
    super(props);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.renderItems = this.renderItems.bind(this);
    this.hoverStart = this.hoverStart.bind(this);
    this.hoverEnd = this.hoverEnd.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.state = {
      activeIndex: this.props.activeIndex,
      direction: 'end',
      indicatorClicked: false
    };
  }

  getContextValue() {
    return {
      direction: this.state.direction
    };
  }

  componentDidMount() {
    // Set up the cycle
    if (this.props.ride === 'carousel') {
      this.setInterval();
    } // TODO: move this to the specific carousel like bootstrap. Currently it will trigger ALL carousels on the page.


    document.addEventListener('keyup', this.handleKeyPress);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let newState = null;
    let {
      activeIndex,
      direction,
      indicatorClicked
    } = prevState;

    if (nextProps.activeIndex !== activeIndex) {
      // Calculate the direction to turn
      if (nextProps.activeIndex === activeIndex + 1) {
        direction = 'end';
      } else if (nextProps.activeIndex === activeIndex - 1) {
        direction = 'start';
      } else if (nextProps.activeIndex < activeIndex) {
        direction = indicatorClicked ? 'start' : 'end';
      } else if (nextProps.activeIndex !== activeIndex) {
        direction = indicatorClicked ? 'end' : 'start';
      }

      newState = {
        activeIndex: nextProps.activeIndex,
        direction,
        indicatorClicked: false
      };
    }

    return newState;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.activeIndex === this.state.activeIndex) return;
    this.setInterval(this.props);
  }

  componentWillUnmount() {
    this.clearInterval();
    document.removeEventListener('keyup', this.handleKeyPress);
  }

  setInterval(props = this.props) {
    // make sure not to have multiple intervals going...
    this.clearInterval();

    if (props.interval) {
      this.cycleInterval = setInterval(() => {
        props.next();
      }, parseInt(props.interval, 10));
    }
  }

  clearInterval() {
    clearInterval(this.cycleInterval);
  }

  hoverStart(...args) {
    if (this.props.pause === 'hover') {
      this.clearInterval();
    }

    if (this.props.mouseEnter) {
      this.props.mouseEnter(...args);
    }
  }

  hoverEnd(...args) {
    if (this.props.pause === 'hover') {
      this.setInterval();
    }

    if (this.props.mouseLeave) {
      this.props.mouseLeave(...args);
    }
  }

  handleKeyPress(evt) {
    if (this.props.keyboard) {
      if (evt.keyCode === 37) {
        this.props.previous();
      } else if (evt.keyCode === 39) {
        this.props.next();
      }
    }
  }

  handleTouchStart(e) {
    if (!this.props.enableTouch) {
      return;
    }

    this.touchStartX = e.changedTouches[0].screenX;
    this.touchStartY = e.changedTouches[0].screenY;
  }

  handleTouchEnd(e) {
    if (!this.props.enableTouch) {
      return;
    }

    const currentX = e.changedTouches[0].screenX;
    const currentY = e.changedTouches[0].screenY;
    const diffX = Math.abs(this.touchStartX - currentX);
    const diffY = Math.abs(this.touchStartY - currentY); // Don't swipe if Y-movement is bigger than X-movement

    if (diffX < diffY) {
      return;
    }

    if (diffX < SWIPE_THRESHOLD) {
      return;
    }

    if (currentX < this.touchStartX) {
      this.props.next();
    } else {
      this.props.previous();
    }
  }

  renderItems(carouselItems, className) {
    const {
      slide
    } = this.props;
    return /*#__PURE__*/React__default.createElement("div", {
      className: className
    }, carouselItems.map((item, index) => {
      const isIn = index === this.state.activeIndex;
      return React__default.cloneElement(item, {
        in: isIn,
        slide: slide
      });
    }));
  }

  render() {
    const {
      cssModule,
      slide,
      className,
      dark,
      fade
    } = this.props;
    const outerClasses = mapToCssModules(classNames$1(className, 'carousel', fade, slide && 'slide', dark && 'carousel-dark'), cssModule);
    const innerClasses = mapToCssModules(classNames$1('carousel-inner'), cssModule); // filter out booleans, null, or undefined

    const children = this.props.children.filter(child => child !== null && child !== undefined && typeof child !== 'boolean');
    const slidesOnly = children.every(child => child.type === CarouselItem$1); // Rendering only slides

    if (slidesOnly) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: outerClasses,
        onMouseEnter: this.hoverStart,
        onMouseLeave: this.hoverEnd
      }, /*#__PURE__*/React__default.createElement(CarouselContext.Provider, {
        value: this.getContextValue()
      }, this.renderItems(children, innerClasses)));
    } // Rendering slides and controls


    if (children[0] instanceof Array) {
      const _carouselItems = children[0];
      const _controlLeft = children[1];
      const _controlRight = children[2];
      return /*#__PURE__*/React__default.createElement("div", {
        className: outerClasses,
        onMouseEnter: this.hoverStart,
        onMouseLeave: this.hoverEnd
      }, /*#__PURE__*/React__default.createElement(CarouselContext.Provider, {
        value: this.getContextValue()
      }, this.renderItems(_carouselItems, innerClasses), _controlLeft, _controlRight));
    } // Rendering indicators, slides and controls


    const indicators = children[0];

    const wrappedOnClick = e => {
      if (typeof indicators.props.onClickHandler === 'function') {
        this.setState({
          indicatorClicked: true
        }, () => indicators.props.onClickHandler(e));
      }
    };

    const wrappedIndicators = React__default.cloneElement(indicators, {
      onClickHandler: wrappedOnClick
    });
    const carouselItems = children[1];
    const controlLeft = children[2];
    const controlRight = children[3];
    return /*#__PURE__*/React__default.createElement("div", {
      className: outerClasses,
      onMouseEnter: this.hoverStart,
      onMouseLeave: this.hoverEnd,
      onTouchStart: this.handleTouchStart,
      onTouchEnd: this.handleTouchEnd
    }, /*#__PURE__*/React__default.createElement(CarouselContext.Provider, {
      value: this.getContextValue()
    }, wrappedIndicators, this.renderItems(carouselItems, innerClasses), controlLeft, controlRight));
  }

}

Carousel.propTypes = {
  // the current active slide of the carousel
  activeIndex: PropTypes.number,
  // a function which should advance the carousel to the next slide (via activeIndex)
  next: PropTypes.func.isRequired,
  // a function which should advance the carousel to the previous slide (via activeIndex)
  previous: PropTypes.func.isRequired,
  // controls if the left and right arrow keys should control the carousel
  keyboard: PropTypes.bool,

  /* If set to "hover", pauses the cycling of the carousel on mouseenter and resumes the cycling of the carousel on
   * mouseleave. If set to false, hovering over the carousel won't pause it. (default: "hover")
   */
  pause: PropTypes.oneOf(['hover', false]),
  // Autoplays the carousel after the user manually cycles the first item. If "carousel", autoplays the carousel on load.
  // This is how bootstrap defines it... I would prefer a bool named autoplay or something...
  ride: PropTypes.oneOf(['carousel']),
  // the interval at which the carousel automatically cycles (default: 5000)
  // eslint-disable-next-line react/no-unused-prop-types
  interval: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
  children: PropTypes.array,
  // called when the mouse enters the Carousel
  mouseEnter: PropTypes.func,
  // called when the mouse exits the Carousel
  mouseLeave: PropTypes.func,
  // controls whether the slide animation on the Carousel works or not
  slide: PropTypes.bool,
  // make the controls, indicators and captions dark on the Carousel
  dark: PropTypes.bool,
  cssModule: PropTypes.object,
  className: PropTypes.string,
  enableTouch: PropTypes.bool
};
Carousel.defaultProps = {
  interval: 5000,
  pause: 'hover',
  keyboard: true,
  slide: true,
  enableTouch: true,
  fade: false
};
Carousel.childContextTypes = {
  direction: PropTypes.string
};
var Carousel$1 = Carousel;

const CarouselControl = props => {
  const {
    direction,
    onClickHandler,
    cssModule,
    directionText,
    className
  } = props;
  const anchorClasses = mapToCssModules(classNames$1(className, `carousel-control-${direction}`), cssModule);
  const iconClasses = mapToCssModules(classNames$1(`carousel-control-${direction}-icon`), cssModule);
  const screenReaderClasses = mapToCssModules(classNames$1('visually-hidden'), cssModule);
  return (
    /*#__PURE__*/
    // We need to disable this linting rule to use an `<a>` instead of
    // `<button>` because that's what the Bootstrap examples require:
    // https://getbootstrap.com/docs/4.5/components/carousel/#with-controls
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    React__default.createElement("a", {
      className: anchorClasses,
      style: {
        cursor: "pointer"
      },
      role: "button",
      tabIndex: "0",
      onClick: e => {
        e.preventDefault();
        onClickHandler();
      }
    }, /*#__PURE__*/React__default.createElement("span", {
      className: iconClasses,
      "aria-hidden": "true"
    }), /*#__PURE__*/React__default.createElement("span", {
      className: screenReaderClasses
    }, directionText || direction))
  );
};

CarouselControl.propTypes = {
  direction: PropTypes.oneOf(['prev', 'next']).isRequired,
  onClickHandler: PropTypes.func.isRequired,
  cssModule: PropTypes.object,
  directionText: PropTypes.string,
  className: PropTypes.string
};
var CarouselControl$1 = CarouselControl;

const CarouselIndicators = props => {
  const {
    items,
    activeIndex,
    cssModule,
    onClickHandler,
    className
  } = props;
  const listClasses = mapToCssModules(classNames$1(className, 'carousel-indicators'), cssModule);
  const indicators = items.map((item, idx) => {
    const indicatorClasses = mapToCssModules(classNames$1({
      active: activeIndex === idx
    }), cssModule);
    return /*#__PURE__*/React__default.createElement("button", {
      "aria-label": item.caption,
      "data-bs-target": true,
      key: `${item.key || Object.values(item).join('')}`,
      onClick: e => {
        e.preventDefault();
        onClickHandler(idx);
      },
      className: indicatorClasses
    }, item.caption);
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: listClasses
  }, indicators);
};

CarouselIndicators.propTypes = {
  items: PropTypes.array.isRequired,
  activeIndex: PropTypes.number.isRequired,
  cssModule: PropTypes.object,
  onClickHandler: PropTypes.func.isRequired,
  className: PropTypes.string
};
var CarouselIndicators$1 = CarouselIndicators;

const CarouselCaption = props => {
  const {
    captionHeader,
    captionText,
    cssModule,
    className
  } = props;
  const classes = mapToCssModules(classNames$1(className, 'carousel-caption', 'd-none', 'd-md-block'), cssModule);
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes
  }, /*#__PURE__*/React__default.createElement("h3", null, captionHeader), /*#__PURE__*/React__default.createElement("p", null, captionText));
};

CarouselCaption.propTypes = {
  captionHeader: PropTypes.node,
  captionText: PropTypes.node.isRequired,
  cssModule: PropTypes.object,
  className: PropTypes.string
};
var CarouselCaption$1 = CarouselCaption;

const _excluded$D = ["defaultActiveIndex", "autoPlay", "indicators", "controls", "items", "goToIndex"];
const propTypes$J = {
  items: PropTypes.array.isRequired,
  indicators: PropTypes.bool,
  controls: PropTypes.bool,
  autoPlay: PropTypes.bool,
  defaultActiveIndex: PropTypes.number,
  activeIndex: PropTypes.number,
  next: PropTypes.func,
  previous: PropTypes.func,
  goToIndex: PropTypes.func
};

class UncontrolledCarousel extends Component {
  constructor(props) {
    super(props);
    this.animating = false;
    this.state = {
      activeIndex: props.defaultActiveIndex || 0
    };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goToIndex = this.goToIndex.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
  }

  onExiting() {
    this.animating = true;
  }

  onExited() {
    this.animating = false;
  }

  next() {
    if (this.animating) return;
    const nextIndex = this.state.activeIndex === this.props.items.length - 1 ? 0 : this.state.activeIndex + 1;
    this.setState({
      activeIndex: nextIndex
    });
  }

  previous() {
    if (this.animating) return;
    const nextIndex = this.state.activeIndex === 0 ? this.props.items.length - 1 : this.state.activeIndex - 1;
    this.setState({
      activeIndex: nextIndex
    });
  }

  goToIndex(newIndex) {
    if (this.animating) return;
    this.setState({
      activeIndex: newIndex
    });
  }

  render() {
    const _this$props = this.props,
          {
      defaultActiveIndex,
      autoPlay,
      indicators,
      controls,
      items,
      goToIndex
    } = _this$props,
          props = _objectWithoutProperties$2(_this$props, _excluded$D);

    const {
      activeIndex
    } = this.state;
    const slides = items.map(item => {
      const key = item.key || item.src;
      return /*#__PURE__*/React__default.createElement(CarouselItem$1, {
        onExiting: this.onExiting,
        onExited: this.onExited,
        key: key
      }, /*#__PURE__*/React__default.createElement("img", {
        className: "d-block w-100",
        src: item.src,
        alt: item.altText
      }), /*#__PURE__*/React__default.createElement(CarouselCaption$1, {
        captionText: item.caption,
        captionHeader: item.header || item.caption
      }));
    });
    return /*#__PURE__*/React__default.createElement(Carousel$1, _extends({
      activeIndex: activeIndex,
      next: this.next,
      previous: this.previous,
      ride: autoPlay ? 'carousel' : undefined
    }, props), indicators && /*#__PURE__*/React__default.createElement(CarouselIndicators$1, {
      items: items,
      activeIndex: props.activeIndex || activeIndex,
      onClickHandler: goToIndex || this.goToIndex
    }), slides, controls && /*#__PURE__*/React__default.createElement(CarouselControl$1, {
      direction: "prev",
      directionText: "Previous",
      onClickHandler: props.previous || this.previous
    }), controls && /*#__PURE__*/React__default.createElement(CarouselControl$1, {
      direction: "next",
      directionText: "Next",
      onClickHandler: props.next || this.next
    }));
  }

}

UncontrolledCarousel.propTypes = propTypes$J;
UncontrolledCarousel.defaultProps = {
  controls: true,
  indicators: true,
  autoPlay: true
};
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});

const _excluded$z = ["cssModule", "children", "isOpen", "flip", "target", "offset", "fallbackPlacements", "placementPrefix", "arrowClassName", "hideArrow", "popperClassName", "tag", "container", "modifiers", "strategy", "boundariesElement", "onClosed", "fade", "transition", "placement"];

function noop$2$1() {}

const propTypes$F = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  popperClassName: PropTypes.string,
  placement: PropTypes.string,
  placementPrefix: PropTypes.string,
  arrowClassName: PropTypes.string,
  hideArrow: PropTypes.bool,
  tag: tagPropType,
  isOpen: PropTypes.bool.isRequired,
  cssModule: PropTypes.object,
  offset: PropTypes.arrayOf(PropTypes.number),
  fallbackPlacements: PropTypes.array,
  flip: PropTypes.bool,
  container: targetPropType,
  target: targetPropType.isRequired,
  modifiers: PropTypes.array,
  strategy: PropTypes.string,
  boundariesElement: PropTypes.oneOfType([PropTypes.string, DOMElement]),
  onClosed: PropTypes.func,
  fade: PropTypes.bool,
  transition: PropTypes.shape(Fade.propTypes)
};
const defaultProps$F = {
  boundariesElement: 'scrollParent',
  placement: 'auto',
  hideArrow: false,
  isOpen: false,
  offset: [0, 0],
  flip: true,
  container: 'body',
  modifiers: [],
  onClosed: noop$2$1,
  fade: true,
  transition: _objectSpread2$3({}, Fade.defaultProps)
};

class PopperContent extends React__default.Component {
  constructor(props) {
    super(props);
    this.setTargetNode = this.setTargetNode.bind(this);
    this.getTargetNode = this.getTargetNode.bind(this);
    this.getRef = this.getRef.bind(this);
    this.onClosed = this.onClosed.bind(this);
    this.state = {
      isOpen: props.isOpen
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.isOpen && !state.isOpen) {
      return {
        isOpen: props.isOpen
      };
    } else return null;
  }

  componentDidUpdate() {
    if (this._element && this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) {
      this._element.childNodes[0].focus();
    }
  }

  setTargetNode(node) {
    this.targetNode = typeof node === 'string' ? getTarget(node) : node;
  }

  getTargetNode() {
    return this.targetNode;
  }

  getContainerNode() {
    return getTarget(this.props.container);
  }

  getRef(ref) {
    this._element = ref;
  }

  onClosed() {
    this.props.onClosed();
    this.setState({
      isOpen: false
    });
  }

  renderChildren() {
    const _this$props = this.props,
          {
      cssModule,
      children,
      isOpen,
      flip,
      target,
      offset,
      fallbackPlacements,
      placementPrefix,
      arrowClassName: _arrowClassName,
      hideArrow,
      popperClassName: _popperClassName,
      tag,
      container,
      modifiers,
      strategy,
      boundariesElement,
      onClosed,
      fade,
      transition,
      placement
    } = _this$props,
          attrs = _objectWithoutProperties$2(_this$props, _excluded$z);

    const arrowClassName = mapToCssModules(classNames$1('arrow', _arrowClassName), cssModule);
    const popperClassName = mapToCssModules(classNames$1(_popperClassName, placementPrefix ? `${placementPrefix}-auto` : ''), this.props.cssModule);
    const modifierNames = modifiers.map(m => m.name);
    const baseModifiers = [{
      name: 'offset',
      options: {
        offset
      }
    }, {
      name: 'flip',
      enabled: flip,
      options: {
        fallbackPlacements
      }
    }, {
      name: 'preventOverflow',
      options: {
        boundary: boundariesElement
      }
    }].filter(m => !modifierNames.includes(m.name));
    const extendedModifiers = [...baseModifiers, ...modifiers];

    const popperTransition = _objectSpread2$3(_objectSpread2$3(_objectSpread2$3({}, Fade.defaultProps), transition), {}, {
      baseClass: fade ? transition.baseClass : '',
      timeout: fade ? transition.timeout : 0
    });

    return /*#__PURE__*/React__default.createElement(Fade, _extends({}, popperTransition, attrs, {
      in: isOpen,
      onExited: this.onClosed,
      tag: tag
    }), /*#__PURE__*/React__default.createElement(Popper, {
      referenceElement: this.targetNode,
      modifiers: extendedModifiers,
      placement: placement,
      strategy: strategy
    }, ({
      ref,
      style,
      placement: popperPlacement,
      isReferenceHidden,
      arrowProps,
      update
    }) => /*#__PURE__*/React__default.createElement("div", {
      ref: ref,
      style: style,
      className: popperClassName,
      "data-popper-placement": popperPlacement,
      "data-popper-reference-hidden": isReferenceHidden ? 'true' : undefined
    }, typeof children === 'function' ? children({
      update
    }) : children, !hideArrow && /*#__PURE__*/React__default.createElement("span", {
      ref: arrowProps.ref,
      className: arrowClassName,
      style: arrowProps.style
    }))));
  }

  render() {
    this.setTargetNode(this.props.target);

    if (this.state.isOpen) {
      return this.props.container === 'inline' ? this.renderChildren() : ReactDOM.createPortal( /*#__PURE__*/React__default.createElement("div", {
        ref: this.getRef
      }, this.renderChildren()), this.getContainerNode());
    }

    return null;
  }

}

PopperContent.propTypes = propTypes$F;
PopperContent.defaultProps = defaultProps$F;
var PopperContent$1 = PopperContent;

({
  popperManager: PropTypes.object.isRequired
});
({
  target: targetPropType.isRequired
});

const propTypes$E = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  placement: PropTypes.oneOf(PopperPlacements),
  target: targetPropType.isRequired,
  container: targetPropType,
  isOpen: PropTypes.bool,
  disabled: PropTypes.bool,
  hideArrow: PropTypes.bool,
  boundariesElement: PropTypes.oneOfType([PropTypes.string, DOMElement]),
  className: PropTypes.string,
  innerClassName: PropTypes.string,
  arrowClassName: PropTypes.string,
  popperClassName: PropTypes.string,
  cssModule: PropTypes.object,
  toggle: PropTypes.func,
  autohide: PropTypes.bool,
  placementPrefix: PropTypes.string,
  delay: PropTypes.oneOfType([PropTypes.shape({
    show: PropTypes.number,
    hide: PropTypes.number
  }), PropTypes.number]),
  modifiers: PropTypes.array,
  strategy: PropTypes.string,
  offset: PropTypes.arrayOf(PropTypes.number),
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.object]),
  trigger: PropTypes.string,
  fade: PropTypes.bool,
  flip: PropTypes.bool
};
const DEFAULT_DELAYS = {
  show: 0,
  hide: 50
};
const defaultProps$E = {
  isOpen: false,
  hideArrow: false,
  autohide: false,
  delay: DEFAULT_DELAYS,
  toggle: function () {},
  trigger: 'click',
  fade: true
};

function isInDOMSubtree(element, subtreeRoot) {
  return subtreeRoot && (element === subtreeRoot || subtreeRoot.contains(element));
}

function isInDOMSubtrees(element, subtreeRoots = []) {
  return subtreeRoots && subtreeRoots.length && subtreeRoots.filter(subTreeRoot => isInDOMSubtree(element, subTreeRoot))[0];
}

class TooltipPopoverWrapper extends React__default.Component {
  constructor(props) {
    super(props);
    this._targets = [];
    this.currentTargetElement = null;
    this.addTargetEvents = this.addTargetEvents.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.removeTargetEvents = this.removeTargetEvents.bind(this);
    this.toggle = this.toggle.bind(this);
    this.showWithDelay = this.showWithDelay.bind(this);
    this.hideWithDelay = this.hideWithDelay.bind(this);
    this.onMouseOverTooltipContent = this.onMouseOverTooltipContent.bind(this);
    this.onMouseLeaveTooltipContent = this.onMouseLeaveTooltipContent.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.onEscKeyDown = this.onEscKeyDown.bind(this);
    this.getRef = this.getRef.bind(this);
    this.state = {
      isOpen: props.isOpen
    };
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    this.updateTarget();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.removeTargetEvents();
    this._targets = null;
    this.clearShowTimeout();
    this.clearHideTimeout();
  }

  static getDerivedStateFromProps(props, state) {
    if (props.isOpen && !state.isOpen) {
      return {
        isOpen: props.isOpen
      };
    } else return null;
  }

  onMouseOverTooltipContent() {
    if (this.props.trigger.indexOf('hover') > -1 && !this.props.autohide) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }

      if (this.state.isOpen && !this.props.isOpen) {
        this.toggle();
      }
    }
  }

  onMouseLeaveTooltipContent(e) {
    if (this.props.trigger.indexOf('hover') > -1 && !this.props.autohide) {
      if (this._showTimeout) {
        this.clearShowTimeout();
      }

      e.persist();
      this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
    }
  }

  onEscKeyDown(e) {
    if (e.key === 'Escape') {
      this.hide(e);
    }
  }

  getRef(ref) {
    const {
      innerRef
    } = this.props;

    if (innerRef) {
      if (typeof innerRef === 'function') {
        innerRef(ref);
      } else if (typeof innerRef === 'object') {
        innerRef.current = ref;
      }
    }

    this._popover = ref;
  }

  getDelay(key) {
    const {
      delay
    } = this.props;

    if (typeof delay === 'object') {
      return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
    }

    return delay;
  }

  getCurrentTarget(target) {
    if (!target) return null;

    const index = this._targets.indexOf(target);

    if (index >= 0) return this._targets[index];
    return this.getCurrentTarget(target.parentElement);
  }

  show(e) {
    if (!this.props.isOpen) {
      this.clearShowTimeout();
      this.currentTargetElement = e ? e.currentTarget || this.getCurrentTarget(e.target) : null;

      if (e && e.composedPath && typeof e.composedPath === 'function') {
        const path = e.composedPath();
        this.currentTargetElement = path && path[0] || this.currentTargetElement;
      }

      this.toggle(e);
    }
  }

  showWithDelay(e) {
    if (this._hideTimeout) {
      this.clearHideTimeout();
    }

    this._showTimeout = setTimeout(this.show.bind(this, e), this.getDelay('show'));
  }

  hide(e) {
    if (this.props.isOpen) {
      this.clearHideTimeout();
      this.currentTargetElement = null;
      this.toggle(e);
    }
  }

  hideWithDelay(e) {
    if (this._showTimeout) {
      this.clearShowTimeout();
    }

    this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
  }

  clearShowTimeout() {
    clearTimeout(this._showTimeout);
    this._showTimeout = undefined;
  }

  clearHideTimeout() {
    clearTimeout(this._hideTimeout);
    this._hideTimeout = undefined;
  }

  handleDocumentClick(e) {
    const triggers = this.props.trigger.split(' ');

    if (triggers.indexOf('legacy') > -1 && (this.props.isOpen || isInDOMSubtrees(e.target, this._targets))) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }

      if (this.props.isOpen && !isInDOMSubtree(e.target, this._popover)) {
        this.hideWithDelay(e);
      } else if (!this.props.isOpen) {
        this.showWithDelay(e);
      }
    } else if (triggers.indexOf('click') > -1 && isInDOMSubtrees(e.target, this._targets)) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }

      if (!this.props.isOpen) {
        this.showWithDelay(e);
      } else {
        this.hideWithDelay(e);
      }
    }
  }

  addEventOnTargets(type, handler, isBubble) {
    this._targets.forEach(target => {
      target.addEventListener(type, handler, isBubble);
    });
  }

  removeEventOnTargets(type, handler, isBubble) {
    this._targets.forEach(target => {
      target.removeEventListener(type, handler, isBubble);
    });
  }

  addTargetEvents() {
    if (this.props.trigger) {
      let triggers = this.props.trigger.split(' ');

      if (triggers.indexOf('manual') === -1) {
        if (triggers.indexOf('click') > -1 || triggers.indexOf('legacy') > -1) {
          document.addEventListener('click', this.handleDocumentClick, true);
        }

        if (this._targets && this._targets.length) {
          if (triggers.indexOf('hover') > -1) {
            this.addEventOnTargets('mouseover', this.showWithDelay, true);
            this.addEventOnTargets('mouseout', this.hideWithDelay, true);
          }

          if (triggers.indexOf('focus') > -1) {
            this.addEventOnTargets('focusin', this.show, true);
            this.addEventOnTargets('focusout', this.hide, true);
          }

          this.addEventOnTargets('keydown', this.onEscKeyDown, true);
        }
      }
    }
  }

  removeTargetEvents() {
    if (this._targets) {
      this.removeEventOnTargets('mouseover', this.showWithDelay, true);
      this.removeEventOnTargets('mouseout', this.hideWithDelay, true);
      this.removeEventOnTargets('keydown', this.onEscKeyDown, true);
      this.removeEventOnTargets('focusin', this.show, true);
      this.removeEventOnTargets('focusout', this.hide, true);
    }

    document.removeEventListener('click', this.handleDocumentClick, true);
  }

  updateTarget() {
    const newTarget = getTarget(this.props.target, true);

    if (newTarget !== this._targets) {
      this.removeTargetEvents();
      this._targets = newTarget ? Array.from(newTarget) : [];
      this.currentTargetElement = this.currentTargetElement || this._targets[0];
      this.addTargetEvents();
    }
  }

  toggle(e) {
    if (this.props.disabled || !this._isMounted) {
      return e && e.preventDefault();
    }

    return this.props.toggle(e);
  }

  render() {
    if (this.props.isOpen) {
      this.updateTarget();
    }

    const target = this.currentTargetElement || this._targets[0];

    if (!target) {
      return null;
    }

    const {
      className,
      cssModule,
      innerClassName,
      isOpen,
      hideArrow,
      boundariesElement,
      placement,
      placementPrefix,
      arrowClassName,
      popperClassName,
      container,
      modifiers,
      strategy,
      offset,
      fade,
      flip,
      children
    } = this.props;
    const attributes = omit(this.props, Object.keys(propTypes$E));
    const popperClasses = mapToCssModules(popperClassName, cssModule);
    const classes = mapToCssModules(innerClassName, cssModule);
    return /*#__PURE__*/React__default.createElement(PopperContent$1, {
      className: className,
      target: target,
      isOpen: isOpen,
      hideArrow: hideArrow,
      boundariesElement: boundariesElement,
      placement: placement,
      placementPrefix: placementPrefix,
      arrowClassName: arrowClassName,
      popperClassName: popperClasses,
      container: container,
      modifiers: modifiers,
      strategy: strategy,
      offset: offset,
      cssModule: cssModule,
      fade: fade,
      flip: flip
    }, ({
      update
    }) => /*#__PURE__*/React__default.createElement("div", _extends({}, attributes, {
      ref: this.getRef,
      className: classes,
      role: "tooltip",
      onMouseOver: this.onMouseOverTooltipContent,
      onMouseLeave: this.onMouseLeaveTooltipContent,
      onKeyDown: this.onEscKeyDown
    }), typeof children === 'function' ? children({
      update
    }) : children));
  }

}

TooltipPopoverWrapper.propTypes = propTypes$E;
TooltipPopoverWrapper.defaultProps = defaultProps$E;
var TooltipPopoverWrapper$1 = TooltipPopoverWrapper;

const defaultProps$D = {
  placement: 'right',
  placementPrefix: 'bs-popover',
  trigger: 'click',
  offset: [0, 8]
};

const Popover$1 = props => {
  const popperClasses = classNames$1('popover', 'show', props.popperClassName);
  const classes = classNames$1('popover-inner', props.innerClassName);
  return /*#__PURE__*/React__default.createElement(TooltipPopoverWrapper$1, _extends({}, props, {
    arrowClassName: "popover-arrow",
    popperClassName: popperClasses,
    innerClassName: classes
  }));
};

Popover$1.propTypes = propTypes$E;
Popover$1.defaultProps = defaultProps$D;
var Popover$1$1 = Popover$1;

const omitKeys$4 = ['defaultOpen'];
class UncontrolledPopover extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.defaultOpen || false
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return /*#__PURE__*/React__default.createElement(Popover$1$1, _extends({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, omit(this.props, omitKeys$4)));
  }

}
UncontrolledPopover.propTypes = _objectSpread2$3({
  defaultOpen: PropTypes.bool
}, Popover$1$1.propTypes);
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  children: PropTypes.node,
  bar: PropTypes.bool,
  multi: PropTypes.bool,
  tag: tagPropType,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  animated: PropTypes.bool,
  striped: PropTypes.bool,
  color: PropTypes.string,
  className: PropTypes.string,
  barClassName: PropTypes.string,
  cssModule: PropTypes.object,
  style: PropTypes.object,
  barStyle: PropTypes.object,
  barAriaValueText: PropTypes.string,
  barAriaLabelledBy: PropTypes.string
});

const propTypes$A = {
  children: PropTypes.node.isRequired,
  node: PropTypes.any
};

class Portal extends React__default.Component {
  componentWillUnmount() {
    if (this.defaultNode) {
      document.body.removeChild(this.defaultNode);
    }

    this.defaultNode = null;
  }

  render() {
    if (!canUseDOM$1) {
      return null;
    }

    if (!this.props.node && !this.defaultNode) {
      this.defaultNode = document.createElement('div');
      document.body.appendChild(this.defaultNode);
    }

    return ReactDOM.createPortal(this.props.children, this.props.node || this.defaultNode);
  }

}

Portal.propTypes = propTypes$A;
var Portal$1 = Portal;

function noop$1$1() {}

const FadePropTypes$1 = PropTypes.shape(Fade.propTypes);
const propTypes$z = {
  isOpen: PropTypes.bool,
  autoFocus: PropTypes.bool,
  centered: PropTypes.bool,
  fullscreen: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['sm', 'md', 'lg', 'xl'])]),
  scrollable: PropTypes.bool,
  size: PropTypes.string,
  toggle: PropTypes.func,
  keyboard: PropTypes.bool,
  role: PropTypes.string,
  labelledBy: PropTypes.string,
  backdrop: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['static'])]),
  onEnter: PropTypes.func,
  onExit: PropTypes.func,
  onOpened: PropTypes.func,
  onClosed: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  wrapClassName: PropTypes.string,
  modalClassName: PropTypes.string,
  backdropClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  external: PropTypes.node,
  fade: PropTypes.bool,
  cssModule: PropTypes.object,
  zIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  backdropTransition: FadePropTypes$1,
  modalTransition: FadePropTypes$1,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),
  unmountOnClose: PropTypes.bool,
  returnFocusAfterClose: PropTypes.bool,
  container: targetPropType,
  trapFocus: PropTypes.bool
};
const propsToOmit$1 = Object.keys(propTypes$z);
const defaultProps$z = {
  isOpen: false,
  autoFocus: true,
  centered: false,
  scrollable: false,
  role: 'dialog',
  backdrop: true,
  keyboard: true,
  zIndex: 1050,
  fade: true,
  onOpened: noop$1$1,
  onClosed: noop$1$1,
  modalTransition: {
    timeout: TransitionTimeouts.Modal
  },
  backdropTransition: {
    mountOnEnter: true,
    timeout: TransitionTimeouts.Fade // uses standard fade transition

  },
  unmountOnClose: true,
  returnFocusAfterClose: true,
  container: 'body',
  trapFocus: false
};

class Modal extends React__default.Component {
  constructor(props) {
    super(props);
    this._element = null;
    this._originalBodyPadding = null;
    this.getFocusableChildren = this.getFocusableChildren.bind(this);
    this.handleBackdropClick = this.handleBackdropClick.bind(this);
    this.handleBackdropMouseDown = this.handleBackdropMouseDown.bind(this);
    this.handleEscape = this.handleEscape.bind(this);
    this.handleStaticBackdropAnimation = this.handleStaticBackdropAnimation.bind(this);
    this.handleTab = this.handleTab.bind(this);
    this.onOpened = this.onOpened.bind(this);
    this.onClosed = this.onClosed.bind(this);
    this.manageFocusAfterClose = this.manageFocusAfterClose.bind(this);
    this.clearBackdropAnimationTimeout = this.clearBackdropAnimationTimeout.bind(this);
    this.trapFocus = this.trapFocus.bind(this);
    this.state = {
      isOpen: false,
      showStaticBackdropAnimation: false
    };
  }

  componentDidMount() {
    const {
      isOpen,
      autoFocus,
      onEnter
    } = this.props;

    if (isOpen) {
      this.init();
      this.setState({
        isOpen: true
      });

      if (autoFocus) {
        this.setFocus();
      }
    }

    if (onEnter) {
      onEnter();
    } // traps focus inside the Modal, even if the browser address bar is focused


    document.addEventListener('focus', this.trapFocus, true);
    this._isMounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.init();
      this.setState({
        isOpen: true
      }); // let render() renders Modal Dialog first

      return;
    } // now Modal Dialog is rendered and we can refer this._element and this._dialog


    if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) {
      this.setFocus();
    }

    if (this._element && prevProps.zIndex !== this.props.zIndex) {
      this._element.style.zIndex = this.props.zIndex;
    }
  }

  componentWillUnmount() {
    this.clearBackdropAnimationTimeout();

    if (this.props.onExit) {
      this.props.onExit();
    }

    if (this._element) {
      this.destroy();

      if (this.props.isOpen || this.state.isOpen) {
        this.close();
      }
    }

    document.removeEventListener('focus', this.trapFocus, true);
    this._isMounted = false;
  }

  trapFocus(ev) {
    if (!this.props.trapFocus) {
      return;
    }

    if (!this._element) //element is not attached
      return;
    if (this._dialog && this._dialog.parentNode === ev.target) // initial focus when the Modal is opened
      return;
    if (this.modalIndex < Modal.openCount - 1) // last opened modal
      return;
    const children = this.getFocusableChildren();

    for (let i = 0; i < children.length; i++) {
      // focus is already inside the Modal
      if (children[i] === ev.target) return;
    }

    if (children.length > 0) {
      // otherwise focus the first focusable element in the Modal
      ev.preventDefault();
      ev.stopPropagation();
      children[0].focus();
    }
  }

  onOpened(node, isAppearing) {
    this.props.onOpened();
    (this.props.modalTransition.onEntered || noop$1$1)(node, isAppearing);
  }

  onClosed(node) {
    const {
      unmountOnClose
    } = this.props; // so all methods get called before it is unmounted

    this.props.onClosed();
    (this.props.modalTransition.onExited || noop$1$1)(node);

    if (unmountOnClose) {
      this.destroy();
    }

    this.close();

    if (this._isMounted) {
      this.setState({
        isOpen: false
      });
    }
  }

  setFocus() {
    if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === 'function') {
      this._dialog.parentNode.focus();
    }
  }

  getFocusableChildren() {
    return this._element.querySelectorAll(focusableElements.join(', '));
  }

  getFocusedChild() {
    let currentFocus;
    const focusableChildren = this.getFocusableChildren();

    try {
      currentFocus = document.activeElement;
    } catch (err) {
      currentFocus = focusableChildren[0];
    }

    return currentFocus;
  } // not mouseUp because scrollbar fires it, shouldn't close when user scrolls


  handleBackdropClick(e) {
    if (e.target === this._mouseDownElement) {
      e.stopPropagation();
      const backdrop = this._dialog ? this._dialog.parentNode : null;

      if (backdrop && e.target === backdrop && this.props.backdrop === 'static') {
        this.handleStaticBackdropAnimation();
      }

      if (!this.props.isOpen || this.props.backdrop !== true) return;

      if (backdrop && e.target === backdrop && this.props.toggle) {
        this.props.toggle(e);
      }
    }
  }

  handleTab(e) {
    if (e.which !== 9) return;
    if (this.modalIndex < Modal.openCount - 1) return; // last opened modal

    const focusableChildren = this.getFocusableChildren();
    const totalFocusable = focusableChildren.length;
    if (totalFocusable === 0) return;
    const currentFocus = this.getFocusedChild();
    let focusedIndex = 0;

    for (let i = 0; i < totalFocusable; i += 1) {
      if (focusableChildren[i] === currentFocus) {
        focusedIndex = i;
        break;
      }
    }

    if (e.shiftKey && focusedIndex === 0) {
      e.preventDefault();
      focusableChildren[totalFocusable - 1].focus();
    } else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
      e.preventDefault();
      focusableChildren[0].focus();
    }
  }

  handleBackdropMouseDown(e) {
    this._mouseDownElement = e.target;
  }

  handleEscape(e) {
    if (this.props.isOpen && e.keyCode === keyCodes.esc && this.props.toggle) {
      if (this.props.keyboard) {
        e.preventDefault();
        e.stopPropagation();
        this.props.toggle(e);
      } else if (this.props.backdrop === 'static') {
        e.preventDefault();
        e.stopPropagation();
        this.handleStaticBackdropAnimation();
      }
    }
  }

  handleStaticBackdropAnimation() {
    this.clearBackdropAnimationTimeout();
    this.setState({
      showStaticBackdropAnimation: true
    });
    this._backdropAnimationTimeout = setTimeout(() => {
      this.setState({
        showStaticBackdropAnimation: false
      });
    }, 100);
  }

  init() {
    try {
      this._triggeringElement = document.activeElement;
    } catch (err) {
      this._triggeringElement = null;
    }

    if (!this._element) {
      this._element = document.createElement('div');

      this._element.setAttribute('tabindex', '-1');

      this._element.style.position = 'relative';
      this._element.style.zIndex = this.props.zIndex;
      this._mountContainer = getTarget(this.props.container);

      this._mountContainer.appendChild(this._element);
    }

    this._originalBodyPadding = getOriginalBodyPadding();
    conditionallyUpdateScrollbar();

    if (Modal.openCount === 0) {
      document.body.className = classNames$1(document.body.className, mapToCssModules('modal-open', this.props.cssModule));
    }

    this.modalIndex = Modal.openCount;
    Modal.openCount += 1;
  }

  destroy() {
    if (this._element) {
      this._mountContainer.removeChild(this._element);

      this._element = null;
    }

    this.manageFocusAfterClose();
  }

  manageFocusAfterClose() {
    if (this._triggeringElement) {
      const {
        returnFocusAfterClose
      } = this.props;
      if (this._triggeringElement.focus && returnFocusAfterClose) this._triggeringElement.focus();
      this._triggeringElement = null;
    }
  }

  close() {
    if (Modal.openCount <= 1) {
      const modalOpenClassName = mapToCssModules('modal-open', this.props.cssModule); // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`

      const modalOpenClassNameRegex = new RegExp(`(^| )${modalOpenClassName}( |$)`);
      document.body.className = document.body.className.replace(modalOpenClassNameRegex, ' ').trim();
    }

    this.manageFocusAfterClose();
    Modal.openCount = Math.max(0, Modal.openCount - 1);
    setScrollbarWidth(this._originalBodyPadding);
  }

  renderModalDialog() {
    const attributes = omit(this.props, propsToOmit$1);
    const dialogBaseClass = 'modal-dialog';
    return /*#__PURE__*/React__default.createElement("div", _extends({}, attributes, {
      className: mapToCssModules(classNames$1(dialogBaseClass, this.props.className, {
        [`modal-${this.props.size}`]: this.props.size,
        [`${dialogBaseClass}-centered`]: this.props.centered,
        [`${dialogBaseClass}-scrollable`]: this.props.scrollable,
        'modal-fullscreen': this.props.fullscreen === true,
        [`modal-fullscreen-${this.props.fullscreen}-down`]: typeof this.props.fullscreen === 'string'
      }), this.props.cssModule),
      role: "document",
      ref: c => {
        this._dialog = c;
      }
    }), /*#__PURE__*/React__default.createElement("div", {
      className: mapToCssModules(classNames$1('modal-content', this.props.contentClassName), this.props.cssModule)
    }, this.props.children));
  }

  render() {
    const {
      unmountOnClose
    } = this.props;

    if (!!this._element && (this.state.isOpen || !unmountOnClose)) {
      const isModalHidden = !!this._element && !this.state.isOpen && !unmountOnClose;
      this._element.style.display = isModalHidden ? 'none' : 'block';
      const {
        wrapClassName,
        modalClassName,
        backdropClassName,
        cssModule,
        isOpen,
        backdrop,
        role,
        labelledBy,
        external,
        innerRef
      } = this.props;
      const modalAttributes = {
        onClick: this.handleBackdropClick,
        onMouseDown: this.handleBackdropMouseDown,
        onKeyUp: this.handleEscape,
        onKeyDown: this.handleTab,
        style: {
          display: 'block'
        },
        'aria-labelledby': labelledBy,
        role,
        tabIndex: '-1'
      };
      const hasTransition = this.props.fade;

      const modalTransition = _objectSpread2$3(_objectSpread2$3(_objectSpread2$3({}, Fade.defaultProps), this.props.modalTransition), {}, {
        baseClass: hasTransition ? this.props.modalTransition.baseClass : '',
        timeout: hasTransition ? this.props.modalTransition.timeout : 0
      });

      const backdropTransition = _objectSpread2$3(_objectSpread2$3(_objectSpread2$3({}, Fade.defaultProps), this.props.backdropTransition), {}, {
        baseClass: hasTransition ? this.props.backdropTransition.baseClass : '',
        timeout: hasTransition ? this.props.backdropTransition.timeout : 0
      });

      const Backdrop = backdrop && (hasTransition ? /*#__PURE__*/React__default.createElement(Fade, _extends({}, backdropTransition, {
        in: isOpen && !!backdrop,
        cssModule: cssModule,
        className: mapToCssModules(classNames$1('modal-backdrop', backdropClassName), cssModule)
      })) : /*#__PURE__*/React__default.createElement("div", {
        className: mapToCssModules(classNames$1('modal-backdrop', 'show', backdropClassName), cssModule)
      }));
      return /*#__PURE__*/React__default.createElement(Portal$1, {
        node: this._element
      }, /*#__PURE__*/React__default.createElement("div", {
        className: mapToCssModules(wrapClassName)
      }, /*#__PURE__*/React__default.createElement(Fade, _extends({}, modalAttributes, modalTransition, {
        in: isOpen,
        onEntered: this.onOpened,
        onExited: this.onClosed,
        cssModule: cssModule,
        className: mapToCssModules(classNames$1('modal', modalClassName, this.state.showStaticBackdropAnimation && 'modal-static'), cssModule),
        innerRef: innerRef
      }), external, this.renderModalDialog()), Backdrop));
    }

    return null;
  }

  clearBackdropAnimationTimeout() {
    if (this._backdropAnimationTimeout) {
      clearTimeout(this._backdropAnimationTimeout);
      this._backdropAnimationTimeout = undefined;
    }
  }

}

Modal.propTypes = propTypes$z;
Modal.defaultProps = defaultProps$z;
Modal.openCount = 0;
({
  tag: tagPropType,
  wrapTag: tagPropType,
  toggle: PropTypes.func,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  children: PropTypes.node,
  closeAriaLabel: PropTypes.string,
  close: PropTypes.object
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});

const defaultProps$v = {
  placement: 'top',
  autohide: true,
  placementPrefix: 'bs-tooltip',
  trigger: 'hover focus'
};

const Tooltip = props => {
  const popperClasses = classNames$1('tooltip', 'show', props.popperClassName);
  const classes = classNames$1('tooltip-inner', props.innerClassName);
  return /*#__PURE__*/React__default.createElement(TooltipPopoverWrapper$1, _extends({}, props, {
    arrowClassName: "tooltip-arrow",
    popperClassName: popperClasses,
    innerClassName: classes
  }));
};

Tooltip.propTypes = propTypes$E;
Tooltip.defaultProps = defaultProps$v;
var Tooltip$1 = Tooltip;
({
  className: PropTypes.string,
  cssModule: PropTypes.object,
  size: PropTypes.string,
  bordered: PropTypes.bool,
  borderless: PropTypes.bool,
  striped: PropTypes.bool,
  dark: PropTypes.bool,
  hover: PropTypes.bool,
  responsive: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  tag: tagPropType,
  responsiveTag: tagPropType,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.object])
});
({
  tag: tagPropType,
  flush: PropTypes.bool,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  horizontal: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  numbered: PropTypes.bool
});

const _excluded$q = ["className", "cssModule", "inline", "tag", "innerRef"];
const propTypes$t = {
  children: PropTypes.node,
  inline: PropTypes.bool,
  tag: tagPropType,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
  className: PropTypes.string,
  cssModule: PropTypes.object
};
const defaultProps$s = {
  tag: 'form'
};

class Form$1 extends Component {
  constructor(props) {
    super(props);
    this.getRef = this.getRef.bind(this);
    this.submit = this.submit.bind(this);
  }

  getRef(ref) {
    if (this.props.innerRef) {
      this.props.innerRef(ref);
    }

    this.ref = ref;
  }

  submit() {
    if (this.ref) {
      this.ref.submit();
    }
  }

  render() {
    const _this$props = this.props,
          {
      className,
      cssModule,
      inline,
      tag: Tag,
      innerRef
    } = _this$props,
          attributes = _objectWithoutProperties$2(_this$props, _excluded$q);

    const classes = mapToCssModules(classNames$1(className, inline ? 'form-inline' : false), cssModule);
    return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
      ref: innerRef,
      className: classes
    }));
  }

}

Form$1.propTypes = propTypes$t;
Form$1.defaultProps = defaultProps$s;
({
  children: PropTypes.node,
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  valid: PropTypes.bool,
  tooltip: PropTypes.bool
});
({
  children: PropTypes.node,
  row: PropTypes.bool,
  check: PropTypes.bool,
  switch: PropTypes.bool,
  inline: PropTypes.bool,
  floating: PropTypes.bool,
  disabled: PropTypes.bool,
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  children: PropTypes.node,
  inline: PropTypes.bool,
  tag: tagPropType,
  color: PropTypes.string,
  className: PropTypes.string,
  cssModule: PropTypes.object
});

const _excluded$m = ["className", "cssModule", "type", "bsSize", "valid", "invalid", "tag", "addon", "plaintext", "innerRef"];
const propTypes$p = {
  children: PropTypes.node,
  type: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  bsSize: PropTypes.string,
  valid: PropTypes.bool,
  invalid: PropTypes.bool,
  tag: tagPropType,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
  plaintext: PropTypes.bool,
  addon: PropTypes.bool,
  className: PropTypes.string,
  cssModule: PropTypes.object
};
const defaultProps$o = {
  type: 'text'
};

class Input$2 extends React__default.Component {
  constructor(props) {
    super(props);
    this.getRef = this.getRef.bind(this);
    this.focus = this.focus.bind(this);
  }

  getRef(ref) {
    if (this.props.innerRef) {
      this.props.innerRef(ref);
    }

    this.ref = ref;
  }

  focus() {
    if (this.ref) {
      this.ref.focus();
    }
  }

  render() {
    let _this$props = this.props,
        {
      className,
      cssModule,
      type,
      bsSize,
      valid,
      invalid,
      tag,
      addon,
      plaintext,
      innerRef
    } = _this$props,
        attributes = _objectWithoutProperties$2(_this$props, _excluded$m);

    const checkInput = ['switch', 'radio', 'checkbox'].indexOf(type) > -1;
    const isNotaNumber = new RegExp('\\D', 'g');
    const textareaInput = type === 'textarea';
    const selectInput = type === 'select';
    const rangeInput = type === 'range';
    let Tag = tag || (selectInput || textareaInput ? type : 'input');
    let formControlClass = 'form-control';

    if (plaintext) {
      formControlClass = `${formControlClass}-plaintext`;
      Tag = tag || 'input';
    } else if (rangeInput) {
      formControlClass = 'form-range';
    } else if (selectInput) {
      formControlClass = "form-select";
    } else if (checkInput) {
      if (addon) {
        formControlClass = null;
      } else {
        formControlClass = 'form-check-input';
      }
    }

    if (attributes.size && isNotaNumber.test(attributes.size)) {
      warnOnce('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
      bsSize = attributes.size;
      delete attributes.size;
    }

    const classes = mapToCssModules(classNames$1(className, invalid && 'is-invalid', valid && 'is-valid', bsSize ? selectInput ? `form-select-${bsSize}` : `form-control-${bsSize}` : false, formControlClass), cssModule);

    if (Tag === 'input' || tag && typeof tag === 'function') {
      attributes.type = type === 'switch' ? 'checkbox' : type;
    }

    if (attributes.children && !(plaintext || type === 'select' || typeof Tag !== 'string' || Tag === 'select')) {
      warnOnce(`Input with a type of "${type}" cannot have children. Please use "value"/"defaultValue" instead.`);
      delete attributes.children;
    }

    return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
      ref: innerRef,
      className: classes,
      "aria-invalid": invalid
    }));
  }

}

Input$2.propTypes = propTypes$p;
Input$2.defaultProps = defaultProps$o;
({
  tag: tagPropType,
  type: PropTypes.bool,
  size: PropTypes.string,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
const stringOrNumberProp = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
const columnProps = PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number, PropTypes.shape({
  size: stringOrNumberProp,
  order: stringOrNumberProp,
  offset: stringOrNumberProp
})]);
({
  children: PropTypes.node,
  hidden: PropTypes.bool,
  check: PropTypes.bool,
  size: PropTypes.string,
  for: PropTypes.string,
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  xxl: columnProps,
  widths: PropTypes.array
});
({
  body: PropTypes.bool,
  bottom: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  heading: PropTypes.bool,
  left: PropTypes.bool,
  list: PropTypes.bool,
  middle: PropTypes.bool,
  object: PropTypes.bool,
  right: PropTypes.bool,
  tag: tagPropType,
  top: PropTypes.bool
});

function noop$5() {}

const FadePropTypes = PropTypes.shape(Fade.propTypes);
const propTypes$k = {
  autoFocus: PropTypes.bool,
  backdrop: PropTypes.bool,
  backdropClassName: PropTypes.string,
  backdropTransition: FadePropTypes,
  children: PropTypes.node,
  className: PropTypes.string,
  container: targetPropType,
  cssModule: PropTypes.object,
  direction: PropTypes.oneOf(['start', 'end', 'bottom', 'top', 'left', 'right']),
  fade: PropTypes.bool,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),
  isOpen: PropTypes.bool,
  keyboard: PropTypes.bool,
  labelledBy: PropTypes.string,
  offcanvasTransition: FadePropTypes,
  onClosed: PropTypes.func,
  onEnter: PropTypes.func,
  onExit: PropTypes.func,
  onOpened: PropTypes.func,
  returnFocusAfterClose: PropTypes.bool,
  role: PropTypes.string,
  scrollable: PropTypes.bool,
  toggle: PropTypes.func,
  trapFocus: PropTypes.bool,
  unmountOnClose: PropTypes.bool,
  zIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
const propsToOmit = Object.keys(propTypes$k);
const defaultProps$k = {
  isOpen: false,
  autoFocus: true,
  direction: 'start',
  scrollable: false,
  role: 'dialog',
  backdrop: true,
  keyboard: true,
  zIndex: 1050,
  fade: true,
  onOpened: noop$5,
  onClosed: noop$5,
  offcanvasTransition: {
    timeout: TransitionTimeouts.Offcanvas
  },
  backdropTransition: {
    mountOnEnter: true,
    timeout: TransitionTimeouts.Fade // uses standard fade transition

  },
  unmountOnClose: true,
  returnFocusAfterClose: true,
  container: 'body',
  trapFocus: false
};

class Offcanvas extends React__default.Component {
  constructor(props) {
    super(props);
    this._element = null;
    this._originalBodyPadding = null;
    this.getFocusableChildren = this.getFocusableChildren.bind(this);
    this.handleBackdropClick = this.handleBackdropClick.bind(this);
    this.handleBackdropMouseDown = this.handleBackdropMouseDown.bind(this);
    this.handleEscape = this.handleEscape.bind(this);
    this.handleTab = this.handleTab.bind(this);
    this.onOpened = this.onOpened.bind(this);
    this.onClosed = this.onClosed.bind(this);
    this.manageFocusAfterClose = this.manageFocusAfterClose.bind(this);
    this.clearBackdropAnimationTimeout = this.clearBackdropAnimationTimeout.bind(this);
    this.trapFocus = this.trapFocus.bind(this);
    this.state = {
      isOpen: false
    };
  }

  componentDidMount() {
    const {
      isOpen,
      autoFocus,
      onEnter
    } = this.props;

    if (isOpen) {
      this.init();
      this.setState({
        isOpen: true
      });

      if (autoFocus) {
        this.setFocus();
      }
    }

    if (onEnter) {
      onEnter();
    } // traps focus inside the Offcanvas, even if the browser address bar is focused


    document.addEventListener('focus', this.trapFocus, true);
    this._isMounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.init();
      this.setState({
        isOpen: true
      });
      return;
    } // now Offcanvas Dialog is rendered and we can refer this._element and this._dialog


    if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) {
      this.setFocus();
    }

    if (this._element && prevProps.zIndex !== this.props.zIndex) {
      this._element.style.zIndex = this.props.zIndex;
    }
  }

  componentWillUnmount() {
    this.clearBackdropAnimationTimeout();

    if (this.props.onExit) {
      this.props.onExit();
    }

    if (this._element) {
      this.destroy();

      if (this.props.isOpen || this.state.isOpen) {
        this.close();
      }
    }

    document.removeEventListener('focus', this.trapFocus, true);
    this._isMounted = false;
  }

  trapFocus(ev) {
    if (!this.props.trapFocus) {
      return;
    }

    if (!this._element) //element is not attached
      return;
    if (this._dialog === ev.target) // initial focus when the Offcanvas is opened
      return;
    if (this.offcanvasIndex < Offcanvas.openCount - 1) // last opened offcanvas
      return;
    const children = this.getFocusableChildren();

    for (let i = 0; i < children.length; i++) {
      // focus is already inside the Offcanvas
      if (children[i] === ev.target) return;
    }

    if (children.length > 0) {
      // otherwise focus the first focusable element in the Offcanvas
      ev.preventDefault();
      ev.stopPropagation();
      children[0].focus();
    }
  }

  onOpened(node, isAppearing) {
    this.props.onOpened();
    (this.props.offcanvasTransition.onEntered || noop$5)(node, isAppearing);
  }

  onClosed(node) {
    const {
      unmountOnClose
    } = this.props; // so all methods get called before it is unmounted

    this.props.onClosed();
    (this.props.offcanvasTransition.onExited || noop$5)(node);

    if (unmountOnClose) {
      this.destroy();
    }

    this.close();

    if (this._isMounted) {
      this.setState({
        isOpen: false
      });
    }
  }

  setFocus() {
    if (this._dialog && typeof this._dialog.focus === 'function') {
      this._dialog.focus();
    }
  }

  getFocusableChildren() {
    return this._element.querySelectorAll(focusableElements.join(', '));
  }

  getFocusedChild() {
    let currentFocus;
    const focusableChildren = this.getFocusableChildren();

    try {
      currentFocus = document.activeElement;
    } catch (err) {
      currentFocus = focusableChildren[0];
    }

    return currentFocus;
  } // not mouseUp because scrollbar fires it, shouldn't close when user scrolls


  handleBackdropClick(e) {
    if (e.target === this._mouseDownElement) {
      e.stopPropagation();
      const backdrop = this._backdrop;
      if (!this.props.isOpen || this.props.backdrop !== true) return;

      if (backdrop && e.target === backdrop && this.props.toggle) {
        this.props.toggle(e);
      }
    }
  }

  handleTab(e) {
    if (e.which !== 9) return;
    if (this.offcanvasIndex < Offcanvas.openCount - 1) return; // last opened offcanvas

    const focusableChildren = this.getFocusableChildren();
    const totalFocusable = focusableChildren.length;
    if (totalFocusable === 0) return;
    const currentFocus = this.getFocusedChild();
    let focusedIndex = 0;

    for (let i = 0; i < totalFocusable; i += 1) {
      if (focusableChildren[i] === currentFocus) {
        focusedIndex = i;
        break;
      }
    }

    if (e.shiftKey && focusedIndex === 0) {
      e.preventDefault();
      focusableChildren[totalFocusable - 1].focus();
    } else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
      e.preventDefault();
      focusableChildren[0].focus();
    }
  }

  handleBackdropMouseDown(e) {
    this._mouseDownElement = e.target;
  }

  handleEscape(e) {
    if (this.props.isOpen && e.keyCode === keyCodes.esc && this.props.toggle) {
      if (this.props.keyboard) {
        e.preventDefault();
        e.stopPropagation();
        this.props.toggle(e);
      }
    }
  }

  init() {
    try {
      this._triggeringElement = document.activeElement;
    } catch (err) {
      this._triggeringElement = null;
    }

    if (!this._element) {
      this._element = document.createElement('div');

      this._element.setAttribute('tabindex', '-1');

      this._element.style.position = 'relative';
      this._element.style.zIndex = this.props.zIndex;
      this._mountContainer = getTarget(this.props.container);

      this._mountContainer.appendChild(this._element);
    }

    this._originalBodyPadding = getOriginalBodyPadding();
    conditionallyUpdateScrollbar();

    if (Offcanvas.openCount === 0 && this.props.backdrop && !this.props.scrollable) {
      document.body.style.overflow = 'hidden';
    }

    this.offcanvasIndex = Offcanvas.openCount;
    Offcanvas.openCount += 1;
  }

  destroy() {
    if (this._element) {
      this._mountContainer.removeChild(this._element);

      this._element = null;
    }

    this.manageFocusAfterClose();
  }

  manageFocusAfterClose() {
    if (this._triggeringElement) {
      const {
        returnFocusAfterClose
      } = this.props;
      if (this._triggeringElement.focus && returnFocusAfterClose) this._triggeringElement.focus();
      this._triggeringElement = null;
    }
  }

  close() {
    this.manageFocusAfterClose();
    Offcanvas.openCount = Math.max(0, Offcanvas.openCount - 1);
    document.body.style.overflow = null;
    setScrollbarWidth(this._originalBodyPadding);
  }

  render() {
    const {
      direction,
      unmountOnClose
    } = this.props;

    if (!!this._element && (this.state.isOpen || !unmountOnClose)) {
      const isOffcanvasHidden = !!this._element && !this.state.isOpen && !unmountOnClose;
      this._element.style.display = isOffcanvasHidden ? 'none' : 'block';
      const {
        className,
        backdropClassName,
        cssModule,
        isOpen,
        backdrop,
        role,
        labelledBy,
        style
      } = this.props;
      const offcanvasAttributes = {
        onKeyUp: this.handleEscape,
        onKeyDown: this.handleTab,
        'aria-labelledby': labelledBy,
        role,
        tabIndex: '-1'
      };
      const hasTransition = this.props.fade;

      const offcanvasTransition = _objectSpread2$3(_objectSpread2$3(_objectSpread2$3({}, Fade.defaultProps), this.props.offcanvasTransition), {}, {
        baseClass: hasTransition ? this.props.offcanvasTransition.baseClass : '',
        timeout: hasTransition ? this.props.offcanvasTransition.timeout : 0
      });

      const backdropTransition = _objectSpread2$3(_objectSpread2$3(_objectSpread2$3({}, Fade.defaultProps), this.props.backdropTransition), {}, {
        baseClass: hasTransition ? this.props.backdropTransition.baseClass : '',
        timeout: hasTransition ? this.props.backdropTransition.timeout : 0
      });

      const Backdrop = backdrop && (hasTransition ? /*#__PURE__*/React__default.createElement(Fade, _extends({}, backdropTransition, {
        in: isOpen && !!backdrop,
        innerRef: c => {
          this._backdrop = c;
        },
        cssModule: cssModule,
        className: mapToCssModules(classNames$1('offcanvas-backdrop', backdropClassName), cssModule),
        onClick: this.handleBackdropClick,
        onMouseDown: this.handleBackdropMouseDown
      })) : /*#__PURE__*/React__default.createElement("div", {
        className: mapToCssModules(classNames$1('offcanvas-backdrop', 'show', backdropClassName), cssModule),
        onClick: this.handleBackdropClick,
        onMouseDown: this.handleBackdropMouseDown
      }));
      const attributes = omit(this.props, propsToOmit);
      return /*#__PURE__*/React__default.createElement(Portal$1, {
        node: this._element
      }, /*#__PURE__*/React__default.createElement(Fade, _extends({}, attributes, offcanvasAttributes, offcanvasTransition, {
        in: isOpen,
        onEntered: this.onOpened,
        onExited: this.onClosed,
        cssModule: cssModule,
        className: mapToCssModules(classNames$1('offcanvas', className, `offcanvas-${direction}`), cssModule),
        innerRef: c => {
          this._dialog = c;
        },
        style: _objectSpread2$3(_objectSpread2$3({}, style), {}, {
          visibility: isOpen ? 'visible' : 'hidden'
        })
      }), this.props.children), Backdrop);
    }

    return null;
  }

  clearBackdropAnimationTimeout() {
    if (this._backdropAnimationTimeout) {
      clearTimeout(this._backdropAnimationTimeout);
      this._backdropAnimationTimeout = undefined;
    }
  }

}

Offcanvas.propTypes = propTypes$k;
Offcanvas.defaultProps = defaultProps$k;
Offcanvas.openCount = 0;
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
});
({
  children: PropTypes.node,
  className: PropTypes.string,
  close: PropTypes.object,
  closeAriaLabel: PropTypes.string,
  cssModule: PropTypes.object,
  tag: tagPropType,
  toggle: PropTypes.func,
  wrapTag: tagPropType
});
({
  children: PropTypes.node,
  className: PropTypes.string,
  listClassName: PropTypes.string,
  cssModule: PropTypes.object,
  size: PropTypes.string,
  tag: tagPropType,
  listTag: tagPropType,
  'aria-label': PropTypes.string
});
({
  active: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  disabled: PropTypes.bool,
  tag: tagPropType
});
({
  'aria-label': PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  next: PropTypes.bool,
  previous: PropTypes.bool,
  first: PropTypes.bool,
  last: PropTypes.bool,
  tag: tagPropType
});

/**
 * TabContext
 * {
 *  activeTabId: PropTypes.any
 * }
 */

const TabContext = React__default.createContext({});

const propTypes$e = {
  tag: tagPropType,
  activeTab: PropTypes.any,
  className: PropTypes.string,
  cssModule: PropTypes.object
};
const defaultProps$e = {
  tag: 'div'
};

class TabContent extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.activeTab !== nextProps.activeTab) {
      return {
        activeTab: nextProps.activeTab
      };
    }

    return null;
  }

  constructor(props) {
    super(props);
    this.state = {
      activeTab: this.props.activeTab
    };
  }

  render() {
    const {
      className,
      cssModule,
      tag: Tag
    } = this.props;
    const attributes = omit(this.props, Object.keys(propTypes$e));
    const classes = mapToCssModules(classNames$1('tab-content', className), cssModule);
    return /*#__PURE__*/React__default.createElement(TabContext.Provider, {
      value: {
        activeTabId: this.state.activeTab
      }
    }, /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
      className: classes
    })));
  }

}
TabContent.propTypes = propTypes$e;
TabContent.defaultProps = defaultProps$e;
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  tabId: PropTypes.any
});
({
  children: PropTypes.node,
  className: PropTypes.string,
  closeClassName: PropTypes.string,
  closeAriaLabel: PropTypes.string,
  cssModule: PropTypes.object,
  color: PropTypes.string,
  fade: PropTypes.bool,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  tag: tagPropType,
  transition: PropTypes.shape(Fade.propTypes),
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func])
});
({
  color: 'success',
  isOpen: true,
  tag: 'div',
  closeAriaLabel: 'Close',
  fade: true,
  transition: _objectSpread2$3(_objectSpread2$3({}, Fade.defaultProps), {}, {
    unmountOnExit: true
  })
});
({
  children: PropTypes.node,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  fade: PropTypes.bool,
  isOpen: PropTypes.bool,
  tag: tagPropType,
  transition: PropTypes.shape(Fade.propTypes),
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func])
});
({
  isOpen: true,
  tag: 'div',
  fade: true,
  transition: _objectSpread2$3(_objectSpread2$3({}, Fade.defaultProps), {}, {
    unmountOnExit: true
  })
});
({
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func])
});
({
  tag: tagPropType,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  wrapTag: tagPropType,
  toggle: PropTypes.func,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  children: PropTypes.node,
  closeAriaLabel: PropTypes.string,
  charCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  close: PropTypes.object
});
({
  tag: tagPropType,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  color: PropTypes.string,
  action: PropTypes.bool,
  className: PropTypes.any,
  cssModule: PropTypes.object
});
({
  tag: tagPropType,
  className: PropTypes.any,
  cssModule: PropTypes.object
});
({
  tag: tagPropType,
  className: PropTypes.any,
  cssModule: PropTypes.object
});

const _excluded$4$1 = ["className", "cssModule", "tag", "type"];
const propTypes$5 = {
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  type: PropTypes.string
};
const defaultProps$5 = {
  tag: 'ul'
};
const List$1 = forwardRef((props, ref) => {
  const {
    className,
    cssModule,
    tag: Tag,
    type
  } = props,
        attributes = _objectWithoutProperties$2(props, _excluded$4$1);

  const classes = mapToCssModules(classNames$1(className, type ? `list-${type}` : false), cssModule);
  return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
    className: classes,
    ref: ref
  }));
});
List$1.name = 'List';
List$1.propTypes = propTypes$5;
List$1.defaultProps = defaultProps$5;

const _excluded$3$2 = ["className", "cssModule", "tag"];
const propTypes$4 = {
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
};
const defaultProps$4 = {
  tag: 'li'
};
const ListInlineItem = forwardRef((props, ref) => {
  const {
    className,
    cssModule,
    tag: Tag
  } = props,
        attributes = _objectWithoutProperties$2(props, _excluded$3$2);

  const classes = mapToCssModules(classNames$1(className, 'list-inline-item'), cssModule);
  return /*#__PURE__*/React__default.createElement(Tag, _extends({}, attributes, {
    className: classes,
    ref: ref
  }));
});
ListInlineItem.name = 'ListInlineItem';
ListInlineItem.propTypes = propTypes$4;
ListInlineItem.defaultProps = defaultProps$4;

const omitKeys$3 = ['defaultOpen'];
class UncontrolledButtonDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.defaultOpen || false
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return /*#__PURE__*/React__default.createElement(ButtonDropdown$1, _extends({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, omit(this.props, omitKeys$3)));
  }

}
UncontrolledButtonDropdown.propTypes = _objectSpread2$3({
  defaultOpen: PropTypes.bool
}, ButtonDropdown$1.propTypes);

const omitKeys$2 = ['toggleEvents', 'defaultOpen'];
const propTypes$3 = {
  defaultOpen: PropTypes.bool,
  toggler: PropTypes.string.isRequired,
  toggleEvents: PropTypes.arrayOf(PropTypes.string)
};
const defaultProps$3 = {
  toggleEvents: defaultToggleEvents
};

class UncontrolledCollapse extends Component {
  constructor(props) {
    super(props);
    this.togglers = null;
    this.removeEventListeners = null;
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: props.defaultOpen || false
    };
  }

  componentDidMount() {
    this.togglers = findDOMElements(this.props.toggler);

    if (this.togglers.length) {
      this.removeEventListeners = addMultipleEventListeners(this.togglers, this.toggle, this.props.toggleEvents);
    }
  }

  componentWillUnmount() {
    if (this.togglers.length && this.removeEventListeners) {
      this.removeEventListeners();
    }
  }

  toggle(e) {
    this.setState(({
      isOpen
    }) => ({
      isOpen: !isOpen
    }));
    e.preventDefault();
  }

  render() {
    return /*#__PURE__*/React__default.createElement(Collapse$1$1, _extends({
      isOpen: this.state.isOpen
    }, omit(this.props, omitKeys$2)));
  }

}

UncontrolledCollapse.propTypes = propTypes$3;
UncontrolledCollapse.defaultProps = defaultProps$3;

const omitKeys$1 = ['defaultOpen'];
class UncontrolledDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.defaultOpen || false
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle(e) {
    const isOpen = !this.state.isOpen;
    this.setState({
      isOpen
    }, () => {
      if (this.props.onToggle) {
        this.props.onToggle(e, isOpen);
      }
    });
  }

  render() {
    return /*#__PURE__*/React__default.createElement(Dropdown$1$1, _extends({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, omit(this.props, omitKeys$1)));
  }

}
UncontrolledDropdown.propTypes = _objectSpread2$3({
  defaultOpen: PropTypes.bool,
  onToggle: PropTypes.func
}, Dropdown$1$1.propTypes);

const omitKeys = ['defaultOpen'];
class UncontrolledTooltip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.defaultOpen || false
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return /*#__PURE__*/React__default.createElement(Tooltip$1, _extends({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, omit(this.props, omitKeys)));
  }

}
UncontrolledTooltip.propTypes = _objectSpread2$3({
  defaultOpen: PropTypes.bool
}, Tooltip$1.propTypes);

const _excluded$2$2 = ["className", "cssModule", "type", "size", "color", "children", "tag"];
const propTypes$2 = {
  tag: tagPropType,
  type: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  children: PropTypes.string
};
const defaultProps$2 = {
  tag: 'div',
  type: 'border',
  children: 'Loading...'
};

const Spinner$1 = props => {
  const {
    className,
    cssModule,
    type,
    size,
    color,
    children,
    tag: Tag
  } = props,
        attributes = _objectWithoutProperties$2(props, _excluded$2$2);

  const classes = mapToCssModules(classNames$1(className, size ? `spinner-${type}-${size}` : false, `spinner-${type}`, color ? `text-${color}` : false), cssModule);
  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    role: "status"
  }, attributes, {
    className: classes
  }), children && /*#__PURE__*/React__default.createElement("span", {
    className: mapToCssModules('visually-hidden', cssModule)
  }, children));
};

Spinner$1.propTypes = propTypes$2;
Spinner$1.defaultProps = defaultProps$2;
var Spinner$1$1 = Spinner$1;

_objectSpread2$3(_objectSpread2$3({}, Col$1.propTypes), {}, {
  color: PropTypes.string,
  tag: tagPropType,
  animation: PropTypes.oneOf(['glow', 'wave']),
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
  size: PropTypes.oneOf(['lg', 'sm', 'xs'])
});
({
  size: PropTypes.string,
  color: PropTypes.string,
  outline: PropTypes.bool,
  className: PropTypes.string,
  tag: tagPropType
});

(() => {
  if (typeof window !== 'object' || typeof window.CustomEvent === 'function') return;

  const CustomEvent = (event, params) => {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: null
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };

  window.CustomEvent = CustomEvent;
})();

(() => {
  if (typeof Object.values === 'function') return;

  const values = O => Object.keys(O).map(key => O[key]);

  Object.values = values;
})();

var _excluded$6 = ["children"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$O() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Container$a = createStyled("div", "development" === "production" ? {
  target: "eht4jo80"
} : {
  target: "eht4jo80",
  label: "Container"
})("development" === "production" ? {
  name: "1cb9v4t",
  styles: "@-webkit-keyframes spinner-border{to{transform:rotate(360deg);}}@keyframes spinner-border{to{transform:rotate(360deg);}}.spinner-border{display:inline-block;width:2rem;height:2rem;vertical-align:-0.125em;border:0.25em solid currentColor;border-right-color:transparent;border-radius:50%;-webkit-animation:0.75s linear infinite spinner-border;animation:0.75s linear infinite spinner-border;}.spinner-border-sm{width:1rem;height:1rem;border-width:0.2em;}@-webkit-keyframes spinner-grow{0%{transform:scale(0);}50%{opacity:1;transform:none;}}@keyframes spinner-grow{0%{transform:scale(0);}50%{opacity:1;transform:none;}}.spinner-grow{display:inline-block;width:2rem;height:2rem;vertical-align:-0.125em;background-color:currentColor;border-radius:50%;opacity:0;-webkit-animation:0.75s linear infinite spinner-grow;animation:0.75s linear infinite spinner-grow;}.spinner-grow-sm{width:1rem;height:1rem;}@media (prefers-reduced-motion: reduce){.spinner-border,.spinner-grow{-webkit-animation-duration:1.5s;animation-duration:1.5s;}}"
} : {
  name: "1cb9v4t",
  styles: "@-webkit-keyframes spinner-border{to{transform:rotate(360deg);}}@keyframes spinner-border{to{transform:rotate(360deg);}}.spinner-border{display:inline-block;width:2rem;height:2rem;vertical-align:-0.125em;border:0.25em solid currentColor;border-right-color:transparent;border-radius:50%;-webkit-animation:0.75s linear infinite spinner-border;animation:0.75s linear infinite spinner-border;}.spinner-border-sm{width:1rem;height:1rem;border-width:0.2em;}@-webkit-keyframes spinner-grow{0%{transform:scale(0);}50%{opacity:1;transform:none;}}@keyframes spinner-grow{0%{transform:scale(0);}50%{opacity:1;transform:none;}}.spinner-grow{display:inline-block;width:2rem;height:2rem;vertical-align:-0.125em;background-color:currentColor;border-radius:50%;opacity:0;-webkit-animation:0.75s linear infinite spinner-grow;animation:0.75s linear infinite spinner-grow;}.spinner-grow-sm{width:1rem;height:1rem;}@media (prefers-reduced-motion: reduce){.spinner-border,.spinner-grow{-webkit-animation-duration:1.5s;animation-duration:1.5s;}}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$O
});
function Spinner(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? "" : _ref$children,
    rest = _objectWithoutProperties$3(_ref, _excluded$6);
  return /*#__PURE__*/React__default.createElement(Container$a, null, /*#__PURE__*/React__default.createElement(Spinner$1$1, rest, children));
}
Spinner.propTypes = {
  children: PropTypes.node.isRequired
};

var colors$1 = {
  primaryGreen: "#003c3c",
  secondaryGreen: "#009f96",
  primaryRed: "#aa3200",
  lightGrey: "#f0f0f0",
  borderGrey: "#dadada",
  white: "#ffffff",
  darkGrey: "#979797",
  errorRed: "#E30820",
  // YX Visa
  black: "#2A2742",
  clearBlue: "#0044B2",
  darkBlue: "#002751",
  coolGrey: "#CFD8E5",
  freshRed: "#FF003D",
  lightBorder: "#99a9b9",
  linearBlue: "linear-gradient(180deg, #004EBC -48.98%, rgba(255, 255, 255, 0) 98.47%), linear-gradient(106.39deg, #004EBC 10.09%, #AAE0FF 83.39%)",
  textGrey: "#656262",
  yxGrey: "#99a9b9"
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$N() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var primaryGreen$a = colors$1.primaryGreen,
  freshRed$3 = colors$1.freshRed;
var Center = createStyled("div", "development" === "production" ? {
  target: "e17k0qgm1"
} : {
  target: "e17k0qgm1",
  label: "Center"
})("development" === "production" ? {
  name: "penmfh",
  styles: "display:flex;align-content:space-around;justify-content:space-around;flex-direction:row;align-items:center;height:100%;opacity:1"
} : {
  name: "penmfh",
  styles: "display:flex;align-content:space-around;justify-content:space-around;flex-direction:row;align-items:center;height:100%;opacity:1",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxvYWRpbmctb3ZlcmxheS5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBU3lCIiwiZmlsZSI6ImxvYWRpbmctb3ZlcmxheS5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gXCJwcm9wLXR5cGVzXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIjtcbmltcG9ydCBTcGlubmVyIGZyb20gXCIuLi9zcGlubmVyXCI7XG5cbmltcG9ydCBjb2xvcnMgZnJvbSBcIi4uLy4uLy4uL2NvbG9yc1wiO1xuXG5jb25zdCB7IHByaW1hcnlHcmVlbiwgZnJlc2hSZWQgfSA9IGNvbG9ycztcblxuY29uc3QgQ2VudGVyID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24tY29udGVudDogc3BhY2UtYXJvdW5kO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWFyb3VuZDtcbiAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgaGVpZ2h0OiAxMDAlO1xuICBvcGFjaXR5OiAxO1xuYDtcblxuY29uc3QgV3JhcHBlckRpdiA9IHN0eWxlZC5kaXZgXG4gIGhlaWdodDogMTAwJTtcbiAgd2lkdGg6IDEwMCU7XG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgei1pbmRleDogMTAwMDAwO1xuICB0b3A6IDA7XG4gIGxlZnQ6IDA7XG4gIGJhY2tncm91bmQtY29sb3I6IHJnYigxMDAsIDEwMCwgMTAwLCAkeyhwcm9wcykgPT4gcHJvcHMub3BhY2l0eX0pO1xuICBvdmVyZmxvdy14OiBoaWRkZW47XG4gIHRyYW5zaXRpb246IDAuNXM7XG5gO1xuXG5mdW5jdGlvbiBMb2FkaW5nT3ZlcmxheSh7IG9wYWNpdHksIGJyYW5kU3R5bGUgfSkge1xuICByZXR1cm4gKFxuICAgIDxXcmFwcGVyRGl2IG9wYWNpdHk9e29wYWNpdHl9PlxuICAgICAgPENlbnRlcj5cbiAgICAgICAgPFNwaW5uZXJcbiAgICAgICAgICBzdHlsZT17e1xuICAgICAgICAgICAgd2lkdGg6IFwiM3JlbVwiLFxuICAgICAgICAgICAgaGVpZ2h0OiBcIjNyZW1cIixcbiAgICAgICAgICAgIG1hcmdpbjogXCIxLjRyZW1cIixcbiAgICAgICAgICAgIGNvbG9yOiBicmFuZFN0eWxlID09PSBcInl4XCIgPyBmcmVzaFJlZCA6IHByaW1hcnlHcmVlbixcbiAgICAgICAgICB9fVxuICAgICAgICA+XG4gICAgICAgICAge1wiIFwifVxuICAgICAgICA8L1NwaW5uZXI+XG4gICAgICA8L0NlbnRlcj5cbiAgICA8L1dyYXBwZXJEaXY+XG4gICk7XG59XG5cbkxvYWRpbmdPdmVybGF5LnByb3BUeXBlcyA9IHtcbiAgb3BhY2l0eTogUHJvcFR5cGVzLnN0cmluZyxcbiAgYnJhbmRTdHlsZTogUHJvcFR5cGVzLm9uZU9mKFtcInlhXCIsIFwieXhcIl0pLFxufTtcblxuTG9hZGluZ092ZXJsYXkuZGVmYXVsdFByb3BzID0ge1xuICBvcGFjaXR5OiBcIjAuNlwiLFxuICBicmFuZFN0eWxlOiBcInlhXCIsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBMb2FkaW5nT3ZlcmxheTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$N
});
var WrapperDiv$1 = createStyled("div", "development" === "production" ? {
  target: "e17k0qgm0"
} : {
  target: "e17k0qgm0",
  label: "WrapperDiv"
})("height:100%;width:100%;position:fixed;z-index:100000;top:0;left:0;background-color:rgb(100, 100, 100, ", function (props) {
  return props.opacity;
}, ");overflow-x:hidden;transition:0.5s;" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxvYWRpbmctb3ZlcmxheS5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbUI2QiIsImZpbGUiOiJsb2FkaW5nLW92ZXJsYXkuanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCI7XG5pbXBvcnQgU3Bpbm5lciBmcm9tIFwiLi4vc3Bpbm5lclwiO1xuXG5pbXBvcnQgY29sb3JzIGZyb20gXCIuLi8uLi8uLi9jb2xvcnNcIjtcblxuY29uc3QgeyBwcmltYXJ5R3JlZW4sIGZyZXNoUmVkIH0gPSBjb2xvcnM7XG5cbmNvbnN0IENlbnRlciA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWNvbnRlbnQ6IHNwYWNlLWFyb3VuZDtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1hcm91bmQ7XG4gIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGhlaWdodDogMTAwJTtcbiAgb3BhY2l0eTogMTtcbmA7XG5cbmNvbnN0IFdyYXBwZXJEaXYgPSBzdHlsZWQuZGl2YFxuICBoZWlnaHQ6IDEwMCU7XG4gIHdpZHRoOiAxMDAlO1xuICBwb3NpdGlvbjogZml4ZWQ7XG4gIHotaW5kZXg6IDEwMDAwMDtcbiAgdG9wOiAwO1xuICBsZWZ0OiAwO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2IoMTAwLCAxMDAsIDEwMCwgJHsocHJvcHMpID0+IHByb3BzLm9wYWNpdHl9KTtcbiAgb3ZlcmZsb3cteDogaGlkZGVuO1xuICB0cmFuc2l0aW9uOiAwLjVzO1xuYDtcblxuZnVuY3Rpb24gTG9hZGluZ092ZXJsYXkoeyBvcGFjaXR5LCBicmFuZFN0eWxlIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8V3JhcHBlckRpdiBvcGFjaXR5PXtvcGFjaXR5fT5cbiAgICAgIDxDZW50ZXI+XG4gICAgICAgIDxTcGlubmVyXG4gICAgICAgICAgc3R5bGU9e3tcbiAgICAgICAgICAgIHdpZHRoOiBcIjNyZW1cIixcbiAgICAgICAgICAgIGhlaWdodDogXCIzcmVtXCIsXG4gICAgICAgICAgICBtYXJnaW46IFwiMS40cmVtXCIsXG4gICAgICAgICAgICBjb2xvcjogYnJhbmRTdHlsZSA9PT0gXCJ5eFwiID8gZnJlc2hSZWQgOiBwcmltYXJ5R3JlZW4sXG4gICAgICAgICAgfX1cbiAgICAgICAgPlxuICAgICAgICAgIHtcIiBcIn1cbiAgICAgICAgPC9TcGlubmVyPlxuICAgICAgPC9DZW50ZXI+XG4gICAgPC9XcmFwcGVyRGl2PlxuICApO1xufVxuXG5Mb2FkaW5nT3ZlcmxheS5wcm9wVHlwZXMgPSB7XG4gIG9wYWNpdHk6IFByb3BUeXBlcy5zdHJpbmcsXG4gIGJyYW5kU3R5bGU6IFByb3BUeXBlcy5vbmVPZihbXCJ5YVwiLCBcInl4XCJdKSxcbn07XG5cbkxvYWRpbmdPdmVybGF5LmRlZmF1bHRQcm9wcyA9IHtcbiAgb3BhY2l0eTogXCIwLjZcIixcbiAgYnJhbmRTdHlsZTogXCJ5YVwiLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgTG9hZGluZ092ZXJsYXk7XG4iXX0= */"));
function LoadingOverlay(_ref) {
  var opacity = _ref.opacity,
    brandStyle = _ref.brandStyle;
  return /*#__PURE__*/React__default.createElement(WrapperDiv$1, {
    opacity: opacity
  }, /*#__PURE__*/React__default.createElement(Center, null, /*#__PURE__*/React__default.createElement(Spinner, {
    style: {
      width: "3rem",
      height: "3rem",
      margin: "1.4rem",
      color: brandStyle === "yx" ? freshRed$3 : primaryGreen$a
    }
  }, " ")));
}
LoadingOverlay.propTypes = {
  opacity: PropTypes.string,
  brandStyle: PropTypes.oneOf(["ya", "yx"])
};
LoadingOverlay.defaultProps = {
  opacity: "0.6",
  brandStyle: "ya"
};

var svgWhite = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20viewBox%3D%22-621.4%20992.6%208.3%2017.4%22%20width%3D%2222px%22%20height%3D%2222px%22%20enable-background%3D%22new%20-621.4%20992.6%208.3%2017.4%22%20xml%3Aspace%3D%22preserve%22%3E%3Cg%3E%20%3Cpolygon%20fill%3D%22%23fff%22%20points%3D%22-615.4%2C1001.6%20-621.4%2C1008.8%20-620.4%2C1010%20-613.1%2C1001.5%20-620.3%2C992.6%20-621.4%2C993.4%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var svgGreen = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20viewBox%3D%22-621.4%20992.6%208.3%2017.4%22%20width%3D%2222px%22%20height%3D%2222px%22%20enable-background%3D%22new%20-621.4%20992.6%208.3%2017.4%22%20xml%3Aspace%3D%22preserve%22%3E%3Cg%3E%20%3Cpolygon%20fill%3D%22%23aa3200%22%20points%3D%22-615.4%2C1001.6%20-621.4%2C1008.8%20-620.4%2C1010%20-613.1%2C1001.5%20-620.3%2C992.6%20-621.4%2C993.4%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

function _EMOTION_STRINGIFIED_CSS_ERROR__$M() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Container$9 = createStyled("div", "development" === "production" ? {
  target: "e134xkpx0"
} : {
  target: "e134xkpx0",
  label: "Container"
})("development" === "production" ? {
  name: "1241mpg",
  styles: ".collapse:not(.show){display:none;}.collapsing{height:0;overflow:hidden;transition:height 0.35s ease;}@media (prefers-reduced-motion: reduce){.collapsing{transition:none;}}.collapsing.collapse-horizontal{width:0;height:auto;transition:width 0.35s ease;}@media (prefers-reduced-motion: reduce){.collapsing.collapse-horizontal{transition:none;}}"
} : {
  name: "1241mpg",
  styles: ".collapse:not(.show){display:none;}.collapsing{height:0;overflow:hidden;transition:height 0.35s ease;}@media (prefers-reduced-motion: reduce){.collapsing{transition:none;}}.collapsing.collapse-horizontal{width:0;height:auto;transition:width 0.35s ease;}@media (prefers-reduced-motion: reduce){.collapsing.collapse-horizontal{transition:none;}}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbGxhcHNlLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLNEIiLCJmaWxlIjoiY29sbGFwc2UuanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCI7XG5pbXBvcnQgeyBDb2xsYXBzZSBhcyBCb290c3RyYXBDb2xsYXBzZSB9IGZyb20gXCJyZWFjdHN0cmFwXCI7XG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIC5jb2xsYXBzZTpub3QoLnNob3cpIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG5cbiAgLmNvbGxhcHNpbmcge1xuICAgIGhlaWdodDogMDtcbiAgICBvdmVyZmxvdzogaGlkZGVuO1xuICAgIHRyYW5zaXRpb246IGhlaWdodCAwLjM1cyBlYXNlO1xuICB9XG4gIEBtZWRpYSAocHJlZmVycy1yZWR1Y2VkLW1vdGlvbjogcmVkdWNlKSB7XG4gICAgLmNvbGxhcHNpbmcge1xuICAgICAgdHJhbnNpdGlvbjogbm9uZTtcbiAgICB9XG4gIH1cbiAgLmNvbGxhcHNpbmcuY29sbGFwc2UtaG9yaXpvbnRhbCB7XG4gICAgd2lkdGg6IDA7XG4gICAgaGVpZ2h0OiBhdXRvO1xuICAgIHRyYW5zaXRpb246IHdpZHRoIDAuMzVzIGVhc2U7XG4gIH1cbiAgQG1lZGlhIChwcmVmZXJzLXJlZHVjZWQtbW90aW9uOiByZWR1Y2UpIHtcbiAgICAuY29sbGFwc2luZy5jb2xsYXBzZS1ob3Jpem9udGFsIHtcbiAgICAgIHRyYW5zaXRpb246IG5vbmU7XG4gICAgfVxuICB9XG5gO1xuXG5mdW5jdGlvbiBDb2xsYXBzZSh7IGNoaWxkcmVuLCBpc09wZW4sIGFwcGVhciwgb25FbnRlcmVkLCBvbkV4aXRlZCB9KSB7XG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lcj5cbiAgICAgIDxCb290c3RyYXBDb2xsYXBzZSBpc09wZW49e2lzT3Blbn0gYXBwZWFyPXthcHBlYXJ9IG9uRW50ZXJlZD17b25FbnRlcmVkfSBvbkV4aXRlZD17b25FeGl0ZWR9PlxuICAgICAgICB7Y2hpbGRyZW59XG4gICAgICA8L0Jvb3RzdHJhcENvbGxhcHNlPlxuICAgIDwvQ29udGFpbmVyPlxuICApO1xufVxuXG5Db2xsYXBzZS5wcm9wVHlwZXMgPSB7XG4gIGNoaWxkcmVuOiBQcm9wVHlwZXMubm9kZS5pc1JlcXVpcmVkLFxuICBpc09wZW46IFByb3BUeXBlcy5ib29sLmlzUmVxdWlyZWQsXG4gIGFwcGVhcjogUHJvcFR5cGVzLmJvb2wuaXNSZXF1aXJlZCxcbiAgb25FbnRlcmVkOiBQcm9wVHlwZXMuZnVuYy5pc1JlcXVpcmVkLFxuICBvbkV4aXRlZDogUHJvcFR5cGVzLmZ1bmMuaXNSZXF1aXJlZCxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IENvbGxhcHNlO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$M
});
function Collapse(_ref) {
  var children = _ref.children,
    isOpen = _ref.isOpen,
    appear = _ref.appear,
    onEntered = _ref.onEntered,
    onExited = _ref.onExited;
  return /*#__PURE__*/React__default.createElement(Container$9, null, /*#__PURE__*/React__default.createElement(Collapse$1$1, {
    isOpen: isOpen,
    appear: appear,
    onEntered: onEntered,
    onExited: onExited
  }, children));
}
Collapse.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  appear: PropTypes.bool.isRequired,
  onEntered: PropTypes.func.isRequired,
  onExited: PropTypes.func.isRequired
};

var ErrorLabelStyling = createStyled("label", "development" === "production" ? {
  target: "e14svkvi0"
} : {
  target: "e14svkvi0",
  label: "ErrorLabelStyling"
})("float:left;max-width:100%;padding:11px 20px;margin:10px 0;z-index:1;color:white;font-size:14px;font-weight:600;background:", colors$1.freshRed, ";border-radius:5px;display:flex;align-items:center;text-align:center;justify-content:center;position:relative;box-shadow:0 5px 10px rgb(0 0 0 / 30%);&:before{top:-9px;border-top:none;border-left:10px solid transparent;border-right:10px solid transparent;border-bottom:10px solid #fe1237;content:\"\";width:0;height:0;position:absolute;bottom:-10px;}" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
function ErrorLabel(_ref) {
  var id = _ref.id,
    showError = _ref.showError;
  var _useState = useState("CLOSED"),
    _useState2 = _slicedToArray$2(_useState, 2),
    appear = _useState2[0],
    setAppear = _useState2[1];
  return /*#__PURE__*/React__default.createElement(Collapse, {
    isOpen: !!showError.length,
    appear: appear !== "ENTERED",
    onEntered: function onEntered() {
      return setAppear("ENTERED");
    },
    onExited: function onExited() {
      return setAppear("CLOSED");
    }
  }, /*#__PURE__*/React__default.createElement(ErrorLabelStyling, {
    htmlFor: id
  }, showError));
}
ErrorLabel.propTypes = {
  id: PropTypes.string.isRequired,
  showError: PropTypes.string
};
ErrorLabel.defaultProps = {
  showError: ""
};

var primaryRed$2 = colors$1.primaryRed,
  freshRed$2 = colors$1.freshRed,
  white$5 = colors$1.white;
var primaryColorSelector$1 = function primaryColorSelector(_ref) {
  var brandStyle = _ref.brandStyle;
  return brandStyle === "yx" ? freshRed$2 : primaryRed$2;
};
var StyledButton$3 = createStyled("button", "development" === "production" ? {
  target: "e1231w850"
} : {
  target: "e1231w850",
  label: "StyledButton"
})("background-position:93% center;background-image:url(\"", svgWhite, "\");background-color:", primaryColorSelector$1, ";background-repeat:no-repeat;color:", white$5, ";text-align:", function (props) {
  return props.textAlign;
}, ";max-width:", function (props) {
  return props.maxWidth;
}, ";display:inline-block;border:2px solid ", primaryColorSelector$1, ";width:100%;margin-bottom:10px;margin-top:16px;transition:background-position 0.3s,background-image 0.1s,background-color 0.15s,color 0.15s;&:hover:not([disabled]){background-position:", function (props) {
  return props.disabled ? "93%" : "95%";
}, " center;cursor:pointer;}&:disabled{opacity:0.5;}", function (_ref2) {
  var brandStyle = _ref2.brandStyle;
  return brandStyle === "yx" ? "\n    border-radius: 33px;\n    font-size: 13px;\n    font-family: 'ClanOT Bold';\n    line-height: unset;\n    padding: 11px 20px;\n\n    &:hover:not([disabled]) {\n      opacity: 0.9;\n      background-image: url(\"".concat(svgWhite, "\");\n      color: ").concat(white$5, ";\n      box-shadow: inherit;\n    }\n  ") : "\n    border-radius: 0px;\n    font-size: 22px;\n    font-family: 'Montserrat';\n    font-weight: 600;\n    line-height: 56px;\n    padding: 0 20px;\n\n    &:hover:not([disabled]) {\n      background-color: ".concat(white$5, ";\n      background-image: url(\"").concat(svgGreen, "\");\n      color: ").concat(primaryRed$2, ";\n      box-shadow: inset;\n    }\n  ");
}, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
function Button(_ref3) {
  var label = _ref3.label,
    onclick = _ref3.onclick,
    textAlign = _ref3.textAlign,
    maxWidth = _ref3.maxWidth,
    showError = _ref3.showError,
    disabled = _ref3.disabled,
    brandStyle = _ref3.brandStyle;
  var clickHandler = disabled ? function () {} : onclick;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledButton$3, {
    type: "button",
    onClick: clickHandler,
    textAlign: textAlign,
    maxWidth: maxWidth,
    disabled: disabled,
    brandStyle: brandStyle
  }, label), showError && /*#__PURE__*/React__default.createElement(ErrorLabel, {
    id: "nextButton",
    showError: showError
  }));
}
Button.propTypes = {
  label: PropTypes.string.isRequired,
  onclick: PropTypes.func,
  textAlign: PropTypes.string,
  maxWidth: PropTypes.string,
  showError: PropTypes.string,
  disabled: PropTypes.bool,
  brandStyle: PropTypes.oneOf(["ya", "yx"])
};
Button.defaultProps = {
  textAlign: "left",
  maxWidth: "380px",
  showError: "",
  onclick: function onclick() {},
  disabled: false,
  brandStyle: "ya"
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$L() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var white$4 = colors$1.white,
  primaryRed$1 = colors$1.primaryRed,
  clearBlue = colors$1.clearBlue;
var primaryColorSelector = function primaryColorSelector(_ref) {
  var brandStyle = _ref.brandStyle;
  return brandStyle === "yx" ? clearBlue : primaryRed$1;
};
var hoverColorSelector = function hoverColorSelector(_ref2) {
  var brandStyle = _ref2.brandStyle;
  return brandStyle === "yx" ? white$4 : primaryRed$1;
};
var hoverBackgroundSelector = function hoverBackgroundSelector(_ref3) {
  var brandStyle = _ref3.brandStyle;
  return brandStyle === "yx" ? clearBlue : white$4;
};
var Pre = createStyled("span", "development" === "production" ? {
  target: "e1e963s22"
} : {
  target: "e1e963s22",
  label: "Pre"
})("development" === "production" ? {
  name: "7key53",
  styles: "font-size:35px"
} : {
  name: "7key53",
  styles: "font-size:35px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$L
});
var LabelSpan = createStyled("span", "development" === "production" ? {
  target: "e1e963s21"
} : {
  target: "e1e963s21",
  label: "LabelSpan"
})("development" === "production" ? {
  name: "1siegsx",
  styles: "margin-left:18px"
} : {
  name: "1siegsx",
  styles: "margin-left:18px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$L
});
var StyledButton$2 = createStyled("button", "development" === "production" ? {
  target: "e1e963s20"
} : {
  target: "e1e963s20",
  label: "StyledButton"
})("background-color:", primaryColorSelector, ";color:", white$4, ";max-width:400px;display:flex;align-items:center;border:2px solid ", primaryColorSelector, ";width:100%;opacity:", function (props) {
  return props.disabled ? 0.5 : 1;
}, ";white-space:nowrap;margin-bottom:10px;margin-top:16px;min-height:60px;font-size:22px;padding:0 18px;transition:background-color 0.15s,color 0.15s;&:hover:not([disabled]){background-color:", hoverBackgroundSelector, ";color:", hoverColorSelector, ";cursor:pointer;}", function (_ref4) {
  var brandStyle = _ref4.brandStyle;
  return brandStyle === "yx" ? "\n      font-family: \"ClanOT News\";\n    " : "\n      font-family: \"Montserrat\";\n    ";
}, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
function ButtonPre(_ref5) {
  var label = _ref5.label,
    onclick = _ref5.onclick,
    disabled = _ref5.disabled,
    pre = _ref5.pre,
    brandStyle = _ref5.brandStyle;
  var clickHandler = disabled ? function () {} : onclick;
  return /*#__PURE__*/React__default.createElement(StyledButton$2, {
    type: "button",
    onClick: clickHandler,
    disabled: disabled,
    brandStyle: brandStyle
  }, /*#__PURE__*/React__default.createElement(Pre, null, pre), /*#__PURE__*/React__default.createElement(LabelSpan, null, label));
}
ButtonPre.propTypes = {
  label: PropTypes.string.isRequired,
  onclick: PropTypes.func,
  disabled: PropTypes.bool,
  pre: PropTypes.string,
  brandStyle: PropTypes.oneOf(["ya", "yx"])
};
ButtonPre.defaultProps = {
  onclick: function onclick() {},
  disabled: false,
  pre: "+",
  brandStyle: "ya"
};

var checkboxEmpty = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%2228px%22%20height%3D%2235px%22%20viewBox%3D%220%200%2028%2035%22%20enable-background%3D%22new%200%200%2028%2035%22%20xml%3Aspace%3D%22preserve%22%3E%3Cg%3E%20%3Cpath%20fill%3D%22%23FFFFFF%22%20d%3D%22M26%2C31c0%2C0.6-0.4%2C1-1%2C1H2c-0.6%2C0-1-0.4-1-1V8c0-0.6%2C0.4-1%2C1-1h23c0.6%2C0%2C1%2C0.4%2C1%2C1V31z%22%2F%3E%3C%2Fg%3E%3Cg%3E%20%3Cpath%20fill%3D%22%23999999%22%20d%3D%22M25.5%2C33h-23C1.7%2C33%2C1%2C32.3%2C1%2C31.5v-23C1%2C7.7%2C1.7%2C7%2C2.5%2C7h23C26.3%2C7%2C27%2C7.7%2C27%2C8.5v23%20%20C27%2C32.3%2C26.3%2C33%2C25.5%2C33z%20M2.5%2C8C2.2%2C8%2C2%2C8.2%2C2%2C8.5v23C2%2C31.8%2C2.2%2C32%2C2.5%2C32h23c0.3%2C0%2C0.5-0.2%2C0.5-0.5v-23C26%2C8.2%2C25.8%2C8%2C25.5%2C8%20%20H2.5z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var checkboxFill = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%2228px%22%20height%3D%2235px%22%20viewBox%3D%220%200%2028%2035%22%20enable-background%3D%22new%200%200%2028%2035%22%20xml%3Aspace%3D%22preserve%22%3E%3Cg%3E%20%3Cpath%20fill%3D%22%23FFFFFF%22%20d%3D%22M26%2C31c0%2C0.6-0.4%2C1-1%2C1H2c-0.6%2C0-1-0.4-1-1V8c0-0.6%2C0.4-1%2C1-1h23c0.6%2C0%2C1%2C0.4%2C1%2C1V31z%22%2F%3E%3C%2Fg%3E%3Cg%3E%20%3Cpath%20fill%3D%22%23999999%22%20d%3D%22M25.5%2C33h-23C1.7%2C33%2C1%2C32.3%2C1%2C31.5v-23C1%2C7.7%2C1.7%2C7%2C2.5%2C7h23C26.3%2C7%2C27%2C7.7%2C27%2C8.5v23%20%20C27%2C32.3%2C26.3%2C33%2C25.5%2C33z%20M2.5%2C8C2.2%2C8%2C2%2C8.2%2C2%2C8.5v23C2%2C31.8%2C2.2%2C32%2C2.5%2C32h23c0.3%2C0%2C0.5-0.2%2C0.5-0.5v-23C26%2C8.2%2C25.8%2C8%2C25.5%2C8%20%20H2.5z%22%2F%3E%3C%2Fg%3E%3Cg%3E%20%3Cpath%20fill%3D%22%23003c3c%22%20d%3D%22M7.1%2C15.6c1.8%2C3.8%2C3.3%2C7.7%2C4.5%2C11.7c0.5%2C1.8%2C3.1%2C1.8%2C3.7%2C0c2.6-8.5%2C6.1-16.6%2C10.7-24.3c1.2-2.1-2-4-3.3-1.9%20%20c-4.7%2C8-8.4%2C16.3-11%2C25.2c1.2%2C0%2C2.4%2C0%2C3.7%2C0c-1.3-4.3-2.9-8.5-4.8-12.6C9.4%2C11.5%2C6.1%2C13.4%2C7.1%2C15.6L7.1%2C15.6z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var checkboxFillYellow = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%2228px%22%20height%3D%2235px%22%20viewBox%3D%220%200%2028%2035%22%20enable-background%3D%22new%200%200%2028%2035%22%20xml%3Aspace%3D%22preserve%22%3E%3Cg%3E%20%3Cpath%20fill%3D%22%23FFFFFF%22%20d%3D%22M26%2C31c0%2C0.6-0.4%2C1-1%2C1H2c-0.6%2C0-1-0.4-1-1V8c0-0.6%2C0.4-1%2C1-1h23c0.6%2C0%2C1%2C0.4%2C1%2C1V31z%22%2F%3E%3C%2Fg%3E%3Cg%3E%20%3Cpath%20fill%3D%22%23999999%22%20d%3D%22M25.5%2C33h-23C1.7%2C33%2C1%2C32.3%2C1%2C31.5v-23C1%2C7.7%2C1.7%2C7%2C2.5%2C7h23C26.3%2C7%2C27%2C7.7%2C27%2C8.5v23%20%20C27%2C32.3%2C26.3%2C33%2C25.5%2C33z%20M2.5%2C8C2.2%2C8%2C2%2C8.2%2C2%2C8.5v23C2%2C31.8%2C2.2%2C32%2C2.5%2C32h23c0.3%2C0%2C0.5-0.2%2C0.5-0.5v-23C26%2C8.2%2C25.8%2C8%2C25.5%2C8%20%20H2.5z%22%2F%3E%3C%2Fg%3E%3Cg%3E%20%3Cpath%20fill%3D%22%23002751%22%20d%3D%22M7.1%2C15.6c1.8%2C3.8%2C3.3%2C7.7%2C4.5%2C11.7c0.5%2C1.8%2C3.1%2C1.8%2C3.7%2C0c2.6-8.5%2C6.1-16.6%2C10.7-24.3c1.2-2.1-2-4-3.3-1.9%20%20c-4.7%2C8-8.4%2C16.3-11%2C25.2c1.2%2C0%2C2.4%2C0%2C3.7%2C0c-1.3-4.3-2.9-8.5-4.8-12.6C9.4%2C11.5%2C6.1%2C13.4%2C7.1%2C15.6L7.1%2C15.6z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var checkboxEmptyDisabled = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%2228px%22%20height%3D%2235px%22%20viewBox%3D%220%200%2028%2035%22%20enable-background%3D%22new%200%200%2028%2035%22%20xml%3Aspace%3D%22preserve%22%3E%3Cg%3E%20%3Cpath%20fill%3D%22%23F5F5F5%22%20d%3D%22M26%2C31c0%2C0.6-0.4%2C1-1%2C1H2c-0.6%2C0-1-0.4-1-1V8c0-0.6%2C0.4-1%2C1-1h23c0.6%2C0%2C1%2C0.4%2C1%2C1V31z%22%2F%3E%3C%2Fg%3E%3Cg%3E%20%3Cpath%20fill%3D%22%23cecece%22%20d%3D%22M25.5%2C33h-23C1.7%2C33%2C1%2C32.3%2C1%2C31.5v-23C1%2C7.7%2C1.7%2C7%2C2.5%2C7h23C26.3%2C7%2C27%2C7.7%2C27%2C8.5v23%20%20C27%2C32.3%2C26.3%2C33%2C25.5%2C33z%20M2.5%2C8C2.2%2C8%2C2%2C8.2%2C2%2C8.5v23C2%2C31.8%2C2.2%2C32%2C2.5%2C32h23c0.3%2C0%2C0.5-0.2%2C0.5-0.5v-23C26%2C8.2%2C25.8%2C8%2C25.5%2C8%20%20H2.5z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var checkboxFillDisabled = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%2228px%22%20height%3D%2235px%22%20viewBox%3D%220%200%2028%2035%22%20enable-background%3D%22new%200%200%2028%2035%22%20xml%3Aspace%3D%22preserve%22%3E%3Cg%3E%20%3Cpath%20fill%3D%22%23F5F5F5%22%20d%3D%22M26%2C31c0%2C0.6-0.4%2C1-1%2C1H2c-0.6%2C0-1-0.4-1-1V8c0-0.6%2C0.4-1%2C1-1h23c0.6%2C0%2C1%2C0.4%2C1%2C1V31z%22%2F%3E%3C%2Fg%3E%3Cg%3E%20%3Cpath%20fill%3D%22%23cecece%22%20d%3D%22M25.5%2C33h-23C1.7%2C33%2C1%2C32.3%2C1%2C31.5v-23C1%2C7.7%2C1.7%2C7%2C2.5%2C7h23C26.3%2C7%2C27%2C7.7%2C27%2C8.5v23%20%20C27%2C32.3%2C26.3%2C33%2C25.5%2C33z%20M2.5%2C8C2.2%2C8%2C2%2C8.2%2C2%2C8.5v23C2%2C31.8%2C2.2%2C32%2C2.5%2C32h23c0.3%2C0%2C0.5-0.2%2C0.5-0.5v-23C26%2C8.2%2C25.8%2C8%2C25.5%2C8%20%20H2.5z%22%2F%3E%3C%2Fg%3E%3Cg%3E%20%3Cpath%20fill%3D%22%23cecece%22%20d%3D%22M7.1%2C15.6c1.8%2C3.8%2C3.3%2C7.7%2C4.5%2C11.7c0.5%2C1.8%2C3.1%2C1.8%2C3.7%2C0c2.6-8.5%2C6.1-16.6%2C10.7-24.3c1.2-2.1-2-4-3.3-1.9%20%20c-4.7%2C8-8.4%2C16.3-11%2C25.2c1.2%2C0%2C2.4%2C0%2C3.7%2C0c-1.3-4.3-2.9-8.5-4.8-12.6C9.4%2C11.5%2C6.1%2C13.4%2C7.1%2C15.6L7.1%2C15.6z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

function _EMOTION_STRINGIFIED_CSS_ERROR__$K() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var InputCSS = createStyled("input", "development" === "production" ? {
  target: "eq2xr331"
} : {
  target: "eq2xr331",
  label: "InputCSS"
})("development" === "production" ? {
  name: "11rawnz",
  styles: "display:none;cursor:pointer"
} : {
  name: "11rawnz",
  styles: "display:none;cursor:pointer",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNoZWNrYm94LmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFZNkIiLCJmaWxlIjoiY2hlY2tib3guanN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyogZXNsaW50LWRpc2FibGUganN4LWExMXkvY2xpY2stZXZlbnRzLWhhdmUta2V5LWV2ZW50cyAqL1xuaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCI7XG5cbmltcG9ydCBFcnJvckxhYmVsIGZyb20gXCIuLi9lcnJvcmxhYmVsXCI7XG5pbXBvcnQgY2hlY2tib3hFbXB0eSBmcm9tIFwiLi4vLi4vLi4vLi4vYXNzZXRzL3N2Z3MvY2hlY2tib3hfZW1wdHkuc3ZnXCI7XG5pbXBvcnQgY2hlY2tib3hGaWxsIGZyb20gXCIuLi8uLi8uLi8uLi9hc3NldHMvc3Zncy9jaGVja2JveF9maWxsLnN2Z1wiO1xuaW1wb3J0IGNoZWNrYm94RmlsbFllbGxvdyBmcm9tIFwiLi4vLi4vLi4vLi4vYXNzZXRzL3N2Z3MvY2hlY2tib3hfZmlsbF95ZWxsb3cuc3ZnXCI7XG5pbXBvcnQgY2hlY2tib3hFbXB0eURpc2FibGVkIGZyb20gXCIuLi8uLi8uLi8uLi9hc3NldHMvc3Zncy9jaGVja2JveF9lbXB0eV9kaXNhYmxlZC5zdmdcIjtcbmltcG9ydCBjaGVja2JveEZpbGxEaXNhYmxlZCBmcm9tIFwiLi4vLi4vLi4vLi4vYXNzZXRzL3N2Z3MvY2hlY2tib3hfZmlsbF9kaXNhYmxlZC5zdmdcIjtcblxuY29uc3QgSW5wdXRDU1MgPSBzdHlsZWQuaW5wdXRgXG4gIGRpc3BsYXk6IG5vbmU7XG4gIGN1cnNvcjogcG9pbnRlcjtcbmA7XG5cbmNvbnN0IExhYmVsQ1NTID0gc3R5bGVkLnNwYW5gXG4gIGJhY2tncm91bmQtcmVwZWF0OiBuby1yZXBlYXQ7XG4gIGJhY2tncm91bmQtaW1hZ2U6IHVybChcIiR7KHByb3BzKSA9PiBwcm9wcy5zdmd9XCIpO1xuICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gIG1pbi1oZWlnaHQ6IDM1cHg7XG4gIGxpbmUtaGVpZ2h0OiAyNnB4O1xuICBwYWRkaW5nLWxlZnQ6IDM2cHg7XG4gIHBhZGRpbmctdG9wOiA1cHg7XG4gIG1hcmdpbi1yaWdodDogNDBweDtcbiAgbWFyZ2luLWJvdHRvbTogNnB4O1xuICBtYXJnaW4tdG9wOiAxNnB4O1xuICB3aWR0aDogMTAwJTtcbiAgY3Vyc29yOiBwb2ludGVyO1xuICAkeyh7IGJyYW5kU3R5bGUgfSkgPT5cbiAgICBicmFuZFN0eWxlID09PSBcInl4XCJcbiAgICAgID8gYFxuICAgICAgICBmb250LWZhbWlseTogXCJDbGFuT1QgTmV3c1wiO1xuICAgICAgYFxuICAgICAgOiBcIlwifVxuYDtcblxuZnVuY3Rpb24gc3ZnU2VsZWN0b3IoY2hlY2tlZCwgYnJhbmRTdHlsZSwgZGlzYWJsZWQpIHtcbiAgaWYgKCFjaGVja2VkKSB7XG4gICAgaWYgKGRpc2FibGVkKSByZXR1cm4gY2hlY2tib3hFbXB0eURpc2FibGVkO1xuICAgIHJldHVybiBjaGVja2JveEVtcHR5O1xuICB9XG5cbiAgaWYgKGRpc2FibGVkKSByZXR1cm4gY2hlY2tib3hGaWxsRGlzYWJsZWQ7XG4gIGlmIChicmFuZFN0eWxlID09PSBcInl4XCIpIHJldHVybiBjaGVja2JveEZpbGxZZWxsb3c7XG4gIHJldHVybiBjaGVja2JveEZpbGw7XG59XG5cbmZ1bmN0aW9uIENoZWNrYm94KHtcbiAgaWQsXG4gIHZhbHVlLFxuICBjaGVja2VkLFxuICBvbmNoYW5nZSxcbiAgc2hvd0Vycm9yLFxuICBkaXNhYmxlTGFiZWxDbGljayxcbiAgY2hpbGRyZW4sXG4gIGJyYW5kU3R5bGUsXG4gIGRpc2FibGVkLFxufSkge1xuICBjb25zdCBsYWJlbElkID0gYCR7aWR9LWxhYmVsYDtcbiAgY29uc3Qgc3ZnID0gc3ZnU2VsZWN0b3IoY2hlY2tlZCwgYnJhbmRTdHlsZSwgZGlzYWJsZWQpO1xuXG4gIGNvbnN0IGNsaWNrSGFuZGxlciA9IChlKSA9PiB7XG4gICAgLy8gZGlzYWJsZSBvbmNsaWNrIGV2ZW50IGZvciB0ZXh0XG4gICAgaWYgKGRpc2FibGVkIHx8IChkaXNhYmxlTGFiZWxDbGljayAmJiBlLnRhcmdldC5pZCAhPT0gbGFiZWxJZCkpIHJldHVybjtcbiAgICBlLnByZXZlbnREZWZhdWx0KCk7XG4gICAgY29uc3QgbmV3RXZlbnQgPSB7XG4gICAgICAuLi5lLFxuICAgICAgcHJldmVudERlZmF1bHQ6ICgpID0+IHt9LFxuICAgICAgdGFyZ2V0OiB7XG4gICAgICAgIHZhbHVlLFxuICAgICAgICBjaGVja2VkOiAhY2hlY2tlZCxcbiAgICAgIH0sXG4gICAgfTtcbiAgICBvbmNoYW5nZShuZXdFdmVudCwgaWQpO1xuICB9O1xuXG4gIHJldHVybiAoXG4gICAgPD5cbiAgICAgIDxkaXYgcm9sZT1cImNoZWNrYm94XCIgdGFiSW5kZXg9ezB9IGFyaWEtY2hlY2tlZD17Y2hlY2tlZH0gb25DbGljaz17Y2xpY2tIYW5kbGVyfT5cbiAgICAgICAgPElucHV0Q1NTIHR5cGU9XCJjaGVja2JveFwiIGlkPXtpZH0gZGVmYXVsdFZhbHVlPXt2YWx1ZX0gY2hlY2tlZD17Y2hlY2tlZH0gcmVhZE9ubHkgLz5cbiAgICAgICAgPExhYmVsQ1NTIGlkPXtsYWJlbElkfSBzdmc9e3N2Z30gYnJhbmRTdHlsZT17YnJhbmRTdHlsZX0+XG4gICAgICAgICAge2NoaWxkcmVufVxuICAgICAgICA8L0xhYmVsQ1NTPlxuICAgICAgPC9kaXY+XG4gICAgICA8RXJyb3JMYWJlbCBpZD17aWR9IHNob3dFcnJvcj17c2hvd0Vycm9yfSAvPlxuICAgIDwvPlxuICApO1xufVxuXG5DaGVja2JveC5wcm9wVHlwZXMgPSB7XG4gIGlkOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIC8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSByZWFjdC9mb3JiaWQtcHJvcC10eXBlc1xuICB2YWx1ZTogUHJvcFR5cGVzLmFueSxcbiAgb25jaGFuZ2U6IFByb3BUeXBlcy5mdW5jLFxuICBjaGVja2VkOiBQcm9wVHlwZXMuYm9vbCxcbiAgc2hvd0Vycm9yOiBQcm9wVHlwZXMuc3RyaW5nLFxuICBkaXNhYmxlTGFiZWxDbGljazogUHJvcFR5cGVzLmJvb2wsXG4gIGNoaWxkcmVuOiBQcm9wVHlwZXMubm9kZS5pc1JlcXVpcmVkLFxuICBicmFuZFN0eWxlOiBQcm9wVHlwZXMub25lT2YoW1wieWFcIiwgXCJ5eFwiXSksXG4gIGRpc2FibGVkOiBQcm9wVHlwZXMuYm9vbCxcbn07XG5cbkNoZWNrYm94LmRlZmF1bHRQcm9wcyA9IHtcbiAgdmFsdWU6IFwiXCIsXG4gIHNob3dFcnJvcjogXCJcIixcbiAgY2hlY2tlZDogZmFsc2UsXG4gIG9uY2hhbmdlOiAoKSA9PiB7fSxcbiAgZGlzYWJsZUxhYmVsQ2xpY2s6IGZhbHNlLFxuICBicmFuZFN0eWxlOiBcInlhXCIsXG4gIGRpc2FibGVkOiBmYWxzZSxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IENoZWNrYm94O1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$K
});
var LabelCSS = createStyled("span", "development" === "production" ? {
  target: "eq2xr330"
} : {
  target: "eq2xr330",
  label: "LabelCSS"
})("background-repeat:no-repeat;background-image:url(\"", function (props) {
  return props.svg;
}, "\");display:inline-block;min-height:35px;line-height:26px;padding-left:36px;padding-top:5px;margin-right:40px;margin-bottom:6px;margin-top:16px;width:100%;cursor:pointer;", function (_ref) {
  var brandStyle = _ref.brandStyle;
  return brandStyle === "yx" ? "\n        font-family: \"ClanOT News\";\n      " : "";
}, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
function svgSelector(checked, brandStyle, disabled) {
  if (!checked) {
    if (disabled) return checkboxEmptyDisabled;
    return checkboxEmpty;
  }
  if (disabled) return checkboxFillDisabled;
  if (brandStyle === "yx") return checkboxFillYellow;
  return checkboxFill;
}
function Checkbox$1(_ref2) {
  var id = _ref2.id,
    value = _ref2.value,
    checked = _ref2.checked,
    onchange = _ref2.onchange,
    showError = _ref2.showError,
    disableLabelClick = _ref2.disableLabelClick,
    children = _ref2.children,
    brandStyle = _ref2.brandStyle,
    disabled = _ref2.disabled;
  var labelId = "".concat(id, "-label");
  var svg = svgSelector(checked, brandStyle, disabled);
  var clickHandler = function clickHandler(e) {
    // disable onclick event for text
    if (disabled || disableLabelClick && e.target.id !== labelId) return;
    e.preventDefault();
    var newEvent = _objectSpread2$4(_objectSpread2$4({}, e), {}, {
      preventDefault: function preventDefault() {},
      target: {
        value: value,
        checked: !checked
      }
    });
    onchange(newEvent, id);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    role: "checkbox",
    tabIndex: 0,
    "aria-checked": checked,
    onClick: clickHandler
  }, /*#__PURE__*/React__default.createElement(InputCSS, {
    type: "checkbox",
    id: id,
    defaultValue: value,
    checked: checked,
    readOnly: true
  }), /*#__PURE__*/React__default.createElement(LabelCSS, {
    id: labelId,
    svg: svg,
    brandStyle: brandStyle
  }, children)), /*#__PURE__*/React__default.createElement(ErrorLabel, {
    id: id,
    showError: showError
  }));
}
Checkbox$1.propTypes = {
  id: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
  onchange: PropTypes.func,
  checked: PropTypes.bool,
  showError: PropTypes.string,
  disableLabelClick: PropTypes.bool,
  children: PropTypes.node.isRequired,
  brandStyle: PropTypes.oneOf(["ya", "yx"]),
  disabled: PropTypes.bool
};
Checkbox$1.defaultProps = {
  value: "",
  showError: "",
  checked: false,
  onchange: function onchange() {},
  disableLabelClick: false,
  brandStyle: "ya",
  disabled: false
};

var svg = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%2220px%22%20height%3D%2210px%22%20viewBox%3D%220%200%2020%2010%22%20enable-background%3D%22new%200%200%2020%2010%22%20xml%3Aspace%3D%22preserve%22%3E%3Cpolygon%20fill%3D%22%23FFFFFF%22%20points%3D%2219.4%2C0.6%200.9%2C0.6%2010.2%2C9.9%20%22%2F%3E%3C%2Fsvg%3E";

var white$3 = colors$1.white,
  primaryGreen$9 = colors$1.primaryGreen,
  freshRed$1 = colors$1.freshRed,
  lightBorder = colors$1.lightBorder;
var backgroundColorSelector = function backgroundColorSelector(_ref) {
  var brandStyle = _ref.brandStyle;
  return brandStyle === "yx" ? freshRed$1 : primaryGreen$9;
};
var borderColorSelector = function borderColorSelector(_ref2) {
  var brandStyle = _ref2.brandStyle;
  return brandStyle === "yx" ? lightBorder : primaryGreen$9;
};
var fontSelector$1 = function fontSelector(_ref3) {
  var brandStyle = _ref3.brandStyle;
  return brandStyle === "yx" ? "ClanOT News" : "Montserrat";
};
var BoxStyling = createStyled("div", "development" === "production" ? {
  target: "e1ezfbkq2"
} : {
  target: "e1ezfbkq2",
  label: "BoxStyling"
})("position:relative;max-width:100%;&:before{content:\"\";right:6px;top:0px;width:20px;height:20px;background:#f8f8f8;position:absolute;pointer-events:none;display:block;}&:after{content:\"\";background:", backgroundColorSelector, " url(\"", svg, "\");display:inline-block;overflow:hidden;background-repeat:no-repeat;background-position:center;width:40px;height:40px;position:absolute;top:0px;right:0px;pointer-events:none;}" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRyb3Bkb3duLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFjNkIiLCJmaWxlIjoiZHJvcGRvd24uanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCI7XG5cbmltcG9ydCBFcnJvckxhYmVsIGZyb20gXCIuLi9lcnJvcmxhYmVsXCI7XG5pbXBvcnQgc3ZnIGZyb20gXCIuLi8uLi8uLi8uLi9hc3NldHMvc3Zncy9hcnJvd19kcm9wZG93bi5zdmdcIjtcbmltcG9ydCBjb2xvcnMgZnJvbSBcIi4uLy4uLy4uL2NvbG9yc1wiO1xuXG5jb25zdCB7IHdoaXRlLCBwcmltYXJ5R3JlZW4sIGZyZXNoUmVkLCBsaWdodEJvcmRlciB9ID0gY29sb3JzO1xuXG5jb25zdCBiYWNrZ3JvdW5kQ29sb3JTZWxlY3RvciA9ICh7IGJyYW5kU3R5bGUgfSkgPT4gKGJyYW5kU3R5bGUgPT09IFwieXhcIiA/IGZyZXNoUmVkIDogcHJpbWFyeUdyZWVuKTtcbmNvbnN0IGJvcmRlckNvbG9yU2VsZWN0b3IgPSAoeyBicmFuZFN0eWxlIH0pID0+IChicmFuZFN0eWxlID09PSBcInl4XCIgPyBsaWdodEJvcmRlciA6IHByaW1hcnlHcmVlbik7XG5jb25zdCBmb250U2VsZWN0b3IgPSAoeyBicmFuZFN0eWxlIH0pID0+IChicmFuZFN0eWxlID09PSBcInl4XCIgPyBcIkNsYW5PVCBOZXdzXCIgOiBcIk1vbnRzZXJyYXRcIik7XG5cbmNvbnN0IEJveFN0eWxpbmcgPSBzdHlsZWQuZGl2YFxuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIG1heC13aWR0aDogMTAwJTtcblxuICAmOmJlZm9yZSB7XG4gICAgY29udGVudDogXCJcIjtcbiAgICByaWdodDogNnB4O1xuICAgIHRvcDogMHB4O1xuICAgIHdpZHRoOiAyMHB4O1xuICAgIGhlaWdodDogMjBweDtcbiAgICBiYWNrZ3JvdW5kOiAjZjhmOGY4O1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICBwb2ludGVyLWV2ZW50czogbm9uZTtcbiAgICBkaXNwbGF5OiBibG9jaztcbiAgfVxuXG4gICY6YWZ0ZXIge1xuICAgIGNvbnRlbnQ6IFwiXCI7XG4gICAgYmFja2dyb3VuZDogJHtiYWNrZ3JvdW5kQ29sb3JTZWxlY3Rvcn0gdXJsKFwiJHtzdmd9XCIpO1xuICAgIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgICBvdmVyZmxvdzogaGlkZGVuO1xuICAgIGJhY2tncm91bmQtcmVwZWF0OiBuby1yZXBlYXQ7XG4gICAgYmFja2dyb3VuZC1wb3NpdGlvbjogY2VudGVyO1xuICAgIHdpZHRoOiA0MHB4O1xuICAgIGhlaWdodDogNDBweDtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgdG9wOiAwcHg7XG4gICAgcmlnaHQ6IDBweDtcbiAgICBwb2ludGVyLWV2ZW50czogbm9uZTtcbiAgfVxuYDtcblxuY29uc3QgTGFiZWwgPSBzdHlsZWQubGFiZWxgXG4gIG1hcmdpbi1ib3R0b206IDZweDtcbiAgbWFyZ2luLXRvcDogMTZweDtcbiAgZGlzcGxheTogYmxvY2s7XG4gICR7KHsgYnJhbmRTdHlsZSB9KSA9PlxuICAgIGJyYW5kU3R5bGUgPT09IFwieXhcIlxuICAgICAgPyBgXG4gICAgZm9udC1mYW1pbHk6ICdDbGFuT1QgQm9sZCc7XG4gICAgZm9udC1zaXplOiAxM3B4O1xuICBgXG4gICAgICA6IGBcbiAgICBmb250LXNpemU6IDE1cHg7XG4gIGB9XG5gO1xuXG5jb25zdCBTZWxlY3RTdHlsaW5nID0gc3R5bGVkLnNlbGVjdGBcbiAgYXBwZWFyYW5jZTogbm9uZTtcbiAgYm9yZGVyOiAxcHggc29saWQgJHtib3JkZXJDb2xvclNlbGVjdG9yfTtcbiAgY3Vyc29yOiBwb2ludGVyO1xuICBoZWlnaHQ6IDQwcHg7XG4gIHBhZGRpbmctbGVmdDogN3B4O1xuICB3aWR0aDogMTAwJTtcbiAgYmFja2dyb3VuZDogJHt3aGl0ZX07XG4gIGJvcmRlci1yYWRpdXM6IDBweDtcbiAgZm9udC1zaXplOiAxNXB4O1xuICBmb250LWZhbWlseTogJHtmb250U2VsZWN0b3J9O1xuYDtcblxuZnVuY3Rpb24gRHJvcGRvd24oeyBpZCwgbGFiZWwsIG9wdGlvbnMsIHNlbGVjdGVkLCBvbmNoYW5nZSwgc2hvd0Vycm9yLCBicmFuZFN0eWxlIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8PlxuICAgICAge2xhYmVsICYmIChcbiAgICAgICAgPExhYmVsIGh0bWxGb3I9e2lkfSBicmFuZFN0eWxlPXticmFuZFN0eWxlfT5cbiAgICAgICAgICB7bGFiZWx9XG4gICAgICAgIDwvTGFiZWw+XG4gICAgICApfVxuICAgICAgPEJveFN0eWxpbmcgYnJhbmRTdHlsZT17YnJhbmRTdHlsZX0+XG4gICAgICAgIDxTZWxlY3RTdHlsaW5nXG4gICAgICAgICAgaWQ9e2lkfVxuICAgICAgICAgIG9uQ2hhbmdlPXsoZSkgPT4gb25jaGFuZ2UoZSwgaWQpfVxuICAgICAgICAgIGRlZmF1bHRWYWx1ZT17c2VsZWN0ZWR9XG4gICAgICAgICAgYnJhbmRTdHlsZT17YnJhbmRTdHlsZX1cbiAgICAgICAgPlxuICAgICAgICAgIHtvcHRpb25zLm1hcCgoeyB2YWx1ZSwgbGFiZWw6IG9wdGlvbkxhYmVsIH0pID0+IChcbiAgICAgICAgICAgIDxvcHRpb24ga2V5PXt2YWx1ZX0gdmFsdWU9e3ZhbHVlfT5cbiAgICAgICAgICAgICAge29wdGlvbkxhYmVsfVxuICAgICAgICAgICAgPC9vcHRpb24+XG4gICAgICAgICAgKSl9XG4gICAgICAgIDwvU2VsZWN0U3R5bGluZz5cbiAgICAgICAgPEVycm9yTGFiZWwgaWQ9e2lkfSBzaG93RXJyb3I9e3Nob3dFcnJvcn0gLz5cbiAgICAgIDwvQm94U3R5bGluZz5cbiAgICA8Lz5cbiAgKTtcbn1cblxuY29uc3QgU3RyaW5nT3JOdW1iZXJQcm9wVHlwZSA9IFByb3BUeXBlcy5vbmVPZlR5cGUoW1Byb3BUeXBlcy5zdHJpbmcsIFByb3BUeXBlcy5udW1iZXJdKTtcblxuRHJvcGRvd24ucHJvcFR5cGVzID0ge1xuICBpZDogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBsYWJlbDogUHJvcFR5cGVzLm9uZU9mVHlwZShbUHJvcFR5cGVzLnN0cmluZywgUHJvcFR5cGVzLm5vZGVdKSxcbiAgb3B0aW9uczogUHJvcFR5cGVzLmFycmF5T2YoXG4gICAgUHJvcFR5cGVzLnNoYXBlKHtcbiAgICAgIHZhbHVlOiBTdHJpbmdPck51bWJlclByb3BUeXBlLFxuICAgICAgbGFiZWw6IFN0cmluZ09yTnVtYmVyUHJvcFR5cGUsXG4gICAgfSlcbiAgKS5pc1JlcXVpcmVkLFxuICBzZWxlY3RlZDogU3RyaW5nT3JOdW1iZXJQcm9wVHlwZSxcbiAgb25jaGFuZ2U6IFByb3BUeXBlcy5mdW5jLFxuICBzaG93RXJyb3I6IFByb3BUeXBlcy5zdHJpbmcsXG4gIGJyYW5kU3R5bGU6IFByb3BUeXBlcy5vbmVPZihbXCJ5YVwiLCBcInl4XCJdKSxcbn07XG5cbkRyb3Bkb3duLmRlZmF1bHRQcm9wcyA9IHtcbiAgbGFiZWw6IFwiXCIsXG4gIHNob3dFcnJvcjogXCJcIixcbiAgc2VsZWN0ZWQ6IFwiXCIsXG4gIG9uY2hhbmdlOiAoKSA9PiB7fSxcbiAgYnJhbmRTdHlsZTogXCJ5YVwiLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgRHJvcGRvd247XG4iXX0= */"));
var Label$3 = createStyled("label", "development" === "production" ? {
  target: "e1ezfbkq1"
} : {
  target: "e1ezfbkq1",
  label: "Label"
})("margin-bottom:6px;margin-top:16px;display:block;", function (_ref4) {
  var brandStyle = _ref4.brandStyle;
  return brandStyle === "yx" ? "\n    font-family: 'ClanOT Bold';\n    font-size: 13px;\n  " : "\n    font-size: 15px;\n  ";
}, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var SelectStyling = createStyled("select", "development" === "production" ? {
  target: "e1ezfbkq0"
} : {
  target: "e1ezfbkq0",
  label: "SelectStyling"
})("appearance:none;border:1px solid ", borderColorSelector, ";cursor:pointer;height:40px;padding-left:7px;width:100%;background:", white$3, ";border-radius:0px;font-size:15px;font-family:", fontSelector$1, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
function Dropdown(_ref5) {
  var id = _ref5.id,
    label = _ref5.label,
    options = _ref5.options,
    selected = _ref5.selected,
    onchange = _ref5.onchange,
    showError = _ref5.showError,
    brandStyle = _ref5.brandStyle;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, label && /*#__PURE__*/React__default.createElement(Label$3, {
    htmlFor: id,
    brandStyle: brandStyle
  }, label), /*#__PURE__*/React__default.createElement(BoxStyling, {
    brandStyle: brandStyle
  }, /*#__PURE__*/React__default.createElement(SelectStyling, {
    id: id,
    onChange: function onChange(e) {
      return onchange(e, id);
    },
    defaultValue: selected,
    brandStyle: brandStyle
  }, options.map(function (_ref6) {
    var value = _ref6.value,
      optionLabel = _ref6.label;
    return /*#__PURE__*/React__default.createElement("option", {
      key: value,
      value: value
    }, optionLabel);
  })), /*#__PURE__*/React__default.createElement(ErrorLabel, {
    id: id,
    showError: showError
  })));
}
var StringOrNumberPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);
Dropdown.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  options: PropTypes.arrayOf(PropTypes.shape({
    value: StringOrNumberPropType,
    label: StringOrNumberPropType
  })).isRequired,
  selected: StringOrNumberPropType,
  onchange: PropTypes.func,
  showError: PropTypes.string,
  brandStyle: PropTypes.oneOf(["ya", "yx"])
};
Dropdown.defaultProps = {
  label: "",
  showError: "",
  selected: "",
  onchange: function onchange() {},
  brandStyle: "ya"
};

var primaryGreen$8 = colors$1.primaryGreen,
  darkBlue$2 = colors$1.darkBlue,
  borderGrey$2 = colors$1.borderGrey;
var Label$2 = createStyled("label", "development" === "production" ? {
  target: "eo3wsir3"
} : {
  target: "eo3wsir3",
  label: "Label"
})("margin-bottom:6px;margin-top:16px;display:block;", function (_ref) {
  var brandStyle = _ref.brandStyle;
  return brandStyle === "yx" ? "\n    font-family: 'ClanOT Bold';\n    font-size: 13px;\n  " : "\n      font-size: 15px;\n  ";
}, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var SecondaryLabel = createStyled("span", "development" === "production" ? {
  target: "eo3wsir2"
} : {
  target: "eo3wsir2",
  label: "SecondaryLabel"
})("display:block;color:", function (_ref2) {
  var brandStyle = _ref2.brandStyle;
  return brandStyle === "yx" ? darkBlue$2 : primaryGreen$8;
}, ";font-size:13px;" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var WrapperDiv = createStyled("div", "development" === "production" ? {
  target: "eo3wsir1"
} : {
  target: "eo3wsir1",
  label: "WrapperDiv"
})("height:", function (_ref3) {
  var height = _ref3.height;
  return height;
}, ";position:relative;display:block;width:100%;", function (_ref4) {
  var isCurrency = _ref4.isCurrency,
    brandStyle = _ref4.brandStyle,
    height = _ref4.height;
  return isCurrency && "\n    &:after {\n      position: absolute;\n      top: ".concat(Number.isNaN(parseInt(height, 10)) ? 17 : (parseInt(height, 10) - 4) / 2 - 7, "px;\n      right: 9px;\n      content: 'kr';\n      box-sizing: border-box;\n      font-size: ").concat(brandStyle === "yx" ? "13px" : "14px", ";\n    }\n  ");
}, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImlucHV0LmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE4QjZCIiwiZmlsZSI6ImlucHV0LmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiO1xuaW1wb3J0IEVycm9yTGFiZWwgZnJvbSBcIi4uL2Vycm9ybGFiZWxcIjtcbmltcG9ydCBjb2xvcnMgZnJvbSBcIi4uLy4uLy4uL2NvbG9yc1wiO1xuXG5jb25zdCB7IHByaW1hcnlHcmVlbiwgZGFya0JsdWUsIGJvcmRlckdyZXkgfSA9IGNvbG9ycztcblxuY29uc3QgTGFiZWwgPSBzdHlsZWQubGFiZWxgXG4gIG1hcmdpbi1ib3R0b206IDZweDtcbiAgbWFyZ2luLXRvcDogMTZweDtcbiAgZGlzcGxheTogYmxvY2s7XG5cbiAgJHsoeyBicmFuZFN0eWxlIH0pID0+XG4gICAgYnJhbmRTdHlsZSA9PT0gXCJ5eFwiXG4gICAgICA/IGBcbiAgICBmb250LWZhbWlseTogJ0NsYW5PVCBCb2xkJztcbiAgICBmb250LXNpemU6IDEzcHg7XG4gIGBcbiAgICAgIDogYFxuICAgICAgZm9udC1zaXplOiAxNXB4O1xuICBgfVxuYDtcblxuY29uc3QgU2Vjb25kYXJ5TGFiZWwgPSBzdHlsZWQuc3BhbmBcbiAgZGlzcGxheTogYmxvY2s7XG4gIGNvbG9yOiAkeyh7IGJyYW5kU3R5bGUgfSkgPT4gKGJyYW5kU3R5bGUgPT09IFwieXhcIiA/IGRhcmtCbHVlIDogcHJpbWFyeUdyZWVuKX07XG4gIGZvbnQtc2l6ZTogMTNweDtcbmA7XG5cbmNvbnN0IFdyYXBwZXJEaXYgPSBzdHlsZWQuZGl2YFxuICBoZWlnaHQ6ICR7KHsgaGVpZ2h0IH0pID0+IGhlaWdodH07XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgZGlzcGxheTogYmxvY2s7XG4gIHdpZHRoOiAxMDAlO1xuXG4gICR7KHsgaXNDdXJyZW5jeSwgYnJhbmRTdHlsZSwgaGVpZ2h0IH0pID0+XG4gICAgaXNDdXJyZW5jeSAmJlxuICAgIGBcbiAgICAmOmFmdGVyIHtcbiAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgIHRvcDogJHtOdW1iZXIuaXNOYU4ocGFyc2VJbnQoaGVpZ2h0LCAxMCkpID8gMTcgOiAocGFyc2VJbnQoaGVpZ2h0LCAxMCkgLSA0KSAvIDIgLSA3fXB4O1xuICAgICAgcmlnaHQ6IDlweDtcbiAgICAgIGNvbnRlbnQ6ICdrcic7XG4gICAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICAgICAgZm9udC1zaXplOiAke2JyYW5kU3R5bGUgPT09IFwieXhcIiA/IFwiMTNweFwiIDogXCIxNHB4XCJ9O1xuICAgIH1cbiAgYH1cbmA7XG5cbmNvbnN0IElucHV0U3R5bGluZyA9IHN0eWxlZC5pbnB1dGBcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlO1xuICBwYWRkaW5nLWxlZnQ6IDhweDtcbiAgJHsoeyBpc0N1cnJlbmN5IH0pID0+IGlzQ3VycmVuY3kgJiYgXCJwYWRkaW5nLXJpZ2h0OiAyNHB4O1wifVxuICBtYXgtd2lkdGg6IDEwMCU7XG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gIGJvcmRlcjogMXB4IHNvbGlkICR7Ym9yZGVyR3JleX07XG4gIGJvcmRlci1yYWRpdXM6IDJweDtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAkeyh7IGJyYW5kU3R5bGUgfSkgPT5cbiAgICBicmFuZFN0eWxlID09PSBcInl4XCJcbiAgICAgID8gYFxuICAgIGZvbnQtZmFtaWx5OiAnQ2xhbk9UIE5ld3MnO1xuICAgIGZvbnQtc2l6ZTogMTNweDtcbiAgYFxuICAgICAgOiBgXG4gICAgZm9udC1mYW1pbHk6ICdNb250c2VycmF0JztcbiAgICBmb250LXNpemU6IDE0cHg7XG4gIGB9XG5gO1xuXG5mdW5jdGlvbiBJbnB1dCh7XG4gIGlkLFxuICB2YWx1ZSxcbiAgdHlwZSxcbiAgdGl0bGUsXG4gIHNlY29uZGFyeVRpdGxlLFxuICBwbGFjZWhvbGRlcixcbiAgaXNDdXJyZW5jeSxcbiAgb25ibHVyLFxuICBzaG93RXJyb3IsXG4gIGhlaWdodCxcbiAgYnJhbmRTdHlsZSxcbn0pIHtcbiAgY29uc3QgcGFyc2VBbW91bnQgPSAoYW1vdW50U3RyaW5nKSA9PiB7XG4gICAgY29uc3QgcGFyc2VkSW50ID0gTnVtYmVyLnBhcnNlSW50KGFtb3VudFN0cmluZy5yZXBsYWNlKC9bXjAtOV0vZywgXCJcIiksIDEwKTtcbiAgICByZXR1cm4gTnVtYmVyLmlzSW50ZWdlcihwYXJzZWRJbnQpID8gcGFyc2VkSW50IDogXCJcIjtcbiAgfTtcblxuICBjb25zdCBvbklucHV0ID0gKGUpID0+IHtcbiAgICBpZiAoaXNDdXJyZW5jeSkge1xuICAgICAgY29uc3QgYW1vdW50ID0gcGFyc2VBbW91bnQoZS50YXJnZXQudmFsdWUpO1xuICAgICAgZS50YXJnZXQudmFsdWUgPSBhbW91bnQudG9Mb2NhbGVTdHJpbmcoXCJub1wiKTtcbiAgICB9XG4gIH07XG5cbiAgY29uc3Qgb25CbHVyID0gKGUpID0+IHtcbiAgICBsZXQgZXZlbnQgPSBlO1xuICAgIGlmIChpc0N1cnJlbmN5KSB7XG4gICAgICBldmVudCA9IHtcbiAgICAgICAgdGFyZ2V0OiB7IHZhbHVlOiBwYXJzZUFtb3VudChlLnRhcmdldC52YWx1ZSkgfSxcbiAgICAgICAgcHJldmVudERlZmF1bHQ6IGUucHJldmVudERlZmF1bHQsXG4gICAgICB9O1xuICAgIH1cbiAgICBvbmJsdXIoZXZlbnQsIGlkKTtcbiAgfTtcblxuICByZXR1cm4gKFxuICAgIDw+XG4gICAgICB7dGl0bGUgJiYgKFxuICAgICAgICA8TGFiZWwgaHRtbEZvcj17aWR9IGJyYW5kU3R5bGU9e2JyYW5kU3R5bGV9PlxuICAgICAgICAgIHt0aXRsZX1cbiAgICAgICAgICB7c2Vjb25kYXJ5VGl0bGUgJiYgKFxuICAgICAgICAgICAgPFNlY29uZGFyeUxhYmVsIGJyYW5kU3R5bGU9e2JyYW5kU3R5bGV9PntzZWNvbmRhcnlUaXRsZX08L1NlY29uZGFyeUxhYmVsPlxuICAgICAgICAgICl9XG4gICAgICAgIDwvTGFiZWw+XG4gICAgICApfVxuICAgICAgPFdyYXBwZXJEaXYgaGVpZ2h0PXtoZWlnaHR9IGlzQ3VycmVuY3k9e2lzQ3VycmVuY3l9IGJyYW5kU3R5bGU9e2JyYW5kU3R5bGV9PlxuICAgICAgICA8SW5wdXRTdHlsaW5nXG4gICAgICAgICAgdHlwZT17dHlwZX1cbiAgICAgICAgICBpZD17aWR9XG4gICAgICAgICAgbmFtZT17aWR9XG4gICAgICAgICAgaGVpZ2h0PXtoZWlnaHR9XG4gICAgICAgICAgcGxhY2Vob2xkZXI9e3BsYWNlaG9sZGVyfVxuICAgICAgICAgIGRlZmF1bHRWYWx1ZT17dmFsdWV9XG4gICAgICAgICAgb25DaGFuZ2U9eyhlKSA9PiBlLnByZXZlbnREZWZhdWx0KCl9XG4gICAgICAgICAgb25CbHVyPXtvbkJsdXJ9XG4gICAgICAgICAgb25JbnB1dD17b25JbnB1dH1cbiAgICAgICAgICBicmFuZFN0eWxlPXticmFuZFN0eWxlfVxuICAgICAgICAgIGlzQ3VycmVuY3k9e2lzQ3VycmVuY3l9XG4gICAgICAgIC8+XG4gICAgICAgIDxFcnJvckxhYmVsIGlkPXtpZH0gc2hvd0Vycm9yPXtzaG93RXJyb3J9IC8+XG4gICAgICA8L1dyYXBwZXJEaXY+XG4gICAgPC8+XG4gICk7XG59XG5cbklucHV0LnByb3BUeXBlcyA9IHtcbiAgaWQ6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdmFsdWU6IFByb3BUeXBlcy5vbmVPZlR5cGUoW1Byb3BUeXBlcy5zdHJpbmcsIFByb3BUeXBlcy5udW1iZXJdKSxcbiAgdHlwZTogUHJvcFR5cGVzLnN0cmluZyxcbiAgdGl0bGU6IFByb3BUeXBlcy5vbmVPZlR5cGUoW1Byb3BUeXBlcy5zdHJpbmcsIFByb3BUeXBlcy5vYmplY3RdKSxcbiAgc2Vjb25kYXJ5VGl0bGU6IFByb3BUeXBlcy5zdHJpbmcsXG4gIHBsYWNlaG9sZGVyOiBQcm9wVHlwZXMuc3RyaW5nLFxuICBpc0N1cnJlbmN5OiBQcm9wVHlwZXMuYm9vbCxcbiAgb25ibHVyOiBQcm9wVHlwZXMuZnVuYyxcbiAgaGVpZ2h0OiBQcm9wVHlwZXMuc3RyaW5nLFxuICBzaG93RXJyb3I6IFByb3BUeXBlcy5zdHJpbmcsXG4gIGJyYW5kU3R5bGU6IFByb3BUeXBlcy5vbmVPZihbXCJ5YVwiLCBcInl4XCJdKSxcbn07XG5cbklucHV0LmRlZmF1bHRQcm9wcyA9IHtcbiAgdmFsdWU6IFwiXCIsXG4gIHR5cGU6IFwidGV4dFwiLFxuICB0aXRsZTogXCJcIixcbiAgc2Vjb25kYXJ5VGl0bGU6IFwiXCIsXG4gIHNob3dFcnJvcjogXCJcIixcbiAgcGxhY2Vob2xkZXI6IFwiXCIsXG4gIGlzQ3VycmVuY3k6IGZhbHNlLFxuICBvbmJsdXI6ICgpID0+IHt9LFxuICBoZWlnaHQ6IFwiNTBweFwiLFxuICBicmFuZFN0eWxlOiBcInlhXCIsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBJbnB1dDtcbiJdfQ== */"));
var InputStyling = createStyled("input", "development" === "production" ? {
  target: "eo3wsir0"
} : {
  target: "eo3wsir0",
  label: "InputStyling"
})("display:inline-block;width:100%;height:100%;padding-left:8px;", function (_ref5) {
  var isCurrency = _ref5.isCurrency;
  return isCurrency && "padding-right: 24px;";
}, " max-width:100%;box-sizing:border-box;border:1px solid ", borderGrey$2, ";border-radius:2px;position:relative;", function (_ref6) {
  var brandStyle = _ref6.brandStyle;
  return brandStyle === "yx" ? "\n    font-family: 'ClanOT News';\n    font-size: 13px;\n  " : "\n    font-family: 'Montserrat';\n    font-size: 14px;\n  ";
}, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
function Input$1(_ref7) {
  var id = _ref7.id,
    value = _ref7.value,
    type = _ref7.type,
    title = _ref7.title,
    secondaryTitle = _ref7.secondaryTitle,
    placeholder = _ref7.placeholder,
    isCurrency = _ref7.isCurrency,
    onblur = _ref7.onblur,
    showError = _ref7.showError,
    height = _ref7.height,
    brandStyle = _ref7.brandStyle;
  var parseAmount = function parseAmount(amountString) {
    var parsedInt = Number.parseInt(amountString.replace(/[^0-9]/g, ""), 10);
    return Number.isInteger(parsedInt) ? parsedInt : "";
  };
  var onInput = function onInput(e) {
    if (isCurrency) {
      var amount = parseAmount(e.target.value);
      e.target.value = amount.toLocaleString("no");
    }
  };
  var onBlur = function onBlur(e) {
    var event = e;
    if (isCurrency) {
      event = {
        target: {
          value: parseAmount(e.target.value)
        },
        preventDefault: e.preventDefault
      };
    }
    onblur(event, id);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, title && /*#__PURE__*/React__default.createElement(Label$2, {
    htmlFor: id,
    brandStyle: brandStyle
  }, title, secondaryTitle && /*#__PURE__*/React__default.createElement(SecondaryLabel, {
    brandStyle: brandStyle
  }, secondaryTitle)), /*#__PURE__*/React__default.createElement(WrapperDiv, {
    height: height,
    isCurrency: isCurrency,
    brandStyle: brandStyle
  }, /*#__PURE__*/React__default.createElement(InputStyling, {
    type: type,
    id: id,
    name: id,
    height: height,
    placeholder: placeholder,
    defaultValue: value,
    onChange: function onChange(e) {
      return e.preventDefault();
    },
    onBlur: onBlur,
    onInput: onInput,
    brandStyle: brandStyle,
    isCurrency: isCurrency
  }), /*#__PURE__*/React__default.createElement(ErrorLabel, {
    id: id,
    showError: showError
  })));
}
Input$1.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  secondaryTitle: PropTypes.string,
  placeholder: PropTypes.string,
  isCurrency: PropTypes.bool,
  onblur: PropTypes.func,
  height: PropTypes.string,
  showError: PropTypes.string,
  brandStyle: PropTypes.oneOf(["ya", "yx"])
};
Input$1.defaultProps = {
  value: "",
  type: "text",
  title: "",
  secondaryTitle: "",
  showError: "",
  placeholder: "",
  isCurrency: false,
  onblur: function onblur() {},
  height: "50px",
  brandStyle: "ya"
};

var infoYa = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%2222px%22%20height%3D%2222px%22%20viewBox%3D%220%200%2022%2022%22%20enable-background%3D%22new%200%200%2022%2022%22%20xml%3Aspace%3D%22preserve%22%3E%3Cpath%20fill%3D%22%23003c3c%22%20d%3D%22M11.1%2C0.5C5.2%2C0.5%2C0.5%2C5.2%2C0.5%2C11.1c0%2C5.9%2C4.7%2C10.6%2C10.6%2C10.6c5.9%2C0%2C10.6-4.7%2C10.6-10.6%20C21.7%2C5.2%2C16.9%2C0.5%2C11.1%2C0.5z%20M12.1%2C17.5h-2V8.2h2V17.5z%20M12.1%2C6.5h-2V4.7h2V6.5z%22%2F%3E%3C%2Fsvg%3E";

var infoYx = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%2222px%22%20height%3D%2222px%22%20viewBox%3D%220%200%2022%2022%22%20enable-background%3D%22new%200%200%2022%2022%22%20xml%3Aspace%3D%22preserve%22%3E%3Cpath%20fill%3D%22%23002751%22%20d%3D%22M11.1%2C0.5C5.2%2C0.5%2C0.5%2C5.2%2C0.5%2C11.1c0%2C5.9%2C4.7%2C10.6%2C10.6%2C10.6c5.9%2C0%2C10.6-4.7%2C10.6-10.6%20C21.7%2C5.2%2C16.9%2C0.5%2C11.1%2C0.5z%20M12.1%2C17.5h-2V8.2h2V17.5z%20M12.1%2C6.5h-2V4.7h2V6.5z%22%2F%3E%3C%2Fsvg%3E";

var fontSelector = function fontSelector(_ref) {
  var brandStyle = _ref.brandStyle;
  return brandStyle === "yx" ? "ClanOT News" : "Montserrat";
};
var PopperTooltip = createStyled("div", "development" === "production" ? {
  target: "e1y0oh301"
} : {
  target: "e1y0oh301",
  label: "PopperTooltip"
})("z-index:99;background-color:white;border:solid black 1px;border-radius:5px;padding:5px;max-width:90%;font-size:16px;white-space:normal;font-family:", fontSelector, ";*{white-space:normal;font-size:16px;font-family:", fontSelector, ";}" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var PopperButton = createStyled("button", "development" === "production" ? {
  target: "e1y0oh300"
} : {
  target: "e1y0oh300",
  label: "PopperButton"
})("position:absolute;float:right;margin-left:4px;margin-top:", function (props) {
  return props.iconMarginTop ? props.iconMarginTop : "unset";
}, ";margin-bottom:", function (props) {
  return props.iconMarginBottom ? props.iconMarginBottom : "unset";
}, ";width:22px;height:27px;border:none;background-color:transparent;background-image:url(\"", function (_ref2) {
  var brandStyle = _ref2.brandStyle;
  return brandStyle === "yx" ? infoYx : infoYa;
}, "\");background-repeat:no-repeat;" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
function Popover(_ref3) {
  var id = _ref3.id,
    text = _ref3.text,
    iconMarginTop = _ref3.iconMarginTop,
    iconMarginBottom = _ref3.iconMarginBottom,
    brandStyle = _ref3.brandStyle;
  var _useState = useState(null),
    _useState2 = _slicedToArray$2(_useState, 2),
    referenceElement = _useState2[0],
    setReferenceElement = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray$2(_useState3, 2),
    popperElement = _useState4[0],
    setPopperElement = _useState4[1];
  var _usePopper = usePopper(referenceElement, popperElement, {
      placement: "auto"
    }),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;
  var _useState5 = useState(false),
    _useState6 = _slicedToArray$2(_useState5, 2),
    shouldShow = _useState6[0],
    setShouldShow = _useState6[1];
  useEffect(function () {
    if (shouldShow && popperElement) popperElement.focus({
      preventScroll: true
    });
  }, [shouldShow, popperElement]);
  var handleOnBlur = function handleOnBlur(event) {
    var node = event.nativeEvent.relatedTarget;
    var hasFound = false;
    // If related target is a child of tooltip, the focus should remain.

    while (node && !hasFound) {
      if (node.id === popperElement.id) {
        hasFound = true;
      } else {
        node = node.parentElement;
      }
    }
    if (!hasFound) {
      setShouldShow(false);
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PopperButton, {
    id: id,
    ref: setReferenceElement,
    type: "button",
    onClick: function onClick() {
      return setShouldShow(true);
    },
    iconMarginBottom: iconMarginBottom,
    iconMarginTop: iconMarginTop,
    brandStyle: brandStyle
  }), shouldShow && /*#__PURE__*/React__default.createElement(PopperTooltip, _extends$2({
    brandStyle: brandStyle,
    id: "tooltip-".concat(id),
    tabIndex: "-1",
    onBlur: handleOnBlur,
    ref: setPopperElement,
    style: styles.popper
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, attributes.popper), text));
}
Popover.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.node.isRequired,
  iconMarginTop: PropTypes.string,
  iconMarginBottom: PropTypes.string,
  brandStyle: PropTypes.oneOf(["ya", "yx"])
};
Popover.defaultProps = {
  brandStyle: "ya",
  iconMarginTop: undefined,
  iconMarginBottom: undefined
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$J() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var primaryGreen$7 = colors$1.primaryGreen,
  primaryRed = colors$1.primaryRed,
  freshRed = colors$1.freshRed,
  textGrey = colors$1.textGrey,
  darkBlue$1 = colors$1.darkBlue,
  borderGrey$1 = colors$1.borderGrey;
var colorSelector = function colorSelector(_ref) {
  var brandStyle = _ref.brandStyle;
  return brandStyle === "yx" ? darkBlue$1 : primaryGreen$7;
};
var StandardInput = createStyled("input", "development" === "production" ? {
  target: "e7cro5414"
} : {
  target: "e7cro5414",
  label: "StandardInput"
})("width:", function (props) {
  return props.width || "300px";
}, ";height:50px;border:1px solid ", primaryGreen$7, ";border-radius:5px;text-align:center;color:", primaryGreen$7, "!important;font-weight:bold;&:focus{outline:none!important;box-shadow:none;border-color:", primaryGreen$7, ";}outline-color:", primaryGreen$7, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var StandardSelect = createStyled("select", "development" === "production" ? {
  target: "e7cro5413"
} : {
  target: "e7cro5413",
  label: "StandardSelect"
})("width:", function (props) {
  return props.width || "300px";
}, ";height:50px;border:1px solid ", primaryGreen$7, ";border-radius:5px;text-align:center;color:", primaryGreen$7, "!important;font-weight:bold;&:focus{outline:none!important;box-shadow:none;border-color:", primaryGreen$7, ";}outline-color:", primaryGreen$7, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var StandardCheckbox = createStyled("input", "development" === "production" ? {
  target: "e7cro5412"
} : {
  target: "e7cro5412",
  label: "StandardCheckbox"
})("development" === "production" ? {
  name: "rrel8y",
  styles: "width:24px;height:24px"
} : {
  name: "rrel8y",
  styles: "width:24px;height:24px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$J
});
var BigButton = createStyled("button", "development" === "production" ? {
  target: "e7cro5411"
} : {
  target: "e7cro5411",
  label: "BigButton"
})("padding:15px 60px;font-weight:bold;margin-left:auto;margin-right:auto;margin:0 auto;display:block;font-size:large;", function (_ref2) {
  var brandStyle = _ref2.brandStyle;
  return brandStyle === "yx" ? "\n        border-radius: 500px;\n        border: 1px ".concat(freshRed, " solid;\n        background-color: ").concat(freshRed, ";\n    ") : "\n        border-radius: 5px;\n        border: 2px ".concat(primaryRed, " solid;\n        background-color: ").concat(primaryRed, ";\n    ");
}, " color:white;transition-property:background-color,color;transition-duration:0.15s;&:hover:not([disabled]){background-color:white;color:", function (_ref3) {
  var brandStyle = _ref3.brandStyle;
  return brandStyle === "yx" ? textGrey : primaryRed;
}, ";cursor:pointer;}&:disabled{opacity:0.7;}" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Label$1 = createStyled("label", "development" === "production" ? {
  target: "e7cro5410"
} : {
  target: "e7cro5410",
  label: "Label"
})("margin-bottom:6px;", function (_ref4) {
  var _ref4$topMargin = _ref4.topMargin,
    topMargin = _ref4$topMargin === void 0 ? true : _ref4$topMargin;
  return topMargin ? "\n    margin-top: 16px;\n  " : "\n    margin-top: 0px;\n  ";
}, " display:block;", function (_ref5) {
  var brandStyle = _ref5.brandStyle;
  return brandStyle === "yx" ? "\n        font-family: 'ClanOT News';\n        font-size: 13px;\n    " : "\n        font-size: 15px;\n    ";
}, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var SubLabel = createStyled("label", "development" === "production" ? {
  target: "e7cro549"
} : {
  target: "e7cro549",
  label: "SubLabel"
})("margin-bottom:6px;margin-top:0px;display:block;", function (_ref6) {
  var brandStyle = _ref6.brandStyle;
  return brandStyle === "yx" ? "\n        font-family: 'ClanOT News';\n        font-size: 13px;\n    " : "\n        font-size: 15px;\n    ";
}, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Legend = createStyled("legend", "development" === "production" ? {
  target: "e7cro548"
} : {
  target: "e7cro548",
  label: "Legend"
})("margin-top:16px;float:left;display:inline-block;overflow:hidden;color:#1c1c1b;border-bottom:1px solid ", colorSelector, ";width:100%;box-sizing:border-box;", function (_ref7) {
  var brandStyle = _ref7.brandStyle;
  return brandStyle === "yx" ? "\n        padding: 0 0 0.4em 0;\n        font-family: 'ClanOT Bold';\n        font-size: 18px;\n        line-height: 20px;\n    " : "\n        padding: 0.5rem 0px;\n        font-weight: 600;\n        font-size: 30px;\n        line-height: 4rem;\n    ";
}, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlZENvbXBvbmVudHMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0htQyIsImZpbGUiOiJzdHlsZWRDb21wb25lbnRzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCI7XG5pbXBvcnQgY29sb3JzIGZyb20gXCIuLi8uLi9jb2xvcnNcIjtcblxuY29uc3QgeyBwcmltYXJ5R3JlZW4sIHByaW1hcnlSZWQsIGZyZXNoUmVkLCB0ZXh0R3JleSwgZGFya0JsdWUsIGJvcmRlckdyZXkgfSA9IGNvbG9ycztcbmNvbnN0IGNvbG9yU2VsZWN0b3IgPSAoeyBicmFuZFN0eWxlIH0pID0+IChicmFuZFN0eWxlID09PSBcInl4XCIgPyBkYXJrQmx1ZSA6IHByaW1hcnlHcmVlbik7XG5cbmV4cG9ydCBjb25zdCBTdGFuZGFyZElucHV0ID0gc3R5bGVkLmlucHV0YFxuICB3aWR0aDogJHsocHJvcHMpID0+IHByb3BzLndpZHRoIHx8IFwiMzAwcHhcIn07XG4gIGhlaWdodDogNTBweDtcbiAgYm9yZGVyOiAxcHggc29saWQgJHtwcmltYXJ5R3JlZW59O1xuICBib3JkZXItcmFkaXVzOiA1cHg7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgY29sb3I6ICR7cHJpbWFyeUdyZWVufSFpbXBvcnRhbnQ7XG4gIGZvbnQtd2VpZ2h0OiBib2xkO1xuICAmOmZvY3VzIHtcbiAgICBvdXRsaW5lOiBub25lICFpbXBvcnRhbnQ7XG4gICAgYm94LXNoYWRvdzogbm9uZTtcbiAgICBib3JkZXItY29sb3I6ICR7cHJpbWFyeUdyZWVufTtcbiAgfVxuICBvdXRsaW5lLWNvbG9yOiAke3ByaW1hcnlHcmVlbn07XG5gO1xuZXhwb3J0IGNvbnN0IFN0YW5kYXJkU2VsZWN0ID0gc3R5bGVkLnNlbGVjdGBcbiAgd2lkdGg6ICR7KHByb3BzKSA9PiBwcm9wcy53aWR0aCB8fCBcIjMwMHB4XCJ9O1xuICBoZWlnaHQ6IDUwcHg7XG4gIGJvcmRlcjogMXB4IHNvbGlkICR7cHJpbWFyeUdyZWVufTtcbiAgYm9yZGVyLXJhZGl1czogNXB4O1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gIGNvbG9yOiAke3ByaW1hcnlHcmVlbn0haW1wb3J0YW50O1xuICBmb250LXdlaWdodDogYm9sZDtcbiAgJjpmb2N1cyB7XG4gICAgb3V0bGluZTogbm9uZSAhaW1wb3J0YW50O1xuICAgIGJveC1zaGFkb3c6IG5vbmU7XG4gICAgYm9yZGVyLWNvbG9yOiAke3ByaW1hcnlHcmVlbn07XG4gIH1cbiAgb3V0bGluZS1jb2xvcjogJHtwcmltYXJ5R3JlZW59O1xuYDtcblxuZXhwb3J0IGNvbnN0IFN0YW5kYXJkQ2hlY2tib3ggPSBzdHlsZWQuaW5wdXRgXG4gIHdpZHRoOiAyNHB4O1xuICBoZWlnaHQ6IDI0cHg7XG5gO1xuXG5leHBvcnQgY29uc3QgQmlnQnV0dG9uID0gc3R5bGVkLmJ1dHRvbmBcbiAgcGFkZGluZzogMTVweCA2MHB4O1xuICBmb250LXdlaWdodDogYm9sZDtcbiAgbWFyZ2luLWxlZnQ6IGF1dG87XG4gIG1hcmdpbi1yaWdodDogYXV0bztcbiAgbWFyZ2luOiAwIGF1dG87XG4gIGRpc3BsYXk6IGJsb2NrO1xuICBmb250LXNpemU6IGxhcmdlO1xuICAkeyh7IGJyYW5kU3R5bGUgfSkgPT5cbiAgICBicmFuZFN0eWxlID09PSBcInl4XCJcbiAgICAgID8gYFxuICAgICAgICBib3JkZXItcmFkaXVzOiA1MDBweDtcbiAgICAgICAgYm9yZGVyOiAxcHggJHtmcmVzaFJlZH0gc29saWQ7XG4gICAgICAgIGJhY2tncm91bmQtY29sb3I6ICR7ZnJlc2hSZWR9O1xuICAgIGBcbiAgICAgIDogYFxuICAgICAgICBib3JkZXItcmFkaXVzOiA1cHg7XG4gICAgICAgIGJvcmRlcjogMnB4ICR7cHJpbWFyeVJlZH0gc29saWQ7XG4gICAgICAgIGJhY2tncm91bmQtY29sb3I6ICR7cHJpbWFyeVJlZH07XG4gICAgYH1cbiAgY29sb3I6IHdoaXRlO1xuXG4gIHRyYW5zaXRpb24tcHJvcGVydHk6IGJhY2tncm91bmQtY29sb3IsIGNvbG9yO1xuICB0cmFuc2l0aW9uLWR1cmF0aW9uOiAwLjE1cztcblxuICAmOmhvdmVyOm5vdChbZGlzYWJsZWRdKSB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogd2hpdGU7XG4gICAgY29sb3I6ICR7KHsgYnJhbmRTdHlsZSB9KSA9PiAoYnJhbmRTdHlsZSA9PT0gXCJ5eFwiID8gdGV4dEdyZXkgOiBwcmltYXJ5UmVkKX07XG4gICAgY3Vyc29yOiBwb2ludGVyO1xuICB9XG4gICY6ZGlzYWJsZWQge1xuICAgIG9wYWNpdHk6IDAuNztcbiAgfVxuYDtcblxuZXhwb3J0IGNvbnN0IExhYmVsID0gc3R5bGVkLmxhYmVsYFxuICBtYXJnaW4tYm90dG9tOiA2cHg7XG4gICR7KHsgdG9wTWFyZ2luID0gdHJ1ZSB9KSA9PlxuICAgIHRvcE1hcmdpblxuICAgICAgPyBgXG4gICAgbWFyZ2luLXRvcDogMTZweDtcbiAgYFxuICAgICAgOiBgXG4gICAgbWFyZ2luLXRvcDogMHB4O1xuICBgfVxuICBkaXNwbGF5OiBibG9jaztcbiAgJHsoeyBicmFuZFN0eWxlIH0pID0+XG4gICAgYnJhbmRTdHlsZSA9PT0gXCJ5eFwiXG4gICAgICA/IGBcbiAgICAgICAgZm9udC1mYW1pbHk6ICdDbGFuT1QgTmV3cyc7XG4gICAgICAgIGZvbnQtc2l6ZTogMTNweDtcbiAgICBgXG4gICAgICA6IGBcbiAgICAgICAgZm9udC1zaXplOiAxNXB4O1xuICAgIGB9XG5gO1xuXG5leHBvcnQgY29uc3QgU3ViTGFiZWwgPSBzdHlsZWQubGFiZWxgXG4gIG1hcmdpbi1ib3R0b206IDZweDtcbiAgbWFyZ2luLXRvcDogMHB4O1xuICBkaXNwbGF5OiBibG9jaztcbiAgJHsoeyBicmFuZFN0eWxlIH0pID0+XG4gICAgYnJhbmRTdHlsZSA9PT0gXCJ5eFwiXG4gICAgICA/IGBcbiAgICAgICAgZm9udC1mYW1pbHk6ICdDbGFuT1QgTmV3cyc7XG4gICAgICAgIGZvbnQtc2l6ZTogMTNweDtcbiAgICBgXG4gICAgICA6IGBcbiAgICAgICAgZm9udC1zaXplOiAxNXB4O1xuICAgIGB9XG5gO1xuXG5leHBvcnQgY29uc3QgTGVnZW5kID0gc3R5bGVkLmxlZ2VuZGBcbiAgbWFyZ2luLXRvcDogMTZweDtcbiAgZmxvYXQ6IGxlZnQ7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgY29sb3I6ICMxYzFjMWI7XG4gIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCAke2NvbG9yU2VsZWN0b3J9O1xuICB3aWR0aDogMTAwJTtcbiAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgJHsoeyBicmFuZFN0eWxlIH0pID0+XG4gICAgYnJhbmRTdHlsZSA9PT0gXCJ5eFwiXG4gICAgICA/IGBcbiAgICAgICAgcGFkZGluZzogMCAwIDAuNGVtIDA7XG4gICAgICAgIGZvbnQtZmFtaWx5OiAnQ2xhbk9UIEJvbGQnO1xuICAgICAgICBmb250LXNpemU6IDE4cHg7XG4gICAgICAgIGxpbmUtaGVpZ2h0OiAyMHB4O1xuICAgIGBcbiAgICAgIDogYFxuICAgICAgICBwYWRkaW5nOiAwLjVyZW0gMHB4O1xuICAgICAgICBmb250LXdlaWdodDogNjAwO1xuICAgICAgICBmb250LXNpemU6IDMwcHg7XG4gICAgICAgIGxpbmUtaGVpZ2h0OiA0cmVtO1xuICAgIGB9XG5gO1xuXG5leHBvcnQgY29uc3QgUm93ID0gc3R5bGVkLmRpdmBcbiAgbWFyZ2luLWJvdHRvbTogNHB4O1xuICB3aWR0aDogMTAwJTtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuXG4gIEBtZWRpYSAobWF4LXdpZHRoOiA3NjhweCkge1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIH1cbmA7XG5cbmV4cG9ydCBjb25zdCBSb3dGbHVpZCA9IHN0eWxlZC5kaXZgXG4gIG1hcmdpbi1ib3R0b206IDRweDtcbiAgd2lkdGg6IDEwMCU7XG4gIGRpc3BsYXk6IGJsb2NrO1xuYDtcblxuZXhwb3J0IGNvbnN0IFNwYW4gPSBzdHlsZWQuc3BhbmBcbiAgd2lkdGg6IDQ5LjM3NSU7XG5cbiAgQG1lZGlhIChtYXgtd2lkdGg6IDc2OHB4KSB7XG4gICAgd2lkdGg6IDEwMCU7XG4gIH1cbmA7XG5cbmV4cG9ydCBjb25zdCBTcGFuRnVsbCA9IHN0eWxlZC5zcGFuYFxuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICBmbG9hdDogbGVmdDtcbiAgd2lkdGg6IDEwMCU7XG5gO1xuXG5leHBvcnQgY29uc3QgU3BhbkJveCA9IHN0eWxlZC5zcGFuYFxuICB3aWR0aDogNDkuMzc1JTtcblxuICBAbWVkaWEgKG1heC13aWR0aDogNzY4cHgpIHtcbiAgICB3aWR0aDogMTAwJTtcbiAgfVxuXG4gIGJvcmRlcjogMXB4IHNvbGlkICR7Ym9yZGVyR3JleX07XG4gIHBhZGRpbmc6IDFlbTtcbmA7XG5cbmV4cG9ydCBjb25zdCBQYXJhZ3JhcGggPSBzdHlsZWQucGBcbiAgY29sb3I6ICR7Y29sb3JTZWxlY3Rvcn07XG4gIG1hcmdpbi10b3A6IDZweDtcbiAgbWFyZ2luLWJvdHRvbTogMHB4O1xuXG4gICR7KHsgYnJhbmRTdHlsZSB9KSA9PlxuICAgIGJyYW5kU3R5bGUgPT09IFwieXhcIlxuICAgICAgPyBgXG4gICAgICAgIGZvbnQtZmFtaWx5OiAnQ2xhbk9UIEJvbGQnO1xuICAgICAgICBmb250LXNpemU6IDEycHg7XG4gICAgYFxuICAgICAgOiBgXG4gICAgICAgIGZvbnQtc2l6ZTogMTVweDtcbiAgICBgfVxuYDtcblxuZXhwb3J0IGNvbnN0IFRleHRBcmVhID0gc3R5bGVkLnRleHRhcmVhYFxuICBkaXNwbGF5OiBibG9jaztcbiAgd2lkdGg6IDEwMCU7XG4gIG1pbi1oZWlnaHQ6IDcycHg7XG4gIHBhZGRpbmc6IDhweCAxMHB4O1xuICBmb250LXNpemU6IDEzcHg7XG5gO1xuXG5leHBvcnQgY29uc3QgQUxpbmsgPSBzdHlsZWQuYWBcbiAgY29sb3I6ICR7Y29sb3JTZWxlY3Rvcn07XG4gIHRleHQtZGVjb3JhdGlvbjogbm9uZTtcbiAgZm9udC13ZWlnaHQ6IDYwMDtcbiAgY3Vyc29yOiBwb2ludGVyO1xuICBwYWRkaW5nOiAzcHg7XG5cbiAgJjpob3ZlciB7XG4gICAgdGV4dC1kZWNvcmF0aW9uOiB1bmRlcmxpbmU7XG4gIH1cbmA7XG4iXX0= */"));
var Row$2 = createStyled("div", "development" === "production" ? {
  target: "e7cro547"
} : {
  target: "e7cro547",
  label: "Row"
})("development" === "production" ? {
  name: "2vrf67",
  styles: "margin-bottom:4px;width:100%;display:flex;flex-direction:row;justify-content:space-between;@media (max-width: 768px){flex-direction:column;}"
} : {
  name: "2vrf67",
  styles: "margin-bottom:4px;width:100%;display:flex;flex-direction:row;justify-content:space-between;@media (max-width: 768px){flex-direction:column;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$J
});
var RowFluid = createStyled("div", "development" === "production" ? {
  target: "e7cro546"
} : {
  target: "e7cro546",
  label: "RowFluid"
})("development" === "production" ? {
  name: "pos8gj",
  styles: "margin-bottom:4px;width:100%;display:block"
} : {
  name: "pos8gj",
  styles: "margin-bottom:4px;width:100%;display:block",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$J
});
var Span$1 = createStyled("span", "development" === "production" ? {
  target: "e7cro545"
} : {
  target: "e7cro545",
  label: "Span"
})("development" === "production" ? {
  name: "1wuka4b",
  styles: "width:49.375%;@media (max-width: 768px){width:100%;}"
} : {
  name: "1wuka4b",
  styles: "width:49.375%;@media (max-width: 768px){width:100%;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$J
});
var SpanFull = createStyled("span", "development" === "production" ? {
  target: "e7cro544"
} : {
  target: "e7cro544",
  label: "SpanFull"
})("development" === "production" ? {
  name: "1efk0yw",
  styles: "box-sizing:border-box;float:left;width:100%"
} : {
  name: "1efk0yw",
  styles: "box-sizing:border-box;float:left;width:100%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$J
});
var SpanBox = createStyled("span", "development" === "production" ? {
  target: "e7cro543"
} : {
  target: "e7cro543",
  label: "SpanBox"
})("width:49.375%;@media (max-width: 768px){width:100%;}border:1px solid ", borderGrey$1, ";padding:1em;" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Paragraph$1 = createStyled("p", "development" === "production" ? {
  target: "e7cro542"
} : {
  target: "e7cro542",
  label: "Paragraph"
})("color:", colorSelector, ";margin-top:6px;margin-bottom:0px;", function (_ref8) {
  var brandStyle = _ref8.brandStyle;
  return brandStyle === "yx" ? "\n        font-family: 'ClanOT Bold';\n        font-size: 12px;\n    " : "\n        font-size: 15px;\n    ";
}, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var TextArea = createStyled("textarea", "development" === "production" ? {
  target: "e7cro541"
} : {
  target: "e7cro541",
  label: "TextArea"
})("development" === "production" ? {
  name: "11h49o0",
  styles: "display:block;width:100%;min-height:72px;padding:8px 10px;font-size:13px"
} : {
  name: "11h49o0",
  styles: "display:block;width:100%;min-height:72px;padding:8px 10px;font-size:13px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$J
});
var ALink = createStyled("a", "development" === "production" ? {
  target: "e7cro540"
} : {
  target: "e7cro540",
  label: "ALink"
})("color:", colorSelector, ";text-decoration:none;font-weight:600;cursor:pointer;padding:3px;&:hover{text-decoration:underline;}" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var checkedIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%2225px%22%20height%3D%2226px%22%20viewBox%3D%220%200%2025%2026%22%20enable-background%3D%22new%200%200%2025%2026%22%20xml%3Aspace%3D%22preserve%22%3E%3Cg%3E%20%3Ccircle%20fill%3D%22%23FFFFFF%22%20cx%3D%2213%22%20cy%3D%2213%22%20r%3D%2211.7%22%2F%3E%3C%2Fg%3E%3Cpath%20fill%3D%22%23003c3c%22%20d%3D%22M12.5%2C0.9C5.8%2C0.9%2C0.4%2C6.3%2C0.4%2C13c0%2C6.7%2C5.4%2C12.1%2C12.1%2C12.1S24.6%2C19.7%2C24.6%2C13C24.6%2C6.3%2C19.2%2C0.9%2C12.5%2C0.9z%20%20M12.5%2C24.2c-6.2%2C0-11.2-5-11.2-11.2s5-11.2%2C11.2-11.2s11.2%2C5%2C11.2%2C11.2S18.7%2C24.2%2C12.5%2C24.2z%22%2F%3E%3Cg%3E%20%3Ccircle%20fill%3D%22%23003c3c%22%20cx%3D%2212.9%22%20cy%3D%2212.8%22%20r%3D%227.5%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var uncheckedIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%2225px%22%20height%3D%2226px%22%20viewBox%3D%220%200%2025%2026%22%20enable-background%3D%22new%200%200%2025%2026%22%20xml%3Aspace%3D%22preserve%22%3E%3Cg%3E%20%3Ccircle%20fill%3D%22%23FFFFFF%22%20cx%3D%2213%22%20cy%3D%2213%22%20r%3D%2211.7%22%2F%3E%3C%2Fg%3E%3Cpath%20fill%3D%22%23003c3c%22%20d%3D%22M12.5%2C0.9C5.8%2C0.9%2C0.4%2C6.3%2C0.4%2C13c0%2C6.7%2C5.4%2C12.1%2C12.1%2C12.1S24.6%2C19.7%2C24.6%2C13C24.6%2C6.3%2C19.2%2C0.9%2C12.5%2C0.9z%20%20M12.5%2C24.2c-6.2%2C0-11.2-5-11.2-11.2s5-11.2%2C11.2-11.2s11.2%2C5%2C11.2%2C11.2S18.7%2C24.2%2C12.5%2C24.2z%22%2F%3E%3C%2Fsvg%3E";

var checkedIconYx = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%2225px%22%20height%3D%2226px%22%20viewBox%3D%220%200%2025%2026%22%20enable-background%3D%22new%200%200%2025%2026%22%20xml%3Aspace%3D%22preserve%22%3E%3Cg%3E%20%3Ccircle%20fill%3D%22%23FFFFFF%22%20cx%3D%2213%22%20cy%3D%2213%22%20r%3D%2211.7%22%2F%3E%3C%2Fg%3E%3Cpath%20fill%3D%22%23000%22%20d%3D%22M12.5%2C0.9C5.8%2C0.9%2C0.4%2C6.3%2C0.4%2C13c0%2C6.7%2C5.4%2C12.1%2C12.1%2C12.1S24.6%2C19.7%2C24.6%2C13C24.6%2C6.3%2C19.2%2C0.9%2C12.5%2C0.9z%20%20M12.5%2C24.2c-6.2%2C0-11.2-5-11.2-11.2s5-11.2%2C11.2-11.2s11.2%2C5%2C11.2%2C11.2S18.7%2C24.2%2C12.5%2C24.2z%22%2F%3E%3Cg%3E%20%3Ccircle%20fill%3D%22%23002751%22%20cx%3D%2212.9%22%20cy%3D%2212.8%22%20r%3D%227.5%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var uncheckedIconYx = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20%20width%3D%2225px%22%20height%3D%2226px%22%20viewBox%3D%220%200%2025%2026%22%20enable-background%3D%22new%200%200%2025%2026%22%20xml%3Aspace%3D%22preserve%22%3E%3Cg%3E%20%3Ccircle%20fill%3D%22%23FFFFFF%22%20cx%3D%2213%22%20cy%3D%2213%22%20r%3D%2211.7%22%2F%3E%3C%2Fg%3E%3Cpath%20fill%3D%22%23000%22%20d%3D%22M12.5%2C0.9C5.8%2C0.9%2C0.4%2C6.3%2C0.4%2C13c0%2C6.7%2C5.4%2C12.1%2C12.1%2C12.1S24.6%2C19.7%2C24.6%2C13C24.6%2C6.3%2C19.2%2C0.9%2C12.5%2C0.9z%20%20M12.5%2C24.2c-6.2%2C0-11.2-5-11.2-11.2s5-11.2%2C11.2-11.2s11.2%2C5%2C11.2%2C11.2S18.7%2C24.2%2C12.5%2C24.2z%22%2F%3E%3C%2Fsvg%3E";

function _EMOTION_STRINGIFIED_CSS_ERROR__$I() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var iconSelector = function iconSelector(_ref) {
  var checked = _ref.checked,
    brandStyle = _ref.brandStyle;
  if (brandStyle === "yx") return checked ? checkedIconYx : uncheckedIconYx;
  return checked ? checkedIcon : uncheckedIcon;
};
var StyledInput$2 = createStyled("input", "development" === "production" ? {
  target: "e1x45o1p1"
} : {
  target: "e1x45o1p1",
  label: "StyledInput"
})("development" === "production" ? {
  name: "c8mmhi",
  styles: "opacity:0;position:absolute;display:inline-block;vertical-align:middle;margin:5px;cursor:pointer"
} : {
  name: "c8mmhi",
  styles: "opacity:0;position:absolute;display:inline-block;vertical-align:middle;margin:5px;cursor:pointer",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$I
});
var StyledRadioLabel = createStyled("label", "development" === "production" ? {
  target: "e1x45o1p0"
} : {
  target: "e1x45o1p0",
  label: "StyledRadioLabel"
})("display:inline-block;vertical-align:middle;margin:5px;cursor:pointer;position:relative;", function (_ref2) {
  var brandStyle = _ref2.brandStyle;
  return brandStyle === "yx" ? "\n    marging-right: 2rem;\n    font-size: 11px;\n    font-family: 'ClanOT News';\n    color: ".concat(colors$1.black, ";\n  ") : "\n    margin-right: 36px;\n  ";
}, " &:before{content:\"\";background:url(\"", iconSelector, "\");display:inline-block;vertical-align:middle;width:25px;height:26px;margin-right:10px;text-align:center;}" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
function Radio(_ref3) {
  var id = _ref3.id,
    label = _ref3.label,
    sublabel = _ref3.sublabel,
    options = _ref3.options,
    onchange = _ref3.onchange,
    showError = _ref3.showError,
    brandStyle = _ref3.brandStyle,
    topMargin = _ref3.topMargin;
  return /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(Label$1, {
    brandStyle: brandStyle,
    topMargin: topMargin
  }, label), sublabel ? /*#__PURE__*/React__default.createElement(SubLabel, {
    brandStyle: brandStyle
  }, sublabel) : null, /*#__PURE__*/React__default.createElement("div", null, options.map(function (option, i) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React__default.createElement("span", {
        key: "radio-option-".concat(i)
      }, /*#__PURE__*/React__default.createElement(StyledInput$2, {
        onChange: function onChange(e) {
          return onchange(e, id);
        },
        id: "radio-option-".concat(id, "-").concat(i),
        name: "radio-option-".concat(id),
        type: "radio",
        value: option.value
      }), /*#__PURE__*/React__default.createElement(StyledRadioLabel, {
        brandStyle: brandStyle,
        htmlFor: "radio-option-".concat(id, "-").concat(i),
        checked: option.checked
      }, option.label))
    );
  }), /*#__PURE__*/React__default.createElement(ErrorLabel, {
    id: id,
    showError: showError
  })));
}
Radio.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  sublabel: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    label: PropTypes.string,
    checked: PropTypes.bool
  })).isRequired,
  onchange: PropTypes.func,
  showError: PropTypes.string,
  brandStyle: PropTypes.oneOf(["ya", "yx"]),
  topMargin: PropTypes.bool
};
Radio.defaultProps = {
  showError: "",
  onchange: function onchange() {},
  brandStyle: "ya",
  sublabel: undefined,
  topMargin: true
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$H() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var primaryGreen$6 = colors$1.primaryGreen,
  darkGrey = colors$1.darkGrey,
  white$2 = colors$1.white,
  darkBlue = colors$1.darkBlue,
  yxGrey = colors$1.yxGrey,
  black = colors$1.black;
var lineColorSelector = function lineColorSelector(_ref) {
  var brandStyle = _ref.brandStyle,
    isNextActive = _ref.isNextActive,
    isLast = _ref.isLast;
  if (isLast) return white$2;
  if (brandStyle === "yx") return isNextActive ? darkBlue : yxGrey;
  return primaryGreen$6;
};
var lineHeightSelector = function lineHeightSelector(_ref2) {
  var brandStyle = _ref2.brandStyle,
    isLast = _ref2.isLast;
  if (isLast) return 5;
  if (brandStyle === "yx") return 3;
  return 1;
};
var List = createStyled("div", "development" === "production" ? {
  target: "e178sfo13"
} : {
  target: "e178sfo13",
  label: "List"
})("development" === "production" ? {
  name: "1o9x793",
  styles: "margin-bottom:2rem;display:flex;justify-content:space-between;overflow:hidden"
} : {
  name: "1o9x793",
  styles: "margin-bottom:2rem;display:flex;justify-content:space-between;overflow:hidden",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$H
});
var Step = createStyled("div", "development" === "production" ? {
  target: "e178sfo12"
} : {
  target: "e178sfo12",
  label: "Step"
})("development" === "production" ? {
  name: "ltj88j",
  styles: "width:17%;display:flex;flex-direction:column;align-items:center;text-align:center"
} : {
  name: "ltj88j",
  styles: "width:17%;display:flex;flex-direction:column;align-items:center;text-align:center",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0ZXBzLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUEwQnVCIiwiZmlsZSI6InN0ZXBzLmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiO1xuaW1wb3J0IGNvbG9ycyBmcm9tIFwiLi4vLi4vLi4vY29sb3JzXCI7XG5cbmNvbnN0IHsgcHJpbWFyeUdyZWVuLCBkYXJrR3JleSwgd2hpdGUsIGRhcmtCbHVlLCB5eEdyZXksIGJsYWNrIH0gPSBjb2xvcnM7XG5cbmNvbnN0IGxpbmVDb2xvclNlbGVjdG9yID0gKHsgYnJhbmRTdHlsZSwgaXNOZXh0QWN0aXZlLCBpc0xhc3QgfSkgPT4ge1xuICBpZiAoaXNMYXN0KSByZXR1cm4gd2hpdGU7XG4gIGlmIChicmFuZFN0eWxlID09PSBcInl4XCIpIHJldHVybiBpc05leHRBY3RpdmUgPyBkYXJrQmx1ZSA6IHl4R3JleTtcbiAgcmV0dXJuIHByaW1hcnlHcmVlbjtcbn07XG5cbmNvbnN0IGxpbmVIZWlnaHRTZWxlY3RvciA9ICh7IGJyYW5kU3R5bGUsIGlzTGFzdCB9KSA9PiB7XG4gIGlmIChpc0xhc3QpIHJldHVybiA1O1xuICBpZiAoYnJhbmRTdHlsZSA9PT0gXCJ5eFwiKSByZXR1cm4gMztcbiAgcmV0dXJuIDE7XG59O1xuXG5jb25zdCBMaXN0ID0gc3R5bGVkLmRpdmBcbiAgbWFyZ2luLWJvdHRvbTogMnJlbTtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICBvdmVyZmxvdzogaGlkZGVuO1xuYDtcblxuY29uc3QgU3RlcCA9IHN0eWxlZC5kaXZgXG4gIHdpZHRoOiAxNyU7XG5cbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcblxuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG5gO1xuXG5jb25zdCBOdW1iZXIgPSBzdHlsZWQucGBcbiAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgd2lkdGg6IDQycHg7XG4gIGhlaWdodDogNDJweDtcbiAgcGFkZGluZzogNXB4O1xuICBtYXJnaW46IDA7XG4gIGJvcmRlci1yYWRpdXM6IDUwcHg7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgZm9udC1zaXplOiAzMHB4O1xuICBsaW5lLWhlaWdodDogMzBweDtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuXG4gICR7KHsgYnJhbmRTdHlsZSwgaXNBY3RpdmUgfSkgPT5cbiAgICBicmFuZFN0eWxlID09PSBcInl4XCJcbiAgICAgID8gYFxuICAgIGJvcmRlcjogMXB4IHNvbGlkICR7aXNBY3RpdmUgPyBkYXJrQmx1ZSA6IHl4R3JleX07XG4gICAgY29sb3I6ICR7d2hpdGV9O1xuICAgIGJhY2tncm91bmQtY29sb3I6ICR7aXNBY3RpdmUgPyBkYXJrQmx1ZSA6IHl4R3JleX07XG4gICAgZm9udC1mYW1pbHk6ICdDbGFuT1QgQm9sZCc7XG4gIGBcbiAgICAgIDogYFxuICAgIGJvcmRlcjogMXB4IHNvbGlkICR7cHJpbWFyeUdyZWVufTtcbiAgICBjb2xvcjogJHtpc0FjdGl2ZSA/IHdoaXRlIDogcHJpbWFyeUdyZWVufTtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2lzQWN0aXZlID8gcHJpbWFyeUdyZWVuIDogd2hpdGV9O1xuICAgIGZvbnQtd2VpZ2h0OiA2MDA7XG4gIGB9XG5cbiAgOjphZnRlciB7XG4gICAgY29udGVudDogXCJcIjtcbiAgICBiYWNrZ3JvdW5kOiAke2xpbmVDb2xvclNlbGVjdG9yfTtcbiAgICBoZWlnaHQ6ICR7bGluZUhlaWdodFNlbGVjdG9yfXB4O1xuICAgIHdpZHRoOiA4MDBweDtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgdG9wOiBjYWxjKDUwJSAtIDFweCk7XG4gICAgbGVmdDogY2FsYygxMDAlICsgMXB4KTtcbiAgfVxuYDtcblxuY29uc3QgTGFiZWwgPSBzdHlsZWQucGBcbiAgcGFkZGluZy10b3A6IDFyZW07XG4gIGZvbnQtd2VpZ2h0OiBib2xkO1xuICBmb250LXNpemU6IDE0cHg7XG5cbiAgJHsoeyBicmFuZFN0eWxlLCBpc0FjdGl2ZSB9KSA9PlxuICAgIGJyYW5kU3R5bGUgPT09IFwieXhcIlxuICAgICAgPyBgXG4gICAgY29sb3I6ICR7aXNBY3RpdmUgPyBibGFjayA6IHl4R3JleX07XG4gICAgZm9udC1mYW1pbHk6ICdDbGFuT1QgTmV3cyc7XG4gIGBcbiAgICAgIDogYFxuICAgIGNvbG9yOiAke2lzQWN0aXZlID8gYmxhY2sgOiBkYXJrR3JleX07XG4gICAgZm9udC1mYW1pbHk6ICdNb250c2VycmF0JztcbiAgYH07XG5gO1xuXG5mdW5jdGlvbiBTdGVwcyh7IGxhYmVscywgY3VycmVudFN0ZXAsIGJyYW5kU3R5bGUgfSkge1xuICByZXR1cm4gKFxuICAgIDxMaXN0PlxuICAgICAge2xhYmVscy5tYXAoKGxhYmVsLCBpbmRleCkgPT4ge1xuICAgICAgICBjb25zdCBpc0FjdGl2ZSA9IGN1cnJlbnRTdGVwID49IGluZGV4O1xuICAgICAgICBjb25zdCBpc05leHRBY3RpdmUgPSBjdXJyZW50U3RlcCA+PSBpbmRleCArIDE7XG4gICAgICAgIGNvbnN0IGlzTGFzdCA9IGluZGV4ID09PSBsYWJlbHMubGVuZ3RoIC0gMTtcbiAgICAgICAgcmV0dXJuIChcbiAgICAgICAgICA8U3RlcCBrZXk9e2xhYmVsfT5cbiAgICAgICAgICAgIDxOdW1iZXJcbiAgICAgICAgICAgICAgYnJhbmRTdHlsZT17YnJhbmRTdHlsZX1cbiAgICAgICAgICAgICAgaXNBY3RpdmU9e2lzQWN0aXZlfVxuICAgICAgICAgICAgICBpc05leHRBY3RpdmU9e2lzTmV4dEFjdGl2ZX1cbiAgICAgICAgICAgICAgaXNMYXN0PXtpc0xhc3R9XG4gICAgICAgICAgICA+XG4gICAgICAgICAgICAgIHtpbmRleCArIDF9XG4gICAgICAgICAgICA8L051bWJlcj5cbiAgICAgICAgICAgIDxMYWJlbCBicmFuZFN0eWxlPXticmFuZFN0eWxlfSBpc0FjdGl2ZT17aXNBY3RpdmV9PlxuICAgICAgICAgICAgICB7bGFiZWx9XG4gICAgICAgICAgICA8L0xhYmVsPlxuICAgICAgICAgIDwvU3RlcD5cbiAgICAgICAgKTtcbiAgICAgIH0pfVxuICAgIDwvTGlzdD5cbiAgKTtcbn1cblxuU3RlcHMucHJvcFR5cGVzID0ge1xuICBsYWJlbHM6IFByb3BUeXBlcy5hcnJheU9mKFByb3BUeXBlcy5zdHJpbmcpLmlzUmVxdWlyZWQsXG4gIGN1cnJlbnRTdGVwOiBQcm9wVHlwZXMubnVtYmVyLmlzUmVxdWlyZWQsXG4gIGJyYW5kU3R5bGU6IFByb3BUeXBlcy5vbmVPZihbXCJ5YVwiLCBcInl4XCJdKSxcbn07XG5cblN0ZXBzLmRlZmF1bHRQcm9wcyA9IHtcbiAgYnJhbmRTdHlsZTogXCJ5YVwiLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgU3RlcHM7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$H
});
var Number$1 = createStyled("p", "development" === "production" ? {
  target: "e178sfo11"
} : {
  target: "e178sfo11",
  label: "Number"
})("box-sizing:border-box;width:42px;height:42px;padding:5px;margin:0;border-radius:50px;display:inline-block;font-size:30px;line-height:30px;position:relative;", function (_ref3) {
  var brandStyle = _ref3.brandStyle,
    isActive = _ref3.isActive;
  return brandStyle === "yx" ? "\n    border: 1px solid ".concat(isActive ? darkBlue : yxGrey, ";\n    color: ").concat(white$2, ";\n    background-color: ").concat(isActive ? darkBlue : yxGrey, ";\n    font-family: 'ClanOT Bold';\n  ") : "\n    border: 1px solid ".concat(primaryGreen$6, ";\n    color: ").concat(isActive ? white$2 : primaryGreen$6, ";\n    background-color: ").concat(isActive ? primaryGreen$6 : white$2, ";\n    font-weight: 600;\n  ");
}, " ::after{content:\"\";background:", lineColorSelector, ";height:", lineHeightSelector, "px;width:800px;position:absolute;top:calc(50% - 1px);left:calc(100% + 1px);}" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Label = createStyled("p", "development" === "production" ? {
  target: "e178sfo10"
} : {
  target: "e178sfo10",
  label: "Label"
})("padding-top:1rem;font-weight:bold;font-size:14px;", function (_ref4) {
  var brandStyle = _ref4.brandStyle,
    isActive = _ref4.isActive;
  return brandStyle === "yx" ? "\n    color: ".concat(isActive ? black : yxGrey, ";\n    font-family: 'ClanOT News';\n  ") : "\n    color: ".concat(isActive ? black : darkGrey, ";\n    font-family: 'Montserrat';\n  ");
}, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0ZXBzLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUEwRXNCIiwiZmlsZSI6InN0ZXBzLmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiO1xuaW1wb3J0IGNvbG9ycyBmcm9tIFwiLi4vLi4vLi4vY29sb3JzXCI7XG5cbmNvbnN0IHsgcHJpbWFyeUdyZWVuLCBkYXJrR3JleSwgd2hpdGUsIGRhcmtCbHVlLCB5eEdyZXksIGJsYWNrIH0gPSBjb2xvcnM7XG5cbmNvbnN0IGxpbmVDb2xvclNlbGVjdG9yID0gKHsgYnJhbmRTdHlsZSwgaXNOZXh0QWN0aXZlLCBpc0xhc3QgfSkgPT4ge1xuICBpZiAoaXNMYXN0KSByZXR1cm4gd2hpdGU7XG4gIGlmIChicmFuZFN0eWxlID09PSBcInl4XCIpIHJldHVybiBpc05leHRBY3RpdmUgPyBkYXJrQmx1ZSA6IHl4R3JleTtcbiAgcmV0dXJuIHByaW1hcnlHcmVlbjtcbn07XG5cbmNvbnN0IGxpbmVIZWlnaHRTZWxlY3RvciA9ICh7IGJyYW5kU3R5bGUsIGlzTGFzdCB9KSA9PiB7XG4gIGlmIChpc0xhc3QpIHJldHVybiA1O1xuICBpZiAoYnJhbmRTdHlsZSA9PT0gXCJ5eFwiKSByZXR1cm4gMztcbiAgcmV0dXJuIDE7XG59O1xuXG5jb25zdCBMaXN0ID0gc3R5bGVkLmRpdmBcbiAgbWFyZ2luLWJvdHRvbTogMnJlbTtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICBvdmVyZmxvdzogaGlkZGVuO1xuYDtcblxuY29uc3QgU3RlcCA9IHN0eWxlZC5kaXZgXG4gIHdpZHRoOiAxNyU7XG5cbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcblxuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG5gO1xuXG5jb25zdCBOdW1iZXIgPSBzdHlsZWQucGBcbiAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgd2lkdGg6IDQycHg7XG4gIGhlaWdodDogNDJweDtcbiAgcGFkZGluZzogNXB4O1xuICBtYXJnaW46IDA7XG4gIGJvcmRlci1yYWRpdXM6IDUwcHg7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgZm9udC1zaXplOiAzMHB4O1xuICBsaW5lLWhlaWdodDogMzBweDtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuXG4gICR7KHsgYnJhbmRTdHlsZSwgaXNBY3RpdmUgfSkgPT5cbiAgICBicmFuZFN0eWxlID09PSBcInl4XCJcbiAgICAgID8gYFxuICAgIGJvcmRlcjogMXB4IHNvbGlkICR7aXNBY3RpdmUgPyBkYXJrQmx1ZSA6IHl4R3JleX07XG4gICAgY29sb3I6ICR7d2hpdGV9O1xuICAgIGJhY2tncm91bmQtY29sb3I6ICR7aXNBY3RpdmUgPyBkYXJrQmx1ZSA6IHl4R3JleX07XG4gICAgZm9udC1mYW1pbHk6ICdDbGFuT1QgQm9sZCc7XG4gIGBcbiAgICAgIDogYFxuICAgIGJvcmRlcjogMXB4IHNvbGlkICR7cHJpbWFyeUdyZWVufTtcbiAgICBjb2xvcjogJHtpc0FjdGl2ZSA/IHdoaXRlIDogcHJpbWFyeUdyZWVufTtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2lzQWN0aXZlID8gcHJpbWFyeUdyZWVuIDogd2hpdGV9O1xuICAgIGZvbnQtd2VpZ2h0OiA2MDA7XG4gIGB9XG5cbiAgOjphZnRlciB7XG4gICAgY29udGVudDogXCJcIjtcbiAgICBiYWNrZ3JvdW5kOiAke2xpbmVDb2xvclNlbGVjdG9yfTtcbiAgICBoZWlnaHQ6ICR7bGluZUhlaWdodFNlbGVjdG9yfXB4O1xuICAgIHdpZHRoOiA4MDBweDtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgdG9wOiBjYWxjKDUwJSAtIDFweCk7XG4gICAgbGVmdDogY2FsYygxMDAlICsgMXB4KTtcbiAgfVxuYDtcblxuY29uc3QgTGFiZWwgPSBzdHlsZWQucGBcbiAgcGFkZGluZy10b3A6IDFyZW07XG4gIGZvbnQtd2VpZ2h0OiBib2xkO1xuICBmb250LXNpemU6IDE0cHg7XG5cbiAgJHsoeyBicmFuZFN0eWxlLCBpc0FjdGl2ZSB9KSA9PlxuICAgIGJyYW5kU3R5bGUgPT09IFwieXhcIlxuICAgICAgPyBgXG4gICAgY29sb3I6ICR7aXNBY3RpdmUgPyBibGFjayA6IHl4R3JleX07XG4gICAgZm9udC1mYW1pbHk6ICdDbGFuT1QgTmV3cyc7XG4gIGBcbiAgICAgIDogYFxuICAgIGNvbG9yOiAke2lzQWN0aXZlID8gYmxhY2sgOiBkYXJrR3JleX07XG4gICAgZm9udC1mYW1pbHk6ICdNb250c2VycmF0JztcbiAgYH07XG5gO1xuXG5mdW5jdGlvbiBTdGVwcyh7IGxhYmVscywgY3VycmVudFN0ZXAsIGJyYW5kU3R5bGUgfSkge1xuICByZXR1cm4gKFxuICAgIDxMaXN0PlxuICAgICAge2xhYmVscy5tYXAoKGxhYmVsLCBpbmRleCkgPT4ge1xuICAgICAgICBjb25zdCBpc0FjdGl2ZSA9IGN1cnJlbnRTdGVwID49IGluZGV4O1xuICAgICAgICBjb25zdCBpc05leHRBY3RpdmUgPSBjdXJyZW50U3RlcCA+PSBpbmRleCArIDE7XG4gICAgICAgIGNvbnN0IGlzTGFzdCA9IGluZGV4ID09PSBsYWJlbHMubGVuZ3RoIC0gMTtcbiAgICAgICAgcmV0dXJuIChcbiAgICAgICAgICA8U3RlcCBrZXk9e2xhYmVsfT5cbiAgICAgICAgICAgIDxOdW1iZXJcbiAgICAgICAgICAgICAgYnJhbmRTdHlsZT17YnJhbmRTdHlsZX1cbiAgICAgICAgICAgICAgaXNBY3RpdmU9e2lzQWN0aXZlfVxuICAgICAgICAgICAgICBpc05leHRBY3RpdmU9e2lzTmV4dEFjdGl2ZX1cbiAgICAgICAgICAgICAgaXNMYXN0PXtpc0xhc3R9XG4gICAgICAgICAgICA+XG4gICAgICAgICAgICAgIHtpbmRleCArIDF9XG4gICAgICAgICAgICA8L051bWJlcj5cbiAgICAgICAgICAgIDxMYWJlbCBicmFuZFN0eWxlPXticmFuZFN0eWxlfSBpc0FjdGl2ZT17aXNBY3RpdmV9PlxuICAgICAgICAgICAgICB7bGFiZWx9XG4gICAgICAgICAgICA8L0xhYmVsPlxuICAgICAgICAgIDwvU3RlcD5cbiAgICAgICAgKTtcbiAgICAgIH0pfVxuICAgIDwvTGlzdD5cbiAgKTtcbn1cblxuU3RlcHMucHJvcFR5cGVzID0ge1xuICBsYWJlbHM6IFByb3BUeXBlcy5hcnJheU9mKFByb3BUeXBlcy5zdHJpbmcpLmlzUmVxdWlyZWQsXG4gIGN1cnJlbnRTdGVwOiBQcm9wVHlwZXMubnVtYmVyLmlzUmVxdWlyZWQsXG4gIGJyYW5kU3R5bGU6IFByb3BUeXBlcy5vbmVPZihbXCJ5YVwiLCBcInl4XCJdKSxcbn07XG5cblN0ZXBzLmRlZmF1bHRQcm9wcyA9IHtcbiAgYnJhbmRTdHlsZTogXCJ5YVwiLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgU3RlcHM7XG4iXX0= */"));
function Steps(_ref5) {
  var labels = _ref5.labels,
    currentStep = _ref5.currentStep,
    brandStyle = _ref5.brandStyle;
  return /*#__PURE__*/React__default.createElement(List, null, labels.map(function (label, index) {
    var isActive = currentStep >= index;
    var isNextActive = currentStep >= index + 1;
    var isLast = index === labels.length - 1;
    return /*#__PURE__*/React__default.createElement(Step, {
      key: label
    }, /*#__PURE__*/React__default.createElement(Number$1, {
      brandStyle: brandStyle,
      isActive: isActive,
      isNextActive: isNextActive,
      isLast: isLast
    }, index + 1), /*#__PURE__*/React__default.createElement(Label, {
      brandStyle: brandStyle,
      isActive: isActive
    }, label));
  }));
}
Steps.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentStep: PropTypes.number.isRequired,
  brandStyle: PropTypes.oneOf(["ya", "yx"])
};
Steps.defaultProps = {
  brandStyle: "ya"
};

var countries = [{
  value: "AF",
  label: "Afghanistan"
}, {
  value: "AL",
  label: "Albania"
}, {
  value: "DZ",
  label: "Algerie"
}, {
  value: "AS",
  label: "Amerikansk Samoa"
}, {
  value: "AD",
  label: "Andorra"
}, {
  value: "AO",
  label: "Angola"
}, {
  value: "AI",
  label: "Anguilla"
}, {
  value: "AQ",
  label: "Antarktis"
}, {
  value: "AG",
  label: "Antigua og Barbuda"
}, {
  value: "AN",
  label: "Antillene"
}, {
  value: "AR",
  label: "Argentina"
}, {
  value: "AM",
  label: "Armenia"
}, {
  value: "AW",
  label: "Aruba"
}, {
  value: "AZ",
  label: "Aserbajdsjan"
}, {
  value: "AU",
  label: "Australia"
}, {
  value: "BS",
  label: "Bahamas"
}, {
  value: "BH",
  label: "Bahrain"
}, {
  value: "BD",
  label: "Bangladesh"
}, {
  value: "BB",
  label: "Barbados"
}, {
  value: "BE",
  label: "Belgia"
}, {
  value: "BZ",
  label: "Belize"
}, {
  value: "BJ",
  label: "Benin"
}, {
  value: "BM",
  label: "Bermuda"
}, {
  value: "BT",
  label: "Bhutan"
}, {
  value: "BO",
  label: "Bolivia"
}, {
  value: "BA",
  label: "Bosnia-Hercegovina"
}, {
  value: "BW",
  label: "Botswana"
}, {
  value: "BV",
  label: "Bouvetøya"
}, {
  value: "BR",
  label: "Brasil"
}, {
  value: "IO",
  label: "Britiske territorier i det indiske hav"
}, {
  value: "BN",
  label: "Brunei"
}, {
  value: "BG",
  label: "Bulgaria"
}, {
  value: "BF",
  label: "Burkina Faso"
}, {
  value: "BI",
  label: "Burundi"
}, {
  value: "CA",
  label: "Canada"
}, {
  value: "KY",
  label: "Caymanøyene"
}, {
  value: "CL",
  label: "Chile"
}, {
  value: "CX",
  label: "Christmasøya"
}, {
  value: "CC",
  label: "Cocosøyene (Keeling)"
}, {
  value: "CO",
  label: "Colombia"
}, {
  value: "CK",
  label: "Cookøyene"
}, {
  value: "CR",
  label: "Costa Rica"
}, {
  value: "CU",
  label: "Cuba"
}, {
  value: "DK",
  label: "Danmark"
}, {
  value: "AE",
  label: "De forente arabiske emirater"
}, {
  value: "DO",
  label: "Den dominikanske republikk"
}, {
  value: "CF",
  label: "Den sentralafrikanske republikk"
}, {
  value: "MK",
  label: "Den tidligere jugoslaviske republikken Makedonia"
}, {
  value: "DJ",
  label: "Djibouti"
}, {
  value: "DM",
  label: "Dominica"
}, {
  value: "EC",
  label: "Ecuador"
}, {
  value: "EG",
  label: "Egypt"
}, {
  value: "GQ",
  label: "Ekvatorial-Guinea"
}, {
  value: "SV",
  label: "El Salvador"
}, {
  value: "CI",
  label: "Elfenbenskysten"
}, {
  value: "ER",
  label: "Eritrea"
}, {
  value: "EE",
  label: "Estland"
}, {
  value: "ET",
  label: "Etiopia"
}, {
  value: "FO",
  label: "Færøyene"
}, {
  value: "FK",
  label: "Falklandsøyene"
}, {
  value: "FJ",
  label: "Fijiøyene"
}, {
  value: "PH",
  label: "Filippinene"
}, {
  value: "FI",
  label: "Finland"
}, {
  value: "FR",
  label: "Frankrike"
}, {
  value: "GF",
  label: "Fransk Guyana"
}, {
  value: "PF",
  label: "Fransk Polynesia"
}, {
  value: "TF",
  label: "Franske sydlige territorier"
}, {
  value: "GA",
  label: "Gabon"
}, {
  value: "GM",
  label: "Gambia"
}, {
  value: "GE",
  label: "Georgia"
}, {
  value: "GH",
  label: "Ghana"
}, {
  value: "GI",
  label: "Gibraltar"
}, {
  value: "GD",
  label: "Grenada"
}, {
  value: "GL",
  label: "Grønland"
}, {
  value: "GP",
  label: "Guadeloupe"
}, {
  value: "GU",
  label: "Guam"
}, {
  value: "GT",
  label: "Guatemala"
}, {
  value: "GN",
  label: "Guinea"
}, {
  value: "GW",
  label: "Guinea-Bissau"
}, {
  value: "GY",
  label: "Guyana"
}, {
  value: "HT",
  label: "Haiti"
}, {
  value: "HM",
  label: "Heardøya og McDonaldøyene"
}, {
  value: "GR",
  label: "Hellas"
}, {
  value: "HN",
  label: "Honduras"
}, {
  value: "HK",
  label: "Hong Kong S. A. R"
}, {
  value: "BY",
  label: "Hviterussland"
}, {
  value: "IN",
  label: "India"
}, {
  value: "ID",
  label: "Indonesia"
}, {
  value: "IQ",
  label: "Irak"
}, {
  value: "IR",
  label: "Iran"
}, {
  value: "IE",
  label: "Irland"
}, {
  value: "IS",
  label: "Island"
}, {
  value: "IL",
  label: "Israel"
}, {
  value: "IT",
  label: "Italia"
}, {
  value: "JM",
  label: "Jamaica"
}, {
  value: "JP",
  label: "Japan"
}, {
  value: "VG",
  label: "Jomfruøyene (Britisk)"
}, {
  value: "VI",
  label: "Jomfruøyene (USA)"
}, {
  value: "JO",
  label: "Jordan"
}, {
  value: "YU",
  label: "Jugoslavia"
}, {
  value: "KH",
  label: "Kambodsja"
}, {
  value: "CM",
  label: "Kamerun"
}, {
  value: "CV",
  label: "Kapp Verde"
}, {
  value: "KZ",
  label: "Kasakhstan"
}, {
  value: "KE",
  label: "Kenya"
}, {
  value: "CN",
  label: "Kina"
}, {
  value: "KG",
  label: "Kirgisistan"
}, {
  value: "KI",
  label: "Kiribati"
}, {
  value: "KM",
  label: "Komorene"
}, {
  value: "CG",
  label: "Kongo"
}, {
  value: "KR",
  label: "Korea"
}, {
  value: "HR",
  label: "Kroatia"
}, {
  value: "KW",
  label: "Kuwait"
}, {
  value: "CY",
  label: "Kypros"
}, {
  value: "LA",
  label: "Laos"
}, {
  value: "LV",
  label: "Latvia"
}, {
  value: "LS",
  label: "Lesotho"
}, {
  value: "LB",
  label: "Libanon"
}, {
  value: "LR",
  label: "Liberia"
}, {
  value: "LY",
  label: "Libya"
}, {
  value: "LI",
  label: "Liechtenstein"
}, {
  value: "LT",
  label: "Litauen"
}, {
  value: "LU",
  label: "Luxembourg"
}, {
  value: "MO",
  label: "Macau"
}, {
  value: "MG",
  label: "Madagaskar"
}, {
  value: "MW",
  label: "Malawi"
}, {
  value: "MY",
  label: "Malaysia"
}, {
  value: "MV",
  label: "Maldivene"
}, {
  value: "ML",
  label: "Mali"
}, {
  value: "MT",
  label: "Malta"
}, {
  value: "MA",
  label: "Marokko"
}, {
  value: "MH",
  label: "Marshalløyene"
}, {
  value: "MQ",
  label: "Martinique"
}, {
  value: "MR",
  label: "Mauritania"
}, {
  value: "MU",
  label: "Mauritius"
}, {
  value: "YT",
  label: "Mayotte"
}, {
  value: "MX",
  label: "Mexico"
}, {
  value: "FM",
  label: "Mikronesia"
}, {
  value: "MD",
  label: "Moldova"
}, {
  value: "MC",
  label: "Monaco"
}, {
  value: "MN",
  label: "Mongolia"
}, {
  value: "MS",
  label: "Montserrat"
}, {
  value: "MZ",
  label: "Mosambik"
}, {
  value: "MM",
  label: "Myanmar"
}, {
  value: "NA",
  label: "Namibia"
}, {
  value: "NR",
  label: "Nauru"
}, {
  value: "NL",
  label: "Nederland"
}, {
  value: "NP",
  label: "Nepal"
}, {
  value: "NZ",
  label: "New Zealand"
}, {
  value: "NI",
  label: "Nicaragua"
}, {
  value: "NE",
  label: "Niger"
}, {
  value: "NG",
  label: "Nigeria"
}, {
  value: "NU",
  label: "Niue"
}, {
  value: "KP",
  label: "Nord-Korea"
}, {
  value: "MP",
  label: "Nordlige Marianaøyer"
}, {
  value: "NF",
  label: "Norfolk Island"
}, {
  value: "NO",
  label: "Norge"
}, {
  value: "NC",
  label: "Ny-Caledonia"
}, {
  value: "OM",
  label: "Oman"
}, {
  value: "AT",
  label: "Østerrike"
}, {
  value: "TP",
  label: "Øst-Timor"
}, {
  value: "PK",
  label: "Pakistan"
}, {
  value: "PW",
  label: "Palau"
}, {
  value: "PA",
  label: "Panama"
}, {
  value: "PG",
  label: "Papua Ny-Guinea"
}, {
  value: "PY",
  label: "Paraguay"
}, {
  value: "PE",
  label: "Peru"
}, {
  value: "PN",
  label: "Pitcairn"
}, {
  value: "PL",
  label: "Polen"
}, {
  value: "PT",
  label: "Portugal"
}, {
  value: "PR",
  label: "Puerto Rico"
}, {
  value: "QA",
  label: "Qatar"
}, {
  value: "RE",
  label: "Réunion"
}, {
  value: "RO",
  label: "Romania"
}, {
  value: "RU",
  label: "Russland"
}, {
  value: "RW",
  label: "Rwanda"
}, {
  value: "SH",
  label: "Saint Helena"
}, {
  value: "PM",
  label: "Saint Pierre og Miquelon"
}, {
  value: "SB",
  label: "Salomonøyene"
}, {
  value: "WS",
  label: "Samoa"
}, {
  value: "SM",
  label: "San Marino"
}, {
  value: "ST",
  label: "São Tomé og Principe"
}, {
  value: "SA",
  label: "Saudi-Arabia"
}, {
  value: "SN",
  label: "Senegal"
}, {
  value: "SC",
  label: "Seychellene"
}, {
  value: "SL",
  label: "Sierra Leone"
}, {
  value: "SG",
  label: "Singapore"
}, {
  value: "SK",
  label: "Slovakia"
}, {
  value: "SI",
  label: "Slovenia"
}, {
  value: "SO",
  label: "Somalia"
}, {
  value: "ZA",
  label: "Sør-Afrika"
}, {
  value: "GS",
  label: "Sør-Georgia og Sør-Sandwichøyene"
}, {
  value: "ES",
  label: "Spania"
}, {
  value: "LK",
  label: "Sri Lanka"
}, {
  value: "KN",
  label: "St. Kitts og Nevis"
}, {
  value: "LC",
  label: "St. Lucia"
}, {
  value: "VC",
  label: "St. Vincent og Grenadinene"
}, {
  value: "UK",
  label: "Storbritannia"
}, {
  value: "SD",
  label: "Sudan"
}, {
  value: "SR",
  label: "Suriname"
}, {
  value: "SJ",
  label: "Svalbard"
}, {
  value: "CH",
  label: "Sveits"
}, {
  value: "SE",
  label: "Sverige"
}, {
  value: "SZ",
  label: "Swaziland"
}, {
  value: "SY",
  label: "Syria"
}, {
  value: "TJ",
  label: "Tadsjikistan"
}, {
  value: "TW",
  label: "Taiwan"
}, {
  value: "TZ",
  label: "Tanzania"
}, {
  value: "TH",
  label: "Thailand"
}, {
  value: "TG",
  label: "Togo"
}, {
  value: "TK",
  label: "Tokelau"
}, {
  value: "TO",
  label: "Tonga"
}, {
  value: "TT",
  label: "Trinidad og Tobago"
}, {
  value: "TD",
  label: "Tsjad"
}, {
  value: "CZ",
  label: "Tsjekkia"
}, {
  value: "TN",
  label: "Tunisia"
}, {
  value: "TM",
  label: "Turkmenistan"
}, {
  value: "TC",
  label: "Turks og Caicosøyene"
}, {
  value: "TV",
  label: "Tuvalu"
}, {
  value: "TR",
  label: "Tyrkia"
}, {
  value: "DE",
  label: "Tyskland"
}, {
  value: "UG",
  label: "Uganda"
}, {
  value: "UA",
  label: "Ukraina"
}, {
  value: "HU",
  label: "Ungarn"
}, {
  value: "UY",
  label: "Uruguay"
}, {
  value: "US",
  label: "USA"
}, {
  value: "UM",
  label: "USAs mindre utenforliggende øyer"
}, {
  value: "UZ",
  label: "Usbekistan"
}, {
  value: "VU",
  label: "Vanuatu"
}, {
  value: "VA",
  label: "Vatikanstaten"
}, {
  value: "VE",
  label: "Venezuela"
}, {
  value: "VN",
  label: "Vietnam"
}, {
  value: "WF",
  label: "Wallis og Futuna"
}, {
  value: "YE",
  label: "Yemen"
}, {
  value: "CD",
  label: "Zaïre"
}, {
  value: "ZM",
  label: "Zambia"
}, {
  value: "ZW",
  label: "Zimbabwe"
}];

function BasicPersonalia(_ref) {
  var state = _ref.state,
    onValueUpdate = _ref.onValueUpdate,
    showEmailRepeat = _ref.showEmailRepeat,
    isSubsidiary = _ref.isSubsidiary,
    brandStyle = _ref.brandStyle;
  var getId = function getId(id) {
    return isSubsidiary ? "".concat(id, "Subsidiary") : id;
  };
  var getErrorId = function getErrorId(id) {
    return "".concat(getId(id), "Error");
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: getId("name"),
    type: "text",
    title: "Fullt navn",
    placeholder: "Fornavn, mellom- og etternavn",
    onblur: onValueUpdate,
    value: state[getId("name")],
    showError: state[getErrorId("name")],
    brandStyle: brandStyle
  })), /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: getId("ssn"),
    type: "text",
    title: "F\xF8dselsnummer",
    placeholder: "11 siffer",
    onblur: onValueUpdate,
    value: state[getId("ssn")],
    showError: state[getErrorId("ssn")],
    brandStyle: brandStyle
  }))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: getId("email"),
    type: "email",
    title: "E-post",
    onblur: onValueUpdate,
    value: state[getId("email")],
    showError: state[getErrorId("email")],
    brandStyle: brandStyle
  })), showEmailRepeat && /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: getId("emailRepeat"),
    type: "email",
    title: "Gjenta e-post",
    onblur: onValueUpdate,
    value: state[getId("emailRepeat")],
    showError: state[getErrorId("emailRepeat")],
    brandStyle: brandStyle
  }))), /*#__PURE__*/React__default.createElement(Paragraph$1, {
    brandStyle: brandStyle
  }, "Vi sender l\xE5nedokumenter per e-post. Det er derfor viktig at du har oppgitt korrekt e-postadresse."), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: getId("mobilNo"),
    type: "tel",
    title: "Mobiltelefonnummer",
    onblur: onValueUpdate,
    value: state[getId("mobilNo")],
    showError: state[getErrorId("mobilNo")],
    brandStyle: brandStyle
  }))));
}
BasicPersonalia.propTypes = {
  state: PropTypes.shape({
    name: PropTypes.string,
    nameError: PropTypes.string,
    ssn: PropTypes.string,
    ssnError: PropTypes.string,
    email: PropTypes.string,
    emailError: PropTypes.string,
    mobilNo: PropTypes.string,
    mobilNoError: PropTypes.string
  }).isRequired,
  onValueUpdate: PropTypes.func.isRequired,
  showEmailRepeat: PropTypes.bool,
  isSubsidiary: PropTypes.bool,
  brandStyle: PropTypes.string
};
BasicPersonalia.defaultProps = {
  showEmailRepeat: true,
  isSubsidiary: false,
  brandStyle: "ya"
};

function StepOne(_ref) {
  var _state$collapseStates, _state$collapseStates2, _state$collapseStates3, _state$collapseStates4, _state$collapseStates6;
  var onValueUpdate = _ref.onValueUpdate,
    onNextStep = _ref.onNextStep,
    state = _ref.state,
    setState = _ref.setState,
    onCollapse = _ref.onCollapse;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Legend, null, "Personalia"), /*#__PURE__*/React__default.createElement(BasicPersonalia, {
    state: state,
    onValueUpdate: onValueUpdate
  }), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(SpanFull, null, /*#__PURE__*/React__default.createElement(Radio, {
    id: "isPoliticallyExposedPerson",
    label: "Har du, din nærmeste familie eller nære venner politiske/offentlige verv utenfor Norge?",
    options: [{
      value: true,
      label: "Ja",
      checked: state.isPoliticallyExposedPerson === true
    }, {
      value: false,
      label: "Nei",
      checked: state.isPoliticallyExposedPerson === false
    }],
    onchange: onValueUpdate,
    showError: state.isPoliticallyExposedPersonError
  }))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(SpanFull, null, /*#__PURE__*/React__default.createElement(Radio, {
    id: "willTransferToOtherCountries",
    label: "Er det sannsynlig at du vil foreta overførsler til/fra utlandet?",
    options: [{
      value: true,
      label: "Ja",
      checked: state.willTransferToOtherCountries === true
    }, {
      value: false,
      label: "Nei",
      checked: state.willTransferToOtherCountries === false
    }],
    onchange: onValueUpdate,
    showError: state.willTransferToOtherCountriesError
  }))), /*#__PURE__*/React__default.createElement(Collapse, {
    isOpen: state.willTransferToOtherCountries === true,
    appear: ((_state$collapseStates = state.collapseStates) === null || _state$collapseStates === void 0 ? void 0 : _state$collapseStates.willTransferToOtherCountries) !== "ENTERED",
    onEntered: function onEntered() {
      return onCollapse("ENTERED", "willTransferToOtherCountries");
    },
    onExited: function onExited() {
      return onCollapse("CLOSED", "willTransferToOtherCountries");
    }
  }, /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: "transfersToOtherCountries",
    type: "tel",
    title: "Gjennomsnittlig bel\xF8p per m\xE5ned til/fra utlandet",
    onblur: onValueUpdate,
    isCurrency: true,
    value: state.transfersToOtherCountries || 0,
    showError: state.transfersToOtherCountriesError
  })))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(SpanFull, null, /*#__PURE__*/React__default.createElement(Radio, {
    id: "isAmericanCitizen",
    label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Er du amerikansk statsborger eller skattemessig bosatt i USA?", /*#__PURE__*/React__default.createElement(ALink, {
      href: "/popup/er-du-amerikansk-statsborger",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Les mer")),
    options: [{
      value: true,
      label: "Ja",
      checked: state.isAmericanCitizen === true
    }, {
      value: false,
      label: "Nei",
      checked: state.isAmericanCitizen === false
    }],
    onchange: onValueUpdate,
    showError: state.isAmericanCitizenError
  }))), /*#__PURE__*/React__default.createElement(Collapse, {
    isOpen: state.isAmericanCitizen === true,
    appear: ((_state$collapseStates2 = state.collapseStates) === null || _state$collapseStates2 === void 0 ? void 0 : _state$collapseStates2.isAmericanCitizen) !== "ENTERED",
    onEntered: function onEntered() {
      return onCollapse("ENTERED", "isAmericanCitizen");
    },
    onExited: function onExited() {
      return onCollapse("CLOSED", "isAmericanCitizen");
    }
  }, /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Label$1, null, "TIN-nummer")), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: "tinNumber",
    onblur: onValueUpdate,
    value: state.tinNumber || "",
    showError: state.noTinNumberCheckbox ? "" : state.tinNumberError
  })), /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
    id: "noTinNumberCheckbox",
    value: !state.noTinNumberCheckbox,
    checked: state.noTinNumberCheckbox === true,
    onchange: function onchange(e) {
      return onValueUpdate(e, "noTinNumberCheckbox");
    },
    showError: state.noTinNumberCheckboxError
  }, /*#__PURE__*/React__default.createElement("span", null, "Har ikke TIN-nummer")))), /*#__PURE__*/React__default.createElement(Collapse, {
    isOpen: state.noTinNumberCheckbox === true,
    appear: ((_state$collapseStates3 = state.collapseStates) === null || _state$collapseStates3 === void 0 ? void 0 : _state$collapseStates3.noTinNumberCheckbox) !== "ENTERED",
    onEntered: function onEntered() {
      return onCollapse("ENTERED", "noTinNumberCheckbox");
    },
    onExited: function onExited() {
      return onCollapse("CLOSED", "noTinNumberCheckbox");
    }
  }, /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(SpanFull, null, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "noTinReason"
  }, "Hvorfor har du ikke TIN-nummer"), /*#__PURE__*/React__default.createElement(TextArea, {
    id: "noTinReason",
    name: "noTinReason",
    maxLength: "5000",
    defaultValue: state.noTinReason,
    onBlur: function onBlur(e) {
      return onValueUpdate(e, "noTinReason");
    }
  }))))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(SpanFull, null, /*#__PURE__*/React__default.createElement(Radio, {
    id: "isTaxwiseResidentOfForeignCountry",
    label: "Er du skattemessig bosatt i andre land enn Norge?",
    options: [{
      value: true,
      label: "Ja",
      checked: state.isTaxwiseResidentOfForeignCountry === true
    }, {
      value: false,
      label: "Nei",
      checked: state.isTaxwiseResidentOfForeignCountry === false
    }],
    onchange: onValueUpdate,
    showError: state.isTaxwiseResidentOfForeignCountryError
  }))), /*#__PURE__*/React__default.createElement(Collapse, {
    isOpen: state.isTaxwiseResidentOfForeignCountry === true,
    appear: ((_state$collapseStates4 = state.collapseStates) === null || _state$collapseStates4 === void 0 ? void 0 : _state$collapseStates4.isTaxwiseResidentOfForeignCountry) !== "ENTERED",
    onEntered: function onEntered() {
      return onCollapse("ENTERED", "isTaxwiseResidentOfForeignCountry");
    },
    onExited: function onExited() {
      return onCollapse("CLOSED", "isTaxwiseResidentOfForeignCountry");
    }
  },
  // https://stackoverflow.com/questions/3746725/how-to-create-an-array-containing-1-n
  Array.from({
    length: state.taxCountriesAmount
  }, function (_, i) {
    return i + 1;
  }).map(function (i) {
    var _state$collapseStates5;
    return /*#__PURE__*/React__default.createElement("div", {
      key: "tax-countries-key-".concat(i, "-").concat(state.taxCountriesAmount)
    }, /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Dropdown, {
      id: "taxCountry".concat(i),
      label: "Land",
      options: [{
        value: "",
        label: "Velg land"
      }].concat(_toConsumableArray$3(countries)),
      selected: state["taxCountry".concat(i)],
      onchange: onValueUpdate,
      showError: state.taxCountry1Error
    }))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Label$1, null, "ID-nummer")), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
      id: "idNumber".concat(i),
      onblur: onValueUpdate,
      value: state["idNumber".concat(i)],
      showError: state["noIdNumberCheckbox".concat(i)] ? "" : state["idNumber".concat(i, "Error")]
    })), /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement("label", {
      htmlFor: "noIdNumberCheckbox".concat(i)
    }), /*#__PURE__*/React__default.createElement(Checkbox$1, {
      id: "noIdNumberCheckbox".concat(i),
      value: !state["noIdNumberCheckbox".concat(i)],
      checked: state["noIdNumberCheckbox".concat(i)] === true,
      onchange: function onchange(e) {
        return onValueUpdate(e, "noIdNumberCheckbox".concat(i));
      },
      showError: state["noIdNumberCheckbox".concat(i, "Error")]
    }, "Har ikke ID-nummer"))), /*#__PURE__*/React__default.createElement(Collapse, {
      isOpen: state["noIdNumberCheckbox".concat(i)] === true,
      appear: ((_state$collapseStates5 = state.collapseStates) === null || _state$collapseStates5 === void 0 ? void 0 : _state$collapseStates5.isTaxwiseResidentOfForeignCountry) !== "ENTERED",
      onEntered: function onEntered() {
        return onCollapse("ENTERED", "isTaxwiseResidentOfForeignCountry");
      },
      onExited: function onExited() {
        return onCollapse("CLOSED", "isTaxwiseResidentOfForeignCountry");
      }
    }, /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(SpanFull, null, /*#__PURE__*/React__default.createElement("label", {
      htmlFor: "noIdReasonText".concat(i)
    }, "Hvorfor har du ikke ID-nummer"), /*#__PURE__*/React__default.createElement(TextArea, {
      id: "noIdReasonText".concat(i),
      name: "noIdReasonText".concat(i),
      maxLength: "5000",
      defaultValue: state["noIdReasonText".concat(i)],
      onBlur: function onBlur(e) {
        return onValueUpdate(e, "noIdReasonText".concat(i));
      }
    })))));
  }), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(ButtonPre, {
    id: "addTaxCountry",
    label: "Legg til land",
    pre: "+",
    disabled: state.taxCountriesAmount === 5,
    onclick: function onclick() {
      if (state.taxCountriesAmount < 5) {
        setState(function (prevState) {
          return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
            taxCountriesAmount: state.taxCountriesAmount + 1
          });
        });
      }
    }
  })), /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(ButtonPre, {
    id: "removeTaxCountry",
    label: "Fjern land",
    pre: "-",
    disabled: state.taxCountriesAmount === 1,
    onclick: function onclick() {
      if (state.taxCountriesAmount > 1) {
        setState(function (prevState) {
          return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
            taxCountriesAmount: state.taxCountriesAmount - 1
          });
        });
      }
    }
  })))), /*#__PURE__*/React__default.createElement(Legend, null, "Hva skal du bruke innskuddskontoen til?"), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
    id: "saveForDwelling",
    value: !state.saveForDwelling,
    checked: state.saveForDwelling === true,
    onchange: function onchange(e) {
      return onValueUpdate(e, "saveForDwelling");
    },
    showError: state.saveForDwellingError
  }, /*#__PURE__*/React__default.createElement("span", null, "Sparing til bolig"))), /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
    id: "saveForFamily",
    value: !state.saveForFamily,
    checked: state.saveForFamily === true,
    onchange: function onchange(e) {
      return onValueUpdate(e, "saveForFamily");
    },
    showError: state.saveForFamilyError
  }, "Sparing til familie"))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
    id: "personalUse",
    value: !state.personalUse,
    checked: state.personalUse === true,
    onchange: function onchange(e) {
      return onValueUpdate(e, "personalUse");
    },
    showError: state.personalUseError
  }, "Privat forbruk (l\xF8pende utgifter og innkj\xF8p)"))), /*#__PURE__*/React__default.createElement(ErrorLabel, {
    id: "saveForError",
    showError: state.saveForError
  }), /*#__PURE__*/React__default.createElement(Legend, null, "Hvor vil midlene p\xE5 konto hovedsakelig komme fra?"), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
    id: "income",
    value: !state.income,
    checked: state.income === true,
    onchange: function onchange(e) {
      return onValueUpdate(e, "income");
    },
    showError: state.incomeError
  }, "L\xF8nn/pensjon/trygd")), /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
    id: "inheritance",
    value: !state.inheritance,
    checked: state.inheritance === true,
    onchange: function onchange(e) {
      return onValueUpdate(e, "inheritance");
    },
    showError: state.inheritanceError
  }, "Arv"))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
    id: "gift",
    value: !state.gift,
    checked: state.gift === true,
    onchange: function onchange(e) {
      return onValueUpdate(e, "gift");
    },
    showError: state.giftError
  }, "Gave")), /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
    id: "realestate",
    value: !state.realestate,
    checked: state.realestate === true,
    onchange: function onchange(e) {
      return onValueUpdate(e, "realestate");
    },
    showError: state.realestateError
  }, "Salg av fast eiendom/l\xF8sr\xF8re"))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
    id: "savings",
    value: !state.savings,
    checked: state.savings === true,
    onchange: function onchange(e) {
      return onValueUpdate(e, "savings");
    },
    showError: state.savingsError
  }, "Sparing")), /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
    id: "willOthersDeposit",
    value: !state.willOthersDeposit,
    checked: state.willOthersDeposit === true,
    onchange: function onchange(e) {
      return onValueUpdate(e, "willOthersDeposit");
    },
    showError: state.willOthersDepositError
  }, "Andre privatpersoner"))), /*#__PURE__*/React__default.createElement(ErrorLabel, {
    id: "mainIncomeError",
    showError: state.mainIncomeError
  }), /*#__PURE__*/React__default.createElement(Collapse, {
    isOpen: state.willOthersDeposit === true,
    appear: ((_state$collapseStates6 = state.collapseStates) === null || _state$collapseStates6 === void 0 ? void 0 : _state$collapseStates6.willOthersDeposit) !== "ENTERED",
    onEntered: function onEntered() {
      return onCollapse("ENTERED", "willOthersDeposit");
    },
    onExited: function onExited() {
      return onCollapse("CLOSED", "willOthersDeposit");
    }
  }, /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: "depositsOtherAverage",
    type: "tel",
    title: "Gjennomsnittlig bel\xF8p per m\xE5ned fra andre privatpersoner",
    onblur: onValueUpdate,
    isCurrency: true,
    value: state.depositsOtherAverage,
    showError: state.depositsOtherAverageError
  })))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(SpanFull, null, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "comment"
  }, "Kommentar"), /*#__PURE__*/React__default.createElement(TextArea, {
    id: "comment",
    name: "comment",
    maxLength: "5000",
    defaultValue: state.comment,
    onBlur: function onBlur(e) {
      return onValueUpdate(e, "comment");
    }
  }))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
    id: "accept",
    value: state.accept === "on" ? "off" : "on",
    checked: state.accept === "on",
    onchange: function onchange(e) {
      return onValueUpdate(e, "accept");
    },
    showError: state.acceptError,
    disableLabelClick: true
  }, /*#__PURE__*/React__default.createElement("span", null, "Jeg aksepterer at det blir foretatt en "), /*#__PURE__*/React__default.createElement(ALink, {
    href: "https://documenthandler.resurs.com/Dokument.pdf?customerType=NATURAL&docType=Kredittvurdering-utsendelse-av-gjenpartsbrev-for-forbrukslan-innskudd-ya-kredittkort&land=NO&language=no",
    target: "_blank",
    rel: "noreferrer"
  }, "kredittvurdering og at utsendelse av gjenpartsbrev foreg\xE5r elektronisk der dette er praktisk mulig"))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Button, {
    label: "S\xF8k n\xE5",
    onclick: onNextStep,
    showError: state.button1Error,
    disabled: !!state.apiStatus.loading
  })), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Paragraph$1, null, "Din foresp\xF8rsel er helt uforpliktende, og vil bli behandlet konfidensielt. Det vil bli gjennomf\xF8rt en rutinemessig kredittsjekk ved innsendelse av s\xF8knaden.")));
}
StepOne.propTypes = {
  onValueUpdate: PropTypes.func.isRequired,
  onNextStep: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  state: PropTypes.object.isRequired,
  setState: PropTypes.func.isRequired,
  onCollapse: PropTypes.func.isRequired
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$G() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

// The WordPress root style kills all default styling for margin, padding and some more.
// We need to restore that to allow configurable properly styled messages.
var revertedGlobalStyles = "development" === "production" ? {
  name: "1tqb1rj",
  styles: "div,h2,p,ol{padding:revert;margin:revert;}"
} : {
  name: "h3vxoq-revertedGlobalStyles",
  styles: "div,h2,p,ol{padding:revert;margin:revert;};label:revertedGlobalStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$G
};

// These messages should be defined in the CMS, but currently sit here in the code.
var properMessages = {
  brukskontoNei: "\n    <h2>Takk for din s\xF8knad om konto i yA Bank!</h2>\n    <p>Vi kan dessverre ikke opprette kontoen \u2013 det kan v\xE6re 2 \xE5rsaker til dette:</p>\n    <ol type=\"1\">\n      <li>Du har allerede opprettet en yA Brukskonto, og det er kun mulig med \xE9n brukskonto pr. kunde.</li>\n      <li>Opplysninger innhentet fra offentlig register (f.eks. ligningsdata) gj\xF8r at kontoen ikke kan opprettes automatisk. Derimot kan du kontakte Kundeservice som vil hjelpe deg med \xE5 opprette kontoen.</li>\n    </ol>\n    <p>For hjelp med opprettelse av konto eller ytterligere opplysninger er du velkommen til \xE5 kontakte Kundeservice p\xE5 telefon: 23 20 46 00.</p>\n    <p>Vennlig hilsen<br />yA \u2013 en del av Resurs Bank</p>\n  ",
  hoyrentekontoNei: "\n    <h2>Takk for din s\xF8knad om konto i yA Bank!</h2>\n    <p>Vi kan dessverre ikke opprette kontoen \u2013 det kan v\xE6re 2 \xE5rsaker til dette:</p>\n    <ol type=\"1\">\n      <li>Du har allerede opprettet en yA H\xF8yrentekonto, og det er kun mulig med \xE9n h\xF8yrentekonto pr. kunde.</li>\n      <li>Opplysninger innhentet fra offentlig register (f.eks. ligningsdata) gj\xF8r at kontoen ikke kan opprettes automatisk. Derimot kan du kontakte Kundeservice som vil hjelpe deg med \xE5 opprette kontoen.</li>\n    </ol>\n    <p>For hjelp med opprettelse av konto eller ytterligere opplysninger er du velkommen til \xE5 kontakte Kundeservice p\xE5 telefon: 23 20 46 00.</p>\n    <p>Vennlig hilsen<br />yA \u2013 en del av Resurs Bank</p>\n  ",
  kredittkortNei: "\n    <h2>Vi kan dessverre ikke innvilge din kredittkorts\xF8knad</h2>\n    <p>P\xE5 bakgrunn av den informasjonen vi har mottatt av deg, eller opplysninger innhentet fra offentlig register (f.eks. ligningsdata) kan vi dessverre ikke innvilge din s\xF8knad.</p>\n    <p>Det er mulig at du allerede har en s\xF8knad registrert i v\xE5re systemer og av denne grunn f\xE5r avslag. Kontakt v\xE5rt <a href=\"https://ya.no/kundesenter#humany-kundesenter=/contact/84\" target=\"_blank\" rel=\"noreferrer\">kundesenter</a> hvis dette kan v\xE6re tilfelle eller telefon 23 20 46 00 (mellom 09:00-16:00 p\xE5 hverdager).</p>\n    <p>Vi takker for din s\xF8knad og \xF8nsker deg velkommen tilbake ved en senere anledning.</p>\n    <p>Vennlig hilsen <br />yA \u2013 en del av Resurs Bank</p>\n  ",
  kredittkortManuell: "\n    <h2>Takk for din s\xF8knad om yA Kredittkort</h2>\n    <p>Din s\xF8knad vil bli behandlet innen kort tid. Har du sp\xF8rsm\xE5l s\xE5 kan du kontakte v\xE5rt kundesenter p\xE5 23 20 46 00 (mellom 09:00-16:00 p\xE5 hverdager).</p>\n    <p>Vennlig hilsen <br />yA \u2013 en del av Resurs Bank</p>\n  ",
  kredittkortAllerede: "\n    <h2>Vi kan dessverre ikke innvilge din kredittkorts\xF8knad.</h2>\n    <p>Du er allerede registrert med et yA kredittkort. Har du glemt PIN-koden din finner du den i nettbanken. \xD8nsker du \xE5 f\xE5 tilsendt et nytt kort kan du <a target=\"_blank\" without rel=\"noreferrer\" href=\"/kundesenter#humany-kundesenter=/117-hvordan-bestiller-jeg-nytt-kort\">bestille det her</a>.</p>\n    <p>Vennlig hilsen <br />yA \u2013 en del av Resurs Bank</p>\n  ",
  yxKredittkortNei: "\n    <h2>Takk for din s\xF8knad om YX Visa-kort!</h2>\n    <p>P\xE5 bakgrunn av den informasjon vi har mottatt fra deg, eller opplysninger innhentet fra offentlige registre (f.eks. ligningsdata) kan vi dessverre ikke innvilge deg YX Visa-kort.</p>\n    <p>Det er mulig at du allerede har en s\xF8knad registrert i v\xE5re systemer og av denne grunn f\xE5r avslag.</p>\n    <p>Vi takker for din interesse.</p>\n    <p>Vennlig hilsen <br />YX Visa</p>\n  ",
  yxKredittkortManuell: "\n    <h2>Takk for din s\xF8knad om YX Visa!</h2>\n    <p>Din s\xF8knad vil bli behandlet innen kort tid.</p>\n    <p>Vennlig hilsen <br />YX Visa</p>\n  ",
  yxKredittkortAllerede: "\n    <h2>Vi kan dessverre ikke innvilge din kredittkorts\xF8knad.</h2>\n    <p>Du er allerede registrert med et YX Visa kredittkort. Har du glemt PIN-koden din finner du den i nettbanken. \xD8nsker du \xE5 f\xE5 tilsendt et nytt kort kan du <a target=\"_blank\" without rel=\"noreferrer\" href=\"https://www.yxvisa.no/kundesenter#humany-yx-visa-kundesenter=/276-hvordan-bestiller-jeg-nytt-kort\">bestille det her</a></p>\n    <p>Vennlig hilsen <br />YX Visa</p>\n  ",
  yx400: "\n    <h2>Teknisk feil</h2>\n    <p>Kj\xE6re kunde!</p>\n    <p>Det har oppst\xE5tt en uventet feil. Vi beklager det inntrufne og ber deg pr\xF8ve igjen p\xE5 et senere tidspunkt.</p>\n    <p>Takk for din t\xE5lmodighet!</p>\n    <p>Vennlig hilsen <br />YX Visa</p>\n  ",
  lanNei: "\n    <h2>Vi kan dessverre ikke innvilge din l\xE5nes\xF8knad</h2>\n    <p>P\xE5 bakgrunn av den informasjonen vi har mottatt av deg, eller opplysninger innhentet fra offentlig register (f.eks. ligningsdata) kan vi dessverre ikke innvilge din s\xF8knad.</p>\n    <p>Det er mulig at du allerede har en s\xF8knad registrert i v\xE5re systemer og av denne grunn f\xE5r avslag. Kontakt v\xE5rt <a href=\"/kundesenter#humany-kundesenter=/contact/84\" target=\"_blank\" rel=\"noreferrer\">kundesenter</a> hvis dette kan v\xE6re tilfelle eller telefon 23 20 46 00 (mellom 09:00-16:00 p\xE5 hverdager).</p>\n    <p>\n      <b>Nyhet! Eier du bolig?</b>\n      <br />\n      yA Pantel\xE5n er et nytt alternativ til deg som eier bolig. Opptil 25 \xE5r nedbetalingstid kan gi lavere m\xE5nedskostnader.\n      <br />\n      <b><a href=\"https://yanettbank.ya.no/#/loan/secured\" target=\"_blank\" rel=\"noreferrer\">S\xF8k uforpliktende her</a></b>\n    </p>\n    <p>Vi takker for din s\xF8knad og \xF8nsker deg velkommen tilbake ved en senere anledning.</p>\n    <p>Vennlig hilsen <br />yA \u2013 en del av Resurs Bank</p>\n  ",
  lanManuell: "\n    <h2>Takk for din s\xF8knad om l\xE5n i yA!</h2>\n    <p>Din s\xF8knad vil bli behandlet innen kort tid.</p>\n    <p>En av v\xE5re kundebehandlere vil kontakte deg n\xE5r s\xF8knaden er ferdigbehandlet.</p>\n    <p>Vennlig hilsen <br />yA \u2013 en del av Resurs Bank</p>\n  ",
  404: "\n    <h2>Finner ikke siden</h2>\n    <p>Beklager, vi finner ikke siden du fors\xF8kte \xE5 n\xE5.</p>\n    <p>Kontakt oss hvis du mener dette er en feil.</p>\n  ",
  tekniskFeil: "\n    <h2>Det har dessverre oppst\xE5tt en teknisk feil</h2>\n    <p>Vennligst kontakt oss p\xE5 telefon 23 20 46 00, eller pr\xF8v igjen senere.</p>\n    <p>Vennlig hilsen<br />yA \u2013 en del av Resurs Bank</p>\n  ",
  tekniskFeilEkstern: "\n    <h2>Det har dessverre oppst\xE5tt en teknisk feil med underleverand\xF8r</h2>\n    <p>Vennligst kontakt oss p\xE5 telefon 23 20 46 00, eller pr\xF8v igjen senere.</p>\n    <p>Vennlig hilsen<br />yA \u2013 en del av Resurs Bank</p>\n  ",
  lastFallback: function lastFallback(code) {
    return "\n    <h2>Det har dessverre oppst\xE5tt en ukjent feil \u2013 ".concat(code, "</h2>\n    <p>Vennligst kontakt oss p\xE5 telefon 23 20 46 00, eller pr\xF8v igjen senere.</p>\n    <p>Vennlig hilsen<br />yA \u2013 en del av Resurs Bank</p>\n  ");
  }
};
var messageMap = {
  ACCOUNT: {
    2: properMessages.brukskontoNei
  },
  HIGHINTERESTACCOUNT: {
    2: properMessages.hoyrentekontoNei
  },
  CREDIT_CARD: {
    202: properMessages.kredittkortNei,
    203: properMessages.kredittkortNei,
    204: properMessages.kredittkortNei,
    205: properMessages.kredittkortNei,
    201: properMessages.kredittkortManuell,
    503: properMessages.kredittkortManuell,
    206: properMessages.kredittkortAllerede
  },
  YX_CARD: {
    202: properMessages.yxKredittkortNei,
    203: properMessages.yxKredittkortNei,
    204: properMessages.yxKredittkortNei,
    205: properMessages.yxKredittkortNei,
    201: properMessages.yxKredittkortManuell,
    503: properMessages.yxKredittkortManuell,
    206: properMessages.yxKredittkortAllerede,
    4: properMessages.yx400,
    5: properMessages.yx400
  },
  UNSECURED_LOAN: {
    202: properMessages.lanNei,
    203: properMessages.lanNei,
    204: properMessages.lanNei,
    205: properMessages.lanNei,
    206: properMessages.lanNei,
    201: properMessages.lanManuell,
    503: properMessages.lanManuell
  }
};
var generalMessages = {
  404: properMessages[404],
  4: properMessages.tekniskFeil,
  5: properMessages.tekniskFeilEkstern
};
function DeadEndView(_ref) {
  var _messageMap$productTy, _messageMap$productTy2;
  var productType = _ref.productType,
    code = _ref.code,
    message = _ref.message;
  var codeInHundreds = Math.floor(code / 100);
  var innerHtml = ((_messageMap$productTy = messageMap[productType]) === null || _messageMap$productTy === void 0 ? void 0 : _messageMap$productTy[code]) || ((_messageMap$productTy2 = messageMap[productType]) === null || _messageMap$productTy2 === void 0 ? void 0 : _messageMap$productTy2[codeInHundreds]) || generalMessages[code] || generalMessages[codeInHundreds];
  if (typeof innerHtml === "string") {
    // eslint-disable-next-line react/no-danger
    return jsx("div", {
      css: revertedGlobalStyles,
      dangerouslySetInnerHTML: {
        __html: innerHtml
      }
    });
  }
  if (typeof message === "string" && message.trim().length > 0) {
    return jsx("p", null, message);
  }
  return jsx("div", {
    css: revertedGlobalStyles
    // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: properMessages.lastFallback(code)
    }
  });
}
DeadEndView.propTypes = {
  productType: PropTypes.oneOf(["ACCOUNT", "HIGHINTERESTACCOUNT", "CREDIT_CARD", "YX_CARD", "UNSECURED_LOAN"]).isRequired,
  code: PropTypes.number.isRequired,
  message: PropTypes.string
};
DeadEndView.defaultProps = {
  message: ""
};

function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

// utils is a library of generic helper functions non-specific to axios

const {toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
};

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray: isArray$1} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject$1 = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject$1(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
};

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray$1(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray$1(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  };

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
};

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
};

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
};

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray$1 = (thing) => {
  if (!thing) return null;
  if (isArray$1(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
};

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
};

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    if (reducer(descriptor, name, obj) !== false) {
      reducedDescriptors[name] = descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
};

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
};

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  };

  isArray$1(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
};

const noop$4 = () => {};

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
};

const ALPHA = 'abcdefghijklmnopqrstuvwxyz';

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0];
  }

  return str;
};

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject$1(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray$1(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  };

  return visit(obj, 0);
};

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject$1(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

var utils = {
  isArray: isArray$1,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject: isObject$1,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray: toArray$1,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop: noop$4,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
};

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const prototype$1 = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

// eslint-disable-next-line strict
var httpAdapter = null;

/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils.isSpecCompliantForm(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        ((utils.isFileList(value) || utils.endsWith(key, '[]')) && (arr = utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode$1(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && toFormData(params, this, options);
}

const prototype = AxiosURLSearchParams.prototype;

prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode$1);
  } : encode$1;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ?
      params.toString() :
      new AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

var InterceptorManager$1 = InterceptorManager;

var transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

var URLSearchParams$1 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;

var FormData$1 = typeof FormData !== 'undefined' ? FormData : null;

var Blob$1 = typeof Blob !== 'undefined' ? Blob : null;

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const isStandardBrowserEnv = (() => {
  let product;
  if (typeof navigator !== 'undefined' && (
    (product = navigator.product) === 'ReactNative' ||
    product === 'NativeScript' ||
    product === 'NS')
  ) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
})();

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
 const isStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();


var platform = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  isStandardBrowserEnv,
  isStandardBrowserWebWorkerEnv,
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
};

function toURLEncodedForm(data, options) {
  return toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};

    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

const DEFAULT_CONTENT_TYPE = {
  'Content-Type': undefined
};

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: transitionalDefaults,

  adapter: ['xhr', 'http'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils.isFormData(data);

    if (isFormData) {
      if (!hasJSONContentType) {
        return data;
      }
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

var defaults$1 = defaults;

// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders = rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};

const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils.isString(value)) return;

  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if(utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

utils.freezeMethods(AxiosHeaders.prototype);
utils.freezeMethods(AxiosHeaders);

var AxiosHeaders$1 = AxiosHeaders;

/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || defaults$1;
  const context = response || config;
  const headers = AxiosHeaders$1.from(context.headers);
  let data = context.data;

  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

var cookies = platform.isStandardBrowserEnv ?

// Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        const cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

// Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })();

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

var isURLSameOrigin = platform.isStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })();

function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

var xhrAdapter = isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = AxiosHeaders$1.from(config.headers).normalize();
    const responseType = config.responseType;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      if (platform.isStandardBrowserEnv || platform.isStandardBrowserWebWorkerEnv) {
        requestHeaders.setContentType(false); // Let the browser set it
      } else {
        requestHeaders.setContentType('multipart/form-data;', false); // mobile/desktop app frameworks
      }
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = AxiosHeaders$1.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (platform.isStandardBrowserEnv) {
      // Add xsrf header
      const xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath))
        && config.xsrfCookieName && cookies.read(config.xsrfCookieName);

      if (xsrfValue) {
        requestHeaders.set(config.xsrfHeaderName, xsrfValue);
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(fullPath);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
};

const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter
};

utils.forEach(knownAdapters, (fn, value) => {
  if(fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

var adapters = {
  getAdapter: (adapters) => {
    adapters = utils.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      if((adapter = utils.isString(nameOrAdapter) ? knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter)) {
        break;
      }
    }

    if (!adapter) {
      if (adapter === false) {
        throw new AxiosError(
          `Adapter ${nameOrAdapter} is not supported by the environment`,
          'ERR_NOT_SUPPORT'
        );
      }

      throw new Error(
        utils.hasOwnProp(knownAdapters, nameOrAdapter) ?
          `Adapter '${nameOrAdapter}' is not available in the build` :
          `Unknown adapter '${nameOrAdapter}'`
      );
    }

    if (!utils.isFunction(adapter)) {
      throw new TypeError('adapter is not a function');
    }

    return adapter;
  },
  adapters: knownAdapters
};

/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = AxiosHeaders$1.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || defaults$1.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = AxiosHeaders$1.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = AxiosHeaders$1.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

const headersToObject = (thing) => thing instanceof AxiosHeaders$1 ? thing.toJSON() : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({caseless}, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  utils.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

const VERSION = "1.4.0";

const validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

var validator = {
  assertOptions,
  validators: validators$1
};

const validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager$1(),
      response: new InterceptorManager$1()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    let contextHeaders;

    // Flatten headers
    contextHeaders = headers && utils.merge(
      headers.common,
      headers[config.method]
    );

    contextHeaders && utils.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = AxiosHeaders$1.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

var Axios$1 = Axios;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

var CancelToken$1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
}

const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

var HttpStatusCode$1 = HttpStatusCode;

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new Axios$1(defaultConfig);
  const instance = bind(Axios$1.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios$1.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(defaults$1);

// Expose Axios class to allow class inheritance
axios.Axios = Axios$1;

// Expose Cancel & CancelToken
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken$1;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData;

// Expose AxiosError class
axios.AxiosError = AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = AxiosHeaders$1;

axios.formToJSON = thing => formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.HttpStatusCode = HttpStatusCode$1;

axios.default = axios;

// this module should only have a default export
var axios$1 = axios;

var headers = {
  "Content-Type": "application/x-www-form-urlencoded"
};
var responseOk = function responseOk(apiName, responseCode) {
  if (apiName === "step1") {
    return [200, 201].includes(responseCode);
  }
  return responseCode === 200;
};
var isDeadEndError = function isDeadEndError(apiName, responseCode) {
  if (apiName === "step1") {
    return ![200, 201, 406].includes(responseCode);
  }
  return ![200, 406].includes(responseCode);
};
function submit(_x, _x2, _x3) {
  return _submit.apply(this, arguments);
}
function _submit() {
  _submit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, baseUrl, apiName) {
    var url, params, responseObject, response, _response$data, message, application, code, _error$response, _error$response2, _error$response3, _error$response4, _error$response4$data, _code;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = "".concat(baseUrl, "/api/application/").concat(apiName);
            params = new URLSearchParams();
            Object.keys(data).forEach(function (key) {
              if (Array.isArray(data[key])) {
                data[key].forEach(function (item) {
                  var value = typeof item === "string" ? item.trim() : item;
                  params.append(key, value);
                });
              } else {
                var value = typeof data[key] === "string" ? data[key].trim() : data[key];
                params.append(key, value);
              }
            });
            responseObject = {};
            _context.prev = 4;
            _context.next = 7;
            return axios$1.post(url, params, {
              headers: headers
            });
          case 7:
            response = _context.sent;
            _response$data = response.data, message = _response$data.message, application = _response$data.application;
            code = response.status;
            responseObject = {
              code: code,
              message: message || response.statusText,
              application: application
            };
            _context.next = 17;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](4);
            _code = ((_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status) || 400;
            responseObject = {
              code: _code,
              message: ((_error$response2 = _context.t0.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data.message) || ((_error$response3 = _context.t0.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.data.error) || _context.t0.message,
              application: ((_error$response4 = _context.t0.response) === null || _error$response4 === void 0 ? void 0 : (_error$response4$data = _error$response4.data) === null || _error$response4$data === void 0 ? void 0 : _error$response4$data.application) || {}
            };
          case 17:
            responseObject.ok = responseOk(apiName, responseObject.code);
            responseObject.isDeadEndError = isDeadEndError(apiName, responseObject.code);
            return _context.abrupt("return", responseObject);
          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 13]]);
  }));
  return _submit.apply(this, arguments);
}
var submitFactory = function submitFactory(apiName) {
  return function (data, baseUrl) {
    return submit(data, baseUrl, apiName);
  };
};
var stepOnePost = submitFactory("step1");
var submitYxVisaCardApplication = submitFactory("submitWhiteLabelCardApplication");
var submitCardApplication = submitFactory("submitCardApplication");
var submitAccount = submitFactory("submitAccount");
var submitUnsecuredLoanApplication = submitFactory("submitUnsecuredLoanApplication");

var dist = {};

(function (exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGender = exports.isValidCheckDigits = exports.idNumberContainsBirthDate = exports.possibleAgeOfPersonWithIdNumber = exports.possibleAgesOfPersonWithIdNumber = exports.validateNorwegianIdNumber = exports.Gender = exports.IDNumberType = exports.isValidDate = exports.diffYears = exports.NorwegianId = void 0;
/**
 * Object-oriented API for Norwegian National ID Validator
 * @example
 * ```javascript
 * import { NorwegianId } from 'norwegian-national-id-validator';
 *
 * const valid = NorwegianId('0000000000');
 * ```
 * @param idNumber norwegian social security number
 */
exports.NorwegianId = function (idNumber) {
    var valid = validateNorwegianIdNumber(idNumber);
    return {
        /** The ID this object was created with */
        idNumber: idNumber,
        isValid: function () { return valid; },
        /**
         * A national identity number (birth number) is an ID number for you who
         * have a residence permit and are going to live in Norway for more than
         * six months.
         */
        isBirthNumber: function () {
            return valid && idNumberType(idNumber) == IDNumberType.BirthNumber;
        },
        /**
         * A D number is a temporary identification number that you get if you have
         * applied for protection (asylum), or if you have a residence permit and
         * are going to stay in Norway for less than six months.
         */
        isDNumber: function () { return valid && idNumberType(idNumber) == IDNumberType.DNumber; },
        /**
         * A H number is a number used for assistance, a unique identification of a
         * person that does not have a national ID or a D number or in cases where
         * this is not known. A H number contains information about age and gender.
         */
        isHNumber: function () { return valid && idNumberType(idNumber) == IDNumberType.HNumber; },
        /**
         * A FH number is used in health care to uniquely identify patients that
         * does not have a known national ID or D number. A FH number does not have
         * any information about age or gender.
         */
        isFhNumber: function () { return valid && idNumberType(idNumber) == IDNumberType.FHNumber; },
        isMale: function () { return valid && getGender(idNumber) == Gender.Male; },
        isFemale: function () { return valid && getGender(idNumber) == Gender.Female; },
        age: function () { return possibleAgeOfPersonWithIdNumber(idNumber); },
    };
};
/**
 * Calculated the difference betweeen two dates.
 * @param startDate Date instance
 * @param endDate Date instance
 * @private
 */
function diffYears(startDate, endDate) {
    var yStart = startDate.getFullYear();
    var mStart = startDate.getMonth();
    var dStart = startDate.getDate();
    var yEnd = endDate.getFullYear();
    var mEnd = endDate.getMonth();
    var dEnd = endDate.getDate();
    var diff = yStart - yEnd;
    if (mEnd > mStart || (mEnd === mStart && dEnd > dStart)) {
        return diff - 1;
    }
    return diff;
}
exports.diffYears = diffYears;
/**
 * Checks if a date is valid against another
 * @param date Date instance
 * @param expectedYear
 * @param expectedMonth
 * @param expectedDay
 */
function isValidDate(date, expectedYear, expectedMonth, expectedDay) {
    return (date.getFullYear() === Number(expectedYear) &&
        date.getMonth() + 1 === Number(expectedMonth) &&
        date.getDate() === Number(expectedDay));
}
exports.isValidDate = isValidDate;
/** In Norway there are several different ID numbers */
var IDNumberType;
(function (IDNumberType) {
    /**
     * A national identity number (birth number) is an ID number for you who
     * have a residence permit and are going to live in Norway for more than
     * six months.
     */
    IDNumberType[IDNumberType["BirthNumber"] = 0] = "BirthNumber";
    /**
     * A D number is a temporary identification number that you get if you have
     * applied for protection (asylum), or if you have a residence permit and
     * are going to stay in Norway for less than six months.
     */
    IDNumberType[IDNumberType["DNumber"] = 1] = "DNumber";
    /**
     * A H number is a number used for assistance, a unique identification of a
     * person that does not have a national ID or a D number or in cases where
     * this is not known. A H number contains information about age and gender.
     */
    IDNumberType[IDNumberType["HNumber"] = 2] = "HNumber";
    /**
     * A FH number is used in health care to uniquely identify patients that
     * does not have a known national ID or D number. A FH number does not have
     * any information about age or gender.
     */
    IDNumberType[IDNumberType["FHNumber"] = 3] = "FHNumber";
})(IDNumberType = exports.IDNumberType || (exports.IDNumberType = {}));
/**
 * Birth numbers, D-number and H-number contains information about gender
 */
var Gender;
(function (Gender) {
    /** If the third last digit in the ID number is odd, it is a male */
    Gender[Gender["Male"] = 0] = "Male";
    /** If the third last digit in the ID number is even, it is a female */
    Gender[Gender["Female"] = 1] = "Female";
})(Gender = exports.Gender || (exports.Gender = {}));
/**
 * Checks if the given value is a valid Norwegian national identity number.
 * @example
 * ```javascript
 * import { validateNorwegianIdNumber } from 'norwegian-national-id-validator';
 * const valid = validateNorwegianIdNumber(0000000000);
 * ```
 * @param idNumber social security number
 * @returns `true` for valid, and `false` for invalid ID number.
 */
function validateNorwegianIdNumber(idNumber) {
    var trimmed = idNumber.trim();
    if (isNaN(Number(trimmed)))
        return false;
    if (trimmed.length !== 11)
        return false;
    if (!isValidCheckDigits(trimmed))
        return false;
    var type = idNumberType(trimmed);
    if (type === IDNumberType.FHNumber)
        return true;
    else
        return possibleAgesOfPersonWithIdNumber(trimmed).length > 0;
}
exports.validateNorwegianIdNumber = validateNorwegianIdNumber;
/**
 * Find possible age of person based of ID number
 * @param elevenDigits Identification number
 */
function possibleAgesOfPersonWithIdNumber(elevenDigits) {
    var possibleAge = possibleAgeOfPersonWithIdNumber(elevenDigits);
    return possibleAge == null ? [] : [possibleAge];
}
exports.possibleAgesOfPersonWithIdNumber = possibleAgesOfPersonWithIdNumber;
/**
 * Returns the age of a person with given Norwegian national identity number.
 * Returns `undefined` when birth date could not be determined (e.g. for FH-numbers and invalid ID-numbers).
 * @param elevenDigits Identification number
 */
function possibleAgeOfPersonWithIdNumber(elevenDigits) {
    var birthDate = possibleBirthDateOfIdNumber(elevenDigits);
    if (birthDate == null) {
        return undefined;
    }
    var years = diffYears(new Date(), birthDate);
    return years >= 0 && years < 125 ? years : undefined;
}
exports.possibleAgeOfPersonWithIdNumber = possibleAgeOfPersonWithIdNumber;
/**
 * Check if idNumber contains birth date
 * @param elevenDigits idNumber
 */
function idNumberContainsBirthDate(elevenDigits) {
    return idNumberType(elevenDigits) !== IDNumberType.FHNumber;
}
exports.idNumberContainsBirthDate = idNumberContainsBirthDate;
/**
 * Get possible birth date from ID number
 * @param elevenDigits IdNumber
 */
function possibleBirthDateOfIdNumber(elevenDigits) {
    if (elevenDigits.length !== 11)
        return undefined;
    var type = idNumberType(elevenDigits);
    switch (type) {
        case IDNumberType.BirthNumber:
            return possibleBirthDateOfBirthNumber(elevenDigits);
        case IDNumberType.DNumber:
            return possibleBirthDateOfDNumber(elevenDigits);
        case IDNumberType.HNumber:
            return possibleBirthDateOfHNumber(elevenDigits);
    }
    return undefined;
}
/**
 * Get the ID number kind/type. This function does not validate, so
 * it should be combined with {@linkcode validateNorwegianIdNumber}.
 * @example
 * ```javascript
 * import { idNumberType, validateNorwegianIdNumber } from 'norwegian-national-id-validator';
 * if (validateNorwegianIdNumber(0000000000)) {
 *   const type = idNumberType(00000000000);
 * }
 * ```
 * @param elevenDigits IdNumber
 */
function idNumberType(elevenDigits) {
    var firstDigit = parseInt(elevenDigits[0]);
    if (firstDigit === 8 || firstDigit === 9)
        return IDNumberType.FHNumber;
    if (firstDigit >= 4 && firstDigit <= 7)
        return IDNumberType.DNumber;
    var thirdDigit = parseInt(elevenDigits[2]);
    if (thirdDigit === 4 || thirdDigit === 5)
        return IDNumberType.HNumber;
    else
        return IDNumberType.BirthNumber;
}
/**
 * Get possible birth date from BirthNumber
 * @param elevenDigits BirthNumber
 */
function possibleBirthDateOfBirthNumber(elevenDigits) {
    return getBirthDate(elevenDigits, IDNumberType.BirthNumber);
}
/**
 * Get possible birth date from HNumber
 * @param elevenDigits HNumber
 */
function possibleBirthDateOfHNumber(elevenDigits) {
    var correctedThirdDigit = (parseInt(elevenDigits[2]) - 4).toString();
    return getBirthDate(elevenDigits.slice(0, 2) + correctedThirdDigit + elevenDigits.slice(3, 11), IDNumberType.HNumber);
}
/**
 * Get possible birth date from DNumber
 * @param elevenDigits DNumber
 */
function possibleBirthDateOfDNumber(elevenDigits) {
    var correctedFirstDigit = (parseInt(elevenDigits[0]) - 4).toString();
    return getBirthDate(correctedFirstDigit + elevenDigits.slice(1, 11), IDNumberType.DNumber);
}
/**
 * @private
 */
function getBirthDate(elevenDigitsWithDDMMYY, idNumberType) {
    var DD = elevenDigitsWithDDMMYY.slice(0, 2);
    var MM = elevenDigitsWithDDMMYY.slice(2, 4);
    var YY = elevenDigitsWithDDMMYY.slice(4, 6);
    var YY_int = parseInt(YY);
    var ageGroupNumber = parseInt(elevenDigitsWithDDMMYY.slice(6, 9));
    var centuryPrefix = '20';
    if (ageGroupNumber >= 0 && ageGroupNumber < 500) {
        centuryPrefix = '19';
    }
    else if (idNumberType === IDNumberType.DNumber) {
        centuryPrefix = '20';
    }
    else if (ageGroupNumber >= 500 && ageGroupNumber < 750 && YY_int >= 54) {
        centuryPrefix = '18';
    }
    else if (ageGroupNumber >= 900 && ageGroupNumber < 1000 && YY_int >= 40) {
        centuryPrefix = '19';
    }
    var fullYear = "" + centuryPrefix + YY;
    var isoStr = [fullYear, MM, DD].join('-') + 'T00:00:00';
    var birthDate = new Date(isoStr);
    if (!isValidDate(birthDate, fullYear, MM, DD)) {
        return undefined;
    }
    return birthDate;
}
/**
 * @private
 */
function isValidCheckDigits(elevenDigits) {
    var staticSequenceFirstCheckDigit = [3, 7, 6, 1, 8, 9, 4, 5, 2, 1];
    var staticSequenceSecondCheckDigit = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2, 1];
    var elevenDigitsArray = elevenDigits.split('').map(Number);
    return (isValidCheckDigit(staticSequenceFirstCheckDigit, elevenDigitsArray) &&
        isValidCheckDigit(staticSequenceSecondCheckDigit, elevenDigitsArray));
}
exports.isValidCheckDigits = isValidCheckDigits;
/**
 * @private
 */
function isValidCheckDigit(staticSequence, elevenDigits) {
    var productSum = staticSequence.reduce(function (acc, value, index) { return acc + value * elevenDigits[index]; }, 0);
    return productSum % 11 === 0;
}
/**
 * Returns the gender based of ID number. Returns `undefined` when no gender
 * information is available.
 * @param elevenDigits ID number
 */
function getGender(elevenDigits) {
    if (elevenDigits.length != 11) {
        return undefined;
    }
    else if (idNumberType(elevenDigits) == IDNumberType.FHNumber) {
        return undefined;
    }
    var isFemale = Number(elevenDigits.charAt(8)) % 2 == 0;
    if (isFemale) {
        return Gender.Female;
    }
    else {
        return Gender.Male;
    }
}
exports.getGender = getGender;
}(dist));

/*
    **CUSTOM FIELDS**
    ********V********
    isRequired  // Field must have a value.
    lettersOnly // Legal letters only. 
    fullName    // Field must have minimum one space inbetween letters {firstName lastName}. Requires: lettersOnly.
    values      // Input values that are allowed.
    digits      // Only numbers allowed.
    rangelength // Amount of characters allowed.
    maxAmount   // Max currency value allowed. Requires: digits.
    errMsg      // A custom error message for the field.

    <i>See validation.js for more information</i>
*/

var rules = {
  productType: {
    values: ["CREDIT_CARD", "UNSECURED_LOAN"],
    isRequired: true
  },
  frontendFormType: {
    values: ["UNSECURED_LOAN_SUBMIT"],
    isRequired: true
  },
  // Step 1
  downpaymentPeriod: {
    isRequired: true,
    digits: true,
    maxAmount: 15
  },
  name: {
    errMsg: "Fornavn, mellom- og etternavn",
    isRequired: true,
    lettersOnly: true,
    fullName: true
  },
  ssn: {
    errMsg: "Legg inn fødselsnummer 11 siffer",
    isRequired: true,
    isSsn: true,
    rangelength: [11, 11]
  },
  email: {
    errMsg: "Feltet må fylles ut",
    isRequired: true
  },
  emailRepeat: {
    errMsg: "Feltet må fylles ut",
    isRequired: true
  },
  mobilNo: {
    // errMsg: "Må være et norsk telefonnummer", // eller svenskt..
    isRequired: true,
    digits: true,
    rangelength: [8, 13]
  },
  // Brukskonto
  isPoliticallyExposedPerson: {
    isRequired: true,
    values: [false, true]
  },
  willTransferToOtherCountries: {
    isRequired: true,
    values: [false, true]
  },
  transfersToOtherCountries: {
    isRequired: true,
    maxAmount: 20000000,
    digits: true
  },
  isAmericanCitizen: {
    isRequired: true,
    values: [false, true]
  },
  tinNumber: {
    isRequired: true
  },
  noTinNumberCheckbox: {
    isRequired: true,
    values: [false, true]
  },
  isTaxwiseResidentOfForeignCountry: {
    isRequired: true,
    values: [false, true]
  },
  saveForDwelling: {
    isRequired: true,
    values: [false, true]
  },
  saveForFamily: {
    isRequired: true,
    values: [false, true]
  },
  personalUse: {
    isRequired: true,
    values: [false, true]
  },
  income: {
    isRequired: true,
    values: [false, true]
  },
  inheritance: {
    isRequired: true,
    values: [false, true]
  },
  gift: {
    isRequired: true,
    values: [false, true]
  },
  realestate: {
    isRequired: true,
    values: [false, true]
  },
  savings: {
    isRequired: true,
    values: [false, true]
  },
  depositsOtherAverage: {
    isRequired: false,
    maxAmount: 20000000,
    digits: true
  },
  idNumber1: {
    isRequired: true,
    digits: true
  },
  idNumber2: {
    isRequired: true,
    digits: true
  },
  idNumber3: {
    isRequired: true,
    digits: true
  },
  idNumber4: {
    isRequired: true
  },
  idNumber5: {
    isRequired: true,
    digits: true
  },
  noIdNumberCheckbox1: {
    isRequired: true,
    values: [false, true]
  },
  noIdNumberCheckbox2: {
    isRequired: true,
    values: [false, true]
  },
  noIdNumberCheckbox3: {
    isRequired: true,
    values: [false, true]
  },
  noIdNumberCheckbox4: {
    isRequired: true,
    values: [false, true]
  },
  noIdNumberCheckbox5: {
    isRequired: true,
    values: [false, true]
  },
  noIdReasonText1: {
    isRequired: true
  },
  noIdReasonText2: {
    isRequired: true
  },
  noIdReasonText3: {
    isRequired: true
  },
  noIdReasonText4: {
    isRequired: true
  },
  noIdReasonText5: {
    isRequired: true
  },
  noTinReason: {
    isRequired: true
  },
  // Step 2
  civilStatus: {
    values: ["MARRIED_OR_PARTNER", "COHABITANT", "SEPARATED", "SINGLE", "WIDOW_OR_WIDOWER"],
    errMsg: "Feltet må fylles ut",
    isRequired: true
  },
  habitat: {
    values: ["RENTED", "OWNED", "PARENTS"],
    // todo: add PARENTS option to yxvisa
    isRequired: true
  },
  noOfChildren: {
    values: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    isRequired: true,
    digits: true
  },
  isNorwegianCitizen: {
    values: [false, true],
    isRequired: true
  },
  education: {
    values: ["PRIMARY_SCHOOL", "SECONDARY_SCHOOL", "UNIVERSITY_SHORT", "UNIVERSITY_LONG"],
    isRequired: true
  },
  employmentSituation: {
    values: ["PERMANENT_EMPLOYMENT", "DEPUTY", "SELF_EMPLOYED", "STUDENT", "RETIRED", "UNEMPLOYED", "REHABILITATION", "INCAPABLE", "OTHER"],
    isRequired: true
  },
  employer: {
    isRequired: true
  },
  employedSince: {
    isRequired: true,
    maxAmount: 100,
    digits: true
  },
  grossIncomeYearly: {
    isRequired: true,
    maxAmount: 20000000,
    digits: true
  },
  extraIncome: {
    isRequired: false,
    maxAmount: 20000000,
    digits: true
  },
  spouseIncomeYearly: {
    isRequired: true,
    maxAmount: 20000000,
    digits: true
  },
  houseLoan: {
    values: ["on", "off"],
    errMsg: "Velg en",
    isRequired: true
  },
  houseLoanInputFieldLoanAmount: {
    isRequired: true,
    maxAmount: 20000000,
    digits: true
  },
  houseLoanInputFieldMonthlyPayment: {
    isRequired: true,
    maxAmount: 20000000,
    digits: true
  },
  studentLoan: {
    values: ["on", "off"],
    errMsg: "Velg en",
    isRequired: true
  },
  studentLoanInputFieldLoanAmount: {
    isRequired: true,
    maxAmount: 20000000,
    digits: true
  },
  studentLoanInputFieldMonthlyPayment: {
    isRequired: true,
    maxAmount: 20000000,
    digits: true
  },
  carLoan: {
    values: ["on", "off"],
    errMsg: "Velg en",
    isRequired: true
  },
  carLoanInputFieldLoanAmount: {
    isRequired: true,
    maxAmount: 20000000,
    digits: true
  },
  carLoanInputFieldMonthlyPayment: {
    isRequired: true,
    maxAmount: 20000000,
    digits: true
  },
  employerSubsidary: {
    isRequired: true
  },
  employedSinceSubsidary: {
    isRequired: true,
    maxAmount: 100,
    digits: true
  },
  nameSubsidiary: {
    errMsg: "Fornavn, mellom- og etternavn",
    isRequired: true,
    lettersOnly: true,
    fullName: true
  },
  ssnSubsidiary: {
    errMsg: "Legg inn fødselsnummer 11 siffer",
    isRequired: true,
    isSsn: true,
    rangelength: [11, 11]
  },
  emailSubsidiary: {
    errMsg: "Feltet må fylles ut",
    isRequired: true
  },
  mobilNoSubsidiary: {
    errMsg: "Feltet må fylles ut",
    isRequired: true,
    digits: true,
    rangelength: [8, 12]
  },
  iLiveWithMainApplicantSubsidiary: {
    values: [true, false],
    isRequired: true
  },
  civilStatusSubsidiary: {
    values: ["MARRIED_OR_PARTNER", "COHABITANT", "SEPARATED", "SINGLE", "WIDOW_OR_WIDOWER"],
    errMsg: "Feltet må fylles ut",
    isRequired: true
  },
  habitatSubsidiary: {
    values: ["RENTED", "OWNED"],
    isRequired: true
  },
  educationSubsidiary: {
    values: ["PRIMARY_SCHOOL", "SECONDARY_SCHOOL", "UNIVERSITY_SHORT", "UNIVERSITY_LONG"],
    isRequired: true
  },
  employmentSituationSubsidiary: {
    values: ["PERMANENT_EMPLOYMENT", "DEPUTY", "SELF_EMPLOYED", "STUDENT", "RETIRED", "UNEMPLOYED", "REHABILITATION", "INCAPABLE", "OTHER"],
    isRequired: true
  },
  isNorwegianCitizenSubsidiary: {
    values: [false, true],
    isRequired: true
  },
  grossIncomeYearlySubsidiary: {
    isRequired: true,
    maxAmount: 20000000,
    digits: true
  },
  extraIncomeSubsidiary: {
    isRequired: false,
    maxAmount: 20000000,
    digits: true
  },
  spouseIncomeYearlySubsidiary: {
    isRequired: true,
    maxAmount: 20000000,
    digits: true
  },
  houseLoanSubsidiary: {
    values: ["on", "off"],
    isRequired: true
  },
  houseLoanSubsidiaryInputFieldLoanAmount: {
    isRequired: true,
    maxAmount: 20000000,
    digits: true
  },
  houseLoanSubsidiaryInputFieldMonthlyPayment: {
    isRequired: true,
    maxAmount: 20000000,
    digits: true
  },
  studentLoanSubsidiary: {
    values: ["on", "off"],
    isRequired: true
  },
  studentLoanSubsidiaryInputFieldLoanAmount: {
    isRequired: true,
    maxAmount: 20000000,
    digits: true
  },
  studentLoanSubsidiaryInputFieldMonthlyPayment: {
    isRequired: true,
    maxAmount: 20000000,
    digits: true
  },
  carLoanSubsidiary: {
    values: ["on", "off"],
    isRequired: true
  },
  carLoanSubsidiaryInputFieldLoanAmount: {
    isRequired: true,
    maxAmount: 20000000,
    digits: true
  },
  carLoanSubsidiaryInputFieldMonthlyPayment: {
    isRequired: true,
    maxAmount: 20000000,
    digits: true
  },
  willUseLoansToRefinance: {
    values: [true, false],
    errMsg: "Velg en",
    isRequired: true
  },
  refinanceEverything: {
    values: [true, false],
    isRequired: true
  },
  refinanceAmount: {
    isRequired: true,
    maxAmount: 20000000,
    digits: true
  },
  dueDate: {
    values: ["FIRST", "TWENTIETH"],
    isRequired: true
  },
  hasDebtCollection: {
    values: [true, false],
    isRequired: true
  },
  discountCode: {
    required: false
  },
  wantsMOT: {
    values: [true, false],
    isRequired: true
  },
  willOthersDeposit: {
    values: [true, false],
    isRequired: true
  },
  wantedCreditLimit: {
    values: ["5000", "10000", "15000", "25000", "50000", "75000", "100000"],
    isRequired: true
  },
  nameAdditionalCardHolder: {
    errMsg: "Fornavn, mellom- og etternavn",
    isRequired: true,
    lettersOnly: true,
    fullName: true
  },
  ssnAdditionalCardHolder: {
    errMsg: "Legg inn fødselsnummer 11 siffer",
    isRequired: true,
    isSsn: true,
    rangelength: [11, 11]
  },
  paymentMethod: {
    values: ["EMAIL", "BANK"],
    isRequired: true
  },
  comment: {
    isRequired: false
  },
  accept: {
    isRequired: true,
    errMsg: "Du må akseptere vilkårene",
    values: ["on"]
  }
};

/* eslint-disable no-console */
/*
Test options are stored in local storage in the browser.
They allow modifying the bahvior of the components in a
test environment.

Default options are written to local storage if they are missing.

Empty url options are ignored and will not yield an override.
*/

function isTestEnvironment() {
  var testHostsSubstrings = ["localhost", "ya.resurs.24hr.se"];
  var isSSR = typeof window === "undefined"; // Server-side rendering doesn't have any window object
  return !isSSR && testHostsSubstrings.some(function (h) {
    return window.location.hostname.includes(h);
  });
}
var DefaultOptions = Object.freeze({
  ssnValidation: true,
  keycloakUrl: "",
  calculatorserviceUrl: "",
  cmshelperUrl: "",
  sblbinUrl: "",
  consentmanagerUrl: "",
  inUrlReplace: "oldSubstringOfUrl|newSubstringOfUrl",
  return412: false
});
function isUrlOption(option) {
  return option.endsWith("Url");
}
function getTestOptions() {
  if (!isTestEnvironment()) {
    return null;
  }
  var testOptions = {};
  Object.entries(DefaultOptions).forEach(function (_ref) {
    var _ref2 = _slicedToArray$2(_ref, 2),
      option = _ref2[0],
      defaultValue = _ref2[1];
    var optionName = "test-option-".concat(option);
    var optionStringValue = localStorage.getItem(optionName);

    // create local storage item if it's missing
    if (optionStringValue === null) {
      optionStringValue = String(defaultValue);
      localStorage.setItem(optionName, optionStringValue);
    }

    // convert from string value to expected type
    var optionValue = optionStringValue;
    if (typeof defaultValue === "boolean") {
      optionValue = Boolean(optionStringValue.toLowerCase() === "true");
    }
    var isEmptyUrlOverride = isUrlOption(option) && optionValue === "";
    if (!isEmptyUrlOverride) {
      testOptions[option] = optionValue;
    }
  });
  var isDefault = Object.entries(testOptions).every(function (_ref3) {
    var _ref4 = _slicedToArray$2(_ref3, 2),
      option = _ref4[0],
      value = _ref4[1];
    return DefaultOptions[option] === value;
  });
  if (!isDefault) {
    console.info("TestOptions are used to modify the behavior. See Local Storage.", testOptions);
  }
  return testOptions;
}

// eslint-disable-next-line import/prefer-default-export
var validateValue = function validateValue(id, value, state) {
  var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  if (!rules[id]) {
    return {
      ok: true,
      errMsg: ""
    };
  }
  var _rules$id = rules[id],
    isRequired = _rules$id.isRequired,
    lettersOnly = _rules$id.lettersOnly,
    fullName = _rules$id.fullName,
    values = _rules$id.values,
    digits = _rules$id.digits,
    rangelength = _rules$id.rangelength,
    maxAmount = _rules$id.maxAmount,
    errMsg = _rules$id.errMsg,
    isSsn = _rules$id.isSsn;
  if (isRequired) {
    if (value === undefined || value == null || value === "Velg" || value === "") {
      return {
        ok: false,
        errMsg: errMsg || "Feltet må fylles ut",
        errorFieldName: typeof index === "number" ? "".concat(id, "Error").concat(index) : undefined
      };
    }
  }
  if (digits) {
    // eslint-disable-next-line no-param-reassign
    value = Number(value);
    if (Number.isNaN(value)) {
      return {
        ok: false,
        errMsg: errMsg || "Benytt siffer",
        errorFieldName: typeof index === "number" ? "".concat(id, "Error").concat(index) : undefined
      };
    }
    if (maxAmount) {
      if (value > maxAmount) {
        return {
          ok: false,
          errMsg: errMsg || "Bel\xF8pet m\xE5 v\xE6re mindre enn ".concat(maxAmount.toLocaleString("no")),
          errorFieldName: typeof index === "number" ? "".concat(id, "Error").concat(index) : undefined
        };
      }
    }
  }
  if (isSsn) {
    if (value === undefined || !/^\d{11}$/.test(value)) {
      return {
        ok: false,
        errMsg: errMsg || "Benytt siffer"
      };
    }
  }
  if (rangelength && rangelength.length === 2) {
    var min = rangelength[0];
    var max = rangelength[1];

    // Min/Max has the same range length
    if (min === max && (String(value).length < min || String(value).length > max)) {
      return {
        ok: false,
        errMsg: id === "ssn" ? errMsg : "Feltet kan ikke v\xE6re mindre eller lengre enn ".concat(max, " tegn")
      };
    }
    if (String(value).length < min || String(value).length > max) {
      return {
        ok: false,
        errMsg: id === "ssn" ? errMsg : "Legg inn en verdi p\xE5 mellom ".concat(min, " og ").concat(max, " tegn")
      };
    }
  }
  if (values) {
    if (!rules[id].values.includes(value)) {
      return {
        ok: false,
        errMsg: errMsg || "Korriger dette feltet"
      };
    }
  }
  if (lettersOnly) {
    var lettersOnlyRegex = /^[ '\x2DA-Za-z\xC0-\xFF]+$/;
    if (!lettersOnlyRegex.test(value)) {
      return {
        ok: false,
        errMsg: errMsg || "Du kan kun bruke bokstaver"
      };
    }
    if (fullName) {
      var nameRegex = /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*[A-Za-z\xC0-\xFF]['\x2DA-Za-z\xC0-\xFF]*( [A-Za-z\xC0-\xFF]['\x2DA-Za-z\xC0-\xFF]*)+[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/;
      if (!nameRegex.test(value)) {
        return {
          ok: false,
          errMsg: "Du kan kun bruke bokstaver. Skriv både fornavn og etternavn"
        };
      }
    }
  }
  if (id === "email" || id === "emailRepeat" || id === "emailSubsidiary") {
    var emailRegex = /^\S+@\S+$/i;
    if (!emailRegex.test(value)) {
      return {
        ok: false,
        errMsg: "Du må skrive inn en gyldig e-post"
      };
    }
  }
  var testOptions = getTestOptions();
  var useSsnValidation = testOptions && testOptions.ssnValidation;
  if ((id === "ssn" || id === "ssnSubsidiary" || id === "ssnAdditionalCardHolder") && useSsnValidation) {
    var validation = dist.NorwegianId(String(value));
    if (!validation.isValid()) {
      return {
        ok: false,
        errMsg: "Må være et norsk fødselsnummer"
      };
    }
  }

  // validate that the two email inputs are equal
  if (id === "emailRepeat") {
    if (value !== state.email) {
      return {
        ok: false,
        errMsg: "Gjenta gyldig e-post"
      };
    }
  }

  // success!
  return {
    ok: true,
    errMsg: "",
    errorFieldName: typeof index === "number" ? "".concat(id, "Error").concat(index) : undefined
  };
};

function useScrollToTop() {
  for (var _len = arguments.length, watchStates = new Array(_len), _key = 0; _key < _len; _key++) {
    watchStates[_key] = arguments[_key];
  }
  useEffect(function () {
    if (typeof window !== "undefined") {
      window.scrollTo(0, 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, watchStates);
}

// eslint-disable-next-line import/prefer-default-export
var UTM_PARAM_KEYS = ["campaignId", "utm_source", "utm_term", "utm_medium", "utm_content", "utm_campaign", "gclid"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$F() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var SystemMessage = createStyled("div", "development" === "production" ? {
  target: "eqzvohu2"
} : {
  target: "eqzvohu2",
  label: "SystemMessage"
})("padding:1.5rem;background:", colors$1.lightGrey, ";border-top:12px solid ", colors$1.primaryGreen, ";border-radius:2px;" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var H2$3 = createStyled("h2", "development" === "production" ? {
  target: "eqzvohu1"
} : {
  target: "eqzvohu1",
  label: "H2"
})("development" === "production" ? {
  name: "16wxvjy",
  styles: "padding:revert;margin:revert"
} : {
  name: "16wxvjy",
  styles: "padding:revert;margin:revert",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$F
});
var P = createStyled("p", "development" === "production" ? {
  target: "eqzvohu0"
} : {
  target: "eqzvohu0",
  label: "P"
})("development" === "production" ? {
  name: "16wxvjy",
  styles: "padding:revert;margin:revert"
} : {
  name: "16wxvjy",
  styles: "padding:revert;margin:revert",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$F
});
function SystemStatus(_ref) {
  var cmsHelperUrl = _ref.cmsHelperUrl,
    children = _ref.children;
  var _useState = useState(""),
    _useState2 = _slicedToArray$2(_useState, 2),
    systemStatus = _useState2[0],
    setSystemStatus = _useState2[1];
  useEffect(function () {
    var getSystemStatus = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, headers, response, _yield$response$json, status;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "".concat(cmsHelperUrl, "/api/status");
                headers = {
                  Accept: "application/json"
                };
                _context.next = 4;
                return fetch(url, {
                  headers: headers
                });
              case 4:
                response = _context.sent;
                if (!response.ok) {
                  _context.next = 11;
                  break;
                }
                _context.next = 8;
                return response.json();
              case 8:
                _yield$response$json = _context.sent;
                status = _yield$response$json.status;
                setSystemStatus(status);
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function getSystemStatus() {
        return _ref2.apply(this, arguments);
      };
    }();
    getSystemStatus();
  }, [cmsHelperUrl]);
  if (systemStatus === "OFFLINE") {
    return /*#__PURE__*/React__default.createElement(SystemMessage, null, /*#__PURE__*/React__default.createElement(H2$3, null, "Driftsmelding"), /*#__PURE__*/React__default.createElement(P, null, "Akkurat n\xE5 gjennomf\xF8rer vi planmessig vedlikehold p\xE5 v\xE5re systemer. Vi forventer \xE5 v\xE6re ferdige i l\xF8pet av kort tid og h\xE5per \xE5 se deg igjen da."), /*#__PURE__*/React__default.createElement(P, null, "Vi beklager ulemper det m\xE5tte medf\xF8re. Dersom du har sp\xF8rsm\xE5l kan du kontakte kundeservice."));
  }
  return children;
}
SystemStatus.propTypes = {
  cmsHelperUrl: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

function gtmEventService() {
  var pushEvent = function pushEvent(gtmEventObject) {
    if (window.dataLayer) {
      window.dataLayer.push({
        eventInfo: null
      }); // before every "real" push this is needed (for more info why, contact Johan Strand)
      window.dataLayer.push(gtmEventObject);
    }
  };
  return {
    creditCard: function creditCard() {
      var event = "card_application";
      var category = "Credit card application";
      return {
        pushStepOne: function pushStepOne() {
          var action = "Step 1 - Personal";
          pushEvent({
            event: event,
            eventInfo: {
              category: category,
              action: action
            }
          });
        },
        pushStepTwo: function pushStepTwo(message) {
          var action = "Step 2 - Economy";
          pushEvent({
            event: event,
            eventInfo: {
              category: category,
              action: action,
              message: message
            }
          });
        },
        pushStepThree: function pushStepThree(label, decision, message) {
          var action = "Step 3 - Result";
          pushEvent({
            event: event,
            eventInfo: {
              category: category,
              action: action,
              label: label,
              decision: decision,
              message: message
            }
          });
        }
      };
    },
    loan: function loan() {
      var event = "loan_application";
      var category = "Loan application";
      return {
        pushStepOne: function pushStepOne(campaignId) {
          var action = "Step 1 - Personal";
          pushEvent({
            event: event,
            eventInfo: {
              category: category,
              action: action,
              campaignId: campaignId
            }
          });
        },
        pushStepTwo: function pushStepTwo(campaignid, decision, message) {
          var action = "Step 2 - Economy";
          pushEvent({
            event: event,
            eventInfo: {
              category: category,
              action: action,
              campaignid: campaignid,
              decision: decision,
              message: message
            }
          });
        },
        pushStepThree: function pushStepThree(label, decision, amount, campaignid, message) {
          var action = "Step 3 - Result";
          pushEvent({
            event: event,
            eventInfo: {
              category: category,
              action: action,
              label: label,
              decision: decision,
              amount: amount,
              campaignid: campaignid,
              message: message
            }
          });
        }
      };
    },
    yxVisa: function yxVisa() {
      var event = "card_application";
      var category = "YX visa card application";
      return {
        pushStepOne: function pushStepOne() {
          var action = "Step 1 - Personal";
          pushEvent({
            event: event,
            eventInfo: {
              category: category,
              action: action
            }
          });
        },
        pushStepTwo: function pushStepTwo(decision, message) {
          var action = "Step 2 - Economy";
          pushEvent({
            event: event,
            eventInfo: {
              category: category,
              action: action,
              decision: decision,
              message: message
            }
          });
        },
        pushStepThree: function pushStepThree(label, decision, message) {
          var action = "Step 3 - Result";
          pushEvent({
            event: event,
            eventInfo: {
              category: category,
              action: action,
              decision: decision,
              label: label,
              message: message
            }
          });
        }
      };
    },
    account: function account() {
      var event = "savings_account_application";
      var category = "Savings account application";
      return {
        pushStepOne: function pushStepOne(label) {
          var action = "Step 1 - Personal";
          pushEvent({
            event: event,
            eventInfo: {
              category: category,
              action: action,
              label: label
            }
          });
        },
        pushStepTwo: function pushStepTwo(label, decision, message) {
          var action = "Step 2 - Result";
          pushEvent({
            event: event,
            eventInfo: {
              category: category,
              action: action,
              label: label,
              decision: decision,
              message: message
            }
          });
        }
      };
    },
    signing: function signing(productType, label) {
      var event = "".concat(productType.toLowerCase(), "_application");
      var category = "".concat(productType, " application");
      return {
        pushStepFour: function pushStepFour() {
          var action = "Step 4 - Sign";
          pushEvent({
            event: event,
            eventInfo: {
              category: category,
              action: action,
              label: label
            }
          });
        },
        pushStepFive: function pushStepFive() {
          var action = "Step 5 - Signing complete";
          pushEvent({
            event: event,
            eventInfo: {
              category: category,
              action: action,
              label: label
            }
          });
        }
      };
    }
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$E() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Container$8 = createStyled("div", "development" === "production" ? {
  target: "ew7pnba0"
} : {
  target: "ew7pnba0",
  label: "Container"
})("development" === "production" ? {
  name: "ihv00n",
  styles: "max-width:610px"
} : {
  name: "ihv00n",
  styles: "max-width:610px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$E
});
function Konto(props) {
  var _state$apiStatus$appl, _state$apiStatus$appl2, _state$apiStatus$appl3;
  var prefilled = props.prefilled,
    productType = props.productType,
    campaignId = props.campaignId,
    baseApiUrl = props.baseApiUrl;
  var _useState = useState({
      coApplicantsPersonalDetails: false,
      collapseStates: {},
      apiStatus: {
        loading: false
      },
      // Base
      productType: productType,
      schema: "/schema/productApplication_v30.xsd",
      // Step: 1
      name: prefilled ? "Karl Olsen" : "",
      nameError: "",
      ssn: prefilled ? "17065349957" : "",
      ssnError: "",
      email: prefilled ? "yabank@gmail.com" : undefined,
      emailError: "",
      emailRepeat: prefilled ? "yabank@gmail.com" : undefined,
      emailRepeatError: "",
      mobilNo: prefilled ? "13345678" : "",
      mobilNoError: "",
      isPoliticallyExposedPerson: false,
      isPoliticallyExposedPersonError: "",
      willTransferToOtherCountries: !!prefilled,
      willTransferToOtherCountriesError: "",
      transfersToOtherCountries: 0,
      transfersToOtherCountriesError: "",
      isAmericanCitizen: !!prefilled,
      isAmericanCitizenError: "",
      tinNumber: "",
      tinNumberError: "",
      noTinNumberCheckbox: !!prefilled,
      noTinReason: "",
      isTaxwiseResidentOfForeignCountry: false,
      saveForDwelling: false,
      saveForFamily: false,
      personalUse: !!prefilled,
      income: !!prefilled,
      inheritance: false,
      gift: false,
      realestate: false,
      savings: false,
      willOthersDeposit: false,
      willOthersDepositError: "",
      idNumber1: "",
      idNumber2: "",
      idNumber3: "",
      idNumber4: "",
      idNumber5: "",
      taxCountriesAmount: 1,
      taxCountry1: "",
      taxCountry2: "",
      taxCountry3: "",
      taxCountry4: "",
      taxCountry5: "",
      noIdNumberCheckbox1: false,
      noIdNumberCheckbox2: false,
      noIdNumberCheckbox3: false,
      noIdNumberCheckbox4: false,
      noIdNumberCheckbox5: false,
      noIdReasonText1: "",
      noIdReasonText2: "",
      noIdReasonText3: "",
      noIdReasonText4: "",
      noIdReasonText5: "",
      comment: "",
      accept: prefilled ? "on" : "off",
      acceptError: "",
      button1Error: "",
      isDeadEndError: false
    }),
    _useState2 = _slicedToArray$2(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useScrollToTop(state.isDeadEndError);
  var shouldNavigate = state.apiStatus.ok && state.apiStatus.code === 200;
  var signingUrl = (_state$apiStatus$appl = state.apiStatus.application) === null || _state$apiStatus$appl === void 0 ? void 0 : (_state$apiStatus$appl2 = _state$apiStatus$appl.mainApplicantApplication) === null || _state$apiStatus$appl2 === void 0 ? void 0 : (_state$apiStatus$appl3 = _state$apiStatus$appl2.applicant) === null || _state$apiStatus$appl3 === void 0 ? void 0 : _state$apiStatus$appl3.signingUrl;
  useEffect(function () {
    if (state.apiStatus.loading) return;
    var label = "";
    if (productType === "HIGHINTERESTACCOUNT") {
      label = campaignId === "yahoyrentekonotpluss" ? "Høyrentekonto Pluss" : "Høyrentekonto";
    } else {
      label = "Brukskonto";
    }
    var isStep1 = !state.apiStatus.application;
    var isStep2 = !!state.apiStatus.application;
    if (isStep1) {
      gtmEventService().account().pushStepOne(label);
    } else if (isStep2) {
      gtmEventService().account().pushStepTwo(label, state.apiStatus.application.applicationState, state.apiStatus.message);
    }
  }, [state.apiStatus, campaignId, productType]);
  useEffect(function () {
    if (shouldNavigate && typeof signingUrl === "string") {
      window.location.href = signingUrl;
    }
  }, [shouldNavigate, signingUrl]);
  var onValueUpdate = function onValueUpdate(event, id) {
    event.preventDefault();
    var value = event.target.value;

    // convert true/false string to a boolean value
    if (value === "true" || value === "false") {
      value = value === "true";
    }
    var result = validateValue(id, value, state);
    setState(function (prevState) {
      var _objectSpread2;
      var append = _objectSpread2$4(_objectSpread2$4({}, prevState), {}, (_objectSpread2 = {}, _defineProperty$5(_objectSpread2, id, value), _defineProperty$5(_objectSpread2, result.errorFieldName || "".concat(id, "Error"), result.errMsg || ""), _objectSpread2));

      // Always check if atleast 1 option of the checkboxes are selected
      if (["saveForDwelling", "saveForFamily", "personalUse"].includes(id)) {
        var saveFor = [state.saveForDwelling, state.saveForFamily, state.personalUse].includes(true);
        append.saveForError = value === true || saveFor ? "" : "Velg minst et alternativ";
      }
      if (["income", "inheritance", "gift", "realestate", "savings", "willOthersDeposit"].includes(id)) {
        var mainIncome = [state.income, state.inheritance, state.gift, state.realestate, state.savings, state.willOthersDeposit].includes(true);
        append.mainIncomeError = value === true || mainIncome ? "" : "Velg minst et alternativ";
      }
      return append;
    });
  };
  var validateField = function validateField(id) {
    var value = state[id];
    var result = validateValue(id, value, state);
    setState(function (prevState) {
      return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, _defineProperty$5({}, result.errorFieldName || "".concat(id, "Error"), result.errMsg || ""));
    });
    return result.ok;
  };

  // Hva skal du bruke innskuddskontoen til? - REQUIRES ATLEAST 1 CHECKED
  var validateCheckboxesFirst = function validateCheckboxesFirst() {
    var hasTrueValue = [state.saveForDwelling, state.saveForFamily, state.personalUse].includes(true);
    setState(function (prevState) {
      return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, _defineProperty$5({}, "saveForError", hasTrueValue ? "" : "Velg minst et alternativ"));
    });
    return hasTrueValue;
  };

  // Hva skal du bruke innskuddskontoen til? - REQUIRES ATLEAST 1 CHECKED
  var validateCheckboxesSecond = function validateCheckboxesSecond() {
    var hasTrueValue = [state.income, state.inheritance, state.gift, state.realestate, state.savings, state.willOthersDeposit].includes(true);
    setState(function (prevState) {
      return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, _defineProperty$5({}, "mainIncomeError", hasTrueValue ? "" : "Velg minst et alternativ"));
    });
    return hasTrueValue;
  };
  var onNextStep = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var isOK, name, ssn, email, emailRepeat, mobilNo, isPoliticallyExposedPerson, willTransferToOtherCountries, transfersToOtherCountries, isAmericanCitizen, noTinNumberCheckbox, tinNumber, isTaxwiseResidentOfForeignCountry, saveForDwelling, saveForFamily, personalUse, income, inheritance, gift, realestate, savings, willOthersDeposit, validateCheckboxesFirstVal, validateCheckboxesSecondVal, depositsOtherAverage, comment, accept, formValues, result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Validate fields
              isOK = true;
              name = validateField("name");
              ssn = validateField("ssn");
              email = validateField("email");
              emailRepeat = validateField("emailRepeat");
              mobilNo = validateField("mobilNo");
              isPoliticallyExposedPerson = validateField("isPoliticallyExposedPerson");
              willTransferToOtherCountries = validateField("willTransferToOtherCountries");
              if (!name || !ssn || !email || !emailRepeat || !mobilNo || !isPoliticallyExposedPerson || !willTransferToOtherCountries) {
                isOK = false;
              }
              if (state.willTransferToOtherCountries === true) {
                transfersToOtherCountries = validateField("transfersToOtherCountries");
                if (!transfersToOtherCountries) {
                  isOK = false;
                }
              }
              isAmericanCitizen = validateField("isAmericanCitizen");
              if (state.isAmericanCitizen === true) {
                noTinNumberCheckbox = validateField("noTinNumberCheckbox");
                if (!noTinNumberCheckbox) {
                  isOK = false;
                }
                if (state.noTinNumberCheckbox === false) {
                  tinNumber = validateField("tinNumber");
                  if (!tinNumber) {
                    isOK = false;
                  }
                }
              }
              isTaxwiseResidentOfForeignCountry = validateField("isTaxwiseResidentOfForeignCountry");
              if (state.isTaxwiseResidentOfForeignCountry === true) {
                Array.from({
                  length: state.taxCountriesAmount
                }, function (_, i) {
                  return i + 1;
                }).forEach(function (i) {
                  var taxCountry = validateField("taxCountry".concat(i));
                  if (!taxCountry) {
                    isOK = false;
                  }
                  var noIdNumberCheckbox = validateField("noIdNumberCheckbox".concat(i));
                  if (!noIdNumberCheckbox) {
                    isOK = false;
                  }
                  if (state["noIdNumberCheckbox".concat(i)] === true) {
                    var noIdReasonText = validateField("noIdReasonText".concat(i));
                    if (!noIdReasonText) {
                      isOK = false;
                    }
                  } else {
                    var idNumber1 = validateField("idNumber".concat(i));
                    if (!idNumber1) {
                      isOK = false;
                    }
                  }
                });
              }
              if (!isAmericanCitizen || !isTaxwiseResidentOfForeignCountry) {
                isOK = false;
              }
              saveForDwelling = validateField("saveForDwelling");
              saveForFamily = validateField("saveForFamily");
              personalUse = validateField("personalUse");
              income = validateField("income");
              inheritance = validateField("inheritance");
              gift = validateField("gift");
              realestate = validateField("realestate");
              savings = validateField("savings");
              willOthersDeposit = validateField("willOthersDeposit");
              validateCheckboxesFirstVal = validateCheckboxesFirst();
              validateCheckboxesSecondVal = validateCheckboxesSecond();
              if (!validateCheckboxesFirstVal || !validateCheckboxesSecondVal) {
                isOK = false;
              }
              if (state.willOthersDeposit === true) {
                depositsOtherAverage = validateField("depositsOtherAverage");
                if (!depositsOtherAverage) {
                  isOK = false;
                }
              }
              comment = validateField("comment");
              accept = validateField("accept");
              if (!saveForDwelling || !saveForFamily || !personalUse || !income || !inheritance || !gift || !realestate || !savings || !willOthersDeposit || !comment || !accept) {
                isOK = false;
              }
              if (isOK) {
                _context.next = 33;
                break;
              }
              return _context.abrupt("return");
            case 33:
              setState(function (prevState) {
                return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
                  button1Error: "",
                  apiStatus: {
                    loading: true
                  }
                });
              });
              formValues = {
                comment: state.comment,
                email: state.email,
                gift: state.gift,
                income: state.income,
                inheritance: state.inheritance,
                // ipAdress:
                isAmericanCitizen: state.isAmericanCitizen,
                isPoliticallyExposedPerson: state.isPoliticallyExposedPerson,
                isTaxwiseResidentOfForeignCountry: state.isTaxwiseResidentOfForeignCountry,
                mobilNo: state.mobilNo,
                name: state.name,
                personalUse: state.personalUse,
                productType: state.productType,
                realestate: state.realestate,
                saveForDwelling: state.saveForDwelling,
                saveForFamily: state.saveForFamily,
                savings: state.savings,
                schema: state.schema,
                ssn: state.ssn,
                willOthersDeposit: state.willOthersDeposit,
                willTransferToOtherCountries: state.willTransferToOtherCountries
              };
              UTM_PARAM_KEYS.forEach(function (paramKey) {
                // eslint-disable-next-line react/destructuring-assignment
                var utmValue = props[paramKey];
                if (utmValue) {
                  formValues[paramKey] = utmValue;
                }
              });
              if (state.willOthersDeposit === true) {
                formValues.depositsOtherAverage = state.depositsOtherAverage;
              }
              if (state.isAmericanCitizen === true) {
                formValues.tinNumber = state.tinNumber;
                if (state.noTinNumberCheckbox === true) {
                  formValues.noTinReason = state.noTinReason;
                }
              }
              if (state.willTransferToOtherCountries === true) {
                formValues.transfersToOtherCountries = state.transfersToOtherCountries;
              }
              if (state.isTaxwiseResidentOfForeignCountry === true) {
                Array.from({
                  length: state.taxCountriesAmount
                }, function (_, i) {
                  return i + 1;
                }).forEach(function (i) {
                  formValues["taxCountry".concat(i)] = state["taxCountry".concat(i)];
                  if (state["noIdNumberCheckbox".concat(i)] === true) {
                    formValues["noIdReasonText".concat(i)] = state["noIdReasonText".concat(i)];
                  } else {
                    formValues["idNumber".concat(i)] = state["idNumber".concat(i)];
                  }
                });
              }

              // Send formdata with validated values
              _context.next = 42;
              return submitAccount(formValues, baseApiUrl);
            case 42:
              result = _context.sent;
              setState(function (prevState) {
                return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
                  button1Error: result.ok ? "" : result.message,
                  isDeadEndError: result.isDeadEndError,
                  apiStatus: _objectSpread2$4({
                    loading: false
                  }, result)
                });
              });
            case 44:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function onNextStep() {
      return _ref.apply(this, arguments);
    };
  }();
  var onCollapse = function onCollapse(collapseState, id) {
    setState(function (prevState) {
      return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
        collapseStates: _objectSpread2$4(_objectSpread2$4({}, state.collapseStates), {}, _defineProperty$5({}, id, collapseState))
      });
    });
  };
  var body;
  if (state.isDeadEndError) {
    body = /*#__PURE__*/React__default.createElement(DeadEndView, {
      productType: state.productType,
      code: state.apiStatus.code,
      message: state.apiStatus.message
    });
  } else {
    body = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StepOne, {
      onValueUpdate: onValueUpdate,
      onNextStep: onNextStep,
      onCollapse: onCollapse,
      state: state,
      setState: setState
    }), (state.apiStatus.loading || shouldNavigate) && /*#__PURE__*/React__default.createElement(LoadingOverlay, null));
  }
  return /*#__PURE__*/React__default.createElement(SystemStatus, {
    cmsHelperUrl: baseApiUrl
  }, /*#__PURE__*/React__default.createElement(Container$8, null, body));
}
Konto.propTypes = {
  prefilled: PropTypes.bool,
  campaignId: PropTypes.string,
  /* eslint-disable react/no-unused-prop-types */
  // These are looped through with the help of UTM_PARAM_KEYS
  gclid: PropTypes.string,
  utm_campaign: PropTypes.string,
  utm_content: PropTypes.string,
  utm_medium: PropTypes.string,
  utm_source: PropTypes.string,
  utm_term: PropTypes.string,
  /* eslint-enable react/no-unused-prop-types */
  baseApiUrl: PropTypes.string.isRequired,
  productType: PropTypes.oneOf(["ACCOUNT", "HIGHINTERESTACCOUNT"]).isRequired
};
Konto.defaultProps = {
  prefilled: false,
  campaignId: "",
  gclid: "",
  utm_campaign: "",
  utm_content: "",
  utm_medium: "",
  utm_source: "",
  utm_term: ""
};

var kontoFactory = function kontoFactory(productType) {
  return function (props) {
    return /*#__PURE__*/React__default.createElement(Konto, _extends$2({}, props, {
      productType: productType
    }));
  };
};
var Brukskonto$1 = kontoFactory("ACCOUNT");
var Hoyrentekonto$1 = kontoFactory("HIGHINTERESTACCOUNT");

function CardPersonalia(_ref) {
  var state = _ref.state,
    onValueUpdate = _ref.onValueUpdate,
    showEmailRepeat = _ref.showEmailRepeat,
    isSubsidiary = _ref.isSubsidiary,
    brandStyle = _ref.brandStyle;
  var getId = function getId(id) {
    return isSubsidiary ? "".concat(id, "Subsidiary") : id;
  };
  var getErrorId = function getErrorId(id) {
    return "".concat(getId(id), "Error");
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: getId("name"),
    type: "text",
    title: "Fullt navn",
    placeholder: "Fornavn, mellom- og etternavn",
    onblur: onValueUpdate,
    value: state[getId("name")],
    showError: state[getErrorId("name")],
    brandStyle: brandStyle
  })), /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: getId("ssn"),
    type: "text",
    title: "F\xF8dselsnummer",
    placeholder: "11 siffer",
    onblur: onValueUpdate,
    value: state[getId("ssn")],
    showError: state[getErrorId("ssn")],
    brandStyle: brandStyle
  }))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: getId("email"),
    type: "email",
    title: "E-post",
    onblur: onValueUpdate,
    value: state[getId("email")],
    showError: state[getErrorId("email")],
    brandStyle: brandStyle
  })), showEmailRepeat && /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: getId("emailRepeat"),
    type: "email",
    title: "Gjenta e-post",
    onblur: onValueUpdate,
    value: state[getId("emailRepeat")],
    showError: state[getErrorId("emailRepeat")],
    brandStyle: brandStyle
  }))), /*#__PURE__*/React__default.createElement(Paragraph$1, {
    brandStyle: brandStyle
  }, "Vi sender kundeavtalen per e-post. Det er derfor viktig at du har oppgitt korrekt e-postadresse."), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: getId("mobilNo"),
    type: "tel",
    title: "Mobiltelefonnummer",
    onblur: onValueUpdate,
    value: state[getId("mobilNo")],
    showError: state[getErrorId("mobilNo")],
    brandStyle: brandStyle
  }))));
}
CardPersonalia.propTypes = {
  state: PropTypes.shape({
    name: PropTypes.string,
    nameError: PropTypes.string,
    ssn: PropTypes.string,
    ssnError: PropTypes.string,
    email: PropTypes.string,
    emailError: PropTypes.string,
    mobilNo: PropTypes.string,
    mobilNoError: PropTypes.string
  }).isRequired,
  onValueUpdate: PropTypes.func.isRequired,
  showEmailRepeat: PropTypes.bool,
  isSubsidiary: PropTypes.bool,
  brandStyle: PropTypes.string
};
CardPersonalia.defaultProps = {
  showEmailRepeat: true,
  isSubsidiary: false,
  brandStyle: "ya"
};

function CardStepOne(props) {
  var onValueUpdate = props.onValueUpdate,
    onNextStep = props.onNextStep,
    state = props.state,
    showEmailRepeat = props.showEmailRepeat,
    brandStyle = props.brandStyle;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Legend, {
    brandStyle: brandStyle
  }, "Personalia"), /*#__PURE__*/React__default.createElement(CardPersonalia, {
    state: state,
    onValueUpdate: onValueUpdate,
    showEmailRepeat: showEmailRepeat,
    brandStyle: brandStyle
  }), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Button, {
    label: "G\xE5 til neste steg",
    onclick: onNextStep,
    showError: state.button1Error,
    disabled: !!state.apiStatus.loading,
    brandStyle: brandStyle
  })));
}
CardStepOne.propTypes = {
  onValueUpdate: PropTypes.func.isRequired,
  onNextStep: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  state: PropTypes.object.isRequired,
  showEmailRepeat: PropTypes.bool,
  brandStyle: PropTypes.oneOf(["ya", "yx"])
};
CardStepOne.defaultProps = {
  showEmailRepeat: true,
  brandStyle: "ya"
};

function MorePersonalia(_ref) {
  var state = _ref.state,
    onValueUpdate = _ref.onValueUpdate,
    showExtendedDetails = _ref.showExtendedDetails,
    isSubsidiary = _ref.isSubsidiary,
    brandStyle = _ref.brandStyle;
  var getId = function getId(id) {
    return isSubsidiary ? "".concat(id, "Subsidiary") : id;
  };
  var getErrorId = function getErrorId(id) {
    return "".concat(getId(id), "Error");
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Dropdown, {
    id: getId("civilStatus"),
    label: "Sivilstand",
    options: [{
      value: "Velg",
      label: "Velg"
    }, {
      value: "MARRIED_OR_PARTNER",
      label: "Gift/partner"
    }, {
      value: "COHABITANT",
      label: "Samboer"
    }, {
      value: "SEPARATED",
      label: "Separert"
    }, {
      value: "SINGLE",
      label: "Singel"
    }, {
      value: "WIDOW_OR_WIDOWER",
      label: "Enke- /mann"
    }],
    selected: state[getId("civilStatus")],
    onchange: onValueUpdate,
    showError: state[getErrorId("civilStatusError")],
    brandStyle: brandStyle
  })), /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Dropdown, {
    id: getId("habitat"),
    label: "Boforhold",
    options: [{
      value: "Velg",
      label: "Velg"
    }, {
      value: "RENTED",
      label: "Leier bolig"
    }, {
      value: "OWNED",
      label: "Eier bolig"
    }],
    selected: state[getId("habitat")],
    onchange: onValueUpdate,
    showError: state[getErrorId("habitat")],
    brandStyle: brandStyle
  }))), /*#__PURE__*/React__default.createElement(Row$2, null, !isSubsidiary && /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Dropdown, {
    id: getId("noOfChildren"),
    label: "Antall barn under 18 \xE5r",
    options: [{
      value: "Velg",
      label: "Velg"
    }, {
      value: 0,
      label: 0
    }, {
      value: 1,
      label: 1
    }, {
      value: 2,
      label: 2
    }, {
      value: 3,
      label: 3
    }, {
      value: 4,
      label: 4
    }, {
      value: 5,
      label: 5
    }, {
      value: 6,
      label: 6
    }, {
      value: 7,
      label: 7
    }, {
      value: 8,
      label: 8
    }, {
      value: 9,
      label: 9
    }, {
      value: 10,
      label: 10
    }],
    selected: state[getId("noOfChildren")],
    onchange: onValueUpdate,
    showError: state[getErrorId("noOfChildren")],
    brandStyle: brandStyle
  })), showExtendedDetails && /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Radio, {
    id: getId("isNorwegianCitizen"),
    label: "Er du norsk statsborger?",
    options: [{
      value: true,
      label: "Ja",
      checked: state[getId("isNorwegianCitizen")] === true
    }, {
      value: false,
      label: "Nei",
      checked: state[getId("isNorwegianCitizen")] === false
    }],
    onchange: onValueUpdate,
    showError: state[getErrorId("isNorwegianCitizen")],
    brandStyle: brandStyle
  }))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Dropdown, {
    id: getId("education"),
    label: "Utdannelse",
    options: [{
      value: "Velg",
      label: "Velg"
    }, {
      value: "PRIMARY_SCHOOL",
      label: "Grunnskole"
    }, {
      value: "SECONDARY_SCHOOL",
      label: "Videregående"
    }, {
      value: "UNIVERSITY_SHORT",
      label: "Høyskole/Universitet 1-3 år"
    }, {
      value: "UNIVERSITY_LONG",
      label: "Høyskole/Universitet 4+ år"
    }],
    selected: state[getId("education")],
    onchange: onValueUpdate,
    showError: state[getErrorId("education")],
    brandStyle: brandStyle
  })), /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Dropdown, {
    id: getId("employmentSituation"),
    label: "Arbeidsforhold",
    options: [{
      value: "Velg",
      label: "Velg"
    }, {
      value: "PERMANENT_EMPLOYMENT",
      label: "Fast ansatt"
    }, {
      value: "DEPUTY",
      label: "Vikar"
    }, {
      value: "SELF_EMPLOYED",
      label: "Selvst. Næringsdrivende"
    }, {
      value: "STUDENT",
      label: "Student"
    }, {
      value: "RETIRED",
      label: "Pensjonist"
    }, {
      value: "UNEMPLOYED",
      label: "Arbeidsledig"
    }, {
      value: "REHABILITATION",
      label: "Attføring"
    }, {
      value: "INCAPABLE",
      label: "Trygdet"
    }, {
      value: "OTHER",
      label: "Annet"
    }],
    selected: state[getId("employmentSituation")],
    onchange: onValueUpdate,
    showError: state[getErrorId("employmentSituation")],
    brandStyle: brandStyle
  }))), showExtendedDetails && ["PERMANENT_EMPLOYMENT", "DEPUTY", "SELF_EMPLOYED"].includes(state[getId("employmentSituation")]) && /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: getId("employer"),
    type: "text",
    title: "Arbeidsgiver",
    onblur: onValueUpdate,
    value: state[getId("employer")],
    showError: state[getErrorId("employer")],
    brandStyle: brandStyle
  })), /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: getId("employedSince"),
    type: "text",
    title: "Ansatt antall \xE5r",
    onblur: onValueUpdate,
    value: state[getId("employedSince")],
    showError: state[getErrorId("employedSince")],
    brandStyle: brandStyle
  }))), showExtendedDetails && ["INCAPABLE"].includes(state[getId("employmentSituation")]) && /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: getId("employedSince"),
    type: "text",
    title: "Trygdet antall \xE5r",
    onblur: onValueUpdate,
    value: state[getId("employedSince")],
    showError: state[getErrorId("employedSince")],
    brandStyle: brandStyle
  }))));
}
MorePersonalia.propTypes = {
  onValueUpdate: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  state: PropTypes.object.isRequired,
  showExtendedDetails: PropTypes.bool,
  isSubsidiary: PropTypes.bool,
  brandStyle: PropTypes.oneOf(["ya", "yx"])
};
MorePersonalia.defaultProps = {
  showExtendedDetails: false,
  isSubsidiary: false,
  brandStyle: "ya"
};

var xSvg = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20width%3D%2219px%22%20height%3D%2220px%22%20viewBox%3D%220%200%2019%2020%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3Ecross%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22cross%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-linecap%3D%22round%22%3E%20%20%20%20%20%20%20%20%3Cline%20x1%3D%221.425%22%20y1%3D%2218.55%22%20x2%3D%2217.575%22%20y2%3D%221.45%22%20id%3D%22Line%22%20stroke%3D%22%23000000%22%20stroke-width%3D%223%22%20fill-rule%3D%22nonzero%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%3Cline%20x1%3D%221.425%22%20y1%3D%2218.55%22%20x2%3D%2217.575%22%20y2%3D%221.45%22%20id%3D%22Line%22%20stroke%3D%22%23000000%22%20stroke-width%3D%223%22%20fill-rule%3D%22nonzero%22%20transform%3D%22translate%289.500000%2C%2010.000000%29%20scale%28-1%2C%201%29%20translate%28-9.500000%2C%20-10.000000%29%20%22%3E%3C%2Fline%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

function _EMOTION_STRINGIFIED_CSS_ERROR__$D() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var RemovableLoanInputsContainer = createStyled("div", "development" === "production" ? {
  target: "e14wyla31"
} : {
  target: "e14wyla31",
  label: "RemovableLoanInputsContainer"
})(function (props) {
  return props.useBorder ? "\n        border-top: 1px solid ".concat(colors$1.borderGrey, ";\n        margin-top: 1rem;\n    ") : "";
}, " display:grid;&>label:nth-of-type(1){grid-area:labelLoanAmount;}&>div:nth-of-type(1){grid-area:inputLoanAmount;}&>label:nth-of-type(2){grid-area:labelMonthlyPayment;}&>div:nth-of-type(2){grid-area:inputMonthlyPayment;}&>img{grid-area:removeLoanButton;margin:auto;}column-gap:0.5em;grid-template-columns:4fr 4fr 1fr;grid-template-areas:\"labelLoanAmount labelMonthlyPayment .\" \"inputLoanAmount inputMonthlyPayment removeLoanButton\";@media (max-width: 768px){grid-template-areas:\"labelLoanAmount labelLoanAmount .\" \"inputLoanAmount inputLoanAmount .\" \"labelMonthlyPayment labelMonthlyPayment .\" \"inputMonthlyPayment inputMonthlyPayment removeLoanButton\";}" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var RemoveLoanIcon = createStyled("img", "development" === "production" ? {
  target: "e14wyla30"
} : {
  target: "e14wyla30",
  label: "RemoveLoanIcon"
})("development" === "production" ? {
  name: "m2e1pz",
  styles: "display:inline-block;overflow:hidden;vertical-align:middle;width:20px;height:20px;right:0px;bottom:15px;cursor:pointer;@media (max-width: 768px){top:5px;width:15px;height:15px;}"
} : {
  name: "m2e1pz",
  styles: "display:inline-block;overflow:hidden;vertical-align:middle;width:20px;height:20px;right:0px;bottom:15px;cursor:pointer;@media (max-width: 768px){top:5px;width:15px;height:15px;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk11bHRpcGxlTG9hbi5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0RpQyIsImZpbGUiOiJNdWx0aXBsZUxvYW4uanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCI7XG5cbmltcG9ydCB4U3ZnIGZyb20gXCIuLi8uLi8uLi9hc3NldHMvc3Zncy94LnN2Z1wiO1xuaW1wb3J0IGNvbG9ycyBmcm9tIFwiLi4vLi4vY29sb3JzXCI7XG5pbXBvcnQgeyBCdXR0b24sIENvbGxhcHNlLCBJbnB1dCwgUmFkaW8sIFJvdywgU3BhbiB9IGZyb20gXCIuLi91aVwiO1xuXG5jb25zdCBSZW1vdmFibGVMb2FuSW5wdXRzQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgJHsocHJvcHMpID0+XG4gICAgcHJvcHMudXNlQm9yZGVyXG4gICAgICA/IGBcbiAgICAgICAgYm9yZGVyLXRvcDogMXB4IHNvbGlkICR7Y29sb3JzLmJvcmRlckdyZXl9O1xuICAgICAgICBtYXJnaW4tdG9wOiAxcmVtO1xuICAgIGBcbiAgICAgIDogXCJcIn1cblxuICBkaXNwbGF5OiBncmlkO1xuICAmID4gbGFiZWw6bnRoLW9mLXR5cGUoMSkge1xuICAgIGdyaWQtYXJlYTogbGFiZWxMb2FuQW1vdW50O1xuICB9XG4gICYgPiBkaXY6bnRoLW9mLXR5cGUoMSkge1xuICAgIGdyaWQtYXJlYTogaW5wdXRMb2FuQW1vdW50O1xuICB9XG4gICYgPiBsYWJlbDpudGgtb2YtdHlwZSgyKSB7XG4gICAgZ3JpZC1hcmVhOiBsYWJlbE1vbnRobHlQYXltZW50O1xuICB9XG4gICYgPiBkaXY6bnRoLW9mLXR5cGUoMikge1xuICAgIGdyaWQtYXJlYTogaW5wdXRNb250aGx5UGF5bWVudDtcbiAgfVxuICAmID4gaW1nIHtcbiAgICBncmlkLWFyZWE6IHJlbW92ZUxvYW5CdXR0b247XG4gICAgbWFyZ2luOiBhdXRvO1xuICB9XG4gIGNvbHVtbi1nYXA6IDAuNWVtO1xuICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IDRmciA0ZnIgMWZyO1xuXG4gIGdyaWQtdGVtcGxhdGUtYXJlYXM6XG4gICAgXCJsYWJlbExvYW5BbW91bnQgbGFiZWxNb250aGx5UGF5bWVudCAuXCJcbiAgICBcImlucHV0TG9hbkFtb3VudCBpbnB1dE1vbnRobHlQYXltZW50IHJlbW92ZUxvYW5CdXR0b25cIjtcblxuICBAbWVkaWEgKG1heC13aWR0aDogNzY4cHgpIHtcbiAgICBncmlkLXRlbXBsYXRlLWFyZWFzOlxuICAgICAgXCJsYWJlbExvYW5BbW91bnQgbGFiZWxMb2FuQW1vdW50IC5cIlxuICAgICAgXCJpbnB1dExvYW5BbW91bnQgaW5wdXRMb2FuQW1vdW50IC5cIlxuICAgICAgXCJsYWJlbE1vbnRobHlQYXltZW50IGxhYmVsTW9udGhseVBheW1lbnQgLlwiXG4gICAgICBcImlucHV0TW9udGhseVBheW1lbnQgaW5wdXRNb250aGx5UGF5bWVudCByZW1vdmVMb2FuQnV0dG9uXCI7XG4gIH1cbmA7XG5cbmNvbnN0IFJlbW92ZUxvYW5JY29uID0gc3R5bGVkLmltZ2BcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICBvdmVyZmxvdzogaGlkZGVuO1xuICB2ZXJ0aWNhbC1hbGlnbjogbWlkZGxlO1xuICB3aWR0aDogMjBweDtcbiAgaGVpZ2h0OiAyMHB4O1xuICByaWdodDogMHB4O1xuICBib3R0b206IDE1cHg7XG4gIGN1cnNvcjogcG9pbnRlcjtcblxuICBAbWVkaWEgKG1heC13aWR0aDogNzY4cHgpIHtcbiAgICB0b3A6IDVweDtcbiAgICB3aWR0aDogMTVweDtcbiAgICBoZWlnaHQ6IDE1cHg7XG4gIH1cbmA7XG5cbmNvbnN0IGxvYW5MYWJlbHMgPSB7XG4gIGNhckxvYW46IFwiSGFyIGR1IGJpbGzDpW4/XCIsXG4gIGNhckxvYW5TdWJzaWRpYXJ5OiBcIkhhciBtZWRzw7hrZXIgYmlsbMOlbj9cIixcbiAgaG91c2VMb2FuOiBcIkhhciBkdSBsw6VuIHDDpSBib2xpZyBlbGxlciBhbm5lbiBlaWVuZG9tP1wiLFxuICBob3VzZUxvYW5TdWJzaWRpYXJ5OiBcIkhhciBtZWRzw7hrZXIgbMOlbiBww6UgYm9saWcgZWxsZXIgYW5uZW4gZWllbmRvbT9cIixcbn07XG5jb25zdCBhZGRCdXR0b25MYWJlbHMgPSB7XG4gIGNhckxvYW46IFwiTGVnZyB0aWwgZmxlcmUgYmlsbMOlblwiLFxuICBob3VzZUxvYW46IFwiTGVnZyB0aWwgZmxlcmUgYm9saWdsw6VuXCIsXG59O1xuXG5mdW5jdGlvbiBNdWx0aXBsZUxvYW4oeyBvblZhbHVlVXBkYXRlLCBvbkNvbGxhcHNlLCBzdGF0ZSwgc2V0U3RhdGUsIGxvYW5JZCwgYnJhbmRTdHlsZSB9KSB7XG4gIGNvbnN0IGFtb3VudElkID0gYCR7bG9hbklkfUlucHV0RmllbGRMb2FuQW1vdW50YDtcbiAgY29uc3QgcGF5bWVudElkID0gYCR7bG9hbklkfUlucHV0RmllbGRNb250aGx5UGF5bWVudGA7XG5cbiAgY29uc3QgYWRkUmVtb3ZlQ2xpY2tIYW5kbGVyID0gKGluZGV4KSA9PiB7XG4gICAgY29uc3QgYW1vdW50ID0gc3RhdGVbYW1vdW50SWRdO1xuICAgIGNvbnN0IHBheW1lbnQgPSBzdGF0ZVtwYXltZW50SWRdO1xuXG4gICAgaWYgKHR5cGVvZiBpbmRleCA9PT0gXCJudW1iZXJcIikge1xuICAgICAgYW1vdW50LnNwbGljZShpbmRleCwgMSk7XG4gICAgICBwYXltZW50LnNwbGljZShpbmRleCwgMSk7XG4gICAgfSBlbHNlIHtcbiAgICAgIGFtb3VudC5wdXNoKFwiXCIpO1xuICAgICAgcGF5bWVudC5wdXNoKFwiXCIpO1xuICAgIH1cblxuICAgIHNldFN0YXRlKChwcmV2U3RhdGUpID0+ICh7XG4gICAgICAuLi5wcmV2U3RhdGUsXG4gICAgICBbYW1vdW50SWRdOiBhbW91bnQsXG4gICAgICBbcGF5bWVudElkXTogcGF5bWVudCxcbiAgICB9KSk7XG4gIH07XG5cbiAgcmV0dXJuIChcbiAgICA8PlxuICAgICAgPFJvdz5cbiAgICAgICAgPFNwYW4+XG4gICAgICAgICAgPFJhZGlvXG4gICAgICAgICAgICBpZD17bG9hbklkfVxuICAgICAgICAgICAgbGFiZWw9e2xvYW5MYWJlbHNbbG9hbklkXX1cbiAgICAgICAgICAgIG9wdGlvbnM9e1tcbiAgICAgICAgICAgICAgeyB2YWx1ZTogXCJvblwiLCBsYWJlbDogXCJKYVwiLCBjaGVja2VkOiBzdGF0ZVtsb2FuSWRdID09PSBcIm9uXCIgfSxcbiAgICAgICAgICAgICAgeyB2YWx1ZTogXCJvZmZcIiwgbGFiZWw6IFwiTmVpXCIsIGNoZWNrZWQ6IHN0YXRlW2xvYW5JZF0gPT09IFwib2ZmXCIgfSxcbiAgICAgICAgICAgIF19XG4gICAgICAgICAgICBvbmNoYW5nZT17b25WYWx1ZVVwZGF0ZX1cbiAgICAgICAgICAgIHNob3dFcnJvcj17c3RhdGVbYCR7bG9hbklkfUVycm9yYF19XG4gICAgICAgICAgICBicmFuZFN0eWxlPXticmFuZFN0eWxlfVxuICAgICAgICAgIC8+XG4gICAgICAgIDwvU3Bhbj5cbiAgICAgIDwvUm93PlxuICAgICAgPENvbGxhcHNlXG4gICAgICAgIGlzT3Blbj17c3RhdGVbbG9hbklkXSA9PT0gXCJvblwifVxuICAgICAgICBhcHBlYXI9e3N0YXRlLmNvbGxhcHNlU3RhdGVzPy5bbG9hbklkXSAhPT0gXCJFTlRFUkVEXCJ9XG4gICAgICAgIG9uRW50ZXJlZD17KCkgPT4gb25Db2xsYXBzZShcIkVOVEVSRURcIiwgbG9hbklkKX1cbiAgICAgICAgb25FeGl0ZWQ9eygpID0+IG9uQ29sbGFwc2UoXCJDTE9TRURcIiwgbG9hbklkKX1cbiAgICAgID5cbiAgICAgICAge1suLi5BcnJheShzdGF0ZVthbW91bnRJZF0ubGVuZ3RoKV0ubWFwKCh4LCBpKSA9PiAoXG4gICAgICAgICAgPFJlbW92YWJsZUxvYW5JbnB1dHNDb250YWluZXJcbiAgICAgICAgICAgIC8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSByZWFjdC9uby1hcnJheS1pbmRleC1rZXlcbiAgICAgICAgICAgIGtleT17YCR7bG9hbklkfS1rZXktJHtpfS0ke3N0YXRlW2Ftb3VudElkXS5sZW5ndGh9YH1cbiAgICAgICAgICAgIHVzZUJvcmRlcj17aSA+IDB9XG4gICAgICAgICAgPlxuICAgICAgICAgICAgPElucHV0XG4gICAgICAgICAgICAgIGlkPXtgJHthbW91bnRJZH0tJHtpfWB9XG4gICAgICAgICAgICAgIHR5cGU9XCJ0ZWxcIlxuICAgICAgICAgICAgICB0aXRsZT1cIkRpbiBhbmRlbCBhdiBzYWxkbyBww6UgbMOlbmV0XCJcbiAgICAgICAgICAgICAgdmFsdWU9e3N0YXRlW2Ftb3VudElkXT8uW2ldfVxuICAgICAgICAgICAgICBvbmJsdXI9e29uVmFsdWVVcGRhdGV9XG4gICAgICAgICAgICAgIGlzQ3VycmVuY3lcbiAgICAgICAgICAgICAgc2hvd0Vycm9yPXtzdGF0ZVtgJHthbW91bnRJZH1FcnJvciR7aX1gXX1cbiAgICAgICAgICAgICAgYnJhbmRTdHlsZT17YnJhbmRTdHlsZX1cbiAgICAgICAgICAgIC8+XG5cbiAgICAgICAgICAgIDxJbnB1dFxuICAgICAgICAgICAgICBpZD17YCR7cGF5bWVudElkfS0ke2l9YH1cbiAgICAgICAgICAgICAgdHlwZT1cInRlbFwiXG4gICAgICAgICAgICAgIHRpdGxlPVwiTcOlbmVkc2JlbMO4cFwiXG4gICAgICAgICAgICAgIHZhbHVlPXtzdGF0ZVtwYXltZW50SWRdPy5baV19XG4gICAgICAgICAgICAgIG9uYmx1cj17b25WYWx1ZVVwZGF0ZX1cbiAgICAgICAgICAgICAgaXNDdXJyZW5jeVxuICAgICAgICAgICAgICBzaG93RXJyb3I9e3N0YXRlW2Ake3BheW1lbnRJZH1FcnJvciR7aX1gXX1cbiAgICAgICAgICAgICAgYnJhbmRTdHlsZT17YnJhbmRTdHlsZX1cbiAgICAgICAgICAgIC8+XG4gICAgICAgICAgICB7aSA+IDAgJiYgKFxuICAgICAgICAgICAgICA8UmVtb3ZlTG9hbkljb25cbiAgICAgICAgICAgICAgICBzcmM9e3hTdmd9XG4gICAgICAgICAgICAgICAgYWx0PVwicmVtb3ZlIGxvYW5cIlxuICAgICAgICAgICAgICAgIG9uQ2xpY2s9eygpID0+IGFkZFJlbW92ZUNsaWNrSGFuZGxlcihpKX1cbiAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgICl9XG4gICAgICAgICAgPC9SZW1vdmFibGVMb2FuSW5wdXRzQ29udGFpbmVyPlxuICAgICAgICApKX1cbiAgICAgICAgPFJvdz5cbiAgICAgICAgICA8QnV0dG9uXG4gICAgICAgICAgICBpZD17YCR7bG9hbklkfUFkZFJvd0lkYH1cbiAgICAgICAgICAgIGxhYmVsPXthZGRCdXR0b25MYWJlbHNbbG9hbklkLnJlcGxhY2UoXCJTdWJzaWRpYXJ5XCIsIFwiXCIpXX1cbiAgICAgICAgICAgIG9uY2xpY2s9eygpID0+IGFkZFJlbW92ZUNsaWNrSGFuZGxlcigpfVxuICAgICAgICAgICAgYnJhbmRTdHlsZT17YnJhbmRTdHlsZX1cbiAgICAgICAgICAvPlxuICAgICAgICA8L1Jvdz5cbiAgICAgIDwvQ29sbGFwc2U+XG4gICAgPC8+XG4gICk7XG59XG5cbk11bHRpcGxlTG9hbi5wcm9wVHlwZXMgPSB7XG4gIG9uVmFsdWVVcGRhdGU6IFByb3BUeXBlcy5mdW5jLmlzUmVxdWlyZWQsXG4gIG9uQ29sbGFwc2U6IFByb3BUeXBlcy5mdW5jLmlzUmVxdWlyZWQsXG4gIC8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSByZWFjdC9mb3JiaWQtcHJvcC10eXBlc1xuICBzdGF0ZTogUHJvcFR5cGVzLm9iamVjdC5pc1JlcXVpcmVkLFxuICBzZXRTdGF0ZTogUHJvcFR5cGVzLmZ1bmMuaXNSZXF1aXJlZCxcbiAgbG9hbklkOiBQcm9wVHlwZXMub25lT2YoW1wiY2FyTG9hblwiLCBcImhvdXNlTG9hblwiLCBcImNhckxvYW5TdWJzaWRpYXJ5XCIsIFwiaG91c2VMb2FuU3Vic2lkaWFyeVwiXSlcbiAgICAuaXNSZXF1aXJlZCxcbiAgYnJhbmRTdHlsZTogUHJvcFR5cGVzLm9uZU9mKFtcInlhXCIsIFwieXhcIl0pLFxufTtcblxuTXVsdGlwbGVMb2FuLmRlZmF1bHRQcm9wcyA9IHtcbiAgYnJhbmRTdHlsZTogXCJ5YVwiLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgTXVsdGlwbGVMb2FuO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$D
});
var loanLabels$1 = {
  carLoan: "Har du billån?",
  carLoanSubsidiary: "Har medsøker billån?",
  houseLoan: "Har du lån på bolig eller annen eiendom?",
  houseLoanSubsidiary: "Har medsøker lån på bolig eller annen eiendom?"
};
var addButtonLabels = {
  carLoan: "Legg til flere billån",
  houseLoan: "Legg til flere boliglån"
};
function MultipleLoan(_ref) {
  var _state$collapseStates;
  var onValueUpdate = _ref.onValueUpdate,
    onCollapse = _ref.onCollapse,
    state = _ref.state,
    setState = _ref.setState,
    loanId = _ref.loanId,
    brandStyle = _ref.brandStyle;
  var amountId = "".concat(loanId, "InputFieldLoanAmount");
  var paymentId = "".concat(loanId, "InputFieldMonthlyPayment");
  var addRemoveClickHandler = function addRemoveClickHandler(index) {
    var amount = state[amountId];
    var payment = state[paymentId];
    if (typeof index === "number") {
      amount.splice(index, 1);
      payment.splice(index, 1);
    } else {
      amount.push("");
      payment.push("");
    }
    setState(function (prevState) {
      var _objectSpread2;
      return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, (_objectSpread2 = {}, _defineProperty$5(_objectSpread2, amountId, amount), _defineProperty$5(_objectSpread2, paymentId, payment), _objectSpread2));
    });
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Radio, {
    id: loanId,
    label: loanLabels$1[loanId],
    options: [{
      value: "on",
      label: "Ja",
      checked: state[loanId] === "on"
    }, {
      value: "off",
      label: "Nei",
      checked: state[loanId] === "off"
    }],
    onchange: onValueUpdate,
    showError: state["".concat(loanId, "Error")],
    brandStyle: brandStyle
  }))), /*#__PURE__*/React__default.createElement(Collapse, {
    isOpen: state[loanId] === "on",
    appear: ((_state$collapseStates = state.collapseStates) === null || _state$collapseStates === void 0 ? void 0 : _state$collapseStates[loanId]) !== "ENTERED",
    onEntered: function onEntered() {
      return onCollapse("ENTERED", loanId);
    },
    onExited: function onExited() {
      return onCollapse("CLOSED", loanId);
    }
  }, _toConsumableArray$3(Array(state[amountId].length)).map(function (x, i) {
    var _state$amountId, _state$paymentId;
    return /*#__PURE__*/React__default.createElement(RemovableLoanInputsContainer
    // eslint-disable-next-line react/no-array-index-key
    , {
      key: "".concat(loanId, "-key-").concat(i, "-").concat(state[amountId].length),
      useBorder: i > 0
    }, /*#__PURE__*/React__default.createElement(Input$1, {
      id: "".concat(amountId, "-").concat(i),
      type: "tel",
      title: "Din andel av saldo p\xE5 l\xE5net",
      value: (_state$amountId = state[amountId]) === null || _state$amountId === void 0 ? void 0 : _state$amountId[i],
      onblur: onValueUpdate,
      isCurrency: true,
      showError: state["".concat(amountId, "Error").concat(i)],
      brandStyle: brandStyle
    }), /*#__PURE__*/React__default.createElement(Input$1, {
      id: "".concat(paymentId, "-").concat(i),
      type: "tel",
      title: "M\xE5nedsbel\xF8p",
      value: (_state$paymentId = state[paymentId]) === null || _state$paymentId === void 0 ? void 0 : _state$paymentId[i],
      onblur: onValueUpdate,
      isCurrency: true,
      showError: state["".concat(paymentId, "Error").concat(i)],
      brandStyle: brandStyle
    }), i > 0 && /*#__PURE__*/React__default.createElement(RemoveLoanIcon, {
      src: xSvg,
      alt: "remove loan",
      onClick: function onClick() {
        return addRemoveClickHandler(i);
      }
    }));
  }), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Button, {
    id: "".concat(loanId, "AddRowId"),
    label: addButtonLabels[loanId.replace("Subsidiary", "")],
    onclick: function onclick() {
      return addRemoveClickHandler();
    },
    brandStyle: brandStyle
  }))));
}
MultipleLoan.propTypes = {
  onValueUpdate: PropTypes.func.isRequired,
  onCollapse: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  state: PropTypes.object.isRequired,
  setState: PropTypes.func.isRequired,
  loanId: PropTypes.oneOf(["carLoan", "houseLoan", "carLoanSubsidiary", "houseLoanSubsidiary"]).isRequired,
  brandStyle: PropTypes.oneOf(["ya", "yx"])
};
MultipleLoan.defaultProps = {
  brandStyle: "ya"
};

var loanLabels = {
  studentLoan: "Har du studielån?",
  studentLoanSubsidiary: "Har medsøker studielån?"
};
function StudentLoan(_ref) {
  var _state$collapseStates;
  var onValueUpdate = _ref.onValueUpdate,
    onCollapse = _ref.onCollapse,
    state = _ref.state,
    loanId = _ref.loanId,
    brandStyle = _ref.brandStyle;
  var amountId = "".concat(loanId, "InputFieldLoanAmount");
  var paymentId = "".concat(loanId, "InputFieldMonthlyPayment");
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Radio, {
    id: loanId,
    label: loanLabels[loanId],
    options: [{
      value: "on",
      label: "Ja",
      checked: state[loanId] === "on"
    }, {
      value: "off",
      label: "Nei",
      checked: state[loanId] === "off"
    }],
    onchange: onValueUpdate,
    showError: state["".concat(loanId, "Error")],
    brandStyle: brandStyle
  }))), /*#__PURE__*/React__default.createElement(Collapse, {
    isOpen: state[loanId] === "on",
    appear: ((_state$collapseStates = state.collapseStates) === null || _state$collapseStates === void 0 ? void 0 : _state$collapseStates.studentLoan) !== "ENTERED",
    onEntered: function onEntered() {
      return onCollapse("ENTERED", "studentLoan");
    },
    onExited: function onExited() {
      return onCollapse("CLOSED", "studentLoan");
    }
  }, /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: amountId,
    type: "tel",
    title: "Saldo p\xE5 l\xE5net",
    value: state[amountId],
    onblur: onValueUpdate,
    isCurrency: true,
    showError: state["".concat(amountId, "Error")],
    brandStyle: brandStyle
  })), /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: paymentId,
    type: "tel",
    title: "M\xE5nedsbel\xF8p",
    value: state[paymentId],
    onblur: onValueUpdate,
    isCurrency: true,
    showError: state["".concat(paymentId, "Error")],
    brandStyle: brandStyle
  })))));
}
StudentLoan.propTypes = {
  onValueUpdate: PropTypes.func.isRequired,
  onCollapse: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  state: PropTypes.object.isRequired,
  loanId: PropTypes.oneOf(["studentLoan", "studentLoanSubsidiary"]).isRequired,
  brandStyle: PropTypes.oneOf(["ya", "yx"])
};
StudentLoan.defaultProps = {
  brandStyle: "ya"
};

function SimpleEconomy(_ref) {
  var onValueUpdate = _ref.onValueUpdate,
    state = _ref.state,
    _ref$brandStyle = _ref.brandStyle,
    brandStyle = _ref$brandStyle === void 0 ? "ya" : _ref$brandStyle;
  return /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: "grossIncomeYearly",
    type: "tel",
    title: "Din brutto \xE5rsl\xF8nn",
    onblur: onValueUpdate,
    isCurrency: true,
    value: state.grossIncomeYearly || "",
    secondaryTitle: "(din \xE5rsl\xF8nn f\xF8r skatt)",
    showError: state.grossIncomeYearlyError,
    brandStyle: brandStyle
  })), /*#__PURE__*/React__default.createElement(Span$1, {
    style: {
      marginLeft: "0.5em"
    }
  }, /*#__PURE__*/React__default.createElement(Input$1, {
    id: "extraIncome",
    type: "tel",
    title: "Andre inntekter per \xE5r",
    onblur: onValueUpdate,
    isCurrency: true,
    value: state.extraIncome || "",
    secondaryTitle: "(husleie, barnebidrag, etc)",
    showError: state.extraIncomeError,
    brandStyle: brandStyle
  })));
}
SimpleEconomy.propTypes = {
  onValueUpdate: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  state: PropTypes.object.isRequired,
  brandStyle: PropTypes.oneOf(["ya", "yx"]).isRequired
};

function DebtCollection(_ref) {
  var onValueUpdate = _ref.onValueUpdate,
    state = _ref.state,
    brandStyle = _ref.brandStyle;
  return /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Radio, {
    id: "hasDebtCollection",
    label: "Har du p\xE5g\xE5ende inkassosaker?",
    options: [{
      value: true,
      label: "Ja",
      checked: state.hasDebtCollection === true
    }, {
      value: false,
      label: "Nei",
      checked: state.hasDebtCollection === false
    }],
    onchange: onValueUpdate,
    showError: state.hasDebtCollectionError,
    brandStyle: brandStyle
  })));
}
DebtCollection.propTypes = {
  onValueUpdate: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  state: PropTypes.object.isRequired,
  brandStyle: PropTypes.oneOf(["ya", "yx"])
};
DebtCollection.defaultProps = {
  brandStyle: "ya"
};

function StepTwo$2(props) {
  var onValueUpdate = props.onValueUpdate,
    onNextStep = props.onNextStep,
    setState = props.setState,
    state = props.state,
    onCollapse = props.onCollapse;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Legend, null, "Personalia"), /*#__PURE__*/React__default.createElement(MorePersonalia, {
    state: state,
    onValueUpdate: onValueUpdate
  }), /*#__PURE__*/React__default.createElement(Legend, null, "Inntekt"), /*#__PURE__*/React__default.createElement(SimpleEconomy, {
    onValueUpdate: onValueUpdate,
    state: state
  }), /*#__PURE__*/React__default.createElement(Legend, null, "Gjeld: Boligl\xE5n"), /*#__PURE__*/React__default.createElement(MultipleLoan, {
    onValueUpdate: onValueUpdate,
    onCollapse: onCollapse,
    state: state,
    setState: setState,
    loanId: "houseLoan"
  }), /*#__PURE__*/React__default.createElement(Legend, null, "Gjeld: Studiel\xE5n"), /*#__PURE__*/React__default.createElement(StudentLoan, {
    onValueUpdate: onValueUpdate,
    onCollapse: onCollapse,
    state: state,
    loanId: "studentLoan"
  }), /*#__PURE__*/React__default.createElement(Legend, null, "Gjeld: Bill\xE5n"), /*#__PURE__*/React__default.createElement(MultipleLoan, {
    onValueUpdate: onValueUpdate,
    onCollapse: onCollapse,
    state: state,
    setState: setState,
    loanId: "carLoan"
  }), /*#__PURE__*/React__default.createElement(Legend, {
    brandStyle: "yx"
  }, "Gjeld: Inkasso"), /*#__PURE__*/React__default.createElement(DebtCollection, {
    onValueUpdate: onValueUpdate,
    state: state,
    brandStyle: "ya"
  }), /*#__PURE__*/React__default.createElement(Legend, null, "Annet"), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Radio, {
    id: "paymentMethod",
    label: "\xD8nsket betalingsm\xE5te",
    options: [{
      value: "EMAIL",
      label: "Faktura per e-post (gratis)",
      checked: state.paymentMethod === "EMAIL"
    }, {
      value: "BANK",
      label: "Papirfaktura per post (kr 35,-)",
      checked: state.paymentMethod === "BANK"
    }],
    onchange: onValueUpdate,
    showError: state.paymentMethodError
  })), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(SpanFull, null, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "comment"
  }, "Kommentar"), /*#__PURE__*/React__default.createElement(TextArea, {
    id: "comment",
    name: "comment",
    maxLength: "5000",
    defaultValue: state.comment,
    onBlur: function onBlur(e) {
      return onValueUpdate(e, "comment");
    }
  }))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
    id: "accept",
    value: state.accept === "on" ? "off" : "on",
    checked: state.accept === "on",
    onchange: function onchange(e) {
      return onValueUpdate(e, "accept");
    },
    showError: state.acceptError,
    disableLabelClick: true
  }, "Jeg aksepterer at det blir foretatt en", /*#__PURE__*/React__default.createElement(ALink, {
    href: "https://documenthandler.resurs.com/Dokument.pdf?customerType=NATURAL&docType=Kredittvurdering-utsendelse-av-gjenpartsbrev-for-forbrukslan-innskudd-ya-kredittkort&land=NO&language=no",
    target: "_blank",
    rel: "noreferrer"
  }, "kredittvurdering og at utsendelse av gjenpartsbrev foreg\xE5r elektronisk der dette er praktisk mulig"))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Button, {
    label: "Send s\xF8knad",
    onclick: onNextStep,
    showError: state.button2Error,
    disabled: !!state.apiStatus.loading
  })));
}
StepTwo$2.propTypes = {
  onValueUpdate: PropTypes.func.isRequired,
  onNextStep: PropTypes.func.isRequired,
  onCollapse: PropTypes.func.isRequired,
  setState: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  state: PropTypes.object.isRequired
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$C() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var H2$2 = createStyled("h3", "development" === "production" ? {
  target: "e534v5e1"
} : {
  target: "e534v5e1",
  label: "H2"
})("development" === "production" ? {
  name: "9uo1ou",
  styles: "margin-bottom:10px;color:#1c1c1b"
} : {
  name: "9uo1ou",
  styles: "margin-bottom:10px;color:#1c1c1b",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$C
});
var Container$7 = createStyled("div", "development" === "production" ? {
  target: "e534v5e0"
} : {
  target: "e534v5e0",
  label: "Container"
})("development" === "production" ? {
  name: "1dvcxr3",
  styles: "padding:1rem"
} : {
  name: "1dvcxr3",
  styles: "padding:1rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN0ZXBUaHJlZS5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBVzRCIiwiZmlsZSI6IlN0ZXBUaHJlZS5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuaW1wb3J0IHsgQnV0dG9uLCBMZWdlbmQsIFJvdyB9IGZyb20gXCIuLi8uLi91aVwiO1xuXG5jb25zdCBIMiA9IHN0eWxlZC5oM2BcbiAgbWFyZ2luLWJvdHRvbTogMTBweDtcbiAgY29sb3I6ICMxYzFjMWI7XG5gO1xuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICBwYWRkaW5nOiAxcmVtO1xuYDtcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gU3RlcFRocmVlKHByb3BzKSB7XG4gIGNvbnN0IHsgYXBpU3RhdHVzIH0gPSBwcm9wcztcbiAgY29uc3QgeyBjb2RlLCBhcHBsaWNhdGlvbiB9ID0gYXBpU3RhdHVzO1xuXG4gIGlmIChjb2RlID09PSAyMDApIHtcbiAgICAvLyBodHRwczovL3lhLm5vL2tyZWRpdHRrb3J0L3MlQzMlQjhrbmFkc3NramVtYS1rdml0dGVyaW5nLWphXG4gICAgLy8gVGl0dGEgaMOkcjogaHR0cHM6Ly8yNGhyY29tbXVuaWNhdGlvbi5zbGFjay5jb20vYXJjaGl2ZXMvQzAxVDFUQjlHM1QvcDE2MzQyOTk1NjUwMjU5MDA/dGhyZWFkX3RzPTE2MzQyOTkzMTMuMDI1NTAwJmNpZD1DMDFUMVRCOUczVFxuXG4gICAgcmV0dXJuIChcbiAgICAgIDxDb250YWluZXI+XG4gICAgICAgIDxIMj5cbiAgICAgICAgICBWZWxrb21tZW4gc29tIHlBIEtyZWRpdHRrb3J0IGt1bmRlLHtcIiBcIn1cbiAgICAgICAgICB7YXBwbGljYXRpb24ubWFpbkFwcGxpY2FudEFwcGxpY2F0aW9uPy5hcHBsaWNhbnQ/Lm5hbWUgfHwgXCJcIn1cbiAgICAgICAgPC9IMj5cbiAgICAgICAgPHA+XG4gICAgICAgICAgRHUgaGFyIGbDpXR0IGlubnZpbGdldCBkaW4gc8O4a25hZCBww6UgeUEgS3JlZGl0dGtvcnQgbWVkIGVuIGtyZWRpdHRyYW1tZSBww6Uga3J7XCIgXCJ9XG4gICAgICAgICAgPGI+e2FwcGxpY2F0aW9uLmFwcGxpZWRBbW91bnR9PC9iPlxuICAgICAgICA8L3A+XG4gICAgICAgIDxiPk9CUyE8L2I+XG4gICAgICAgIDxwPkR1IGhhciBmw6V0dCBpbm52aWxnZXQgZGluIHPDuGtuYWQgb20ga3JlZGl0dGtvcnQuPC9wPlxuICAgICAgICA8cD5cbiAgICAgICAgICBERVJTT00gRFUgU0lUVEVSIFZFRCBFTiBQQyBlbGxlciBNb2JpbC8gTmV0YnJldHQgbWVkIHN0w7h0dGUgZm9yIEJhbmtJRCAoQW5kcm9pZCBvZyBJT1MpOlxuICAgICAgICA8L3A+XG5cbiAgICAgICAgPEJ1dHRvblxuICAgICAgICAgIGxhYmVsPVwiU3RhcnRlIHNpZ25lcmluZ1wiXG4gICAgICAgICAgb25jbGljaz17KCkgPT4ge1xuICAgICAgICAgICAgd2luZG93LmxvY2F0aW9uLmhyZWYgPSBhcHBsaWNhdGlvbi5tYWluQXBwbGljYW50QXBwbGljYXRpb24/LmFwcGxpY2FudD8uc2lnbmluZ1VybDtcbiAgICAgICAgICB9fVxuICAgICAgICAvPlxuXG4gICAgICAgIDxwPlRyeWtrIHDDpSBrbmFwcGVuIGZvciDDpSBzdGFydGUgc2lnbmVyaW5nPC9wPlxuICAgICAgICA8cD5cbiAgICAgICAgICBERVJTT00gRFUgQkVOWVRURVIgTkVUVEJSRVRULCBNT0JJTFRFTEVGT04gU09NIElLS0UgU1TDmFRURVIgQkFOS0lEIEVMTEVSIElLS0UgSEFSIERJTlxuICAgICAgICAgIEJBTktJRCBCUklLS0UgVElMR0pFTkdFTElHIEtBTiBEVSBTSUdORVJFIFNFTkVSRTpcbiAgICAgICAgPC9wPlxuICAgICAgICA8YnIgLz5cbiAgICAgICAgPHA+XG4gICAgICAgICAgRHUgaGFyIGbDpXR0IHRpbHNlbmR0IGVuIHBvc3QgbWVkIGxpbmsgdGlsIHNpZ25lcmluZyBzb20ga2FuIGdqZW5ub21mw7hyZXMgcMOlIGRpbiBQQyBlbGxlclxuICAgICAgICAgIE1BQy5cbiAgICAgICAgPC9wPlxuICAgICAgICA8YnIgLz5cbiAgICAgICAgPHA+XG4gICAgICAgICAgVmVubmxpZyBoaWxzZW4gPGJyIC8+XG4gICAgICAgICAgeUEg4oCTIGVuIGRlbCBhdiBSZXN1cnMgQmFua1xuICAgICAgICA8L3A+XG4gICAgICA8L0NvbnRhaW5lcj5cbiAgICApO1xuICB9XG5cbiAgcmV0dXJuIChcbiAgICA8Q29udGFpbmVyPlxuICAgICAgPFJvdz5cbiAgICAgICAgPExlZ2VuZD5GaW5uZXIgaWtrZSBzaWRlbjwvTGVnZW5kPlxuICAgICAgPC9Sb3c+XG4gICAgICA8Um93PlxuICAgICAgICA8cD5CZWtsYWdlciwgdmkgZmlubmVyIGlra2Ugc2lkZW4gZHUgZm9yc8O4a3RlIMOlIG7DpS48L3A+XG4gICAgICAgIDxwPktvbnRha3Qgb3NzIGh2aXMgZHUgbWVuZXIgZGV0dGUgZXIgZW4gZmVpbC48L3A+XG4gICAgICA8L1Jvdz5cbiAgICA8L0NvbnRhaW5lcj5cbiAgKTtcbn1cblxuU3RlcFRocmVlLnByb3BUeXBlcyA9IHtcbiAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIHJlYWN0L2ZvcmJpZC1wcm9wLXR5cGVzXG4gIGFwaVN0YXR1czogUHJvcFR5cGVzLm9iamVjdC5pc1JlcXVpcmVkLFxufTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$C
});
function StepThree$2(props) {
  var apiStatus = props.apiStatus;
  var code = apiStatus.code,
    application = apiStatus.application;
  if (code === 200) {
    var _application$mainAppl, _application$mainAppl2;
    // https://ya.no/kredittkort/s%C3%B8knadsskjema-kvittering-ja
    // Titta här: https://24hrcommunication.slack.com/archives/C01T1TB9G3T/p1634299565025900?thread_ts=1634299313.025500&cid=C01T1TB9G3T

    return /*#__PURE__*/React__default.createElement(Container$7, null, /*#__PURE__*/React__default.createElement(H2$2, null, "Velkommen som yA Kredittkort kunde,", " ", ((_application$mainAppl = application.mainApplicantApplication) === null || _application$mainAppl === void 0 ? void 0 : (_application$mainAppl2 = _application$mainAppl.applicant) === null || _application$mainAppl2 === void 0 ? void 0 : _application$mainAppl2.name) || ""), /*#__PURE__*/React__default.createElement("p", null, "Du har f\xE5tt innvilget din s\xF8knad p\xE5 yA Kredittkort med en kredittramme p\xE5 kr", " ", /*#__PURE__*/React__default.createElement("b", null, application.appliedAmount)), /*#__PURE__*/React__default.createElement("b", null, "OBS!"), /*#__PURE__*/React__default.createElement("p", null, "Du har f\xE5tt innvilget din s\xF8knad om kredittkort."), /*#__PURE__*/React__default.createElement("p", null, "DERSOM DU SITTER VED EN PC eller Mobil/ Netbrett med st\xF8tte for BankID (Android og IOS):"), /*#__PURE__*/React__default.createElement(Button, {
      label: "Starte signering",
      onclick: function onclick() {
        var _application$mainAppl3, _application$mainAppl4;
        window.location.href = (_application$mainAppl3 = application.mainApplicantApplication) === null || _application$mainAppl3 === void 0 ? void 0 : (_application$mainAppl4 = _application$mainAppl3.applicant) === null || _application$mainAppl4 === void 0 ? void 0 : _application$mainAppl4.signingUrl;
      }
    }), /*#__PURE__*/React__default.createElement("p", null, "Trykk p\xE5 knappen for \xE5 starte signering"), /*#__PURE__*/React__default.createElement("p", null, "DERSOM DU BENYTTER NETTBRETT, MOBILTELEFON SOM IKKE ST\xD8TTER BANKID ELLER IKKE HAR DIN BANKID BRIKKE TILGJENGELIG KAN DU SIGNERE SENERE:"), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("p", null, "Du har f\xE5tt tilsendt en post med link til signering som kan gjennomf\xF8res p\xE5 din PC eller MAC."), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("p", null, "Vennlig hilsen ", /*#__PURE__*/React__default.createElement("br", null), "yA \u2013 en del av Resurs Bank"));
  }
  return /*#__PURE__*/React__default.createElement(Container$7, null, /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Legend, null, "Finner ikke siden")), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement("p", null, "Beklager, vi finner ikke siden du fors\xF8kte \xE5 n\xE5."), /*#__PURE__*/React__default.createElement("p", null, "Kontakt oss hvis du mener dette er en feil.")));
}
StepThree$2.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  apiStatus: PropTypes.object.isRequired
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$B() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Container$6 = createStyled("div", "development" === "production" ? {
  target: "eae6j661"
} : {
  target: "eae6j661",
  label: "Container"
})("development" === "production" ? {
  name: "ihv00n",
  styles: "max-width:610px"
} : {
  name: "ihv00n",
  styles: "max-width:610px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$B
});
var StepPagination$2 = createStyled("p", "development" === "production" ? {
  target: "eae6j660"
} : {
  target: "eae6j660",
  label: "StepPagination"
})("color:", colors$1.primaryGreen, ";font-size:15px;margin-top:6px;margin-bottom:0px;" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
function KredittKort(props) {
  // Test-mode
  var prefilled = props.prefilled,
    baseApiUrl = props.baseApiUrl;
  var _useState = useState({
      currentStep: 0,
      collapseStates: {},
      apiStatus: {
        loading: false
      },
      // Base
      productType: "CREDIT_CARD",
      schema: "/schema/productApplication_v30.xsd",
      // Step: 1
      name: prefilled ? "Karl Olsen" : "",
      nameError: "",
      ssn: prefilled ? "17065349957" : "",
      ssnError: "",
      email: prefilled ? "yabank@gmail.com" : undefined,
      emailError: "",
      emailRepeat: prefilled ? "yabank@gmail.com" : undefined,
      emailRepeatError: "",
      mobilNo: prefilled ? "13345678" : "",
      mobilNoError: "",
      button1Error: "",
      // Step: 2
      // Personalia
      civilStatus: prefilled ? "SEPARATED" : "Velg",
      civilStatusError: "",
      noOfChildren: prefilled ? "0" : "Velg",
      noOfChildrenError: "",
      habitat: prefilled ? "OWNED" : "Velg",
      habitatError: "",
      education: prefilled ? "UNIVERSITY_LONG" : "Velg",
      educationError: "",
      employmentSituation: prefilled ? "RETIRED" : "Velg",
      employmentSituationError: "",
      // Inntekt
      grossIncomeYearly: prefilled ? 900000 : undefined,
      grossIncomeYearlyError: "",
      hasDebtCollection: prefilled ? false : undefined,
      hasDebtCollectionError: "",
      // Annet
      paymentMethod: prefilled ? "EMAIL" : undefined,
      paymentMethodError: "",
      comment: "",
      accept: prefilled ? "on" : "off",
      acceptError: "",
      button2Error: "",
      houseLoan: prefilled ? "on" : "off",
      houseLoanError: "",
      houseLoanInputFieldLoanAmount: prefilled ? [123, 234] : [""],
      houseLoanInputFieldMonthlyPayment: prefilled ? [123, 234] : [""],
      carLoan: "off",
      carLoanError: "",
      carLoanInputFieldLoanAmount: [""],
      carLoanInputFieldMonthlyPayment: [""],
      studentLoan: "off",
      studentLoanError: "",
      studentLoanInputFieldLoanAmount: undefined,
      studentLoanInputFieldLoanAmountError: "",
      studentLoanInputFieldMonthlyPayment: undefined,
      studentLoanInputFieldMonthlyPaymentError: "",
      extraIncome: prefilled ? 1 : undefined,
      extraIncomeError: "",
      isDeadEndError: false
    }),
    _useState2 = _slicedToArray$2(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useScrollToTop(state.currentStep, state.isDeadEndError);
  useEffect(function () {
    if (state.apiStatus.loading) return;
    var isStep3 = state.currentStep === 2 && !state.apiStatus.isDeadEndError || state.currentStep === 1 && state.apiStatus.isDeadEndError;
    var isStep2 = state.currentStep === 1 && !state.apiStatus.isDeadEndError || state.currentStep === 0 && state.apiStatus.isDeadEndError;
    var isStep1 = state.currentStep === 0 && !state.apiStatus.isDeadEndError;
    if (isStep1) {
      gtmEventService().creditCard().pushStepOne();
    }
    if (isStep2) {
      gtmEventService().creditCard().pushStepTwo(state.apiStatus.message);
    }
    if (isStep3) {
      gtmEventService().creditCard().pushStepThree(state.apiStatus.application.applicationId, state.apiStatus.application.applicationState, state.apiStatus.message);
    }
  }, [state.currentStep, state.apiStatus]);
  var onValueUpdate = function onValueUpdate(event, id) {
    event.preventDefault();
    var value = event.target.value;

    // convert true/false string to a boolean value
    if (value === "true" || value === "false") {
      value = value === "true";
    }

    // Handle array inputs - for example usage: carLoanInputFieldLoanAmount-1 [value-index]
    var split = id.split("-");
    if (split.length && split.length === 2) {
      var name = split[0];
      var index = Number(split[1]);
      var result = validateValue(name, value, state, index);
      setState(function (prevState) {
        var _objectSpread2;
        var a = prevState[name];
        a["".concat(index)] = value;
        return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, (_objectSpread2 = {}, _defineProperty$5(_objectSpread2, result.errorFieldName || "".concat(id, "Error"), result.errMsg || ""), _defineProperty$5(_objectSpread2, name, _toConsumableArray$3(a)), _objectSpread2));
      });
    } else {
      var _result = validateValue(id, value, state);
      setState(function (prevState) {
        var _objectSpread3;
        return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, (_objectSpread3 = {}, _defineProperty$5(_objectSpread3, _result.errorFieldName || "".concat(id, "Error"), _result.errMsg || ""), _defineProperty$5(_objectSpread3, id, value), _objectSpread3));
      });
    }
  };
  var validateField = function validateField(id) {
    var value = state[id];

    // state: array objects
    if (_typeof$3(value) === "object") {
      var okArray = value.map(function (v, index) {
        var result = validateValue(id, v, state, index);
        setState(function (prevState) {
          return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, _defineProperty$5({}, result.errorFieldName || "".concat(id, "Error"), result.errMsg || ""));
        });
        return result.ok;
      });
      return !okArray.includes(false);
    }
    var result = validateValue(id, value, state);
    setState(function (prevState) {
      return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, _defineProperty$5({}, result.errorFieldName || "".concat(id, "Error"), result.errMsg || ""));
    });
    return result.ok;
  };
  var onNextStep = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var name, ssn, email, emailRepeat, mobilNo, formValues, result, isOK, civilStatus, noOfChildren, habitat, education, employmentSituation, grossIncomeYearly, extraIncome, hasDebtCollection, paymentMethod, comment, accept, houseLoan, houseLoanInputFieldLoanAmount, houseLoanInputFieldMonthlyPayment, studentLoan, studentLoanInputFieldLoanAmount, studentLoanInputFieldMonthlyPayment, carLoan, carLoanInputFieldLoanAmount, carLoanInputFieldMonthlyPayment, _formValues, _result2;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(state.currentStep === 0)) {
                _context.next = 17;
                break;
              }
              // Validate fields for 1st step
              name = validateField("name");
              ssn = validateField("ssn");
              email = validateField("email");
              emailRepeat = validateField("emailRepeat");
              mobilNo = validateField("mobilNo");
              if (!(!name || !ssn || !email || !emailRepeat || !mobilNo)) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return");
            case 8:
              setState(function (prevState) {
                return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
                  button1Error: "",
                  apiStatus: {
                    loading: true
                  }
                });
              });
              formValues = {
                productType: state.productType,
                name: state.name,
                ssn: state.ssn,
                email: state.email,
                mobilNo: state.mobilNo,
                schema: state.schema
              };
              UTM_PARAM_KEYS.forEach(function (paramKey) {
                // eslint-disable-next-line react/destructuring-assignment
                var utmValue = props[paramKey];
                if (utmValue) {
                  formValues[paramKey] = utmValue;
                }
              });
              _context.next = 13;
              return stepOnePost(formValues, baseApiUrl);
            case 13:
              result = _context.sent;
              setState(function (prevState) {
                return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
                  currentStep: result.ok ? state.currentStep + 1 : state.currentStep,
                  button1Error: result.ok ? "" : result.message,
                  isDeadEndError: result.isDeadEndError,
                  apiStatus: _objectSpread2$4({
                    loading: false
                  }, result)
                });
              });
              _context.next = 49;
              break;
            case 17:
              if (!(state.currentStep === 1)) {
                _context.next = 49;
                break;
              }
              // Validate fields for second step
              isOK = true;
              civilStatus = validateField("civilStatus");
              noOfChildren = validateField("noOfChildren");
              habitat = validateField("habitat");
              education = validateField("education");
              employmentSituation = validateField("employmentSituation");
              grossIncomeYearly = validateField("grossIncomeYearly");
              extraIncome = validateField("extraIncome");
              hasDebtCollection = validateField("hasDebtCollection");
              paymentMethod = validateField("paymentMethod");
              comment = validateField("comment");
              accept = validateField("accept");
              houseLoan = validateField("houseLoan"); // houseLoan extra fields
              if (state.houseLoan === "on") {
                houseLoanInputFieldLoanAmount = validateField("houseLoanInputFieldLoanAmount");
                houseLoanInputFieldMonthlyPayment = validateField("houseLoanInputFieldMonthlyPayment");
                if (!houseLoanInputFieldLoanAmount || !houseLoanInputFieldMonthlyPayment) {
                  isOK = false;
                }
              }
              studentLoan = validateField("studentLoan"); // studentLoan extra fields
              if (state.studentLoan === "on") {
                studentLoanInputFieldLoanAmount = validateField("studentLoanInputFieldLoanAmount");
                studentLoanInputFieldMonthlyPayment = validateField("studentLoanInputFieldMonthlyPayment");
                if (!studentLoanInputFieldLoanAmount || !studentLoanInputFieldMonthlyPayment) {
                  isOK = false;
                }
              }
              carLoan = validateField("carLoan"); // carLoan extra fields
              if (state.carLoan === "on") {
                carLoanInputFieldLoanAmount = validateField("carLoanInputFieldLoanAmount");
                carLoanInputFieldMonthlyPayment = validateField("carLoanInputFieldMonthlyPayment");
                if (!carLoanInputFieldLoanAmount || !carLoanInputFieldMonthlyPayment) {
                  isOK = false;
                }
              }
              if (!civilStatus || !noOfChildren || !habitat || !education || !employmentSituation || !grossIncomeYearly || !extraIncome || !houseLoan || !studentLoan || !carLoan || !hasDebtCollection || !paymentMethod || !comment || !accept) {
                isOK = false;
              }
              if (isOK) {
                _context.next = 39;
                break;
              }
              return _context.abrupt("return");
            case 39:
              setState(function (prevState) {
                return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
                  button2Error: "",
                  apiStatus: {
                    loading: true
                  }
                });
              });
              _formValues = {
                productType: state.productType,
                schema: state.schema,
                // step 1
                name: state.name,
                ssn: state.ssn,
                email: state.email,
                mobilNo: state.mobilNo,
                // step 2
                civilStatus: state.civilStatus,
                noOfChildren: state.noOfChildren,
                habitat: state.habitat,
                education: state.education,
                employmentSituation: state.employmentSituation,
                grossIncomeYearly: state.grossIncomeYearly,
                extraIncome: state.extraIncome,
                hasDebtCollection: state.hasDebtCollection,
                paymentMethod: state.paymentMethod,
                comment: state.comment
              };
              if (state.houseLoan === "on") {
                _formValues.houseLoanInputFieldLoanAmount = state.houseLoanInputFieldLoanAmount;
                _formValues.houseLoanInputFieldMonthlyPayment = state.houseLoanInputFieldMonthlyPayment;
              }
              if (state.studentLoan === "on") {
                _formValues.studentLoanInputFieldLoanAmount = [state.studentLoanInputFieldLoanAmount]; // backend expects array even though its only one value
                _formValues.studentLoanInputFieldMonthlyPayment = [state.studentLoanInputFieldMonthlyPayment];
              }
              if (state.carLoan === "on") {
                _formValues.carLoanInputFieldLoanAmount = state.carLoanInputFieldLoanAmount;
                _formValues.carLoanInputFieldMonthlyPayment = state.carLoanInputFieldMonthlyPayment;
              }
              UTM_PARAM_KEYS.forEach(function (paramKey) {
                // eslint-disable-next-line react/destructuring-assignment
                var utmValue = props[paramKey];
                if (utmValue) {
                  _formValues[paramKey] = utmValue;
                }
              });

              // Send form with validated values
              _context.next = 47;
              return submitCardApplication(_formValues, baseApiUrl);
            case 47:
              _result2 = _context.sent;
              setState(function (prevState) {
                return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
                  currentStep: _result2.ok ? state.currentStep + 1 : state.currentStep,
                  button2Error: _result2.ok ? "" : _result2.message,
                  isDeadEndError: _result2.isDeadEndError,
                  apiStatus: _objectSpread2$4({
                    loading: false
                  }, _result2)
                });
              });
            case 49:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function onNextStep() {
      return _ref.apply(this, arguments);
    };
  }();
  var onCollapse = function onCollapse(collapseState, id) {
    setState(function (prevState) {
      return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
        collapseStates: _objectSpread2$4(_objectSpread2$4({}, state.collapseStates), {}, _defineProperty$5({}, id, collapseState))
      });
    });
  };
  var body;
  if (state.isDeadEndError) {
    body = /*#__PURE__*/React__default.createElement(DeadEndView, {
      productType: state.productType,
      code: state.apiStatus.code,
      message: state.apiStatus.message
    });
  } else {
    body = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Steps, {
      labels: ["Personalia", "Din økonomi", "Resultat"],
      currentStep: state.currentStep
    }), state.currentStep === 0 && /*#__PURE__*/React__default.createElement(CardStepOne, {
      onValueUpdate: onValueUpdate,
      onNextStep: onNextStep,
      state: state
    }), state.currentStep === 1 && /*#__PURE__*/React__default.createElement(StepTwo$2, {
      onValueUpdate: onValueUpdate,
      onNextStep: onNextStep,
      onCollapse: onCollapse,
      setState: setState,
      state: state
    }), state.currentStep === 2 && /*#__PURE__*/React__default.createElement(StepThree$2, {
      apiStatus: state.apiStatus
    }), state.apiStatus.loading && /*#__PURE__*/React__default.createElement(LoadingOverlay, null), state.currentStep < 2 && /*#__PURE__*/React__default.createElement(StepPagination$2, null, "(Steg ", state.currentStep + 1, " av 3)"));
  }
  return /*#__PURE__*/React__default.createElement(SystemStatus, {
    cmsHelperUrl: baseApiUrl
  }, /*#__PURE__*/React__default.createElement(Container$6, null, body));
}
KredittKort.propTypes = {
  prefilled: PropTypes.bool,
  /* eslint-disable react/no-unused-prop-types */
  // These are looped through with the help of UTM_PARAM_KEYS
  campaignId: PropTypes.string,
  gclid: PropTypes.string,
  utm_campaign: PropTypes.string,
  utm_content: PropTypes.string,
  utm_medium: PropTypes.string,
  utm_source: PropTypes.string,
  utm_term: PropTypes.string,
  /* eslint-enable react/no-unused-prop-types */
  baseApiUrl: PropTypes.string.isRequired
};
KredittKort.defaultProps = {
  prefilled: false,
  campaignId: undefined,
  gclid: undefined,
  utm_campaign: undefined,
  utm_content: undefined,
  utm_medium: undefined,
  utm_source: undefined,
  utm_term: undefined
};

var Logo = "data:image/svg+xml,%3Csvg%20width%3D%22150%22%20height%3D%2248%22%20viewBox%3D%220%200%20150%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url%28%23clip0%29%22%3E%3Cpath%20d%3D%22M2.53685%200H34.5673C35.9684%200%2037.1042%201.13571%2037.1042%202.53685V45.4632C37.1042%2046.8643%2035.9684%2048%2034.5673%2048H2.53685C1.13571%2048%200%2046.8643%200%2045.4632V2.53685C0%201.13571%201.13571%200%202.53685%200Z%22%20fill%3D%22%23FF003D%22%2F%3E%3Cpath%20d%3D%22M15.2755%2028.7626C16.2938%2028.756%2017.2293%2028.2012%2017.7254%2027.3114C18.3476%2026.2235%2018.6914%2024.9464%2019.1265%2023.8107C19.1787%2023.6954%2019.207%2023.5714%2019.207%2023.4452C19.1961%2023.1145%2018.9612%2022.8338%2018.6392%2022.762C17.7863%2022.5575%2014.1137%2021.7329%2013.8657%2016.5374C13.6177%2011.3418%2013.5655%207.28201%2013.5393%206.77725C13.5328%206.25509%2013.9397%205.82212%2014.4618%205.80037H18.3781C18.9089%205.78514%2019.3528%206.20069%2019.368%206.73156C19.368%206.75549%2019.368%206.77943%2019.368%206.80553C19.4159%207.96735%2019.4355%209.25971%2019.4355%2011.2178C19.4355%2013.1759%2019.3789%2012.6581%2019.3789%2013.8917C19.3789%2015.1254%2019.3789%2015.9717%2019.5965%2016.7201C19.7596%2017.3076%2020.2862%2017.7819%2020.6843%2017.7819C21.0172%2017.7971%2021.3196%2017.5882%2021.4197%2017.2706C22.0724%2015.4517%2024.9334%207.14277%2025.164%206.48571C25.2859%206.06145%2025.684%205.77861%2026.1257%205.80037H30.1268C30.6381%205.82648%2031.0362%206.25291%2031.0275%206.7642C31.0253%206.86428%2031.0079%206.96436%2030.9753%207.06009C30.9753%207.06009%2024.3199%2025.7318%2023.6345%2027.6486C22.9492%2029.5654%2022.0659%2030.8251%2021.213%2031.6802C20.9519%2031.9282%2020.9236%2032.3329%2021.1499%2032.6135C23.5432%2035.0068%2023.7607%2039.0644%2023.9152%2041.2728C23.9%2041.7732%2023.504%2042.1779%2023.0036%2042.1996H19.0569C18.5913%2042.1931%2018.1997%2041.8537%2018.1235%2041.3946C17.8124%2039.0318%2017.6579%2037.1368%2016.6245%2035.9315C16.4287%2035.7139%2016.1893%2035.4158%2015.8064%2035.4158C15.517%2035.4267%2015.2603%2035.5986%2015.1385%2035.8618L11.975%2041.5926C11.8206%2041.9559%2011.4659%2042.1953%2011.0699%2042.1996H6.95137C6.43138%2042.1909%206.01365%2041.7666%206.01147%2041.2467C6.018%2041.0639%206.07239%2040.8877%206.16595%2040.731L10.2084%2033.2706C10.2519%2033.1814%2010.278%2033.0835%2010.2823%2032.9834C10.2823%2032.4373%209.96035%2032.4634%209.33157%2031.7868C7.55839%2029.8787%207.31471%2027.8401%207.31471%2024.2371C7.33429%2023.7215%207.75855%2023.3146%208.27419%2023.3168H12.0229C12.5385%2023.3125%2012.9606%2023.7215%2012.9737%2024.2371C12.9954%2024.5983%2012.9737%2025.4098%2013.065%2026.1953C13.1912%2027.4136%2013.8091%2028.7626%2015.2755%2028.7626Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M61.4895%2018.5259C61.4895%2021.3478%2059.923%2022.9143%2056.629%2022.9143C53.3351%2022.9143%2051.7207%2021.3652%2051.7207%2018.5259V10.4694H55.5543V18.4607C55.5543%2019.2439%2055.7979%2019.5855%2056.6312%2019.5855C57.4645%2019.5855%2057.6755%2019.2765%2057.6755%2018.4607V10.4694H61.4917V18.5259H61.4895Z%22%20fill%3D%22%23002751%22%2F%3E%3Cpath%20d%3D%22M67.5727%2021.9831C66.9852%2022.5531%2066.2194%2022.8643%2065.273%2022.8643C63.4302%2022.8643%2062.2727%2021.7068%2062.2727%2019.4397C62.2727%2017.5643%2063.6108%2016.211%2065.6494%2016.211C66.2368%2016.211%2066.611%2016.2763%2067.0026%2016.3568V16.2088C67.0026%2015.7041%2066.6937%2015.3451%2065.6494%2015.3451C64.605%2015.3451%2064.0502%2015.4909%2063.1539%2015.8172L62.8775%2013.1107C63.8566%2012.7038%2065.0467%2012.4906%2066.3347%2012.4906C69.4829%2012.4906%2070.5099%2013.8286%2070.5099%2016.6984V22.7011H67.8033L67.5727%2021.9831ZM67.0026%2018.6239C66.8068%2018.5738%2066.611%2018.5412%2066.3347%2018.5412C65.8452%2018.5412%2065.6015%2018.7849%2065.6015%2019.4049C65.6015%2019.9423%2065.83%2020.1708%2066.2368%2020.1708C66.6437%2020.1708%2067.0026%2019.9597%2067.0026%2019.5028V18.6239Z%22%20fill%3D%22%23002751%22%2F%3E%3Cpath%20d%3D%22M76.6911%2022.701V16.3719C76.6911%2015.6866%2076.4301%2015.4429%2075.9405%2015.4429C75.5663%2015.4429%2075.2878%2015.5887%2075.1094%2015.8019V22.701H71.5696V12.7037L74.1304%2012.5732L74.5698%2013.2738C75.2552%2012.7364%2076.1037%2012.4579%2076.9827%2012.4579C78.9408%2012.4579%2080.2288%2013.8612%2080.2288%2016.3719V22.701H76.6911Z%22%20fill%3D%22%23002751%22%2F%3E%3Cpath%20d%3D%22M84.1451%2022.8969C83.0203%2022.8969%2082.0412%2022.7337%2081.1927%2022.3595L81.5016%2019.5551C82.2849%2019.9293%2083.3945%2020.0924%2084.0776%2020.0924C84.5998%2020.0924%2084.8435%2019.9293%2084.8435%2019.6834C84.8435%2018.7044%2081.0273%2019.3897%2081.0273%2015.8346C81.0273%2013.9918%2082.2348%2012.4906%2084.9588%2012.4906C85.9531%2012.4906%2086.9321%2012.7016%2087.7154%2013.0128L87.4717%2015.7694C86.7059%2015.493%2085.5963%2015.3451%2084.961%2015.3451C84.5519%2015.3451%2084.3909%2015.4582%2084.3909%2015.6867C84.3909%2016.6483%2088.1092%2016.0457%2088.1092%2019.3897C88.1092%2021.511%2086.9844%2022.8969%2084.1451%2022.8969Z%22%20fill%3D%22%23002751%22%2F%3E%3Cpath%20d%3D%22M88.6135%2017.6622C88.6135%2014.3508%2089.9994%2012.4928%2093.0824%2012.4928C95.7411%2012.4928%2097.2096%2013.944%2097.2096%2017.1422C97.2096%2017.6796%2097.177%2018.2997%2097.1117%2018.7892H92.2839C92.4297%2019.6203%2093.0019%2019.9467%2094.192%2019.9467C95.0231%2019.9467%2095.839%2019.8314%2096.6222%2019.6051L96.9964%2022.3291C96.2306%2022.6228%2095.0057%2022.8665%2093.7503%2022.8665C90.2453%2022.8643%2088.6135%2021.0041%2088.6135%2017.6622ZM93.9461%2016.52C93.9135%2015.591%2093.685%2015.2973%2093.115%2015.2973C92.4949%2015.2973%2092.3165%2015.4778%2092.2339%2016.52H93.9461Z%22%20fill%3D%22%23002751%22%2F%3E%3Cpath%20d%3D%22M101.776%2015.182V19.455C101.776%2019.9446%20101.987%2020.1556%20102.575%2020.1556C102.786%2020.1556%20103.097%2020.123%20103.243%2020.0577L103.406%2022.5532C103.064%2022.7164%20102.296%2022.8622%20101.48%2022.8622C99.2612%2022.8622%2098.2343%2021.5415%2098.2343%2019.5508V15.182H97.4836V12.6538H98.4127L98.9827%2010.5978L101.772%2010.3541V12.6538H103.549V15.182H101.776Z%22%20fill%3D%22%23002751%22%2F%3E%3Cpath%20d%3D%22M108.284%2015.182V19.455C108.284%2019.9446%20108.495%2020.1556%20109.083%2020.1556C109.294%2020.1556%20109.605%2020.123%20109.751%2020.0577L109.914%2022.5532C109.572%2022.7164%20108.804%2022.8622%20107.988%2022.8622C105.769%2022.8622%20104.742%2021.5415%20104.742%2019.5508V15.182H103.991V12.6538H104.92L105.491%2010.5978L108.28%2010.3541V12.6538H110.057V15.182H108.284Z%22%20fill%3D%22%23002751%22%2F%3E%3Cpath%20d%3D%22M119.26%2022.701V16.372C119.26%2015.704%20119.032%2015.443%20118.51%2015.443C118.166%2015.443%20117.874%2015.5735%20117.694%2015.8019V22.701H114.154V10.1256L117.694%209.9624V11.7073L117.661%2013.0127L117.709%2013.0453C118.377%2012.5732%20119.08%2012.4579%20119.682%2012.4579C121.59%2012.4579%20122.813%2013.9265%20122.813%2016.372V22.701H119.26Z%22%20fill%3D%22%23002751%22%2F%3E%3Cpath%20d%3D%22M132.993%2012.6538L129.943%2022.7011H125.75L122.75%2012.6538H126.566L127.593%2017.8232L127.837%2019.1112H127.887L128.115%2017.8232L129.175%2012.6538H132.993Z%22%20fill%3D%22%23002751%22%2F%3E%3Cpath%20d%3D%22M137.449%2022.9296C134.301%2022.9296%20132.865%2021.511%20132.865%2017.7253C132.865%2013.9571%20134.316%2012.458%20137.449%2012.458C140.63%2012.458%20142.016%2013.9592%20142.016%2017.7253C142.016%2021.511%20140.612%2022.9296%20137.449%2022.9296ZM137.464%2020.1904C138.149%2020.1904%20138.361%2019.8488%20138.361%2017.7275C138.361%2015.5736%20138.149%2015.2494%20137.447%2015.2494C136.761%2015.2494%20136.533%2015.5584%20136.533%2017.7275C136.535%2019.8793%20136.779%2020.1904%20137.464%2020.1904Z%22%20fill%3D%22%23002751%22%2F%3E%3Cpath%20d%3D%22M142.847%2022.7012V12.7191L145.684%2012.606L145.945%2013.7961H145.995C146.582%2012.8497%20147.381%2012.4755%20148.245%2012.4755C148.717%2012.4755%20149.126%2012.5407%20149.354%2012.6212L149.158%2015.9979C148.832%2015.9174%20148.425%2015.8347%20148.034%2015.8347C147.007%2015.8347%20146.402%2016.4222%20146.402%2017.5796V22.7012H142.847Z%22%20fill%3D%22%23002751%22%2F%3E%3Cpath%20d%3D%22M57.5905%2039.3299L57.3141%2038.6446C56.7593%2039.182%2056.074%2039.5083%2055.0623%2039.5083C52.7953%2039.5083%2051.4746%2037.8766%2051.4746%2034.2236C51.4746%2030.897%2052.7626%2029.0868%2054.9644%2029.0868C55.6323%2029.0868%2056.2698%2029.2978%2056.8072%2029.7221L56.8398%2029.6895L56.8072%2028.3841V26.7523L60.347%2026.5891V39.3278H57.5905V39.3299ZM56.8072%2032.4635C56.6614%2032.2677%2056.4004%2032.1045%2056.0566%2032.1045C55.3713%2032.1045%2055.1428%2032.5113%2055.1428%2034.3541C55.1428%2036.3775%2055.306%2036.7365%2056.0566%2036.7365C56.3982%2036.7365%2056.6767%2036.5407%2056.8072%2036.2644V32.4635Z%22%20fill%3D%22%23002751%22%2F%3E%3Cpath%20d%3D%22M70.1008%2035.6443C70.1008%2038.2703%2068.6822%2039.4931%2065.7777%2039.4931C62.8753%2039.4931%2061.4546%2038.1724%2061.4546%2035.6443V29.2826H64.9944V35.6269C64.9944%2036.2296%2065.2055%2036.508%2065.7929%2036.508C66.3629%2036.508%2066.5762%2036.2644%2066.5762%2035.6269V29.2826H70.0986V35.6443H70.1008Z%22%20fill%3D%22%23002751%22%2F%3E%3Cpath%20d%3D%22M74.228%2034.2888C74.228%2030.9774%2075.6139%2029.1194%2078.6969%2029.1194C81.3556%2029.1194%2082.8242%2030.5706%2082.8242%2033.7688C82.8242%2034.3062%2082.7915%2034.9263%2082.7263%2035.4158H77.8984C78.0442%2036.2469%2078.6164%2036.5733%2079.8065%2036.5733C80.6376%2036.5733%2081.4535%2036.458%2082.2367%2036.2317L82.611%2038.9557C81.8451%2039.2494%2080.6202%2039.4931%2079.3648%2039.4931C75.8598%2039.4931%2074.228%2037.6328%2074.228%2034.2888ZM79.5606%2033.1488C79.528%2032.2197%2079.2996%2031.926%2078.7295%2031.926C78.1095%2031.926%2077.931%2032.1066%2077.8484%2033.1488H79.5606Z%22%20fill%3D%22%23002751%22%2F%3E%3Cpath%20d%3D%22M83.6399%2039.33V29.3479L86.477%2029.2348L86.7381%2030.4249H86.7881C87.3756%2029.4785%2088.174%2029.1042%2089.0378%2029.1042C89.5099%2029.1042%2089.9189%2029.1695%2090.1474%2029.25L89.9516%2032.6267C89.6252%2032.5462%2089.2184%2032.4635%2088.8267%2032.4635C87.7998%2032.4635%2087.195%2033.0509%2087.195%2034.2084V39.33H83.6399Z%22%20fill%3D%22%23002751%22%2F%3E%3Cpath%20d%3D%22M99.4941%2039.4604C98.8588%2039.4604%2098.2714%2039.3473%2097.7819%2038.9709L97.7318%2038.9883L97.7645%2040.3089V41.8254H94.2246V29.3478L96.6723%2029.2021L97.2749%2029.9026C97.895%2029.4131%2098.6935%2029.1194%2099.5268%2029.1194C101.826%2029.1194%20103.099%2030.4074%20103.099%2034.2888C103.097%2037.6328%20101.679%2039.4604%2099.4941%2039.4604ZM98.5477%2032.087C98.2214%2032.087%2097.9124%2032.2828%2097.7645%2032.5439V36.1643C97.9429%2036.4732%2098.1887%2036.669%2098.5151%2036.669C99.1025%2036.669%2099.4289%2036.3427%2099.4289%2034.2061C99.4289%2032.446%2099.2809%2032.087%2098.5477%2032.087Z%22%20fill%3D%22%23002751%22%2F%3E%3Cpath%20d%3D%22M108.937%2038.6119C108.349%2039.182%20107.583%2039.4931%20106.637%2039.4931C104.794%2039.4931%20103.637%2038.3356%20103.637%2036.0686C103.637%2034.1931%20104.975%2032.8398%20107.013%2032.8398C107.601%2032.8398%20107.975%2032.9051%20108.367%2032.9856V32.8398C108.367%2032.3351%20108.058%2031.9761%20107.013%2031.9761C105.969%2031.9761%20105.414%2032.1219%20104.518%2032.4482L104.242%2029.7417C105.221%2029.3348%20106.411%2029.1216%20107.699%2029.1216C110.847%2029.1216%20111.874%2030.4596%20111.874%2033.3294V39.3321H109.167L108.937%2038.6119ZM107.829%2025.6775C109.559%2025.6775%20110.242%2026.3302%20110.242%2027.2766C110.242%2028.3862%20109.557%2028.8583%20107.829%2028.8583C106.215%2028.8583%20105.447%2028.4515%20105.447%2027.2766C105.447%2026.2976%20106.034%2025.6775%20107.829%2025.6775ZM108.367%2035.2527C108.171%2035.2026%20107.975%2035.17%20107.699%2035.17C107.209%2035.17%20106.966%2035.4137%20106.966%2036.0338C106.966%2036.5711%20107.194%2036.7996%20107.601%2036.7996C108.008%2036.7996%20108.367%2036.5886%20108.367%2036.1317V35.2527ZM107.877%2027.6508C108.447%2027.6508%20108.628%2027.5529%20108.628%2027.2918C108.628%2027.0482%20108.512%2026.9176%20107.877%2026.9176C107.224%2026.9176%20107.111%2027.0482%20107.111%2027.2918C107.111%2027.5203%20107.209%2027.6508%20107.877%2027.6508Z%22%20fill%3D%22%23002751%22%2F%3E%3Cpath%20d%3D%22M125.931%2029.2826L122.881%2039.3299H118.688L115.688%2029.2826H119.504L120.531%2034.452L120.775%2035.74H120.825L121.053%2034.452L122.113%2029.2826H125.931Z%22%20fill%3D%22%23002751%22%2F%3E%3Cpath%20d%3D%22M125.802%2034.2888C125.802%2030.9774%20127.188%2029.1194%20130.271%2029.1194C132.93%2029.1194%20134.399%2030.5706%20134.399%2033.7688C134.399%2034.3062%20134.366%2034.9263%20134.301%2035.4158H129.473C129.619%2036.2469%20130.191%2036.5733%20131.381%2036.5733C132.212%2036.5733%20133.028%2036.458%20133.811%2036.2317L134.185%2038.9557C133.42%2039.2494%20132.195%2039.4931%20130.939%2039.4931C127.434%2039.4931%20125.802%2037.6329%20125.802%2034.2888ZM131.135%2033.1488C131.102%2032.2197%20130.874%2031.926%20130.304%2031.926C129.684%2031.926%20129.506%2032.1066%20129.423%2033.1488H131.135Z%22%20fill%3D%22%23002751%22%2F%3E%3Cpath%20d%3D%22M137.171%2028.8104C135.898%2028.8104%20135.295%2028.4362%20135.295%2027.4898C135.295%2026.6086%20135.898%2026.1517%20137.171%2026.1517C138.476%2026.1517%20139.031%2026.6086%20139.031%2027.4898C139.031%2028.3535%20138.476%2028.8104%20137.171%2028.8104ZM135.36%2039.3299V29.3652L138.981%2029.2195V39.332H135.36V39.3299Z%22%20fill%3D%22%23002751%22%2F%3E%3Cpath%20d%3D%22M141.918%2039.5257C140.58%2039.5257%20140.01%2039.021%20140.01%2037.7808C140.01%2036.6712%20140.58%2036.0033%20141.918%2036.0033C143.238%2036.0033%20143.811%2036.6712%20143.811%2037.7808C143.809%2038.8252%20143.238%2039.5257%20141.918%2039.5257Z%22%20fill%3D%22%23002751%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0%22%3E%3Crect%20width%3D%22149.354%22%20height%3D%2248%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

function _EMOTION_STRINGIFIED_CSS_ERROR__$A() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var RowCentered = /*#__PURE__*/createStyled(Row$2, "development" === "production" ? {
  target: "eyxtkj82"
} : {
  target: "eyxtkj82",
  label: "RowCentered"
})("development" === "production" ? {
  name: "1h3rtzg",
  styles: "align-items:center"
} : {
  name: "1h3rtzg",
  styles: "align-items:center",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$A
});
var PTopMargin = /*#__PURE__*/createStyled(SpanFull, "development" === "production" ? {
  target: "eyxtkj81"
} : {
  target: "eyxtkj81",
  label: "PTopMargin"
})("development" === "production" ? {
  name: "xda5ep",
  styles: "margin-top:12px"
} : {
  name: "xda5ep",
  styles: "margin-top:12px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$A
});
var InvoiceAlternative = createStyled("div", "development" === "production" ? {
  target: "eyxtkj80"
} : {
  target: "eyxtkj80",
  label: "InvoiceAlternative"
})("development" === "production" ? {
  name: "9rxt3v",
  styles: "font-family:\"ClanOT News\";font-size:13px;font-weight:700;margin-top:7rem"
} : {
  name: "9rxt3v",
  styles: "font-family:\"ClanOT News\";font-size:13px;font-weight:700;margin-top:7rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$A
});
function StepTwo$1(props) {
  var _state$collapseStates;
  var onValueUpdate = props.onValueUpdate,
    onNextStep = props.onNextStep,
    state = props.state,
    setState = props.setState,
    onCollapse = props.onCollapse;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Legend, {
    brandStyle: "yx"
  }, "Kundeinformasjon"), /*#__PURE__*/React__default.createElement(MorePersonalia, {
    state: state,
    onValueUpdate: onValueUpdate,
    brandStyle: "yx"
  }), /*#__PURE__*/React__default.createElement(Legend, {
    brandStyle: "yx"
  }, "Inntekt"), /*#__PURE__*/React__default.createElement(SimpleEconomy, {
    onValueUpdate: onValueUpdate,
    state: state,
    brandStyle: "yx"
  }), /*#__PURE__*/React__default.createElement(Legend, {
    brandStyle: "yx"
  }, "Gjeld: Boligl\xE5n"), /*#__PURE__*/React__default.createElement(MultipleLoan, {
    onValueUpdate: onValueUpdate,
    onCollapse: onCollapse,
    state: state,
    setState: setState,
    loanId: "houseLoan",
    brandStyle: "yx"
  }), /*#__PURE__*/React__default.createElement(Legend, {
    brandStyle: "yx"
  }, "Gjeld: Studiel\xE5n"), /*#__PURE__*/React__default.createElement(StudentLoan, {
    onValueUpdate: onValueUpdate,
    onCollapse: onCollapse,
    state: state,
    loanId: "studentLoan",
    brandStyle: "yx"
  }), /*#__PURE__*/React__default.createElement(Legend, {
    brandStyle: "yx"
  }, "Gjeld: Bill\xE5n"), /*#__PURE__*/React__default.createElement(MultipleLoan, {
    onValueUpdate: onValueUpdate,
    onCollapse: onCollapse,
    state: state,
    setState: setState,
    loanId: "carLoan",
    brandStyle: "yx"
  }), /*#__PURE__*/React__default.createElement(Legend, {
    brandStyle: "yx"
  }, "Gjeld: Inkasso"), /*#__PURE__*/React__default.createElement(DebtCollection, {
    onValueUpdate: onValueUpdate,
    state: state,
    brandStyle: "yx"
  }), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Dropdown, {
    id: "wantedCreditLimit",
    label: "Ønsket kredittramme",
    options: [{
      value: "Velg",
      label: "Velg..."
    }, {
      value: "5000",
      label: "5 000 kr"
    }, {
      value: "10000",
      label: "10 000 kr"
    }, {
      value: "15000",
      label: "15 000 kr"
    }, {
      value: "25000",
      label: "25 000 kr"
    }, {
      value: "50000",
      label: "50 000 kr"
    }, {
      value: "75000",
      label: "75 000 kr"
    }, {
      value: "100000",
      label: "100 000 kr"
    }],
    selected: state.wantedCreditLimit,
    onchange: onValueUpdate,
    showError: state.wantedCreditLimitError,
    brandStyle: "yx"
  }))), /*#__PURE__*/React__default.createElement(RowCentered, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(ButtonPre, {
    brandStyle: "yx",
    label: state.tillegskort ? "Fjern tilleggskort" : "Legg til tilleggskort",
    onclick: function onclick() {
      setState(function (prevState) {
        return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
          tillegskort: !state.tillegskort
        });
      });
    },
    pre: state.tillegskort ? "-" : "+"
  })), /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(PTopMargin, null, "Er dere flere? Les om fordelene med tilleggskort.", /*#__PURE__*/React__default.createElement(Popover, {
    id: "popover-tillegskort",
    text: "Med tilleggskort f\xE5r dere samlet alle kj\xF8p p\xE5 \xE8n faktura. Tilleggskort er kostnadsfritt \xE5 bestille og har de samme gode fordelene.",
    brandStyle: "yx"
  })))), /*#__PURE__*/React__default.createElement(Collapse, {
    isOpen: state.tillegskort === true,
    appear: ((_state$collapseStates = state.collapseStates) === null || _state$collapseStates === void 0 ? void 0 : _state$collapseStates.tillegskort) !== "ENTERED",
    onEntered: function onEntered() {
      return onCollapse("ENTERED", "tillegskort");
    },
    onExited: function onExited() {
      return onCollapse("CLOSED", "tillegskort");
    }
  }, /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: "nameAdditionalCardHolder",
    type: "text",
    title: "Fullt navn p\xE5 den som skal ha tilleggskortet",
    placeholder: "Fornavn, mellom- og etternavn",
    onblur: onValueUpdate,
    value: state.nameAdditionalCardHolder,
    showError: state.nameAdditionalCardHolderError,
    brandStyle: "yx"
  }))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: "ssnAdditionalCardHolder",
    type: "text",
    title: "F\xF8dselsnummer p\xE5 den som skal ha tilleggskortet",
    placeholder: "11 siffer",
    onblur: onValueUpdate,
    value: state.ssnAdditionalCardHolder,
    showError: state.ssnAdditionalCardHolderError,
    brandStyle: "yx"
  })))), /*#__PURE__*/React__default.createElement(Legend, {
    brandStyle: "yx"
  }, "Annet"), /*#__PURE__*/React__default.createElement(InvoiceAlternative, null, "Faktureringsalternativer"), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Radio, {
    topMargin: false,
    id: "paymentMethod",
    label: "Hvis du vanligvis mottar eFaktura, vil du automatisk f\xE5 det fra oss. I tilfelle noe skulle g\xE5 galt, eller du ikke har eFaktura, velg ett av faktureringsalternativene nedenfor.",
    options: [{
      value: "EMAIL",
      label: "Faktura per e-post (gratis)",
      checked: state.paymentMethod === "EMAIL"
    }, {
      value: "BANK",
      label: "Papirfaktura per post (14,76 kr)",
      checked: state.paymentMethod === "BANK"
    }],
    onchange: onValueUpdate,
    showError: state.paymentMethodError,
    brandStyle: "yx"
  })), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
    id: "accept",
    value: state.accept === "on" ? "off" : "on",
    checked: state.accept === "on",
    onchange: function onchange(e) {
      return onValueUpdate(e, "accept");
    },
    showError: state.acceptError,
    disableLabelClick: true,
    brandStyle: "yx"
  }, /*#__PURE__*/React__default.createElement("span", null, "Jeg aksepterer at det blir foretatt en "), /*#__PURE__*/React__default.createElement(ALink, {
    brandStyle: "yx",
    href: "https://documenthandler.resurs.com/Dokument.pdf?customerType=NATURAL&docType=Kredittvurdering-utsendelse-av-gjenpartsbrev-for-forbrukslan-innskudd-ya-kredittkort&land=NO&language=no",
    target: "_blank",
    rel: "noreferrer"
  }, "kredittvurdering og at utsendelse av gjenpartsbrev foreg\xE5r elektronisk der dette er praktisk mulig"))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Button, {
    label: "G\xE5 videre",
    disabled: !!state.apiStatus.loading,
    onclick: onNextStep,
    showError: state.button2Error,
    brandStyle: "yx"
  })));
}
StepTwo$1.propTypes = {
  onValueUpdate: PropTypes.func.isRequired,
  onNextStep: PropTypes.func.isRequired,
  onCollapse: PropTypes.func.isRequired,
  setState: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  state: PropTypes.object.isRequired
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$z() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var H2$1 = createStyled("h3", "development" === "production" ? {
  target: "e1v77wtm1"
} : {
  target: "e1v77wtm1",
  label: "H2"
})("development" === "production" ? {
  name: "9uo1ou",
  styles: "margin-bottom:10px;color:#1c1c1b"
} : {
  name: "9uo1ou",
  styles: "margin-bottom:10px;color:#1c1c1b",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$z
});
var Container$5 = createStyled("div", "development" === "production" ? {
  target: "e1v77wtm0"
} : {
  target: "e1v77wtm0",
  label: "Container"
})("development" === "production" ? {
  name: "19jwy0r",
  styles: "padding:1rem;font-family:\"ClanOT News\""
} : {
  name: "19jwy0r",
  styles: "padding:1rem;font-family:\"ClanOT News\"",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$z
});
function StepThree$1(props) {
  var apiStatus = props.apiStatus;
  var code = apiStatus.code,
    application = apiStatus.application;
  if (code === 200) {
    return /*#__PURE__*/React__default.createElement(Container$5, null, /*#__PURE__*/React__default.createElement(H2$1, null, "Gratulerer!"), /*#__PURE__*/React__default.createElement("p", null, "Du har f\xE5tt innvilget din s\xF8knad om YX Kredittkort med en kredittramme p\xE5 kr", " ", /*#__PURE__*/React__default.createElement("b", null, application.appliedAmount)), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("p", null, "Kredittrammen er gitt under forutsetningen av at de opplysninger du har oppgitt er korrekte."), /*#__PURE__*/React__default.createElement(Button, {
      brandStyle: "yx",
      label: "Start signering",
      onclick: function onclick() {
        var _application$mainAppl, _application$mainAppl2;
        window.location.href = (_application$mainAppl = application.mainApplicantApplication) === null || _application$mainAppl === void 0 ? void 0 : (_application$mainAppl2 = _application$mainAppl.applicant) === null || _application$mainAppl2 === void 0 ? void 0 : _application$mainAppl2.signingUrl;
      }
    }), /*#__PURE__*/React__default.createElement("p", null, "Du vil f\xE5 tilsendt en e-post med link til signering, eller du kan signere med BankID allerede n\xE5 ved \xE5 trykke p\xE5 knappen over."), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("p", null, "Vennlig hilsen YX"));
  }
  return /*#__PURE__*/React__default.createElement(Container$5, null, /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Legend, {
    brandStyle: "yx"
  }, "Finner ikke siden")), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement("p", null, "Beklager, vi finner ikke siden du fors\xF8kte \xE5 n\xE5."), /*#__PURE__*/React__default.createElement("p", null, "Kontakt oss hvis du mener dette er en feil."))));
}
StepThree$1.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  apiStatus: PropTypes.object.isRequired
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$y() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Main = createStyled("div", "development" === "production" ? {
  target: "e1k2wmcg5"
} : {
  target: "e1k2wmcg5",
  label: "Main"
})("font-family:Arial,sans-serif;background-color:", colors$1.white, ";width:100%;" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Header$2 = createStyled("header", "development" === "production" ? {
  target: "e1k2wmcg4"
} : {
  target: "e1k2wmcg4",
  label: "Header"
})("background-color:", colors$1.white, ";width:100%;padding:12px 20px;" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Container$4 = createStyled("div", "development" === "production" ? {
  target: "e1k2wmcg3"
} : {
  target: "e1k2wmcg3",
  label: "Container"
})("development" === "production" ? {
  name: "11fdagd",
  styles: "max-width:610px;padding:1rem"
} : {
  name: "11fdagd",
  styles: "max-width:610px;padding:1rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$y
});
var BoldContainer = /*#__PURE__*/createStyled(Container$4, "development" === "production" ? {
  target: "e1k2wmcg2"
} : {
  target: "e1k2wmcg2",
  label: "BoldContainer"
})("development" === "production" ? {
  name: "3u31mn",
  styles: "font-family:\"ClanOT Bold\""
} : {
  name: "3u31mn",
  styles: "font-family:\"ClanOT Bold\"",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$y
});
var StepPagination$1 = createStyled("p", "development" === "production" ? {
  target: "e1k2wmcg1"
} : {
  target: "e1k2wmcg1",
  label: "StepPagination"
})("development" === "production" ? {
  name: "1yjqs49",
  styles: "font-size:15px;margin-bottom:0px"
} : {
  name: "1yjqs49",
  styles: "font-size:15px;margin-bottom:0px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$y
});
var YxLogo = createStyled("img", "development" === "production" ? {
  target: "e1k2wmcg0"
} : {
  target: "e1k2wmcg0",
  label: "YxLogo"
})("development" === "production" ? {
  name: "1aa6tmo",
  styles: "position:relative;max-height:77px"
} : {
  name: "1aa6tmo",
  styles: "position:relative;max-height:77px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$y
});
function YXVisa$1(props) {
  var prefilled = props.prefilled,
    baseApiUrl = props.baseApiUrl;
  var _useState = useState({
      currentStep: 0,
      tillegskort: false,
      collapseStates: {},
      apiStatus: {
        loading: false
      },
      // Base
      productType: "YX_CARD",
      schema: "/schema/productApplication_v30.xsd",
      // Step: 1
      name: prefilled ? "Karl Olsen" : "",
      nameError: "",
      ssn: prefilled ? "17065349957" : "",
      ssnError: "",
      email: prefilled ? "yabank@gmail.com" : undefined,
      emailError: "",
      emailRepeat: prefilled ? "yabank@gmail.com" : undefined,
      emailRepeatError: "",
      mobilNo: prefilled ? "13345678" : "",
      mobilNoError: "",
      button1Error: "",
      // Step: 2
      civilStatus: prefilled ? "SEPARATED" : "Velg",
      civilStatusError: "",
      noOfChildren: prefilled ? "0" : "Velg",
      noOfChildrenError: "",
      habitat: prefilled ? "OWNED" : "Velg",
      habitatError: "",
      education: prefilled ? "UNIVERSITY_LONG" : "Velg",
      educationError: "",
      employmentSituation: prefilled ? "RETIRED" : "Velg",
      employmentSituationError: "",
      grossIncomeYearly: prefilled ? 900000 : undefined,
      grossIncomeYearlyError: "",
      hasDebtCollection: prefilled ? false : undefined,
      hasDebtCollectionError: "",
      wantedCreditLimit: prefilled ? "15000" : "Velg",
      wantedCreditLimitError: "",
      nameAdditionalCardHolder: undefined,
      nameAdditionalCardHolderError: "",
      ssnAdditionalCardHolder: undefined,
      ssnAdditionalCardHolderError: "",
      paymentMethod: prefilled ? "EMAIL" : undefined,
      paymentMethodError: "",
      accept: prefilled ? "on" : "off",
      acceptError: "",
      button2Error: "",
      houseLoan: prefilled ? "on" : "off",
      houseLoanError: "",
      houseLoanInputFieldLoanAmount: prefilled ? [123, 234] : [""],
      houseLoanInputFieldMonthlyPayment: prefilled ? [123, 234] : [""],
      carLoan: "off",
      carLoanError: "",
      carLoanInputFieldLoanAmount: [""],
      carLoanInputFieldMonthlyPayment: [""],
      studentLoan: "off",
      studentLoanError: "",
      studentLoanInputFieldLoanAmount: undefined,
      studentLoanInputFieldLoanAmountError: "",
      studentLoanInputFieldMonthlyPayment: undefined,
      studentLoanInputFieldMonthlyPaymentError: "",
      extraIncome: prefilled ? 1 : undefined,
      extraIncomeError: "",
      isDeadEndError: false
    }),
    _useState2 = _slicedToArray$2(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useScrollToTop(state.currentStep, state.isDeadEndError);
  useEffect(function () {
    if (state.apiStatus.loading) return;
    var isStep1 = !state.apiStatus.isDeadEndError && state.currentStep === 0;
    var isStep2 = !state.apiStatus.isDeadEndError && state.currentStep === 1 || state.apiStatus.isDeadEndError && state.currentStep === 0;
    var isStep3 = !state.apiStatus.isDeadEndError && state.currentStep === 2 || state.apiStatus.isDeadEndError && state.currentStep === 1;
    if (isStep1) {
      gtmEventService().yxVisa().pushStepOne();
    }
    if (isStep2) {
      var _state$apiStatus$appl;
      gtmEventService().yxVisa().pushStepTwo((_state$apiStatus$appl = state.apiStatus.application) === null || _state$apiStatus$appl === void 0 ? void 0 : _state$apiStatus$appl.applicationState, state.apiStatus.message);
    }
    if (isStep3) {
      gtmEventService().yxVisa().pushStepThree(state.apiStatus.application.applicationId, state.apiStatus.application.applicationState, state.apiStatus.message);
    }
  }, [state.currentStep, state.apiStatus]);
  var onValueUpdate = function onValueUpdate(event, id) {
    event.preventDefault();
    var value = event.target.value;
    // convert true/false string to a boolean value
    if (value === "true" || value === "false") {
      value = value === "true";
    }

    // Handle array inputs - for example usage: carLoanInputFieldLoanAmount-1 [value-index]
    var split = id.split("-");
    if (split.length && split.length === 2) {
      var name = split[0];
      var index = Number(split[1]);
      var result = validateValue(name, value, state, index);
      setState(function (prevState) {
        var _objectSpread2;
        var a = prevState[name];
        a["".concat(index)] = value;
        return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, (_objectSpread2 = {}, _defineProperty$5(_objectSpread2, result.errorFieldName || "".concat(id, "Error"), result.errMsg || ""), _defineProperty$5(_objectSpread2, name, _toConsumableArray$3(a)), _objectSpread2));
      });
    } else {
      var _result = validateValue(id, value, state);
      setState(function (prevState) {
        var _objectSpread3;
        return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, (_objectSpread3 = {}, _defineProperty$5(_objectSpread3, _result.errorFieldName || "".concat(id, "Error"), _result.errMsg || ""), _defineProperty$5(_objectSpread3, id, value), _objectSpread3));
      });
    }
  };
  var validateField = function validateField(id) {
    var value = state[id];

    // state: array objects
    if (_typeof$3(value) === "object") {
      var okArray = value.map(function (v, index) {
        var result = validateValue(id, v, state, index);
        setState(function (prevState) {
          return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, _defineProperty$5({}, result.errorFieldName || "".concat(id, "Error"), result.errMsg || ""));
        });
        return result.ok;
      });
      return !okArray.includes(false);
    }
    var result = validateValue(id, value, state);
    setState(function (prevState) {
      return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, _defineProperty$5({}, result.errorFieldName || "".concat(id, "Error"), result.errMsg || ""));
    });
    return result.ok;
  };
  var onNextStep = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var name, ssn, email, emailRepeat, mobilNo, formValues, result, isOK, civilStatus, noOfChildren, habitat, education, employmentSituation, grossIncomeYearly, extraIncome, hasDebtCollection, wantedCreditLimit, nameAdditionalCardHolder, ssnAdditionalCardHolder, paymentMethod, accept, houseLoan, houseLoanInputFieldLoanAmount, houseLoanInputFieldMonthlyPayment, studentLoan, studentLoanInputFieldLoanAmount, studentLoanInputFieldMonthlyPayment, carLoan, carLoanInputFieldLoanAmount, carLoanInputFieldMonthlyPayment, _formValues, _result2;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(state.currentStep === 0)) {
                _context.next = 17;
                break;
              }
              // Validate fields for 1st step
              name = validateField("name");
              ssn = validateField("ssn");
              email = validateField("email");
              emailRepeat = validateField("emailRepeat");
              mobilNo = validateField("mobilNo");
              if (!(!name || !ssn || !email || !emailRepeat || !mobilNo)) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return");
            case 8:
              setState(function (prevState) {
                return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
                  button1Error: "",
                  apiStatus: {
                    loading: true
                  }
                });
              });
              formValues = {
                productType: state.productType,
                schema: state.schema,
                name: state.name,
                ssn: state.ssn,
                email: state.email,
                mobilNo: state.mobilNo
              };
              UTM_PARAM_KEYS.forEach(function (paramKey) {
                var utmValue = props[paramKey];
                if (utmValue) {
                  formValues[paramKey] = utmValue;
                }
              });
              _context.next = 13;
              return stepOnePost(formValues, baseApiUrl);
            case 13:
              result = _context.sent;
              setState(function (prevState) {
                return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
                  currentStep: result.ok ? state.currentStep + 1 : state.currentStep,
                  button1Error: result.ok ? "" : result.message,
                  isDeadEndError: result.isDeadEndError,
                  apiStatus: _objectSpread2$4({
                    loading: false
                  }, result)
                });
              });
              _context.next = 50;
              break;
            case 17:
              if (!(state.currentStep === 1)) {
                _context.next = 50;
                break;
              }
              // Validate fields for 2nd step
              isOK = true;
              civilStatus = validateField("civilStatus");
              noOfChildren = validateField("noOfChildren");
              habitat = validateField("habitat");
              education = validateField("education");
              employmentSituation = validateField("employmentSituation");
              grossIncomeYearly = validateField("grossIncomeYearly");
              extraIncome = validateField("extraIncome");
              hasDebtCollection = validateField("hasDebtCollection");
              wantedCreditLimit = validateField("wantedCreditLimit");
              if (state.tillegskort) {
                nameAdditionalCardHolder = validateField("nameAdditionalCardHolder");
                ssnAdditionalCardHolder = validateField("ssnAdditionalCardHolder");
                if (!nameAdditionalCardHolder || !ssnAdditionalCardHolder) {
                  isOK = false;
                }
              }
              paymentMethod = validateField("paymentMethod");
              accept = validateField("accept");
              houseLoan = validateField("houseLoan"); // houseLoan extra fields
              if (state.houseLoan === "on") {
                houseLoanInputFieldLoanAmount = validateField("houseLoanInputFieldLoanAmount");
                houseLoanInputFieldMonthlyPayment = validateField("houseLoanInputFieldMonthlyPayment");
                if (!houseLoanInputFieldLoanAmount || !houseLoanInputFieldMonthlyPayment) {
                  isOK = false;
                }
              }
              studentLoan = validateField("studentLoan"); // studentLoan extra fields
              if (state.studentLoan === "on") {
                studentLoanInputFieldLoanAmount = validateField("studentLoanInputFieldLoanAmount");
                studentLoanInputFieldMonthlyPayment = validateField("studentLoanInputFieldMonthlyPayment");
                if (!studentLoanInputFieldLoanAmount || !studentLoanInputFieldMonthlyPayment) {
                  isOK = false;
                }
              }
              carLoan = validateField("carLoan"); // carLoan extra fields
              if (state.carLoan === "on") {
                carLoanInputFieldLoanAmount = validateField("carLoanInputFieldLoanAmount");
                carLoanInputFieldMonthlyPayment = validateField("carLoanInputFieldMonthlyPayment");
                if (!carLoanInputFieldLoanAmount || !carLoanInputFieldMonthlyPayment) {
                  isOK = false;
                }
              }
              if (!civilStatus || !noOfChildren || !habitat || !education || !employmentSituation || !grossIncomeYearly || !extraIncome || !houseLoan || !studentLoan || !carLoan || !hasDebtCollection || !wantedCreditLimit || !paymentMethod || !accept) {
                isOK = false;
              }
              if (isOK) {
                _context.next = 40;
                break;
              }
              return _context.abrupt("return");
            case 40:
              setState(function (prevState) {
                return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
                  button2Error: "",
                  apiStatus: {
                    loading: true
                  }
                });
              });
              _formValues = {
                productType: state.productType,
                schema: state.schema,
                // step 1
                name: state.name,
                ssn: state.ssn,
                email: state.email,
                mobilNo: state.mobilNo,
                // step 2
                civilStatus: state.civilStatus,
                noOfChildren: state.noOfChildren,
                habitat: state.habitat,
                education: state.education,
                employmentSituation: state.employmentSituation,
                grossIncomeYearly: state.grossIncomeYearly,
                extraIncome: state.extraIncome,
                hasDebtCollection: state.hasDebtCollection,
                wantedCreditLimit: state.wantedCreditLimit,
                nameAdditionalCardHolder: state.tillegskort ? state.nameAdditionalCardHolder : "",
                ssnAdditionalCardHolder: state.tillegskort ? state.ssnAdditionalCardHolder : "",
                paymentMethod: state.paymentMethod
              };
              if (state.houseLoan === "on") {
                _formValues.houseLoanInputFieldLoanAmount = state.houseLoanInputFieldLoanAmount;
                _formValues.houseLoanInputFieldMonthlyPayment = state.houseLoanInputFieldMonthlyPayment;
              }
              if (state.studentLoan === "on") {
                _formValues.studentLoanInputFieldLoanAmount = [state.studentLoanInputFieldLoanAmount]; // backend expects array even though its only one value
                _formValues.studentLoanInputFieldMonthlyPayment = [state.studentLoanInputFieldMonthlyPayment];
              }
              if (state.carLoan === "on") {
                _formValues.carLoanInputFieldLoanAmount = state.carLoanInputFieldLoanAmount;
                _formValues.carLoanInputFieldMonthlyPayment = state.carLoanInputFieldMonthlyPayment;
              }
              UTM_PARAM_KEYS.forEach(function (paramKey) {
                var utmValue = props[paramKey];
                if (utmValue) {
                  _formValues[paramKey] = utmValue;
                }
              });
              // Send form with validated values
              _context.next = 48;
              return submitYxVisaCardApplication(_formValues, baseApiUrl);
            case 48:
              _result2 = _context.sent;
              setState(function (prevState) {
                return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
                  currentStep: _result2.ok ? state.currentStep + 1 : state.currentStep,
                  button2Error: _result2.ok ? "" : _result2.message,
                  isDeadEndError: _result2.isDeadEndError,
                  apiStatus: _objectSpread2$4({
                    loading: false
                  }, _result2)
                });
              });
            case 50:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function onNextStep() {
      return _ref.apply(this, arguments);
    };
  }();
  var onCollapse = function onCollapse(collapseState, id) {
    setState(function (prevState) {
      return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
        collapseStates: _objectSpread2$4(_objectSpread2$4({}, state.collapseStates), {}, _defineProperty$5({}, id, collapseState))
      });
    });
  };
  var bodyWrapper = function bodyWrapper(node) {
    return /*#__PURE__*/React__default.createElement(Main, null, /*#__PURE__*/React__default.createElement(Header$2, null, /*#__PURE__*/React__default.createElement(YxLogo, {
      src: Logo,
      alt: "YX Visa Logo"
    })), /*#__PURE__*/React__default.createElement(SystemStatus, {
      cmsHelperUrl: props.baseApiUrl
    }, /*#__PURE__*/React__default.createElement(Container$4, null, node)));
  };
  if (state.isDeadEndError) {
    return bodyWrapper( /*#__PURE__*/React__default.createElement(DeadEndView, {
      productType: state.productType,
      code: state.apiStatus.code,
      message: state.apiStatus.message
    }));
  }
  return bodyWrapper( /*#__PURE__*/React__default.createElement(BoldContainer, null, /*#__PURE__*/React__default.createElement(Steps, {
    brandStyle: "yx",
    labels: ["Personalia", "Din økonomi", "Resultat"],
    currentStep: state.currentStep
  }), state.currentStep === 0 && /*#__PURE__*/React__default.createElement(CardStepOne, {
    onValueUpdate: onValueUpdate,
    onNextStep: onNextStep,
    state: state,
    brandStyle: "yx"
  }), state.currentStep === 1 && /*#__PURE__*/React__default.createElement(StepTwo$1, {
    onValueUpdate: onValueUpdate,
    onNextStep: onNextStep,
    onCollapse: onCollapse,
    setState: setState,
    state: state
  }), state.currentStep === 2 && /*#__PURE__*/React__default.createElement(StepThree$1, {
    apiStatus: state.apiStatus
  }), state.apiStatus.loading && /*#__PURE__*/React__default.createElement(LoadingOverlay, {
    brandStyle: "yx"
  }), state.currentStep < 2 && /*#__PURE__*/React__default.createElement(StepPagination$1, null, "Steg ", state.currentStep + 1, " av 3")));
}
YXVisa$1.propTypes = {
  prefilled: PropTypes.bool,
  campaignId: PropTypes.string,
  gclid: PropTypes.string,
  utm_campaign: PropTypes.string,
  utm_content: PropTypes.string,
  utm_medium: PropTypes.string,
  utm_source: PropTypes.string,
  utm_term: PropTypes.string,
  baseApiUrl: PropTypes.string.isRequired
};
YXVisa$1.defaultProps = {
  prefilled: false
};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_debounce = debounce;

function _EMOTION_STRINGIFIED_CSS_ERROR__$x() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var StyledBigText = createStyled("h3", "development" === "production" ? {
  target: "e167e4cf0"
} : {
  target: "e167e4cf0",
  label: "StyledBigText"
})("development" === "production" ? {
  name: "1pgsh9i",
  styles: "font-size:23px;line-height:1.3;font-weight:400"
} : {
  name: "1pgsh9i",
  styles: "font-size:23px;line-height:1.3;font-weight:400",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN0eWxlZEJpZ1RleHQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRStCIiwiZmlsZSI6IlN0eWxlZEJpZ1RleHQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIjtcblxuY29uc3QgU3R5bGVkQmlnVGV4dCA9IHN0eWxlZC5oM2BcbiAgZm9udC1zaXplOiAyM3B4O1xuICBsaW5lLWhlaWdodDogMS4zO1xuICBmb250LXdlaWdodDogNDAwO1xuYDtcblxuZXhwb3J0IGRlZmF1bHQgU3R5bGVkQmlnVGV4dDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$x
});

function Slider(_ref) {
  var min = _ref.min,
    max = _ref.max,
    value = _ref.value,
    step = _ref.step,
    inputChanged = _ref.inputChanged;
  return /*#__PURE__*/React__default.createElement(StyledInput$1, {
    type: "range",
    min: min,
    max: max,
    value: value,
    step: step,
    onInput: function onInput(event) {
      inputChanged(event.target.value);
    },
    onChange: function onChange() {}
  });
}
Slider.propTypes = {
  /**
   * The minimum value
   */
  min: PropTypes.number.isRequired,
  /**
   * The maximum value
   */
  max: PropTypes.number.isRequired,
  /**
   * The starting value
   */
  value: PropTypes.number.isRequired,
  /**
   * The callback function
   */
  inputChanged: PropTypes.func.isRequired
};
var StyledInput$1 = createStyled("input", "development" === "production" ? {
  target: "ee2wbx00"
} : {
  target: "ee2wbx00",
  label: "StyledInput"
})("-webkit-appearance:none;width:100%;height:6px;outline:none;-webkit-transition:0.2s;transition:opacity 0.2s;background:", colors$1.secondaryGreen, ";&::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:30px;height:30px;background:", colors$1.primaryGreen, ";cursor:pointer;}&::-moz-range-thumb{width:30px;height:30px;background:", colors$1.primaryGreen, ";cursor:pointer;}" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNsaWRlci5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBeUNnQyIsImZpbGUiOiJTbGlkZXIuanN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyogZXNsaW50LWRpc2FibGUgcmVhY3QvcHJvcC10eXBlcyAqL1xuaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCI7XG5pbXBvcnQgY29sb3JzIGZyb20gXCIuLi8uLi9jb2xvcnNcIjtcblxuZnVuY3Rpb24gU2xpZGVyKHsgbWluLCBtYXgsIHZhbHVlLCBzdGVwLCBpbnB1dENoYW5nZWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxTdHlsZWRJbnB1dFxuICAgICAgdHlwZT1cInJhbmdlXCJcbiAgICAgIG1pbj17bWlufVxuICAgICAgbWF4PXttYXh9XG4gICAgICB2YWx1ZT17dmFsdWV9XG4gICAgICBzdGVwPXtzdGVwfVxuICAgICAgb25JbnB1dD17KGV2ZW50KSA9PiB7XG4gICAgICAgIGlucHV0Q2hhbmdlZChldmVudC50YXJnZXQudmFsdWUpO1xuICAgICAgfX1cbiAgICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgICAvPlxuICApO1xufVxuXG5TbGlkZXIucHJvcFR5cGVzID0ge1xuICAvKipcbiAgICogVGhlIG1pbmltdW0gdmFsdWVcbiAgICovXG4gIG1pbjogUHJvcFR5cGVzLm51bWJlci5pc1JlcXVpcmVkLFxuICAvKipcbiAgICogVGhlIG1heGltdW0gdmFsdWVcbiAgICovXG4gIG1heDogUHJvcFR5cGVzLm51bWJlci5pc1JlcXVpcmVkLFxuICAvKipcbiAgICogVGhlIHN0YXJ0aW5nIHZhbHVlXG4gICAqL1xuICB2YWx1ZTogUHJvcFR5cGVzLm51bWJlci5pc1JlcXVpcmVkLFxuICAvKipcbiAgICogVGhlIGNhbGxiYWNrIGZ1bmN0aW9uXG4gICAqL1xuICBpbnB1dENoYW5nZWQ6IFByb3BUeXBlcy5mdW5jLmlzUmVxdWlyZWQsXG59O1xuXG5jb25zdCBTdHlsZWRJbnB1dCA9IHN0eWxlZC5pbnB1dGBcbiAgLXdlYmtpdC1hcHBlYXJhbmNlOiBub25lO1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiA2cHg7XG4gIG91dGxpbmU6IG5vbmU7XG4gIC13ZWJraXQtdHJhbnNpdGlvbjogMC4ycztcbiAgdHJhbnNpdGlvbjogb3BhY2l0eSAwLjJzO1xuICBiYWNrZ3JvdW5kOiAke2NvbG9ycy5zZWNvbmRhcnlHcmVlbn07XG5cbiAgJjo6LXdlYmtpdC1zbGlkZXItdGh1bWIge1xuICAgIC13ZWJraXQtYXBwZWFyYW5jZTogbm9uZTtcbiAgICBhcHBlYXJhbmNlOiBub25lO1xuICAgIHdpZHRoOiAzMHB4O1xuICAgIGhlaWdodDogMzBweDtcbiAgICBiYWNrZ3JvdW5kOiAke2NvbG9ycy5wcmltYXJ5R3JlZW59O1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgfVxuXG4gICY6Oi1tb3otcmFuZ2UtdGh1bWIge1xuICAgIHdpZHRoOiAzMHB4O1xuICAgIGhlaWdodDogMzBweDtcbiAgICBiYWNrZ3JvdW5kOiAke2NvbG9ycy5wcmltYXJ5R3JlZW59O1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgfVxuYDtcblxuZXhwb3J0IGRlZmF1bHQgU2xpZGVyO1xuIl19 */"));

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$2(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _typeof$2(obj) {
  "@babel/helpers - typeof";

  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$2(obj);
}

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        _defineProperty$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var _excluded$3$1 = ["className", "clearValue", "cx", "getStyles", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
// ==============================
// NO OP
// ==============================
var noop$3 = function noop() {};
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/

function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, state, className) {
  var arr = [className];

  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
} // ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (isArray(value)) return value.filter(Boolean);
  if (_typeof$2(value) === 'object' && value !== null) return [value];
  return [];
}; // ==============================
// Clean Common Props
// ==============================

var cleanCommonProps = function cleanCommonProps(props) {
  //className
  props.className;
      props.clearValue;
      props.cx;
      props.getStyles;
      props.getValue;
      props.hasValue;
      props.isMulti;
      props.isRtl;
      props.options;
      props.selectOption;
      props.selectProps;
      props.setValue;
      props.theme;
      var innerProps = _objectWithoutProperties$1(props, _excluded$3$1);

  return _objectSpread2$2({}, innerProps);
}; // ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }

  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  if (style.position === 'fixed') return document.documentElement;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);

    if (excludeStaticParent && style.position === 'static') {
      continue;
    }

    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return document.documentElement;
} // Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/

function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop$3;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);

    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }

  animateScroll();
} // Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect

function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
} // ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
} // ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36

var passiveOptionAccessed = false;
var options = {
  get passive() {
    return passiveOptionAccessed = true;
  }

}; // check for SSR

var w$1 = typeof window !== 'undefined' ? window : {};

if (w$1.addEventListener && w$1.removeEventListener) {
  w$1.addEventListener('p', noop$3, options);
  w$1.removeEventListener('p', noop$3, false);
}

var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
  return item != null;
}
function isArray(arg) {
  return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
  return singleValue;
}
function multiValueAsValue(multiValue) {
  return multiValue;
}

function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition,
      theme = _ref.theme;
  var spacing = theme.spacing;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: maxHeight
  }; // something went wrong, return default state

  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        } // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.


        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      } // 4. Forked beviour when there isn't enough space below
      // AUTO: flip the menu, render above


      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;

        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll


      if (placement === 'bottom') {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      }

      break;

    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }

        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      } // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below


      return {
        placement: 'bottom',
        maxHeight: maxHeight
      };

    default:
      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
  }

  return defaultState;
} // Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}

var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement,
      _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      spacing = _ref2$theme.spacing,
      colors = _ref2$theme.colors;
  return _ref3 = {
    label: 'menu'
  }, _defineProperty$3(_ref3, alignToControl(placement), '100%'), _defineProperty$3(_ref3, "backgroundColor", colors.neutral0), _defineProperty$3(_ref3, "borderRadius", borderRadius), _defineProperty$3(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), _defineProperty$3(_ref3, "marginBottom", spacing.menuGutter), _defineProperty$3(_ref3, "marginTop", spacing.menuGutter), _defineProperty$3(_ref3, "position", 'absolute'), _defineProperty$3(_ref3, "width", '100%'), _defineProperty$3(_ref3, "zIndex", 1), _ref3;
};
var PortalPlacementContext = /*#__PURE__*/createContext({
  getPortalPlacement: null
}); // NOTE: internal only

var MenuPlacer = /*#__PURE__*/function (_Component) {
  _inherits(MenuPlacer, _Component);

  var _super = _createSuper(MenuPlacer);

  function MenuPlacer() {
    var _this;

    _classCallCheck$1(this, MenuPlacer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    };
    _this.context = void 0;

    _this.getPlacement = function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
          theme = _this$props.theme;
      if (!ref) return; // DO NOT scroll if position is fixed

      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition,
        theme: theme
      });
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    };

    _this.getUpdatedProps = function () {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return _objectSpread2$2(_objectSpread2$2({}, _this.props), {}, {
        placement: placement,
        maxHeight: _this.state.maxHeight
      });
    };

    return _this;
  }

  _createClass$1(MenuPlacer, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);

  return MenuPlacer;
}(Component);
MenuPlacer.contextType = PortalPlacementContext;

var Menu = function Menu(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles('menu', props),
    className: cx({
      menu: true
    }, className),
    ref: innerRef
  }, innerProps), children);
};
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4) {
  var maxHeight = _ref4.maxHeight,
      baseUnit = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      innerRef = props.innerRef,
      isMulti = props.isMulti;
  return jsx("div", _extends$1({
    css: getStyles('menuList', props),
    className: cx({
      'menu-list': true,
      'menu-list--is-multi': isMulti
    }, className),
    ref: innerRef
  }, innerProps), children);
}; // ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5) {
  var _ref5$theme = _ref5.theme,
      baseUnit = _ref5$theme.spacing.baseUnit,
      colors = _ref5$theme.colors;
  return {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
    textAlign: 'center'
  };
};

var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles('noOptionsMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--no-options': true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};
var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles('loadingMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--loading': true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = /*#__PURE__*/function (_Component2) {
  _inherits(MenuPortal, _Component2);

  var _super2 = _createSuper(MenuPortal);

  function MenuPortal() {
    var _this2;

    _classCallCheck$1(this, MenuPortal);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _this2.state = {
      placement: null
    };

    _this2.getPortalPlacement = function (_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

      if (placement !== initialPlacement) {
        _this2.setState({
          placement: placement
        });
      }
    };

    return _this2;
  }

  _createClass$1(MenuPortal, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          appendTo = _this$props2.appendTo,
          children = _this$props2.children,
          className = _this$props2.className,
          controlElement = _this$props2.controlElement,
          cx = _this$props2.cx,
          innerProps = _this$props2.innerProps,
          menuPlacement = _this$props2.menuPlacement,
          position = _this$props2.menuPosition,
          getStyles = _this$props2.getStyles;
      var isFixed = position === 'fixed'; // bail early if required elements aren't present

      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = {
        offset: offset,
        position: position,
        rect: rect
      }; // same wrapper element whether fixed or portalled

      var menuWrapper = jsx("div", _extends$1({
        css: getStyles('menuPortal', state),
        className: cx({
          'menu-portal': true
        }, className)
      }, innerProps), children);
      return jsx(PortalPlacementContext.Provider, {
        value: {
          getPortalPlacement: this.getPortalPlacement
        }
      }, appendTo ? /*#__PURE__*/createPortal(menuWrapper, appendTo) : menuWrapper);
    }
  }]);

  return MenuPortal;
}(Component);

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : undefined,
    pointerEvents: isDisabled ? 'none' : undefined,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;
  return jsx("div", _extends$1({
    css: getStyles('container', props),
    className: cx({
      '--is-disabled': isDisabled,
      '--is-rtl': isRtl
    }, className)
  }, innerProps), children);
}; // ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing,
      isMulti = _ref2.isMulti,
      hasValue = _ref2.hasValue,
      controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
  return {
    alignItems: 'center',
    display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
    flex: 1,
    flexWrap: 'wrap',
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};
var ValueContainer = function ValueContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      innerProps = props.innerProps,
      isMulti = props.isMulti,
      getStyles = props.getStyles,
      hasValue = props.hasValue;
  return jsx("div", _extends$1({
    css: getStyles('valueContainer', props),
    className: cx({
      'value-container': true,
      'value-container--is-multi': isMulti,
      'value-container--has-value': hasValue
    }, className)
  }, innerProps), children);
}; // ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      innerProps = props.innerProps,
      getStyles = props.getStyles;
  return jsx("div", _extends$1({
    css: getStyles('indicatorsContainer', props),
    className: cx({
      indicators: true
    }, className)
  }, innerProps), children);
};

var _templateObject;

var _excluded$2$1 = ["size"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$w() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref2$1 = {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$w
};

// ==============================
// Dropdown & Clear Icons
// ==============================
var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties$1(_ref, _excluded$2$1);

  return jsx("svg", _extends$1({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2$1
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return jsx(Svg, _extends$1({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return jsx(Svg, _extends$1({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref3) {
  var isFocused = _ref3.isFocused,
      _ref3$theme = _ref3.theme,
      baseUnit = _ref3$theme.spacing.baseUnit,
      colors = _ref3$theme.colors;
  return {
    label: 'indicatorContainer',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator$1 = function DropdownIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles('dropdownIndicator', props),
    className: cx({
      indicator: true,
      'dropdown-indicator': true
    }, className)
  }, innerProps), children || jsx(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles('clearIndicator', props),
    className: cx({
      indicator: true,
      'clear-indicator': true
    }, className)
  }, innerProps), children || jsx(CrossIcon, null));
}; // ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
  var isDisabled = _ref4.isDisabled,
      _ref4$theme = _ref4.theme,
      baseUnit = _ref4$theme.spacing.baseUnit,
      colors = _ref4$theme.colors;
  return {
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("span", _extends$1({}, innerProps, {
    css: getStyles('indicatorSeparator', props),
    className: cx({
      'indicator-separator': true
    }, className)
  }));
}; // ==============================
// Loading
// ==============================

var loadingDotAnimations = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
  var isFocused = _ref5.isFocused,
      size = _ref5.size,
      _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      baseUnit = _ref5$theme.spacing.baseUnit;
  return {
    label: 'loadingIndicator',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref6) {
  var delay = _ref6.delay,
      offset = _ref6.offset;
  return jsx("span", {
    css: /*#__PURE__*/css$3({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: 'currentColor',
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : undefined,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    }, ";label:LoadingDot;", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
};

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isRtl = props.isRtl;
  return jsx("div", _extends$1({
    css: getStyles('loadingIndicator', props),
    className: cx({
      indicator: true,
      'loading-indicator': true
    }, className)
  }, innerProps), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};

var css$1 = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      borderRadius = _ref$theme.borderRadius,
      spacing = _ref$theme.spacing;
  return {
    label: 'control',
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      menuIsOpen = props.menuIsOpen;
  return jsx("div", _extends$1({
    ref: innerRef,
    css: getStyles('control', props),
    className: cx({
      control: true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }, className)
  }, innerProps), children);
};

var _excluded$1$1 = ["data"];
var groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      headingProps = props.headingProps,
      innerProps = props.innerProps,
      label = props.label,
      theme = props.theme,
      selectProps = props.selectProps;
  return jsx("div", _extends$1({
    css: getStyles('group', props),
    className: cx({
      group: true
    }, className)
  }, innerProps), jsx(Heading, _extends$1({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    cx: cx
  }), label), jsx("div", null, children));
};

var groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    label: 'group',
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: 500,
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};
var GroupHeading = function GroupHeading(props) {
  var getStyles = props.getStyles,
      cx = props.cx,
      className = props.className;

  var _cleanCommonProps = cleanCommonProps(props);
      _cleanCommonProps.data;
      var innerProps = _objectWithoutProperties$1(_cleanCommonProps, _excluded$1$1);

  return jsx("div", _extends$1({
    css: getStyles('groupHeading', props),
    className: cx({
      'group-heading': true
    }, className)
  }, innerProps));
};

var _excluded$5 = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      value = _ref.value,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return _objectSpread2$2({
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80,
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: value ? 'translateZ(0)' : ''
  }, containerStyle);
};
var spacingStyle = {
  gridArea: '1 / 2',
  font: 'inherit',
  minWidth: '2px',
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: '1 1 auto',
  display: 'inline-grid',
  gridArea: '1 / 1 / 2 / 3',
  gridTemplateColumns: '0 min-content',
  '&:after': _objectSpread2$2({
    content: 'attr(data-value) " "',
    visibility: 'hidden',
    whiteSpace: 'pre'
  }, spacingStyle)
};

var inputStyle = function inputStyle(isHidden) {
  return _objectSpread2$2({
    label: 'input',
    color: 'inherit',
    background: 0,
    opacity: isHidden ? 0 : 1,
    width: '100%'
  }, spacingStyle);
};

var Input = function Input(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      value = props.value;

  var _cleanCommonProps = cleanCommonProps(props),
      innerRef = _cleanCommonProps.innerRef,
      isDisabled = _cleanCommonProps.isDisabled,
      isHidden = _cleanCommonProps.isHidden,
      inputClassName = _cleanCommonProps.inputClassName,
      innerProps = _objectWithoutProperties$1(_cleanCommonProps, _excluded$5);

  return jsx("div", {
    className: cx({
      'input-container': true
    }, className),
    css: getStyles('input', props),
    "data-value": value || ''
  }, jsx("input", _extends$1({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};

var multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      colors = _ref$theme.colors;
  return {
    label: 'multiValue',
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug

  };
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      colors = _ref2$theme.colors,
      cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      borderRadius = _ref3$theme.borderRadius,
      colors = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused ? colors.dangerLight : undefined,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
      innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children,
      innerProps = _ref5.innerProps;
  return jsx("div", _extends$1({
    role: "button"
  }, innerProps), children || jsx(CrossIcon, {
    size: 14
  }));
}

var MultiValue = function MultiValue(props) {
  var children = props.children,
      className = props.className,
      components = props.components,
      cx = props.cx,
      data = props.data,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      removeProps = props.removeProps,
      selectProps = props.selectProps;
  var Container = components.Container,
      Label = components.Label,
      Remove = components.Remove;
  return jsx(ClassNames, null, function (_ref6) {
    var css = _ref6.css,
        emotionCx = _ref6.cx;
    return jsx(Container, {
      data: data,
      innerProps: _objectSpread2$2({
        className: emotionCx(css(getStyles('multiValue', props)), cx({
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className))
      }, innerProps),
      selectProps: selectProps
    }, jsx(Label, {
      data: data,
      innerProps: {
        className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
          'multi-value__label': true
        }, className))
      },
      selectProps: selectProps
    }, children), jsx(Remove, {
      data: data,
      innerProps: _objectSpread2$2({
        className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
          'multi-value__remove': true
        }, className)),
        'aria-label': "Remove ".concat(children || 'option')
      }, removeProps),
      selectProps: selectProps
    }));
  });
};

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'option',
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles('option', props),
    className: cx({
      option: true,
      'option--is-disabled': isDisabled,
      'option--is-focused': isFocused,
      'option--is-selected': isSelected
    }, className),
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};

var placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'placeholder',
    color: colors.neutral50,
    gridArea: '1 / 1 / 2 / 3',
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles('placeholder', props),
    className: cx({
      placeholder: true
    }, className)
  }, innerProps), children);
};

var css$2 = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'singleValue',
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    gridArea: '1 / 1 / 2 / 3',
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;
  return jsx("div", _extends$1({
    css: getStyles('singleValue', props),
    className: cx({
      'single-value': true,
      'single-value--is-disabled': isDisabled
    }, className)
  }, innerProps), children);
};

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator$1,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return _objectSpread2$2(_objectSpread2$2({}, components), props.components);
};

function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$1(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray$2(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}

function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$1();
}

var _excluded$4 = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function useStateManager(_ref) {
  var _ref$defaultInputValu = _ref.defaultInputValue,
      defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu,
      _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen,
      defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
      propsInputValue = _ref.inputValue,
      propsMenuIsOpen = _ref.menuIsOpen,
      propsOnChange = _ref.onChange,
      propsOnInputChange = _ref.onInputChange,
      propsOnMenuClose = _ref.onMenuClose,
      propsOnMenuOpen = _ref.onMenuOpen,
      propsValue = _ref.value,
      restSelectProps = _objectWithoutProperties$1(_ref, _excluded$4);

  var _useState = useState(propsInputValue !== undefined ? propsInputValue : defaultInputValue),
      _useState2 = _slicedToArray$1(_useState, 2),
      stateInputValue = _useState2[0],
      setStateInputValue = _useState2[1];

  var _useState3 = useState(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen),
      _useState4 = _slicedToArray$1(_useState3, 2),
      stateMenuIsOpen = _useState4[0],
      setStateMenuIsOpen = _useState4[1];

  var _useState5 = useState(propsValue !== undefined ? propsValue : defaultValue),
      _useState6 = _slicedToArray$1(_useState5, 2),
      stateValue = _useState6[0],
      setStateValue = _useState6[1];

  var onChange = useCallback(function (value, actionMeta) {
    if (typeof propsOnChange === 'function') {
      propsOnChange(value, actionMeta);
    }

    setStateValue(value);
  }, [propsOnChange]);
  var onInputChange = useCallback(function (value, actionMeta) {
    var newValue;

    if (typeof propsOnInputChange === 'function') {
      newValue = propsOnInputChange(value, actionMeta);
    }

    setStateInputValue(newValue !== undefined ? newValue : value);
  }, [propsOnInputChange]);
  var onMenuOpen = useCallback(function () {
    if (typeof propsOnMenuOpen === 'function') {
      propsOnMenuOpen();
    }

    setStateMenuIsOpen(true);
  }, [propsOnMenuOpen]);
  var onMenuClose = useCallback(function () {
    if (typeof propsOnMenuClose === 'function') {
      propsOnMenuClose();
    }

    setStateMenuIsOpen(false);
  }, [propsOnMenuClose]);
  var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
  var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
  var value = propsValue !== undefined ? propsValue : stateValue;
  return _objectSpread2$2(_objectSpread2$2({}, restSelectProps), {}, {
    inputValue: inputValue,
    menuIsOpen: menuIsOpen,
    onChange: onChange,
    onInputChange: onInputChange,
    onMenuClose: onMenuClose,
    onMenuOpen: onMenuOpen,
    value: value
  });
}

function _arrayWithoutHoles$2(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$2(arr);
}

function _iterableToArray$2(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread$2() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray$2(arr) {
  return _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread$2();
}

var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$1$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$1 = {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1$1
};

var A11yText = function A11yText(props) {
  return jsx("span", _extends$1({
    css: _ref$1
  }, props));
};

var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable,
        isMulti = props.isMulti,
        isDisabled = props.isDisabled,
        tabSelectsValue = props.tabSelectsValue,
        context = props.context;

    switch (context) {
      case 'menu':
        return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");

      case 'input':
        return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');

      case 'value':
        return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';

      default:
        return '';
    }
  },
  onChange: function onChange(props) {
    var action = props.action,
        _props$label = props.label,
        label = _props$label === void 0 ? '' : _props$label,
        labels = props.labels,
        isDisabled = props.isDisabled;

    switch (action) {
      case 'deselect-option':
      case 'pop-value':
      case 'remove-value':
        return "option ".concat(label, ", deselected.");

      case 'clear':
        return 'All selected options have been cleared.';

      case 'initial-input-focus':
        return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");

      case 'select-option':
        return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");

      default:
        return '';
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context,
        focused = props.focused,
        options = props.options,
        _props$label2 = props.label,
        label = _props$label2 === void 0 ? '' : _props$label2,
        selectValue = props.selectValue,
        isDisabled = props.isDisabled,
        isSelected = props.isSelected;

    var getArrayIndex = function getArrayIndex(arr, item) {
      return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
    };

    if (context === 'value' && selectValue) {
      return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }

    if (context === 'menu') {
      var disabled = isDisabled ? ' disabled' : '';
      var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
      return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
    }

    return '';
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue,
        resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
  }
};

var LiveRegion = function LiveRegion(props) {
  var ariaSelection = props.ariaSelection,
      focusedOption = props.focusedOption,
      focusedValue = props.focusedValue,
      focusableOptions = props.focusableOptions,
      isFocused = props.isFocused,
      selectValue = props.selectValue,
      selectProps = props.selectProps,
      id = props.id;
  var ariaLiveMessages = selectProps.ariaLiveMessages,
      getOptionLabel = selectProps.getOptionLabel,
      inputValue = selectProps.inputValue,
      isMulti = selectProps.isMulti,
      isOptionDisabled = selectProps.isOptionDisabled,
      isSearchable = selectProps.isSearchable,
      menuIsOpen = selectProps.menuIsOpen,
      options = selectProps.options,
      screenReaderStatus = selectProps.screenReaderStatus,
      tabSelectsValue = selectProps.tabSelectsValue;
  var ariaLabel = selectProps['aria-label'];
  var ariaLive = selectProps['aria-live']; // Update aria live message configuration when prop changes

  var messages = useMemo(function () {
    return _objectSpread2$2(_objectSpread2$2({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]); // Update aria live selected option when prop changes

  var ariaSelected = useMemo(function () {
    var message = '';

    if (ariaSelection && messages.onChange) {
      var option = ariaSelection.option,
          selectedOptions = ariaSelection.options,
          removedValue = ariaSelection.removedValue,
          removedValues = ariaSelection.removedValues,
          value = ariaSelection.value; // select-option when !isMulti does not return option so we assume selected option is value

      var asOption = function asOption(val) {
        return !Array.isArray(val) ? val : null;
      }; // If there is just one item from the action then get its label


      var selected = removedValue || option || asOption(value);
      var label = selected ? getOptionLabel(selected) : ''; // If there are multiple items from the action then return an array of labels

      var multiSelected = selectedOptions || removedValues || undefined;
      var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];

      var onChangeProps = _objectSpread2$2({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: selected && isOptionDisabled(selected, selectValue),
        label: label,
        labels: labels
      }, ariaSelection);

      message = messages.onChange(onChangeProps);
    }

    return message;
  }, [ariaSelection, messages, isOptionDisabled, selectValue, getOptionLabel]);
  var ariaFocused = useMemo(function () {
    var focusMsg = '';
    var focused = focusedOption || focusedValue;
    var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));

    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused: focused,
        label: getOptionLabel(focused),
        isDisabled: isOptionDisabled(focused, selectValue),
        isSelected: isSelected,
        options: options,
        context: focused === focusedOption ? 'menu' : 'value',
        selectValue: selectValue
      };
      focusMsg = messages.onFocus(onFocusProps);
    }

    return focusMsg;
  }, [focusedOption, focusedValue, getOptionLabel, isOptionDisabled, messages, options, selectValue]);
  var ariaResults = useMemo(function () {
    var resultsMsg = '';

    if (menuIsOpen && options.length && messages.onFilter) {
      var resultsMessage = screenReaderStatus({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue: inputValue,
        resultsMessage: resultsMessage
      });
    }

    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options, screenReaderStatus]);
  var ariaGuidance = useMemo(function () {
    var guidanceMsg = '';

    if (messages.guidance) {
      var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
      guidanceMsg = messages.guidance({
        'aria-label': ariaLabel,
        context: context,
        isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
        isMulti: isMulti,
        isSearchable: isSearchable,
        tabSelectsValue: tabSelectsValue
      });
    }

    return guidanceMsg;
  }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue]);
  var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
  var ScreenReaderText = jsx(Fragment, null, jsx("span", {
    id: "aria-selection"
  }, ariaSelected), jsx("span", {
    id: "aria-context"
  }, ariaContext));
  var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
  return jsx(Fragment, null, jsx(A11yText, {
    id: id
  }, isInitialFocus && ScreenReaderText), jsx(A11yText, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, isFocused && !isInitialFocus && ScreenReaderText));
};

var diacritics = [{
  base: 'A',
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: 'AA',
  letters: "\uA732"
}, {
  base: 'AE',
  letters: "\xC6\u01FC\u01E2"
}, {
  base: 'AO',
  letters: "\uA734"
}, {
  base: 'AU',
  letters: "\uA736"
}, {
  base: 'AV',
  letters: "\uA738\uA73A"
}, {
  base: 'AY',
  letters: "\uA73C"
}, {
  base: 'B',
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: 'C',
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: 'D',
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: 'DZ',
  letters: "\u01F1\u01C4"
}, {
  base: 'Dz',
  letters: "\u01F2\u01C5"
}, {
  base: 'E',
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: 'F',
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: 'G',
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: 'H',
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: 'I',
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: 'J',
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: 'K',
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: 'L',
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: 'LJ',
  letters: "\u01C7"
}, {
  base: 'Lj',
  letters: "\u01C8"
}, {
  base: 'M',
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: 'N',
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: 'NJ',
  letters: "\u01CA"
}, {
  base: 'Nj',
  letters: "\u01CB"
}, {
  base: 'O',
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: 'OI',
  letters: "\u01A2"
}, {
  base: 'OO',
  letters: "\uA74E"
}, {
  base: 'OU',
  letters: "\u0222"
}, {
  base: 'P',
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: 'Q',
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: 'R',
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: 'S',
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: 'T',
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: 'TZ',
  letters: "\uA728"
}, {
  base: 'U',
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: 'V',
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: 'VY',
  letters: "\uA760"
}, {
  base: 'W',
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: 'X',
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: 'Y',
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: 'Z',
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: 'a',
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: 'aa',
  letters: "\uA733"
}, {
  base: 'ae',
  letters: "\xE6\u01FD\u01E3"
}, {
  base: 'ao',
  letters: "\uA735"
}, {
  base: 'au',
  letters: "\uA737"
}, {
  base: 'av',
  letters: "\uA739\uA73B"
}, {
  base: 'ay',
  letters: "\uA73D"
}, {
  base: 'b',
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: 'c',
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: 'd',
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: 'dz',
  letters: "\u01F3\u01C6"
}, {
  base: 'e',
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: 'f',
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: 'g',
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: 'h',
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: 'hv',
  letters: "\u0195"
}, {
  base: 'i',
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: 'j',
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: 'k',
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: 'l',
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: 'lj',
  letters: "\u01C9"
}, {
  base: 'm',
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: 'n',
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: 'nj',
  letters: "\u01CC"
}, {
  base: 'o',
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: 'oi',
  letters: "\u01A3"
}, {
  base: 'ou',
  letters: "\u0223"
}, {
  base: 'oo',
  letters: "\uA74F"
}, {
  base: 'p',
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: 'q',
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: 'r',
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: 's',
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: 't',
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: 'tz',
  letters: "\uA729"
}, {
  base: 'u',
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: 'v',
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: 'vy',
  letters: "\uA761"
}, {
  base: 'w',
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: 'x',
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: 'y',
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: 'z',
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp('[' + diacritics.map(function (d) {
  return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};

for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];

  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}

var stripDiacritics = function stripDiacritics(str) {
  return str.replace(anyDiacritic, function (match) {
    return diacriticToBase[match];
  });
};

var memoizedStripDiacriticsForInput = memoizeOne(stripDiacritics);

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};

var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    // eslint-disable-next-line no-underscore-dangle
    if (option.data.__isNew__) return true;

    var _ignoreCase$ignoreAcc = _objectSpread2$2({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);

    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }

    if (ignoreAccents) {
      input = memoizedStripDiacriticsForInput(input);
      candidate = stripDiacritics(candidate);
    }

    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

var _excluded$3 = ["innerRef"];
function DummyInput(_ref) {
  var innerRef = _ref.innerRef,
      props = _objectWithoutProperties$1(_ref, _excluded$3);

  return jsx("input", _extends$1({
    ref: innerRef
  }, props, {
    css: /*#__PURE__*/css$3({
      label: 'dummyInput',
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: 'transparent',
      fontSize: 'inherit',
      gridArea: '1 / 1 / 2 / 3',
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: 'transparent',
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: 'relative',
      transform: 'scale(.01)'
    }, ";label:DummyInput;", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNNIiwiZmlsZSI6IkR1bW15SW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgcmV0dXJuIChcbiAgICA8aW5wdXRcbiAgICAgIHJlZj17aW5uZXJSZWZ9XG4gICAgICB7Li4ucHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}

var cancelScroll = function cancelScroll(event) {
  event.preventDefault();
  event.stopPropagation();
};

function useScrollCapture(_ref) {
  var isEnabled = _ref.isEnabled,
      onBottomArrive = _ref.onBottomArrive,
      onBottomLeave = _ref.onBottomLeave,
      onTopArrive = _ref.onTopArrive,
      onTopLeave = _ref.onTopLeave;
  var isBottom = useRef(false);
  var isTop = useRef(false);
  var touchStart = useRef(0);
  var scrollTarget = useRef(null);
  var handleEventDelta = useCallback(function (event, delta) {
    if (scrollTarget.current === null) return;
    var _scrollTarget$current = scrollTarget.current,
        scrollTop = _scrollTarget$current.scrollTop,
        scrollHeight = _scrollTarget$current.scrollHeight,
        clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false; // reset bottom/top flags

    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave) onBottomLeave(event);
      isBottom.current = false;
    }

    if (isDeltaPositive && isTop.current) {
      if (onTopLeave) onTopLeave(event);
      isTop.current = false;
    } // bottom limit


    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }

      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true; // top limit
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }

      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    } // cancel scroll


    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
  var onWheel = useCallback(function (event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart = useCallback(function (event) {
    // set touch start so we can calculate touchmove delta
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove = useCallback(function (event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = useCallback(function (el) {
    // bail early if no element is available to attach to
    if (!el) return;
    var notPassive = supportsPassiveEvents ? {
      passive: false
    } : false;
    el.addEventListener('wheel', onWheel, notPassive);
    el.addEventListener('touchstart', onTouchStart, notPassive);
    el.addEventListener('touchmove', onTouchMove, notPassive);
  }, [onTouchMove, onTouchStart, onWheel]);
  var stopListening = useCallback(function (el) {
    // bail early if no element is available to detach from
    if (!el) return;
    el.removeEventListener('wheel', onWheel, false);
    el.removeEventListener('touchstart', onTouchStart, false);
    el.removeEventListener('touchmove', onTouchMove, false);
  }, [onTouchMove, onTouchStart, onWheel]);
  useEffect(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    startListening(element);
    return function () {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function (element) {
    scrollTarget.current = element;
  };
}

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

function preventTouchMove(e) {
  e.preventDefault();
}

function allowTouchMove(e) {
  e.stopPropagation();
}

function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface


function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};
function useScrollLock(_ref) {
  var isEnabled = _ref.isEnabled,
      _ref$accountForScroll = _ref.accountForScrollbars,
      accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = useRef({});
  var scrollTarget = useRef(null);
  var addScrollLock = useCallback(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;

    if (accountForScrollbars) {
      // store any styles already applied to the body
      STYLE_KEYS.forEach(function (key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    } // apply the lock styles and padding if this is the first scroll lock


    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function (key) {
        var val = LOCK_STYLES[key];

        if (targetStyle) {
          targetStyle[key] = val;
        }
      });

      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    } // account for touch devices


    if (target && isTouchDevice()) {
      // Mobile Safari ignores { overflow: hidden } declaration on the body.
      target.addEventListener('touchmove', preventTouchMove, listenerOptions); // Allow scroll on provided target

      if (touchScrollTarget) {
        touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    } // increment active scroll locks


    activeScrollLocks += 1;
  }, [accountForScrollbars]);
  var removeScrollLock = useCallback(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style; // safely decrement active scroll locks

    activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any

    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function (key) {
        var val = originalStyles.current[key];

        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    } // remove touch listeners


    if (target && isTouchDevice()) {
      target.removeEventListener('touchmove', preventTouchMove, listenerOptions);

      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    }
  }, [accountForScrollbars]);
  useEffect(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function () {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function (element) {
    scrollTarget.current = element;
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$v() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var blurSelectInput = function blurSelectInput() {
  return document.activeElement && document.activeElement.blur();
};

var _ref2 = {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$v
};

function ScrollManager(_ref) {
  var children = _ref.children,
      lockEnabled = _ref.lockEnabled,
      _ref$captureEnabled = _ref.captureEnabled,
      captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled,
      onBottomArrive = _ref.onBottomArrive,
      onBottomLeave = _ref.onBottomLeave,
      onTopArrive = _ref.onTopArrive,
      onTopLeave = _ref.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive: onBottomArrive,
    onBottomLeave: onBottomLeave,
    onTopArrive: onTopArrive,
    onTopLeave: onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });

  var targetRef = function targetRef(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };

  return jsx(Fragment, null, lockEnabled && jsx("div", {
    onClick: blurSelectInput,
    css: _ref2
  }), children(targetRef));
}

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css$2,
  valueContainer: valueContainerCSS
}; // Merge Utility

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4; // Used to calculate consistent margin/padding on elements

var baseUnit = 4; // The minimum height of the control

var controlHeight = 38; // The amount of space between the control and menu */

var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

var defaultProps = {
  'aria-live': 'polite',
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionValue$1,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: true
};

function toCategorizedOption(props, option, selectValue, index) {
  var isDisabled = _isOptionDisabled(props, option, selectValue);

  var isSelected = _isOptionSelected(props, option, selectValue);

  var label = getOptionLabel(props, option);
  var value = getOptionValue(props, option);
  return {
    type: 'option',
    data: option,
    isDisabled: isDisabled,
    isSelected: isSelected,
    label: label,
    value: value,
    index: index
  };
}

function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function (groupOrOption, groupOrOptionIndex) {
    if ('options' in groupOrOption) {
      var categorizedOptions = groupOrOption.options.map(function (option, optionIndex) {
        return toCategorizedOption(props, option, selectValue, optionIndex);
      }).filter(function (categorizedOption) {
        return isFocusable(props, categorizedOption);
      });
      return categorizedOptions.length > 0 ? {
        type: 'group',
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : undefined;
    }

    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
  }).filter(notNullish);
}

function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function (optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === 'group') {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray$2(categorizedOption.options.map(function (option) {
        return option.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }

    return optionsAccumulator;
  }, []);
}

function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}

function isFocusable(props, categorizedOption) {
  var _props$inputValue = props.inputValue,
      inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
  var data = categorizedOption.data,
      isSelected = categorizedOption.isSelected,
      label = categorizedOption.label,
      value = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label: label,
    value: value,
    data: data
  }, inputValue);
}

function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue,
      lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);

  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);

    if (nextFocusedIndex > -1) {
      // the focused value is still in the selectValue, return it
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      // the focusedValue is not present in the next selectValue array by
      // reference, so return the new value at the same index
      return nextSelectValue[lastFocusedIndex];
    }
  }

  return null;
}

function getNextFocusedOption(state, options) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}

var getOptionLabel = function getOptionLabel(props, data) {
  return props.getOptionLabel(data);
};

var getOptionValue = function getOptionValue(props, data) {
  return props.getOptionValue(data);
};

function _isOptionDisabled(props, option, selectValue) {
  return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}

function _isOptionSelected(props, option, selectValue) {
  if (selectValue.indexOf(option) > -1) return true;

  if (typeof props.isOptionSelected === 'function') {
    return props.isOptionSelected(option, selectValue);
  }

  var candidate = getOptionValue(props, option);
  return selectValue.some(function (i) {
    return getOptionValue(props, i) === candidate;
  });
}

function _filterOption(props, option, inputValue) {
  return props.filterOption ? props.filterOption(option, inputValue) : true;
}

var shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
  var hideSelectedOptions = props.hideSelectedOptions,
      isMulti = props.isMulti;
  if (hideSelectedOptions === undefined) return isMulti;
  return hideSelectedOptions;
};

var instanceId = 1;

var Select$1 = /*#__PURE__*/function (_Component) {
  _inherits(Select, _Component);

  var _super = _createSuper(Select);

  // Misc. Instance Properties
  // ------------------------------
  // TODO
  // Refs
  // ------------------------------
  // Lifecycle
  // ------------------------------
  function Select(_props) {
    var _this;

    _classCallCheck$1(this, Select);

    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      prevWasFocused: false,
      inputIsHiddenAfterUpdate: undefined,
      prevProps: undefined
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.instancePrefix = '';
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.controlRef = null;

    _this.getControlRef = function (ref) {
      _this.controlRef = ref;
    };

    _this.focusedOptionRef = null;

    _this.getFocusedOptionRef = function (ref) {
      _this.focusedOptionRef = ref;
    };

    _this.menuListRef = null;

    _this.getMenuListRef = function (ref) {
      _this.menuListRef = ref;
    };

    _this.inputRef = null;

    _this.getInputRef = function (ref) {
      _this.inputRef = ref;
    };

    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;

    _this.onChange = function (newValue, actionMeta) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name;
      actionMeta.name = name;

      _this.ariaOnChange(newValue, actionMeta);

      onChange(newValue, actionMeta);
    };

    _this.setValue = function (newValue, action, option) {
      var _this$props2 = _this.props,
          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
          isMulti = _this$props2.isMulti,
          inputValue = _this$props2.inputValue;

      _this.onInputChange('', {
        action: 'set-value',
        prevInputValue: inputValue
      });

      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });

        _this.onMenuClose();
      } // when the select value should change, we should reset focusedValue


      _this.setState({
        clearFocusValueOnUpdate: true
      });

      _this.onChange(newValue, {
        action: action,
        option: option
      });
    };

    _this.selectOption = function (newValue) {
      var _this$props3 = _this.props,
          blurInputOnSelect = _this$props3.blurInputOnSelect,
          isMulti = _this$props3.isMulti,
          name = _this$props3.name;
      var selectValue = _this.state.selectValue;

      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);

      var isDisabled = _this.isOptionDisabled(newValue, selectValue);

      if (deselected) {
        var candidate = _this.getOptionValue(newValue);

        _this.setValue(multiValueAsValue(selectValue.filter(function (i) {
          return _this.getOptionValue(i) !== candidate;
        })), 'deselect-option', newValue);
      } else if (!isDisabled) {
        // Select option if option is not disabled
        if (isMulti) {
          _this.setValue(multiValueAsValue([].concat(_toConsumableArray$2(selectValue), [newValue])), 'select-option', newValue);
        } else {
          _this.setValue(singleValueAsValue(newValue), 'select-option');
        }
      } else {
        _this.ariaOnChange(singleValueAsValue(newValue), {
          action: 'select-option',
          option: newValue,
          name: name
        });

        return;
      }

      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };

    _this.removeValue = function (removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;

      var candidate = _this.getOptionValue(removedValue);

      var newValueArray = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);

      _this.onChange(newValue, {
        action: 'remove-value',
        removedValue: removedValue
      });

      _this.focusInput();
    };

    _this.clearValue = function () {
      var selectValue = _this.state.selectValue;

      _this.onChange(valueTernary(_this.props.isMulti, [], null), {
        action: 'clear',
        removedValues: selectValue
      });
    };

    _this.popValue = function () {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);

      _this.onChange(newValue, {
        action: 'pop-value',
        removedValue: lastSelectedValue
      });
    };

    _this.getValue = function () {
      return _this.state.selectValue;
    };

    _this.cx = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };

    _this.getOptionLabel = function (data) {
      return getOptionLabel(_this.props, data);
    };

    _this.getOptionValue = function (data) {
      return getOptionValue(_this.props, data);
    };

    _this.getStyles = function (key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };

    _this.getElementId = function (element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    };

    _this.getComponents = function () {
      return defaultComponents(_this.props);
    };

    _this.buildCategorizedOptions = function () {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };

    _this.getCategorizedOptions = function () {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };

    _this.buildFocusableOptions = function () {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };

    _this.getFocusableOptions = function () {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };

    _this.ariaOnChange = function (value, actionMeta) {
      _this.setState({
        ariaSelection: _objectSpread2$2({
          value: value
        }, actionMeta)
      });
    };

    _this.onMenuMouseDown = function (event) {
      if (event.button !== 0) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();

      _this.focusInput();
    };

    _this.onMenuMouseMove = function (event) {
      _this.blockOptionHover = false;
    };

    _this.onControlMouseDown = function (event) {
      var openMenuOnClick = _this.props.openMenuOnClick;

      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }

        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
          _this.onMenuClose();
        }
      }

      if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
        event.preventDefault();
      }
    };

    _this.onDropdownIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
          isMulti = _this$props4.isMulti,
          menuIsOpen = _this$props4.menuIsOpen;

      _this.focusInput();

      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });

        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }

      event.preventDefault();
      event.stopPropagation();
    };

    _this.onClearIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      _this.clearValue();

      event.preventDefault();
      event.stopPropagation();
      _this.openAfterFocus = false;

      if (event.type === 'touchend') {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    };

    _this.onScroll = function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };

    _this.onCompositionStart = function () {
      _this.isComposing = true;
    };

    _this.onCompositionEnd = function () {
      _this.isComposing = false;
    };

    _this.onTouchStart = function (_ref2) {
      var touches = _ref2.touches;
      var touch = touches && touches.item(0);

      if (!touch) {
        return;
      }

      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };

    _this.onTouchMove = function (_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);

      if (!touch) {
        return;
      }

      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };

    _this.onTouchEnd = function (event) {
      if (_this.userIsDragging) return; // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).

      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      } // reset move vars


      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };

    _this.onControlTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onControlMouseDown(event);
    };

    _this.onClearIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onClearIndicatorMouseDown(event);
    };

    _this.onDropdownIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onDropdownIndicatorMouseDown(event);
    };

    _this.handleInputChange = function (event) {
      var prevInputValue = _this.props.inputValue;
      var inputValue = event.currentTarget.value;

      _this.setState({
        inputIsHiddenAfterUpdate: false
      });

      _this.onInputChange(inputValue, {
        action: 'input-change',
        prevInputValue: prevInputValue
      });

      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };

    _this.onInputFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });

      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }

      _this.openAfterFocus = false;
    };

    _this.onInputBlur = function (event) {
      var prevInputValue = _this.props.inputValue;

      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();

        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      _this.onInputChange('', {
        action: 'input-blur',
        prevInputValue: prevInputValue
      });

      _this.onMenuClose();

      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };

    _this.onOptionHover = function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }

      _this.setState({
        focusedOption: focusedOption
      });
    };

    _this.shouldHideSelectedOptions = function () {
      return shouldHideSelectedOptions(_this.props);
    };

    _this.onKeyDown = function (event) {
      var _this$props5 = _this.props,
          isMulti = _this$props5.isMulti,
          backspaceRemovesValue = _this$props5.backspaceRemovesValue,
          escapeClearsValue = _this$props5.escapeClearsValue,
          inputValue = _this$props5.inputValue,
          isClearable = _this$props5.isClearable,
          isDisabled = _this$props5.isDisabled,
          menuIsOpen = _this$props5.menuIsOpen,
          onKeyDown = _this$props5.onKeyDown,
          tabSelectsValue = _this$props5.tabSelectsValue,
          openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state,
          focusedOption = _this$state.focusedOption,
          focusedValue = _this$state.focusedValue,
          selectValue = _this$state.selectValue;
      if (isDisabled) return;

      if (typeof onKeyDown === 'function') {
        onKeyDown(event);

        if (event.defaultPrevented) {
          return;
        }
      } // Block option hover events when the user has just pressed a key


      _this.blockOptionHover = true;

      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;

          _this.focusValue('previous');

          break;

        case 'ArrowRight':
          if (!isMulti || inputValue) return;

          _this.focusValue('next');

          break;

        case 'Delete':
        case 'Backspace':
          if (inputValue) return;

          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;

            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }

          break;

        case 'Tab':
          if (_this.isComposing) return;

          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }

          _this.selectOption(focusedOption);

          break;

        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }

          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;

            _this.selectOption(focusedOption);

            break;
          }

          return;

        case 'Escape':
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });

            _this.onInputChange('', {
              action: 'menu-close',
              prevInputValue: inputValue
            });

            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }

          break;

        case ' ':
          // space
          if (inputValue) {
            return;
          }

          if (!menuIsOpen) {
            _this.openMenu('first');

            break;
          }

          if (!focusedOption) return;

          _this.selectOption(focusedOption);

          break;

        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }

          break;

        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }

          break;

        case 'PageUp':
          if (!menuIsOpen) return;

          _this.focusOption('pageup');

          break;

        case 'PageDown':
          if (!menuIsOpen) return;

          _this.focusOption('pagedown');

          break;

        case 'Home':
          if (!menuIsOpen) return;

          _this.focusOption('first');

          break;

        case 'End':
          if (!menuIsOpen) return;

          _this.focusOption('last');

          break;

        default:
          return;
      }

      event.preventDefault();
    };

    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = cleanValue(_props.value);
    return _this;
  }

  _createClass$1(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();

      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }

      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props,
          isDisabled = _this$props6.isDisabled,
          menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;

      if ( // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }

      if (isFocused && isDisabled && !prevProps.isDisabled) {
        // ensure select state gets blurred in case Select is programatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } // scroll the focused option into view if necessary


      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    } // ==============================
    // Consumer Handlers
    // ==============================

  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange('', {
        action: 'menu-close',
        prevInputValue: this.props.inputValue
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    } // ==============================
    // Methods
    // ==============================

  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    } // aliased for consumers

  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;

      var _this$state2 = this.state,
          selectValue = _this$state2.selectValue,
          isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;

      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);

        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      } // only scroll if the menu isn't already open


      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex]
      }, function () {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state,
          selectValue = _this$state3.selectValue,
          focusedValue = _this$state3.focusedValue; // Only multiselects support value focusing

      if (!this.props.isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);

      if (!focusedValue) {
        focusedIndex = -1;
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }

          break;

        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }

          break;
      }

      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var focusedOption = this.state.focusedOption;
      var options = this.getFocusableOptions();
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'

      var focusedIndex = options.indexOf(focusedOption);

      if (!focusedOption) {
        focusedIndex = -1;
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: "getTheme",
    value: // ==============================
    // Getters
    // ==============================
    function getTheme() {
      // Use the default theme if there are no customizations.
      if (!this.props.theme) {
        return defaultTheme;
      } // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.


      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      } // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.


      return _objectSpread2$2(_objectSpread2$2({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
          cx = this.cx,
          getStyles = this.getStyles,
          getValue = this.getValue,
          selectOption = this.selectOption,
          setValue = this.setValue,
          props = this.props;
      var isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue: clearValue,
        cx: cx,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        selectProps: props,
        setValue: setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props,
          isClearable = _this$props7.isClearable,
          isMulti = _this$props7.isMulti; // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled(option, selectValue) {
      return _isOptionDisabled(this.props, option, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      return _isOptionSelected(this.props, option, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return _filterOption(this.props, option, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var _inputValue = this.props.inputValue;
        var _selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: _inputValue,
          selectValue: _selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel(data) {
      return this.props.formatGroupLabel(data);
    } // ==============================
    // Mouse Handlers
    // ==============================

  }, {
    key: "startListeningComposition",
    value: // ==============================
    // Composition Handlers
    // ==============================
    function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value: // ==============================
    // Touch Handlers
    // ==============================
    function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value: // ==============================
    // Renderers
    // ==============================
    function renderInput() {
      var _this$props8 = this.props,
          isDisabled = _this$props8.isDisabled,
          isSearchable = _this$props8.isSearchable,
          inputId = _this$props8.inputId,
          inputValue = _this$props8.inputValue,
          tabIndex = _this$props8.tabIndex,
          form = _this$props8.form,
          menuIsOpen = _this$props8.menuIsOpen;

      var _this$getComponents = this.getComponents(),
          Input = _this$getComponents.Input;

      var _this$state4 = this.state,
          inputIsHidden = _this$state4.inputIsHidden,
          ariaSelection = _this$state4.ariaSelection;
      var commonProps = this.commonProps;
      var id = inputId || this.getElementId('input'); // aria attributes makes the JSX "noisy", separated for clarity

      var ariaAttributes = _objectSpread2$2(_objectSpread2$2({
        'aria-autocomplete': 'list',
        'aria-expanded': menuIsOpen,
        'aria-haspopup': true,
        'aria-controls': this.getElementId('listbox'),
        'aria-owns': this.getElementId('listbox'),
        'aria-errormessage': this.props['aria-errormessage'],
        'aria-invalid': this.props['aria-invalid'],
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby'],
        role: 'combobox'
      }, !isSearchable && {
        'aria-readonly': true
      }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
        'aria-describedby': this.getElementId('live-region')
      } : {
        'aria-describedby': this.getElementId('placeholder')
      });

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/React.createElement(DummyInput, _extends$1({
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop$3,
          onFocus: this.onInputFocus,
          disabled: isDisabled,
          tabIndex: tabIndex,
          inputMode: "none",
          form: form,
          value: ""
        }, ariaAttributes));
      }

      return /*#__PURE__*/React.createElement(Input, _extends$1({}, commonProps, {
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex: tabIndex,
        form: form,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;

      var _this$getComponents2 = this.getComponents(),
          MultiValue = _this$getComponents2.MultiValue,
          MultiValueContainer = _this$getComponents2.MultiValueContainer,
          MultiValueLabel = _this$getComponents2.MultiValueLabel,
          MultiValueRemove = _this$getComponents2.MultiValueRemove,
          SingleValue = _this$getComponents2.SingleValue,
          Placeholder = _this$getComponents2.Placeholder;

      var commonProps = this.commonProps;
      var _this$props9 = this.props,
          controlShouldRenderValue = _this$props9.controlShouldRenderValue,
          isDisabled = _this$props9.isDisabled,
          isMulti = _this$props9.isMulti,
          inputValue = _this$props9.inputValue,
          placeholder = _this$props9.placeholder;
      var _this$state5 = this.state,
          selectValue = _this$state5.selectValue,
          focusedValue = _this$state5.focusedValue,
          isFocused = _this$state5.isFocused;

      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /*#__PURE__*/React.createElement(Placeholder, _extends$1({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused,
          innerProps: {
            id: this.getElementId('placeholder')
          }
        }), placeholder);
      }

      if (isMulti) {
        return selectValue.map(function (opt, index) {
          var isOptionFocused = opt === focusedValue;
          var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
          return /*#__PURE__*/React.createElement(MultiValue, _extends$1({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: key,
            index: index,
            removeProps: {
              onClick: function onClick() {
                return _this3.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this3.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
                e.stopPropagation();
              }
            },
            data: opt
          }), _this3.formatOptionLabel(opt, 'value'));
        });
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return /*#__PURE__*/React.createElement(SingleValue, _extends$1({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(),
          ClearIndicator = _this$getComponents3.ClearIndicator;

      var commonProps = this.commonProps;
      var _this$props10 = this.props,
          isDisabled = _this$props10.isDisabled,
          isLoading = _this$props10.isLoading;
      var isFocused = this.state.isFocused;

      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React.createElement(ClearIndicator, _extends$1({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(),
          LoadingIndicator = _this$getComponents4.LoadingIndicator;

      var commonProps = this.commonProps;
      var _this$props11 = this.props,
          isDisabled = _this$props11.isDisabled,
          isLoading = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React.createElement(LoadingIndicator, _extends$1({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(),
          DropdownIndicator = _this$getComponents5.DropdownIndicator,
          IndicatorSeparator = _this$getComponents5.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator


      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /*#__PURE__*/React.createElement(IndicatorSeparator, _extends$1({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(),
          DropdownIndicator = _this$getComponents6.DropdownIndicator;

      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React.createElement(DropdownIndicator, _extends$1({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;

      var _this$getComponents7 = this.getComponents(),
          Group = _this$getComponents7.Group,
          GroupHeading = _this$getComponents7.GroupHeading,
          Menu = _this$getComponents7.Menu,
          MenuList = _this$getComponents7.MenuList,
          MenuPortal = _this$getComponents7.MenuPortal,
          LoadingMessage = _this$getComponents7.LoadingMessage,
          NoOptionsMessage = _this$getComponents7.NoOptionsMessage,
          Option = _this$getComponents7.Option;

      var commonProps = this.commonProps;
      var focusedOption = this.state.focusedOption;
      var _this$props12 = this.props,
          captureMenuScroll = _this$props12.captureMenuScroll,
          inputValue = _this$props12.inputValue,
          isLoading = _this$props12.isLoading,
          loadingMessage = _this$props12.loadingMessage,
          minMenuHeight = _this$props12.minMenuHeight,
          maxMenuHeight = _this$props12.maxMenuHeight,
          menuIsOpen = _this$props12.menuIsOpen,
          menuPlacement = _this$props12.menuPlacement,
          menuPosition = _this$props12.menuPosition,
          menuPortalTarget = _this$props12.menuPortalTarget,
          menuShouldBlockScroll = _this$props12.menuShouldBlockScroll,
          menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView,
          noOptionsMessage = _this$props12.noOptionsMessage,
          onMenuScrollToTop = _this$props12.onMenuScrollToTop,
          onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen) return null; // TODO: Internal Option Type here

      var render = function render(props, id) {
        var type = props.type,
            data = props.data,
            isDisabled = props.isDisabled,
            isSelected = props.isSelected,
            label = props.label,
            value = props.value;
        var isFocused = focusedOption === data;
        var onHover = isDisabled ? undefined : function () {
          return _this4.onOptionHover(data);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this4.selectOption(data);
        };
        var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1
        };
        return /*#__PURE__*/React.createElement(Option, _extends$1({}, commonProps, {
          innerProps: innerProps,
          data: data,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: type,
          value: value,
          isFocused: isFocused,
          innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
        }), _this4.formatOptionLabel(props.data, 'menu'));
      };

      var menuUI;

      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function (item) {
          if (item.type === 'group') {
            var _data = item.data,
                options = item.options,
                groupIndex = item.index;
            var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return /*#__PURE__*/React.createElement(Group, _extends$1({}, commonProps, {
              key: groupId,
              data: _data,
              options: options,
              Heading: GroupHeading,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this4.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option, "".concat(groupIndex, "-").concat(option.index));
            }));
          } else if (item.type === 'option') {
            return render(item, "".concat(item.index));
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = /*#__PURE__*/React.createElement(LoadingMessage, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });

        if (_message === null) return null;
        menuUI = /*#__PURE__*/React.createElement(NoOptionsMessage, commonProps, _message);
      }

      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = /*#__PURE__*/React.createElement(MenuPlacer, _extends$1({}, commonProps, menuPlacementProps), function (_ref4) {
        var ref = _ref4.ref,
            _ref4$placerProps = _ref4.placerProps,
            placement = _ref4$placerProps.placement,
            maxHeight = _ref4$placerProps.maxHeight;
        return /*#__PURE__*/React.createElement(Menu, _extends$1({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this4.onMenuMouseDown,
            onMouseMove: _this4.onMenuMouseMove,
            id: _this4.getElementId('listbox')
          },
          isLoading: isLoading,
          placement: placement
        }), /*#__PURE__*/React.createElement(ScrollManager, {
          captureEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom,
          lockEnabled: menuShouldBlockScroll
        }, function (scrollTargetRef) {
          return /*#__PURE__*/React.createElement(MenuList, _extends$1({}, commonProps, {
            innerRef: function innerRef(instance) {
              _this4.getMenuListRef(instance);

              scrollTargetRef(instance);
            },
            isLoading: isLoading,
            maxHeight: maxHeight,
            focusedOption: focusedOption
          }), menuUI);
        }));
      }); // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`

      return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/React.createElement(MenuPortal, _extends$1({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;

      var _this$props13 = this.props,
          delimiter = _this$props13.delimiter,
          isDisabled = _this$props13.isDisabled,
          isMulti = _this$props13.isMulti,
          name = _this$props13.name;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter);
          return /*#__PURE__*/React.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return /*#__PURE__*/React.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this5.getOptionValue(opt)
            });
          }) : /*#__PURE__*/React.createElement("input", {
            name: name,
            type: "hidden"
          });
          return /*#__PURE__*/React.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';

        return /*#__PURE__*/React.createElement("input", {
          name: name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state6 = this.state,
          ariaSelection = _this$state6.ariaSelection,
          focusedOption = _this$state6.focusedOption,
          focusedValue = _this$state6.focusedValue,
          isFocused = _this$state6.isFocused,
          selectValue = _this$state6.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return /*#__PURE__*/React.createElement(LiveRegion, _extends$1({}, commonProps, {
        id: this.getElementId('live-region'),
        ariaSelection: ariaSelection,
        focusedOption: focusedOption,
        focusedValue: focusedValue,
        isFocused: isFocused,
        selectValue: selectValue,
        focusableOptions: focusableOptions
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getComponents8 = this.getComponents(),
          Control = _this$getComponents8.Control,
          IndicatorsContainer = _this$getComponents8.IndicatorsContainer,
          SelectContainer = _this$getComponents8.SelectContainer,
          ValueContainer = _this$getComponents8.ValueContainer;

      var _this$props14 = this.props,
          className = _this$props14.className,
          id = _this$props14.id,
          isDisabled = _this$props14.isDisabled,
          menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /*#__PURE__*/React.createElement(SelectContainer, _extends$1({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), /*#__PURE__*/React.createElement(Control, _extends$1({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), /*#__PURE__*/React.createElement(ValueContainer, _extends$1({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/React.createElement(IndicatorsContainer, _extends$1({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps,
          clearFocusValueOnUpdate = state.clearFocusValueOnUpdate,
          inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate,
          ariaSelection = state.ariaSelection,
          isFocused = state.isFocused,
          prevWasFocused = state.prevWasFocused;
      var options = props.options,
          value = props.value,
          menuIsOpen = props.menuIsOpen,
          inputValue = props.inputValue,
          isMulti = props.isMulti;
      var selectValue = cleanValue(value);
      var newMenuOptionsState = {};

      if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption = getNextFocusedOption(state, focusableOptions);
        newMenuOptionsState = {
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedValue: focusedValue,
          clearFocusValueOnUpdate: false
        };
      } // some updates should toggle the state of the input visibility


      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: undefined
      } : {};
      var newAriaSelection = ariaSelection;
      var hasKeptFocus = isFocused && prevWasFocused;

      if (isFocused && !hasKeptFocus) {
        // If `value` or `defaultValue` props are not empty then announce them
        // when the Select is initially focused
        newAriaSelection = {
          value: valueTernary(isMulti, selectValue, selectValue[0] || null),
          options: selectValue,
          action: 'initial-input-focus'
        };
        hasKeptFocus = !prevWasFocused;
      } // If the 'initial-input-focus' action has been set already
      // then reset the ariaSelection to null


      if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') {
        newAriaSelection = null;
      }

      return _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props,
        ariaSelection: newAriaSelection,
        prevWasFocused: hasKeptFocus
      });
    }
  }]);

  return Select;
}(Component);

Select$1.defaultProps = defaultProps;

var StateManagedSelect = /*#__PURE__*/forwardRef(function (props, ref) {
  var baseSelectProps = useStateManager(props);
  return /*#__PURE__*/React.createElement(Select$1, _extends$1({
    ref: ref
  }, baseSelectProps));
});

var Select = StateManagedSelect;

/*!
 * Font Awesome Free 6.1.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2022 Fonticons, Inc.
 */
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof$1(obj) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$1(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest();
}

function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1();
}

function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var noop = function noop() {};

var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};

try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}

var _ref = _WINDOW.navigator || {},
    _ref$userAgent = _ref.userAgent,
    userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;
var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var MUTATION_OBSERVER = _MUTATION_OBSERVER;
var PERFORMANCE = _PERFORMANCE;
!!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var UNITS_IN_GRID = 16;
var DEFAULT_FAMILY_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';
var DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
var DATA_PREFIX = 'data-prefix';
var DATA_ICON = 'data-icon';
var HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var MUTATION_APPROACH_ASYNC = 'async';
var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ['HTML', 'HEAD', 'STYLE', 'SCRIPT'];
var PRODUCTION$1 = function () {
  try {
    return "development" === 'production';
  } catch (e) {
    return false;
  }
}();
var PREFIX_TO_STYLE = {
  'fas': 'solid',
  'fa-solid': 'solid',
  'far': 'regular',
  'fa-regular': 'regular',
  'fal': 'light',
  'fa-light': 'light',
  'fat': 'thin',
  'fa-thin': 'thin',
  'fad': 'duotone',
  'fa-duotone': 'duotone',
  'fab': 'brands',
  'fa-brands': 'brands',
  'fak': 'kit',
  'fa-kit': 'kit',
  'fa': 'solid'
};
var STYLE_TO_PREFIX = {
  'solid': 'fas',
  'regular': 'far',
  'light': 'fal',
  'thin': 'fat',
  'duotone': 'fad',
  'brands': 'fab',
  'kit': 'fak'
};
var PREFIX_TO_LONG_STYLE = {
  'fab': 'fa-brands',
  'fad': 'fa-duotone',
  'fak': 'fa-kit',
  'fal': 'fa-light',
  'far': 'fa-regular',
  'fas': 'fa-solid',
  'fat': 'fa-thin'
};
var LONG_STYLE_TO_PREFIX = {
  'fa-brands': 'fab',
  'fa-duotone': 'fad',
  'fa-kit': 'fak',
  'fa-light': 'fal',
  'fa-regular': 'far',
  'fa-solid': 'fas',
  'fa-thin': 'fat'
};
var ICON_SELECTION_SYNTAX_PATTERN = /fa[srltdbk\-\ ]/; // eslint-disable-line no-useless-escape

var LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Kit)?.*/i; // TODO: do we need to handle font-weight for kit SVG pseudo-elements?

var FONT_WEIGHT_TO_PREFIX = {
  '900': 'fas',
  '400': 'far',
  'normal': 'far',
  '300': 'fal',
  '100': 'fat'
};
var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
var ATTRIBUTES_WATCHED_FOR_MUTATION = ['class', 'data-prefix', 'data-icon', 'data-fa-transform', 'data-fa-mask'];
var DUOTONE_CLASSES = {
  GROUP: 'duotone-group',
  SWAP_OPACITY: 'swap-opacity',
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};
var RESERVED_CLASSES = [].concat(_toConsumableArray$1(Object.keys(STYLE_TO_PREFIX)), ['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', 'beat', 'border', 'fade', 'beat-fade', 'bounce', 'flip-both', 'flip-horizontal', 'flip-vertical', 'flip', 'fw', 'inverse', 'layers-counter', 'layers-text', 'layers', 'li', 'pull-left', 'pull-right', 'pulse', 'rotate-180', 'rotate-270', 'rotate-90', 'rotate-by', 'shake', 'spin-pulse', 'spin-reverse', 'spin', 'stack-1x', 'stack-2x', 'stack', 'ul', DUOTONE_CLASSES.GROUP, DUOTONE_CLASSES.SWAP_OPACITY, DUOTONE_CLASSES.PRIMARY, DUOTONE_CLASSES.SECONDARY]).concat(oneToTen.map(function (n) {
  return "".concat(n, "x");
})).concat(oneToTwenty.map(function (n) {
  return "w-".concat(n);
}));

var initial = WINDOW.FontAwesomeConfig || {};

function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');

  if (element) {
    return element.getAttribute(attr);
  }
}

function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}

if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  var attrs = [['data-family-prefix', 'familyPrefix'], ['data-style-default', 'styleDefault'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
  attrs.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        attr = _ref2[0],
        key = _ref2[1];

    var val = coerce(getAttrConfig(attr));

    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}

var _default = {
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  styleDefault: 'solid',
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: 'async',
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};

var _config = _objectSpread2$1(_objectSpread2$1({}, _default), initial);

if (!_config.autoReplaceSvg) _config.observeMutations = false;
var config = {};
Object.keys(_config).forEach(function (key) {
  Object.defineProperty(config, key, {
    enumerable: true,
    set: function set(val) {
      _config[key] = val;

      _onChangeCb.forEach(function (cb) {
        return cb(config);
      });
    },
    get: function get() {
      return _config[key];
    }
  });
});
WINDOW.FontAwesomeConfig = config;
var _onChangeCb = [];
function onChange(cb) {
  _onChangeCb.push(cb);

  return function () {
    _onChangeCb.splice(_onChangeCb.indexOf(cb), 1);
  };
}

var d = UNITS_IN_GRID;
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }

  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;

  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();

    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }

  DOCUMENT.head.insertBefore(style, beforeChild);
  return css;
}
var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function nextUniqueId() {
  var size = 12;
  var id = '';

  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }

  return id;
}
function toArray(obj) {
  var array = [];

  for (var i = (obj || []).length >>> 0; i--;) {
    array[i] = obj[i];
  }

  return array;
}
function classArray(node) {
  if (node.classList) {
    return toArray(node.classList);
  } else {
    return (node.getAttribute('class') || '').split(' ').filter(function (i) {
      return i;
    });
  }
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
  }, '').trim();
}
function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
  }, '');
}
function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref) {
  var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}
function transformForCss(_ref2) {
  var transform = _ref2.transform,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height,
      _ref2$startCentered = _ref2.startCentered,
      startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
  var val = '';

  if (startCentered && IS_IE) {
    val += "translate(".concat(transform.x / d - width / 2, "em, ").concat(transform.y / d - height / 2, "em) ");
  } else if (startCentered) {
    val += "translate(calc(-50% + ".concat(transform.x / d, "em), calc(-50% + ").concat(transform.y / d, "em)) ");
  } else {
    val += "translate(".concat(transform.x / d, "em, ").concat(transform.y / d, "em) ");
  }

  val += "scale(".concat(transform.size / d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d * (transform.flipY ? -1 : 1), ") ");
  val += "rotate(".concat(transform.rotate, "deg) ");
  return val;
}

var baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Solid\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Regular\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Light\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Thin\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}";

function css() {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.familyPrefix;
  var rc = config.replacementClass;
  var s = baseStyles;

  if (fp !== dfp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
    var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), 'g');
    var rPatt = new RegExp("\\.".concat(drc), 'g');
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }

  return s;
}

var _cssInserted = false;

function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());
    _cssInserted = true;
  }
}

var InjectCSS = {
  mixout: function mixout() {
    return {
      dom: {
        css: css,
        insertCss: ensureCss
      }
    };
  },
  hooks: function hooks() {
    return {
      beforeDOMElementCreation: function beforeDOMElementCreation() {
        ensureCss();
      },
      beforeI2svg: function beforeI2svg() {
        ensureCss();
      }
    };
  }
};

var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];

var functions = [];

var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};

var loaded = false;

if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}

function domready (fn) {
  if (!IS_DOM) return;
  loaded ? setTimeout(fn, 0) : functions.push(fn);
}

function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;

  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
  }
}

function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */

var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};

/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */


var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
      length = keys.length,
      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i,
      key,
      result;

  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }

  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }

  return result;
};

/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
function ucs2decode(string) {
  var output = [];
  var counter = 0;
  var length = string.length;

  while (counter < length) {
    var value = string.charCodeAt(counter++);

    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      var extra = string.charCodeAt(counter++);

      if ((extra & 0xFC00) == 0xDC00) {
        // eslint-disable-line eqeqeq
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }

  return output;
}

function toHex(unicode) {
  var decoded = ucs2decode(unicode);
  return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function codePointAt(string, index) {
  var size = string.length;
  var first = string.charCodeAt(index);
  var second;

  if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
    second = string.charCodeAt(index + 1);

    if (second >= 0xDC00 && second <= 0xDFFF) {
      return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
  }

  return first;
}

function normalizeIcons(icons) {
  return Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;

    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }

    return acc;
  }, {});
}

function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks,
      skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = normalizeIcons(icons);

  if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
    namespace.hooks.addPack(prefix, normalizeIcons(icons));
  } else {
    namespace.styles[prefix] = _objectSpread2$1(_objectSpread2$1({}, namespace.styles[prefix] || {}), normalized);
  }
  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */


  if (prefix === 'fas') {
    defineIcons('fa', icons);
  }
}

var styles = namespace.styles,
    shims = namespace.shims;
var LONG_STYLE = Object.values(PREFIX_TO_LONG_STYLE);
var _defaultUsablePrefix = null;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};
var _byOldUnicode = {};
var _byAlias = {};
var PREFIXES = Object.keys(PREFIX_TO_STYLE);

function isReserved(name) {
  return ~RESERVED_CLASSES.indexOf(name);
}

function getIconName(familyPrefix, cls) {
  var parts = cls.split('-');
  var prefix = parts[0];
  var iconName = parts.slice(1).join('-');

  if (prefix === familyPrefix && iconName !== '' && !isReserved(iconName)) {
    return iconName;
  } else {
    return null;
  }
}
var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce(styles, function (o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };

  _byUnicode = lookup(function (acc, icon, iconName) {
    if (icon[3]) {
      acc[icon[3]] = iconName;
    }

    if (icon[2]) {
      var aliases = icon[2].filter(function (a) {
        return typeof a === 'number';
      });
      aliases.forEach(function (alias) {
        acc[alias.toString(16)] = iconName;
      });
    }

    return acc;
  });
  _byLigature = lookup(function (acc, icon, iconName) {
    acc[iconName] = iconName;

    if (icon[2]) {
      var aliases = icon[2].filter(function (a) {
        return typeof a === 'string';
      });
      aliases.forEach(function (alias) {
        acc[alias] = iconName;
      });
    }

    return acc;
  });
  _byAlias = lookup(function (acc, icon, iconName) {
    var aliases = icon[2];
    acc[iconName] = iconName;
    aliases.forEach(function (alias) {
      acc[alias] = iconName;
    });
    return acc;
  }); // If we have a Kit, we can't determine if regular is available since we
  // could be auto-fetching it. We'll have to assume that it is available.

  var hasRegular = 'far' in styles || config.autoFetchSvg;
  var shimLookups = reduce(shims, function (acc, shim) {
    var maybeNameMaybeUnicode = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];

    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }

    if (typeof maybeNameMaybeUnicode === 'string') {
      acc.names[maybeNameMaybeUnicode] = {
        prefix: prefix,
        iconName: iconName
      };
    }

    if (typeof maybeNameMaybeUnicode === 'number') {
      acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
        prefix: prefix,
        iconName: iconName
      };
    }

    return acc;
  }, {
    names: {},
    unicodes: {}
  });
  _byOldName = shimLookups.names;
  _byOldUnicode = shimLookups.unicodes;
  _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault);
};
onChange(function (c) {
  _defaultUsablePrefix = getCanonicalPrefix(c.styleDefault);
});
build();
function byUnicode(prefix, unicode) {
  return (_byUnicode[prefix] || {})[unicode];
}
function byLigature(prefix, ligature) {
  return (_byLigature[prefix] || {})[ligature];
}
function byAlias(prefix, alias) {
  return (_byAlias[prefix] || {})[alias];
}
function byOldName(name) {
  return _byOldName[name] || {
    prefix: null,
    iconName: null
  };
}
function byOldUnicode(unicode) {
  var oldUnicode = _byOldUnicode[unicode];
  var newUnicode = byUnicode('fas', unicode);
  return oldUnicode || (newUnicode ? {
    prefix: 'fas',
    iconName: newUnicode
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function getDefaultUsablePrefix() {
  return _defaultUsablePrefix;
}
var emptyCanonicalIcon = function emptyCanonicalIcon() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function getCanonicalPrefix(styleOrPrefix) {
  var style = PREFIX_TO_STYLE[styleOrPrefix];
  var prefix = STYLE_TO_PREFIX[styleOrPrefix] || STYLE_TO_PREFIX[style];
  var defined = styleOrPrefix in namespace.styles ? styleOrPrefix : null;
  return prefix || defined || null;
}
function getCanonicalIcon(values) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$skipLookups = params.skipLookups,
      skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
  var givenPrefix = null;
  var canonical = values.reduce(function (acc, cls) {
    var iconName = getIconName(config.familyPrefix, cls);

    if (styles[cls]) {
      cls = LONG_STYLE.includes(cls) ? LONG_STYLE_TO_PREFIX[cls] : cls;
      givenPrefix = cls;
      acc.prefix = cls;
    } else if (PREFIXES.indexOf(cls) > -1) {
      givenPrefix = cls;
      acc.prefix = getCanonicalPrefix(cls);
    } else if (iconName) {
      acc.iconName = iconName;
    } else if (cls !== config.replacementClass) {
      acc.rest.push(cls);
    }

    if (!skipLookups && acc.prefix && acc.iconName) {
      var shim = givenPrefix === 'fa' ? byOldName(acc.iconName) : {};
      var aliasIconName = byAlias(acc.prefix, acc.iconName);

      if (shim.prefix) {
        givenPrefix = null;
      }

      acc.iconName = shim.iconName || aliasIconName || acc.iconName;
      acc.prefix = shim.prefix || acc.prefix;

      if (acc.prefix === 'far' && !styles['far'] && styles['fas'] && !config.autoFetchSvg) {
        // Allow a fallback from the regular style to solid if regular is not available
        // but only if we aren't auto-fetching SVGs
        acc.prefix = 'fas';
      }
    }

    return acc;
  }, emptyCanonicalIcon());

  if (canonical.prefix === 'fa' || givenPrefix === 'fa') {
    // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = getDefaultUsablePrefix() || 'fas';
  }

  return canonical;
}

var Library = /*#__PURE__*/function () {
  function Library() {
    _classCallCheck(this, Library);

    this.definitions = {};
  }

  _createClass(Library, [{
    key: "add",
    value: function add() {
      var _this = this;

      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _objectSpread2$1(_objectSpread2$1({}, _this.definitions[key] || {}), additions[key]);
        defineIcons(key, additions[key]);
        var longPrefix = PREFIX_TO_LONG_STYLE[key];
        if (longPrefix) defineIcons(longPrefix, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
            prefix = _normalized$key.prefix,
            iconName = _normalized$key.iconName,
            icon = _normalized$key.icon;
        var aliases = icon[2];
        if (!additions[prefix]) additions[prefix] = {};

        if (aliases.length > 0) {
          aliases.forEach(function (alias) {
            if (typeof alias === 'string') {
              additions[prefix][alias] = icon;
            }
          });
        }

        additions[prefix][iconName] = icon;
      });
      return additions;
    }
  }]);

  return Library;
}();

var _plugins = [];
var _hooks = {};
var providers = {};
var defaultProviderKeys = Object.keys(providers);
function registerPlugins(nextPlugins, _ref) {
  var obj = _ref.mixoutsTo;
  _plugins = nextPlugins;
  _hooks = {};
  Object.keys(providers).forEach(function (k) {
    if (defaultProviderKeys.indexOf(k) === -1) {
      delete providers[k];
    }
  });

  _plugins.forEach(function (plugin) {
    var mixout = plugin.mixout ? plugin.mixout() : {};
    Object.keys(mixout).forEach(function (tk) {
      if (typeof mixout[tk] === 'function') {
        obj[tk] = mixout[tk];
      }

      if (_typeof$1(mixout[tk]) === 'object') {
        Object.keys(mixout[tk]).forEach(function (sk) {
          if (!obj[tk]) {
            obj[tk] = {};
          }

          obj[tk][sk] = mixout[tk][sk];
        });
      }
    });

    if (plugin.hooks) {
      var hooks = plugin.hooks();
      Object.keys(hooks).forEach(function (hook) {
        if (!_hooks[hook]) {
          _hooks[hook] = [];
        }

        _hooks[hook].push(hooks[hook]);
      });
    }

    if (plugin.provides) {
      plugin.provides(providers);
    }
  });

  return obj;
}
function chainHooks(hook, accumulator) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    accumulator = hookFn.apply(null, [accumulator].concat(args)); // eslint-disable-line no-useless-call
  });
  return accumulator;
}
function callHooks(hook) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    hookFn.apply(null, args);
  });
  return undefined;
}
function callProvided() {
  var hook = arguments[0];
  var args = Array.prototype.slice.call(arguments, 1);
  return providers[hook] ? providers[hook].apply(null, args) : undefined;
}

function findIconDefinition(iconLookup) {
  if (iconLookup.prefix === 'fa') {
    iconLookup.prefix = 'fas';
  }

  var iconName = iconLookup.iconName;
  var prefix = iconLookup.prefix || getDefaultUsablePrefix();
  if (!iconName) return;
  iconName = byAlias(prefix, iconName) || iconName;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}
var library = new Library();
var noAuto = function noAuto() {
  config.autoReplaceSvg = false;
  config.observeMutations = false;
  callHooks('noAuto');
};
var dom = {
  i2svg: function i2svg() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (IS_DOM) {
      callHooks('beforeI2svg', params);
      callProvided('pseudoElements2svg', params);
      return callProvided('i2svg', params);
    } else {
      return Promise.reject('Operation requires a DOM of some kind.');
    }
  },
  watch: function watch() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var autoReplaceSvgRoot = params.autoReplaceSvgRoot;

    if (config.autoReplaceSvg === false) {
      config.autoReplaceSvg = true;
    }

    config.observeMutations = true;
    domready(function () {
      autoReplace({
        autoReplaceSvgRoot: autoReplaceSvgRoot
      });
      callHooks('watch', params);
    });
  }
};
var parse = {
  icon: function icon(_icon) {
    if (_icon === null) {
      return null;
    }

    if (_typeof$1(_icon) === 'object' && _icon.prefix && _icon.iconName) {
      return {
        prefix: _icon.prefix,
        iconName: byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
      };
    }

    if (Array.isArray(_icon) && _icon.length === 2) {
      var iconName = _icon[1].indexOf('fa-') === 0 ? _icon[1].slice(3) : _icon[1];
      var prefix = getCanonicalPrefix(_icon[0]);
      return {
        prefix: prefix,
        iconName: byAlias(prefix, iconName) || iconName
      };
    }

    if (typeof _icon === 'string' && (_icon.indexOf("".concat(config.familyPrefix, "-")) > -1 || _icon.match(ICON_SELECTION_SYNTAX_PATTERN))) {
      var canonicalIcon = getCanonicalIcon(_icon.split(' '), {
        skipLookups: true
      });
      return {
        prefix: canonicalIcon.prefix || getDefaultUsablePrefix(),
        iconName: byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
      };
    }

    if (typeof _icon === 'string') {
      var _prefix = getDefaultUsablePrefix();

      return {
        prefix: _prefix,
        iconName: byAlias(_prefix, _icon) || _icon
      };
    }
  }
};
var api = {
  noAuto: noAuto,
  config: config,
  dom: dom,
  parse: parse,
  library: library,
  findIconDefinition: findIconDefinition,
  toHtml: toHtml
};

var autoReplace = function autoReplace() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$autoReplaceSv = params.autoReplaceSvgRoot,
      autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
  if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
    node: autoReplaceSvgRoot
  });
};

function domVariants(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });
  Object.defineProperty(val, 'html', {
    get: function get() {
      return val.abstract.map(function (a) {
        return toHtml(a);
      });
    }
  });
  Object.defineProperty(val, 'node', {
    get: function get() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}

function asIcon (_ref) {
  var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;

  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
        height = main.height;
    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_objectSpread2$1(_objectSpread2$1({}, styles), {}, {
      'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
    }));
  }

  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
}

function asSymbol (_ref) {
  var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _objectSpread2$1(_objectSpread2$1({}, attributes), {}, {
        id: id
      }),
      children: children
    }]
  }];
}

function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      maskId = params.maskId,
      titleId = params.titleId,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === void 0 ? false : _params$watchable;

  var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;

  var isUploadedIcon = prefix === 'fak';
  var attrClass = [config.replacementClass, iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : ''].filter(function (c) {
    return extra.classes.indexOf(c) === -1;
  }).filter(function (c) {
    return c !== '' || !!c;
  }).concat(extra.classes).join(' ');
  var content = {
    children: [],
    attributes: _objectSpread2$1(_objectSpread2$1({}, extra.attributes), {}, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': extra.attributes.role || 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': "0 0 ".concat(width, " ").concat(height)
    })
  };
  var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
    width: "".concat(width / height * 16 * 0.0625, "em")
  } : {};

  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }

  if (title) {
    content.children.push({
      tag: 'title',
      attributes: {
        id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
      },
      children: [title]
    });
    delete content.attributes.title;
  }

  var args = _objectSpread2$1(_objectSpread2$1({}, content), {}, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    maskId: maskId,
    transform: transform,
    symbol: symbol,
    styles: _objectSpread2$1(_objectSpread2$1({}, uploadedIconWidthStyle), extra.styles)
  });

  var _ref2 = mask.found && main.found ? callProvided('generateAbstractMask', args) || {
    children: [],
    attributes: {}
  } : callProvided('generateAbstractIcon', args) || {
    children: [],
    attributes: {}
  },
      children = _ref2.children,
      attributes = _ref2.attributes;

  args.children = children;
  args.attributes = attributes;

  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}
function makeLayersTextAbstract(params) {
  var content = params.content,
      width = params.width,
      height = params.height,
      transform = params.transform,
      title = params.title,
      extra = params.extra,
      _params$watchable2 = params.watchable,
      watchable = _params$watchable2 === void 0 ? false : _params$watchable2;

  var attributes = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });

  if (watchable) {
    attributes[DATA_FA_I2SVG] = '';
  }

  var styles = _objectSpread2$1({}, extra.styles);

  if (transformIsMeaningful(transform)) {
    styles['transform'] = transformForCss({
      transform: transform,
      startCentered: true,
      width: width,
      height: height
    });
    styles['-webkit-transform'] = styles['transform'];
  }

  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}
function makeLayersCounterAbstract(params) {
  var content = params.content,
      title = params.title,
      extra = params.extra;

  var attributes = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });

  var styleString = joinStyles(extra.styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}

var styles$1 = namespace.styles;
function asFoundIcon(icon) {
  var width = icon[0];
  var height = icon[1];

  var _icon$slice = icon.slice(4),
      _icon$slice2 = _slicedToArray(_icon$slice, 1),
      vectorData = _icon$slice2[0];

  var element = null;

  if (Array.isArray(vectorData)) {
    element = {
      tag: 'g',
      attributes: {
        class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: 'currentColor',
          d: vectorData[0]
        }
      }, {
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: 'currentColor',
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: 'path',
      attributes: {
        fill: 'currentColor',
        d: vectorData
      }
    };
  }

  return {
    found: true,
    width: width,
    height: height,
    icon: element
  };
}
var missingIconResolutionMixin = {
  found: false,
  width: 512,
  height: 512
};

function maybeNotifyMissing(iconName, prefix) {
  if (!PRODUCTION$1 && !config.showMissingIcons && iconName) {
    console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
  }
}

function findIcon(iconName, prefix) {
  var givenPrefix = prefix;

  if (prefix === 'fa' && config.styleDefault !== null) {
    prefix = getDefaultUsablePrefix();
  }

  return new Promise(function (resolve, reject) {
    ({
      found: false,
      width: 512,
      height: 512,
      icon: callProvided('missingIconAbstract') || {}
    });

    if (givenPrefix === 'fa') {
      var shim = byOldName(iconName) || {};
      iconName = shim.iconName || iconName;
      prefix = shim.prefix || prefix;
    }

    if (iconName && prefix && styles$1[prefix] && styles$1[prefix][iconName]) {
      var icon = styles$1[prefix][iconName];
      return resolve(asFoundIcon(icon));
    }

    maybeNotifyMissing(iconName, prefix);
    resolve(_objectSpread2$1(_objectSpread2$1({}, missingIconResolutionMixin), {}, {
      icon: config.showMissingIcons && iconName ? callProvided('missingIconAbstract') || {} : {}
    }));
  });
}

var noop$1 = function noop() {};

var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};
var preamble = "FA \"6.1.1\"";

var begin = function begin(name) {
  p.mark("".concat(preamble, " ").concat(name, " begins"));
  return function () {
    return end(name);
  };
};

var end = function end(name) {
  p.mark("".concat(preamble, " ").concat(name, " ends"));
  p.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
};

var perf = {
  begin: begin,
  end: end
};

var noop$2 = function noop() {};

function isWatched(node) {
  var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
  return typeof i2svg === 'string';
}

function hasPrefixAndIcon(node) {
  var prefix = node.getAttribute ? node.getAttribute(DATA_PREFIX) : null;
  var icon = node.getAttribute ? node.getAttribute(DATA_ICON) : null;
  return prefix && icon;
}

function hasBeenReplaced(node) {
  return node && node.classList && node.classList.contains && node.classList.contains(config.replacementClass);
}

function getMutator() {
  if (config.autoReplaceSvg === true) {
    return mutators.replace;
  }

  var mutator = mutators[config.autoReplaceSvg];
  return mutator || mutators.replace;
}

function createElementNS(tag) {
  return DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}

function createElement(tag) {
  return DOCUMENT.createElement(tag);
}

function convertSVG(abstractObj) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$ceFn = params.ceFn,
      ceFn = _params$ceFn === void 0 ? abstractObj.tag === 'svg' ? createElementNS : createElement : _params$ceFn;

  if (typeof abstractObj === 'string') {
    return DOCUMENT.createTextNode(abstractObj);
  }

  var tag = ceFn(abstractObj.tag);
  Object.keys(abstractObj.attributes || []).forEach(function (key) {
    tag.setAttribute(key, abstractObj.attributes[key]);
  });
  var children = abstractObj.children || [];
  children.forEach(function (child) {
    tag.appendChild(convertSVG(child, {
      ceFn: ceFn
    }));
  });
  return tag;
}

function nodeAsComment(node) {
  var comment = " ".concat(node.outerHTML, " ");
  /* BEGIN.ATTRIBUTION */

  comment = "".concat(comment, "Font Awesome fontawesome.com ");
  /* END.ATTRIBUTION */

  return comment;
}

var mutators = {
  replace: function replace(mutation) {
    var node = mutation[0];

    if (node.parentNode) {
      mutation[1].forEach(function (abstract) {
        node.parentNode.insertBefore(convertSVG(abstract), node);
      });

      if (node.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
        var comment = DOCUMENT.createComment(nodeAsComment(node));
        node.parentNode.replaceChild(comment, node);
      } else {
        node.remove();
      }
    }
  },
  nest: function nest(mutation) {
    var node = mutation[0];
    var abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
    // Short-circuit to the standard replacement

    if (~classArray(node).indexOf(config.replacementClass)) {
      return mutators.replace(mutation);
    }

    var forSvg = new RegExp("".concat(config.familyPrefix, "-.*"));
    delete abstract[0].attributes.id;

    if (abstract[0].attributes.class) {
      var splitClasses = abstract[0].attributes.class.split(' ').reduce(function (acc, cls) {
        if (cls === config.replacementClass || cls.match(forSvg)) {
          acc.toSvg.push(cls);
        } else {
          acc.toNode.push(cls);
        }

        return acc;
      }, {
        toNode: [],
        toSvg: []
      });
      abstract[0].attributes.class = splitClasses.toSvg.join(' ');

      if (splitClasses.toNode.length === 0) {
        node.removeAttribute('class');
      } else {
        node.setAttribute('class', splitClasses.toNode.join(' '));
      }
    }

    var newInnerHTML = abstract.map(function (a) {
      return toHtml(a);
    }).join('\n');
    node.setAttribute(DATA_FA_I2SVG, '');
    node.innerHTML = newInnerHTML;
  }
};

function performOperationSync(op) {
  op();
}

function perform(mutations, callback) {
  var callbackFunction = typeof callback === 'function' ? callback : noop$2;

  if (mutations.length === 0) {
    callbackFunction();
  } else {
    var frame = performOperationSync;

    if (config.mutateApproach === MUTATION_APPROACH_ASYNC) {
      frame = WINDOW.requestAnimationFrame || performOperationSync;
    }

    frame(function () {
      var mutator = getMutator();
      var mark = perf.begin('mutate');
      mutations.map(mutator);
      mark();
      callbackFunction();
    });
  }
}
var disabled = false;
function disableObservation() {
  disabled = true;
}
function enableObservation() {
  disabled = false;
}
var mo = null;
function observe(options) {
  if (!MUTATION_OBSERVER) {
    return;
  }

  if (!config.observeMutations) {
    return;
  }

  var _options$treeCallback = options.treeCallback,
      treeCallback = _options$treeCallback === void 0 ? noop$2 : _options$treeCallback,
      _options$nodeCallback = options.nodeCallback,
      nodeCallback = _options$nodeCallback === void 0 ? noop$2 : _options$nodeCallback,
      _options$pseudoElemen = options.pseudoElementsCallback,
      pseudoElementsCallback = _options$pseudoElemen === void 0 ? noop$2 : _options$pseudoElemen,
      _options$observeMutat = options.observeMutationsRoot,
      observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
  mo = new MUTATION_OBSERVER(function (objects) {
    if (disabled) return;
    var defaultPrefix = getDefaultUsablePrefix();
    toArray(objects).forEach(function (mutationRecord) {
      if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
        if (config.searchPseudoElements) {
          pseudoElementsCallback(mutationRecord.target);
        }

        treeCallback(mutationRecord.target);
      }

      if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config.searchPseudoElements) {
        pseudoElementsCallback(mutationRecord.target.parentNode);
      }

      if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
        if (mutationRecord.attributeName === 'class' && hasPrefixAndIcon(mutationRecord.target)) {
          var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)),
              prefix = _getCanonicalIcon.prefix,
              iconName = _getCanonicalIcon.iconName;

          mutationRecord.target.setAttribute(DATA_PREFIX, prefix || defaultPrefix);
          if (iconName) mutationRecord.target.setAttribute(DATA_ICON, iconName);
        } else if (hasBeenReplaced(mutationRecord.target)) {
          nodeCallback(mutationRecord.target);
        }
      }
    });
  });
  if (!IS_DOM) return;
  mo.observe(observeMutationsRoot, {
    childList: true,
    attributes: true,
    characterData: true,
    subtree: true
  });
}
function disconnect() {
  if (!mo) return;
  mo.disconnect();
}

function styleParser (node) {
  var style = node.getAttribute('style');
  var val = [];

  if (style) {
    val = style.split(';').reduce(function (acc, style) {
      var styles = style.split(':');
      var prop = styles[0];
      var value = styles.slice(1);

      if (prop && value.length > 0) {
        acc[prop] = value.join(':').trim();
      }

      return acc;
    }, {});
  }

  return val;
}

function classParser (node) {
  var existingPrefix = node.getAttribute('data-prefix');
  var existingIconName = node.getAttribute('data-icon');
  var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
  var val = getCanonicalIcon(classArray(node));

  if (!val.prefix) {
    val.prefix = getDefaultUsablePrefix();
  }

  if (existingPrefix && existingIconName) {
    val.prefix = existingPrefix;
    val.iconName = existingIconName;
  }

  if (val.iconName && val.prefix) {
    return val;
  }

  if (val.prefix && innerText.length > 0) {
    val.iconName = byLigature(val.prefix, node.innerText) || byUnicode(val.prefix, toHex(node.innerText));
  }

  return val;
}

function attributesParser (node) {
  var extraAttributes = toArray(node.attributes).reduce(function (acc, attr) {
    if (acc.name !== 'class' && acc.name !== 'style') {
      acc[attr.name] = attr.value;
    }

    return acc;
  }, {});
  var title = node.getAttribute('title');
  var titleId = node.getAttribute('data-fa-title-id');

  if (config.autoA11y) {
    if (title) {
      extraAttributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
    } else {
      extraAttributes['aria-hidden'] = 'true';
      extraAttributes['focusable'] = 'false';
    }
  }

  return extraAttributes;
}

function blankMeta() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: false,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(node) {
  var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    styleParser: true
  };

  var _classParser = classParser(node),
      iconName = _classParser.iconName,
      prefix = _classParser.prefix,
      extraClasses = _classParser.rest;

  var extraAttributes = attributesParser(node);
  var pluginMeta = chainHooks('parseNodeAttributes', {}, node);
  var extraStyles = parser.styleParser ? styleParser(node) : [];
  return _objectSpread2$1({
    iconName: iconName,
    title: node.getAttribute('title'),
    titleId: node.getAttribute('data-fa-title-id'),
    prefix: prefix,
    transform: meaninglessTransform,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: false,
    extra: {
      classes: extraClasses,
      styles: extraStyles,
      attributes: extraAttributes
    }
  }, pluginMeta);
}

var styles$2 = namespace.styles;

function generateMutation(node) {
  var nodeMeta = config.autoReplaceSvg === 'nest' ? parseMeta(node, {
    styleParser: false
  }) : parseMeta(node);

  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
    return callProvided('generateLayersText', node, nodeMeta);
  } else {
    return callProvided('generateSvgReplacementMutation', node, nodeMeta);
  }
}

function onTree(root) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!IS_DOM) return Promise.resolve();
  var htmlClassList = DOCUMENT.documentElement.classList;

  var hclAdd = function hclAdd(suffix) {
    return htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var hclRemove = function hclRemove(suffix) {
    return htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var prefixes = config.autoFetchSvg ? Object.keys(PREFIX_TO_STYLE) : Object.keys(styles$2);
  var prefixesDomQuery = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(prefixes.map(function (p) {
    return ".".concat(p, ":not([").concat(DATA_FA_I2SVG, "])");
  })).join(', ');

  if (prefixesDomQuery.length === 0) {
    return Promise.resolve();
  }

  var candidates = [];

  try {
    candidates = toArray(root.querySelectorAll(prefixesDomQuery));
  } catch (e) {// noop
  }

  if (candidates.length > 0) {
    hclAdd('pending');
    hclRemove('complete');
  } else {
    return Promise.resolve();
  }

  var mark = perf.begin('onTree');
  var mutations = candidates.reduce(function (acc, node) {
    try {
      var mutation = generateMutation(node);

      if (mutation) {
        acc.push(mutation);
      }
    } catch (e) {
      if (!PRODUCTION$1) {
        if (e.name === 'MissingIcon') {
          console.error(e);
        }
      }
    }

    return acc;
  }, []);
  return new Promise(function (resolve, reject) {
    Promise.all(mutations).then(function (resolvedMutations) {
      perform(resolvedMutations, function () {
        hclAdd('active');
        hclAdd('complete');
        hclRemove('pending');
        if (typeof callback === 'function') callback();
        mark();
        resolve();
      });
    }).catch(function (e) {
      mark();
      reject(e);
    });
  });
}

function onNode(node) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  generateMutation(node).then(function (mutation) {
    if (mutation) {
      perform([mutation], callback);
    }
  });
}

function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;

    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }

    return next(iconDefinition, _objectSpread2$1(_objectSpread2$1({}, params), {}, {
      mask: mask
    }));
  };
}

var render = function render(iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
      transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === void 0 ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === void 0 ? null : _params$mask,
      _params$maskId = params.maskId,
      maskId = _params$maskId === void 0 ? null : _params$maskId,
      _params$title = params.title,
      title = _params$title === void 0 ? null : _params$title,
      _params$titleId = params.titleId,
      titleId = _params$titleId === void 0 ? null : _params$titleId,
      _params$classes = params.classes,
      classes = _params$classes === void 0 ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === void 0 ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;
  return domVariants(_objectSpread2$1({
    type: 'icon'
  }, iconDefinition), function () {
    callHooks('beforeDOMElementCreation', {
      iconDefinition: iconDefinition,
      params: params
    });

    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes['aria-hidden'] = 'true';
        attributes['focusable'] = 'false';
      }
    }

    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _objectSpread2$1(_objectSpread2$1({}, meaninglessTransform), transform),
      symbol: symbol,
      title: title,
      maskId: maskId,
      titleId: titleId,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
};
var ReplaceElements = {
  mixout: function mixout() {
    return {
      icon: resolveIcons(render)
    };
  },
  hooks: function hooks() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.treeCallback = onTree;
        accumulator.nodeCallback = onNode;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.i2svg = function (params) {
      var _params$node = params.node,
          node = _params$node === void 0 ? DOCUMENT : _params$node,
          _params$callback = params.callback,
          callback = _params$callback === void 0 ? function () {} : _params$callback;
      return onTree(node, callback);
    };

    providers$$1.generateSvgReplacementMutation = function (node, nodeMeta) {
      var iconName = nodeMeta.iconName,
          title = nodeMeta.title,
          titleId = nodeMeta.titleId,
          prefix = nodeMeta.prefix,
          transform = nodeMeta.transform,
          symbol = nodeMeta.symbol,
          mask = nodeMeta.mask,
          maskId = nodeMeta.maskId,
          extra = nodeMeta.extra;
      return new Promise(function (resolve, reject) {
        Promise.all([findIcon(iconName, prefix), mask.iconName ? findIcon(mask.iconName, mask.prefix) : Promise.resolve({
          found: false,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              main = _ref2[0],
              mask = _ref2[1];

          resolve([node, makeInlineSvgAbstract({
            icons: {
              main: main,
              mask: mask
            },
            prefix: prefix,
            iconName: iconName,
            transform: transform,
            symbol: symbol,
            maskId: maskId,
            title: title,
            titleId: titleId,
            extra: extra,
            watchable: true
          })]);
        }).catch(reject);
      });
    };

    providers$$1.generateAbstractIcon = function (_ref3) {
      var children = _ref3.children,
          attributes = _ref3.attributes,
          main = _ref3.main,
          transform = _ref3.transform,
          styles = _ref3.styles;
      var styleString = joinStyles(styles);

      if (styleString.length > 0) {
        attributes['style'] = styleString;
      }

      var nextChild;

      if (transformIsMeaningful(transform)) {
        nextChild = callProvided('generateAbstractTransformGrouping', {
          main: main,
          transform: transform,
          containerWidth: main.width,
          iconWidth: main.width
        });
      }

      children.push(nextChild || main.icon);
      return {
        children: children,
        attributes: attributes
      };
    };
  }
};

var Layers = {
  mixout: function mixout() {
    return {
      layer: function layer(assembler) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes;
        return domVariants({
          type: 'layer'
        }, function () {
          callHooks('beforeDOMElementCreation', {
            assembler: assembler,
            params: params
          });
          var children = [];
          assembler(function (args) {
            Array.isArray(args) ? args.map(function (a) {
              children = children.concat(a.abstract);
            }) : children = children.concat(args.abstract);
          });
          return [{
            tag: 'span',
            attributes: {
              class: ["".concat(config.familyPrefix, "-layers")].concat(_toConsumableArray$1(classes)).join(' ')
            },
            children: children
          }];
        });
      }
    };
  }
};

var LayersCounter = {
  mixout: function mixout() {
    return {
      counter: function counter(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$title = params.title,
            title = _params$title === void 0 ? null : _params$title,
            _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes,
            _params$attributes = params.attributes,
            attributes = _params$attributes === void 0 ? {} : _params$attributes,
            _params$styles = params.styles,
            styles = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: 'counter',
          content: content
        }, function () {
          callHooks('beforeDOMElementCreation', {
            content: content,
            params: params
          });
          return makeLayersCounterAbstract({
            content: content.toString(),
            title: title,
            extra: {
              attributes: attributes,
              styles: styles,
              classes: ["".concat(config.familyPrefix, "-layers-counter")].concat(_toConsumableArray$1(classes))
            }
          });
        });
      }
    };
  }
};

var LayersText = {
  mixout: function mixout() {
    return {
      text: function text(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$transform = params.transform,
            transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
            _params$title = params.title,
            title = _params$title === void 0 ? null : _params$title,
            _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes,
            _params$attributes = params.attributes,
            attributes = _params$attributes === void 0 ? {} : _params$attributes,
            _params$styles = params.styles,
            styles = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: 'text',
          content: content
        }, function () {
          callHooks('beforeDOMElementCreation', {
            content: content,
            params: params
          });
          return makeLayersTextAbstract({
            content: content,
            transform: _objectSpread2$1(_objectSpread2$1({}, meaninglessTransform), transform),
            title: title,
            extra: {
              attributes: attributes,
              styles: styles,
              classes: ["".concat(config.familyPrefix, "-layers-text")].concat(_toConsumableArray$1(classes))
            }
          });
        });
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.generateLayersText = function (node, nodeMeta) {
      var title = nodeMeta.title,
          transform = nodeMeta.transform,
          extra = nodeMeta.extra;
      var width = null;
      var height = null;

      if (IS_IE) {
        var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
        var boundingClientRect = node.getBoundingClientRect();
        width = boundingClientRect.width / computedFontSize;
        height = boundingClientRect.height / computedFontSize;
      }

      if (config.autoA11y && !title) {
        extra.attributes['aria-hidden'] = 'true';
      }

      return Promise.resolve([node, makeLayersTextAbstract({
        content: node.innerHTML,
        width: width,
        height: height,
        transform: transform,
        title: title,
        extra: extra,
        watchable: true
      })]);
    };
  }
};

var CLEAN_CONTENT_PATTERN = new RegExp("\"", 'ug');
var SECONDARY_UNICODE_RANGE = [1105920, 1112319];
function hexValueFromContent(content) {
  var cleaned = content.replace(CLEAN_CONTENT_PATTERN, '');
  var codePoint = codePointAt(cleaned, 0);
  var isPrependTen = codePoint >= SECONDARY_UNICODE_RANGE[0] && codePoint <= SECONDARY_UNICODE_RANGE[1];
  var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
  return {
    value: isDoubled ? toHex(cleaned[0]) : toHex(cleaned),
    isSecondary: isPrependTen || isDoubled
  };
}

function replaceForPosition(node, position) {
  var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
  return new Promise(function (resolve, reject) {
    if (node.getAttribute(pendingAttribute) !== null) {
      // This node is already being processed
      return resolve();
    }

    var children = toArray(node.children);
    var alreadyProcessedPseudoElement = children.filter(function (c) {
      return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position;
    })[0];
    var styles = WINDOW.getComputedStyle(node, position);
    var fontFamily = styles.getPropertyValue('font-family').match(FONT_FAMILY_PATTERN);
    var fontWeight = styles.getPropertyValue('font-weight');
    var content = styles.getPropertyValue('content');

    if (alreadyProcessedPseudoElement && !fontFamily) {
      // If we've already processed it but the current computed style does not result in a font-family,
      // that probably means that a class name that was previously present to make the icon has been
      // removed. So we now should delete the icon.
      node.removeChild(alreadyProcessedPseudoElement);
      return resolve();
    } else if (fontFamily && content !== 'none' && content !== '') {
      var _content = styles.getPropertyValue('content');

      var prefix = ~['Solid', 'Regular', 'Light', 'Thin', 'Duotone', 'Brands', 'Kit'].indexOf(fontFamily[2]) ? STYLE_TO_PREFIX[fontFamily[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[fontWeight];

      var _hexValueFromContent = hexValueFromContent(_content),
          hexValue = _hexValueFromContent.value,
          isSecondary = _hexValueFromContent.isSecondary;

      var isV4 = fontFamily[0].startsWith('FontAwesome');
      var iconName = byUnicode(prefix, hexValue);
      var iconIdentifier = iconName;

      if (isV4) {
        var iconName4 = byOldUnicode(hexValue);

        if (iconName4.iconName && iconName4.prefix) {
          iconName = iconName4.iconName;
          prefix = iconName4.prefix;
        }
      } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
      // already done so with the same prefix and iconName


      if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
        node.setAttribute(pendingAttribute, iconIdentifier);

        if (alreadyProcessedPseudoElement) {
          // Delete the old one, since we're replacing it with a new one
          node.removeChild(alreadyProcessedPseudoElement);
        }

        var meta = blankMeta();
        var extra = meta.extra;
        extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
        findIcon(iconName, prefix).then(function (main) {
          var abstract = makeInlineSvgAbstract(_objectSpread2$1(_objectSpread2$1({}, meta), {}, {
            icons: {
              main: main,
              mask: emptyCanonicalIcon()
            },
            prefix: prefix,
            iconName: iconIdentifier,
            extra: extra,
            watchable: true
          }));
          var element = DOCUMENT.createElement('svg');

          if (position === '::before') {
            node.insertBefore(element, node.firstChild);
          } else {
            node.appendChild(element);
          }

          element.outerHTML = abstract.map(function (a) {
            return toHtml(a);
          }).join('\n');
          node.removeAttribute(pendingAttribute);
          resolve();
        }).catch(reject);
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
}

function replace(node) {
  return Promise.all([replaceForPosition(node, '::before'), replaceForPosition(node, '::after')]);
}

function processable(node) {
  return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}

function searchPseudoElements(root) {
  if (!IS_DOM) return;
  return new Promise(function (resolve, reject) {
    var operations = toArray(root.querySelectorAll('*')).filter(processable).map(replace);
    var end = perf.begin('searchPseudoElements');
    disableObservation();
    Promise.all(operations).then(function () {
      end();
      enableObservation();
      resolve();
    }).catch(function () {
      end();
      enableObservation();
      reject();
    });
  });
}

var PseudoElements = {
  hooks: function hooks() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.pseudoElementsCallback = searchPseudoElements;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.pseudoElements2svg = function (params) {
      var _params$node = params.node,
          node = _params$node === void 0 ? DOCUMENT : _params$node;

      if (config.searchPseudoElements) {
        searchPseudoElements(node);
      }
    };
  }
};

var _unwatched = false;
var MutationObserver$1 = {
  mixout: function mixout() {
    return {
      dom: {
        unwatch: function unwatch() {
          disableObservation();
          _unwatched = true;
        }
      }
    };
  },
  hooks: function hooks() {
    return {
      bootstrap: function bootstrap() {
        observe(chainHooks('mutationObserverCallbacks', {}));
      },
      noAuto: function noAuto() {
        disconnect();
      },
      watch: function watch(params) {
        var observeMutationsRoot = params.observeMutationsRoot;

        if (_unwatched) {
          enableObservation();
        } else {
          observe(chainHooks('mutationObserverCallbacks', {
            observeMutationsRoot: observeMutationsRoot
          }));
        }
      }
    };
  }
};

var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };
  return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
    var parts = n.toLowerCase().split('-');
    var first = parts[0];
    var rest = parts.slice(1).join('-');

    if (first && rest === 'h') {
      acc.flipX = true;
      return acc;
    }

    if (first && rest === 'v') {
      acc.flipY = true;
      return acc;
    }

    rest = parseFloat(rest);

    if (isNaN(rest)) {
      return acc;
    }

    switch (first) {
      case 'grow':
        acc.size = acc.size + rest;
        break;

      case 'shrink':
        acc.size = acc.size - rest;
        break;

      case 'left':
        acc.x = acc.x - rest;
        break;

      case 'right':
        acc.x = acc.x + rest;
        break;

      case 'up':
        acc.y = acc.y - rest;
        break;

      case 'down':
        acc.y = acc.y + rest;
        break;

      case 'rotate':
        acc.rotate = acc.rotate + rest;
        break;
    }

    return acc;
  }, transform);
};
var PowerTransforms = {
  mixout: function mixout() {
    return {
      parse: {
        transform: function transform(transformString) {
          return parseTransformString(transformString);
        }
      }
    };
  },
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var transformString = node.getAttribute('data-fa-transform');

        if (transformString) {
          accumulator.transform = parseTransformString(transformString);
        }

        return accumulator;
      }
    };
  },
  provides: function provides(providers) {
    providers.generateAbstractTransformGrouping = function (_ref) {
      var main = _ref.main,
          transform = _ref.transform,
          containerWidth = _ref.containerWidth,
          iconWidth = _ref.iconWidth;
      var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
      };
      var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
      var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
      var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
      var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
      };
      var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
      };
      var operations = {
        outer: outer,
        inner: inner,
        path: path
      };
      return {
        tag: 'g',
        attributes: _objectSpread2$1({}, operations.outer),
        children: [{
          tag: 'g',
          attributes: _objectSpread2$1({}, operations.inner),
          children: [{
            tag: main.icon.tag,
            children: main.icon.children,
            attributes: _objectSpread2$1(_objectSpread2$1({}, main.icon.attributes), operations.path)
          }]
        }]
      };
    };
  }
};

var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};

function fillBlack(abstract) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (abstract.attributes && (abstract.attributes.fill || force)) {
    abstract.attributes.fill = 'black';
  }

  return abstract;
}

function deGroup(abstract) {
  if (abstract.tag === 'g') {
    return abstract.children;
  } else {
    return [abstract];
  }
}

var Masks = {
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var maskData = node.getAttribute('data-fa-mask');
        var mask = !maskData ? emptyCanonicalIcon() : getCanonicalIcon(maskData.split(' ').map(function (i) {
          return i.trim();
        }));

        if (!mask.prefix) {
          mask.prefix = getDefaultUsablePrefix();
        }

        accumulator.mask = mask;
        accumulator.maskId = node.getAttribute('data-fa-mask-id');
        return accumulator;
      }
    };
  },
  provides: function provides(providers) {
    providers.generateAbstractMask = function (_ref) {
      var children = _ref.children,
          attributes = _ref.attributes,
          main = _ref.main,
          mask = _ref.mask,
          explicitMaskId = _ref.maskId,
          transform = _ref.transform;
      var mainWidth = main.width,
          mainPath = main.icon;
      var maskWidth = mask.width,
          maskPath = mask.icon;
      var trans = transformForSvg({
        transform: transform,
        containerWidth: maskWidth,
        iconWidth: mainWidth
      });
      var maskRect = {
        tag: 'rect',
        attributes: _objectSpread2$1(_objectSpread2$1({}, ALL_SPACE), {}, {
          fill: 'white'
        })
      };
      var maskInnerGroupChildrenMixin = mainPath.children ? {
        children: mainPath.children.map(fillBlack)
      } : {};
      var maskInnerGroup = {
        tag: 'g',
        attributes: _objectSpread2$1({}, trans.inner),
        children: [fillBlack(_objectSpread2$1({
          tag: mainPath.tag,
          attributes: _objectSpread2$1(_objectSpread2$1({}, mainPath.attributes), trans.path)
        }, maskInnerGroupChildrenMixin))]
      };
      var maskOuterGroup = {
        tag: 'g',
        attributes: _objectSpread2$1({}, trans.outer),
        children: [maskInnerGroup]
      };
      var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
      var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
      var maskTag = {
        tag: 'mask',
        attributes: _objectSpread2$1(_objectSpread2$1({}, ALL_SPACE), {}, {
          id: maskId,
          maskUnits: 'userSpaceOnUse',
          maskContentUnits: 'userSpaceOnUse'
        }),
        children: [maskRect, maskOuterGroup]
      };
      var defs = {
        tag: 'defs',
        children: [{
          tag: 'clipPath',
          attributes: {
            id: clipId
          },
          children: deGroup(maskPath)
        }, maskTag]
      };
      children.push(defs, {
        tag: 'rect',
        attributes: _objectSpread2$1({
          fill: 'currentColor',
          'clip-path': "url(#".concat(clipId, ")"),
          mask: "url(#".concat(maskId, ")")
        }, ALL_SPACE)
      });
      return {
        children: children,
        attributes: attributes
      };
    };
  }
};

var MissingIconIndicator = {
  provides: function provides(providers) {
    var reduceMotion = false;

    if (WINDOW.matchMedia) {
      reduceMotion = WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    providers.missingIconAbstract = function () {
      var gChildren = [];
      var FILL = {
        fill: 'currentColor'
      };
      var ANIMATION_BASE = {
        attributeType: 'XML',
        repeatCount: 'indefinite',
        dur: '2s'
      }; // Ring

      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2$1(_objectSpread2$1({}, FILL), {}, {
          d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
        })
      });

      var OPACITY_ANIMATE = _objectSpread2$1(_objectSpread2$1({}, ANIMATION_BASE), {}, {
        attributeName: 'opacity'
      });

      var dot = {
        tag: 'circle',
        attributes: _objectSpread2$1(_objectSpread2$1({}, FILL), {}, {
          cx: '256',
          cy: '364',
          r: '28'
        }),
        children: []
      };

      if (!reduceMotion) {
        dot.children.push({
          tag: 'animate',
          attributes: _objectSpread2$1(_objectSpread2$1({}, ANIMATION_BASE), {}, {
            attributeName: 'r',
            values: '28;14;28;28;14;28;'
          })
        }, {
          tag: 'animate',
          attributes: _objectSpread2$1(_objectSpread2$1({}, OPACITY_ANIMATE), {}, {
            values: '1;0;1;1;0;1;'
          })
        });
      }

      gChildren.push(dot);
      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2$1(_objectSpread2$1({}, FILL), {}, {
          opacity: '1',
          d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
        }),
        children: reduceMotion ? [] : [{
          tag: 'animate',
          attributes: _objectSpread2$1(_objectSpread2$1({}, OPACITY_ANIMATE), {}, {
            values: '1;0;0;0;0;1;'
          })
        }]
      });

      if (!reduceMotion) {
        // Exclamation
        gChildren.push({
          tag: 'path',
          attributes: _objectSpread2$1(_objectSpread2$1({}, FILL), {}, {
            opacity: '0',
            d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
          }),
          children: [{
            tag: 'animate',
            attributes: _objectSpread2$1(_objectSpread2$1({}, OPACITY_ANIMATE), {}, {
              values: '0;0;1;1;0;0;'
            })
          }]
        });
      }

      return {
        tag: 'g',
        attributes: {
          'class': 'missing'
        },
        children: gChildren
      };
    };
  }
};

var SvgSymbols = {
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var symbolData = node.getAttribute('data-fa-symbol');
        var symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
        accumulator['symbol'] = symbol;
        return accumulator;
      }
    };
  }
};

var plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];

registerPlugins(plugins, {
  mixoutsTo: api
});
api.noAuto;
api.config;
api.library;
api.dom;
var parse$1 = api.parse;
api.findIconDefinition;
api.toHtml;
var icon = api.icon;
api.layer;
api.text;
api.counter;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// Get CSS class list from a props object
function classList(props) {
  var _classes;

  var beat = props.beat,
      fade = props.fade,
      beatFade = props.beatFade,
      bounce = props.bounce,
      shake = props.shake,
      flash = props.flash,
      spin = props.spin,
      spinPulse = props.spinPulse,
      spinReverse = props.spinReverse,
      pulse = props.pulse,
      fixedWidth = props.fixedWidth,
      inverse = props.inverse,
      border = props.border,
      listItem = props.listItem,
      flip = props.flip,
      size = props.size,
      rotation = props.rotation,
      pull = props.pull; // map of CSS class names to properties

  var classes = (_classes = {
    'fa-beat': beat,
    'fa-fade': fade,
    'fa-beat-fade': beatFade,
    'fa-bounce': bounce,
    'fa-shake': shake,
    'fa-flash': flash,
    'fa-spin': spin,
    'fa-spin-reverse': spinReverse,
    'fa-spin-pulse': spinPulse,
    'fa-pulse': pulse,
    'fa-fw': fixedWidth,
    'fa-inverse': inverse,
    'fa-border': border,
    'fa-li': listItem,
    'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
    'fa-flip-vertical': flip === 'vertical' || flip === 'both'
  }, _defineProperty(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), _defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), _defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), _defineProperty(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
  // return an array of the keys where the value for the key is not null

  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}

// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function _isNumerical(obj) {
  obj = obj - 0; // eslint-disable-next-line no-self-compare

  return obj === obj;
}

function camelize(string) {
  if (_isNumerical(string)) {
    return string;
  } // eslint-disable-next-line no-useless-escape


  string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
    return chr ? chr.toUpperCase() : '';
  }); // Ensure 1st char is always lowercase

  return string.substr(0, 1).toLowerCase() + string.substr(1);
}

var _excluded$1 = ["style"];

function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;
    return acc;
  }, {});
}

function convert(createElement, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof element === 'string') {
    return element;
  }

  var children = (element.children || []).map(function (child) {
    return convert(createElement, child);
  });
  /* eslint-disable dot-notation */

  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc.attrs['className'] = val;
        delete element.attributes['class'];
        break;

      case 'style':
        acc.attrs['style'] = styleToObject(val);
        break;

      default:
        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[camelize(key)] = val;
        }

    }

    return acc;
  }, {
    attrs: {}
  });

  var _extraProps$style = extraProps.style,
      existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style,
      remaining = _objectWithoutProperties(extraProps, _excluded$1);

  mixins.attrs['style'] = _objectSpread2(_objectSpread2({}, mixins.attrs['style']), existingStyle);
  /* eslint-enable */

  return createElement.apply(void 0, [element.tag, _objectSpread2(_objectSpread2({}, mixins.attrs), remaining)].concat(_toConsumableArray(children)));
}

var PRODUCTION = false;

try {
  PRODUCTION = "development" === 'production';
} catch (e) {}

function log () {
  if (!PRODUCTION && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
}

function normalizeIconArgs(icon) {
  // this has everything that it needs to be rendered which means it was probably imported
  // directly from an icon svg package
  if (icon && _typeof(icon) === 'object' && icon.prefix && icon.iconName && icon.icon) {
    return icon;
  }

  if (parse$1.icon) {
    return parse$1.icon(icon);
  } // if the icon is null, there's nothing to do


  if (icon === null) {
    return null;
  } // if the icon is an object and has a prefix and an icon name, return it


  if (icon && _typeof(icon) === 'object' && icon.prefix && icon.iconName) {
    return icon;
  } // if it's an array with length of two


  if (Array.isArray(icon) && icon.length === 2) {
    // use the first item as prefix, second as icon name
    return {
      prefix: icon[0],
      iconName: icon[1]
    };
  } // if it's a string, use it as the icon name


  if (typeof icon === 'string') {
    return {
      prefix: 'fas',
      iconName: icon
    };
  }
}

// creates an object with a key of key
// and a value of value
// if certain conditions are met
function objectWithKey(key, value) {
  // if the value is a non-empty array
  // or it's not an array but it is truthy
  // then create the object with the key and the value
  // if not, return an empty array
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty({}, key, value) : {};
}

var _excluded$2 = ["forwardedRef"];
function FontAwesomeIcon(_ref) {
  var forwardedRef = _ref.forwardedRef,
      props = _objectWithoutProperties(_ref, _excluded$2);

  var iconArgs = props.icon,
      maskArgs = props.mask,
      symbol = props.symbol,
      className = props.className,
      title = props.title,
      titleId = props.titleId,
      maskId = props.maskId;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey('classes', [].concat(_toConsumableArray(classList(props)), _toConsumableArray(className.split(' '))));
  var transform = objectWithKey('transform', typeof props.transform === 'string' ? parse$1.transform(props.transform) : props.transform);
  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
  var renderedIcon = icon(iconLookup, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, classes), transform), mask), {}, {
    symbol: symbol,
    title: title,
    titleId: titleId,
    maskId: maskId
  }));

  if (!renderedIcon) {
    log('Could not find icon', iconLookup);
    return null;
  }

  var abstract = renderedIcon.abstract;
  var extraProps = {
    ref: forwardedRef
  };
  Object.keys(props).forEach(function (key) {
    // eslint-disable-next-line no-prototype-builtins
    if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
      extraProps[key] = props[key];
    }
  });
  return convertCurry(abstract[0], extraProps);
}
FontAwesomeIcon.displayName = 'FontAwesomeIcon';
FontAwesomeIcon.propTypes = {
  beat: PropTypes.bool,
  border: PropTypes.bool,
  bounce: PropTypes.bool,
  className: PropTypes.string,
  fade: PropTypes.bool,
  flash: PropTypes.bool,
  mask: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  maskId: PropTypes.string,
  fixedWidth: PropTypes.bool,
  inverse: PropTypes.bool,
  flip: PropTypes.oneOf(['horizontal', 'vertical', 'both']),
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  listItem: PropTypes.bool,
  pull: PropTypes.oneOf(['right', 'left']),
  pulse: PropTypes.bool,
  rotation: PropTypes.oneOf([0, 90, 180, 270]),
  shake: PropTypes.bool,
  size: PropTypes.oneOf(['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
  spin: PropTypes.bool,
  spinPulse: PropTypes.bool,
  spinReverse: PropTypes.bool,
  symbol: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  title: PropTypes.string,
  titleId: PropTypes.string,
  transform: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  swapOpacity: PropTypes.bool
};
FontAwesomeIcon.defaultProps = {
  border: false,
  className: '',
  mask: null,
  maskId: null,
  fixedWidth: false,
  inverse: false,
  flip: null,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  beat: false,
  fade: false,
  beatFade: false,
  bounce: false,
  shake: false,
  symbol: false,
  title: '',
  titleId: null,
  transform: null,
  swapOpacity: false
};
var convertCurry = convert.bind(null, React__default.createElement);

/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */
var faCheck = {
  prefix: 'fas',
  iconName: 'check',
  icon: [512, 512, [], "f00c", "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"]
};
var faChevronDown = {
  prefix: 'fas',
  iconName: 'chevron-down',
  icon: [448, 512, [], "f078", "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"]
};
var faChevronRight = {
  prefix: 'fas',
  iconName: 'chevron-right',
  icon: [320, 512, [], "f054", "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"]
};
var faChevronUp = {
  prefix: 'fas',
  iconName: 'chevron-up',
  icon: [448, 512, [], "f077", "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"]
};
var faClock = {
  prefix: 'fas',
  iconName: 'clock',
  icon: [512, 512, [], "f017", "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"]
};
var faSortDown = {
  prefix: 'fas',
  iconName: 'sort-down',
  icon: [320, 512, [], "f0dd", "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"]
};

function SortDownIcon() {
  return /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faSortDown,
    color: "white"
  });
}
var colourStyles = {
  control: function control(styles) {
    return _objectSpread2$4(_objectSpread2$4({}, styles), {}, {
      backgroundColor: "white"
    });
  },
  indicatorsContainer: function indicatorsContainer(styles) {
    return _objectSpread2$4(_objectSpread2$4({}, styles), {}, {
      backgroundColor: colors$1.primaryGreen,
      alignContent: "center"
    });
  },
  indicatorSeparator: function indicatorSeparator() {
    return {
      display: "none"
    };
  },
  option: function option(styles, _ref) {
    var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected;
    return _objectSpread2$4(_objectSpread2$4({}, styles), {}, {
      backgroundColor: isDisabled ? null : isFocused ? colors$1.primaryGreen : isSelected ? colors$1.secondaryGreen : null,
      color: isDisabled ? colors$1.borderGrey : isFocused ? colors$1.white : isSelected ? colors$1.white : null,
      cursor: isDisabled ? "not-allowed" : "pointer",
      ":active": _objectSpread2$4(_objectSpread2$4({}, styles[":active"]), {}, {
        backgroundColor: !isDisabled && colors$1.primaryGreen,
        color: !isDisabled && colors$1.white
      })
    });
  }
};
function DropdownIndicator(props) {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React__default.createElement(components.DropdownIndicator, props, /*#__PURE__*/React__default.createElement(SortDownIcon, null))
  );
}
function YaSelect(_ref2) {
  var values = _ref2.values,
    defaultSelectedIndex = _ref2.defaultSelectedIndex,
    callback = _ref2.callback;
  var handleValueChange = function handleValueChange(selected) {
    if (callback) {
      callback(selected);
    }
  };
  return /*#__PURE__*/React__default.createElement(Select, {
    defaultValue: values[defaultSelectedIndex],
    options: values,
    name: "select",
    components: {
      DropdownIndicator: DropdownIndicator
    },
    styles: colourStyles,
    onChange: function onChange(data) {
      return handleValueChange(data);
    }
  });
}
YaSelect.propTypes = {
  /**
   * The values that can be selected
   */
  values: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })).isRequired,
  /**
   * The preselected value
   */
  defaultSelectedIndex: PropTypes.number.isRequired,
  /**
   * The callback that is called when new value is selected
   */
  callback: PropTypes.func.isRequired
};

var primaryGreen$5 = colors$1.primaryGreen,
  secondaryGreen$2 = colors$1.secondaryGreen,
  borderGrey = colors$1.borderGrey;
var CalculatorInput = createStyled("input", "development" === "production" ? {
  target: "e13qchfe0"
} : {
  target: "e13qchfe0",
  label: "CalculatorInput"
})("height:100%;border-bottom:6px solid ", secondaryGreen$2, ";color:", primaryGreen$5, ";border-top:1px solid ", borderGrey, ";border-left:1px solid ", borderGrey, ";border-right:1px solid ", borderGrey, ";font-weight:500;box-sizing:border-box;font-size:30px;color:", primaryGreen$5, ";width:100%;font-style:normal;text-align:center;&:focus{border:2px solid ", primaryGreen$5, ";border-bottom:6px solid ", primaryGreen$5, ";}&:focus-visible{outline:none;}" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhbGN1bGF0b3JJbnB1dC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLb0MiLCJmaWxlIjoiQ2FsY3VsYXRvcklucHV0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCI7XG5pbXBvcnQgY29sb3JzIGZyb20gXCIuLi8uLi9jb2xvcnNcIjtcblxuY29uc3QgeyBwcmltYXJ5R3JlZW4sIHNlY29uZGFyeUdyZWVuLCBib3JkZXJHcmV5IH0gPSBjb2xvcnM7XG5cbmNvbnN0IENhbGN1bGF0b3JJbnB1dCA9IHN0eWxlZC5pbnB1dGBcbiAgaGVpZ2h0OiAxMDAlO1xuICBib3JkZXItYm90dG9tOiA2cHggc29saWQgJHtzZWNvbmRhcnlHcmVlbn07XG4gIGNvbG9yOiAke3ByaW1hcnlHcmVlbn07XG4gIGJvcmRlci10b3A6IDFweCBzb2xpZCAke2JvcmRlckdyZXl9O1xuICBib3JkZXItbGVmdDogMXB4IHNvbGlkICR7Ym9yZGVyR3JleX07XG4gIGJvcmRlci1yaWdodDogMXB4IHNvbGlkICR7Ym9yZGVyR3JleX07XG4gIGZvbnQtd2VpZ2h0OiA1MDA7XG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gIGZvbnQtc2l6ZTogMzBweDtcbiAgY29sb3I6ICR7cHJpbWFyeUdyZWVufTtcbiAgd2lkdGg6IDEwMCU7XG4gIGZvbnQtc3R5bGU6IG5vcm1hbDtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuXG4gICY6Zm9jdXMge1xuICAgIGJvcmRlcjogMnB4IHNvbGlkICR7cHJpbWFyeUdyZWVufTtcbiAgICBib3JkZXItYm90dG9tOiA2cHggc29saWQgJHtwcmltYXJ5R3JlZW59O1xuICB9XG4gICY6Zm9jdXMtdmlzaWJsZSB7XG4gICAgb3V0bGluZTogbm9uZTtcbiAgfVxuYDtcblxuZXhwb3J0IGRlZmF1bHQgQ2FsY3VsYXRvcklucHV0O1xuIl19 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$u() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Row$1 = createStyled("div", "development" === "production" ? {
  target: "e1xvp0rx3"
} : {
  target: "e1xvp0rx3",
  label: "Row"
})("development" === "production" ? {
  name: "2vrf67",
  styles: "margin-bottom:4px;width:100%;display:flex;flex-direction:row;justify-content:space-between;@media (max-width: 768px){flex-direction:column;}"
} : {
  name: "2vrf67",
  styles: "margin-bottom:4px;width:100%;display:flex;flex-direction:row;justify-content:space-between;@media (max-width: 768px){flex-direction:column;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$u
});
var Span = createStyled("span", "development" === "production" ? {
  target: "e1xvp0rx2"
} : {
  target: "e1xvp0rx2",
  label: "Span"
})("development" === "production" ? {
  name: "na531m",
  styles: "width:49.375%;position:relative;@media (max-width: 768px){width:100%;}@media (min-width: 768px){input[type=\"range\"]{position:absolute;bottom:0;margin-bottom:0;}}"
} : {
  name: "na531m",
  styles: "width:49.375%;position:relative;@media (max-width: 768px){width:100%;}@media (min-width: 768px){input[type=\"range\"]{position:absolute;bottom:0;margin-bottom:0;}}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$u
});
var Grid$1 = createStyled("div", "development" === "production" ? {
  target: "e1xvp0rx1"
} : {
  target: "e1xvp0rx1",
  label: "Grid"
})("width:100%;border-right:2px solid ", colors$1.secondaryGreen, ";padding-right:30px;@media (max-width: 768px){border-right:none;}" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var CurrencyLabel = createStyled("span", "development" === "production" ? {
  target: "e1xvp0rx0"
} : {
  target: "e1xvp0rx0",
  label: "CurrencyLabel"
})("color:", colors$1.primaryGreen, ";font-size:30px;font-weight:400;margin-left:5px;" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
function LeftGrid(_ref) {
  var rangeLabel = _ref.rangeLabel,
    rangeMin = _ref.rangeMin,
    rangeMax = _ref.rangeMax,
    rangeStep = _ref.rangeStep,
    loanAmount = _ref.loanAmount,
    handleLoanAmountChange = _ref.handleLoanAmountChange,
    setLoanAmount = _ref.setLoanAmount,
    selectionValues = _ref.selectionValues,
    selectionInfoText = _ref.selectionInfoText,
    defaultSelectedIndex = _ref.defaultSelectedIndex,
    handleDownpaymentYearsChange = _ref.handleDownpaymentYearsChange;
  var getNumberFromValue = function getNumberFromValue(value) {
    return Number.isNaN(value) ? Number(rangeMin) : Number(value);
  };
  var handleInput = function handleInput(value) {
    var inputValue = value.replace(/\s+/g, "");
    var numberValue = getNumberFromValue(inputValue);
    if (numberValue > rangeMax) {
      numberValue = rangeMax;
    }
    if (numberValue < rangeMin) {
      numberValue = rangeMin;
    }
    handleLoanAmountChange(numberValue);
  };
  return /*#__PURE__*/React__default.createElement(Grid$1, null, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Span, null, /*#__PURE__*/React__default.createElement(StyledBigText, null, rangeLabel), /*#__PURE__*/React__default.createElement(Slider, {
    min: rangeMin,
    max: rangeMax,
    step: rangeStep,
    inputChanged: function inputChanged(value) {
      return handleLoanAmountChange(parseInt(value, 10));
    },
    value: getNumberFromValue(loanAmount)
  })), /*#__PURE__*/React__default.createElement(Span, {
    style: {
      marginTop: "20px",
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(CalculatorInput, {
    value: loanAmount.toLocaleString("no"),
    onChange: function onChange(event) {
      return setLoanAmount(event.target.value);
    },
    onBlur: function onBlur(event) {
      return handleInput(event.target.value);
    }
  }), /*#__PURE__*/React__default.createElement(CurrencyLabel, null, "kr"))), /*#__PURE__*/React__default.createElement(Row$1, {
    style: {
      marginTop: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Span, null, /*#__PURE__*/React__default.createElement("div", null, selectionInfoText), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(YaSelect, {
    values: selectionValues,
    defaultSelectedIndex: defaultSelectedIndex,
    callback: function callback(value) {
      return handleDownpaymentYearsChange(value);
    }
  })))));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$t() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Grid = createStyled("div", "development" === "production" ? {
  target: "elrgkm1"
} : {
  target: "elrgkm1",
  label: "Grid"
})("development" === "production" ? {
  name: "1aoew43",
  styles: "display:grid;grid-template-columns:1fr 1fr;grid-auto-rows:20px;grid-row-gap:20px;grid-column-gap:10px;padding:20px"
} : {
  name: "1aoew43",
  styles: "display:grid;grid-template-columns:1fr 1fr;grid-auto-rows:20px;grid-row-gap:20px;grid-column-gap:10px;padding:20px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$t
});
var StyledBigTextPurple = /*#__PURE__*/createStyled(StyledBigText, "development" === "production" ? {
  target: "elrgkm0"
} : {
  target: "elrgkm0",
  label: "StyledBigTextPurple"
})("color:", colors$1.primaryGreen, ";font-weight:600;white-space:nowrap;font-size:23px;display:inline-block;line-height:22px;width:100%;text-align:left;margin:0px;" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJpZ2h0R3JpZC5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBaUJpRCIsImZpbGUiOiJSaWdodEdyaWQuanN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyogZXNsaW50LWRpc2FibGUgbm8tdW51c2VkLXZhcnMgKi9cbi8qIGVzbGludC1kaXNhYmxlIHJlYWN0L3Byb3AtdHlwZXMgKi9cbmltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiO1xuXG5pbXBvcnQgU3R5bGVkQmlnVGV4dCBmcm9tIFwiLi9TdHlsZWRCaWdUZXh0XCI7XG5pbXBvcnQgY29sb3JzIGZyb20gXCIuLi8uLi9jb2xvcnNcIjtcblxuY29uc3QgR3JpZCA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGdyaWQ7XG4gIGdyaWQtdGVtcGxhdGUtY29sdW1uczogMWZyIDFmcjtcbiAgZ3JpZC1hdXRvLXJvd3M6IDIwcHg7XG4gIGdyaWQtcm93LWdhcDogMjBweDtcbiAgZ3JpZC1jb2x1bW4tZ2FwOiAxMHB4O1xuICBwYWRkaW5nOiAyMHB4O1xuYDtcblxuY29uc3QgU3R5bGVkQmlnVGV4dFB1cnBsZSA9IHN0eWxlZChTdHlsZWRCaWdUZXh0KWBcbiAgY29sb3I6ICR7Y29sb3JzLnByaW1hcnlHcmVlbn07XG4gIGZvbnQtd2VpZ2h0OiA2MDA7XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gIGZvbnQtc2l6ZTogMjNweDtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICBsaW5lLWhlaWdodDogMjJweDtcbiAgd2lkdGg6IDEwMCU7XG4gIHRleHQtYWxpZ246IGxlZnQ7XG4gIG1hcmdpbjogMHB4O1xuYDtcblxuZnVuY3Rpb24gUmlnaHRHcmlkKHtcbiAgbW9udGhQcmljZUxhYmVsLFxuICBtb250aFByaWNlLFxuICBlZmZlY3RpdmVJbnRlcmVzdExhYmVsLFxuICBlZmZlY3RpdmVJbnRlcmVzdCxcbiAgY29zdExhYmVsLFxuICBjb3N0LFxuICB0b3RhbExhYmVsLFxuICB0b3RhbCxcbn0pIHtcbiAgcmV0dXJuIChcbiAgICA8R3JpZD5cbiAgICAgIDxTdHlsZWRCaWdUZXh0UHVycGxlIHN0eWxlPXt7IGdyaWRSb3c6IDEsIGdyaWRDb2x1bW46IDEgfX0+XG4gICAgICAgIHttb250aFByaWNlTGFiZWx9OlxuICAgICAgPC9TdHlsZWRCaWdUZXh0UHVycGxlPlxuICAgICAgPFN0eWxlZEJpZ1RleHRQdXJwbGUgc3R5bGU9e3sgZ3JpZFJvdzogMSwgZ3JpZENvbHVtbjogMiB9fT5cbiAgICAgICAge21vbnRoUHJpY2UudG9Mb2NhbGVTdHJpbmcoXCJub1wiKX0ga3JcbiAgICAgIDwvU3R5bGVkQmlnVGV4dFB1cnBsZT5cbiAgICAgIDxTdHlsZWRCaWdUZXh0UHVycGxlIHN0eWxlPXt7IGdyaWRSb3c6IDIsIGdyaWRDb2x1bW46IDEgfX0+XG4gICAgICAgIHtlZmZlY3RpdmVJbnRlcmVzdExhYmVsfTpcbiAgICAgIDwvU3R5bGVkQmlnVGV4dFB1cnBsZT5cbiAgICAgIDxTdHlsZWRCaWdUZXh0UHVycGxlIHN0eWxlPXt7IGdyaWRSb3c6IDIsIGdyaWRDb2x1bW46IDIgfX0+XG4gICAgICAgIHtlZmZlY3RpdmVJbnRlcmVzdC50b0xvY2FsZVN0cmluZyhcIm5vXCIpfSVcbiAgICAgIDwvU3R5bGVkQmlnVGV4dFB1cnBsZT5cbiAgICAgIDxTdHlsZWRCaWdUZXh0UHVycGxlIHN0eWxlPXt7IGdyaWRSb3c6IDMsIGdyaWRDb2x1bW46IDEgfX0+e2Nvc3RMYWJlbH06PC9TdHlsZWRCaWdUZXh0UHVycGxlPlxuICAgICAgPFN0eWxlZEJpZ1RleHRQdXJwbGUgc3R5bGU9e3sgZ3JpZFJvdzogMywgZ3JpZENvbHVtbjogMiB9fT5cbiAgICAgICAge2Nvc3QudG9Mb2NhbGVTdHJpbmcoXCJub1wiKX0ga3JcbiAgICAgIDwvU3R5bGVkQmlnVGV4dFB1cnBsZT5cbiAgICAgIDxTdHlsZWRCaWdUZXh0UHVycGxlIHN0eWxlPXt7IGdyaWRSb3c6IDQsIGdyaWRDb2x1bW46IDEgfX0+e3RvdGFsTGFiZWx9OjwvU3R5bGVkQmlnVGV4dFB1cnBsZT5cbiAgICAgIDxTdHlsZWRCaWdUZXh0UHVycGxlIHN0eWxlPXt7IGdyaWRSb3c6IDQsIGdyaWRDb2x1bW46IDIgfX0+XG4gICAgICAgIHt0b3RhbC50b0xvY2FsZVN0cmluZyhcIm5vXCIpfSBrclxuICAgICAgPC9TdHlsZWRCaWdUZXh0UHVycGxlPlxuICAgIDwvR3JpZD5cbiAgKTtcbn1cblxuZXhwb3J0IGRlZmF1bHQgUmlnaHRHcmlkO1xuIl19 */"));
function RightGrid(_ref) {
  var monthPriceLabel = _ref.monthPriceLabel,
    monthPrice = _ref.monthPrice,
    effectiveInterestLabel = _ref.effectiveInterestLabel,
    effectiveInterest = _ref.effectiveInterest,
    costLabel = _ref.costLabel,
    cost = _ref.cost,
    totalLabel = _ref.totalLabel,
    total = _ref.total;
  return /*#__PURE__*/React__default.createElement(Grid, null, /*#__PURE__*/React__default.createElement(StyledBigTextPurple, {
    style: {
      gridRow: 1,
      gridColumn: 1
    }
  }, monthPriceLabel, ":"), /*#__PURE__*/React__default.createElement(StyledBigTextPurple, {
    style: {
      gridRow: 1,
      gridColumn: 2
    }
  }, monthPrice.toLocaleString("no"), " kr"), /*#__PURE__*/React__default.createElement(StyledBigTextPurple, {
    style: {
      gridRow: 2,
      gridColumn: 1
    }
  }, effectiveInterestLabel, ":"), /*#__PURE__*/React__default.createElement(StyledBigTextPurple, {
    style: {
      gridRow: 2,
      gridColumn: 2
    }
  }, effectiveInterest.toLocaleString("no"), "%"), /*#__PURE__*/React__default.createElement(StyledBigTextPurple, {
    style: {
      gridRow: 3,
      gridColumn: 1
    }
  }, costLabel, ":"), /*#__PURE__*/React__default.createElement(StyledBigTextPurple, {
    style: {
      gridRow: 3,
      gridColumn: 2
    }
  }, cost.toLocaleString("no"), " kr"), /*#__PURE__*/React__default.createElement(StyledBigTextPurple, {
    style: {
      gridRow: 4,
      gridColumn: 1
    }
  }, totalLabel, ":"), /*#__PURE__*/React__default.createElement(StyledBigTextPurple, {
    style: {
      gridRow: 4,
      gridColumn: 2
    }
  }, total.toLocaleString("no"), " kr"));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$s() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Row = createStyled("div", "development" === "production" ? {
  target: "e19hnsb21"
} : {
  target: "e19hnsb21",
  label: "Row"
})("development" === "production" ? {
  name: "2vrf67",
  styles: "margin-bottom:4px;width:100%;display:flex;flex-direction:row;justify-content:space-between;@media (max-width: 768px){flex-direction:column;}"
} : {
  name: "2vrf67",
  styles: "margin-bottom:4px;width:100%;display:flex;flex-direction:row;justify-content:space-between;@media (max-width: 768px){flex-direction:column;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$s
});
var InformationText = createStyled("div", "development" === "production" ? {
  target: "e19hnsb20"
} : {
  target: "e19hnsb20",
  label: "InformationText"
})("development" === "production" ? {
  name: "18lfdfz",
  styles: "font-size:15px;font-weight:400"
} : {
  name: "18lfdfz",
  styles: "font-size:15px;font-weight:400",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$s
});
function CalculatorView(_ref) {
  var rangeLabel = _ref.rangeLabel,
    rangeMin = _ref.rangeMin,
    rangeMax = _ref.rangeMax,
    rangeStep = _ref.rangeStep,
    rangeSelected = _ref.rangeSelected,
    selectionValues = _ref.selectionValues,
    defaultSelectedIndex = _ref.defaultSelectedIndex,
    selectionInfoText = _ref.selectionInfoText,
    monthPriceLabel = _ref.monthPriceLabel,
    monthPrice = _ref.monthPrice,
    effectiveInterestLabel = _ref.effectiveInterestLabel,
    effectiveInterest = _ref.effectiveInterest,
    costLabel = _ref.costLabel,
    cost = _ref.cost,
    totalLabel = _ref.totalLabel,
    total = _ref.total,
    disclaimer = _ref.disclaimer,
    informationText = _ref.informationText,
    changeCallback = _ref.changeCallback;
  var _useState = useState(rangeSelected),
    _useState2 = _slicedToArray$2(_useState, 2),
    loanAmount = _useState2[0],
    setLoanAmount = _useState2[1];
  var _useState3 = useState(selectionValues[defaultSelectedIndex].value),
    _useState4 = _slicedToArray$2(_useState3, 2),
    downpaymentYears = _useState4[0],
    setDownpaymentYears = _useState4[1];
  var handleLoanAmountChange = function handleLoanAmountChange(value) {
    setLoanAmount(value);
    if (changeCallback) {
      changeCallback(value, downpaymentYears);
    }
  };
  var handleDownpaymentYearsChange = function handleDownpaymentYearsChange(value) {
    var years = value.value;
    setDownpaymentYears(years);
    if (changeCallback) {
      changeCallback(loanAmount, years);
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row, null, /*#__PURE__*/React__default.createElement(LeftGrid, {
    rangeLabel: rangeLabel,
    rangeMin: rangeMin,
    rangeMax: rangeMax,
    rangeStep: rangeStep,
    loanAmount: loanAmount,
    handleLoanAmountChange: handleLoanAmountChange,
    setLoanAmount: setLoanAmount,
    selectionValues: selectionValues,
    defaultSelectedIndex: defaultSelectedIndex,
    selectionInfoText: selectionInfoText,
    disclaimer: disclaimer,
    handleDownpaymentYearsChange: handleDownpaymentYearsChange
  }), /*#__PURE__*/React__default.createElement(RightGrid, {
    monthPriceLabel: monthPriceLabel,
    monthPrice: monthPrice,
    effectiveInterestLabel: effectiveInterestLabel,
    effectiveInterest: effectiveInterest,
    costLabel: costLabel,
    cost: cost,
    totalLabel: totalLabel,
    total: total
  })), /*#__PURE__*/React__default.createElement(InformationText, {
    style: {
      paddingRight: "30px",
      textAlign: "left",
      fontWeight: "600",
      maxWidth: "650px"
    }
  }, informationText));
}
CalculatorView.propTypes = {
  /**
   * The label for the slider
   */
  rangeLabel: PropTypes.string,
  /**
   * Slider min value
   */
  rangeMin: PropTypes.number,
  /**
   * Slider max value
   */
  rangeMax: PropTypes.number,
  /**
   * The range step size
   */
  rangeStep: PropTypes.number,
  /**
   * The preselected slider value
   */
  rangeSelected: PropTypes.number,
  /**
   * The values that can be selected
   */
  selectionValues: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })),
  /**
   * The index that is selected from the start
   */
  defaultSelectedIndex: PropTypes.number,
  /**
   * The select text
   */
  selectionInfoText: PropTypes.string,
  /**
   * The label for the monthly price
   */
  monthPriceLabel: PropTypes.string,
  /**
   * The monthly price
   */
  monthPrice: PropTypes.number,
  /**
   * The label for effective interest
   */
  effectiveInterestLabel: PropTypes.string,
  /**
   * The effective interest
   */
  effectiveInterest: PropTypes.number,
  /**
   * The label for cost
   */
  costLabel: PropTypes.string,
  /**
   * The cost
   */
  cost: PropTypes.number,
  /**
   * The label for total cost
   */
  totalLabel: PropTypes.string,
  /**
   * The total cost
   */
  total: PropTypes.number,
  /**
   * Disclaimer text
   */
  disclaimer: PropTypes.string,
  /**
   * Information text
   */
  informationText: PropTypes.string,
  /**
   * The callback function that is called when the loan amount changes
   */
  changeCallback: PropTypes.func
};

function Calculator(props) {
  var selectionValues = props.selectionValues,
    defaultSelectedIndex = props.defaultSelectedIndex,
    rangeSelected = props.rangeSelected,
    nominalInterest = props.nominalInterest,
    settingUpCharge = props.settingUpCharge,
    invoiceCharge = props.invoiceCharge,
    endpointURL = props.endpointURL,
    propsCb = props.cb,
    debounceTime = props.debounce;
  var _useState = useState(2002),
    _useState2 = _slicedToArray$2(_useState, 2),
    monthPrice = _useState2[0],
    setMonthPrice = _useState2[1];
  var _useState3 = useState(15.76),
    _useState4 = _slicedToArray$2(_useState3, 2),
    effectiveInterest = _useState4[0],
    setEffectiveInterest = _useState4[1];
  var _useState5 = useState(215377),
    _useState6 = _slicedToArray$2(_useState5, 2),
    cost = _useState6[0],
    setCost = _useState6[1];
  var _useState7 = useState(360377),
    _useState8 = _slicedToArray$2(_useState7, 2),
    total = _useState8[0],
    setTotal = _useState8[1];
  var initialDownpaymentYears = selectionValues[defaultSelectedIndex || 0].value;
  var callCallback = useCallback(function (loanAmount, years, loading) {
    return propsCb(loanAmount, years, loading);
  }, [propsCb]);
  var callBackend = useCallback(function (loanAmount, years) {
    var params = {
      nominalInterest: nominalInterest,
      loanAmount: loanAmount,
      downPaymentYears: years,
      settingUpCharge: settingUpCharge,
      invoiceCharge: invoiceCharge
    };
    var requestData = new URLSearchParams(params).toString();
    axios$1({
      method: "POST",
      url: endpointURL,
      data: requestData
    }).then(function (response) {
      var data = response.data;
      setMonthPrice(Math.round(data.installments[0].amortizationAmountWithCharge));
      setEffectiveInterest(Math.round(data.effectiveInterest * 100) / 100);
      setCost(Math.round(data.totalCost.interestAmount + data.totalCost.invoiceCharge + data.settingUpCharge));
      setTotal(Math.round(data.totalCost.amortizationAmountWithCharge));
      callCallback(loanAmount, years, false);
    });
  }, [callCallback, endpointURL, invoiceCharge, nominalInterest, settingUpCharge]);
  useEffect(function () {
    return callBackend(rangeSelected, initialDownpaymentYears);
  }, [callBackend, initialDownpaymentYears, rangeSelected]);
  var changeCallback = lodash_debounce(function (loanAmount, years) {
    callCallback(loanAmount, years, true);
    callBackend(loanAmount, years);
  }, debounceTime);
  var allProps = _objectSpread2$4({
    changeCallback: changeCallback,
    monthPrice: monthPrice,
    effectiveInterest: effectiveInterest,
    cost: cost,
    total: total
  }, props);

  // eslint-disable-next-line react/jsx-props-no-spreading
  return /*#__PURE__*/React__default.createElement(CalculatorView, allProps);
}
Calculator.propTypes = {
  /**
   * The label for the slider
   */
  rangeLabel: PropTypes.string.isRequired,
  /**
   * Slider min value
   */
  rangeMin: PropTypes.number.isRequired,
  /**
   * Slider max value
   */
  rangeMax: PropTypes.number.isRequired,
  /**
   * The range step size
   */
  rangeStep: PropTypes.number.isRequired,
  /**
   * The preselected slider value
   */
  rangeSelected: PropTypes.number.isRequired,
  /**
   * The values that can be selected
   */
  // eslint-disable-next-line react/forbid-prop-types
  selectionValues: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * The index that is selected from the start
   */
  defaultSelectedIndex: PropTypes.number.isRequired,
  /**
   * The select text
   */
  selectionInfoText: PropTypes.string.isRequired,
  /**
   * The label for the monthly price
   */
  monthPriceLabel: PropTypes.string.isRequired,
  /**
   * The label for effective interest
   */
  effectiveInterestLabel: PropTypes.string.isRequired,
  /**
   * The label for cost
   */
  costLabel: PropTypes.string.isRequired,
  /**
   * The label for total cost
   */
  totalLabel: PropTypes.string.isRequired,
  /**
   * Disclaimer text
   */
  disclaimer: PropTypes.string.isRequired,
  /**
   * Information text
   */
  informationText: PropTypes.string.isRequired,
  /**
   * The nominal interest to use
   */
  nominalInterest: PropTypes.number.isRequired,
  /**
   * The charge for setting up the loan
   */
  settingUpCharge: PropTypes.number.isRequired,
  /**
   * The invoice charge
   */
  invoiceCharge: PropTypes.number.isRequired,
  /**
   * URL for calculateLoan endpoint
   */
  endpointURL: PropTypes.string.isRequired,
  /**
   * Callback for "amount", "downpaymentPeriod" and whether we are waiting for results (boolean)
   */
  cb: PropTypes.func,
  /**
   * Debounce value in milliseconds when dragging slider
   */
  debounce: PropTypes.number
};
Calculator.defaultProps = {
  cb: function cb() {},
  debounce: 1000
};

function BasicStepOne(props) {
  var onValueUpdate = props.onValueUpdate,
    onNextStep = props.onNextStep,
    state = props.state,
    showEmailRepeat = props.showEmailRepeat,
    brandStyle = props.brandStyle;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Legend, {
    brandStyle: brandStyle
  }, "Personalia"), /*#__PURE__*/React__default.createElement(BasicPersonalia, {
    state: state,
    onValueUpdate: onValueUpdate,
    showEmailRepeat: showEmailRepeat,
    brandStyle: brandStyle
  }), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Button, {
    label: "G\xE5 til neste steg",
    onclick: onNextStep,
    showError: state.button1Error,
    disabled: !!state.apiStatus.loading,
    brandStyle: brandStyle
  })));
}
BasicStepOne.propTypes = {
  onValueUpdate: PropTypes.func.isRequired,
  onNextStep: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  state: PropTypes.object.isRequired,
  showEmailRepeat: PropTypes.bool,
  brandStyle: PropTypes.oneOf(["ya", "yx"])
};
BasicStepOne.defaultProps = {
  showEmailRepeat: true,
  brandStyle: "ya"
};

var labels = {
  grossIncomeYearly: {
    title: "Brutto årslønn",
    secondaryTitle: "(din årslønn før skatt)"
  },
  grossIncomeYearlySubsidiary: {
    title: "Medsøkers brutto årslønn",
    secondaryTitle: "(medsøkers årslønn før skatt)"
  },
  extraIncome: {
    title: "Andre inntekter per år",
    secondaryTitle: "(husleie, barnebidrag, etc)"
  },
  extraIncomeSubsidiary: {
    title: "Medsøkers andre inntekter per år",
    secondaryTitle: "(husleie, barnebidrag, etc)"
  },
  spouseIncomeYearly: {
    title: "Ektefelle/samboers brutto årsinntekt",
    secondaryTitle: "(ektefelle/samboers årslønn før skatt)"
  },
  spouseIncomeYearlySubsidiary: {
    title: "Medsøkers ektefelle/samboers brutto årsinntekt",
    secondaryTitle: "(ektefelle/samboers årslønn før skatt)"
  }
};
function Economy(_ref) {
  var _state$collapseStates;
  var onValueUpdate = _ref.onValueUpdate,
    onCollapse = _ref.onCollapse,
    state = _ref.state,
    isSubsidiary = _ref.isSubsidiary;
  var getId = function getId(id) {
    return isSubsidiary ? "".concat(id, "Subsidiary") : id;
  };
  var InputSpan = useCallback(function (id) {
    return /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
      id: id,
      type: "tel",
      title: labels[id].title,
      onblur: onValueUpdate,
      isCurrency: true,
      value: state[id] || "",
      secondaryTitle: labels[id].secondaryTitle,
      showError: state["".concat(id, "Error")]
    }));
  }, [onValueUpdate, state]);
  var SpouseIncome = /*#__PURE__*/React__default.createElement(Row$2, null, InputSpan(getId("spouseIncomeYearly")));
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row$2, null, InputSpan(getId("grossIncomeYearly")), InputSpan(getId("extraIncome"))), isSubsidiary ? SpouseIncome : /*#__PURE__*/React__default.createElement(Collapse, {
    isOpen: ["MARRIED_OR_PARTNER", "COHABITANT"].includes(state.civilStatus),
    appear: ((_state$collapseStates = state.collapseStates) === null || _state$collapseStates === void 0 ? void 0 : _state$collapseStates.civilStatus) !== "ENTERED",
    onEntered: function onEntered() {
      return onCollapse("ENTERED", "civilStatus");
    },
    onExited: function onExited() {
      return onCollapse("CLOSED", "civilStatus");
    }
  }, SpouseIncome));
}
Economy.propTypes = {
  onValueUpdate: PropTypes.func.isRequired,
  onCollapse: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  state: PropTypes.object.isRequired,
  isSubsidiary: PropTypes.bool
};
Economy.defaultProps = {
  isSubsidiary: false
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$r() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var LeftFloatSpan = createStyled("span", "development" === "production" ? {
  target: "e33mx382"
} : {
  target: "e33mx382",
  label: "LeftFloatSpan"
})("development" === "production" ? {
  name: "g0dsyy",
  styles: "float:left"
} : {
  name: "g0dsyy",
  styles: "float:left",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$r
});
var SpanFullWithTopMargin = /*#__PURE__*/createStyled(SpanFull, "development" === "production" ? {
  target: "e33mx381"
} : {
  target: "e33mx381",
  label: "SpanFullWithTopMargin"
})("development" === "production" ? {
  name: "yz1nei",
  styles: "margin-top:16px"
} : {
  name: "yz1nei",
  styles: "margin-top:16px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$r
});
var AlmostFullSpan = /*#__PURE__*/createStyled(SpanFull, "development" === "production" ? {
  target: "e33mx380"
} : {
  target: "e33mx380",
  label: "AlmostFullSpan"
})("development" === "production" ? {
  name: "ersup0",
  styles: "@media (max-width: 768px){width:90%;}"
} : {
  name: "ersup0",
  styles: "@media (max-width: 768px){width:90%;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$r
});
function StepTwo(props) {
  var _state$collapseStates;
  var onValueUpdate = props.onValueUpdate,
    onNextStep = props.onNextStep,
    state = props.state,
    onCollapse = props.onCollapse,
    setState = props.setState;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Legend, null, "Personalia"), /*#__PURE__*/React__default.createElement(MorePersonalia, {
    state: state,
    onValueUpdate: onValueUpdate,
    showExtendedDetails: true
  }), /*#__PURE__*/React__default.createElement(Legend, null, "Inntekt"), /*#__PURE__*/React__default.createElement(Economy, {
    onValueUpdate: onValueUpdate,
    onCollapse: onCollapse,
    state: state
  }), /*#__PURE__*/React__default.createElement(Legend, null, "Gjeld: Boligl\xE5n"), /*#__PURE__*/React__default.createElement(MultipleLoan, {
    onValueUpdate: onValueUpdate,
    onCollapse: onCollapse,
    state: state,
    setState: setState,
    loanId: "houseLoan"
  }), /*#__PURE__*/React__default.createElement(Legend, null, "Gjeld: Studiel\xE5n"), /*#__PURE__*/React__default.createElement(StudentLoan, {
    onValueUpdate: onValueUpdate,
    onCollapse: onCollapse,
    state: state,
    loanId: "studentLoan"
  }), /*#__PURE__*/React__default.createElement(Legend, null, "Gjeld: Bill\xE5n"), /*#__PURE__*/React__default.createElement(MultipleLoan, {
    onValueUpdate: onValueUpdate,
    onCollapse: onCollapse,
    state: state,
    setState: setState,
    loanId: "carLoan"
  }), /*#__PURE__*/React__default.createElement(Legend, null, "Gjeld: Usikret gjeld"), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(SpanFullWithTopMargin, null, "Totalsum av dine kredittkort og l\xE5n hentes fra Gjeldsregisteret", /*#__PURE__*/React__default.createElement(Popover, {
    id: "popover-totalsum",
    iconMarginBottom: "1rem",
    text: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("p", null, "Gjeldsregisteret inneholder en oversikt over all din usikrede gjeld. Vi henter inn all informasjon herfra slik at du slipper \xE5 fylle inn dette selv."), /*#__PURE__*/React__default.createElement("p", null, "Dersom du skal refinansiere hele eller deler av din usikrede gjeld fyller du ut dette i posten \"Refinansiering\" lenger ned."))
  }))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Radio, {
    id: "hasDebtCollection",
    label: "Har du pågående inkassosaker?",
    options: [{
      value: true,
      label: "Ja",
      checked: state.hasDebtCollection === true
    }, {
      value: false,
      label: "Nei",
      checked: state.hasDebtCollection === false
    }],
    onchange: onValueUpdate,
    showError: state.hasDebtCollectionError
  }))), /*#__PURE__*/React__default.createElement(RowFluid, null, /*#__PURE__*/React__default.createElement(AlmostFullSpan, null, /*#__PURE__*/React__default.createElement(Button, {
    label: state.coApplicantsPersonalDetails ? "Fjern Medsøker" : "Legg til Medsøker",
    onclick: function onclick() {
      setState(function (prevState) {
        return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
          coApplicantsPersonalDetails: !state.coApplicantsPersonalDetails
        });
      });
    }
  }), /*#__PURE__*/React__default.createElement(Popover, {
    id: "popover-subsidiary",
    iconMarginTop: "2.2rem",
    text: /*#__PURE__*/React__default.createElement("p", null, "En meds\xF8ker st\xE5r ansvarlig for l\xE5net sammen med deg. S\xF8ker du sammen med en meds\xF8ker \xF8ker du sjansen din for \xE5 f\xE5 innvilget l\xE5n betraktelig.")
  }))), state.coApplicantsPersonalDetails === true && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Legend, null, "Meds\xF8kers personalia"), /*#__PURE__*/React__default.createElement(BasicPersonalia, {
    state: state,
    onValueUpdate: onValueUpdate,
    isSubsidiary: true
  }), /*#__PURE__*/React__default.createElement(MorePersonalia, {
    state: state,
    onValueUpdate: onValueUpdate,
    showExtendedDetails: true,
    isSubsidiary: true
  }), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Radio, {
    id: "iLiveWithMainApplicantSubsidiary",
    label: "Bor du sammen med medsøker?",
    options: [{
      value: true,
      label: "Ja",
      checked: state.iLiveWithMainApplicantSubsidiary === true
    }, {
      value: false,
      label: "Nei",
      checked: state.iLiveWithMainApplicantSubsidiary === false
    }],
    onchange: onValueUpdate,
    showError: state.iLiveWithMainApplicantSubsidiaryError
  }))), /*#__PURE__*/React__default.createElement(Collapse, {
    isOpen: state.iLiveWithMainApplicantSubsidiary === false,
    appear: ((_state$collapseStates = state.collapseStates) === null || _state$collapseStates === void 0 ? void 0 : _state$collapseStates.subsidiaryEconomy) !== "ENTERED",
    onEntered: function onEntered() {
      return onCollapse("ENTERED", "subsidiaryEconomy");
    },
    onExited: function onExited() {
      return onCollapse("CLOSED", "subsidiaryEconomy");
    }
  }, /*#__PURE__*/React__default.createElement(Legend, null, "Meds\xF8kers \xF8konomi"), /*#__PURE__*/React__default.createElement(Economy, {
    onValueUpdate: onValueUpdate,
    onCollapse: onCollapse,
    state: state,
    isSubsidiary: true
  })), /*#__PURE__*/React__default.createElement(Legend, null, "Meds\xF8kers gjeld: Boligl\xE5n"), /*#__PURE__*/React__default.createElement(MultipleLoan, {
    onValueUpdate: onValueUpdate,
    onCollapse: onCollapse,
    state: state,
    setState: setState,
    loanId: "houseLoanSubsidiary"
  }), /*#__PURE__*/React__default.createElement(Legend, null, "Meds\xF8kers gjeld: Studiel\xE5n"), /*#__PURE__*/React__default.createElement(StudentLoan, {
    onValueUpdate: onValueUpdate,
    onCollapse: onCollapse,
    state: state,
    loanId: "studentLoanSubsidiary"
  }), /*#__PURE__*/React__default.createElement(Legend, null, "Meds\xF8kers gjeld: Bill\xE5n"), /*#__PURE__*/React__default.createElement(MultipleLoan, {
    onValueUpdate: onValueUpdate,
    onCollapse: onCollapse,
    state: state,
    setState: setState,
    loanId: "carLoanSubsidiary"
  })), /*#__PURE__*/React__default.createElement(Legend, null, /*#__PURE__*/React__default.createElement(LeftFloatSpan, null, "Refinansiering"), /*#__PURE__*/React__default.createElement(LeftFloatSpan, null, /*#__PURE__*/React__default.createElement(Popover, {
    iconMarginTop: "0.5rem",
    id: "popover-refinansiering",
    text: /*#__PURE__*/React__default.createElement("p", null, "Med refinansiering samler du flere sm\xE5 l\xE5n til et stort. Vi s\xF8rger for utbetaling direkte til dine kreditorer.")
  }))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Radio, {
    id: "willUseLoansToRefinance",
    label: "Skal lånet benyttes til refinansiering av andre lån?",
    options: [{
      value: true,
      label: "Ja",
      checked: state.willUseLoansToRefinance === true
    }, {
      value: false,
      label: "Nei",
      checked: state.willUseLoansToRefinance === false
    }],
    onchange: onValueUpdate,
    showError: state.willUseLoansToRefinanceError
  }))), state.willUseLoansToRefinance === true && /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Radio, {
    id: "refinanceEverything",
    label: "Vil du bruke hele lånebeløpet til refinansiering?",
    options: [{
      value: true,
      label: "Ja",
      checked: state.refinanceEverything === true
    }, {
      value: false,
      label: "Nei",
      checked: state.refinanceEverything === false
    }],
    onchange: onValueUpdate,
    showError: state.refinanceEverythingError
  }))), state.willUseLoansToRefinance === true && state.refinanceEverything === false && /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: "refinanceAmount",
    type: "tel",
    title: "Bel\xF8p som skal refinansieres:",
    value: state.refinanceAmount,
    onblur: onValueUpdate,
    isCurrency: true,
    showError: state.refinanceAmountError
  }))), /*#__PURE__*/React__default.createElement(Legend, null, "Annet"), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement(Radio, {
    id: "dueDate",
    label: "Ønsket forfallsdato",
    options: [{
      value: "FIRST",
      label: "1",
      checked: state.dueDate === "FIRST"
    }, {
      value: "TWENTIETH",
      label: "20",
      checked: state.dueDate === "TWENTIETH"
    }],
    onchange: onValueUpdate,
    showError: state.dueDateError
  }))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(SpanFull, null, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "comment"
  }, "Kommentar"), /*#__PURE__*/React__default.createElement(TextArea, {
    id: "comment",
    name: "comment",
    maxLength: "5000",
    defaultValue: state.comment,
    onBlur: function onBlur(e) {
      return onValueUpdate(e, "comment");
    }
  }))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
    id: "accept",
    value: state.accept === "on" ? "off" : "on",
    checked: state.accept === "on",
    onchange: function onchange(e) {
      return onValueUpdate(e, "accept");
    },
    showError: state.acceptError,
    disableLabelClick: true
  }, /*#__PURE__*/React__default.createElement("span", null, "Jeg aksepterer at det blir foretatt en "), /*#__PURE__*/React__default.createElement(ALink, {
    href: "https://documenthandler.resurs.com/Dokument.pdf?customerType=NATURAL&docType=Kredittvurdering-utsendelse-av-gjenpartsbrev-for-forbrukslan-innskudd-ya-kredittkort&land=NO&language=no",
    target: "_blank",
    rel: "noreferrer"
  }, "kredittvurdering og at utsendelse av gjenpartsbrev foreg\xE5r elektronisk der dette er praktisk mulig"))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Button, {
    label: "Send s\xF8knad",
    onclick: onNextStep,
    showError: state.button2Error,
    disabled: !!state.apiStatus.loading
  })));
}
StepTwo.propTypes = {
  onValueUpdate: PropTypes.func.isRequired,
  onNextStep: PropTypes.func.isRequired,
  onCollapse: PropTypes.func.isRequired,
  setState: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  state: PropTypes.object.isRequired
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$q() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Container$3 = createStyled("div", "development" === "production" ? {
  target: "eo67if66"
} : {
  target: "eo67if66",
  label: "Container"
})("development" === "production" ? {
  name: "1dvcxr3",
  styles: "padding:1rem"
} : {
  name: "1dvcxr3",
  styles: "padding:1rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$q
});
var Table = createStyled("table", "development" === "production" ? {
  target: "eo67if65"
} : {
  target: "eo67if65",
  label: "Table"
})("development" === "production" ? {
  name: "1efk0yw",
  styles: "box-sizing:border-box;float:left;width:100%"
} : {
  name: "1efk0yw",
  styles: "box-sizing:border-box;float:left;width:100%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$q
});
var Tr = createStyled("tr", "development" === "production" ? {
  target: "eo67if64"
} : {
  target: "eo67if64",
  label: "Tr"
})("padding-top:0.4rem;border-bottom:1px solid ", colors$1.borderGrey, ";height:40px;" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var TdValue = createStyled("td", "development" === "production" ? {
  target: "eo67if63"
} : {
  target: "eo67if63",
  label: "TdValue"
})("color:", colors$1.primaryGreen, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var StyledRow = /*#__PURE__*/createStyled(Row$2, "development" === "production" ? {
  target: "eo67if62"
} : {
  target: "eo67if62",
  label: "StyledRow"
})("margin-top:", function (props) {
  return props.verticalMargin;
}, ";margin-bottom:", function (props) {
  return props.verticalMargin;
}, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var H4 = createStyled("h4", "development" === "production" ? {
  target: "eo67if61"
} : {
  target: "eo67if61",
  label: "H4"
})("development" === "production" ? {
  name: "16ceglb",
  styles: "font-weight:600"
} : {
  name: "16ceglb",
  styles: "font-weight:600",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$q
});
var UnderlineP = createStyled("p", "development" === "production" ? {
  target: "eo67if60"
} : {
  target: "eo67if60",
  label: "UnderlineP"
})("development" === "production" ? {
  name: "1wbll7q",
  styles: "text-decoration:underline"
} : {
  name: "1wbll7q",
  styles: "text-decoration:underline",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$q
});
function StepThree(_ref) {
  var apiStatus = _ref.apiStatus;
  var code = apiStatus.code,
    application = apiStatus.application;
  var loanAmount = application !== null && application !== void 0 && application.creditAdjustedAmount ? Number(application.creditAdjustedAmount).toLocaleString("no").split(",").join(" ") : 0;
  if (code === 200) {
    var _apiStatus$applicatio, _apiStatus$applicatio2, _apiStatus$applicatio3, _apiStatus$applicatio4, _apiStatus$applicatio5, _apiStatus$applicatio6, _apiStatus$applicatio7, _apiStatus$applicatio8, _apiStatus$applicatio9, _apiStatus$applicatio10;
    return /*#__PURE__*/React__default.createElement(Container$3, null, /*#__PURE__*/React__default.createElement(StyledRow, {
      verticalMargin: "1rem"
    }, /*#__PURE__*/React__default.createElement(SpanFull, null, /*#__PURE__*/React__default.createElement(Legend, null, "S\xF8knaden din er innvilget!"), /*#__PURE__*/React__default.createElement(H4, null, "Du har f\xE5tt innvilget l\xE5n p\xE5 kr"), /*#__PURE__*/React__default.createElement(UnderlineP, null, loanAmount))), ((_apiStatus$applicatio = apiStatus.application) === null || _apiStatus$applicatio === void 0 ? void 0 : (_apiStatus$applicatio2 = _apiStatus$applicatio.mainApplicantApplication) === null || _apiStatus$applicatio2 === void 0 ? void 0 : (_apiStatus$applicatio3 = _apiStatus$applicatio2.applicant) === null || _apiStatus$applicatio3 === void 0 ? void 0 : _apiStatus$applicatio3.signingUrl) && ((_apiStatus$applicatio4 = apiStatus.application) === null || _apiStatus$applicatio4 === void 0 ? void 0 : _apiStatus$applicatio4.paymentAuthorizationRequired) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledRow, {
      verticalMargin: "1rem"
    }, /*#__PURE__*/React__default.createElement(SpanFull, null, /*#__PURE__*/React__default.createElement("p", null, "F\xF8r vi kan utbetale l\xE5net ditt gjenst\xE5r kun signering med BankID."), /*#__PURE__*/React__default.createElement("p", null, "Dersom du ikke har BankID tilgjengelig n\xE5 kan du signere senere via en e-post som er sendt deg."))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Span$1, null, /*#__PURE__*/React__default.createElement("a", {
      href: apiStatus.application.mainApplicantApplication.applicant.signingUrl
    }, /*#__PURE__*/React__default.createElement(Button, {
      label: "Start signering n\xE5!"
    }))))), /*#__PURE__*/React__default.createElement(StyledRow, {
      verticalMargin: "2rem"
    }, /*#__PURE__*/React__default.createElement(SpanBox, null, /*#__PURE__*/React__default.createElement(Table, null, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement("h3", null, "OM L\xC5NET:")))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement(Tr, null, /*#__PURE__*/React__default.createElement("td", null, "L\xE5nebel\xF8p:"), /*#__PURE__*/React__default.createElement(TdValue, null, loanAmount)), /*#__PURE__*/React__default.createElement(Tr, null, /*#__PURE__*/React__default.createElement("td", null, "Nedbetalingstid (\xC5r):"), /*#__PURE__*/React__default.createElement(TdValue, null, ((_apiStatus$applicatio5 = apiStatus.application) === null || _apiStatus$applicatio5 === void 0 ? void 0 : _apiStatus$applicatio5.creditAdjustedDownPaymentPeriod) || "n/a")), /*#__PURE__*/React__default.createElement(Tr, null, /*#__PURE__*/React__default.createElement("td", null, "Terminbel\xF8p:"), /*#__PURE__*/React__default.createElement(TdValue, null, ((_apiStatus$applicatio6 = apiStatus.application) === null || _apiStatus$applicatio6 === void 0 ? void 0 : _apiStatus$applicatio6.installmentAmountWithCharges) || "n/a", ",-")), /*#__PURE__*/React__default.createElement(Tr, null, /*#__PURE__*/React__default.createElement("td", null, "Nominell rente:"), /*#__PURE__*/React__default.createElement(TdValue, null, ((_apiStatus$applicatio7 = apiStatus.application) === null || _apiStatus$applicatio7 === void 0 ? void 0 : _apiStatus$applicatio7.nominalInterest) || "n/a", " %")), /*#__PURE__*/React__default.createElement(Tr, null, /*#__PURE__*/React__default.createElement("td", null, "Effektiv rente:"), /*#__PURE__*/React__default.createElement(TdValue, null, ((_apiStatus$applicatio8 = apiStatus.application) === null || _apiStatus$applicatio8 === void 0 ? void 0 : _apiStatus$applicatio8.effectiveInterest) || "n/a", " %")), /*#__PURE__*/React__default.createElement(Tr, null, /*#__PURE__*/React__default.createElement("td", null, "Etableringsgebyr:"), /*#__PURE__*/React__default.createElement(TdValue, null, ((_apiStatus$applicatio9 = apiStatus.application) === null || _apiStatus$applicatio9 === void 0 ? void 0 : _apiStatus$applicatio9.settingUpCharge) || "n/a", ",-")), /*#__PURE__*/React__default.createElement(Tr, null, /*#__PURE__*/React__default.createElement("td", null, "Termingebyr:"), /*#__PURE__*/React__default.createElement(TdValue, null, ((_apiStatus$applicatio10 = apiStatus.application) === null || _apiStatus$applicatio10 === void 0 ? void 0 : _apiStatus$applicatio10.invoiceCharge) || "n/a", ",-")))))), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(SpanFull, null, "L\xE5netilbudet du har mottatt er et betinget tilbud. Betingelsene p\xE5 ditt l\xE5n bestemmes p\xE5 bakgrunn av din \xF8konomiske situasjon, samt opplysningene du har oppgitt i s\xF8knaden. L\xE5netilbudet er gyldig i 30 dager.")));
  }
  return /*#__PURE__*/React__default.createElement(Container$3, null, /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement(Legend, null, "Finner ikke siden")), /*#__PURE__*/React__default.createElement(Row$2, null, /*#__PURE__*/React__default.createElement("p", null, "Beklager, vi finner ikke siden du fors\xF8kte \xE5 n\xE5."), /*#__PURE__*/React__default.createElement("p", null, "Kontakt oss hvis du mener dette er en feil.")));
}
StepThree.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  apiStatus: PropTypes.object.isRequired
};

/**
 * Helpers for the calculator
 */

/**
 * @description Return an array of selection values by giving a number.
 * @param {number} maxYears - Maximum years
 */
function generateSelectionValues(maxYears) {
  var values = [];
  for (var i = 1; i <= maxYears; i += 1) {
    values.push({
      value: "".concat(i),
      label: "".concat(i, " \xE5r")
    });
  }
  return values;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$p() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Container$2 = createStyled("div", "development" === "production" ? {
  target: "eeumfn92"
} : {
  target: "eeumfn92",
  label: "Container"
})("development" === "production" ? {
  name: "ihv00n",
  styles: "max-width:610px"
} : {
  name: "ihv00n",
  styles: "max-width:610px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$p
});
var StepPagination = createStyled("p", "development" === "production" ? {
  target: "eeumfn91"
} : {
  target: "eeumfn91",
  label: "StepPagination"
})("color:", colors$1.primaryGreen, ";font-size:15px;margin-top:6px;margin-bottom:0px;" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var CalculatorContainer = createStyled("div", "development" === "production" ? {
  target: "eeumfn90"
} : {
  target: "eeumfn90",
  label: "CalculatorContainer"
})("development" === "production" ? {
  name: "12o2e3a",
  styles: "max-width:960px;margin-bottom:2rem"
} : {
  name: "12o2e3a",
  styles: "max-width:960px;margin-bottom:2rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$p
});
var calculatorArgs = {
  rangeLabel: "Lånebeløp",
  selectionValues: [{
    value: "1",
    label: "1 år"
  }, {
    value: "2",
    label: "2 år"
  }, {
    value: "3",
    label: "3 år"
  }, {
    value: "4",
    label: "4 år"
  }, {
    value: "5",
    label: "5 år"
  }, {
    value: "6",
    label: "6 år"
  }, {
    value: "7",
    label: "7 år"
  }, {
    value: "8",
    label: "8 år"
  }, {
    value: "9",
    label: "9 år"
  }, {
    value: "10",
    label: "10 år"
  }, {
    value: "11",
    label: "11 år"
  }, {
    value: "12",
    label: "12 år"
  }, {
    value: "13",
    label: "13 år"
  }, {
    value: "14",
    label: "14 år"
  }, {
    value: "15",
    label: "15 år"
  }],
  selectionInfoText: "Nedbetalingstid *",
  monthPriceLabel: "Månedspris",
  effectiveInterestLabel: "Eff.rente",
  costLabel: "Kostnad",
  totalLabel: "Totalt",
  informationText: "* Nedbetalingstid over 5 år forutsetter at du skal refinansiere annen gjeld. Dette opplyser du om i siste steg av søknaden."
};
function Form(props) {
  var prefilled = props.prefilled,
    baseApiUrl = props.baseApiUrl,
    defaultSelectedIndex = props.defaultSelectedIndex,
    campaignId = props.campaignId,
    currentStep = props.currentStep;
  var _useState = useState({
      currentStep: currentStep,
      coApplicantsPersonalDetails: false,
      collapseStates: {},
      apiStatus: {
        loading: false
      },
      // Base
      productType: "UNSECURED_LOAN",
      schema: "/schema/productApplication_v30.xsd",
      // Calculator
      amount: calculatorArgs.rangeSelected,
      amountError: "",
      downpaymentPeriod: defaultSelectedIndex,
      downpaymentPeriodError: "",
      // Step: 1
      name: prefilled ? "Karl Olsen" : "",
      nameError: "",
      ssn: prefilled ? "17065349957" : "",
      ssnError: "",
      email: prefilled ? "yabank@gmail.com" : undefined,
      emailError: "",
      mobilNo: prefilled ? "13345678" : "",
      mobilNoError: "",
      button1Error: "",
      // Step: 2
      civilStatus: prefilled ? "SEPARATED" : "Velg",
      civilStatusError: "",
      habitat: prefilled ? "OWNED" : "Velg",
      habitatError: "",
      noOfChildren: prefilled ? "0" : "Velg",
      noOfChildrenError: "",
      isNorwegianCitizen: true,
      isNorwegianCitizenError: "",
      education: prefilled ? "UNIVERSITY_LONG" : "Velg",
      educationError: "",
      employmentSituation: prefilled ? "RETIRED" : "Velg",
      employmentSituationError: "",
      employer: undefined,
      employerError: "",
      employedSince: undefined,
      employedSinceError: "",
      grossIncomeYearly: prefilled ? 900000 : undefined,
      grossIncomeYearlyError: "",
      extraIncome: prefilled ? 1 : undefined,
      extraIncomeError: "",
      spouseIncomeYearly: undefined,
      spouseIncomeYearlyError: "",
      houseLoan: prefilled ? "on" : undefined,
      houseLoanError: "",
      houseLoanInputFieldLoanAmount: prefilled ? [123, 234] : [""],
      houseLoanInputFieldMonthlyPayment: prefilled ? [123, 234] : [""],
      studentLoan: prefilled ? "off" : undefined,
      studentLoanError: "",
      studentLoanInputFieldLoanAmount: undefined,
      studentLoanInputFieldLoanAmountError: "",
      studentLoanInputFieldMonthlyPayment: undefined,
      studentLoanInputFieldMonthlyPaymentError: "",
      carLoan: prefilled ? "off" : undefined,
      carLoanError: "",
      carLoanInputFieldLoanAmount: [""],
      carLoanInputFieldMonthlyPayment: [""],
      hasDebtCollection: prefilled ? false : undefined,
      hasDebtCollectionError: "",
      // medsøker
      employerSubsidiary: undefined,
      employerSubsidiaryError: "",
      employedSinceSubsidiary: undefined,
      employedSinceSubsidiaryError: "",
      grossIncomeYearlySubsidiary: undefined,
      grossIncomeYearlySubsidiaryError: "",
      extraIncomeSubsidiary: undefined,
      extraIncomeSubsidiaryError: "",
      spouseIncomeYearlySubsidiary: undefined,
      spouseIncomeYearlySubsidiaryError: "",
      houseLoanSubsidiary: undefined,
      houseLoanSubsidiaryError: "",
      houseLoanSubsidiaryInputFieldLoanAmount: [""],
      houseLoanSubsidiaryInputFieldMonthlyPayment: [""],
      studentLoanSubsidiary: undefined,
      studentLoanSubsidiaryError: "",
      studentLoanSubsidiaryInputFieldLoanAmount: undefined,
      studentLoanSubsidiaryInputFieldLoanAmountError: "",
      studentLoanSubsidiaryInputFieldMonthlyPayment: undefined,
      studentLoanSubsidiaryInputFieldMonthlyPaymentError: "",
      carLoanSubsidiary: undefined,
      carLoanSubsidiaryError: "",
      carLoanSubsidiaryInputFieldLoanAmount: [""],
      carLoanSubsidiaryInputFieldMonthlyPayment: [""],
      nameSubsidiary: undefined,
      nameSubsidiaryError: "",
      ssnSubsidiary: undefined,
      ssnSubsidiaryError: "",
      emailSubsidiary: undefined,
      emailSubsidiaryError: "",
      mobilNoSubsidiary: undefined,
      mobilNoSubsidiaryError: "",
      iLiveWithMainApplicantSubsidiary: undefined,
      iLiveWithMainApplicantSubsidiaryError: "",
      civilStatusSubsidiary: undefined,
      civilStatusSubsidiaryError: "",
      habitatSubsidiary: undefined,
      habitatSubsidiaryError: "",
      educationSubsidiary: undefined,
      educationSubsidiaryError: "",
      employmentSituationSubsidiary: undefined,
      employmentSituationSubsidiaryError: "",
      isNorwegianCitizenSubsidiary: undefined,
      isNorwegianCitizenSubsidiaryError: "",
      willUseLoansToRefinance: prefilled ? false : undefined,
      willUseLoansToRefinanceError: "",
      refinanceEverything: undefined,
      refinanceEverythingError: "",
      refinanceAmount: undefined,
      refinanceAmountError: "",
      dueDate: prefilled ? "TWENTIETH" : undefined,
      dueDateError: "",
      comment: "",
      accept: prefilled ? "on" : "off",
      acceptError: "",
      button2Error: "",
      isDeadEndError: false
    }),
    _useState2 = _slicedToArray$2(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useScrollToTop(state.currentStep, state.isDeadEndError);
  useEffect(function () {
    if (state.apiStatus.loading) return;
    var isStep1 = !state.apiStatus.isDeadEndError && state.currentStep === 0;
    var isStep2 = !state.apiStatus.isDeadEndError && state.currentStep === 1 || state.apiStatus.isDeadEndError && state.currentStep === 0;
    var isStep3 = !state.apiStatus.isDeadEndError && state.currentStep === 2 || state.apiStatus.isDeadEndError && state.currentStep === 1;
    if (isStep1) {
      gtmEventService().loan().pushStepOne(campaignId);
    } else if (isStep2) {
      var _state$apiStatus$appl;
      gtmEventService().loan().pushStepTwo(campaignId, (_state$apiStatus$appl = state.apiStatus.application) === null || _state$apiStatus$appl === void 0 ? void 0 : _state$apiStatus$appl.applicationState, state.apiStatus.message);
    } else if (isStep3) {
      gtmEventService().loan().pushStepThree(state.apiStatus.application.applicationId, state.apiStatus.application.applicationState, state.apiStatus.application.creditAdjustedAmount, campaignId, state.apiStatus.message);
    }
  }, [state.currentStep, state.apiStatus, campaignId]);
  var onValueUpdate = function onValueUpdate(event, id) {
    event.preventDefault();
    var value = event.target.value;

    // convert true/false string to a boolean value
    if (value === "true" || value === "false") {
      value = value === "true";
    }

    // Handle array inputs - for example usage: carLoanInputFieldLoanAmount-1 [value-index]
    var split = id.split("-");
    if (split.length && split.length === 2) {
      var name = split[0];
      var index = Number(split[1]);
      var result = validateValue(name, value, state, index);
      setState(function (prevState) {
        var _objectSpread2;
        var a = prevState[name];
        a["".concat(index)] = value;
        return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, (_objectSpread2 = {}, _defineProperty$5(_objectSpread2, result.errorFieldName || "".concat(id, "Error"), result.errMsg || ""), _defineProperty$5(_objectSpread2, name, _toConsumableArray$3(a)), _objectSpread2));
      });
    } else {
      var _result = validateValue(id, value, state);
      setState(function (prevState) {
        var _objectSpread3;
        return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, (_objectSpread3 = {}, _defineProperty$5(_objectSpread3, _result.errorFieldName || "".concat(id, "Error"), _result.errMsg || ""), _defineProperty$5(_objectSpread3, id, value), _objectSpread3));
      });
    }
  };
  var validateField = function validateField(id) {
    var value = state[id];

    // state: array objects
    if (_typeof$3(value) === "object") {
      var okArray = value.map(function (v, index) {
        var result = validateValue(id, v, state, index);
        setState(function (prevState) {
          return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, _defineProperty$5({}, result.errorFieldName || "".concat(id, "Error"), result.errMsg || ""));
        });
        return result.ok;
      });
      return !okArray.includes(false);
    }
    var result = validateValue(id, value, state);
    setState(function (prevState) {
      return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, _defineProperty$5({}, result.errorFieldName || "".concat(id, "Error"), result.errMsg || ""));
    });
    return result.ok;
  };
  var onNextStep = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var name, ssn, email, mobilNo, amount, downpaymentPeriod, formValues, result, isOK, civilStatus, habitat, noOfChildren, isNorwegianCitizen, education, employmentSituation, employer, employedSince, _employedSince, grossIncomeYearly, extraIncome, spouseIncomeYearly, houseLoan, houseLoanInputFieldLoanAmount, houseLoanInputFieldMonthlyPayment, studentLoan, studentLoanInputFieldLoanAmount, studentLoanInputFieldMonthlyPayment, carLoan, carLoanInputFieldLoanAmount, carLoanInputFieldMonthlyPayment, hasDebtCollection, nameSubsidiary, ssnSubsidiary, emailSubsidiary, mobilNoSubsidiary, iLiveWithMainApplicantSubsidiary, civilStatusSubsidiary, habitatSubsidiary, educationSubsidiary, employmentSituationSubsidiary, isNorwegianCitizenSubsidiary, grossIncomeYearlySubsidiary, extraIncomeSubsidiary, spouseIncomeYearlySubsidiary, houseLoanSubsidiary, houseLoanSubsidiaryInputFieldLoanAmount, houseLoanSubsidiaryInputFieldMonthlyPayment, studentLoanSubsidiary, studentLoanSubsidiaryInputFieldLoanAmount, studentLoanSubsidiaryInputFieldMonthlyPayment, carLoanSubsidiary, carLoanSubsidiaryInputFieldLoanAmount, carLoanSubsidiaryInputFieldMonthlyPayment, willUseLoansToRefinance, refinanceEverything, refinanceAmount, dueDate, comment, accept, _amount, _downpaymentPeriod, _formValues, _result2;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(state.currentStep === 0)) {
                _context.next = 20;
                break;
              }
              // Validate fields for 1st step
              name = validateField("name");
              ssn = validateField("ssn");
              email = validateField("email");
              mobilNo = validateField("mobilNo");
              if (!(!name || !ssn || !email || !mobilNo)) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return");
            case 7:
              amount = validateField("amount");
              downpaymentPeriod = validateField("downpaymentPeriod");
              if (!(!amount || !downpaymentPeriod)) {
                _context.next = 11;
                break;
              }
              return _context.abrupt("return");
            case 11:
              setState(function (prevState) {
                return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
                  button1Error: "",
                  apiStatus: {
                    loading: true
                  }
                });
              });
              formValues = {
                productType: state.productType,
                name: state.name,
                ssn: state.ssn,
                email: state.email,
                mobilNo: state.mobilNo,
                schema: state.schema
              };
              UTM_PARAM_KEYS.forEach(function (paramKey) {
                // eslint-disable-next-line react/destructuring-assignment
                var utmValue = props[paramKey];
                if (utmValue) {
                  formValues[paramKey] = utmValue;
                }
              });
              _context.next = 16;
              return stepOnePost(formValues, baseApiUrl);
            case 16:
              result = _context.sent;
              setState(function (prevState) {
                return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
                  currentStep: result.ok ? state.currentStep + 1 : state.currentStep,
                  button1Error: result.ok ? "" : result.message,
                  isDeadEndError: result.isDeadEndError,
                  apiStatus: _objectSpread2$4({
                    loading: false
                  }, result)
                });
              });
              _context.next = 64;
              break;
            case 20:
              if (!(state.currentStep === 1)) {
                _context.next = 64;
                break;
              }
              // Validate fields for 2nd step
              isOK = true;
              civilStatus = validateField("civilStatus");
              habitat = validateField("habitat");
              noOfChildren = validateField("noOfChildren");
              isNorwegianCitizen = validateField("isNorwegianCitizen");
              education = validateField("education");
              employmentSituation = validateField("employmentSituation"); // employmentSituation extra fields
              if (["PERMANENT_EMPLOYMENT", "DEPUTY", "SELF_EMPLOYED"].includes(state.employmentSituation)) {
                employer = validateField("employer");
                employedSince = validateField("employedSince");
                if (!employer || !employedSince) {
                  isOK = false;
                }
              } else if (["INCAPABLE"].includes(state.employmentSituation)) {
                _employedSince = validateField("employedSince");
                if (!_employedSince) {
                  isOK = false;
                }
              }
              grossIncomeYearly = validateField("grossIncomeYearly");
              extraIncome = validateField("extraIncome"); // civilStatus extra field
              if (["MARRIED_OR_PARTNER", "COHABITANT"].includes(state.civilStatus)) {
                spouseIncomeYearly = validateField("spouseIncomeYearly");
                if (!spouseIncomeYearly) {
                  isOK = false;
                }
              }
              houseLoan = validateField("houseLoan"); // houseLoan extra fields
              if (state.houseLoan === "on") {
                houseLoanInputFieldLoanAmount = validateField("houseLoanInputFieldLoanAmount");
                houseLoanInputFieldMonthlyPayment = validateField("houseLoanInputFieldMonthlyPayment");
                if (!houseLoanInputFieldLoanAmount || !houseLoanInputFieldMonthlyPayment) {
                  isOK = false;
                }
              }
              studentLoan = validateField("studentLoan"); // studentLoan extra fields
              if (state.studentLoan === "on") {
                studentLoanInputFieldLoanAmount = validateField("studentLoanInputFieldLoanAmount");
                studentLoanInputFieldMonthlyPayment = validateField("studentLoanInputFieldMonthlyPayment");
                if (!studentLoanInputFieldLoanAmount || !studentLoanInputFieldMonthlyPayment) {
                  isOK = false;
                }
              }
              carLoan = validateField("carLoan"); // carLoan extra fields
              if (state.carLoan === "on") {
                carLoanInputFieldLoanAmount = validateField("carLoanInputFieldLoanAmount");
                carLoanInputFieldMonthlyPayment = validateField("carLoanInputFieldMonthlyPayment");
                if (!carLoanInputFieldLoanAmount || !carLoanInputFieldMonthlyPayment) {
                  isOK = false;
                }
              }
              hasDebtCollection = validateField("hasDebtCollection"); // medsøker / medsökare
              if (state.coApplicantsPersonalDetails) {
                nameSubsidiary = validateField("nameSubsidiary");
                ssnSubsidiary = validateField("ssnSubsidiary");
                emailSubsidiary = validateField("emailSubsidiary");
                mobilNoSubsidiary = validateField("mobilNoSubsidiary");
                iLiveWithMainApplicantSubsidiary = validateField("iLiveWithMainApplicantSubsidiary");
                civilStatusSubsidiary = validateField("civilStatusSubsidiary");
                habitatSubsidiary = validateField("habitatSubsidiary");
                educationSubsidiary = validateField("educationSubsidiary");
                employmentSituationSubsidiary = validateField("employmentSituationSubsidiary");
                isNorwegianCitizenSubsidiary = validateField("isNorwegianCitizenSubsidiary");
                if (state.iLiveWithMainApplicantSubsidiary === false) {
                  grossIncomeYearlySubsidiary = validateField("grossIncomeYearlySubsidiary");
                  extraIncomeSubsidiary = validateField("extraIncomeSubsidiary");
                  spouseIncomeYearlySubsidiary = validateField("spouseIncomeYearlySubsidiary");
                  if (!grossIncomeYearlySubsidiary || !extraIncomeSubsidiary || !spouseIncomeYearlySubsidiary) {
                    isOK = false;
                  }
                }
                houseLoanSubsidiary = validateField("houseLoanSubsidiary"); // houseLoanSubsidiary extra fields
                if (state.houseLoanSubsidiary === "on") {
                  houseLoanSubsidiaryInputFieldLoanAmount = validateField("houseLoanSubsidiaryInputFieldLoanAmount");
                  houseLoanSubsidiaryInputFieldMonthlyPayment = validateField("houseLoanSubsidiaryInputFieldMonthlyPayment");
                  if (!houseLoanSubsidiaryInputFieldLoanAmount || !houseLoanSubsidiaryInputFieldMonthlyPayment) {
                    isOK = false;
                  }
                }
                studentLoanSubsidiary = validateField("studentLoanSubsidiary"); // studentLoan extra fields
                if (state.studentLoanSubsidiary === "on") {
                  studentLoanSubsidiaryInputFieldLoanAmount = validateField("studentLoanSubsidiaryInputFieldLoanAmount");
                  studentLoanSubsidiaryInputFieldMonthlyPayment = validateField("studentLoanSubsidiaryInputFieldMonthlyPayment");
                  if (!studentLoanSubsidiaryInputFieldLoanAmount || !studentLoanSubsidiaryInputFieldMonthlyPayment) {
                    isOK = false;
                  }
                }
                carLoanSubsidiary = validateField("carLoanSubsidiary"); // carLoan extra fields
                if (state.carLoanSubsidiary === "on") {
                  carLoanSubsidiaryInputFieldLoanAmount = validateField("carLoanSubsidiaryInputFieldLoanAmount");
                  carLoanSubsidiaryInputFieldMonthlyPayment = validateField("carLoanSubsidiaryInputFieldMonthlyPayment");
                  if (!carLoanSubsidiaryInputFieldLoanAmount || !carLoanSubsidiaryInputFieldMonthlyPayment) {
                    isOK = false;
                  }
                }
                if (!nameSubsidiary || !ssnSubsidiary || !emailSubsidiary || !mobilNoSubsidiary || !iLiveWithMainApplicantSubsidiary || !civilStatusSubsidiary || !habitatSubsidiary || !educationSubsidiary || !employmentSituationSubsidiary || !isNorwegianCitizenSubsidiary || !houseLoanSubsidiary || !studentLoanSubsidiary || !carLoanSubsidiary) {
                  isOK = false;
                }
              }
              willUseLoansToRefinance = validateField("willUseLoansToRefinance"); // willUseLoansToRefinance extra fields
              if (state.willUseLoansToRefinance === true) {
                refinanceEverything = validateField("refinanceEverything");
                if (!refinanceEverything) {
                  isOK = false;
                }
                if (state.refinanceEverything === false) {
                  refinanceAmount = validateField("refinanceAmount");
                  if (!refinanceAmount) {
                    isOK = false;
                  }
                }
              }
              dueDate = validateField("dueDate");
              comment = validateField("comment");
              accept = validateField("accept");
              if (!habitat || !noOfChildren || !isNorwegianCitizen || !education || !civilStatus || !willUseLoansToRefinance || !employmentSituation || !grossIncomeYearly || !extraIncome || !houseLoan || !studentLoan || !carLoan || !hasDebtCollection || !dueDate || !comment || !accept) {
                isOK = false;
              }
              _amount = validateField("amount");
              _downpaymentPeriod = validateField("downpaymentPeriod");
              if (!_amount || !_downpaymentPeriod) {
                isOK = false;
              }
              if (isOK) {
                _context.next = 51;
                break;
              }
              return _context.abrupt("return");
            case 51:
              setState(function (prevState) {
                return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
                  button2Error: "",
                  apiStatus: {
                    loading: true
                  }
                });
              });
              _formValues = {
                // frontendFormType: state.frontendFormType,
                productType: state.productType,
                amount: state.amount,
                downpaymentPeriod: state.downpaymentPeriod,
                schema: state.schema,
                // step 1
                name: state.name,
                ssn: state.ssn,
                email: state.email,
                mobilNo: state.mobilNo,
                // step 2
                civilStatus: state.civilStatus,
                habitat: state.habitat,
                noOfChildren: state.noOfChildren,
                isNorwegianCitizen: state.isNorwegianCitizen,
                education: state.education,
                employmentSituation: state.employmentSituation,
                grossIncomeYearly: state.grossIncomeYearly,
                extraIncome: state.extraIncome,
                spouseIncomeYearly: ["MARRIED_OR_PARTNER", "COHABITANT"].includes(state.civilStatus) ? state.spouseIncomeYearly : 0,
                // houseLoan: state.houseLoan,
                // studentLoan: state.studentLoan,
                // carLoan: state.carLoan,
                hasDebtCollection: state.hasDebtCollection,
                willUseLoansToRefinance: state.willUseLoansToRefinance,
                refinanceAmount: state.willUseLoansToRefinance === true && state.refinanceEverything === false ? state.refinanceAmount : 0,
                refinanceEverything: state.willUseLoansToRefinance ? state.refinanceEverything : false,
                dueDate: state.dueDate,
                comment: state.comment
                // accept: state.accept
              };

              UTM_PARAM_KEYS.forEach(function (paramKey) {
                // eslint-disable-next-line react/destructuring-assignment
                var utmValue = props[paramKey];
                if (utmValue) {
                  _formValues[paramKey] = utmValue;
                }
              });

              /* Optional fields START */
              if (["PERMANENT_EMPLOYMENT", "DEPUTY", "SELF_EMPLOYED"].includes(state.employmentSituation)) {
                _formValues.employer = state.employer;
              }
              if (["PERMANENT_EMPLOYMENT", "DEPUTY", "SELF_EMPLOYED", "INCAPABLE"].includes(state.employmentSituation)) {
                _formValues.employedSince = state.employedSince;
              }
              if (state.coApplicantsPersonalDetails) {
                _formValues.nameSubsidiary = state.nameSubsidiary;
                _formValues.ssnSubsidiary = state.ssnSubsidiary;
                _formValues.emailSubsidiary = state.emailSubsidiary;
                _formValues.mobilNoSubsidiary = state.mobilNoSubsidiary;
                _formValues.iLiveWithMainApplicantSubsidiary = state.iLiveWithMainApplicantSubsidiary;
                _formValues.civilStatusSubsidiary = state.civilStatusSubsidiary;
                _formValues.habitatSubsidiary = state.habitatSubsidiary;
                _formValues.educationSubsidiary = state.educationSubsidiary;
                _formValues.employmentSituationSubsidiary = state.employmentSituationSubsidiary;
                _formValues.isNorwegianCitizenSubsidiary = state.isNorwegianCitizenSubsidiary;
                if (state.iLiveWithMainApplicantSubsidiary === false) {
                  _formValues.grossIncomeYearlySubsidiary = state.grossIncomeYearlySubsidiary;
                  _formValues.extraIncomeSubsidiary = state.extraIncomeSubsidiary;
                  _formValues.spouseIncomeYearlySubsidiary = state.spouseIncomeYearlySubsidiary;
                }
                if (["PERMANENT_EMPLOYMENT", "DEPUTY", "SELF_EMPLOYED"].includes(state.employmentSituationSubsidiary)) {
                  _formValues.employerSubsidiary = state.employerSubsidiary;
                }
                if (["PERMANENT_EMPLOYMENT", "DEPUTY", "SELF_EMPLOYED", "INCAPABLE"].includes(state.employmentSituationSubsidiary)) {
                  _formValues.employedSinceSubsidiary = state.employedSinceSubsidiary;
                }
              }
              if (state.houseLoan === "on") {
                _formValues.houseLoanInputFieldLoanAmount = state.houseLoanInputFieldLoanAmount;
                _formValues.houseLoanInputFieldMonthlyPayment = state.houseLoanInputFieldMonthlyPayment;
              }
              if (state.studentLoan === "on") {
                _formValues.studentLoanInputFieldLoanAmount = [state.studentLoanInputFieldLoanAmount]; // backend expects array even though its only one value
                _formValues.studentLoanInputFieldMonthlyPayment = [state.studentLoanInputFieldMonthlyPayment];
              }
              if (state.carLoan === "on") {
                _formValues.carLoanInputFieldLoanAmount = state.carLoanInputFieldLoanAmount;
                _formValues.carLoanInputFieldMonthlyPayment = state.carLoanInputFieldMonthlyPayment;
              }
              /* Optional fields END */

              // Send formdata with validated values
              _context.next = 62;
              return submitUnsecuredLoanApplication(_formValues, baseApiUrl);
            case 62:
              _result2 = _context.sent;
              setState(function (prevState) {
                return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
                  currentStep: _result2.ok ? state.currentStep + 1 : state.currentStep,
                  button2Error: _result2.ok ? "" : _result2.message,
                  isDeadEndError: _result2.isDeadEndError,
                  apiStatus: _objectSpread2$4({
                    loading: false
                  }, _result2)
                });
              });
            case 64:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function onNextStep() {
      return _ref.apply(this, arguments);
    };
  }();
  var onCollapse = function onCollapse(collapseState, id) {
    setState(function (prevState) {
      return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
        collapseStates: _objectSpread2$4(_objectSpread2$4({}, state.collapseStates), {}, _defineProperty$5({}, id, collapseState))
      });
    });
  };
  var calculatorCallback = useCallback(function (amount, downpaymentPeriod) {
    setState(function (prevState) {
      return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, {
        amount: amount,
        downpaymentPeriod: downpaymentPeriod
      });
    });
  }, [setState]);
  if (state.isDeadEndError) {
    return /*#__PURE__*/React__default.createElement(SystemStatus, {
      cmsHelperUrl: baseApiUrl
    }, /*#__PURE__*/React__default.createElement(Container$2, null, /*#__PURE__*/React__default.createElement(DeadEndView, {
      productType: state.productType,
      code: state.apiStatus.code,
      message: state.apiStatus.message
    })));
  }
  return /*#__PURE__*/React__default.createElement(SystemStatus, {
    cmsHelperUrl: baseApiUrl
  }, state.currentStep === 0 && /*#__PURE__*/React__default.createElement(CalculatorContainer, null, /*#__PURE__*/React__default.createElement(Calculator
  /* eslint-disable react/destructuring-assignment */
  // eslint-disable-next-line react/jsx-props-no-spreading
  , _objectSpread2$4(_objectSpread2$4({}, calculatorArgs), {}, {
    rangeMin: props.rangeMin,
    rangeMax: props.rangeMax,
    rangeStep: props.rangeStep,
    rangeSelected: props.rangeSelected,
    selectionValues: props.calculatorMaxYears ? generateSelectionValues(props.calculatorMaxYears) : calculatorArgs.selectionValues,
    defaultSelectedIndex: props.defaultSelectedIndex,
    cb: calculatorCallback,
    endpointURL: props.calculatorEndpointURL,
    nominalInterest: props.nominalInterest,
    settingUpCharge: props.settingUpCharge,
    invoiceCharge: props.invoiceCharge
  })), /*#__PURE__*/React__default.createElement(ErrorLabel, {
    id: "amountError",
    showError: state.amountError
  }), /*#__PURE__*/React__default.createElement(ErrorLabel, {
    id: "downpaymentPeriodError",
    showError: state.downpaymentPeriodError
  })), /*#__PURE__*/React__default.createElement(Container$2, null, /*#__PURE__*/React__default.createElement(Steps, {
    labels: ["Personalia", "Din økonomi", "Resultat"],
    currentStep: state.currentStep
  }), state.currentStep === 0 && /*#__PURE__*/React__default.createElement(BasicStepOne, {
    onValueUpdate: onValueUpdate,
    onNextStep: onNextStep,
    state: state,
    showEmailRepeat: false
  }), state.currentStep === 1 && /*#__PURE__*/React__default.createElement(StepTwo, {
    onValueUpdate: onValueUpdate,
    onNextStep: onNextStep,
    onCollapse: onCollapse,
    setState: setState,
    state: state
  }), state.currentStep === 2 && /*#__PURE__*/React__default.createElement(StepThree, {
    apiStatus: state.apiStatus
  }), state.apiStatus.loading && /*#__PURE__*/React__default.createElement(LoadingOverlay, null), state.currentStep < 2 && /*#__PURE__*/React__default.createElement(StepPagination, null, "(Steg ", state.currentStep + 1, " av 3)")));
}
Form.propTypes = {
  prefilled: PropTypes.bool,
  campaignId: PropTypes.string,
  gclid: PropTypes.string,
  utm_campaign: PropTypes.string,
  utm_content: PropTypes.string,
  utm_medium: PropTypes.string,
  utm_source: PropTypes.string,
  utm_term: PropTypes.string,
  defaultSelectedIndex: PropTypes.number,
  calculatorEndpointURL: PropTypes.string.isRequired,
  baseApiUrl: PropTypes.string.isRequired,
  nominalInterest: PropTypes.number,
  settingUpCharge: PropTypes.number,
  invoiceCharge: PropTypes.number,
  calculatorMaxYears: PropTypes.number,
  rangeMin: PropTypes.number,
  rangeMax: PropTypes.number,
  rangeStep: PropTypes.number,
  rangeSelected: PropTypes.number,
  currentStep: PropTypes.number
};
Form.defaultProps = {
  prefilled: false,
  campaignId: undefined,
  gclid: undefined,
  utm_campaign: undefined,
  utm_content: undefined,
  utm_medium: undefined,
  utm_source: undefined,
  utm_term: undefined,
  defaultSelectedIndex: 4,
  nominalInterest: 14.1,
  settingUpCharge: 900,
  invoiceCharge: 30,
  calculatorMaxYears: undefined,
  rangeMin: 25000,
  rangeMax: 500000,
  rangeStep: 5000,
  rangeSelected: 100000,
  currentStep: 0
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$o() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var ToggleSwitch = createStyled("label", "development" === "production" ? {
  target: "e1p648pu2"
} : {
  target: "e1p648pu2",
  label: "ToggleSwitch"
})("development" === "production" ? {
  name: "f8n408",
  styles: "position:relative;display:inline-block;width:50px;height:25px"
} : {
  name: "f8n408",
  styles: "position:relative;display:inline-block;width:50px;height:25px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$o
});
var HiddenInput = createStyled("input", "development" === "production" ? {
  target: "e1p648pu1"
} : {
  target: "e1p648pu1",
  label: "HiddenInput"
})("development" === "production" ? {
  name: "eivff4",
  styles: "display:none"
} : {
  name: "eivff4",
  styles: "display:none",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$o
});
var SwitchSpan = createStyled("span", "development" === "production" ? {
  target: "e1p648pu0"
} : {
  target: "e1p648pu0",
  label: "SwitchSpan"
})("position:absolute;cursor:pointer;background-color:", function (_ref) {
  var isSelected = _ref.isSelected;
  return isSelected ? colors$1.primaryGreen : colors$1.white;
}, ";border:solid ", colors$1.borderGrey, " 1px;border-radius:25px;top:0;right:0;bottom:0;left:0;transition:background-color 0.15s ease;&:before{box-sizing:border-box;position:absolute;content:\"\";left:-1px;top:-1px;width:25px;height:25px;background-color:", colors$1.white, ";border:solid ", colors$1.borderGrey, " 1px;border-radius:50%;transition:transform 0.2s ease;", function (_ref2) {
  var isSelected = _ref2.isSelected;
  return isSelected && "\n      transform: translateX(25px);\n    ";
}, ";}" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
function ToggleButton(_ref3) {
  var className = _ref3.className,
    isSelected = _ref3.isSelected,
    onChanged = _ref3.onChanged;
  return /*#__PURE__*/React__default.createElement(ToggleSwitch, {
    className: className
  }, /*#__PURE__*/React__default.createElement(HiddenInput, {
    type: "checkbox",
    checked: isSelected,
    onChange: function onChange() {
      return onChanged(!isSelected);
    }
  }), /*#__PURE__*/React__default.createElement(SwitchSpan, {
    isSelected: isSelected
  }));
}
ToggleButton.propTypes = {
  className: PropTypes.string,
  isSelected: PropTypes.bool,
  onChanged: PropTypes.func
};
ToggleButton.defaultProps = {
  className: undefined,
  isSelected: false,
  onChanged: function onChanged() {}
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$n() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var ConsentWrapper = createStyled("div", "development" === "production" ? {
  target: "enfeln73"
} : {
  target: "enfeln73",
  label: "ConsentWrapper"
})("padding-top:1rem;padding-bottom:2rem;border-bottom:2px solid ", colors$1.secondaryGreen, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var H3$1 = createStyled("h3", "development" === "production" ? {
  target: "enfeln72"
} : {
  target: "enfeln72",
  label: "H3"
})("development" === "production" ? {
  name: "dfesk7",
  styles: "margin-top:1rem;margin-bottom:1rem"
} : {
  name: "dfesk7",
  styles: "margin-top:1rem;margin-bottom:1rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$n
});
var OptionWrapper = createStyled("div", "development" === "production" ? {
  target: "enfeln71"
} : {
  target: "enfeln71",
  label: "OptionWrapper"
})("development" === "production" ? {
  name: "1k36h99",
  styles: "margin-top:2rem;display:flex;align-items:center"
} : {
  name: "1k36h99",
  styles: "margin-top:2rem;display:flex;align-items:center",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$n
});
var StyledToggleButton = /*#__PURE__*/createStyled(ToggleButton, "development" === "production" ? {
  target: "enfeln70"
} : {
  target: "enfeln70",
  label: "StyledToggleButton"
})("development" === "production" ? {
  name: "23l56g",
  styles: "margin-left:1rem;margin-right:1rem"
} : {
  name: "23l56g",
  styles: "margin-left:1rem;margin-right:1rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$n
});
function CustomerConsentItem(_ref) {
  var name = _ref.name,
    displayName = _ref.displayName,
    description = _ref.description,
    text = _ref.text,
    value = _ref.value,
    onChanged = _ref.onChanged;
  var onToggleValue = function onToggleValue() {
    return onChanged(name, !value);
  };
  return /*#__PURE__*/React__default.createElement(ConsentWrapper, null, /*#__PURE__*/React__default.createElement(H3$1, null, displayName), /*#__PURE__*/React__default.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: description
    }
  }), /*#__PURE__*/React__default.createElement(OptionWrapper, null, /*#__PURE__*/React__default.createElement("span", null, "Nei"), /*#__PURE__*/React__default.createElement(StyledToggleButton, {
    isSelected: value,
    onChanged: onToggleValue
  }), /*#__PURE__*/React__default.createElement("span", null, text || "Ja")));
}
CustomerConsentItem.propTypes = {
  name: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  onChanged: PropTypes.func
};
CustomerConsentItem.defaultProps = {
  onChanged: function onChanged() {}
};

var stringsResource = {
  channelLabels: {
    ya: "yA",
    yx: "YX Visa"
  }
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$m() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var ConsentListWrapper = createStyled("div", "development" === "production" ? {
  target: "e14d6tze2"
} : {
  target: "e14d6tze2",
  label: "ConsentListWrapper"
})("development" === "production" ? {
  name: "1fttcpj",
  styles: "display:flex;flex-direction:column"
} : {
  name: "1fttcpj",
  styles: "display:flex;flex-direction:column",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$m
});
var H2 = createStyled("h2", "development" === "production" ? {
  target: "e14d6tze1"
} : {
  target: "e14d6tze1",
  label: "H2"
})("development" === "production" ? {
  name: "1yp7290",
  styles: "margin-bottom:2rem"
} : {
  name: "1yp7290",
  styles: "margin-bottom:2rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$m
});
var StyledButton$1 = /*#__PURE__*/createStyled(BigButton, "development" === "production" ? {
  target: "e14d6tze0"
} : {
  target: "e14d6tze0",
  label: "StyledButton"
})("development" === "production" ? {
  name: "5yl01g",
  styles: "margin-top:5rem"
} : {
  name: "5yl01g",
  styles: "margin-top:5rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImN1c3RvbWVyLWNvbnNlbnRzLWxpc3QuanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWdCc0MiLCJmaWxlIjoiY3VzdG9tZXItY29uc2VudHMtbGlzdC5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgdXNlU3RhdGUsIHVzZUVmZmVjdCB9IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCI7XG5pbXBvcnQgQ3VzdG9tZXJDb25zZW50SXRlbSBmcm9tIFwiLi9jdXN0b21lci1jb25zZW50LWl0ZW1cIjtcbmltcG9ydCBzdHJpbmdzUmVzb3VyY2UgZnJvbSBcIi4uL3N0cmluZ3NSZXNvdXJjZVwiO1xuaW1wb3J0IHsgQmlnQnV0dG9uIH0gZnJvbSBcIi4uLy4uL3VpXCI7XG5cbmNvbnN0IENvbnNlbnRMaXN0V3JhcHBlciA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG5gO1xuXG5jb25zdCBIMiA9IHN0eWxlZC5oMmBcbiAgbWFyZ2luLWJvdHRvbTogMnJlbTtcbmA7XG5cbmNvbnN0IFN0eWxlZEJ1dHRvbiA9IHN0eWxlZChCaWdCdXR0b24pYFxuICBtYXJnaW4tdG9wOiA1cmVtO1xuYDtcblxuZnVuY3Rpb24gQ3VzdG9tZXJDb25zZW50c0xpc3QoeyBpZGVudGlmaWVyLCBjb25zZW50c0RldGFpbHMsIG9uU2F2ZSB9KSB7XG4gIC8vIEtlZXAgdGhlIGNvbnNlbnQgY2hhbmdlcyBpbiBhIHN0YXRlIHVudGlsIHRoZSBzYXZlIGJ1dHRvbiBpcyBoaXQuXG4gIGNvbnN0IFtjb25zZW50VmFsdWVzLCBzZXRDb25zZW50VmFsdWVzXSA9IHVzZVN0YXRlKHt9KTtcblxuICAvLyBQb3B1bGF0ZSB0aGUgY29uc2VudFZhbHVlcyBtYXBcbiAgdXNlRWZmZWN0KCgpID0+IHtcbiAgICBjb25zdCBwcm9wQ29uc2VudHMgPSB7fTtcbiAgICAvLyBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgbm8tcmVzdHJpY3RlZC1zeW50YXhcbiAgICBmb3IgKGNvbnN0IHsgY29uc2VudE5hbWUsIGNvbnNlbnRJbmRpY2F0b3IgfSBvZiBjb25zZW50c0RldGFpbHMpIHtcbiAgICAgIHByb3BDb25zZW50c1tjb25zZW50TmFtZV0gPSBjb25zZW50SW5kaWNhdG9yO1xuICAgIH1cbiAgICBzZXRDb25zZW50VmFsdWVzKHByb3BDb25zZW50cyk7XG4gIH0sIFtjb25zZW50c0RldGFpbHNdKTtcblxuICBjb25zdCBvbkNvbnNlbnRDaGFuZ2VkID0gKGNvbnNlbnROYW1lLCBjb25zZW50VmFsdWUpID0+IHtcbiAgICBjb25zdCBuZXdDb25zZW50cyA9IHsgLi4uY29uc2VudFZhbHVlcywgW2NvbnNlbnROYW1lXTogY29uc2VudFZhbHVlIH07XG4gICAgc2V0Q29uc2VudFZhbHVlcyhuZXdDb25zZW50cyk7XG4gIH07XG5cbiAgY29uc3QgaGFuZGxlT25TYXZlID0gKCkgPT4gb25TYXZlKGlkZW50aWZpZXIsIGNvbnNlbnRWYWx1ZXMpO1xuXG4gIGNvbnN0IGJyYW5kTGFiZWwgPVxuICAgIHN0cmluZ3NSZXNvdXJjZS5jaGFubmVsTGFiZWxzW2lkZW50aWZpZXIuY29uc2VudFR5cGVzQ2hhbm5lbF0gfHwgaWRlbnRpZmllci5jb25zZW50VHlwZXNDaGFubmVsO1xuXG4gIHJldHVybiAoXG4gICAgPENvbnNlbnRMaXN0V3JhcHBlcj5cbiAgICAgIDxIMj5cbiAgICAgICAgRGV0dGUgZXIgc2FtdHlra2Ugc29tIGVyIHJlZ2lzdHJldCBww6Uge2lkZW50aWZpZXIuaWRlbnRpZmllcn0gaG9zIHticmFuZExhYmVsfVxuICAgICAgPC9IMj5cbiAgICAgIHtjb25zZW50c0RldGFpbHMubWFwKCh7IGNvbnNlbnROYW1lLCBkaXNwbGF5TmFtZSwgY29uc2VudFRleHQsIGRlc2NyaXB0aW9uIH0pID0+IChcbiAgICAgICAgPEN1c3RvbWVyQ29uc2VudEl0ZW1cbiAgICAgICAgICBrZXk9e2NvbnNlbnROYW1lfVxuICAgICAgICAgIG5hbWU9e2NvbnNlbnROYW1lfVxuICAgICAgICAgIGRpc3BsYXlOYW1lPXtkaXNwbGF5TmFtZX1cbiAgICAgICAgICB0ZXh0PXtjb25zZW50VGV4dH1cbiAgICAgICAgICBkZXNjcmlwdGlvbj17ZGVzY3JpcHRpb259XG4gICAgICAgICAgdmFsdWU9e2NvbnNlbnRWYWx1ZXNbY29uc2VudE5hbWVdIHx8IGZhbHNlfVxuICAgICAgICAgIG9uQ2hhbmdlZD17b25Db25zZW50Q2hhbmdlZH1cbiAgICAgICAgLz5cbiAgICAgICkpfVxuICAgICAgPFN0eWxlZEJ1dHRvbiBvbkNsaWNrPXtoYW5kbGVPblNhdmV9PkxhZ3JlPC9TdHlsZWRCdXR0b24+XG4gICAgPC9Db25zZW50TGlzdFdyYXBwZXI+XG4gICk7XG59XG5cbmNvbnN0IElkZW50aWZpZXJEYXRhVHlwZSA9IFByb3BUeXBlcy5zaGFwZSh7XG4gIGlkZW50aWZpZXI6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgaWRlbnRpZmllclR5cGU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgY29uc2VudFR5cGVzQ2hhbm5lbDogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxufSk7XG5cbmNvbnN0IENvbnNlbnRzRGV0YWlsc0RhdGFUeXBlID0gUHJvcFR5cGVzLmFycmF5T2YoXG4gIFByb3BUeXBlcy5zaGFwZSh7XG4gICAgY29uc2VudE5hbWU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgICBjb25zZW50VGV4dDogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICAgIGRlc2NyaXB0aW9uOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gICAgY29uc2VudEluZGljYXRvcjogUHJvcFR5cGVzLmJvb2wuaXNSZXF1aXJlZCxcbiAgfSlcbik7XG5cbkN1c3RvbWVyQ29uc2VudHNMaXN0LnByb3BUeXBlcyA9IHtcbiAgaWRlbnRpZmllcjogSWRlbnRpZmllckRhdGFUeXBlLmlzUmVxdWlyZWQsXG4gIGNvbnNlbnRzRGV0YWlsczogQ29uc2VudHNEZXRhaWxzRGF0YVR5cGUsXG4gIG9uU2F2ZTogUHJvcFR5cGVzLmZ1bmMsXG59O1xuXG5DdXN0b21lckNvbnNlbnRzTGlzdC5kZWZhdWx0UHJvcHMgPSB7XG4gIGNvbnNlbnRzRGV0YWlsczogW10sXG4gIG9uU2F2ZTogKCkgPT4ge30sXG59O1xuXG5leHBvcnQgZGVmYXVsdCBDdXN0b21lckNvbnNlbnRzTGlzdDtcblxuZXhwb3J0IHsgSWRlbnRpZmllckRhdGFUeXBlLCBDb25zZW50c0RldGFpbHNEYXRhVHlwZSB9O1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$m
});
function CustomerConsentsList(_ref) {
  var identifier = _ref.identifier,
    consentsDetails = _ref.consentsDetails,
    onSave = _ref.onSave;
  // Keep the consent changes in a state until the save button is hit.
  var _useState = useState({}),
    _useState2 = _slicedToArray$2(_useState, 2),
    consentValues = _useState2[0],
    setConsentValues = _useState2[1];

  // Populate the consentValues map
  useEffect(function () {
    var propConsents = {};
    // eslint-disable-next-line no-restricted-syntax
    var _iterator = _createForOfIteratorHelper(consentsDetails),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _step.value,
          consentName = _step$value.consentName,
          consentIndicator = _step$value.consentIndicator;
        propConsents[consentName] = consentIndicator;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    setConsentValues(propConsents);
  }, [consentsDetails]);
  var onConsentChanged = function onConsentChanged(consentName, consentValue) {
    var newConsents = _objectSpread2$4(_objectSpread2$4({}, consentValues), {}, _defineProperty$5({}, consentName, consentValue));
    setConsentValues(newConsents);
  };
  var handleOnSave = function handleOnSave() {
    return onSave(identifier, consentValues);
  };
  var brandLabel = stringsResource.channelLabels[identifier.consentTypesChannel] || identifier.consentTypesChannel;
  return /*#__PURE__*/React__default.createElement(ConsentListWrapper, null, /*#__PURE__*/React__default.createElement(H2, null, "Dette er samtykke som er registret p\xE5 ", identifier.identifier, " hos ", brandLabel), consentsDetails.map(function (_ref2) {
    var consentName = _ref2.consentName,
      displayName = _ref2.displayName,
      consentText = _ref2.consentText,
      description = _ref2.description;
    return /*#__PURE__*/React__default.createElement(CustomerConsentItem, {
      key: consentName,
      name: consentName,
      displayName: displayName,
      text: consentText,
      description: description,
      value: consentValues[consentName] || false,
      onChanged: onConsentChanged
    });
  }), /*#__PURE__*/React__default.createElement(StyledButton$1, {
    onClick: handleOnSave
  }, "Lagre"));
}
var IdentifierDataType = PropTypes.shape({
  identifier: PropTypes.string.isRequired,
  identifierType: PropTypes.string.isRequired,
  consentTypesChannel: PropTypes.string.isRequired
});
var ConsentsDetailsDataType = PropTypes.arrayOf(PropTypes.shape({
  consentName: PropTypes.string.isRequired,
  consentText: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  consentIndicator: PropTypes.bool.isRequired
}));
CustomerConsentsList.propTypes = {
  identifier: IdentifierDataType.isRequired,
  consentsDetails: ConsentsDetailsDataType,
  onSave: PropTypes.func
};
CustomerConsentsList.defaultProps = {
  consentsDetails: [],
  onSave: function onSave() {}
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$l() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var StyledCustomerConsentsList = /*#__PURE__*/createStyled(CustomerConsentsList, "development" === "production" ? {
  target: "erxluia0"
} : {
  target: "erxluia0",
  label: "StyledCustomerConsentsList"
})("development" === "production" ? {
  name: "136oou1",
  styles: "margin-top:1.5rem;margin-bottom:1.5rem"
} : {
  name: "136oou1",
  styles: "margin-top:1.5rem;margin-bottom:1.5rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImN1c3RvbWVyLWNvbnNlbnRzLXZpZXcuanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVErRCIsImZpbGUiOiJjdXN0b21lci1jb25zZW50cy12aWV3LmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiO1xuaW1wb3J0IEN1c3RvbWVyQ29uc2VudHNMaXN0LCB7XG4gIElkZW50aWZpZXJEYXRhVHlwZSxcbiAgQ29uc2VudHNEZXRhaWxzRGF0YVR5cGUsXG59IGZyb20gXCIuL2N1c3RvbWVyLWNvbnNlbnRzLWxpc3RcIjtcblxuY29uc3QgU3R5bGVkQ3VzdG9tZXJDb25zZW50c0xpc3QgPSBzdHlsZWQoQ3VzdG9tZXJDb25zZW50c0xpc3QpYFxuICBtYXJnaW4tdG9wOiAxLjVyZW07XG4gIG1hcmdpbi1ib3R0b206IDEuNXJlbTtcbmA7XG5cbmZ1bmN0aW9uIEN1c3RvbWVyQ29uc2VudHNWaWV3KHsgY29uc2VudENoYW5uZWxzRGF0YSwgb25TYXZlIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8PlxuICAgICAge2NvbnNlbnRDaGFubmVsc0RhdGEubWFwKCh7IGlkZW50aWZpZXIsIGNvbnNlbnRzRGV0YWlscyB9KSA9PiAoXG4gICAgICAgIDxTdHlsZWRDdXN0b21lckNvbnNlbnRzTGlzdFxuICAgICAgICAgIGtleT17aWRlbnRpZmllci5jb25zZW50VHlwZXNDaGFubmVsfVxuICAgICAgICAgIGlkZW50aWZpZXI9e2lkZW50aWZpZXJ9XG4gICAgICAgICAgY29uc2VudHNEZXRhaWxzPXtjb25zZW50c0RldGFpbHN9XG4gICAgICAgICAgb25TYXZlPXtvblNhdmV9XG4gICAgICAgIC8+XG4gICAgICApKX1cbiAgICA8Lz5cbiAgKTtcbn1cblxuY29uc3QgY29uc2VudENoYW5uZWxzRGF0YURhdGFUeXBlID0gUHJvcFR5cGVzLmFycmF5T2YoXG4gIFByb3BUeXBlcy5zaGFwZSh7XG4gICAgaWRlbnRpZmllcjogSWRlbnRpZmllckRhdGFUeXBlLmlzUmVxdWlyZWQsXG4gICAgY29uc2VudHNEZXRhaWxzOiBDb25zZW50c0RldGFpbHNEYXRhVHlwZS5pc1JlcXVpcmVkLFxuICB9KVxuKTtcblxuQ3VzdG9tZXJDb25zZW50c1ZpZXcucHJvcFR5cGVzID0ge1xuICBjb25zZW50Q2hhbm5lbHNEYXRhOiBjb25zZW50Q2hhbm5lbHNEYXRhRGF0YVR5cGUsXG4gIG9uU2F2ZTogUHJvcFR5cGVzLmZ1bmMsXG59O1xuXG5DdXN0b21lckNvbnNlbnRzVmlldy5kZWZhdWx0UHJvcHMgPSB7XG4gIGNvbnNlbnRDaGFubmVsc0RhdGE6IFtdLFxuICBvblNhdmU6ICgpID0+IHt9LFxufTtcblxuZXhwb3J0IGRlZmF1bHQgQ3VzdG9tZXJDb25zZW50c1ZpZXc7XG5cbmV4cG9ydCB7IGNvbnNlbnRDaGFubmVsc0RhdGFEYXRhVHlwZSB9O1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$l
});
function CustomerConsentsView(_ref) {
  var consentChannelsData = _ref.consentChannelsData,
    onSave = _ref.onSave;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, consentChannelsData.map(function (_ref2) {
    var identifier = _ref2.identifier,
      consentsDetails = _ref2.consentsDetails;
    return /*#__PURE__*/React__default.createElement(StyledCustomerConsentsList, {
      key: identifier.consentTypesChannel,
      identifier: identifier,
      consentsDetails: consentsDetails,
      onSave: onSave
    });
  }));
}
var consentChannelsDataDataType = PropTypes.arrayOf(PropTypes.shape({
  identifier: IdentifierDataType.isRequired,
  consentsDetails: ConsentsDetailsDataType.isRequired
}));
CustomerConsentsView.propTypes = {
  consentChannelsData: consentChannelsDataDataType,
  onSave: PropTypes.func
};
CustomerConsentsView.defaultProps = {
  consentChannelsData: [],
  onSave: function onSave() {}
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$k() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var SearchWrapper = createStyled("div", "development" === "production" ? {
  target: "e15a6np20"
} : {
  target: "e15a6np20",
  label: "SearchWrapper"
})("development" === "production" ? {
  name: "3q4sw",
  styles: "max-width:960px;margin-top:2rem;margin-bottom:5rem;display:flex;flex-direction:row;align-items:center"
} : {
  name: "3q4sw",
  styles: "max-width:960px;margin-top:2rem;margin-bottom:5rem;display:flex;flex-direction:row;align-items:center",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$k
});
function CustomerCenterConsentsView(_ref) {
  var onSearch = _ref.onSearch,
    consentChannelsData = _ref.consentChannelsData,
    onSave = _ref.onSave;
  var _useState = useState(""),
    _useState2 = _slicedToArray$2(_useState, 2),
    searchText = _useState2[0],
    setSearchText = _useState2[1];
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("h2", null, "Skriv inn f\xF8dselsnummer eller E-post"), /*#__PURE__*/React__default.createElement(SearchWrapper, null, /*#__PURE__*/React__default.createElement(Input$1, {
    id: "search-box",
    onblur: function onblur(event) {
      return setSearchText(event.target.value);
    }
  }), /*#__PURE__*/React__default.createElement(BigButton, {
    style: {
      marginLeft: "2rem"
    },
    onClick: function onClick() {
      return onSearch(searchText);
    }
  }, "S\xF8k")), /*#__PURE__*/React__default.createElement(CustomerConsentsView, {
    consentChannelsData: consentChannelsData,
    onSave: onSave
  }));
}
CustomerCenterConsentsView.propTypes = {
  onSearch: PropTypes.func,
  consentChannelsData: consentChannelsDataDataType,
  onSave: PropTypes.func
};
CustomerCenterConsentsView.defaultProps = {
  onSearch: function onSearch() {},
  consentChannelsData: [],
  onSave: function onSave() {}
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$j() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Header$1 = createStyled("div", "development" === "production" ? {
  target: "e1ihe8212"
} : {
  target: "e1ihe8212",
  label: "Header"
})("development" === "production" ? {
  name: "drgr5u",
  styles: "font-size:2.5rem;letter-spacing:0.065em;line-height:1.3;margin-bottom:1rem"
} : {
  name: "drgr5u",
  styles: "font-size:2.5rem;letter-spacing:0.065em;line-height:1.3;margin-bottom:1rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$j
});
var BodyText = createStyled("div", "development" === "production" ? {
  target: "e1ihe8211"
} : {
  target: "e1ihe8211",
  label: "BodyText"
})("development" === "production" ? {
  name: "1tlmwo2",
  styles: "margin-bottom:0px"
} : {
  name: "1tlmwo2",
  styles: "margin-bottom:0px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$j
});
var Spacer = createStyled("div", "development" === "production" ? {
  target: "e1ihe8210"
} : {
  target: "e1ihe8210",
  label: "Spacer"
})("development" === "production" ? {
  name: "163ewy1",
  styles: "height:5rem"
} : {
  name: "163ewy1",
  styles: "height:5rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$j
});
function LoginView(_ref) {
  var targetPage = _ref.targetPage,
    buttonClicked = _ref.buttonClicked;
  var header = "";
  var bodyTextAboveBtn = "";
  var bodyTextBelowBtn = "";
  switch (targetPage) {
    case "CustomerCenterConsents":
    case "CustomerConsentsActive":
    case "MarketingConsents":
      {
        header = "Logg inn i nettbanken";
        bodyTextAboveBtn = "For å endre samtykke til markedsføring, må du identifisere deg og logge inn i nettbanken med BankID.";
        break;
      }
    case "IdentificationActive":
    case "SigningActive":
    default:
      {
        header = "Logg inn på Min Side";
        bodyTextAboveBtn = "For å signere avtalen må du identifisere deg og logge inn på Min Side med BankID.";
        bodyTextBelowBtn = "På Min side kan du signere avtalen og laste opp eventuell nødvendig dokumentasjon.";
        break;
      }
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Header$1, null, header), /*#__PURE__*/React__default.createElement(BodyText, null, bodyTextAboveBtn), /*#__PURE__*/React__default.createElement(Button, {
    label: "Logg inn med BankID",
    onclick: buttonClicked
  }), /*#__PURE__*/React__default.createElement(BodyText, null, bodyTextBelowBtn), /*#__PURE__*/React__default.createElement(Spacer, null), /*#__PURE__*/React__default.createElement(Header$1, null, "Elektronisk kommunikasjon"), /*#__PURE__*/React__default.createElement(BodyText, null, "Vi benytter oss av digitalt f\xF8rstevalg. \xD8nsker du som kunde \xE5 velge bort denne tjenesten, vennligst kontakt v\xE5r kundeservice p\xE5 telefonnummer 22 56 37 33."));
}
LoginView.propTypes = {
  targetPage: PropTypes.oneOf(["CustomerCenterConsents", "CustomerConsentsActive", "MarketingConsents", "IdentificationActive", "SigningActive"]),
  buttonClicked: PropTypes.func.isRequired
};
LoginView.defaultProps = {
  targetPage: "SigningActive"
};

/* eslint-disable */
if (typeof window !== "undefined") {
  (function (global, factory) {
    (typeof exports === "undefined" ? "undefined" : _typeof$3(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define('keycloak', factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Keycloak = factory());
  })(undefined, function () {

    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
    function commonjsRequire(path) {
      throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
    }
    var es6Promise_min = {
      exports: {}
    };
    (function (module, exports) {
      !function (t, e) {
        module.exports = e();
      }(commonjsGlobal, function () {
        function t(t) {
          var e = _typeof$3(t);
          return null !== t && ("object" === e || "function" === e);
        }
        function e(t) {
          return "function" == typeof t;
        }
        function n(t) {
          W = t;
        }
        function r(t) {
          z = t;
        }
        function o() {
          return function () {
            return process.nextTick(a);
          };
        }
        function i() {
          return "undefined" != typeof U ? function () {
            U(a);
          } : c();
        }
        function s() {
          var t = 0,
            e = new H(a),
            n = document.createTextNode("");
          return e.observe(n, {
            characterData: !0
          }), function () {
            n.data = t = ++t % 2;
          };
        }
        function u() {
          var t = new MessageChannel();
          return t.port1.onmessage = a, function () {
            return t.port2.postMessage(0);
          };
        }
        function c() {
          var t = setTimeout;
          return function () {
            return t(a, 1);
          };
        }
        function a() {
          for (var t = 0; t < N; t += 2) {
            var e = Q[t],
              n = Q[t + 1];
            e(n), Q[t] = void 0, Q[t + 1] = void 0;
          }
          N = 0;
        }
        function f() {
          try {
            var t = Function("return this")().require("vertx");
            return U = t.runOnLoop || t.runOnContext, i();
          } catch (e) {
            return c();
          }
        }
        function l(t, e) {
          var n = this,
            r = new this.constructor(v);
          void 0 === r[V] && x(r);
          var o = n._state;
          if (o) {
            var i = arguments[o - 1];
            z(function () {
              return T(o, r, i, n._result);
            });
          } else j(n, r, t, e);
          return r;
        }
        function h(t) {
          var e = this;
          if (t && "object" == _typeof$3(t) && t.constructor === e) return t;
          var n = new e(v);
          return w(n, t), n;
        }
        function v() {}
        function p() {
          return new TypeError("You cannot resolve a promise with itself");
        }
        function d() {
          return new TypeError("A promises callback cannot return that same promise.");
        }
        function _(t, e, n, r) {
          try {
            t.call(e, n, r);
          } catch (o) {
            return o;
          }
        }
        function y(t, e, n) {
          z(function (t) {
            var r = !1,
              o = _(n, e, function (n) {
                r || (r = !0, e !== n ? w(t, n) : A(t, n));
              }, function (e) {
                r || (r = !0, S(t, e));
              }, "Settle: " + (t._label || " unknown promise"));
            !r && o && (r = !0, S(t, o));
          }, t);
        }
        function m(t, e) {
          e._state === Z ? A(t, e._result) : e._state === $ ? S(t, e._result) : j(e, void 0, function (e) {
            return w(t, e);
          }, function (e) {
            return S(t, e);
          });
        }
        function b(t, n, r) {
          n.constructor === t.constructor && r === l && n.constructor.resolve === h ? m(t, n) : void 0 === r ? A(t, n) : e(r) ? y(t, n, r) : A(t, n);
        }
        function w(e, n) {
          if (e === n) S(e, p());else if (t(n)) {
            var r = void 0;
            try {
              r = n.then;
            } catch (o) {
              return void S(e, o);
            }
            b(e, n, r);
          } else A(e, n);
        }
        function g(t) {
          t._onerror && t._onerror(t._result), E(t);
        }
        function A(t, e) {
          t._state === X && (t._result = e, t._state = Z, 0 !== t._subscribers.length && z(E, t));
        }
        function S(t, e) {
          t._state === X && (t._state = $, t._result = e, z(g, t));
        }
        function j(t, e, n, r) {
          var o = t._subscribers,
            i = o.length;
          t._onerror = null, o[i] = e, o[i + Z] = n, o[i + $] = r, 0 === i && t._state && z(E, t);
        }
        function E(t) {
          var e = t._subscribers,
            n = t._state;
          if (0 !== e.length) {
            for (var r = void 0, o = void 0, i = t._result, s = 0; s < e.length; s += 3) {
              r = e[s], o = e[s + n], r ? T(n, r, o, i) : o(i);
            }
            t._subscribers.length = 0;
          }
        }
        function T(t, n, r, o) {
          var i = e(r),
            s = void 0,
            u = void 0,
            c = !0;
          if (i) {
            try {
              s = r(o);
            } catch (a) {
              c = !1, u = a;
            }
            if (n === s) return void S(n, d());
          } else s = o;
          n._state !== X || (i && c ? w(n, s) : c === !1 ? S(n, u) : t === Z ? A(n, s) : t === $ && S(n, s));
        }
        function M(t, e) {
          try {
            e(function (e) {
              w(t, e);
            }, function (e) {
              S(t, e);
            });
          } catch (n) {
            S(t, n);
          }
        }
        function P() {
          return tt++;
        }
        function x(t) {
          t[V] = tt++, t._state = void 0, t._result = void 0, t._subscribers = [];
        }
        function C() {
          return new Error("Array Methods must be provided an Array");
        }
        function O(t) {
          return new et(this, t).promise;
        }
        function k(t) {
          var e = this;
          return new e(L(t) ? function (n, r) {
            for (var o = t.length, i = 0; i < o; i++) {
              e.resolve(t[i]).then(n, r);
            }
          } : function (t, e) {
            return e(new TypeError("You must pass an array to race."));
          });
        }
        function F(t) {
          var e = this,
            n = new e(v);
          return S(n, t), n;
        }
        function Y() {
          throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
        }
        function q() {
          throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
        }
        function D() {
          var t = void 0;
          if ("undefined" != typeof commonjsGlobal) t = commonjsGlobal;else if ("undefined" != typeof self) t = self;else try {
            t = Function("return this")();
          } catch (e) {
            throw new Error("polyfill failed because global object is unavailable in this environment");
          }
          var n = t.Promise;
          if (n) {
            var r = null;
            try {
              r = Object.prototype.toString.call(n.resolve());
            } catch (e) {}
            if ("[object Promise]" === r && !n.cast) return;
          }
          t.Promise = nt;
        }
        var K = void 0;
        K = Array.isArray ? Array.isArray : function (t) {
          return "[object Array]" === Object.prototype.toString.call(t);
        };
        var L = K,
          N = 0,
          U = void 0,
          W = void 0,
          z = function z(t, e) {
            Q[N] = t, Q[N + 1] = e, N += 2, 2 === N && (W ? W(a) : R());
          },
          B = "undefined" != typeof window ? window : void 0,
          G = B || {},
          H = G.MutationObserver || G.WebKitMutationObserver,
          I = "undefined" == typeof self && "undefined" != typeof process && "[object process]" === {}.toString.call(process),
          J = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel,
          Q = new Array(1e3),
          R = void 0;
        R = I ? o() : H ? s() : J ? u() : void 0 === B && "function" == typeof commonjsRequire ? f() : c();
        var V = Math.random().toString(36).substring(2),
          X = void 0,
          Z = 1,
          $ = 2,
          tt = 0,
          et = function () {
            function t(t, e) {
              this._instanceConstructor = t, this.promise = new t(v), this.promise[V] || x(this.promise), L(e) ? (this.length = e.length, this._remaining = e.length, this._result = new Array(this.length), 0 === this.length ? A(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(e), 0 === this._remaining && A(this.promise, this._result))) : S(this.promise, C());
            }
            return t.prototype._enumerate = function (t) {
              for (var e = 0; this._state === X && e < t.length; e++) {
                this._eachEntry(t[e], e);
              }
            }, t.prototype._eachEntry = function (t, e) {
              var n = this._instanceConstructor,
                r = n.resolve;
              if (r === h) {
                var o = void 0,
                  i = void 0,
                  s = !1;
                try {
                  o = t.then;
                } catch (u) {
                  s = !0, i = u;
                }
                if (o === l && t._state !== X) this._settledAt(t._state, e, t._result);else if ("function" != typeof o) this._remaining--, this._result[e] = t;else if (n === nt) {
                  var c = new n(v);
                  s ? S(c, i) : b(c, t, o), this._willSettleAt(c, e);
                } else this._willSettleAt(new n(function (e) {
                  return e(t);
                }), e);
              } else this._willSettleAt(r(t), e);
            }, t.prototype._settledAt = function (t, e, n) {
              var r = this.promise;
              r._state === X && (this._remaining--, t === $ ? S(r, n) : this._result[e] = n), 0 === this._remaining && A(r, this._result);
            }, t.prototype._willSettleAt = function (t, e) {
              var n = this;
              j(t, void 0, function (t) {
                return n._settledAt(Z, e, t);
              }, function (t) {
                return n._settledAt($, e, t);
              });
            }, t;
          }(),
          nt = function () {
            function t(e) {
              this[V] = P(), this._result = this._state = void 0, this._subscribers = [], v !== e && ("function" != typeof e && Y(), this instanceof t ? M(this, e) : q());
            }
            return t.prototype["catch"] = function (t) {
              return this.then(null, t);
            }, t.prototype["finally"] = function (t) {
              var n = this,
                r = n.constructor;
              return e(t) ? n.then(function (e) {
                return r.resolve(t()).then(function () {
                  return e;
                });
              }, function (e) {
                return r.resolve(t()).then(function () {
                  throw e;
                });
              }) : n.then(t, t);
            }, t;
          }();
        return nt.prototype.then = l, nt.all = O, nt.race = k, nt.resolve = h, nt.reject = F, nt._setScheduler = n, nt._setAsap = r, nt._asap = z, nt.polyfill = D, nt.Promise = nt, nt;
      });
    })(es6Promise_min);
    var base64Js = {};
    base64Js.byteLength = byteLength;
    base64Js.toByteArray = toByteArray;
    base64Js.fromByteArray = fromByteArray;
    var lookup = [];
    var revLookup = [];
    var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
    var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    for (var i = 0, len = code.length; i < len; ++i) {
      lookup[i] = code[i];
      revLookup[code.charCodeAt(i)] = i;
    }

    // Support decoding URL-safe base64 strings, as Node.js does.
    // See: https://en.wikipedia.org/wiki/Base64#URL_applications
    revLookup['-'.charCodeAt(0)] = 62;
    revLookup['_'.charCodeAt(0)] = 63;
    function getLens(b64) {
      var len = b64.length;
      if (len % 4 > 0) {
        throw new Error('Invalid string. Length must be a multiple of 4');
      }

      // Trim off extra bytes after placeholder bytes are found
      // See: https://github.com/beatgammit/base64-js/issues/42
      var validLen = b64.indexOf('=');
      if (validLen === -1) validLen = len;
      var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
      return [validLen, placeHoldersLen];
    }

    // base64 is 4/3 + up to two characters of the original data
    function byteLength(b64) {
      var lens = getLens(b64);
      var validLen = lens[0];
      var placeHoldersLen = lens[1];
      return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function _byteLength(b64, validLen, placeHoldersLen) {
      return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function toByteArray(b64) {
      var tmp;
      var lens = getLens(b64);
      var validLen = lens[0];
      var placeHoldersLen = lens[1];
      var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
      var curByte = 0;

      // if there are placeholders, only get up to the last complete 4 chars
      var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
      var i;
      for (i = 0; i < len; i += 4) {
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
      }
      if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
      }
      if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
      }
      return arr;
    }
    function tripletToBase64(num) {
      return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
    }
    function encodeChunk(uint8, start, end) {
      var tmp;
      var output = [];
      for (var i = start; i < end; i += 3) {
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
      }
      return output.join('');
    }
    function fromByteArray(uint8) {
      var tmp;
      var len = uint8.length;
      var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
      var parts = [];
      var maxChunkLength = 16383; // must be multiple of 3

      // go through the array every three bytes, we'll deal with trailing stuff later
      for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
        parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
      }

      // pad the end with zeros, but make sure to not forget the extra bytes
      if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
      } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
      }
      return parts.join('');
    }
    var sha256$1 = {
      exports: {}
    };

    /**
     * [js-sha256]{@link https://github.com/emn178/js-sha256}
     *
     * @version 0.9.0
     * @author Chen, Yi-Cyuan [emn178@gmail.com]
     * @copyright Chen, Yi-Cyuan 2014-2017
     * @license MIT
     */

    (function (module) {
      /*jslint bitwise: true */
      (function () {
        var ERROR = 'input is invalid type';
        var WINDOW = (typeof window === "undefined" ? "undefined" : _typeof$3(window)) === 'object';
        var root = WINDOW ? window : {};
        if (root.JS_SHA256_NO_WINDOW) {
          WINDOW = false;
        }
        var WEB_WORKER = !WINDOW && (typeof self === "undefined" ? "undefined" : _typeof$3(self)) === 'object';
        var NODE_JS = !root.JS_SHA256_NO_NODE_JS && (typeof process === "undefined" ? "undefined" : _typeof$3(process)) === 'object' && process.versions && process.versions.node;
        if (NODE_JS) {
          root = commonjsGlobal;
        } else if (WEB_WORKER) {
          root = self;
        }
        var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && 'object' === 'object' && module.exports;
        var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
        var HEX_CHARS = '0123456789abcdef'.split('');
        var EXTRA = [-2147483648, 8388608, 32768, 128];
        var SHIFT = [24, 16, 8, 0];
        var K = [0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85, 0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2];
        var OUTPUT_TYPES = ['hex', 'array', 'digest', 'arrayBuffer'];
        var blocks = [];
        if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) {
          Array.isArray = function (obj) {
            return Object.prototype.toString.call(obj) === '[object Array]';
          };
        }
        if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
          ArrayBuffer.isView = function (obj) {
            return _typeof$3(obj) === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
          };
        }
        var createOutputMethod = function createOutputMethod(outputType, is224) {
          return function (message) {
            return new Sha256(is224, true).update(message)[outputType]();
          };
        };
        var createMethod = function createMethod(is224) {
          var method = createOutputMethod('hex', is224);
          if (NODE_JS) {
            method = nodeWrap(method, is224);
          }
          method.create = function () {
            return new Sha256(is224);
          };
          method.update = function (message) {
            return method.create().update(message);
          };
          for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type, is224);
          }
          return method;
        };
        var nodeWrap = function nodeWrap(method, is224) {
          var crypto = eval("require('crypto')");
          var Buffer = eval("require('buffer').Buffer");
          var algorithm = is224 ? 'sha224' : 'sha256';
          var nodeMethod = function nodeMethod(message) {
            if (typeof message === 'string') {
              return crypto.createHash(algorithm).update(message, 'utf8').digest('hex');
            } else {
              if (message === null || message === undefined) {
                throw new Error(ERROR);
              } else if (message.constructor === ArrayBuffer) {
                message = new Uint8Array(message);
              }
            }
            if (Array.isArray(message) || ArrayBuffer.isView(message) || message.constructor === Buffer) {
              return crypto.createHash(algorithm).update(new Buffer(message)).digest('hex');
            } else {
              return method(message);
            }
          };
          return nodeMethod;
        };
        var createHmacOutputMethod = function createHmacOutputMethod(outputType, is224) {
          return function (key, message) {
            return new HmacSha256(key, is224, true).update(message)[outputType]();
          };
        };
        var createHmacMethod = function createHmacMethod(is224) {
          var method = createHmacOutputMethod('hex', is224);
          method.create = function (key) {
            return new HmacSha256(key, is224);
          };
          method.update = function (key, message) {
            return method.create(key).update(message);
          };
          for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
            var type = OUTPUT_TYPES[i];
            method[type] = createHmacOutputMethod(type, is224);
          }
          return method;
        };
        function Sha256(is224, sharedMemory) {
          if (sharedMemory) {
            blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            this.blocks = blocks;
          } else {
            this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
          }
          if (is224) {
            this.h0 = 0xc1059ed8;
            this.h1 = 0x367cd507;
            this.h2 = 0x3070dd17;
            this.h3 = 0xf70e5939;
            this.h4 = 0xffc00b31;
            this.h5 = 0x68581511;
            this.h6 = 0x64f98fa7;
            this.h7 = 0xbefa4fa4;
          } else {
            // 256
            this.h0 = 0x6a09e667;
            this.h1 = 0xbb67ae85;
            this.h2 = 0x3c6ef372;
            this.h3 = 0xa54ff53a;
            this.h4 = 0x510e527f;
            this.h5 = 0x9b05688c;
            this.h6 = 0x1f83d9ab;
            this.h7 = 0x5be0cd19;
          }
          this.block = this.start = this.bytes = this.hBytes = 0;
          this.finalized = this.hashed = false;
          this.first = true;
          this.is224 = is224;
        }
        Sha256.prototype.update = function (message) {
          if (this.finalized) {
            return;
          }
          var notString,
            type = _typeof$3(message);
          if (type !== 'string') {
            if (type === 'object') {
              if (message === null) {
                throw new Error(ERROR);
              } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
                message = new Uint8Array(message);
              } else if (!Array.isArray(message)) {
                if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
                  throw new Error(ERROR);
                }
              }
            } else {
              throw new Error(ERROR);
            }
            notString = true;
          }
          var code,
            index = 0,
            i,
            length = message.length,
            blocks = this.blocks;
          while (index < length) {
            if (this.hashed) {
              this.hashed = false;
              blocks[0] = this.block;
              blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            }
            if (notString) {
              for (i = this.start; index < length && i < 64; ++index) {
                blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
              }
            } else {
              for (i = this.start; index < length && i < 64; ++index) {
                code = message.charCodeAt(index);
                if (code < 0x80) {
                  blocks[i >> 2] |= code << SHIFT[i++ & 3];
                } else if (code < 0x800) {
                  blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                  blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                  code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                  blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
              }
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 64) {
              this.block = blocks[16];
              this.start = i - 64;
              this.hash();
              this.hashed = true;
            } else {
              this.start = i;
            }
          }
          if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
          }
          return this;
        };
        Sha256.prototype.finalize = function () {
          if (this.finalized) {
            return;
          }
          this.finalized = true;
          var blocks = this.blocks,
            i = this.lastByteIndex;
          blocks[16] = this.block;
          blocks[i >> 2] |= EXTRA[i & 3];
          this.block = blocks[16];
          if (i >= 56) {
            if (!this.hashed) {
              this.hash();
            }
            blocks[0] = this.block;
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
          }
          blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
          blocks[15] = this.bytes << 3;
          this.hash();
        };
        Sha256.prototype.hash = function () {
          var a = this.h0,
            b = this.h1,
            c = this.h2,
            d = this.h3,
            e = this.h4,
            f = this.h5,
            g = this.h6,
            h = this.h7,
            blocks = this.blocks,
            j,
            s0,
            s1,
            maj,
            t1,
            t2,
            ch,
            ab,
            da,
            cd,
            bc;
          for (j = 16; j < 64; ++j) {
            // rightrotate
            t1 = blocks[j - 15];
            s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
            t1 = blocks[j - 2];
            s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
            blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
          }
          bc = b & c;
          for (j = 0; j < 64; j += 4) {
            if (this.first) {
              if (this.is224) {
                ab = 300032;
                t1 = blocks[0] - 1413257819;
                h = t1 - 150054599 << 0;
                d = t1 + 24177077 << 0;
              } else {
                ab = 704751109;
                t1 = blocks[0] - 210244248;
                h = t1 - 1521486534 << 0;
                d = t1 + 143694565 << 0;
              }
              this.first = false;
            } else {
              s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
              s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
              ab = a & b;
              maj = ab ^ a & c ^ bc;
              ch = e & f ^ ~e & g;
              t1 = h + s1 + ch + K[j] + blocks[j];
              t2 = s0 + maj;
              h = d + t1 << 0;
              d = t1 + t2 << 0;
            }
            s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
            s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
            da = d & a;
            maj = da ^ d & b ^ ab;
            ch = h & e ^ ~h & f;
            t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
            t2 = s0 + maj;
            g = c + t1 << 0;
            c = t1 + t2 << 0;
            s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
            s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
            cd = c & d;
            maj = cd ^ c & a ^ da;
            ch = g & h ^ ~g & e;
            t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
            t2 = s0 + maj;
            f = b + t1 << 0;
            b = t1 + t2 << 0;
            s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
            s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
            bc = b & c;
            maj = bc ^ b & d ^ cd;
            ch = f & g ^ ~f & h;
            t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
            t2 = s0 + maj;
            e = a + t1 << 0;
            a = t1 + t2 << 0;
          }
          this.h0 = this.h0 + a << 0;
          this.h1 = this.h1 + b << 0;
          this.h2 = this.h2 + c << 0;
          this.h3 = this.h3 + d << 0;
          this.h4 = this.h4 + e << 0;
          this.h5 = this.h5 + f << 0;
          this.h6 = this.h6 + g << 0;
          this.h7 = this.h7 + h << 0;
        };
        Sha256.prototype.hex = function () {
          this.finalize();
          var h0 = this.h0,
            h1 = this.h1,
            h2 = this.h2,
            h3 = this.h3,
            h4 = this.h4,
            h5 = this.h5,
            h6 = this.h6,
            h7 = this.h7;
          var hex = HEX_CHARS[h0 >> 28 & 0x0F] + HEX_CHARS[h0 >> 24 & 0x0F] + HEX_CHARS[h0 >> 20 & 0x0F] + HEX_CHARS[h0 >> 16 & 0x0F] + HEX_CHARS[h0 >> 12 & 0x0F] + HEX_CHARS[h0 >> 8 & 0x0F] + HEX_CHARS[h0 >> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h1 >> 28 & 0x0F] + HEX_CHARS[h1 >> 24 & 0x0F] + HEX_CHARS[h1 >> 20 & 0x0F] + HEX_CHARS[h1 >> 16 & 0x0F] + HEX_CHARS[h1 >> 12 & 0x0F] + HEX_CHARS[h1 >> 8 & 0x0F] + HEX_CHARS[h1 >> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h2 >> 28 & 0x0F] + HEX_CHARS[h2 >> 24 & 0x0F] + HEX_CHARS[h2 >> 20 & 0x0F] + HEX_CHARS[h2 >> 16 & 0x0F] + HEX_CHARS[h2 >> 12 & 0x0F] + HEX_CHARS[h2 >> 8 & 0x0F] + HEX_CHARS[h2 >> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h3 >> 28 & 0x0F] + HEX_CHARS[h3 >> 24 & 0x0F] + HEX_CHARS[h3 >> 20 & 0x0F] + HEX_CHARS[h3 >> 16 & 0x0F] + HEX_CHARS[h3 >> 12 & 0x0F] + HEX_CHARS[h3 >> 8 & 0x0F] + HEX_CHARS[h3 >> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h4 >> 28 & 0x0F] + HEX_CHARS[h4 >> 24 & 0x0F] + HEX_CHARS[h4 >> 20 & 0x0F] + HEX_CHARS[h4 >> 16 & 0x0F] + HEX_CHARS[h4 >> 12 & 0x0F] + HEX_CHARS[h4 >> 8 & 0x0F] + HEX_CHARS[h4 >> 4 & 0x0F] + HEX_CHARS[h4 & 0x0F] + HEX_CHARS[h5 >> 28 & 0x0F] + HEX_CHARS[h5 >> 24 & 0x0F] + HEX_CHARS[h5 >> 20 & 0x0F] + HEX_CHARS[h5 >> 16 & 0x0F] + HEX_CHARS[h5 >> 12 & 0x0F] + HEX_CHARS[h5 >> 8 & 0x0F] + HEX_CHARS[h5 >> 4 & 0x0F] + HEX_CHARS[h5 & 0x0F] + HEX_CHARS[h6 >> 28 & 0x0F] + HEX_CHARS[h6 >> 24 & 0x0F] + HEX_CHARS[h6 >> 20 & 0x0F] + HEX_CHARS[h6 >> 16 & 0x0F] + HEX_CHARS[h6 >> 12 & 0x0F] + HEX_CHARS[h6 >> 8 & 0x0F] + HEX_CHARS[h6 >> 4 & 0x0F] + HEX_CHARS[h6 & 0x0F];
          if (!this.is224) {
            hex += HEX_CHARS[h7 >> 28 & 0x0F] + HEX_CHARS[h7 >> 24 & 0x0F] + HEX_CHARS[h7 >> 20 & 0x0F] + HEX_CHARS[h7 >> 16 & 0x0F] + HEX_CHARS[h7 >> 12 & 0x0F] + HEX_CHARS[h7 >> 8 & 0x0F] + HEX_CHARS[h7 >> 4 & 0x0F] + HEX_CHARS[h7 & 0x0F];
          }
          return hex;
        };
        Sha256.prototype.toString = Sha256.prototype.hex;
        Sha256.prototype.digest = function () {
          this.finalize();
          var h0 = this.h0,
            h1 = this.h1,
            h2 = this.h2,
            h3 = this.h3,
            h4 = this.h4,
            h5 = this.h5,
            h6 = this.h6,
            h7 = this.h7;
          var arr = [h0 >> 24 & 0xFF, h0 >> 16 & 0xFF, h0 >> 8 & 0xFF, h0 & 0xFF, h1 >> 24 & 0xFF, h1 >> 16 & 0xFF, h1 >> 8 & 0xFF, h1 & 0xFF, h2 >> 24 & 0xFF, h2 >> 16 & 0xFF, h2 >> 8 & 0xFF, h2 & 0xFF, h3 >> 24 & 0xFF, h3 >> 16 & 0xFF, h3 >> 8 & 0xFF, h3 & 0xFF, h4 >> 24 & 0xFF, h4 >> 16 & 0xFF, h4 >> 8 & 0xFF, h4 & 0xFF, h5 >> 24 & 0xFF, h5 >> 16 & 0xFF, h5 >> 8 & 0xFF, h5 & 0xFF, h6 >> 24 & 0xFF, h6 >> 16 & 0xFF, h6 >> 8 & 0xFF, h6 & 0xFF];
          if (!this.is224) {
            arr.push(h7 >> 24 & 0xFF, h7 >> 16 & 0xFF, h7 >> 8 & 0xFF, h7 & 0xFF);
          }
          return arr;
        };
        Sha256.prototype.array = Sha256.prototype.digest;
        Sha256.prototype.arrayBuffer = function () {
          this.finalize();
          var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
          var dataView = new DataView(buffer);
          dataView.setUint32(0, this.h0);
          dataView.setUint32(4, this.h1);
          dataView.setUint32(8, this.h2);
          dataView.setUint32(12, this.h3);
          dataView.setUint32(16, this.h4);
          dataView.setUint32(20, this.h5);
          dataView.setUint32(24, this.h6);
          if (!this.is224) {
            dataView.setUint32(28, this.h7);
          }
          return buffer;
        };
        function HmacSha256(key, is224, sharedMemory) {
          var i,
            type = _typeof$3(key);
          if (type === 'string') {
            var bytes = [],
              length = key.length,
              index = 0,
              code;
            for (i = 0; i < length; ++i) {
              code = key.charCodeAt(i);
              if (code < 0x80) {
                bytes[index++] = code;
              } else if (code < 0x800) {
                bytes[index++] = 0xc0 | code >> 6;
                bytes[index++] = 0x80 | code & 0x3f;
              } else if (code < 0xd800 || code >= 0xe000) {
                bytes[index++] = 0xe0 | code >> 12;
                bytes[index++] = 0x80 | code >> 6 & 0x3f;
                bytes[index++] = 0x80 | code & 0x3f;
              } else {
                code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                bytes[index++] = 0xf0 | code >> 18;
                bytes[index++] = 0x80 | code >> 12 & 0x3f;
                bytes[index++] = 0x80 | code >> 6 & 0x3f;
                bytes[index++] = 0x80 | code & 0x3f;
              }
            }
            key = bytes;
          } else {
            if (type === 'object') {
              if (key === null) {
                throw new Error(ERROR);
              } else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) {
                key = new Uint8Array(key);
              } else if (!Array.isArray(key)) {
                if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) {
                  throw new Error(ERROR);
                }
              }
            } else {
              throw new Error(ERROR);
            }
          }
          if (key.length > 64) {
            key = new Sha256(is224, true).update(key).array();
          }
          var oKeyPad = [],
            iKeyPad = [];
          for (i = 0; i < 64; ++i) {
            var b = key[i] || 0;
            oKeyPad[i] = 0x5c ^ b;
            iKeyPad[i] = 0x36 ^ b;
          }
          Sha256.call(this, is224, sharedMemory);
          this.update(iKeyPad);
          this.oKeyPad = oKeyPad;
          this.inner = true;
          this.sharedMemory = sharedMemory;
        }
        HmacSha256.prototype = new Sha256();
        HmacSha256.prototype.finalize = function () {
          Sha256.prototype.finalize.call(this);
          if (this.inner) {
            this.inner = false;
            var innerHash = this.array();
            Sha256.call(this, this.is224, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash);
            Sha256.prototype.finalize.call(this);
          }
        };
        var exports = createMethod();
        exports.sha256 = exports;
        exports.sha224 = createMethod(true);
        exports.sha256.hmac = createHmacMethod();
        exports.sha224.hmac = createHmacMethod(true);
        if (COMMON_JS) {
          module.exports = exports;
        } else {
          root.sha256 = exports.sha256;
          root.sha224 = exports.sha224;
        }
      })();
    })(sha256$1);
    var sha256 = sha256$1.exports;
    if (typeof es6Promise_min.exports.Promise === 'undefined') {
      throw Error('Keycloak requires an environment that supports Promises. Make sure that you include the appropriate polyfill.');
    }
    var loggedPromiseDeprecation = false;
    function logPromiseDeprecation() {
      if (!loggedPromiseDeprecation) {
        loggedPromiseDeprecation = true;
        console.warn('[KEYCLOAK] Usage of legacy style promise methods such as `.error()` and `.success()` has been deprecated and support will be removed in future versions. Use standard style promise methods such as `.then() and `.catch()` instead.');
      }
    }
    function Keycloak(config) {
      if (!(this instanceof Keycloak)) {
        return new Keycloak(config);
      }
      var kc = this;
      var adapter;
      var refreshQueue = [];
      var callbackStorage;
      var loginIframe = {
        enable: true,
        callbackList: [],
        interval: 5
      };
      var scripts = document.getElementsByTagName('script');
      for (var i = 0; i < scripts.length; i++) {
        if ((scripts[i].src.indexOf('keycloak.js') !== -1 || scripts[i].src.indexOf('keycloak.min.js') !== -1) && scripts[i].src.indexOf('version=') !== -1) {
          kc.iframeVersion = scripts[i].src.substring(scripts[i].src.indexOf('version=') + 8).split('&')[0];
        }
      }
      var useNonce = true;
      var logInfo = createLogger(console.info);
      var logWarn = createLogger(console.warn);
      kc.init = function (initOptions) {
        kc.authenticated = false;
        callbackStorage = createCallbackStorage();
        var adapters = ['default', 'cordova', 'cordova-native'];
        if (initOptions && adapters.indexOf(initOptions.adapter) > -1) {
          adapter = loadAdapter(initOptions.adapter);
        } else if (initOptions && _typeof$3(initOptions.adapter) === "object") {
          adapter = initOptions.adapter;
        } else {
          if (window.Cordova || window.cordova) {
            adapter = loadAdapter('cordova');
          } else {
            adapter = loadAdapter();
          }
        }
        if (initOptions) {
          if (typeof initOptions.useNonce !== 'undefined') {
            useNonce = initOptions.useNonce;
          }
          if (typeof initOptions.checkLoginIframe !== 'undefined') {
            loginIframe.enable = initOptions.checkLoginIframe;
          }
          if (initOptions.checkLoginIframeInterval) {
            loginIframe.interval = initOptions.checkLoginIframeInterval;
          }
          if (initOptions.onLoad === 'login-required') {
            kc.loginRequired = true;
          }
          if (initOptions.responseMode) {
            if (initOptions.responseMode === 'query' || initOptions.responseMode === 'fragment') {
              kc.responseMode = initOptions.responseMode;
            } else {
              throw 'Invalid value for responseMode';
            }
          }
          if (initOptions.flow) {
            switch (initOptions.flow) {
              case 'standard':
                kc.responseType = 'code';
                break;
              case 'implicit':
                kc.responseType = 'id_token token';
                break;
              case 'hybrid':
                kc.responseType = 'code id_token token';
                break;
              default:
                throw 'Invalid value for flow';
            }
            kc.flow = initOptions.flow;
          }
          if (initOptions.timeSkew != null) {
            kc.timeSkew = initOptions.timeSkew;
          }
          if (initOptions.redirectUri) {
            kc.redirectUri = initOptions.redirectUri;
          }
          if (initOptions.silentCheckSsoRedirectUri) {
            kc.silentCheckSsoRedirectUri = initOptions.silentCheckSsoRedirectUri;
          }
          if (typeof initOptions.silentCheckSsoFallback === 'boolean') {
            kc.silentCheckSsoFallback = initOptions.silentCheckSsoFallback;
          } else {
            kc.silentCheckSsoFallback = true;
          }
          if (initOptions.pkceMethod) {
            if (initOptions.pkceMethod !== "S256") {
              throw 'Invalid value for pkceMethod';
            }
            kc.pkceMethod = initOptions.pkceMethod;
          }
          if (typeof initOptions.enableLogging === 'boolean') {
            kc.enableLogging = initOptions.enableLogging;
          } else {
            kc.enableLogging = false;
          }
          if (typeof initOptions.scope === 'string') {
            kc.scope = initOptions.scope;
          }
          if (typeof initOptions.messageReceiveTimeout === 'number' && initOptions.messageReceiveTimeout > 0) {
            kc.messageReceiveTimeout = initOptions.messageReceiveTimeout;
          } else {
            kc.messageReceiveTimeout = 10000;
          }
        }
        if (!kc.responseMode) {
          kc.responseMode = 'fragment';
        }
        if (!kc.responseType) {
          kc.responseType = 'code';
          kc.flow = 'standard';
        }
        var promise = createPromise();
        var initPromise = createPromise();
        initPromise.promise.then(function () {
          kc.onReady && kc.onReady(kc.authenticated);
          promise.setSuccess(kc.authenticated);
        }).catch(function (error) {
          promise.setError(error);
        });
        var configPromise = loadConfig();
        function onLoad() {
          var doLogin = function doLogin(prompt) {
            if (!prompt) {
              options.prompt = 'none';
            }
            kc.login(options).then(function () {
              initPromise.setSuccess();
            }).catch(function (error) {
              initPromise.setError(error);
            });
          };
          var checkSsoSilently = function checkSsoSilently() {
            var ifrm = document.createElement("iframe");
            var src = kc.createLoginUrl({
              prompt: 'none',
              redirectUri: kc.silentCheckSsoRedirectUri
            });
            ifrm.setAttribute("src", src);
            ifrm.setAttribute("title", "keycloak-silent-check-sso");
            ifrm.style.display = "none";
            document.body.appendChild(ifrm);
            var messageCallback = function messageCallback(event) {
              if (event.origin !== window.location.origin || ifrm.contentWindow !== event.source) {
                return;
              }
              var oauth = parseCallback(event.data);
              processCallback(oauth, initPromise);
              document.body.removeChild(ifrm);
              window.removeEventListener("message", messageCallback);
            };
            window.addEventListener("message", messageCallback);
          };
          var options = {};
          switch (initOptions.onLoad) {
            case 'check-sso':
              if (loginIframe.enable) {
                setupCheckLoginIframe().then(function () {
                  checkLoginIframe().then(function (unchanged) {
                    if (!unchanged) {
                      kc.silentCheckSsoRedirectUri ? checkSsoSilently() : doLogin(false);
                    } else {
                      initPromise.setSuccess();
                    }
                  }).catch(function (error) {
                    initPromise.setError(error);
                  });
                });
              } else {
                kc.silentCheckSsoRedirectUri ? checkSsoSilently() : doLogin(false);
              }
              break;
            case 'login-required':
              doLogin(true);
              break;
            default:
              throw 'Invalid value for onLoad';
          }
        }
        function processInit() {
          var callback = parseCallback(window.location.href);
          if (callback) {
            window.history.replaceState(window.history.state, null, callback.newUrl);
          }
          if (callback && callback.valid) {
            return setupCheckLoginIframe().then(function () {
              processCallback(callback, initPromise);
            }).catch(function (error) {
              initPromise.setError(error);
            });
          } else if (initOptions) {
            if (initOptions.token && initOptions.refreshToken) {
              setToken(initOptions.token, initOptions.refreshToken, initOptions.idToken);
              if (loginIframe.enable) {
                setupCheckLoginIframe().then(function () {
                  checkLoginIframe().then(function (unchanged) {
                    if (unchanged) {
                      kc.onAuthSuccess && kc.onAuthSuccess();
                      initPromise.setSuccess();
                      scheduleCheckIframe();
                    } else {
                      initPromise.setSuccess();
                    }
                  }).catch(function (error) {
                    initPromise.setError(error);
                  });
                });
              } else {
                kc.updateToken(-1).then(function () {
                  kc.onAuthSuccess && kc.onAuthSuccess();
                  initPromise.setSuccess();
                }).catch(function (error) {
                  kc.onAuthError && kc.onAuthError();
                  if (initOptions.onLoad) {
                    onLoad();
                  } else {
                    initPromise.setError(error);
                  }
                });
              }
            } else if (initOptions.onLoad) {
              onLoad();
            } else {
              initPromise.setSuccess();
            }
          } else {
            initPromise.setSuccess();
          }
        }
        function domReady() {
          var promise = createPromise();
          var checkReadyState = function checkReadyState() {
            if (document.readyState === 'interactive' || document.readyState === 'complete') {
              document.removeEventListener('readystatechange', checkReadyState);
              promise.setSuccess();
            }
          };
          document.addEventListener('readystatechange', checkReadyState);
          checkReadyState(); // just in case the event was already fired and we missed it (in case the init is done later than at the load time, i.e. it's done from code)

          return promise.promise;
        }
        configPromise.then(function () {
          domReady().then(check3pCookiesSupported).then(processInit).catch(function (error) {
            promise.setError(error);
          });
        });
        configPromise.catch(function (error) {
          promise.setError(error);
        });
        return promise.promise;
      };
      kc.login = function (options) {
        return adapter.login(options);
      };
      function generateRandomData(len) {
        // use web crypto APIs if possible
        var array = null;
        var crypto = window.crypto || window.msCrypto;
        if (crypto && crypto.getRandomValues && window.Uint8Array) {
          array = new Uint8Array(len);
          crypto.getRandomValues(array);
          return array;
        }

        // fallback to Math random
        array = new Array(len);
        for (var j = 0; j < array.length; j++) {
          array[j] = Math.floor(256 * Math.random());
        }
        return array;
      }
      function generateCodeVerifier(len) {
        return generateRandomString(len, 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789');
      }
      function generateRandomString(len, alphabet) {
        var randomData = generateRandomData(len);
        var chars = new Array(len);
        for (var i = 0; i < len; i++) {
          chars[i] = alphabet.charCodeAt(randomData[i] % alphabet.length);
        }
        return String.fromCharCode.apply(null, chars);
      }
      function generatePkceChallenge(pkceMethod, codeVerifier) {
        switch (pkceMethod) {
          // The use of the "plain" method is considered insecure and therefore not supported.
          case "S256":
            // hash codeVerifier, then encode as url-safe base64 without padding
            var hashBytes = new Uint8Array(sha256.arrayBuffer(codeVerifier));
            var encodedHash = base64Js.fromByteArray(hashBytes).replace(/\+/g, '-').replace(/\//g, '_').replace(/\=/g, '');
            return encodedHash;
          default:
            throw 'Invalid value for pkceMethod';
        }
      }
      function buildClaimsParameter(requestedAcr) {
        var claims = {
          id_token: {
            acr: requestedAcr
          }
        };
        return JSON.stringify(claims);
      }
      kc.createLoginUrl = function (options) {
        var state = createUUID();
        var nonce = createUUID();
        var redirectUri = adapter.redirectUri(options);
        var callbackState = {
          state: state,
          nonce: nonce,
          redirectUri: encodeURIComponent(redirectUri)
        };
        if (options && options.prompt) {
          callbackState.prompt = options.prompt;
        }
        var baseUrl;
        if (options && options.action == 'register') {
          baseUrl = kc.endpoints.register();
        } else {
          baseUrl = kc.endpoints.authorize();
        }
        var scope = options && options.scope || kc.scope;
        if (!scope) {
          // if scope is not set, default to "openid"
          scope = "openid";
        } else if (scope.indexOf("openid") === -1) {
          // if openid scope is missing, prefix the given scopes with it
          scope = "openid " + scope;
        }
        var url = baseUrl + '?client_id=' + encodeURIComponent(kc.clientId) + '&redirect_uri=' + encodeURIComponent(redirectUri) + '&state=' + encodeURIComponent(state) + '&response_mode=' + encodeURIComponent(kc.responseMode) + '&response_type=' + encodeURIComponent(kc.responseType) + '&scope=' + encodeURIComponent(scope);
        if (useNonce) {
          url = url + '&nonce=' + encodeURIComponent(nonce);
        }
        if (options && options.prompt) {
          url += '&prompt=' + encodeURIComponent(options.prompt);
        }
        if (options && options.maxAge) {
          url += '&max_age=' + encodeURIComponent(options.maxAge);
        }
        if (options && options.loginHint) {
          url += '&login_hint=' + encodeURIComponent(options.loginHint);
        }
        if (options && options.idpHint) {
          url += '&kc_idp_hint=' + encodeURIComponent(options.idpHint);
        }
        if (options && options.action && options.action != 'register') {
          url += '&kc_action=' + encodeURIComponent(options.action);
        }
        if (options && options.locale) {
          url += '&ui_locales=' + encodeURIComponent(options.locale);
        }
        if (options && options.acr) {
          var claimsParameter = buildClaimsParameter(options.acr);
          url += '&claims=' + encodeURIComponent(claimsParameter);
        }
        if (kc.pkceMethod) {
          var codeVerifier = generateCodeVerifier(96);
          callbackState.pkceCodeVerifier = codeVerifier;
          var pkceChallenge = generatePkceChallenge(kc.pkceMethod, codeVerifier);
          url += '&code_challenge=' + pkceChallenge;
          url += '&code_challenge_method=' + kc.pkceMethod;
        }
        callbackStorage.add(callbackState);
        return url;
      };
      kc.logout = function (options) {
        return adapter.logout(options);
      };
      kc.createLogoutUrl = function (options) {
        var url = kc.endpoints.logout() + '?client_id=' + encodeURIComponent(kc.clientId) + '&post_logout_redirect_uri=' + encodeURIComponent(adapter.redirectUri(options, false));
        if (kc.idToken) {
          url += '&id_token_hint=' + encodeURIComponent(kc.idToken);
        }
        return url;
      };
      kc.register = function (options) {
        return adapter.register(options);
      };
      kc.createRegisterUrl = function (options) {
        if (!options) {
          options = {};
        }
        options.action = 'register';
        return kc.createLoginUrl(options);
      };
      kc.createAccountUrl = function (options) {
        var realm = getRealmUrl();
        var url = undefined;
        if (typeof realm !== 'undefined') {
          url = realm + '/account' + '?referrer=' + encodeURIComponent(kc.clientId) + '&referrer_uri=' + encodeURIComponent(adapter.redirectUri(options));
        }
        return url;
      };
      kc.accountManagement = function () {
        return adapter.accountManagement();
      };
      kc.hasRealmRole = function (role) {
        var access = kc.realmAccess;
        return !!access && access.roles.indexOf(role) >= 0;
      };
      kc.hasResourceRole = function (role, resource) {
        if (!kc.resourceAccess) {
          return false;
        }
        var access = kc.resourceAccess[resource || kc.clientId];
        return !!access && access.roles.indexOf(role) >= 0;
      };
      kc.loadUserProfile = function () {
        var url = getRealmUrl() + '/account';
        var req = new XMLHttpRequest();
        req.open('GET', url, true);
        req.setRequestHeader('Accept', 'application/json');
        req.setRequestHeader('Authorization', 'bearer ' + kc.token);
        var promise = createPromise();
        req.onreadystatechange = function () {
          if (req.readyState == 4) {
            if (req.status == 200) {
              kc.profile = JSON.parse(req.responseText);
              promise.setSuccess(kc.profile);
            } else {
              promise.setError();
            }
          }
        };
        req.send();
        return promise.promise;
      };
      kc.loadUserInfo = function () {
        var url = kc.endpoints.userinfo();
        var req = new XMLHttpRequest();
        req.open('GET', url, true);
        req.setRequestHeader('Accept', 'application/json');
        req.setRequestHeader('Authorization', 'bearer ' + kc.token);
        var promise = createPromise();
        req.onreadystatechange = function () {
          if (req.readyState == 4) {
            if (req.status == 200) {
              kc.userInfo = JSON.parse(req.responseText);
              promise.setSuccess(kc.userInfo);
            } else {
              promise.setError();
            }
          }
        };
        req.send();
        return promise.promise;
      };
      kc.isTokenExpired = function (minValidity) {
        if (!kc.tokenParsed || !kc.refreshToken && kc.flow != 'implicit') {
          throw 'Not authenticated';
        }
        if (kc.timeSkew == null) {
          logInfo('[KEYCLOAK] Unable to determine if token is expired as timeskew is not set');
          return true;
        }
        var expiresIn = kc.tokenParsed['exp'] - Math.ceil(new Date().getTime() / 1000) + kc.timeSkew;
        if (minValidity) {
          if (isNaN(minValidity)) {
            throw 'Invalid minValidity';
          }
          expiresIn -= minValidity;
        }
        return expiresIn < 0;
      };
      kc.updateToken = function (minValidity) {
        var promise = createPromise();
        if (!kc.refreshToken) {
          promise.setError();
          return promise.promise;
        }
        minValidity = minValidity || 5;
        var exec = function exec() {
          var refreshToken = false;
          if (minValidity == -1) {
            refreshToken = true;
            logInfo('[KEYCLOAK] Refreshing token: forced refresh');
          } else if (!kc.tokenParsed || kc.isTokenExpired(minValidity)) {
            refreshToken = true;
            logInfo('[KEYCLOAK] Refreshing token: token expired');
          }
          if (!refreshToken) {
            promise.setSuccess(false);
          } else {
            var params = 'grant_type=refresh_token&' + 'refresh_token=' + kc.refreshToken;
            var url = kc.endpoints.token();
            refreshQueue.push(promise);
            if (refreshQueue.length == 1) {
              var req = new XMLHttpRequest();
              req.open('POST', url, true);
              req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
              req.withCredentials = true;
              params += '&client_id=' + encodeURIComponent(kc.clientId);
              var timeLocal = new Date().getTime();
              req.onreadystatechange = function () {
                if (req.readyState == 4) {
                  if (req.status == 200) {
                    logInfo('[KEYCLOAK] Token refreshed');
                    timeLocal = (timeLocal + new Date().getTime()) / 2;
                    var tokenResponse = JSON.parse(req.responseText);
                    setToken(tokenResponse['access_token'], tokenResponse['refresh_token'], tokenResponse['id_token'], timeLocal);
                    kc.onAuthRefreshSuccess && kc.onAuthRefreshSuccess();
                    for (var p = refreshQueue.pop(); p != null; p = refreshQueue.pop()) {
                      p.setSuccess(true);
                    }
                  } else {
                    logWarn('[KEYCLOAK] Failed to refresh token');
                    if (req.status == 400) {
                      kc.clearToken();
                    }
                    kc.onAuthRefreshError && kc.onAuthRefreshError();
                    for (var p = refreshQueue.pop(); p != null; p = refreshQueue.pop()) {
                      p.setError(true);
                    }
                  }
                }
              };
              req.send(params);
            }
          }
        };
        if (loginIframe.enable) {
          var iframePromise = checkLoginIframe();
          iframePromise.then(function () {
            exec();
          }).catch(function (error) {
            promise.setError(error);
          });
        } else {
          exec();
        }
        return promise.promise;
      };
      kc.clearToken = function () {
        if (kc.token) {
          setToken(null, null, null);
          kc.onAuthLogout && kc.onAuthLogout();
          if (kc.loginRequired) {
            kc.login();
          }
        }
      };
      function getRealmUrl() {
        if (typeof kc.authServerUrl !== 'undefined') {
          if (kc.authServerUrl.charAt(kc.authServerUrl.length - 1) == '/') {
            return kc.authServerUrl + 'realms/' + encodeURIComponent(kc.realm);
          } else {
            return kc.authServerUrl + '/realms/' + encodeURIComponent(kc.realm);
          }
        } else {
          return undefined;
        }
      }
      function getOrigin() {
        if (!window.location.origin) {
          return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
        } else {
          return window.location.origin;
        }
      }
      function processCallback(oauth, promise) {
        var code = oauth.code;
        var error = oauth.error;
        var prompt = oauth.prompt;
        var timeLocal = new Date().getTime();
        if (oauth['kc_action_status']) {
          kc.onActionUpdate && kc.onActionUpdate(oauth['kc_action_status']);
        }
        if (error) {
          if (prompt != 'none') {
            var errorData = {
              error: error,
              error_description: oauth.error_description
            };
            kc.onAuthError && kc.onAuthError(errorData);
            promise && promise.setError(errorData);
          } else {
            promise && promise.setSuccess();
          }
          return;
        } else if (kc.flow != 'standard' && (oauth.access_token || oauth.id_token)) {
          authSuccess(oauth.access_token, null, oauth.id_token, true);
        }
        if (kc.flow != 'implicit' && code) {
          var params = 'code=' + code + '&grant_type=authorization_code';
          var url = kc.endpoints.token();
          var req = new XMLHttpRequest();
          req.open('POST', url, true);
          req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
          params += '&client_id=' + encodeURIComponent(kc.clientId);
          params += '&redirect_uri=' + oauth.redirectUri;
          if (oauth.pkceCodeVerifier) {
            params += '&code_verifier=' + oauth.pkceCodeVerifier;
          }
          req.withCredentials = true;
          req.onreadystatechange = function () {
            if (req.readyState == 4) {
              if (req.status == 200) {
                var tokenResponse = JSON.parse(req.responseText);
                authSuccess(tokenResponse['access_token'], tokenResponse['refresh_token'], tokenResponse['id_token'], kc.flow === 'standard');
                scheduleCheckIframe();
              } else {
                kc.onAuthError && kc.onAuthError();
                promise && promise.setError();
              }
            }
          };
          req.send(params);
        }
        function authSuccess(accessToken, refreshToken, idToken, fulfillPromise) {
          timeLocal = (timeLocal + new Date().getTime()) / 2;
          setToken(accessToken, refreshToken, idToken, timeLocal);
          if (useNonce && (kc.tokenParsed && kc.tokenParsed.nonce != oauth.storedNonce || kc.refreshTokenParsed && kc.refreshTokenParsed.nonce != oauth.storedNonce || kc.idTokenParsed && kc.idTokenParsed.nonce != oauth.storedNonce)) {
            logInfo('[KEYCLOAK] Invalid nonce, clearing token');
            kc.clearToken();
            promise && promise.setError();
          } else {
            if (fulfillPromise) {
              kc.onAuthSuccess && kc.onAuthSuccess();
              promise && promise.setSuccess();
            }
          }
        }
      }
      function loadConfig(url) {
        var promise = createPromise();
        var configUrl;
        if (!config) {
          configUrl = 'keycloak.json';
        } else if (typeof config === 'string') {
          configUrl = config;
        }
        function setupOidcEndoints(oidcConfiguration) {
          if (!oidcConfiguration) {
            kc.endpoints = {
              authorize: function authorize() {
                return getRealmUrl() + '/protocol/openid-connect/auth';
              },
              token: function token() {
                return getRealmUrl() + '/protocol/openid-connect/token';
              },
              logout: function logout() {
                return getRealmUrl() + '/protocol/openid-connect/logout';
              },
              checkSessionIframe: function checkSessionIframe() {
                var src = getRealmUrl() + '/protocol/openid-connect/login-status-iframe.html';
                if (kc.iframeVersion) {
                  src = src + '?version=' + kc.iframeVersion;
                }
                return src;
              },
              thirdPartyCookiesIframe: function thirdPartyCookiesIframe() {
                var src = getRealmUrl() + '/protocol/openid-connect/3p-cookies/step1.html';
                if (kc.iframeVersion) {
                  src = src + '?version=' + kc.iframeVersion;
                }
                return src;
              },
              register: function register() {
                return getRealmUrl() + '/protocol/openid-connect/registrations';
              },
              userinfo: function userinfo() {
                return getRealmUrl() + '/protocol/openid-connect/userinfo';
              }
            };
          } else {
            kc.endpoints = {
              authorize: function authorize() {
                return oidcConfiguration.authorization_endpoint;
              },
              token: function token() {
                return oidcConfiguration.token_endpoint;
              },
              logout: function logout() {
                if (!oidcConfiguration.end_session_endpoint) {
                  throw "Not supported by the OIDC server";
                }
                return oidcConfiguration.end_session_endpoint;
              },
              checkSessionIframe: function checkSessionIframe() {
                if (!oidcConfiguration.check_session_iframe) {
                  throw "Not supported by the OIDC server";
                }
                return oidcConfiguration.check_session_iframe;
              },
              register: function register() {
                throw 'Redirection to "Register user" page not supported in standard OIDC mode';
              },
              userinfo: function userinfo() {
                if (!oidcConfiguration.userinfo_endpoint) {
                  throw "Not supported by the OIDC server";
                }
                return oidcConfiguration.userinfo_endpoint;
              }
            };
          }
        }
        if (configUrl) {
          var req = new XMLHttpRequest();
          req.open('GET', configUrl, true);
          req.setRequestHeader('Accept', 'application/json');
          req.onreadystatechange = function () {
            if (req.readyState == 4) {
              if (req.status == 200 || fileLoaded(req)) {
                var config = JSON.parse(req.responseText);
                kc.authServerUrl = config['auth-server-url'];
                kc.realm = config['realm'];
                kc.clientId = config['resource'];
                setupOidcEndoints(null);
                promise.setSuccess();
              } else {
                promise.setError();
              }
            }
          };
          req.send();
        } else {
          if (!config.clientId) {
            throw 'clientId missing';
          }
          kc.clientId = config.clientId;
          var oidcProvider = config['oidcProvider'];
          if (!oidcProvider) {
            if (!config['url']) {
              var scripts = document.getElementsByTagName('script');
              for (var i = 0; i < scripts.length; i++) {
                if (scripts[i].src.match(/.*keycloak\.js/)) {
                  config.url = scripts[i].src.substr(0, scripts[i].src.indexOf('/js/keycloak.js'));
                  break;
                }
              }
            }
            if (!config.realm) {
              throw 'realm missing';
            }
            kc.authServerUrl = config.url;
            kc.realm = config.realm;
            setupOidcEndoints(null);
            promise.setSuccess();
          } else {
            if (typeof oidcProvider === 'string') {
              var oidcProviderConfigUrl;
              if (oidcProvider.charAt(oidcProvider.length - 1) == '/') {
                oidcProviderConfigUrl = oidcProvider + '.well-known/openid-configuration';
              } else {
                oidcProviderConfigUrl = oidcProvider + '/.well-known/openid-configuration';
              }
              var req = new XMLHttpRequest();
              req.open('GET', oidcProviderConfigUrl, true);
              req.setRequestHeader('Accept', 'application/json');
              req.onreadystatechange = function () {
                if (req.readyState == 4) {
                  if (req.status == 200 || fileLoaded(req)) {
                    var oidcProviderConfig = JSON.parse(req.responseText);
                    setupOidcEndoints(oidcProviderConfig);
                    promise.setSuccess();
                  } else {
                    promise.setError();
                  }
                }
              };
              req.send();
            } else {
              setupOidcEndoints(oidcProvider);
              promise.setSuccess();
            }
          }
        }
        return promise.promise;
      }
      function fileLoaded(xhr) {
        return xhr.status == 0 && xhr.responseText && xhr.responseURL.startsWith('file:');
      }
      function setToken(token, refreshToken, idToken, timeLocal) {
        if (kc.tokenTimeoutHandle) {
          clearTimeout(kc.tokenTimeoutHandle);
          kc.tokenTimeoutHandle = null;
        }
        if (refreshToken) {
          kc.refreshToken = refreshToken;
          kc.refreshTokenParsed = decodeToken(refreshToken);
        } else {
          delete kc.refreshToken;
          delete kc.refreshTokenParsed;
        }
        if (idToken) {
          kc.idToken = idToken;
          kc.idTokenParsed = decodeToken(idToken);
        } else {
          delete kc.idToken;
          delete kc.idTokenParsed;
        }
        if (token) {
          kc.token = token;
          kc.tokenParsed = decodeToken(token);
          kc.sessionId = kc.tokenParsed.session_state;
          kc.authenticated = true;
          kc.subject = kc.tokenParsed.sub;
          kc.realmAccess = kc.tokenParsed.realm_access;
          kc.resourceAccess = kc.tokenParsed.resource_access;
          if (timeLocal) {
            kc.timeSkew = Math.floor(timeLocal / 1000) - kc.tokenParsed.iat;
          }
          if (kc.timeSkew != null) {
            logInfo('[KEYCLOAK] Estimated time difference between browser and server is ' + kc.timeSkew + ' seconds');
            if (kc.onTokenExpired) {
              var expiresIn = (kc.tokenParsed['exp'] - new Date().getTime() / 1000 + kc.timeSkew) * 1000;
              logInfo('[KEYCLOAK] Token expires in ' + Math.round(expiresIn / 1000) + ' s');
              if (expiresIn <= 0) {
                kc.onTokenExpired();
              } else {
                kc.tokenTimeoutHandle = setTimeout(kc.onTokenExpired, expiresIn);
              }
            }
          }
        } else {
          delete kc.token;
          delete kc.tokenParsed;
          delete kc.subject;
          delete kc.realmAccess;
          delete kc.resourceAccess;
          kc.authenticated = false;
        }
      }
      function decodeToken(str) {
        str = str.split('.')[1];
        str = str.replace(/-/g, '+');
        str = str.replace(/_/g, '/');
        switch (str.length % 4) {
          case 0:
            break;
          case 2:
            str += '==';
            break;
          case 3:
            str += '=';
            break;
          default:
            throw 'Invalid token';
        }
        str = decodeURIComponent(escape(atob(str)));
        str = JSON.parse(str);
        return str;
      }
      function createUUID() {
        var hexDigits = '0123456789abcdef';
        var s = generateRandomString(36, hexDigits).split("");
        s[14] = '4';
        s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1);
        s[8] = s[13] = s[18] = s[23] = '-';
        var uuid = s.join('');
        return uuid;
      }
      function parseCallback(url) {
        var oauth = parseCallbackUrl(url);
        if (!oauth) {
          return;
        }
        var oauthState = callbackStorage.get(oauth.state);
        if (oauthState) {
          oauth.valid = true;
          oauth.redirectUri = oauthState.redirectUri;
          oauth.storedNonce = oauthState.nonce;
          oauth.prompt = oauthState.prompt;
          oauth.pkceCodeVerifier = oauthState.pkceCodeVerifier;
        }
        return oauth;
      }
      function parseCallbackUrl(url) {
        var supportedParams;
        switch (kc.flow) {
          case 'standard':
            supportedParams = ['code', 'state', 'session_state', 'kc_action_status'];
            break;
          case 'implicit':
            supportedParams = ['access_token', 'token_type', 'id_token', 'state', 'session_state', 'expires_in', 'kc_action_status'];
            break;
          case 'hybrid':
            supportedParams = ['access_token', 'token_type', 'id_token', 'code', 'state', 'session_state', 'expires_in', 'kc_action_status'];
            break;
        }
        supportedParams.push('error');
        supportedParams.push('error_description');
        supportedParams.push('error_uri');
        var queryIndex = url.indexOf('?');
        var fragmentIndex = url.indexOf('#');
        var newUrl;
        var parsed;
        if (kc.responseMode === 'query' && queryIndex !== -1) {
          newUrl = url.substring(0, queryIndex);
          parsed = parseCallbackParams(url.substring(queryIndex + 1, fragmentIndex !== -1 ? fragmentIndex : url.length), supportedParams);
          if (parsed.paramsString !== '') {
            newUrl += '?' + parsed.paramsString;
          }
          if (fragmentIndex !== -1) {
            newUrl += url.substring(fragmentIndex);
          }
        } else if (kc.responseMode === 'fragment' && fragmentIndex !== -1) {
          newUrl = url.substring(0, fragmentIndex);
          parsed = parseCallbackParams(url.substring(fragmentIndex + 1), supportedParams);
          if (parsed.paramsString !== '') {
            newUrl += '#' + parsed.paramsString;
          }
        }
        if (parsed && parsed.oauthParams) {
          if (kc.flow === 'standard' || kc.flow === 'hybrid') {
            if ((parsed.oauthParams.code || parsed.oauthParams.error) && parsed.oauthParams.state) {
              parsed.oauthParams.newUrl = newUrl;
              return parsed.oauthParams;
            }
          } else if (kc.flow === 'implicit') {
            if ((parsed.oauthParams.access_token || parsed.oauthParams.error) && parsed.oauthParams.state) {
              parsed.oauthParams.newUrl = newUrl;
              return parsed.oauthParams;
            }
          }
        }
      }
      function parseCallbackParams(paramsString, supportedParams) {
        var p = paramsString.split('&');
        var result = {
          paramsString: '',
          oauthParams: {}
        };
        for (var i = 0; i < p.length; i++) {
          var split = p[i].indexOf("=");
          var key = p[i].slice(0, split);
          if (supportedParams.indexOf(key) !== -1) {
            result.oauthParams[key] = p[i].slice(split + 1);
          } else {
            if (result.paramsString !== '') {
              result.paramsString += '&';
            }
            result.paramsString += p[i];
          }
        }
        return result;
      }
      function createPromise() {
        // Need to create a native Promise which also preserves the
        // interface of the custom promise type previously used by the API
        var p = {
          setSuccess: function setSuccess(result) {
            p.resolve(result);
          },
          setError: function setError(result) {
            p.reject(result);
          }
        };
        p.promise = new es6Promise_min.exports.Promise(function (resolve, reject) {
          p.resolve = resolve;
          p.reject = reject;
        });
        p.promise.success = function (callback) {
          logPromiseDeprecation();
          this.then(function handleSuccess(value) {
            callback(value);
          });
          return this;
        };
        p.promise.error = function (callback) {
          logPromiseDeprecation();
          this.catch(function handleError(error) {
            callback(error);
          });
          return this;
        };
        return p;
      }

      // Function to extend existing native Promise with timeout
      function applyTimeoutToPromise(promise, timeout, errorMessage) {
        var timeoutHandle = null;
        var timeoutPromise = new es6Promise_min.exports.Promise(function (resolve, reject) {
          timeoutHandle = setTimeout(function () {
            reject({
              "error": errorMessage || "Promise is not settled within timeout of " + timeout + "ms"
            });
          }, timeout);
        });
        return es6Promise_min.exports.Promise.race([promise, timeoutPromise]).finally(function () {
          clearTimeout(timeoutHandle);
        });
      }
      function setupCheckLoginIframe() {
        var promise = createPromise();
        if (!loginIframe.enable) {
          promise.setSuccess();
          return promise.promise;
        }
        if (loginIframe.iframe) {
          promise.setSuccess();
          return promise.promise;
        }
        var iframe = document.createElement('iframe');
        loginIframe.iframe = iframe;
        iframe.onload = function () {
          var authUrl = kc.endpoints.authorize();
          if (authUrl.charAt(0) === '/') {
            loginIframe.iframeOrigin = getOrigin();
          } else {
            loginIframe.iframeOrigin = authUrl.substring(0, authUrl.indexOf('/', 8));
          }
          promise.setSuccess();
        };
        var src = kc.endpoints.checkSessionIframe();
        iframe.setAttribute('src', src);
        iframe.setAttribute('title', 'keycloak-session-iframe');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        var messageCallback = function messageCallback(event) {
          if (event.origin !== loginIframe.iframeOrigin || loginIframe.iframe.contentWindow !== event.source) {
            return;
          }
          if (!(event.data == 'unchanged' || event.data == 'changed' || event.data == 'error')) {
            return;
          }
          if (event.data != 'unchanged') {
            kc.clearToken();
          }
          var callbacks = loginIframe.callbackList.splice(0, loginIframe.callbackList.length);
          for (var i = callbacks.length - 1; i >= 0; --i) {
            var promise = callbacks[i];
            if (event.data == 'error') {
              promise.setError();
            } else {
              promise.setSuccess(event.data == 'unchanged');
            }
          }
        };
        window.addEventListener('message', messageCallback, false);
        return promise.promise;
      }
      function scheduleCheckIframe() {
        if (loginIframe.enable) {
          if (kc.token) {
            setTimeout(function () {
              checkLoginIframe().then(function (unchanged) {
                if (unchanged) {
                  scheduleCheckIframe();
                }
              });
            }, loginIframe.interval * 1000);
          }
        }
      }
      function checkLoginIframe() {
        var promise = createPromise();
        if (loginIframe.iframe && loginIframe.iframeOrigin) {
          var msg = kc.clientId + ' ' + (kc.sessionId ? kc.sessionId : '');
          loginIframe.callbackList.push(promise);
          var origin = loginIframe.iframeOrigin;
          if (loginIframe.callbackList.length == 1) {
            loginIframe.iframe.contentWindow.postMessage(msg, origin);
          }
        } else {
          promise.setSuccess();
        }
        return promise.promise;
      }
      function check3pCookiesSupported() {
        var promise = createPromise();
        if (loginIframe.enable || kc.silentCheckSsoRedirectUri) {
          var iframe = document.createElement('iframe');
          iframe.setAttribute('src', kc.endpoints.thirdPartyCookiesIframe());
          iframe.setAttribute('title', 'keycloak-3p-check-iframe');
          iframe.style.display = 'none';
          document.body.appendChild(iframe);
          var messageCallback = function messageCallback(event) {
            if (iframe.contentWindow !== event.source) {
              return;
            }
            if (event.data !== "supported" && event.data !== "unsupported") {
              return;
            } else if (event.data === "unsupported") {
              loginIframe.enable = false;
              if (kc.silentCheckSsoFallback) {
                kc.silentCheckSsoRedirectUri = false;
              }
              logWarn("[KEYCLOAK] 3rd party cookies aren't supported by this browser. checkLoginIframe and " + "silent check-sso are not available.");
            }
            document.body.removeChild(iframe);
            window.removeEventListener("message", messageCallback);
            promise.setSuccess();
          };
          window.addEventListener('message', messageCallback, false);
        } else {
          promise.setSuccess();
        }
        return applyTimeoutToPromise(promise.promise, kc.messageReceiveTimeout, "Timeout when waiting for 3rd party check iframe message.");
      }
      function loadAdapter(type) {
        if (!type || type == 'default') {
          return {
            login: function login(options) {
              window.location.replace(kc.createLoginUrl(options));
              return createPromise().promise;
            },
            logout: function logout(options) {
              window.location.replace(kc.createLogoutUrl(options));
              return createPromise().promise;
            },
            register: function register(options) {
              window.location.replace(kc.createRegisterUrl(options));
              return createPromise().promise;
            },
            accountManagement: function accountManagement() {
              var accountUrl = kc.createAccountUrl();
              if (typeof accountUrl !== 'undefined') {
                window.location.href = accountUrl;
              } else {
                throw "Not supported by the OIDC server";
              }
              return createPromise().promise;
            },
            redirectUri: function redirectUri(options, encodeHash) {
              if (options && options.redirectUri) {
                return options.redirectUri;
              } else if (kc.redirectUri) {
                return kc.redirectUri;
              } else {
                return location.href;
              }
            }
          };
        }
        if (type == 'cordova') {
          loginIframe.enable = false;
          var cordovaOpenWindowWrapper = function cordovaOpenWindowWrapper(loginUrl, target, options) {
            if (window.cordova && window.cordova.InAppBrowser) {
              // Use inappbrowser for IOS and Android if available
              return window.cordova.InAppBrowser.open(loginUrl, target, options);
            } else {
              return window.open(loginUrl, target, options);
            }
          };
          var shallowCloneCordovaOptions = function shallowCloneCordovaOptions(userOptions) {
            if (userOptions && userOptions.cordovaOptions) {
              return Object.keys(userOptions.cordovaOptions).reduce(function (options, optionName) {
                options[optionName] = userOptions.cordovaOptions[optionName];
                return options;
              }, {});
            } else {
              return {};
            }
          };
          var formatCordovaOptions = function formatCordovaOptions(cordovaOptions) {
            return Object.keys(cordovaOptions).reduce(function (options, optionName) {
              options.push(optionName + "=" + cordovaOptions[optionName]);
              return options;
            }, []).join(",");
          };
          var createCordovaOptions = function createCordovaOptions(userOptions) {
            var cordovaOptions = shallowCloneCordovaOptions(userOptions);
            cordovaOptions.location = 'no';
            if (userOptions && userOptions.prompt == 'none') {
              cordovaOptions.hidden = 'yes';
            }
            return formatCordovaOptions(cordovaOptions);
          };
          return {
            login: function login(options) {
              var promise = createPromise();
              var cordovaOptions = createCordovaOptions(options);
              var loginUrl = kc.createLoginUrl(options);
              var ref = cordovaOpenWindowWrapper(loginUrl, '_blank', cordovaOptions);
              var completed = false;
              var closed = false;
              var closeBrowser = function closeBrowser() {
                closed = true;
                ref.close();
              };
              ref.addEventListener('loadstart', function (event) {
                if (event.url.indexOf('http://localhost') == 0) {
                  var callback = parseCallback(event.url);
                  processCallback(callback, promise);
                  closeBrowser();
                  completed = true;
                }
              });
              ref.addEventListener('loaderror', function (event) {
                if (!completed) {
                  if (event.url.indexOf('http://localhost') == 0) {
                    var callback = parseCallback(event.url);
                    processCallback(callback, promise);
                    closeBrowser();
                    completed = true;
                  } else {
                    promise.setError();
                    closeBrowser();
                  }
                }
              });
              ref.addEventListener('exit', function (event) {
                if (!closed) {
                  promise.setError({
                    reason: "closed_by_user"
                  });
                }
              });
              return promise.promise;
            },
            logout: function logout(options) {
              var promise = createPromise();
              var logoutUrl = kc.createLogoutUrl(options);
              var ref = cordovaOpenWindowWrapper(logoutUrl, '_blank', 'location=no,hidden=yes,clearcache=yes');
              var error;
              ref.addEventListener('loadstart', function (event) {
                if (event.url.indexOf('http://localhost') == 0) {
                  ref.close();
                }
              });
              ref.addEventListener('loaderror', function (event) {
                if (event.url.indexOf('http://localhost') == 0) {
                  ref.close();
                } else {
                  error = true;
                  ref.close();
                }
              });
              ref.addEventListener('exit', function (event) {
                if (error) {
                  promise.setError();
                } else {
                  kc.clearToken();
                  promise.setSuccess();
                }
              });
              return promise.promise;
            },
            register: function register(options) {
              var promise = createPromise();
              var registerUrl = kc.createRegisterUrl();
              var cordovaOptions = createCordovaOptions(options);
              var ref = cordovaOpenWindowWrapper(registerUrl, '_blank', cordovaOptions);
              ref.addEventListener('loadstart', function (event) {
                if (event.url.indexOf('http://localhost') == 0) {
                  ref.close();
                  var oauth = parseCallback(event.url);
                  processCallback(oauth, promise);
                }
              });
              return promise.promise;
            },
            accountManagement: function accountManagement() {
              var accountUrl = kc.createAccountUrl();
              if (typeof accountUrl !== 'undefined') {
                var ref = cordovaOpenWindowWrapper(accountUrl, '_blank', 'location=no');
                ref.addEventListener('loadstart', function (event) {
                  if (event.url.indexOf('http://localhost') == 0) {
                    ref.close();
                  }
                });
              } else {
                throw "Not supported by the OIDC server";
              }
            },
            redirectUri: function redirectUri(options) {
              return 'http://localhost';
            }
          };
        }
        if (type == 'cordova-native') {
          loginIframe.enable = false;
          return {
            login: function login(options) {
              var promise = createPromise();
              var loginUrl = kc.createLoginUrl(options);
              universalLinks.subscribe('keycloak', function (event) {
                universalLinks.unsubscribe('keycloak');
                window.cordova.plugins.browsertab.close();
                var oauth = parseCallback(event.url);
                processCallback(oauth, promise);
              });
              window.cordova.plugins.browsertab.openUrl(loginUrl);
              return promise.promise;
            },
            logout: function logout(options) {
              var promise = createPromise();
              var logoutUrl = kc.createLogoutUrl(options);
              universalLinks.subscribe('keycloak', function (event) {
                universalLinks.unsubscribe('keycloak');
                window.cordova.plugins.browsertab.close();
                kc.clearToken();
                promise.setSuccess();
              });
              window.cordova.plugins.browsertab.openUrl(logoutUrl);
              return promise.promise;
            },
            register: function register(options) {
              var promise = createPromise();
              var registerUrl = kc.createRegisterUrl(options);
              universalLinks.subscribe('keycloak', function (event) {
                universalLinks.unsubscribe('keycloak');
                window.cordova.plugins.browsertab.close();
                var oauth = parseCallback(event.url);
                processCallback(oauth, promise);
              });
              window.cordova.plugins.browsertab.openUrl(registerUrl);
              return promise.promise;
            },
            accountManagement: function accountManagement() {
              var accountUrl = kc.createAccountUrl();
              if (typeof accountUrl !== 'undefined') {
                window.cordova.plugins.browsertab.openUrl(accountUrl);
              } else {
                throw "Not supported by the OIDC server";
              }
            },
            redirectUri: function redirectUri(options) {
              if (options && options.redirectUri) {
                return options.redirectUri;
              } else if (kc.redirectUri) {
                return kc.redirectUri;
              } else {
                return "http://localhost";
              }
            }
          };
        }
        throw 'invalid adapter type: ' + type;
      }
      var LocalStorage = function LocalStorage() {
        if (!(this instanceof LocalStorage)) {
          return new LocalStorage();
        }
        localStorage.setItem('kc-test', 'test');
        localStorage.removeItem('kc-test');
        var cs = this;
        function clearExpired() {
          var time = new Date().getTime();
          for (var i = 0; i < localStorage.length; i++) {
            var key = localStorage.key(i);
            if (key && key.indexOf('kc-callback-') == 0) {
              var value = localStorage.getItem(key);
              if (value) {
                try {
                  var expires = JSON.parse(value).expires;
                  if (!expires || expires < time) {
                    localStorage.removeItem(key);
                  }
                } catch (err) {
                  localStorage.removeItem(key);
                }
              }
            }
          }
        }
        cs.get = function (state) {
          if (!state) {
            return;
          }
          var key = 'kc-callback-' + state;
          var value = localStorage.getItem(key);
          if (value) {
            localStorage.removeItem(key);
            value = JSON.parse(value);
          }
          clearExpired();
          return value;
        };
        cs.add = function (state) {
          clearExpired();
          var key = 'kc-callback-' + state.state;
          state.expires = new Date().getTime() + 60 * 60 * 1000;
          localStorage.setItem(key, JSON.stringify(state));
        };
      };
      var CookieStorage = function CookieStorage() {
        if (!(this instanceof CookieStorage)) {
          return new CookieStorage();
        }
        var cs = this;
        cs.get = function (state) {
          if (!state) {
            return;
          }
          var value = getCookie('kc-callback-' + state);
          setCookie('kc-callback-' + state, '', cookieExpiration(-100));
          if (value) {
            return JSON.parse(value);
          }
        };
        cs.add = function (state) {
          setCookie('kc-callback-' + state.state, JSON.stringify(state), cookieExpiration(60));
        };
        cs.removeItem = function (key) {
          setCookie(key, '', cookieExpiration(-100));
        };
        var cookieExpiration = function cookieExpiration(minutes) {
          var exp = new Date();
          exp.setTime(exp.getTime() + minutes * 60 * 1000);
          return exp;
        };
        var getCookie = function getCookie(key) {
          var name = key + '=';
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return '';
        };
        var setCookie = function setCookie(key, value, expirationDate) {
          var cookie = key + '=' + value + '; ' + 'expires=' + expirationDate.toUTCString() + '; ';
          document.cookie = cookie;
        };
      };
      function createCallbackStorage() {
        try {
          return new LocalStorage();
        } catch (err) {}
        return new CookieStorage();
      }
      function createLogger(fn) {
        return function () {
          if (kc.enableLogging) {
            fn.apply(console, Array.prototype.slice.call(arguments));
          }
        };
      }
    }
    return Keycloak;
  });
}

var AuthContext = /*#__PURE__*/React__default.createContext(null);
function Auth(_ref) {
  var url = _ref.url,
    realm = _ref.realm,
    clientId = _ref.clientId,
    targetPage = _ref.targetPage,
    children = _ref.children;
  var keycloak = useRef();
  var _useState = useState(undefined),
    _useState2 = _slicedToArray$2(_useState, 2),
    authenticated = _useState2[0],
    setAuthenticated = _useState2[1];
  var setLoggedInSession = function setLoggedInSession() {
    return window.sessionStorage.setItem("LOGGEDIN", true);
  };
  var hasLoggedInSession = function hasLoggedInSession() {
    return window.sessionStorage.getItem("LOGGEDIN");
  };
  var loginClicked = function loginClicked() {
    setLoggedInSession();
    keycloak.current.login();
  };
  var value = useMemo(function () {
    var _keycloak$current, _keycloak$current$tok, _keycloak$current2, _keycloak$current2$to, _keycloak$current3, _keycloak$current4, _keycloak$current5, _keycloak$current6;
    return {
      ssn: (_keycloak$current = keycloak.current) === null || _keycloak$current === void 0 ? void 0 : (_keycloak$current$tok = _keycloak$current.tokenParsed) === null || _keycloak$current$tok === void 0 ? void 0 : _keycloak$current$tok.ssn,
      userName: (_keycloak$current2 = keycloak.current) === null || _keycloak$current2 === void 0 ? void 0 : (_keycloak$current2$to = _keycloak$current2.tokenParsed) === null || _keycloak$current2$to === void 0 ? void 0 : _keycloak$current2$to.preferred_username,
      authenticated: authenticated,
      setAuthenticated: setAuthenticated,
      realmAccess: (_keycloak$current3 = keycloak.current) === null || _keycloak$current3 === void 0 ? void 0 : _keycloak$current3.realmAccess,
      resourceAccess: (_keycloak$current4 = keycloak.current) === null || _keycloak$current4 === void 0 ? void 0 : _keycloak$current4.resourceAccess,
      token: (_keycloak$current5 = keycloak.current) === null || _keycloak$current5 === void 0 ? void 0 : _keycloak$current5.token,
      logout: (_keycloak$current6 = keycloak.current) === null || _keycloak$current6 === void 0 ? void 0 : _keycloak$current6.logout
    };
  }, [authenticated]);
  useEffect(function () {
    if (typeof window !== "undefined") {
      // eslint-disable-next-line no-undef
      keycloak.current = Keycloak({
        url: "".concat(url, "/auth"),
        realm: realm,
        clientId: clientId
      });
      keycloak.current.init({
        "enable-pkce": "true",
        pkceMethod: "S256",
        onLoad: "check-sso",
        checkLoginIframe: false
      }).then(function (auth) {
        // eslint-disable-next-line no-console
        console.log("Authentication result: ".concat(auth));
        if (auth && !hasLoggedInSession()) {
          setAuthenticated(false);
          keycloak.current.logout();
        } else {
          setAuthenticated(auth);
        }
      }).catch(function (error) {
        setAuthenticated(false);
        // eslint-disable-next-line no-console
        console.log(error);
      });
    }
  }, [url, realm, clientId]);
  var element = "";
  if (authenticated === false) {
    element = /*#__PURE__*/React__default.createElement(LoginView, {
      buttonClicked: loginClicked,
      targetPage: targetPage
    });
  } else if (authenticated === true) {
    element = children;
  }
  return /*#__PURE__*/React__default.createElement(AuthContext.Provider, {
    value: value
  }, element);
}
Auth.propTypes = {
  // The url to the keycloak server to use
  url: PropTypes.string.isRequired,
  // The realm in which the keycloak client is defined
  realm: PropTypes.string.isRequired,
  // The name of the keycloak client to use
  clientId: PropTypes.string.isRequired,
  // The name of the children component (being rendered after authentication)
  targetPage: PropTypes.string.isRequired,
  // Regular react children components
  children: PropTypes.node.isRequired
};

var onlyNumbersRegEx = /^\d+$/;
var consentTypesChannels$1 = ["ya", "yx"];
function CustomerCenterConsents$1(_ref) {
  var endpointUrl = _ref.endpointUrl;
  var _useState = useState({}),
    _useState2 = _slicedToArray$2(_useState, 2),
    consentChannelsData = _useState2[0],
    setConsentChannelsData = _useState2[1];
  var keycloakResult = useContext(AuthContext);
  var commonHeaders = {
    Accept: "application/json",
    Authorization: "Bearer ".concat(keycloakResult.token)
  };
  var consentApiUrl = "".concat(endpointUrl, "/consentmanager/api/consents/consent");
  var setData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
      var _yield$response$json, identifier, consentDetailsMap, channel;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return response.json();
            case 2:
              _yield$response$json = _context.sent;
              identifier = _yield$response$json.identifier;
              consentDetailsMap = _yield$response$json.consentDetailsMap;
              channel = identifier.consentTypesChannel;
              setConsentChannelsData(function (prevState) {
                return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, _defineProperty$5({}, channel, {
                  identifier: identifier,
                  consentsDetails: Object.values(consentDetailsMap)
                }));
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function setData(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onSearch = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(searchText) {
      var cleanString, identifierType, url;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              cleanString = searchText.trim();
              identifierType = onlyNumbersRegEx.test(cleanString) ? "SSN" : "EMAIL";
              url = "".concat(consentApiUrl, "/customer/").concat(cleanString, "/").concat(identifierType);
              consentTypesChannels$1.forEach( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(channel) {
                  var response;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return fetch("".concat(url, "/").concat(channel), {
                            headers: commonHeaders
                          });
                        case 2:
                          response = _context2.sent;
                          if (response.ok) {
                            setData(response);
                          }
                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));
                return function (_x3) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function onSearch(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var onSave = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(identifier, consentValues) {
      var headers, body, response;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              headers = _objectSpread2$4(_objectSpread2$4({}, commonHeaders), {}, {
                "Content-Type": "application/json"
              });
              body = JSON.stringify({
                identifier: identifier,
                consentIndicatorsToCreateOrUpdate: consentValues
              });
              _context4.next = 4;
              return fetch(consentApiUrl, {
                method: "POST",
                headers: headers,
                body: body
              });
            case 4:
              response = _context4.sent;
              if (response.ok) {
                setData(response);
              }
            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return function onSave(_x4, _x5) {
      return _ref5.apply(this, arguments);
    };
  }();
  var orderedConsentChannelsData = consentTypesChannels$1.map(function (channel) {
    return consentChannelsData[channel];
  }).filter(Boolean);
  return /*#__PURE__*/React__default.createElement(CustomerCenterConsentsView, {
    onSearch: onSearch,
    consentChannelsData: orderedConsentChannelsData,
    onSave: onSave
  });
}
CustomerCenterConsents$1.propTypes = {
  endpointUrl: PropTypes.string.isRequired
};

function SecuredCustomerCenterConsents$1(_ref) {
  var endpointUrl = _ref.endpointUrl,
    _ref$keycloakData = _ref.keycloakData,
    url = _ref$keycloakData.url,
    realm = _ref$keycloakData.realm,
    clientId = _ref$keycloakData.clientId,
    cmsHelperUrl = _ref.cmsHelperUrl;
  return /*#__PURE__*/React__default.createElement(SystemStatus, {
    cmsHelperUrl: cmsHelperUrl
  }, /*#__PURE__*/React__default.createElement(Auth, {
    url: url,
    realm: realm,
    clientId: clientId,
    targetPage: "CustomerCenterConsents"
  }, /*#__PURE__*/React__default.createElement(CustomerCenterConsents$1, {
    endpointUrl: endpointUrl
  })));
}
SecuredCustomerCenterConsents$1.propTypes = {
  cmsHelperUrl: PropTypes.string.isRequired,
  endpointUrl: PropTypes.string.isRequired,
  keycloakData: PropTypes.shape({
    url: PropTypes.string,
    realm: PropTypes.string,
    clientId: PropTypes.string
  }).isRequired
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$i() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var WrapperContainer = createStyled("div", "development" === "production" ? {
  target: "ea0rn1i0"
} : {
  target: "ea0rn1i0",
  label: "WrapperContainer"
})("development" === "production" ? {
  name: "dezffx",
  styles: "max-width:960px"
} : {
  name: "dezffx",
  styles: "max-width:960px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$i
});
function CustomerCenterConsents(_ref) {
  var endpointUrl = _ref.endpointUrl,
    consentTypesChannel = _ref.consentTypesChannel;
  var _useState = useState({}),
    _useState2 = _slicedToArray$2(_useState, 2),
    customerConsentData = _useState2[0],
    setCustomerConsentData = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray$2(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var keycloakResult = useContext(AuthContext);
  var commonHeaders = useMemo(function () {
    return {
      Accept: "application/json",
      securityrealm: "public",
      Authorization: "Bearer ".concat(keycloakResult.token)
    };
  }, [keycloakResult.token]);
  var consentApiUrl = "".concat(endpointUrl, "/consentmanager/api/consents/consent");
  useEffect(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var identifierType, url, response, _yield$response$json, _identifier, consentDetailsMap;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                identifierType = "SSN";
                url = "".concat(consentApiUrl, "/customer/").concat(keycloakResult.ssn, "/").concat(identifierType, "/").concat(consentTypesChannel);
                _context.next = 4;
                return fetch(url, {
                  headers: commonHeaders
                });
              case 4:
                response = _context.sent;
                if (!response.ok) {
                  _context.next = 14;
                  break;
                }
                _context.next = 8;
                return response.json();
              case 8:
                _yield$response$json = _context.sent;
                _identifier = _yield$response$json.identifier;
                consentDetailsMap = _yield$response$json.consentDetailsMap;
                setCustomerConsentData({
                  identifier: _identifier,
                  consentsDetails: Object.values(consentDetailsMap)
                });
                _context.next = 15;
                break;
              case 14:
                if (response.status === 404) {
                  setError("Vi har ingen opplysninger om samtykke registrert i systemet.");
                } else {
                  setError("Uventet feil.");
                }
              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();
    fetchData();
  }, [commonHeaders, consentApiUrl, consentTypesChannel, keycloakResult.ssn]);
  var onSave = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(identifier, consentValues) {
      var headers, body, response;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              headers = _objectSpread2$4(_objectSpread2$4({}, commonHeaders), {}, {
                "Content-Type": "application/json"
              });
              body = JSON.stringify({
                identifier: identifier,
                consentIndicatorsToCreateOrUpdate: consentValues
              });
              _context2.next = 4;
              return fetch(consentApiUrl, {
                method: "POST",
                headers: headers,
                body: body
              });
            case 4:
              response = _context2.sent;
              if (!response.ok) {
                setError("Uventet feil.");
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function onSave(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var identifier = customerConsentData.identifier,
    consentsDetails = customerConsentData.consentsDetails;
  return /*#__PURE__*/React__default.createElement(WrapperContainer, null, error && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("h2", null, "Samtykke"), /*#__PURE__*/React__default.createElement("p", null, error)), !error && identifier && /*#__PURE__*/React__default.createElement(CustomerConsentsList, {
    identifier: identifier,
    consentsDetails: consentsDetails,
    onSave: onSave
  }));
}
CustomerCenterConsents.propTypes = {
  endpointUrl: PropTypes.string.isRequired,
  consentTypesChannel: PropTypes.string.isRequired
};

function SecuredCustomerConsents$1(_ref) {
  var endpointUrl = _ref.endpointUrl,
    consentTypesChannel = _ref.consentTypesChannel,
    _ref$keycloakData = _ref.keycloakData,
    url = _ref$keycloakData.url,
    realm = _ref$keycloakData.realm,
    clientId = _ref$keycloakData.clientId,
    cmsHelperUrl = _ref.cmsHelperUrl;
  return /*#__PURE__*/React__default.createElement(SystemStatus, {
    cmsHelperUrl: cmsHelperUrl
  }, /*#__PURE__*/React__default.createElement(Auth, {
    url: url,
    realm: realm,
    clientId: clientId,
    targetPage: "CustomerConsentsActive"
  }, /*#__PURE__*/React__default.createElement(CustomerCenterConsents, {
    endpointUrl: endpointUrl,
    consentTypesChannel: consentTypesChannel
  })));
}
SecuredCustomerConsents$1.propTypes = {
  cmsHelperUrl: PropTypes.string.isRequired,
  endpointUrl: PropTypes.string.isRequired,
  consentTypesChannel: PropTypes.string.isRequired,
  keycloakData: PropTypes.shape({
    url: PropTypes.string,
    realm: PropTypes.string,
    clientId: PropTypes.string
  }).isRequired
};

var Wrapper$1 = createStyled("div", "development" === "production" ? {
  target: "e1rxgp3q1"
} : {
  target: "e1rxgp3q1",
  label: "Wrapper"
})("display:flex;flex-direction:column;margin-bottom:0.25rem;border:1px solid ", colors$1.secondaryGreen, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var TextBlock = createStyled("div", "development" === "production" ? {
  target: "e1rxgp3q0"
} : {
  target: "e1rxgp3q0",
  label: "TextBlock"
})(function (_ref) {
  var isHidden = _ref.isHidden;
  return isHidden && "\n    display: none;\n  ";
}, " cursor:pointer;", function (_ref2) {
  var forceOccupySpace = _ref2.forceOccupySpace;
  return forceOccupySpace && "\n    &:after {\n      content: '.';\n      visibility: hidden;\n    }\n  ";
}, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
function EditableText(_ref3) {
  var text = _ref3.text,
    allowHtml = _ref3.allowHtml,
    rows = _ref3.rows,
    onChanged = _ref3.onChanged;
  var _useState = useState(false),
    _useState2 = _slicedToArray$2(_useState, 2),
    isEditing = _useState2[0],
    setIsEditing = _useState2[1];
  var textAreaRef = /*#__PURE__*/React__default.createRef();

  // Focus textarea once isEditing flag is properly flipped
  useEffect(function () {
    if (textAreaRef && isEditing) {
      textAreaRef.current.focus();
    }
  }, [textAreaRef, isEditing]);
  var startEditing = function startEditing() {
    return setIsEditing(true);
  };
  var stopEditing = function stopEditing() {
    var _textAreaRef$current;
    onChanged((_textAreaRef$current = textAreaRef.current) === null || _textAreaRef$current === void 0 ? void 0 : _textAreaRef$current.value);
    setIsEditing(false);
  };
  var forceOccupy = text.length === 0;
  var textareaStyle = isEditing ? {} : {
    display: "none"
  };
  return /*#__PURE__*/React__default.createElement(Wrapper$1, null, allowHtml ? /*#__PURE__*/React__default.createElement(TextBlock, {
    isHidden: isEditing,
    forceOccupySpace: forceOccupy,
    dangerouslySetInnerHTML: {
      __html: text
    },
    onClick: startEditing
  }) : /*#__PURE__*/React__default.createElement(TextBlock, {
    isHidden: isEditing,
    forceOccupySpace: forceOccupy,
    onClick: startEditing
  }, text), /*#__PURE__*/React__default.createElement("textarea", {
    style: textareaStyle,
    ref: textAreaRef,
    rows: rows,
    onBlur: stopEditing,
    defaultValue: text
  }));
}
EditableText.propTypes = {
  text: PropTypes.string,
  allowHtml: PropTypes.bool,
  rows: PropTypes.number,
  onChanged: PropTypes.func
};
EditableText.defaultProps = {
  text: "",
  allowHtml: false,
  rows: 1,
  onChanged: function onChanged() {}
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$h() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var StyledInput = createStyled("input", "development" === "production" ? {
  target: "efajvpr0"
} : {
  target: "efajvpr0",
  label: "StyledInput"
})("development" === "production" ? {
  name: "u7ytkp",
  styles: "margin-right:0.5rem"
} : {
  name: "u7ytkp",
  styles: "margin-right:0.5rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNoZWNrYm94LmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLZ0MiLCJmaWxlIjoiY2hlY2tib3guanN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyogZXNsaW50LWRpc2FibGUganN4LWExMXkvY2xpY2stZXZlbnRzLWhhdmUta2V5LWV2ZW50cyAqL1xuaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCI7XG5cbmNvbnN0IFN0eWxlZElucHV0ID0gc3R5bGVkLmlucHV0YFxuICBtYXJnaW4tcmlnaHQ6IDAuNXJlbTtcbmA7XG5cbmZ1bmN0aW9uIENoZWNrYm94KHsgY2xhc3NOYW1lLCBjaGVja2VkLCBsYWJlbCwgb25DaGFuZ2VkIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8ZGl2XG4gICAgICByb2xlPVwiY2hlY2tib3hcIlxuICAgICAgdGFiSW5kZXg9ezB9XG4gICAgICBhcmlhLWNoZWNrZWQ9e2NoZWNrZWR9XG4gICAgICBjbGFzc05hbWU9e2NsYXNzTmFtZX1cbiAgICAgIG9uQ2xpY2s9eygpID0+IG9uQ2hhbmdlZCghY2hlY2tlZCl9XG4gICAgPlxuICAgICAgPFN0eWxlZElucHV0IHR5cGU9XCJjaGVja2JveFwiIGNoZWNrZWQ9e2NoZWNrZWR9IHJlYWRPbmx5IC8+XG4gICAgICA8c3Bhbj57bGFiZWx9PC9zcGFuPlxuICAgIDwvZGl2PlxuICApO1xufVxuXG5DaGVja2JveC5wcm9wVHlwZXMgPSB7XG4gIGNsYXNzTmFtZTogUHJvcFR5cGVzLnN0cmluZyxcbiAgY2hlY2tlZDogUHJvcFR5cGVzLmJvb2wsXG4gIGxhYmVsOiBQcm9wVHlwZXMuc3RyaW5nLFxuICBvbkNoYW5nZWQ6IFByb3BUeXBlcy5mdW5jLFxufTtcblxuQ2hlY2tib3guZGVmYXVsdFByb3BzID0ge1xuICBjbGFzc05hbWU6IFwiXCIsXG4gIGNoZWNrZWQ6IGZhbHNlLFxuICBsYWJlbDogXCJcIixcbiAgb25DaGFuZ2VkOiAoKSA9PiB7fSxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IENoZWNrYm94O1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$h
});
function Checkbox(_ref) {
  var className = _ref.className,
    checked = _ref.checked,
    label = _ref.label,
    onChanged = _ref.onChanged;
  return /*#__PURE__*/React__default.createElement("div", {
    role: "checkbox",
    tabIndex: 0,
    "aria-checked": checked,
    className: className,
    onClick: function onClick() {
      return onChanged(!checked);
    }
  }, /*#__PURE__*/React__default.createElement(StyledInput, {
    type: "checkbox",
    checked: checked,
    readOnly: true
  }), /*#__PURE__*/React__default.createElement("span", null, label));
}
Checkbox.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool,
  label: PropTypes.string,
  onChanged: PropTypes.func
};
Checkbox.defaultProps = {
  className: "",
  checked: false,
  label: "",
  onChanged: function onChanged() {}
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$g() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Wrapper = createStyled("div", "development" === "production" ? {
  target: "ej8aqur2"
} : {
  target: "ej8aqur2",
  label: "Wrapper"
})("display:flex;flex-direction:column;padding-bottom:5rem;margin-top:2rem;margin-bottom:5rem;border-bottom:2px solid ", colors$1.secondaryGreen, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var StyledCheckbox = /*#__PURE__*/createStyled(Checkbox, "development" === "production" ? {
  target: "ej8aqur1"
} : {
  target: "ej8aqur1",
  label: "StyledCheckbox"
})("development" === "production" ? {
  name: "135vrw8",
  styles: "align-self:start"
} : {
  name: "135vrw8",
  styles: "align-self:start",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
});
var StyledButton = /*#__PURE__*/createStyled(BigButton, "development" === "production" ? {
  target: "ej8aqur0"
} : {
  target: "ej8aqur0",
  label: "StyledButton"
})("development" === "production" ? {
  name: "hltamm",
  styles: "margin-top:2rem"
} : {
  name: "hltamm",
  styles: "margin-top:2rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
});
function MarketingConsentItem(_ref) {
  var consentTypeData = _ref.consentTypeData,
    onSave = _ref.onSave;
  var consentTypesDetail = consentTypeData.consentTypesDetail;
  var _useState = useState(consentTypesDetail.displayName),
    _useState2 = _slicedToArray$2(_useState, 2),
    displayName = _useState2[0],
    setDisplayName = _useState2[1];
  var _useState3 = useState(consentTypesDetail.displayToCustomer),
    _useState4 = _slicedToArray$2(_useState3, 2),
    displayToCustomer = _useState4[0],
    setDisplayToCustomer = _useState4[1];
  var _useState5 = useState(consentTypesDetail.consentDefaultIndicator),
    _useState6 = _slicedToArray$2(_useState5, 2),
    isDisabledByDefault = _useState6[0],
    setIsDisabledByDefault = _useState6[1];
  var _useState7 = useState(consentTypesDetail.consentText),
    _useState8 = _slicedToArray$2(_useState7, 2),
    consentText = _useState8[0],
    setConsentText = _useState8[1];
  var _useState9 = useState(consentTypesDetail.description),
    _useState10 = _slicedToArray$2(_useState9, 2),
    description = _useState10[0],
    setDescription = _useState10[1];
  var handleOnSave = function handleOnSave() {
    // Deep clone to not mutate input properties
    var newConsentTypeData = JSON.parse(JSON.stringify(consentTypeData));

    // Override with local modifications
    newConsentTypeData.consentTypesDetail = _objectSpread2$4(_objectSpread2$4({}, newConsentTypeData.consentTypesDetail), {}, {
      displayName: displayName,
      displayToCustomer: displayToCustomer,
      consentDefaultIndicator: isDisabledByDefault,
      consentText: consentText,
      description: description
    });
    onSave(newConsentTypeData);
  };
  return /*#__PURE__*/React__default.createElement(Wrapper, null, /*#__PURE__*/React__default.createElement("b", null, /*#__PURE__*/React__default.createElement(EditableText, {
    text: displayName,
    onChanged: setDisplayName
  })), /*#__PURE__*/React__default.createElement(StyledCheckbox, {
    checked: displayToCustomer,
    label: "Vises til kunde",
    onChanged: setDisplayToCustomer
  }), /*#__PURE__*/React__default.createElement(StyledCheckbox, {
    checked: isDisabledByDefault,
    label: "Forh\xE5ndsavkrysset",
    onChanged: setIsDisabledByDefault
  }), /*#__PURE__*/React__default.createElement(EditableText, {
    text: consentText,
    onChanged: setConsentText
  }), /*#__PURE__*/React__default.createElement(EditableText, {
    text: description,
    rows: 5,
    allowHtml: true,
    onChanged: setDescription
  }), /*#__PURE__*/React__default.createElement(StyledButton, {
    onClick: handleOnSave
  }, "Lagre"));
}
var MarketingConsentDataType = PropTypes.shape({
  consentTypesChannelIdentifier: PropTypes.shape({
    consentTypeName: PropTypes.string.isRequired,
    consentChannelName: PropTypes.string.isRequired
  }).isRequired,
  consentTypesDetail: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    displayToCustomer: PropTypes.bool.isRequired,
    consentDefaultIndicator: PropTypes.bool.isRequired,
    consentText: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  }).isRequired
});
MarketingConsentItem.propTypes = {
  consentTypeData: MarketingConsentDataType.isRequired,
  onSave: PropTypes.func
};
MarketingConsentItem.defaultProps = {
  onSave: function onSave() {}
};

function MarketingConsentsView(_ref) {
  var marketingConsents = _ref.marketingConsents,
    onSave = _ref.onSave;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, marketingConsents.map(function (consentsList) {
    var _consentsList$;
    var channel = (_consentsList$ = consentsList[0]) === null || _consentsList$ === void 0 ? void 0 : _consentsList$.consentTypesChannelIdentifier.consentChannelName;
    return /*#__PURE__*/React__default.createElement("div", {
      key: channel
    }, /*#__PURE__*/React__default.createElement("h2", null, stringsResource.channelLabels[channel]), consentsList.map(function (consent) {
      return /*#__PURE__*/React__default.createElement(MarketingConsentItem, {
        key: consent.consentTypesChannelIdentifier.consentTypeName,
        consentTypeData: consent,
        onSave: onSave
      });
    }));
  }));
}
MarketingConsentsView.propTypes = {
  marketingConsents: PropTypes.arrayOf(PropTypes.arrayOf(MarketingConsentDataType)),
  onSave: PropTypes.func
};
MarketingConsentsView.defaultProps = {
  marketingConsents: [],
  onSave: function onSave() {}
};

var consentTypesChannels = ["ya", "yx"];
function MarketingConsents(_ref) {
  var endpointUrl = _ref.endpointUrl;
  var _useState = useState({}),
    _useState2 = _slicedToArray$2(_useState, 2),
    marketingConsents = _useState2[0],
    setMarketingConsents = _useState2[1];
  var keycloakResult = useContext(AuthContext);
  var commonHeaders = useMemo(function () {
    return {
      Accept: "application/json",
      Authorization: "Bearer ".concat(keycloakResult.token)
    };
  }, [keycloakResult.token]);
  var consentTypesApiUrl = "".concat(endpointUrl, "/consentmanager/api/consenttypes");

  // Fetch consent types from all channels
  useEffect(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                consentTypesChannels.forEach( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(channel) {
                    var response, _yield$response$json, consentTypes;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return fetch("".concat(consentTypesApiUrl, "/consentchannel/").concat(channel), {
                              headers: commonHeaders
                            });
                          case 2:
                            response = _context.sent;
                            if (!response.ok) {
                              _context.next = 9;
                              break;
                            }
                            _context.next = 6;
                            return response.json();
                          case 6:
                            _yield$response$json = _context.sent;
                            consentTypes = _yield$response$json.consentTypes;
                            if (Array.isArray(consentTypes)) {
                              setMarketingConsents(function (prevState) {
                                return _objectSpread2$4(_objectSpread2$4({}, prevState), {}, _defineProperty$5({}, channel, consentTypes));
                              });
                            }
                          case 9:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));
                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }());
              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();
    fetchData();
  }, [commonHeaders, consentTypesApiUrl]);
  var onSave = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(consentData) {
      var url, headers, body, response, responseBody, _responseBody$consent, consentTypeName, consentChannelName;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              url = "".concat(consentTypesApiUrl, "/consenttype");
              headers = _objectSpread2$4(_objectSpread2$4({}, commonHeaders), {}, {
                "Content-Type": "application/json"
              });
              body = JSON.stringify(consentData);
              _context3.next = 5;
              return fetch(url, {
                method: "POST",
                headers: headers,
                body: body
              });
            case 5:
              response = _context3.sent;
              if (!response.ok) {
                _context3.next = 14;
                break;
              }
              _context3.next = 9;
              return response.json();
            case 9:
              responseBody = _context3.sent;
              // The response contains the updated consent. Plug it into the right channel and position.
              _responseBody$consent = responseBody.consentTypesChannelIdentifier, consentTypeName = _responseBody$consent.consentTypeName, consentChannelName = _responseBody$consent.consentChannelName;
              setMarketingConsents(function (prevState) {
                var newState = JSON.parse(JSON.stringify(prevState));
                var targetedConsent = newState[consentChannelName].find(function (consent) {
                  return consent.consentTypesChannelIdentifier.consentTypeName === consentTypeName;
                });
                targetedConsent.consentTypesDetail = responseBody.consentTypesDetail;
                return newState;
              });
              _context3.next = 15;
              break;
            case 14:
              // eslint-disable-next-line no-console
              console.warn("Failed saving consent type.");
            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function onSave(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var orderedConsents = consentTypesChannels.map(function (channel) {
    return marketingConsents[channel];
  }).filter(Boolean);
  return /*#__PURE__*/React__default.createElement(MarketingConsentsView, {
    marketingConsents: orderedConsents,
    onSave: onSave
  });
}
MarketingConsents.propTypes = {
  endpointUrl: PropTypes.string.isRequired
};

function SecuredMarketingConsents$1(_ref) {
  var endpointUrl = _ref.endpointUrl,
    _ref$keycloakData = _ref.keycloakData,
    url = _ref$keycloakData.url,
    realm = _ref$keycloakData.realm,
    clientId = _ref$keycloakData.clientId,
    cmsHelperUrl = _ref.cmsHelperUrl;
  return /*#__PURE__*/React__default.createElement(SystemStatus, {
    cmsHelperUrl: cmsHelperUrl
  }, /*#__PURE__*/React__default.createElement(Auth, {
    url: url,
    realm: realm,
    clientId: clientId,
    targetPage: "MarketingConsents"
  }, /*#__PURE__*/React__default.createElement(MarketingConsents, {
    endpointUrl: endpointUrl
  })));
}
SecuredMarketingConsents$1.propTypes = {
  cmsHelperUrl: PropTypes.string.isRequired,
  endpointUrl: PropTypes.string.isRequired,
  keycloakData: PropTypes.shape({
    url: PropTypes.string,
    realm: PropTypes.string,
    clientId: PropTypes.string
  }).isRequired
};

var _excluded = ["nominalInterest", "productType"];
var Requests = (function (applicationId, sblDomain, cmsDomain, keycloakResult) {
  var SBL_DOMAIN = sblDomain;
  var CMS_API_DOMAIN = cmsDomain;
  var SBL_BASE_URL = "".concat(SBL_DOMAIN, "/api");
  var CMS_SIGNATURE_API_BASE_URL = "".concat(CMS_API_DOMAIN, "/api/signature");
  var throwErrorOnFlag = function throwErrorOnFlag() {
    var errorObject = {
      response: {
        data: {
          error: "Precondition Failed",
          message: "Request failed with status code 412"
        },
        status: 412,
        statusText: "Precondition Failed",
        headers: {
          "content-type": "application/json"
        }
      }
    };
    var testOptions = getTestOptions();
    var return412 = testOptions && testOptions.return412;
    if (return412) {
      throw errorObject;
    }
  };
  var getConfigWithAuth = function getConfigWithAuth(config) {
    var configToUse = {};
    if (config) {
      configToUse = config;
    }
    return _objectSpread2$4(_objectSpread2$4({}, configToUse), {}, {
      headers: _objectSpread2$4(_objectSpread2$4({}, configToUse.headers), {}, {
        Authorization: "Bearer ".concat(keycloakResult === null || keycloakResult === void 0 ? void 0 : keycloakResult.token)
      })
    });
  };
  var reqPost = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, data, config) {
      var allowedStatuses,
        _e$response,
        _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              allowedStatuses = _args.length > 3 && _args[3] !== undefined ? _args[3] : [];
              _context.prev = 1;
              axios$1.defaults.validateStatus = function validateStatusFunction(status) {
                // Return true if the status code is between 200 and 299 OR is an allowed status
                return status >= 200 && status < 300 || allowedStatuses.includes(status);
              };
              throwErrorOnFlag();
              _context.next = 6;
              return axios$1.post(url, data, getConfigWithAuth(config));
            case 6:
              return _context.abrupt("return", _context.sent);
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              if ((_context.t0 === null || _context.t0 === void 0 ? void 0 : (_e$response = _context.t0.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 401) {
                keycloakResult.setAuthenticated(false);
              }
              throw _context.t0;
            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9]]);
    }));
    return function reqPost(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
  var reqGet = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url, data) {
      var config,
        configToUse,
        _e$response2,
        _args2 = arguments;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              config = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
              configToUse = getConfigWithAuth(config);
              if (data) {
                configToUse = _objectSpread2$4(_objectSpread2$4({}, configToUse), {}, {
                  params: data
                });
              }
              _context2.prev = 3;
              throwErrorOnFlag();
              _context2.next = 7;
              return axios$1.get(url, configToUse);
            case 7:
              return _context2.abrupt("return", _context2.sent);
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](3);
              if ((_context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_e$response2 = _context2.t0.response) === null || _e$response2 === void 0 ? void 0 : _e$response2.status) === 401) {
                keycloakResult.setAuthenticated(false);
              }
              throw _context2.t0;
            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 10]]);
    }));
    return function reqGet(_x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }();
  return {
    checkApplication: function checkApplication() {
      return reqPost("".concat(CMS_SIGNATURE_API_BASE_URL, "/checkApplication"), {
        applicationId: applicationId
      });
    },
    verifySsn: function verifySsn(ssn, isMainApplicant) {
      return reqPost("".concat(CMS_SIGNATURE_API_BASE_URL, "/verifySsn"), {
        applicationId: applicationId,
        mainApplicant: isMainApplicant,
        ssn: ssn
      });
    },
    uploadDocument: function uploadDocument(isMainApplicant, file, documentType) {
      var documentPassword = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
      var formData = new FormData();
      formData.append("file", file);
      formData.append("documentType", documentType);
      formData.append("applicationId", applicationId);
      formData.append("mainApplicant", isMainApplicant);
      if (documentType === "paycheck") formData.append("documentPassword", documentPassword);
      return reqPost("".concat(CMS_SIGNATURE_API_BASE_URL, "/uploadDocument"), formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    },
    chooseIdentificationMethod: function chooseIdentificationMethod(isMainApplicant, identificationMethod, redirectUrlCancel, redirectUrlCompleted, redirectUrlRejected) {
      return reqPost("".concat(CMS_SIGNATURE_API_BASE_URL, "/chooseIdentificationMethod"), {
        applicationId: applicationId,
        identificationMethod: identificationMethod,
        mainApplicant: isMainApplicant,
        signicatUrls: {
          targetUrlOnSigningCancel: redirectUrlCancel,
          targetUrlOnSigningComplete: redirectUrlCompleted,
          targetUrlOnSigningReject: redirectUrlRejected
        }
      });
    },
    checkApplicationSigningStatus: function checkApplicationSigningStatus(isMainApplicant) {
      return reqPost("".concat(CMS_SIGNATURE_API_BASE_URL, "/checkApplicationSigningStatus"), {
        applicationId: applicationId,
        mainApplicant: isMainApplicant
      }, {}, [413]);
    },
    submitPaymentAuthorization: function submitPaymentAuthorization(accountNr) {
      var existingLoans = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return reqPost("".concat(CMS_SIGNATURE_API_BASE_URL, "/submitPaymentAuthorization"), {
        accountNr: accountNr,
        applicationId: applicationId,
        existingLoans: existingLoans.map(function (_ref3) {
          _ref3.nominalInterest;
            _ref3.productType;
            var theRest = _objectWithoutProperties$3(_ref3, _excluded);
          return _objectSpread2$4({}, theRest);
        }),
        mainApplicant: true
      });
    },
    registerDocumentsUploadedExternally: function registerDocumentsUploadedExternally(isMainApplicant, documentType) {
      return reqGet("".concat(CMS_SIGNATURE_API_BASE_URL, "/registerDocumentsUploadedExternally"), {
        applicationId: applicationId,
        documentType: documentType,
        mainApplicant: isMainApplicant
      });
    },
    chooseInsurance: function chooseInsurance(isMainApplicant, acceptTerms, wantInsurance, ssn) {
      return reqPost("".concat(CMS_SIGNATURE_API_BASE_URL, "/chooseInsurance"), {
        acceptTerms: acceptTerms,
        applicationId: applicationId,
        insuranceIsForSubsidiary: false,
        mainApplicant: isMainApplicant,
        ssn: ssn,
        wantInsurance: wantInsurance
      });
    },
    verifySignature: function verifySignature(isMainApplicant) {
      return reqPost("".concat(CMS_SIGNATURE_API_BASE_URL, "/verifySignature"), {
        applicationId: applicationId,
        mainApplicant: isMainApplicant
      });
    },
    getAltinnConsent: function getAltinnConsent(ssn, lastName) {
      return reqGet("".concat(SBL_BASE_URL, "/getConsentUrl"), {
        lastName: lastName,
        ssn: ssn,
        redirectUrl: window.location.href
      });
    },
    fetchAltinnTaxReturnsAndIncome: function fetchAltinnTaxReturnsAndIncome(authCode) {
      return reqPost("".concat(CMS_SIGNATURE_API_BASE_URL, "/fetchTaxReturnsAndIncome"), {
        authCode: authCode,
        applicationId: applicationId
      });
    },
    fetchCreditors: function fetchCreditors() {
      return reqGet("".concat(CMS_API_DOMAIN, "/api/creditors/accountNumbersAndPrefixes"));
    },
    validateKidAndAccount: function validateKidAndAccount(account, kid) {
      return reqPost("".concat(CMS_SIGNATURE_API_BASE_URL, "/validateKidAndAccount"), {
        account: account,
        kid: kid
      });
    },
    fetchTrafficLightColor: function fetchTrafficLightColor() {
      return reqGet("".concat(CMS_SIGNATURE_API_BASE_URL, "/trafficLight"), {
        applicationId: applicationId
      });
    }
  };
});

var getUrlWithAppendedParams = function getUrlWithAppendedParams(paramsObj) {
  var currentUrl = new URL(window.location.href);
  var searchParams = currentUrl.searchParams;
  Object.keys(paramsObj).forEach(function (key) {
    searchParams.set(key, paramsObj[key]);
  });
  return currentUrl.toString();
};
var hasParam = function hasParam(param) {
  var currentUrl = new URL(window.location.href);
  var searchParams = currentUrl.searchParams;
  return searchParams.has(param);
};
var getParam = function getParam(param) {
  var currentUrl = new URL(window.location.href);
  var searchParams = currentUrl.searchParams;
  return searchParams.get(param);
};
var removeUrlParameter = function removeUrlParameter(parameter) {
  var currentUrl = new URL(window.location.href);
  var searchParams = currentUrl.searchParams;
  searchParams.delete(parameter);
  // eslint-disable-next-line no-restricted-globals
  history.replaceState(null, "", currentUrl);
};
var removeIdentifiedUrlParameter = function removeIdentifiedUrlParameter() {
  return removeUrlParameter("identified");
};
var removeAuthCodeParameter = function removeAuthCodeParameter() {
  return removeUrlParameter("AuthorizationCode");
};

var profileImage = "data:image/png;base64,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";

function _EMOTION_STRINGIFIED_CSS_ERROR__$f() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var StepItemUiContainer = createStyled("div", "development" === "production" ? {
  target: "efs4sez2"
} : {
  target: "efs4sez2",
  label: "StepItemUiContainer"
})("development" === "production" ? {
  name: "nlhusu",
  styles: "margin-bottom:20px;@media only screen and (min-width: 600px){grid-template-columns:100px auto;}grid-template-columns:auto;display:grid;grid-row-gap:20px"
} : {
  name: "nlhusu",
  styles: "margin-bottom:20px;@media only screen and (min-width: 600px){grid-template-columns:100px auto;}grid-template-columns:auto;display:grid;grid-row-gap:20px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
});
var MinProfilContainer = createStyled("div", "development" === "production" ? {
  target: "efs4sez1"
} : {
  target: "efs4sez1",
  label: "MinProfilContainer"
})("development" === "production" ? {
  name: "qtqjyp",
  styles: "@media only screen and (min-width: 600px){display:block;}display:none;margin:60px auto auto auto"
} : {
  name: "qtqjyp",
  styles: "@media only screen and (min-width: 600px){display:block;}display:none;margin:60px auto auto auto",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
});
var Box$1 = createStyled("div", "development" === "production" ? {
  target: "efs4sez0"
} : {
  target: "efs4sez0",
  label: "Box"
})("overflow:hidden;.border-with-shape{margin:0 0 3px;margin-left:4px;box-shadow:", function (props) {
  return props.removeBoxShadow ? "none" : "-1px 0px 4px 1px rgba(0, 0, 0, 0.3);";
}, ";position:relative;@media only screen and (min-width: 600px){margin-left:20px;&:before{content:\"\";position:absolute;display:", function (props) {
  return props.isCurrentStep ? "block" : "none";
}, ";top:65px;left:-18px;right:0;bottom:calc(100 % - 6px);width:30px;height:30px;transform:rotate(45deg);border:2px solid;border-color:transparent transparent #ccc transparent;background-color:white;}}}" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
function StepItemContainer(props) {
  var isCurrentStep = props.isCurrentStep,
    removeBoxShadow = props.removeBoxShadow,
    children = props.children;
  return /*#__PURE__*/React__default.createElement(StepItemUiContainer, null, /*#__PURE__*/React__default.createElement(MinProfilContainer, null, isCurrentStep && /*#__PURE__*/React__default.createElement("img", {
    src: profileImage,
    alt: "user icon"
  })), /*#__PURE__*/React__default.createElement(Box$1, {
    isCurrentStep: isCurrentStep,
    removeBoxShadow: removeBoxShadow
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "border-with-shape"
  }, children)));
}
StepItemContainer.propTypes = {
  children: PropTypes.node,
  isCurrentStep: PropTypes.bool.isRequired,
  removeBoxShadow: PropTypes.bool
};
StepItemContainer.defaultProps = {
  removeBoxShadow: false,
  children: null
};

function GoToSubsidaryPage(props) {
  var name = props.name;
  var keycloakResult = useContext(AuthContext);
  return /*#__PURE__*/React__default.createElement(StepItemContainer, {
    isCurrentStep: true,
    removeBoxShadow: true
  }, /*#__PURE__*/React__default.createElement("h4", {
    style: {
      fontWeight: "500",
      padding: "20px"
    }
  }, "Takk ", name), /*#__PURE__*/React__default.createElement("h2", {
    style: {
      paddingLeft: "20px"
    }
  }, "Medl\xE5ntaker"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      padding: "20px",
      maxWidth: "800px"
    }
  }, "F\xF8r vi kan utbetale l\xE5net, m\xE5 ogs\xE5 medl\xE5ntaker fullf\xF8re signeringsprosessen. Dersom du har medl\xE5ntaker ved siden av deg n\xE5, kan han/hun starte ved \xE5 trykke p\xE5 knappen under. Medl\xE5ntaker kan ogs\xE5 benytte linken han/hun har mottatt i egen e-post.", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null), "Du vil motta en e-post s\xE5 snart medl\xE5ntaker har fullf\xF8rt prosessen og l\xE5net er utbetalt."), /*#__PURE__*/React__default.createElement("div", {
    style: {
      maxWidth: "300px",
      paddingLeft: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Button, {
    label: "Medl\xE5ntaker",
    onclick: keycloakResult.logout,
    textAlign: "center"
  })));
}
GoToSubsidaryPage.propTypes = {
  name: PropTypes.string
};
GoToSubsidaryPage.defaultProps = {
  name: ""
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$e() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var stepContainerWidthInPx$1 = 700;
var stepContainerWidth$1 = "".concat(stepContainerWidthInPx$1, "px");
var StatusPreText = createStyled("span", "development" === "production" ? {
  target: "ed4yynj6"
} : {
  target: "ed4yynj6",
  label: "StatusPreText"
})("color:", function (props) {
  return props.completed ? "#4fb576" : "#cc281d";
}, ";&:after{content:\" \";}font-weight:", function (props) {
  return props.fontWeight || "unset";
}, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNoYXJlZFN0eWxlZENvbXBvbmVudHMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBS3dDIiwiZmlsZSI6InNoYXJlZFN0eWxlZENvbXBvbmVudHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIjtcblxuY29uc3Qgc3RlcENvbnRhaW5lcldpZHRoSW5QeCA9IDcwMDtcbmNvbnN0IHN0ZXBDb250YWluZXJXaWR0aCA9IGAke3N0ZXBDb250YWluZXJXaWR0aEluUHh9cHhgO1xuXG5leHBvcnQgY29uc3QgU3RhdHVzUHJlVGV4dCA9IHN0eWxlZC5zcGFuYFxuICBjb2xvcjogJHsocHJvcHMpID0+IChwcm9wcy5jb21wbGV0ZWQgPyBcIiM0ZmI1NzZcIiA6IFwiI2NjMjgxZFwiKX07XG4gICY6YWZ0ZXIge1xuICAgIGNvbnRlbnQ6IFwiIFwiO1xuICB9XG4gIGZvbnQtd2VpZ2h0OiAkeyhwcm9wcykgPT4gcHJvcHMuZm9udFdlaWdodCB8fCBcInVuc2V0XCJ9O1xuYDtcblxuZXhwb3J0IGNvbnN0IFN0ZXBTZWN0aW9uSGVhZGVyID0gc3R5bGVkLmg0YFxuICBmb250LXdlaWdodDogYm9sZDtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICBjb2xvcjogYmxhY2s7XG4gIHBhZGRpbmctYm90dG9tOiAxNXB4O1xuYDtcbmV4cG9ydCBjb25zdCBTdGVwU2VjdGlvblBhcmFncmFwaCA9IHN0eWxlZC5wYFxuICBtYXgtd2lkdGg6ICR7c3RlcENvbnRhaW5lcldpZHRofTtcbiAgd2lkdGg6IDgwJTtcbiAgcGFkZGluZy1sZWZ0OiAxMHB4O1xuICBwYWRkaW5nLXJpZ2h0OiAxMHB4O1xuICBwYWRkaW5nLXRvcDogMnB4O1xuICBwYWRkaW5nLWJvdHRvbTogNXB4O1xuICBtYXJnaW4tbGVmdDogYXV0bztcbiAgbWFyZ2luLXJpZ2h0OiBhdXRvO1xuYDtcblxuZXhwb3J0IGNvbnN0IEhvcml6b250YWxEZXZpZGVyID0gc3R5bGVkLmRpdmBcbiAgYm9yZGVyLWJvdHRvbTogMXB4IHNvbGlkIGxpZ2h0Z3JleTtcbiAgbWF4LXdpZHRoOiAkeyhwcm9wcykgPT4gcHJvcHMubWF4V2lkdGggfHwgc3RlcENvbnRhaW5lcldpZHRofTtcbiAgd2lkdGg6IDgwJTtcbiAgbWFyZ2luOiAxNXB4IGF1dG87XG4gIG1hcmdpbi1sZWZ0OiBhdXRvO1xuICBtYXJnaW4tcmlnaHQ6IGF1dG87XG5gO1xuXG5leHBvcnQgY29uc3QgU3RlcENvbnRlbnRDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICBwYWRkaW5nLWJvdHRvbTogMzBweDtcbiAgcGFkZGluZy10b3A6IDEwcHg7XG5gO1xuZXhwb3J0IGNvbnN0IEF1dG9BbGlnblN0ZXBJdGVtTGVmdFNwYWNlQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgQG1lZGlhIG9ubHkgc2NyZWVuIGFuZCAobWluLXdpZHRoOiA2MDBweCkge1xuICAgIHBhZGRpbmctbGVmdDogMTIwcHg7XG4gIH1cbiAgcGFkZGluZy1sZWZ0OiAxMHB4O1xuYDtcblxuLy8gdW51c2VkXG5leHBvcnQgY29uc3QgQ2VudGVyZFNwaW5uZXJDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICBtYXJnaW46IDA7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiA1MCU7XG4gIGxlZnQ6IDUwJTtcbiAgdHJhbnNmb3JtOiB0cmFuc2xhdGUoLTUwJSwgLTUwJSk7XG5gO1xuIl19 */"));
var StepSectionHeader$1 = createStyled("h4", "development" === "production" ? {
  target: "ed4yynj5"
} : {
  target: "ed4yynj5",
  label: "StepSectionHeader"
})("development" === "production" ? {
  name: "kprxo1",
  styles: "font-weight:bold;text-align:center;color:black;padding-bottom:15px"
} : {
  name: "kprxo1",
  styles: "font-weight:bold;text-align:center;color:black;padding-bottom:15px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
});
var StepSectionParagraph$1 = createStyled("p", "development" === "production" ? {
  target: "ed4yynj4"
} : {
  target: "ed4yynj4",
  label: "StepSectionParagraph"
})("max-width:", stepContainerWidth$1, ";width:80%;padding-left:10px;padding-right:10px;padding-top:2px;padding-bottom:5px;margin-left:auto;margin-right:auto;" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var HorizontalDevider = createStyled("div", "development" === "production" ? {
  target: "ed4yynj3"
} : {
  target: "ed4yynj3",
  label: "HorizontalDevider"
})("border-bottom:1px solid lightgrey;max-width:", function (props) {
  return props.maxWidth || stepContainerWidth$1;
}, ";width:80%;margin:15px auto;margin-left:auto;margin-right:auto;" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var StepContentContainer$1 = createStyled("div", "development" === "production" ? {
  target: "ed4yynj2"
} : {
  target: "ed4yynj2",
  label: "StepContentContainer"
})("development" === "production" ? {
  name: "1okb6a7",
  styles: "padding-bottom:30px;padding-top:10px"
} : {
  name: "1okb6a7",
  styles: "padding-bottom:30px;padding-top:10px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
});
var AutoAlignStepItemLeftSpaceContainer = createStyled("div", "development" === "production" ? {
  target: "ed4yynj1"
} : {
  target: "ed4yynj1",
  label: "AutoAlignStepItemLeftSpaceContainer"
})("development" === "production" ? {
  name: "18b3zbn",
  styles: "@media only screen and (min-width: 600px){padding-left:120px;}padding-left:10px"
} : {
  name: "18b3zbn",
  styles: "@media only screen and (min-width: 600px){padding-left:120px;}padding-left:10px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
});

// unused
createStyled("div", "development" === "production" ? {
  target: "ed4yynj0"
} : {
  target: "ed4yynj0",
  label: "CenterdSpinnerContainer"
})("development" === "production" ? {
  name: "g3r6o5",
  styles: "margin:0;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
} : {
  name: "g3r6o5",
  styles: "margin:0;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
});

var CopiedErrorLabel = createStyled("label", "development" === "production" ? {
  target: "e1mv090a0"
} : {
  target: "e1mv090a0",
  label: "CopiedErrorLabel"
})("white-space:pre-wrap;padding:11px 20px;margin:10px 0;z-index:1!important;color:white;font-size:14px;font-weight:600;background:", colors$1.freshRed, ";border-radius:5px;text-align:center;box-shadow:0 5px 10px rgb(0 0 0 / 30%);&:before{top:-9px;border-top:none;border-left:10px solid transparent;border-right:10px solid transparent;border-bottom:10px solid #fe1237;content:\"\";width:0;height:0;position:absolute;bottom:-10px;", function (props) {
  return props.positionAbsoluteHorizontallyCenter ? "left: 50%;\n        -webkit-transform: translateX(-50%);\n        transform: translateX(-50%);" : "";
}, ";}", function (props) {
  return props.positionAbsoluteHorizontallyCenter ? "\n        position: absolute;\n        left: 50%;\n        -webkit-transform: translateX(-50%);\n        transform: translateX(-50%);\n    " : "";
}, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
function SimpleErrorLabel(props) {
  var _useState = useState(0),
    _useState2 = _slicedToArray$2(_useState, 2),
    labelHeight = _useState2[0],
    setLabelHeight = _useState2[1];
  var errorText = props.errorText,
    positionAbsoluteHorizontallyCenter = props.positionAbsoluteHorizontallyCenter;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(function () {
    if (labelHeight === 0 && errorText) {
      var errorLabelElement = document.getElementById("simple-error-label");
      setLabelHeight(errorLabelElement.offsetHeight);
    }
  });
  return errorText !== null && errorText !== void 0 && errorText.length ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "".concat(labelHeight, "px")
    }
  }, /*#__PURE__*/React__default.createElement(CopiedErrorLabel, {
    id: "simple-error-label",
    positionAbsoluteHorizontallyCenter: positionAbsoluteHorizontallyCenter
  }, errorText)) : null;
}
SimpleErrorLabel.propTypes = {
  errorText: PropTypes.string,
  positionAbsoluteHorizontallyCenter: PropTypes.bool
};
SimpleErrorLabel.defaultProps = {
  positionAbsoluteHorizontallyCenter: false,
  errorText: null
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$d() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var RevertedGlobalResets = createStyled("div", "development" === "production" ? {
  target: "eig8mqv0"
} : {
  target: "eig8mqv0",
  label: "RevertedGlobalResets"
})("development" === "production" ? {
  name: "c53b6d",
  styles: "br,div,h2,h6,p,ul,li,a,label{padding:revert;margin:revert;}"
} : {
  name: "c53b6d",
  styles: "br,div,h2,h6,p,ul,li,a,label{padding:revert;margin:revert;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJldmVydGVkR2xvYmFsUmVzZXRzLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUV1QyIsImZpbGUiOiJSZXZlcnRlZEdsb2JhbFJlc2V0cy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiO1xuXG5jb25zdCBSZXZlcnRlZEdsb2JhbFJlc2V0cyA9IHN0eWxlZC5kaXZgXG4gIGJyLFxuICBkaXYsXG4gIGgyLFxuICBoNixcbiAgcCxcbiAgdWwsXG4gIGxpLFxuICBhLFxuICBsYWJlbCB7XG4gICAgcGFkZGluZzogcmV2ZXJ0O1xuICAgIG1hcmdpbjogcmV2ZXJ0O1xuICB9XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBSZXZlcnRlZEdsb2JhbFJlc2V0cztcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
});

var primaryGreen$4 = colors$1.primaryGreen,
  lightGrey$1 = colors$1.lightGrey;
var ToggleCollapseSpanContainer$1 = createStyled("span", "development" === "production" ? {
  target: "e4wz4up0"
} : {
  target: "e4wz4up0",
  label: "ToggleCollapseSpanContainer"
})("cursor:pointer;color:", primaryGreen$4, ";font-weight:bold;float:right;text-align:right;width:100%;" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
function Insurance$1(props) {
  var chooseInsurance = props.chooseInsurance,
    insuranceTermsLink = props.insuranceTermsLink,
    termsOfPurchaseLink = props.termsOfPurchaseLink,
    insuranceIsMandatory = props.insuranceIsMandatory;
  var _useState = useState(false),
    _useState2 = _slicedToArray$2(_useState, 2),
    acceptTerms = _useState2[0],
    setAcceptTerms = _useState2[1];
  var _useState3 = useState(insuranceIsMandatory),
    _useState4 = _slicedToArray$2(_useState3, 2),
    wantInsurance = _useState4[0],
    setWantInsurance = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray$2(_useState5, 2),
    isExpanded = _useState6[0],
    setIsExpanded = _useState6[1];
  var toggleExpanded = function toggleExpanded() {
    setIsExpanded(!isExpanded);
  };
  var displayErrorContext = useContext(DisplayErrorsSigningContext);
  return /*#__PURE__*/React__default.createElement(StepItemContainer, {
    isCurrentStep: true,
    removeBoxShadow: true
  }, /*#__PURE__*/React__default.createElement(StepSectionHeader$1, null, "\xD8nsker du betalingsforsikring p\xE5 l\xE5net?"), /*#__PURE__*/React__default.createElement(StepSectionParagraph$1, null, "\xD8nsker du betalingsforsikring p\xE5 l\xE5net?"), /*#__PURE__*/React__default.createElement(ToggleCollapseSpanContainer$1, {
    onClick: toggleExpanded
  }, isExpanded ? "Lukk" : "Les om fordelene her", " ", /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: isExpanded ? faChevronUp : faChevronDown
  })), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Collapse, {
    isOpen: isExpanded
  }, /*#__PURE__*/React__default.createElement(RevertedGlobalResets, {
    style: {
      backgroundColor: lightGrey$1,
      padding: "30px 10px",
      margin: "0 20px"
    }
  }, /*#__PURE__*/React__default.createElement("h6", null, "Nyhet! yA betalingsforsikring"), /*#__PURE__*/React__default.createElement("p", null, "yA gir deg \xF8konomisk trygghet! Forsikringen dekker ditt terminbel\xF8p ved:"), /*#__PURE__*/React__default.createElement("ul", null, /*#__PURE__*/React__default.createElement("li", null, "Sykmelding i mer enn 30 dager"), /*#__PURE__*/React__default.createElement("li", null, "Sykehusinnlegging i mer enn 5 dager"), /*#__PURE__*/React__default.createElement("li", null, "Arbeidsledighet"), /*#__PURE__*/React__default.createElement("li", null, "Ved d\xF8dsfall innfris l\xE5net med inntil kr 50.000,-")), /*#__PURE__*/React__default.createElement("p", null, "Se fullstendige vilk\xE5r", " ", /*#__PURE__*/React__default.createElement("a", {
    href: insuranceTermsLink,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "her")), /*#__PURE__*/React__default.createElement("p", null, "Forsikringspremien legges p\xE5 l\xE5nebel\xF8pet og nedbetales over hele l\xE5neperioden."), /*#__PURE__*/React__default.createElement("p", null, "Forsikringen gjelder i inntil 3 \xE5r og utgj\xF8r kr 255,- per m\xE5ned."))), /*#__PURE__*/React__default.createElement(HorizontalDevider, null), /*#__PURE__*/React__default.createElement(RevertedGlobalResets, {
    style: {
      padding: "30px 50px",
      margin: "0 20px"
    }
  }, /*#__PURE__*/React__default.createElement(Checkbox$1, {
    id: "wants-insurance-checkbox",
    disabled: insuranceIsMandatory,
    checked: wantInsurance,
    onchange: function onchange(e) {
      var checked = e.target.checked;
      setWantInsurance(checked);
      if (!checked) {
        setAcceptTerms(false);
      }
    }
  }, "Ja, jeg \xF8nsker yA Betalingsforsikring p\xE5 l\xE5net", insuranceIsMandatory && /*#__PURE__*/React__default.createElement("div", null, "(Du har allerede forsikring p\xE5 ditt eksisterende l\xE5n)")), /*#__PURE__*/React__default.createElement(Checkbox$1, {
    id: "accept-insurance-terms-checkbox",
    checked: acceptTerms,
    onchange: function onchange(e) {
      setAcceptTerms(e.target.checked);
    },
    disabled: !wantInsurance
  }, "Jeg har lest og forst\xE5tt", " ", /*#__PURE__*/React__default.createElement("a", {
    href: termsOfPurchaseLink,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "forkj\xF8psinformasjonen"), " ", "for", " ", /*#__PURE__*/React__default.createElement("a", {
    href: insuranceTermsLink,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "yA Betalingsforsikring"), " ", "og erkl\xE6rer at jeg:", /*#__PURE__*/React__default.createElement("ul", null, /*#__PURE__*/React__default.createElement("li", null, "er over 18 \xE5r"), /*#__PURE__*/React__default.createElement("li", null, "er fast ansatt eller er selvstendig n\xE6ringsdrivende som ikke mottar sykepenger, dagpenger, uf\xF8retrygd eller lignende st\xF8nad eller erstatning (forsikringsdekningen som ytes under denne forsikringen kan variere ut i fra Forsikredes konkrete jobbstatus, i henhold til hva som er beskrevet heretter og i vilk\xE5r), og"), /*#__PURE__*/React__default.createElement("li", null, "ikke er kjent med, eller burde hatt grunn til \xE5 regne med, forest\xE5ende ufrivillig tap av arbeid"), /*#__PURE__*/React__default.createElement("li", null, "ikke er kjent med eksisterende sykdom, eller tilstand som kan medf\xF8re arbeidsuf\xF8rhet eller sykehusinnlegging"))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(BigButton, {
    type: "button",
    disabled: wantInsurance && !acceptTerms,
    onClick: function onClick() {
      chooseInsurance(acceptTerms, wantInsurance);
    }
  }, "Fortsette"), /*#__PURE__*/React__default.createElement(SimpleErrorLabel, {
    errorText: displayErrorContext.chooseInsurance,
    positionAbsoluteHorizontallyCenter: true
  })));
}
Insurance$1.propTypes = {
  chooseInsurance: PropTypes.func.isRequired,
  insuranceTermsLink: PropTypes.string.isRequired,
  termsOfPurchaseLink: PropTypes.string.isRequired,
  insuranceIsMandatory: PropTypes.bool.isRequired
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$c() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var primaryGreen$3 = colors$1.primaryGreen;
var BoldText = createStyled("p", "development" === "production" ? {
  target: "e6llxwr1"
} : {
  target: "e6llxwr1",
  label: "BoldText"
})("development" === "production" ? {
  name: "1iqtc62",
  styles: "font-weight:500;padding:10px;padding-left:20px;max-width:800px"
} : {
  name: "1iqtc62",
  styles: "font-weight:500;padding:10px;padding-left:20px;max-width:800px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$c
});
var AccountInfoInput = createStyled("input", "development" === "production" ? {
  target: "e6llxwr0"
} : {
  target: "e6llxwr0",
  label: "AccountInfoInput"
})("margin-left:20px;max-width:", function (props) {
  return props.inputWidth || "300px";
}, ";height:50px;border:1px solid ", primaryGreen$3, ";border-radius:5px;text-align:center;color:", primaryGreen$3, "!important;font-weight:bold;&:focus{outline:none!important;box-shadow:none;border-color:", primaryGreen$3, ";}outline-color:", primaryGreen$3, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
function ThankYouPage(props) {
  var name = props.name,
    accountNumber = props.accountNumber;
  return /*#__PURE__*/React__default.createElement(StepItemContainer, {
    isCurrentStep: true,
    removeBoxShadow: true
  }, /*#__PURE__*/React__default.createElement(BoldText, null, "Takk ", name), /*#__PURE__*/React__default.createElement(BoldText, null, "Vi vil n\xE5 g\xE5 igjennom dokumentasjonen, dersom vi har flere sp\xF8rsm\xE5l vil vi ta kontakt med deg. Hvis ikke vil vi utbetale l\xE5net til kontonummer:"), /*#__PURE__*/React__default.createElement(AccountInfoInput, {
    placeholder: accountNumber || "xxxx xx xxxxx",
    disabled: true
  }), /*#__PURE__*/React__default.createElement(BoldText, null, "Du vil motta en sms og en mail s\xE5 fort l\xE5net er utbetalt."), /*#__PURE__*/React__default.createElement(BoldText, null, "Har du sp\xF8rsm\xE5l?", /*#__PURE__*/React__default.createElement("br", null), "Ring oss p\xE5 ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: primaryGreen$3
    }
  }, "Tlf. 23 20 46 00"), /*#__PURE__*/React__default.createElement("br", null), "Eller send e-post til: ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: primaryGreen$3
    }
  }, "post@ya.no")));
}
ThankYouPage.propTypes = {
  name: PropTypes.string.isRequired,
  accountNumber: PropTypes.string.isRequired
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$b() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var primaryGreen$2 = colors$1.primaryGreen,
  secondaryGreen$1 = colors$1.secondaryGreen,
  white$1 = colors$1.white;
var LeftCol = createStyled("div", "development" === "production" ? {
  target: "e181qdkr5"
} : {
  target: "e181qdkr5",
  label: "LeftCol"
})("development" === "production" ? {
  name: "11pbljn",
  styles: "display:grid;grid-template-columns:99fr 1fr;.left-col-content{margin:auto;}"
} : {
  name: "11pbljn",
  styles: "display:grid;grid-template-columns:99fr 1fr;.left-col-content{margin:auto;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
});
var StepNumberIcon$1 = createStyled("div", "development" === "production" ? {
  target: "e181qdkr4"
} : {
  target: "e181qdkr4",
  label: "StepNumberIcon"
})("box-sizing:border-box;margin:auto;border-radius:50%;width:45px;height:45px;background:", function (props) {
  return props.completed ? secondaryGreen$1 : white$1;
}, ";border:1px solid ", primaryGreen$2, ";color:", function (props) {
  return props.completed ? white$1 : primaryGreen$2;
}, ";text-align:center;font-size:200%;line-height:45px;font-weight:bold;" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var RightCol = createStyled("div", "development" === "production" ? {
  target: "e181qdkr3"
} : {
  target: "e181qdkr3",
  label: "RightCol"
})("display:grid;.centered{margin:auto 0;display:grid;.main-title{padding-left:20px;padding-bottom:10px;font-weight:bold;@media only screen and (max-width: 600px){margin:0;}}.status-text-title{padding-left:20px;}}.toggle-collapse-span{cursor:pointer;color:", primaryGreen$2, ";font-weight:bold;position:absolute;top:130px;right:10px;}" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var MainRowContainer = createStyled("div", "development" === "production" ? {
  target: "e181qdkr2"
} : {
  target: "e181qdkr2",
  label: "MainRowContainer"
})("development" === "production" ? {
  name: "2jtoo3",
  styles: "height:160px;display:grid;grid-template-columns:25fr 75fr;gap:10px"
} : {
  name: "2jtoo3",
  styles: "height:160px;display:grid;grid-template-columns:25fr 75fr;gap:10px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN0ZXBJdGVtLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUErRG1DIiwiZmlsZSI6IlN0ZXBJdGVtLmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyB1c2VTdGF0ZSB9IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCI7XG5pbXBvcnQgeyBGb250QXdlc29tZUljb24gfSBmcm9tIFwiQGZvcnRhd2Vzb21lL3JlYWN0LWZvbnRhd2Vzb21lXCI7XG5pbXBvcnQgeyBmYUNoZXZyb25VcCwgZmFDaGV2cm9uRG93biB9IGZyb20gXCJAZm9ydGF3ZXNvbWUvZnJlZS1zb2xpZC1zdmctaWNvbnNcIjtcblxuaW1wb3J0IENvbGxhcHNlIGZyb20gXCIuLi8uLi91aS9jb2xsYXBzZVwiO1xuaW1wb3J0IGNvbG9ycyBmcm9tIFwiLi4vLi4vLi4vY29sb3JzXCI7XG5cbmltcG9ydCB7IFN0YXR1c1ByZVRleHQgfSBmcm9tIFwiLi4vc2hhcmVkL3NoYXJlZFN0eWxlZENvbXBvbmVudHNcIjtcbmltcG9ydCBTdGVwSXRlbUNvbnRhaW5lciBmcm9tIFwiLi4vc2hhcmVkL1N0ZXBJdGVtQ29udGFpbmVyXCI7XG5cbmNvbnN0IHsgcHJpbWFyeUdyZWVuLCBzZWNvbmRhcnlHcmVlbiwgd2hpdGUgfSA9IGNvbG9ycztcblxuY29uc3QgTGVmdENvbCA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGdyaWQ7XG4gIGdyaWQtdGVtcGxhdGUtY29sdW1uczogOTlmciAxZnI7XG4gIC5sZWZ0LWNvbC1jb250ZW50IHtcbiAgICBtYXJnaW46IGF1dG87XG4gIH1cbmA7XG5jb25zdCBTdGVwTnVtYmVySWNvbiA9IHN0eWxlZC5kaXZgXG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gIG1hcmdpbjogYXV0bztcbiAgYm9yZGVyLXJhZGl1czogNTAlO1xuICB3aWR0aDogNDVweDtcbiAgaGVpZ2h0OiA0NXB4O1xuICBiYWNrZ3JvdW5kOiAkeyhwcm9wcykgPT4gKHByb3BzLmNvbXBsZXRlZCA/IHNlY29uZGFyeUdyZWVuIDogd2hpdGUpfTtcbiAgYm9yZGVyOiAxcHggc29saWQgJHtwcmltYXJ5R3JlZW59O1xuICBjb2xvcjogJHsocHJvcHMpID0+IChwcm9wcy5jb21wbGV0ZWQgPyB3aGl0ZSA6IHByaW1hcnlHcmVlbil9O1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gIGZvbnQtc2l6ZTogMjAwJTtcbiAgbGluZS1oZWlnaHQ6IDQ1cHg7XG4gIGZvbnQtd2VpZ2h0OiBib2xkO1xuYDtcbmNvbnN0IFJpZ2h0Q29sID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogZ3JpZDtcblxuICAuY2VudGVyZWQge1xuICAgIG1hcmdpbjogYXV0byAwO1xuICAgIGRpc3BsYXk6IGdyaWQ7XG4gICAgLm1haW4tdGl0bGUge1xuICAgICAgcGFkZGluZy1sZWZ0OiAyMHB4O1xuICAgICAgcGFkZGluZy1ib3R0b206IDEwcHg7XG4gICAgICBmb250LXdlaWdodDogYm9sZDtcbiAgICAgIEBtZWRpYSBvbmx5IHNjcmVlbiBhbmQgKG1heC13aWR0aDogNjAwcHgpIHtcbiAgICAgICAgbWFyZ2luOiAwO1xuICAgICAgfVxuICAgIH1cbiAgICAuc3RhdHVzLXRleHQtdGl0bGUge1xuICAgICAgcGFkZGluZy1sZWZ0OiAyMHB4O1xuICAgIH1cbiAgfVxuICAudG9nZ2xlLWNvbGxhcHNlLXNwYW4ge1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgICBjb2xvcjogJHtwcmltYXJ5R3JlZW59O1xuICAgIGZvbnQtd2VpZ2h0OiBib2xkO1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICB0b3A6IDEzMHB4O1xuICAgIHJpZ2h0OiAxMHB4O1xuICB9XG5gO1xuXG5jb25zdCBNYWluUm93Q29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgaGVpZ2h0OiAxNjBweDtcbiAgZGlzcGxheTogZ3JpZDtcbiAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiAyNWZyIDc1ZnI7XG4gIGdhcDogMTBweDtcbmA7XG5jb25zdCBIZWFkZXJEZXZpZGVyID0gc3R5bGVkLmRpdmBcbiAgYm9yZGVyLWxlZnQ6IDFweCBzb2xpZCBsaWdodGdyZXk7XG4gIGhlaWdodDogMTIwcHg7XG4gIG1hcmdpbi10b3A6IGF1dG87XG4gIG1hcmdpbi1ib3R0b206IGF1dG87XG5gO1xuXG5jb25zdCBDb2xsYXBzZUJ1dHRvbiA9IHN0eWxlZC5idXR0b25gXG4gIGJhY2tncm91bmQ6IG5vbmU7XG4gIGJvcmRlcjogbm9uZTtcbiAgcGFkZGluZzogMDtcbiAgY3Vyc29yOiBwb2ludGVyO1xuICBvdXRsaW5lOiBpbmhlcml0O1xuICBmb250LXNpemU6IGluaGVyaXQ7XG4gIGZvbnQtd2VpZ2h0OiA2MDA7XG5gO1xuXG5mdW5jdGlvbiBTdGVwSXRlbShwcm9wcykge1xuICBjb25zdCB7XG4gICAgc3RlcE5yLFxuICAgIG1haW5UaXRsZSxcbiAgICBzdGF0dXNUZXh0LFxuICAgIHN0YXR1c1RleHRHcmV5VGV4dCxcbiAgICBleHBhbmRDbGlja0Rlc2NyaXB0aW9uLFxuICAgIGV4cGFuZGFibGVDb250ZW50LFxuICAgIGNvbXBsZXRlZCxcbiAgICBleHBhbmRhYmxlLFxuICAgIGlzQ3VycmVudFN0ZXAsXG4gICAgaGlkZGVuLFxuICAgIGFsbFZpc2libGVTdGVwc0NvdW50LFxuICB9ID0gcHJvcHM7XG5cbiAgY29uc3QgW2lzRXhwYW5kZWQsIHNldElzRXhwYW5kZWRdID0gdXNlU3RhdGUoZmFsc2UpO1xuXG4gIGlmIChoaWRkZW4pIHJldHVybiBudWxsO1xuICBjb25zdCB0b2dnbGVFeHBhbmRlZCA9ICgpID0+IHtcbiAgICBzZXRJc0V4cGFuZGVkKCFpc0V4cGFuZGVkKTtcbiAgfTtcblxuICByZXR1cm4gKFxuICAgIDxTdGVwSXRlbUNvbnRhaW5lciBpc0N1cnJlbnRTdGVwPXtpc0N1cnJlbnRTdGVwfT5cbiAgICAgIDxNYWluUm93Q29udGFpbmVyPlxuICAgICAgICA8TGVmdENvbD5cbiAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cImxlZnQtY29sLWNvbnRlbnRcIj5cbiAgICAgICAgICAgIDxTdGVwTnVtYmVySWNvbiBjb21wbGV0ZWQ9e2NvbXBsZXRlZH0+e3N0ZXBOcn08L1N0ZXBOdW1iZXJJY29uPlxuICAgICAgICAgICAgPHAgc3R5bGU9e3sgbWFyZ2luVG9wOiBcIjFyZW1cIiB9fT5cbiAgICAgICAgICAgICAgU3RlZyB7c3RlcE5yfSBhdiB7YWxsVmlzaWJsZVN0ZXBzQ291bnR9XG4gICAgICAgICAgICA8L3A+XG4gICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgPEhlYWRlckRldmlkZXIgLz5cbiAgICAgICAgPC9MZWZ0Q29sPlxuICAgICAgICA8UmlnaHRDb2w+XG4gICAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJjZW50ZXJlZFwiPlxuICAgICAgICAgICAgPGgzIGNsYXNzTmFtZT1cIm1haW4tdGl0bGVcIj57bWFpblRpdGxlfTwvaDM+XG4gICAgICAgICAgICA8c3BhbiBjbGFzc05hbWU9XCJzdGF0dXMtdGV4dC10aXRsZVwiPlxuICAgICAgICAgICAgICA8U3RhdHVzUHJlVGV4dCBmb250V2VpZ2h0PVwiYm9sZFwiIGNvbXBsZXRlZD17Y29tcGxldGVkfT5cbiAgICAgICAgICAgICAgICB7c3RhdHVzVGV4dH1cbiAgICAgICAgICAgICAgPC9TdGF0dXNQcmVUZXh0PlxuICAgICAgICAgICAgICA8c3Bhbj57c3RhdHVzVGV4dEdyZXlUZXh0fTwvc3Bhbj5cbiAgICAgICAgICAgIDwvc3Bhbj5cbiAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICB7ZXhwYW5kYWJsZSAmJiAoXG4gICAgICAgICAgICA8Q29sbGFwc2VCdXR0b24gY2xhc3NOYW1lPVwidG9nZ2xlLWNvbGxhcHNlLXNwYW5cIiBvbkNsaWNrPXt0b2dnbGVFeHBhbmRlZH0+XG4gICAgICAgICAgICAgIHtpc0V4cGFuZGVkID8gXCJMdWtrXCIgOiBleHBhbmRDbGlja0Rlc2NyaXB0aW9ufXtcIiBcIn1cbiAgICAgICAgICAgICAgPEZvbnRBd2Vzb21lSWNvbiBpY29uPXtpc0V4cGFuZGVkID8gZmFDaGV2cm9uVXAgOiBmYUNoZXZyb25Eb3dufSAvPlxuICAgICAgICAgICAgPC9Db2xsYXBzZUJ1dHRvbj5cbiAgICAgICAgICApfVxuICAgICAgICA8L1JpZ2h0Q29sPlxuICAgICAgPC9NYWluUm93Q29udGFpbmVyPlxuICAgICAgPENvbGxhcHNlIGlzT3Blbj17aXNFeHBhbmRlZH0+e2V4cGFuZGFibGVDb250ZW50fTwvQ29sbGFwc2U+XG4gICAgPC9TdGVwSXRlbUNvbnRhaW5lcj5cbiAgKTtcbn1cblN0ZXBJdGVtLnByb3BUeXBlcyA9IHtcbiAgc3RlcE5yOiBQcm9wVHlwZXMubnVtYmVyLmlzUmVxdWlyZWQsXG4gIG1haW5UaXRsZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBzdGF0dXNUZXh0OiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHN0YXR1c1RleHRHcmV5VGV4dDogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBleHBhbmRDbGlja0Rlc2NyaXB0aW9uOiBQcm9wVHlwZXMuc3RyaW5nLFxuICBleHBhbmRhYmxlQ29udGVudDogUHJvcFR5cGVzLmVsZW1lbnQuaXNSZXF1aXJlZCxcbiAgY29tcGxldGVkOiBQcm9wVHlwZXMuYm9vbC5pc1JlcXVpcmVkLFxuICBleHBhbmRhYmxlOiBQcm9wVHlwZXMuYm9vbC5pc1JlcXVpcmVkLFxuICBpc0N1cnJlbnRTdGVwOiBQcm9wVHlwZXMuYm9vbC5pc1JlcXVpcmVkLFxuICBoaWRkZW46IFByb3BUeXBlcy5ib29sLmlzUmVxdWlyZWQsXG4gIGFsbFZpc2libGVTdGVwc0NvdW50OiBQcm9wVHlwZXMubnVtYmVyLmlzUmVxdWlyZWQsXG59O1xuXG5TdGVwSXRlbS5kZWZhdWx0UHJvcHMgPSB7XG4gIGV4cGFuZENsaWNrRGVzY3JpcHRpb246IFwiXCIsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBTdGVwSXRlbTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
});
var HeaderDevider = createStyled("div", "development" === "production" ? {
  target: "e181qdkr1"
} : {
  target: "e181qdkr1",
  label: "HeaderDevider"
})("development" === "production" ? {
  name: "618sjr",
  styles: "border-left:1px solid lightgrey;height:120px;margin-top:auto;margin-bottom:auto"
} : {
  name: "618sjr",
  styles: "border-left:1px solid lightgrey;height:120px;margin-top:auto;margin-bottom:auto",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
});
var CollapseButton = createStyled("button", "development" === "production" ? {
  target: "e181qdkr0"
} : {
  target: "e181qdkr0",
  label: "CollapseButton"
})("development" === "production" ? {
  name: "1jn7n5b",
  styles: "background:none;border:none;padding:0;cursor:pointer;outline:inherit;font-size:inherit;font-weight:600"
} : {
  name: "1jn7n5b",
  styles: "background:none;border:none;padding:0;cursor:pointer;outline:inherit;font-size:inherit;font-weight:600",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
});
function StepItem(props) {
  var stepNr = props.stepNr,
    mainTitle = props.mainTitle,
    statusText = props.statusText,
    statusTextGreyText = props.statusTextGreyText,
    expandClickDescription = props.expandClickDescription,
    expandableContent = props.expandableContent,
    completed = props.completed,
    expandable = props.expandable,
    isCurrentStep = props.isCurrentStep,
    hidden = props.hidden,
    allVisibleStepsCount = props.allVisibleStepsCount;
  var _useState = useState(false),
    _useState2 = _slicedToArray$2(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  if (hidden) return null;
  var toggleExpanded = function toggleExpanded() {
    setIsExpanded(!isExpanded);
  };
  return /*#__PURE__*/React__default.createElement(StepItemContainer, {
    isCurrentStep: isCurrentStep
  }, /*#__PURE__*/React__default.createElement(MainRowContainer, null, /*#__PURE__*/React__default.createElement(LeftCol, null, /*#__PURE__*/React__default.createElement("div", {
    className: "left-col-content"
  }, /*#__PURE__*/React__default.createElement(StepNumberIcon$1, {
    completed: completed
  }, stepNr), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginTop: "1rem"
    }
  }, "Steg ", stepNr, " av ", allVisibleStepsCount)), /*#__PURE__*/React__default.createElement(HeaderDevider, null)), /*#__PURE__*/React__default.createElement(RightCol, null, /*#__PURE__*/React__default.createElement("div", {
    className: "centered"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "main-title"
  }, mainTitle), /*#__PURE__*/React__default.createElement("span", {
    className: "status-text-title"
  }, /*#__PURE__*/React__default.createElement(StatusPreText, {
    fontWeight: "bold",
    completed: completed
  }, statusText), /*#__PURE__*/React__default.createElement("span", null, statusTextGreyText))), expandable && /*#__PURE__*/React__default.createElement(CollapseButton, {
    className: "toggle-collapse-span",
    onClick: toggleExpanded
  }, isExpanded ? "Lukk" : expandClickDescription, " ", /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: isExpanded ? faChevronUp : faChevronDown
  })))), /*#__PURE__*/React__default.createElement(Collapse, {
    isOpen: isExpanded
  }, expandableContent));
}
StepItem.propTypes = {
  stepNr: PropTypes.number.isRequired,
  mainTitle: PropTypes.string.isRequired,
  statusText: PropTypes.string.isRequired,
  statusTextGreyText: PropTypes.string.isRequired,
  expandClickDescription: PropTypes.string,
  expandableContent: PropTypes.element.isRequired,
  completed: PropTypes.bool.isRequired,
  expandable: PropTypes.bool.isRequired,
  isCurrentStep: PropTypes.bool.isRequired,
  hidden: PropTypes.bool.isRequired,
  allVisibleStepsCount: PropTypes.number.isRequired
};
StepItem.defaultProps = {
  expandClickDescription: ""
};

createStyled("button", "development" === "production" ? {
  target: "egy3ijm0"
} : {
  target: "egy3ijm0",
  label: "BankIdImageButton"
})("background:none;border:none;padding:0;outline:inherit;background:url(", function (_ref) {
  var imgSrc = _ref.imgSrc;
  return imgSrc;
}, ") no-repeat center;width:100px;height:100px;" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
({
  src: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
});
var IDENTIFICATION_METHOD = {
  BANKID: "BANKID"
};
function SignLoanAgreement(props) {
  var chooseIdentificationMethod = props.chooseIdentificationMethod;
  var displayErrorContext = useContext(DisplayErrorsSigningContext);
  return /*#__PURE__*/React__default.createElement(StepContentContainer$1, null, /*#__PURE__*/React__default.createElement(StepSectionHeader$1, null, /*#__PURE__*/React__default.createElement(StatusPreText, null, "1"), "Signer dokument"), /*#__PURE__*/React__default.createElement(SimpleErrorLabel, {
    errorText: displayErrorContext.chooseIdentificationMethod,
    positionAbsoluteHorizontallyCenter: true
  }), /*#__PURE__*/React__default.createElement(StepSectionParagraph$1, null, "Her signerer du gjeldsbrevet som er l\xE5neavtalen mellom deg og Resurs Bank:"), /*#__PURE__*/React__default.createElement(BigButton, {
    onClick: function onClick() {
      return chooseIdentificationMethod(IDENTIFICATION_METHOD.BANKID);
    },
    type: "button"
  }, "Signer med BankID"));
}
SignLoanAgreement.propTypes = {
  chooseIdentificationMethod: PropTypes.func.isRequired
};

var useTempPaymentAuthorizationError = function useTempPaymentAuthorizationError(paymentAuthorizationError, loansToRefinanceState, accountNumber, loansToRefinance) {
  var _useState = useState({
      /*
         accountNrInput: '',
         ['accountNr-0']: '',
         ['bank-0']: '',
         ['debt-0']: '',
         ['kidOrMessage-0']: '',
         ['productType-0']: '',
         ['nominalInterest-0']: '',
         etc 
         */
    }),
    _useState2 = _slicedToArray$2(_useState, 2),
    validationState = _useState2[0],
    setValidationState = _useState2[1];
  useEffect(function () {
    if (!paymentAuthorizationError) return;
    var message = paymentAuthorizationError.message,
      errorMessages = paymentAuthorizationError.errorMessages,
      code = paymentAuthorizationError.code;
    if (code !== 400 || message !== "Valideringsfeil") return;
    var updatedValidationState = {};
    errorMessages.forEach(function (_ref) {
      var errorMessage = _ref.errorMessage,
        errorParams = _ref.errorParams,
        errorId = _ref.errorId;
      var _errorParams = _slicedToArray$2(errorParams, 2),
        fieldDisplayName = _errorParams[0],
        errorFieldValue = _errorParams[1];
      if (fieldDisplayName === "Kontonummer dok i retur") return; // consider as duplicate

      var invalidFieldName = "";
      switch (errorId) {
        case "errors.accountNumber":
          {
            loansToRefinanceState.forEach(function (loan, i) {
              var hasSameValueAsError = loan.accountNr === errorFieldValue;
              var isNotHandeledYet = !updatedValidationState["accountNr-".concat(i)];
              if (hasSameValueAsError && isNotHandeledYet) {
                invalidFieldName = "accountNr-".concat(i);
              }
            });
            // if it wasnt account number of a refinance loan, it migtht be the 'usual' account number
            if (!invalidFieldName && accountNumber === errorFieldValue && !updatedValidationState.accountNumber) {
              invalidFieldName = "accountNumber";
            }
            break;
          }
        case "errors.amountLargerThanOtherAmount":
          {
            loansToRefinanceState.forEach(function (loan, i) {
              var fieldHasChanged = Number(loan.debt) > Number(loansToRefinance[i].debt);
              var isNotHandeledYet = !updatedValidationState["debt-".concat(i)];
              if (fieldHasChanged && isNotHandeledYet) {
                invalidFieldName = "debt-".concat(i);
              }
            });
            break;
          }
      }
      if (invalidFieldName) {
        updatedValidationState[invalidFieldName] = errorMessage;
      }
    });
    setValidationState(function (prev) {
      return _objectSpread2$4(_objectSpread2$4({}, prev), updatedValidationState);
    });
  }, [accountNumber, loansToRefinance, loansToRefinanceState, paymentAuthorizationError]);
  return {
    validationState: validationState
  };
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$a() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var AccountInfoInputContainer = createStyled("div", "development" === "production" ? {
  target: "eudctpd0"
} : {
  target: "eudctpd0",
  label: "AccountInfoInputContainer"
})("development" === "production" ? {
  name: "3plvx2",
  styles: "margin-bottom:20px;text-align:center;label{display:block;text-align:center;font-weight:bold;}"
} : {
  name: "3plvx2",
  styles: "margin-bottom:20px;text-align:center;label{display:block;text-align:center;font-weight:bold;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkFjY291bnRJbmZvSW5wdXRDb250YWluZXIuanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUU0QyIsImZpbGUiOiJBY2NvdW50SW5mb0lucHV0Q29udGFpbmVyLmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiO1xuXG5jb25zdCBBY2NvdW50SW5mb0lucHV0Q29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgbWFyZ2luLWJvdHRvbTogMjBweDtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuXG4gIGxhYmVsIHtcbiAgICBkaXNwbGF5OiBibG9jaztcbiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gICAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gIH1cbmA7XG5leHBvcnQgZGVmYXVsdCBBY2NvdW50SW5mb0lucHV0Q29udGFpbmVyO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$a
});

var lightGrey = colors$1.lightGrey;
var MAX_RECEIVER_LENGTH = 50;
function AccountInfo(_ref, forwardRefProp) {
  var loanToRefinance = _ref.loanToRefinance,
    index = _ref.index,
    creditors = _ref.creditors,
    validateKidAndAccount = _ref.validateKidAndAccount;
  var accountNr = loanToRefinance.accountNr,
    bank = loanToRefinance.bank,
    debt = loanToRefinance.debt,
    kidOrMessage = loanToRefinance.kidOrMessage,
    locked = loanToRefinance.locked,
    _loanToRefinance$shal = loanToRefinance.shallRefinance,
    shallRefinance = _loanToRefinance$shal === void 0 ? true : _loanToRefinance$shal,
    _loanToRefinance$nomi = loanToRefinance.nominalInterest,
    nominalInterest = _loanToRefinance$nomi === void 0 ? "" : _loanToRefinance$nomi,
    productType = loanToRefinance.productType;
  var _useState = useState(""),
    _useState2 = _slicedToArray$2(_useState, 2),
    accountErrorText = _useState2[0],
    setAccountErrorText = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray$2(_useState3, 2),
    kidErrorText = _useState4[0],
    setKidErrorText = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray$2(_useState5, 2),
    receiverErrorText = _useState6[0],
    setReceiverErrorText = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray$2(_useState7, 2),
    amountErrorText = _useState8[0],
    setAmountErrorText = _useState8[1];
  var _useState9 = useState(accountNr),
    _useState10 = _slicedToArray$2(_useState9, 2),
    account = _useState10[0],
    setAccount = _useState10[1];
  var _useState11 = useState(bank),
    _useState12 = _slicedToArray$2(_useState11, 2),
    receiverState = _useState12[0],
    setReceiverState = _useState12[1];
  var _useState13 = useState(debt),
    _useState14 = _slicedToArray$2(_useState13, 2),
    amount = _useState14[0],
    setAmount = _useState14[1];
  var _useState15 = useState(kidOrMessage),
    _useState16 = _slicedToArray$2(_useState15, 2),
    kid = _useState16[0],
    setKid = _useState16[1];
  var _useState17 = useState(!shallRefinance),
    _useState18 = _slicedToArray$2(_useState17, 2),
    noRefinance = _useState18[0],
    setNoRefinance = _useState18[1];
  var updateAmountErrorText = function updateAmountErrorText() {
    var MAX_LOAN_AMOUNT = 20000000;
    if (noRefinance) {
      setAmountErrorText("");
      return true;
    }
    var text = "";
    if (amount === "") {
      text = "Feltet må fylles ut";
    } else if (parseInt(amount, 10) <= 0) {
      text = "Beløpet må være større enn 0";
    } else if (!/^[1-9]\d*$/.test(amount)) {
      text = "Du kan kun bruke siffer";
    } else if (parseInt(amount, 10) > MAX_LOAN_AMOUNT) {
      text = "Bel\xF8pet m\xE5 v\xE6re mindre enn ".concat(MAX_LOAN_AMOUNT.toLocaleString("no"));
    }
    setAmountErrorText(text);
    return text === "";
  };
  var updateReceiverErrorText = function updateReceiverErrorText() {
    var text = "";
    if (noRefinance) {
      return true;
    }
    if (receiverState.length > MAX_RECEIVER_LENGTH) {
      text = "Feltet kan ikke v\xE6re mer enn ".concat(MAX_RECEIVER_LENGTH, " tegn");
    } else {
      text = receiverState === "" ? "Feltet må fylles ut" : "";
    }
    setReceiverErrorText(text);
    return text === "";
  };
  var updateKidAndAccount = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var response, _response$data, kidOk, accountOk, foundCreditor;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!noRefinance) {
                _context.next = 4;
                break;
              }
              setAccountErrorText("");
              setKidErrorText("");
              return _context.abrupt("return", true);
            case 4:
              if (!(account.length !== 11)) {
                _context.next = 8;
                break;
              }
              setAccountErrorText("Legg inn kontonr 11 siffer");
              setKidErrorText("");
              return _context.abrupt("return", false);
            case 8:
              _context.next = 10;
              return validateKidAndAccount(account, kid);
            case 10:
              response = _context.sent;
              if (response.statusOk) {
                _context.next = 15;
                break;
              }
              setAccountErrorText("Teknisk feil - mislyktes ved validering");
              setKidErrorText("Teknisk feil - mislyktes ved validering");
              return _context.abrupt("return", false);
            case 15:
              _response$data = response.data, kidOk = _response$data.kidOk, accountOk = _response$data.accountOk;
              setAccountErrorText(accountOk ? "" : "Vennligst oppgi gyldig kontonummer");
              setKidErrorText(kidOk ? "" : "Vennligst oppgi gyldig kid nummer");
              if (accountOk) {
                foundCreditor = creditors.find(function (creditor) {
                  return creditor.accountNumbersAndPrefixes.includes(account);
                });
                if (foundCreditor) {
                  setReceiverState(foundCreditor.creditorName);
                  setReceiverErrorText("");
                }
              }
              return _context.abrupt("return", accountOk && kidOk);
            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function updateKidAndAccount() {
      return _ref2.apply(this, arguments);
    };
  }();
  var validate = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var amountOk, receiverOk, kidAndAccountOk, isValid;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              amountOk = updateAmountErrorText();
              receiverOk = updateReceiverErrorText();
              _context2.next = 4;
              return updateKidAndAccount();
            case 4:
              kidAndAccountOk = _context2.sent;
              isValid = amountOk && receiverOk && kidAndAccountOk; // {useLoan, isValid, loan}
              return _context2.abrupt("return", {
                useLoan: !noRefinance,
                isValid: isValid,
                loan: _objectSpread2$4(_objectSpread2$4({}, loanToRefinance), {}, {
                  accountNr: account,
                  bank: receiverState,
                  debt: amount,
                  kidOrMessage: kid,
                  shallRefinance: !noRefinance
                })
              });
            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function validate() {
      return _ref3.apply(this, arguments);
    };
  }();
  useImperativeHandle(forwardRefProp, function () {
    return {
      validate: validate
    };
  });
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: lightGrey,
      margin: "10px",
      padding: "10px 0",
      borderRadius: "5px"
    },
    key: index
  }, /*#__PURE__*/React__default.createElement(AccountInfoInputContainer, null, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "accountNr-".concat(index)
  }, "Kontonummer"), /*#__PURE__*/React__default.createElement(StandardInput, {
    type: "text",
    name: "accountNr-".concat(index),
    id: "accountNr-".concat(index),
    placeholder: "Skriv inn mottakers kontonummer",
    value: account,
    onChange: function onChange(e) {
      return setAccount(e.target.value);
    },
    onBlur: updateKidAndAccount,
    disabled: noRefinance
  }), /*#__PURE__*/React__default.createElement(SimpleErrorLabel, {
    errorText: accountErrorText
  })), /*#__PURE__*/React__default.createElement(AccountInfoInputContainer, null, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "bank-".concat(index)
  }, "Navn p\xE5 mottaker ", /*#__PURE__*/React__default.createElement("br", null), "(bank/finansieringsselskap)"), /*#__PURE__*/React__default.createElement(StandardInput, {
    type: "text",
    name: "bank-".concat(index),
    id: "bank-".concat(index),
    placeholder: "Skriv inn navn p\xE5 bank",
    value: receiverState,
    onChange: function onChange(e) {
      return setReceiverState(e.target.value);
    },
    onBlur: updateReceiverErrorText,
    disabled: noRefinance
  }), /*#__PURE__*/React__default.createElement(SimpleErrorLabel, {
    errorText: receiverErrorText
  })), /*#__PURE__*/React__default.createElement(AccountInfoInputContainer, null, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "debt-".concat(index)
  }, "L\xE5nebel\xF8p"), /*#__PURE__*/React__default.createElement(StandardInput, {
    type: "text",
    name: "debt-".concat(index),
    id: "debt-".concat(index),
    placeholder: "Skriv inn l\xE5nebel\xF8pet som skal innfris",
    value: amount,
    onChange: function onChange(e) {
      return setAmount(e.target.value);
    },
    onBlur: updateAmountErrorText,
    disabled: noRefinance
  }), /*#__PURE__*/React__default.createElement(SimpleErrorLabel, {
    errorText: amountErrorText
  })), /*#__PURE__*/React__default.createElement(AccountInfoInputContainer, null, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "kidOrMessage-".concat(index)
  }, "KID/Melding"), /*#__PURE__*/React__default.createElement(StandardInput, {
    type: "text",
    name: "kidOrMessage-".concat(index),
    id: "kidOrMessage-".concat(index),
    placeholder: "Skriv inn KID/melding",
    onChange: function onChange(e) {
      return setKid(e.target.value);
    },
    onBlur: updateKidAndAccount,
    disabled: noRefinance
  }), /*#__PURE__*/React__default.createElement(SimpleErrorLabel, {
    errorText: kidErrorText
  })), /*#__PURE__*/React__default.createElement(AccountInfoInputContainer, null, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "productType-".concat(index)
  }, "Produkt"), /*#__PURE__*/React__default.createElement(StandardSelect, {
    name: "productType-".concat(index),
    id: "productType-".concat(index),
    placeholder: "Velg produkt",
    defaultValue: productType,
    disabled: true
  }, /*#__PURE__*/React__default.createElement("option", {
    value: ""
  }, "Nedbetalingsl\xE5n"), /*#__PURE__*/React__default.createElement("option", {
    value: "CREDIT_CARD"
  }, "Rammekreditt"), /*#__PURE__*/React__default.createElement("option", {
    value: "UNSECURED_FLEXI_LOAN"
  }, "Rammekreditt"), /*#__PURE__*/React__default.createElement("option", {
    value: "CHARGE_CARD"
  }, "Faktureringskort"))), /*#__PURE__*/React__default.createElement(AccountInfoInputContainer, null, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "nominalInterest-".concat(index)
  }, "Nominell Rente"), /*#__PURE__*/React__default.createElement(StandardInput, {
    type: "text",
    name: "nominalInterest-".concat(index),
    id: "nominalInterest-".concat(index),
    placeholder: "Skriv inn nominell rente",
    value: nominalInterest,
    required: true,
    disabled: true
  })), !locked && /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React__default.createElement(StandardCheckbox, {
    type: "checkbox",
    name: "shallRefinance-".concat(index),
    id: "shallRefinance-".concat(index),
    style: {
      marginRight: "5px"
    },
    onChange: function onChange(e) {
      return setNoRefinance(e.target.checked);
    }
  }), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "shallRefinance-".concat(index)
  }, "Ikke refinansier dette l\xE5net")));
}
AccountInfo.propTypes = {
  loanToRefinance: PropTypes.arrayOf(PropTypes.shape({
    accountNr: PropTypes.string,
    bank: PropTypes.string,
    creditAdjustmentExistingLoanId: PropTypes.number.isRequired,
    debt: PropTypes.number,
    kidOrMessage: PropTypes.string,
    locked: PropTypes.bool,
    shallRefinance: PropTypes.bool,
    nominalInterest: PropTypes.string,
    productType: PropTypes.string
  })).isRequired,
  index: PropTypes.number.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  creditors: PropTypes.arrayOf(PropTypes.object),
  validateKidAndAccount: PropTypes.func.isRequired
};
AccountInfo.defaultProps = {
  creditors: []
};
var AccountInfo$1 = /*#__PURE__*/forwardRef(AccountInfo);

function AccountInfoList(props) {
  var submitPaymentAuthorization = props.submitPaymentAuthorization,
    loansToRefinance = props.loansToRefinance,
    creditors = props.creditors,
    fetchCreditors = props.fetchCreditors,
    validateKidAndAccount = props.validateKidAndAccount,
    accountNumber = props.accountNumber;
  var _useState = useState(accountNumber),
    _useState2 = _slicedToArray$2(_useState, 2),
    accountNumberFieldValue = _useState2[0],
    setAccountNumberFieldValue = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray$2(_useState3, 2),
    loansToRefinanceState = _useState4[0],
    setLoansToRefinanceState = _useState4[1];
  var displayErrorContext = useContext(DisplayErrorsSigningContext);
  var _useState5 = useState(""),
    _useState6 = _slicedToArray$2(_useState5, 2),
    accountErrorText = _useState6[0],
    setAccountErrorText = _useState6[1];
  var _useTempPaymentAuthor = useTempPaymentAuthorizationError(displayErrorContext === null || displayErrorContext === void 0 ? void 0 : displayErrorContext.paymentAuthorizationError, loansToRefinanceState, accountNumberFieldValue, loansToRefinance),
    validationState = _useTempPaymentAuthor.validationState;
  var validateAccount = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var response, accountOk;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(accountNumberFieldValue.length !== 11)) {
                _context.next = 3;
                break;
              }
              setAccountErrorText("Legg inn kontonr 11 siffer");
              return _context.abrupt("return", false);
            case 3:
              _context.next = 5;
              return validateKidAndAccount(accountNumberFieldValue, "");
            case 5:
              response = _context.sent;
              if (response.statusOk) {
                _context.next = 9;
                break;
              }
              setAccountErrorText("Teknisk feil - mislyktes ved validering");
              return _context.abrupt("return", false);
            case 9:
              accountOk = response.data.accountOk;
              setAccountErrorText(accountOk ? "" : "Vennligst oppgi gyldig kontonummer");
              return _context.abrupt("return", accountOk);
            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function validateAccount() {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(function () {
    fetchCreditors();
  }, [fetchCreditors]);
  useEffect(function () {
    var loansToRefinanceFixed = Array.isArray(loansToRefinance) ? _toConsumableArray$3(loansToRefinance) : [];
    loansToRefinanceFixed = loansToRefinanceFixed.map(function (loan) {
      return _objectSpread2$4({}, loan);
    });
    setLoansToRefinanceState(loansToRefinanceFixed);
  }, [loansToRefinance, setLoansToRefinanceState]);
  var accountInfos = [];
  var onSaveButtonClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
      var validateData, accountOk, invalidLoans, loansToSubmit;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              e.preventDefault();
              // {useLoan, isValid, loan}
              _context2.next = 3;
              return Promise.all(accountInfos.map(function (info) {
                return info.validate();
              }));
            case 3:
              validateData = _context2.sent;
              _context2.next = 6;
              return validateAccount();
            case 6:
              accountOk = _context2.sent;
              invalidLoans = validateData.filter(function (data) {
                return data.useLoan && !data.isValid;
              });
              if (invalidLoans.length === 0 && accountOk) {
                loansToSubmit = validateData.map(function (data) {
                  return data.loan;
                });
                submitPaymentAuthorization(accountNumberFieldValue, loansToSubmit);
              }
            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function onSaveButtonClick(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var addAccountReference = function addAccountReference(element, index) {
    if (element !== null) {
      accountInfos[index] = element;
    }
  };
  var getLoansToRefinanceInputs = function getLoansToRefinanceInputs() {
    return loansToRefinanceState.map(function (loanToRefinance, index) {
      return /*#__PURE__*/React__default.createElement(AccountInfo$1, {
        loanToRefinance: loanToRefinance,
        key: loanToRefinance.creditAdjustmentExistingLoanId,
        index: index,
        ref: function ref(element) {
          return addAccountReference(element, index);
        },
        setLoansToRefinanceState: setLoansToRefinanceState,
        creditors: creditors,
        validateKidAndAccount: validateKidAndAccount
      });
    });
  };
  return /*#__PURE__*/React__default.createElement(StepContentContainer$1, null, /*#__PURE__*/React__default.createElement(HorizontalDevider, null), /*#__PURE__*/React__default.createElement("form", {
    id: "fill-account-info-form"
  }, loansToRefinanceState.length > 0 && /*#__PURE__*/React__default.createElement(StepSectionParagraph$1, null, "Vennligst fyll ut informasjon om l\xE5n som skal refinansieres i tabellen nedenfor"), loansToRefinance.length > 0 && getLoansToRefinanceInputs(), loansToRefinanceState.length > 0 ? /*#__PURE__*/React__default.createElement(StepSectionHeader$1, null, "Hvilket kontonummer skal evt. restbel\xF8p overf\xF8res til?") : /*#__PURE__*/React__default.createElement(StepSectionHeader$1, null, /*#__PURE__*/React__default.createElement(StatusPreText, null, "1"), "Skriv inn det kontonummeret du \xF8nsker l\xE5net utbetalt til"), /*#__PURE__*/React__default.createElement(AccountInfoInputContainer, {
    inputWidth: "250px"
  }, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "accountNrInput"
  }, "Kontonr. 11 siffer"), /*#__PURE__*/React__default.createElement(StandardInput, {
    type: "text",
    name: "accountNrInput",
    id: "accountNrInput",
    placeholder: "xxxx xx xxxxx",
    onChange: function onChange(e) {
      return setAccountNumberFieldValue(e.target.value);
    },
    onBlur: validateAccount,
    value: accountNumberFieldValue
  }), /*#__PURE__*/React__default.createElement(SimpleErrorLabel, {
    errorText: accountErrorText
  })), /*#__PURE__*/React__default.createElement(StepSectionParagraph$1, null, "Ved refinansiering har Resurs Bank fullmakt til \xE5 innfri l\xE5n og kreditter med tiln\xE6rmede bel\xF8p til oppgitte kredittinstitusjoner/kreditorer, samt kontakte disse for avslutning/reduksjon av l\xE5n og kreditt der dette er p\xE5krevd."), /*#__PURE__*/React__default.createElement(BigButton, {
    onClick: onSaveButtonClick,
    type: "submit"
  }, "Lagre"), /*#__PURE__*/React__default.createElement(SimpleErrorLabel, {
    errorText: validationState.kid,
    positionAbsoluteHorizontallyCenter: true
  })));
}
AccountInfoList.propTypes = {
  loansToRefinance: PropTypes.arrayOf(PropTypes.shape({
    accountNr: PropTypes.string,
    bank: PropTypes.string,
    creditAdjustmentExistingLoanId: PropTypes.number.isRequired,
    debt: PropTypes.number,
    kidOrMessage: PropTypes.string,
    locked: PropTypes.bool,
    shallRefinance: PropTypes.bool,
    nominalInterest: PropTypes.string,
    productType: PropTypes.string
  })),
  submitPaymentAuthorization: PropTypes.func.isRequired,
  accountNumber: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  creditors: PropTypes.arrayOf(PropTypes.object),
  fetchCreditors: PropTypes.func.isRequired,
  validateKidAndAccount: PropTypes.func.isRequired
};
AccountInfoList.defaultProps = {
  loansToRefinance: [],
  accountNumber: "0",
  creditors: []
};

var uploadImg = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3C!DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg%20version%3D%221.1%22%20viewBox%3D%220%200%2064%2064%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%3Cpath%20d%3D%22M31%2048V3M16%2020L31%203l15%2016%22%20stroke-width%3D%222%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke%3D%22%23003c3c%22%20fill%3D%22none%22%20data-name%3D%22layer2%22%3E%3C%2Fpath%3E%20%20%3Cpath%20d%3D%22M8%2046v16h46V46%22%20stroke-width%3D%222%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke%3D%22%23003c3c%22%20fill%3D%22none%22%20data-name%3D%22layer1%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

function _EMOTION_STRINGIFIED_CSS_ERROR__$9() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var primaryGreen$1 = colors$1.primaryGreen;
var FetchFromAltinnBtnContainer$1 = createStyled("div", "development" === "production" ? {
  target: "e1oryvow5"
} : {
  target: "e1oryvow5",
  label: "FetchFromAltinnBtnContainer"
})("development" === "production" ? {
  name: "3k8zwm",
  styles: "text-align:center;button{font-size:18px;}"
} : {
  name: "3k8zwm",
  styles: "text-align:center;button{font-size:18px;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
});
var ToggleCollapseSpanContainer = createStyled("span", "development" === "production" ? {
  target: "e1oryvow4"
} : {
  target: "e1oryvow4",
  label: "ToggleCollapseSpanContainer"
})("cursor:pointer;color:", primaryGreen$1, ";font-weight:bold;float:right;text-align:right;width:100%;" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var CustomizedInputTypeFileContainer = createStyled("div", "development" === "production" ? {
  target: "e1oryvow3"
} : {
  target: "e1oryvow3",
  label: "CustomizedInputTypeFileContainer"
})("text-align:center;i{display:block;width:100%;height:20px;}svg{}&>button{width:400px;height:50px;color:", primaryGreen$1, ";border:1px solid ", primaryGreen$1, ";background-color:white;border-radius:0;position:relative;margin:auto 0;cursor:pointer;}img{position:absolute;right:8px;top:8px;width:30px;}" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var CustomizedPasswordInputContainer = createStyled("div", "development" === "production" ? {
  target: "e1oryvow2"
} : {
  target: "e1oryvow2",
  label: "CustomizedPasswordInputContainer"
})("text-align:center;input{text-align:center;width:400px;height:50px;border-radius:2px;border:1px solid #c3c3c3;position:relative;margin:auto 0;color:", primaryGreen$1, ";&:focus{border:1px solid ", primaryGreen$1, ";outline:0;}}" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var UploadButtonContainer = createStyled("div", "development" === "production" ? {
  target: "e1oryvow1"
} : {
  target: "e1oryvow1",
  label: "UploadButtonContainer"
})("development" === "production" ? {
  name: "1pu18zb",
  styles: "text-align:center;>*{padding:15px 60px;font-weight:bold;}"
} : {
  name: "1pu18zb",
  styles: "text-align:center;>*{padding:15px 60px;font-weight:bold;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
});
var CheckMarkContainer = createStyled("div", "development" === "production" ? {
  target: "e1oryvow0"
} : {
  target: "e1oryvow0",
  label: "CheckMarkContainer"
})("development" === "production" ? {
  name: "15y8v7p",
  styles: "background-color:#4fb576;width:42px;height:42px;border-radius:50%;padding:8px;margin:auto;margin-bottom:20px;text-align:center"
} : {
  name: "15y8v7p",
  styles: "background-color:#4fb576;width:42px;height:42px;border-radius:50%;padding:8px;margin:auto;margin-bottom:20px;text-align:center",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
});
var UPLOAD_OTHER_WORKAROUND_STATE = {
  NONE: "NONE",
  HAS_LOCAL_FILE: "HAS_LOCAL_FILE",
  GOT_SUCCESSFULL_RESPONSE: "GOT_SUCCESSFULL_RESPONSE"
};
function UploadFileComponent(props) {
  var text = props.text,
    id = props.id,
    stateValue = props.stateValue,
    stateSetter = props.stateSetter;
  var handleFileUploadButtonClick = function handleFileUploadButtonClick() {
    document.getElementById(id).click();
  };
  return /*#__PURE__*/React__default.createElement(CustomizedInputTypeFileContainer, null, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: handleFileUploadButtonClick
  }, text, /*#__PURE__*/React__default.createElement("img", {
    src: uploadImg,
    alt: "upload"
  })), /*#__PURE__*/React__default.createElement("input", {
    style: {
      display: "none"
    },
    type: "file",
    accept: "image/*,.pdf",
    id: id,
    value: "",
    multiple: true,
    onChange: function onChange(e) {
      stateSetter(_toConsumableArray$3(e.target.files));
    }
  }), /*#__PURE__*/React__default.createElement("i", null, stateValue.length ? stateValue.map(function (f) {
    return f.name;
  }).join(", ") : ""));
}
UploadFileComponent.propTypes = {
  text: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  stateValue: PropTypes.array.isRequired,
  stateSetter: PropTypes.func.isRequired
};
function UploadDocuments(props) {
  var uploadDocumentMultiple = props.uploadDocumentMultiple,
    documentTypesToInclude = props.documentTypesToInclude,
    uploadedDocuments = props.uploadedDocuments,
    getAltinnConsent = props.getAltinnConsent;
  var _useState = useState([]),
    _useState2 = _slicedToArray$2(_useState, 2),
    payCheckFiles = _useState2[0],
    setPayCheckFiles = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray$2(_useState3, 2),
    taxReturnFiles = _useState4[0],
    setTaxReturnFiles = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray$2(_useState5, 2),
    purchacedocumentFiles = _useState6[0],
    setPurchacedocumentFiles = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray$2(_useState7, 2),
    otherFiles = _useState8[0],
    setOtherFiles = _useState8[1];
  var _useState9 = useState(""),
    _useState10 = _slicedToArray$2(_useState9, 2),
    payCheckPassword = _useState10[0],
    setPayCheckPassword = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray$2(_useState11, 2),
    isExpanded = _useState12[0],
    setIsExpanded = _useState12[1];
  var _useState13 = useState(UPLOAD_OTHER_WORKAROUND_STATE.NONE),
    _useState14 = _slicedToArray$2(_useState13, 2),
    uploadOtherWorkaroundState = _useState14[0],
    setUploadOtherWorkaroundState = _useState14[1];
  var displayErrorContext = useContext(DisplayErrorsSigningContext);
  useEffect(function () {
    /*    This workaround checks if
              there was an upload of 
              'other files'. if the the 
              request was successful we 
              assume that 'other files'
              was uploaded, and therefor 
              gets a green check in ui.
              
              With this order we assume 
              that other files was uploaded:
              1. Had files in input[type="file"]
              2. Then has no files in input[type="file"]
              3. Getting new new response (if props.uploadedDocuments comes in)
        */
    if (otherFiles.length) {
      setUploadOtherWorkaroundState(UPLOAD_OTHER_WORKAROUND_STATE.HAS_LOCAL_FILE);
    } else if (uploadOtherWorkaroundState === UPLOAD_OTHER_WORKAROUND_STATE.HAS_LOCAL_FILE) {
      setUploadOtherWorkaroundState(UPLOAD_OTHER_WORKAROUND_STATE.GOT_SUCCESSFULL_RESPONSE);
    }
  }, [uploadOtherWorkaroundState, setUploadOtherWorkaroundState, otherFiles, uploadedDocuments]);
  var onUploadButtonClick = function onUploadButtonClick() {
    var paramsList = [];
    payCheckFiles.forEach(function (file) {
      paramsList.push([file, "paycheck", payCheckPassword]);
    });
    setPayCheckFiles([]);
    taxReturnFiles.forEach(function (file) {
      paramsList.push([file, "taxreturn"]);
    });
    setTaxReturnFiles([]);
    purchacedocumentFiles.forEach(function (file) {
      paramsList.push([file, "purchacedocument"]);
    });
    setTaxReturnFiles([]);
    otherFiles.forEach(function (file) {
      paramsList.push([file, "other"]);
    });
    setOtherFiles([]);
    // todo handle uploaded
    uploadDocumentMultiple(paramsList);
  };
  var renderFileUploadInputs = function renderFileUploadInputs() {
    return React__default.Children.toArray([].concat(_toConsumableArray$3(documentTypesToInclude), ["other"]).map(function (docType, index) {
      var foundDocInState = uploadedDocuments.find(function (doc) {
        return doc.type === docType;
      });
      var alreadyUploaded = foundDocInState && foundDocInState.documentState === "Received";
      var getHeader = function getHeader(headerText) {
        return /*#__PURE__*/React__default.createElement(StepSectionHeader$1, null, /*#__PURE__*/React__default.createElement(StatusPreText, null, index + 1), headerText);
      };
      var getCheckMark = function getCheckMark() {
        return /*#__PURE__*/React__default.createElement(CheckMarkContainer, null, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
          icon: faCheck,
          color: "#fff",
          size: "2x",
          style: {
            height: "100%"
          }
        }));
      };
      switch (docType) {
        case "paycheck":
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, getHeader("Last opp lønnsslipp"), /*#__PURE__*/React__default.createElement(StepSectionParagraph$1, null, "Last opp din siste l\xF8nnsslipp/n\xE6ringsoppgave. Er l\xF8nnsslippen passordbeskyttet kan du ta bilde av l\xF8nnsslippen eller s\xE5 kan du skrive inn passordet i feltet som heter \xABpassordet\xBB."), alreadyUploaded ? getCheckMark() : null, /*#__PURE__*/React__default.createElement(UploadFileComponent, {
            text: "Velg l\xF8nnsslipp",
            id: "paycheck",
            stateValue: payCheckFiles,
            stateSetter: setPayCheckFiles
          }), /*#__PURE__*/React__default.createElement(CustomizedPasswordInputContainer, null, /*#__PURE__*/React__default.createElement("input", {
            type: "text",
            placeholder: "Skriv \xABpassordet\xBB her",
            value: payCheckPassword,
            onChange: function onChange(e) {
              setPayCheckPassword(e.target.value);
            }
          })), /*#__PURE__*/React__default.createElement(HorizontalDevider, null));
        case "taxreturn":
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, getHeader("Last opp skattemelding"), /*#__PURE__*/React__default.createElement(StepSectionParagraph$1, null, "Vi trenger siste \xE5rs skattemelding. Denne finner du ved \xE5 logge deg inn p\xE5 p\xE5 altinn.no."), alreadyUploaded ? getCheckMark() : null, /*#__PURE__*/React__default.createElement(UploadFileComponent, {
            text: "Velg skattemelding",
            id: "taxreturn",
            stateValue: taxReturnFiles,
            stateSetter: setTaxReturnFiles
          }), /*#__PURE__*/React__default.createElement(HorizontalDevider, null));
        case "purchacedocument":
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, getHeader("Last opp Kjøpskontrakt"), /*#__PURE__*/React__default.createElement(StepSectionParagraph$1, null, "Kj\xF8pekontrakt kan ogs\xE5 sendes oss innen 30 dager etter at l\xE5net er utbetalt"), alreadyUploaded ? getCheckMark() : null, /*#__PURE__*/React__default.createElement(UploadFileComponent, {
            text: "Velg Kj\xF8pskontrakt",
            id: "purchacedocument",
            stateValue: purchacedocumentFiles,
            stateSetter: setPurchacedocumentFiles
          }), /*#__PURE__*/React__default.createElement(HorizontalDevider, null));
        case "other":
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, getHeader("Last opp Annet"), /*#__PURE__*/React__default.createElement(StepSectionParagraph$1, null, "Andre dokumenter"), uploadOtherWorkaroundState === UPLOAD_OTHER_WORKAROUND_STATE.GOT_SUCCESSFULL_RESPONSE ? getCheckMark() : null, /*#__PURE__*/React__default.createElement(UploadFileComponent, {
            text: "Velg Annet",
            id: "other",
            stateValue: otherFiles,
            stateSetter: setOtherFiles
          }), /*#__PURE__*/React__default.createElement(HorizontalDevider, null));
        default:
          return null;
      }
    }));
  };
  return /*#__PURE__*/React__default.createElement(StepContentContainer$1, null, /*#__PURE__*/React__default.createElement(HorizontalDevider, null), /*#__PURE__*/React__default.createElement(StepSectionHeader$1, null, "Hent dokumentasjon fra skatteetaten"), /*#__PURE__*/React__default.createElement(StepSectionParagraph$1, null, "Etter at du har gitt ditt samtykke, leverer Skatteetaten opplysninger om ditt skattegrunnlag og inntekt direkte til Resurs Bank. Opplysningene skal brukes \xE9n gang til behandling av din l\xE5nes\xF8knad."), /*#__PURE__*/React__default.createElement(FetchFromAltinnBtnContainer$1, null, /*#__PURE__*/React__default.createElement(Button, {
    label: "Hent dokumentasjon fra Altinn",
    onclick: getAltinnConsent,
    textAlign: "center",
    maxWidth: "22em"
  })), /*#__PURE__*/React__default.createElement(SimpleErrorLabel, {
    errorText: displayErrorContext.getAltinnConsent,
    positionAbsoluteHorizontallyCenter: true
  }), /*#__PURE__*/React__default.createElement(HorizontalDevider, null), /*#__PURE__*/React__default.createElement(StepSectionParagraph$1, null, "\xD8nsker du \xE5 l\xE5ste opp dokumentasjon manuelt?"), /*#__PURE__*/React__default.createElement(ToggleCollapseSpanContainer, {
    onClick: function onClick() {
      setIsExpanded(!isExpanded);
    }
  }, isExpanded ? "Lukk" : "Ja takk, vis meg mer informasjon", " ", /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: isExpanded ? faChevronUp : faChevronDown
  })), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Collapse, {
    style: {
      backgroundColor: "#ebe4ee",
      padding: "30px 0",
      margin: "0 20px"
    },
    isOpen: isExpanded
  }, renderFileUploadInputs(), /*#__PURE__*/React__default.createElement(StepSectionParagraph$1, null, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: primaryGreen$1
    }
  }, "Om du trenger \xE5 laste opp flere filer, hold nede ctrl mens du velger.")), /*#__PURE__*/React__default.createElement(UploadButtonContainer, null, /*#__PURE__*/React__default.createElement(BigButton, {
    type: "button",
    size: "lg",
    onClick: onUploadButtonClick
  }, "Last opp")), /*#__PURE__*/React__default.createElement(SimpleErrorLabel, {
    errorText: displayErrorContext.uploadDocument,
    positionAbsoluteHorizontallyCenter: true
  })));
}
UploadDocuments.propTypes = {
  documentTypesToInclude: PropTypes.arrayOf(PropTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  uploadedDocuments: PropTypes.array,
  uploadDocumentMultiple: PropTypes.func.isRequired,
  getAltinnConsent: PropTypes.func.isRequired
};
UploadDocuments.defaultProps = {
  documentTypesToInclude: [],
  uploadedDocuments: []
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$8() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var ItalicP = createStyled("p", "development" === "production" ? {
  target: "ei5n5d10"
} : {
  target: "ei5n5d10",
  label: "ItalicP"
})("development" === "production" ? {
  name: "32oux2",
  styles: "font-style:italic;margin-top:0.5rem;margin-bottom:2rem"
} : {
  name: "32oux2",
  styles: "font-style:italic;margin-top:0.5rem;margin-bottom:2rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$8
});
var loanAndCreditTexts = {
  GENERIC: {
    LOAN: "Vi i Resurs har nylig foretatt en kredittvurdering i forbindelse med din s\xF8knad p\xE5 l\xE5n.\n          Kredittvurderingen er basert p\xE5 informasjon du har oppgitt i s\xF8knaden, samt data innhentet\n          fra p\xE5litelige tredjeparter. V\xE5r kredittvurdering tar hensyn til flere faktorer, inkludert\n          din \xF8konomiske situasjon, inntekt, gjeldsbelastning, betalingshistorikk, og andre relevante\n          variabler. Basert p\xE5 v\xE5r grundige vurdering har vi kommet frem til at du er i:",
    CREDIT: "Vi i Resurs har nylig foretatt en kredittvurdering i forbindelse med din kreditts\xF8knad.\n          Kredittvurderingen er basert p\xE5 informasjon du har oppgitt i s\xF8knaden, samt data innhentet\n          fra p\xE5litelige tredjeparter. V\xE5r kredittvurdering tar hensyn til flere faktorer, inkludert\n          din \xF8konomiske situasjon, inntekt, gjeldsbelastning, betalingshistorikk, og andre relevante\n          variabler. Basert p\xE5 v\xE5r grundige vurdering har vi kommet frem til at du er i:"
  },
  POPUP: {
    LOAN: "Form\xE5let med de ulike kategoriene er \xE5 gj\xF8re det enklere for deg \xE5 vurdere den mulige\n          risikoen kredittavtalen kan utgj\xF8re for din personlige \xF8konomi. En kredittsjekk tar\n          ikke h\xF8yde for fremtidige forhold, eller planer som kan p\xE5virke din \xF8konomi. Vi\n          oppfordrer deg derfor til \xE5 bruke v\xE5r vurdering som en veiledning i din \xF8konomiske\n          beslutningsprosess. Vi setter pris p\xE5 at du valgte \xE5 s\xF8ke om l\xE5n hos Resurs, og vi ser\n          frem til \xE5 bist\xE5 deg med dine \xF8konomiske behov. Hvis du har noen \xF8vrige sp\xF8rsm\xE5l\n          ang\xE5ende din s\xF8knad, eller trenger ytterligere informasjon kan du kontakte oss p\xE5\n          telefon: 23 20 46 00 ",
    CREDIT: "Form\xE5let med de ulike kategoriene er \xE5 gj\xF8re det enklere for deg \xE5 vurdere den mulige\n          risikoen kredittavtalen kan utgj\xF8re for din personlige \xF8konomi. En kredittsjekk tar\n          ikke h\xF8yde for fremtidige forhold, eller planer som kan p\xE5virke din \xF8konomi. Vi\n          oppfordrer deg derfor til \xE5 bruke v\xE5r vurdering som en veiledning i din \xF8konomiske\n          beslutningsprosess. Vi setter pris p\xE5 at du valgte \xE5 s\xF8ke om kreditt hos Resurs, og vi ser\n          frem til \xE5 bist\xE5 deg med dine \xF8konomiske behov. Hvis du har noen \xF8vrige sp\xF8rsm\xE5l\n          ang\xE5ende din s\xF8knad, eller trenger ytterligere informasjon kan du kontakte oss p\xE5\n          telefon: 23 20 46 90 "
  }
};
var texts$1 = {
  GREEN: {
    colorInNorwegian: "Grønn",
    shortColorDescription: "Lav risiko, evne til å håndtere renteøkning.",
    longColorDescription: "Er du i grønn kategori, er det etter vår vurdering liten risiko for at du ikke kan overholde dine forpliktelser etter avtalen. Vi anser det samtidig som sannsynlig at du kan håndtere en vesentlig renteøkning med god margin.",
    colorToUse: "#00a515"
  },
  YELLOW: {
    colorInNorwegian: "Gul",
    shortColorDescription: "Akseptabel risiko og evne til å håndtere renteøkning.",
    longColorDescription: "Er du i gul kategori, er det etter vår vurdering liten, eller akseptabel risiko for at du ikke kan overholde dine forpliktelser etter avtalen. Vi anser det samtidig som at du antas å kunne håndtere en vesentlig renteøkning, eventuelt med moderate økonomiske omdisponeringer.",
    colorToUse: "#f9b900"
  },
  RED: {
    colorInNorwegian: "Rød",
    shortColorDescription: "Risiko for manglende overholdelse av forpliktelser.",
    longColorDescription: "Er du i rød kategori, er det etter vår vurdering risiko for at du ikke kan overholde dine forpliktelser etter avtalen. Vi anser det som at du må gjøre betydelige økonomiske omdisponeringer for å håndtere en vesentlig renteøkning.",
    colorToUse: "#f70005"
  }
};
function TrafficLightSection(props) {
  var trafficLightColor = props.trafficLightColor,
    type = props.type;
  if (trafficLightColor == null) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", null, " ", loanAndCreditTexts.GENERIC[type]), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "2rem"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: texts$1[trafficLightColor].colorToUse,
      fontWeight: 800
    }
  }, texts$1[trafficLightColor].colorInNorwegian, " kategori"), /*#__PURE__*/React__default.createElement(Popover, {
    id: "popover-traffic-light-info",
    text: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Etter finansavtaleloven skal resultatet av en kredittvurdering klassifisere og presentere i form av gr\xF8nn, gul, eller r\xF8d kategori.", /*#__PURE__*/React__default.createElement("br", null), loanAndCreditTexts.POPUP[type], /*#__PURE__*/React__default.createElement("br", null), "Med vennlig hilsen ", /*#__PURE__*/React__default.createElement("br", null), "Resurs"),
    brandStyle: "ya",
    iconMarginTop: "-0.5em"
  })), /*#__PURE__*/React__default.createElement(ItalicP, null, texts$1[trafficLightColor].shortColorDescription), /*#__PURE__*/React__default.createElement("p", null, texts$1[trafficLightColor].longColorDescription));
}
TrafficLightSection.propTypes = {
  trafficLightColor: PropTypes.oneOf(["GREEN", "YELLOW", "RED"]),
  type: PropTypes.oneOf(["CREDIT", "LOAN"])
};
TrafficLightSection.defaultProps = {
  trafficLightColor: null,
  type: null
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$7() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Header = createStyled("div", "development" === "production" ? {
  target: "e1fw2y6j0"
} : {
  target: "e1fw2y6j0",
  label: "Header"
})("development" === "production" ? {
  name: "jw0069",
  styles: "margin-top:4rem;margin-bottom:1rem;font-weight:600"
} : {
  name: "jw0069",
  styles: "margin-top:4rem;margin-bottom:1rem;font-weight:600",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBlcnNvbmFsQ3JlZGl0LmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHeUIiLCJmaWxlIjoiUGVyc29uYWxDcmVkaXQuanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCI7XG5cbmNvbnN0IEhlYWRlciA9IHN0eWxlZC5kaXZgXG4gIG1hcmdpbi10b3A6IDRyZW07XG4gIG1hcmdpbi1ib3R0b206IDFyZW07XG4gIGZvbnQtd2VpZ2h0OiA2MDA7XG5gO1xuXG5mdW5jdGlvbiBQZXJzb25hbENyZWRpdCgpIHtcbiAgcmV0dXJuIChcbiAgICA8ZGl2PlxuICAgICAgPEhlYWRlcj5Gb3JrbGFyaW5nIC0gUGVyc29ua3JlZGl0dCB0aWwgZm9yYnJ1a2VyPC9IZWFkZXI+XG4gICAgICA8ZGl2PlxuICAgICAgICBGb3IgbWVyIGluZm9ybWFzam9uIG9tIGh2YSBwZXJzb25rcmVkaXR0IGlubmViw6ZyZXIgZm9yIGRlZyBzb20gZm9yYnJ1a2VyLCBzZSBkZW5uZSBsZW5rZW46e1wiIFwifVxuICAgICAgICA8YVxuICAgICAgICAgIGhyZWY9XCJodHRwczovL2RvY3VtZW50aGFuZGxlci5yZXN1cnMuY29tL0Rva3VtZW50LnBkZj9jdXN0b21lclR5cGU9TkFUVVJBTCZkb2NUeXBlPWZvcmtsYXJpbmctcGVyc29ua3JlZGl0dC1mb3JicnVrZXItMjAyMyZsYW5kPU5PJmxhbmd1YWdlPW5vXCJcbiAgICAgICAgICB0YXJnZXQ9XCJfYmxhbmtcIlxuICAgICAgICAgIHJlbD1cIm5vcmVmZXJyZXJcIlxuICAgICAgICAgIHRpdGxlPVwiUGVyc29ua3JlZGl0dFwiXG4gICAgICAgID5cbiAgICAgICAgICBGb3JrbGFyaW5nIHBlcnNvbmtyZWRpdHQgdGlsIGZvcmJydWtlclxuICAgICAgICA8L2E+XG4gICAgICA8L2Rpdj5cbiAgICA8L2Rpdj5cbiAgKTtcbn1cblxuZXhwb3J0IGRlZmF1bHQgUGVyc29uYWxDcmVkaXQ7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
});
function PersonalCredit() {
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Header, null, "Forklaring - Personkreditt til forbruker"), /*#__PURE__*/React__default.createElement("div", null, "For mer informasjon om hva personkreditt inneb\xE6rer for deg som forbruker, se denne lenken:", " ", /*#__PURE__*/React__default.createElement("a", {
    href: "https://documenthandler.resurs.com/Dokument.pdf?customerType=NATURAL&docType=forklaring-personkreditt-forbruker-2023&land=NO&language=no",
    target: "_blank",
    rel: "noreferrer",
    title: "Personkreditt"
  }, "Forklaring personkreditt til forbruker")));
}

/* eslint-disable import/no-cycle */
function SigningStepList(props) {
  var submitPaymentAuthorization = props.submitPaymentAuthorization,
    isMainApplicant = props.isMainApplicant,
    chooseIdentificationMethod = props.chooseIdentificationMethod,
    uploadDocumentMultiple = props.uploadDocumentMultiple,
    getAltinnConsent = props.getAltinnConsent,
    creditors = props.creditors,
    fetchCreditors = props.fetchCreditors,
    documentsSigned = props.documentsSigned,
    paymentAuthorizationRequired = props.paymentAuthorizationRequired,
    loansToRefinance = props.loansToRefinance,
    accountNumber = props.accountNumber,
    customerDocuments = props.customerDocuments,
    nextStep = props.nextStep,
    creditAdjustedAmount = props.creditAdjustedAmount,
    name = props.name,
    validateKidAndAccount = props.validateKidAndAccount,
    trafficLightColor = props.trafficLightColor;

  // Step1: SignLoanAgreement
  // Step2: AccountInfoList
  // Step3: UploadDocuments

  var buildSignDocumentsProps = function buildSignDocumentsProps() {
    // component level logic about whats supposed to be hidden,required, prefilled etc.

    var completed = documentsSigned;
    var expandable = !completed;
    return {
      step: "sign_documents",
      mainTitle: "Signer låneavtalen",
      statusTextGreyText: "dokument er signert",
      expandClickDescription: "Trykk her for å signere",
      completed: completed,
      expandable: expandable,
      statusText: "".concat(completed ? "1" : "0", " av 1"),
      expandableContent: /*#__PURE__*/React__default.createElement(SignLoanAgreement, {
        chooseIdentificationMethod: chooseIdentificationMethod
      })
    };
  };
  var buildPaymentAuthorizationProps = function buildPaymentAuthorizationProps() {
    // component level logic about whats supposed to be hidden,required, prefilled etc.
    var completed = !paymentAuthorizationRequired; // todo more logic here
    var expandable = true;
    return {
      step: "payment_authorization",
      mainTitle: "Fyll inn kontoinformasjon",
      statusTextGreyText: "felter er fylt inn",
      expandClickDescription: "Trykk her for å fylle inn",
      completed: completed,
      expandable: expandable,
      statusText: "".concat(completed ? "1" : "0", " av 1"),
      expandableContent: /*#__PURE__*/React__default.createElement(AccountInfoList, {
        submitPaymentAuthorization: submitPaymentAuthorization,
        loansToRefinance: loansToRefinance,
        accountNumber: accountNumber || "",
        creditors: creditors,
        fetchCreditors: fetchCreditors,
        validateKidAndAccount: validateKidAndAccount
      })
    };
  };
  var buildDocumentationProps = function buildDocumentationProps() {
    // component level logic about whats supposed to be hidden,required, prefilled etc.
    var uploadDocumentsReceived = customerDocuments.filter(function (_ref) {
      var documentState = _ref.documentState;
      return documentState === "Received";
    });
    var completed = uploadDocumentsReceived.length === customerDocuments.length;
    var expandable = true;
    return {
      step: "documentation",
      mainTitle: "Last opp lønnsslipp eller næringsoppgave og din skattemelding",
      statusTextGreyText: "dokumenter er lastet opp",
      expandClickDescription: "Trykk her for å laste opp",
      completed: completed,
      expandable: expandable,
      statusText: "".concat(uploadDocumentsReceived.length, " av ").concat(customerDocuments.length),
      expandableContent: /*#__PURE__*/React__default.createElement(UploadDocuments, {
        uploadDocumentMultiple: uploadDocumentMultiple,
        documentTypesToInclude: customerDocuments.map(function (_ref2) {
          var type = _ref2.type;
          return type;
        }),
        uploadedDocuments: customerDocuments,
        getAltinnConsent: getAltinnConsent
      })
    };
  };
  var buildStateBasedStepItems = function buildStateBasedStepItems() {
    // LIST LEVEL
    var stepItemsPropsList = [];

    // Decide whether to include payment_authorization
    // logic here
    var includePaymentAuthorization = isMainApplicant;

    // Decide whether to include documentation
    // logic here

    var includeDocumentation = customerDocuments && customerDocuments.length;

    // COMPONENT LEVEL

    {
      stepItemsPropsList.push(buildSignDocumentsProps());
    }
    if (includePaymentAuthorization) {
      stepItemsPropsList.push(buildPaymentAuthorizationProps());
    }
    if (includeDocumentation) {
      stepItemsPropsList.push(buildDocumentationProps());
    }
    // STATE LEVEL
    return stepItemsPropsList.map(function (stepItemProps, index) {
      return /*#__PURE__*/React__default.createElement(StepItem, {
        key: stepItemProps.step,
        stepNr: index + 1,
        isCurrentStep: stepItemProps.step === nextStep,
        allVisibleStepsCount: stepItemsPropsList.length,
        step: stepItemProps.step,
        mainTitle: stepItemProps.mainTitle,
        statusTextGreyText: stepItemProps.statusTextGreyText,
        expandClickDescription: stepItemProps.expandClickDescription,
        completed: stepItemProps.completed,
        expandable: stepItemProps.expandable,
        statusText: stepItemProps.statusText,
        expandableContent: stepItemProps.expandableContent
      });
    });
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AutoAlignStepItemLeftSpaceContainer, null, /*#__PURE__*/React__default.createElement("h4", {
    style: {
      marginBottom: "1rem"
    }
  }, "Hei ", name, "!"), /*#__PURE__*/React__default.createElement(TrafficLightSection, {
    trafficLightColor: trafficLightColor,
    type: "LOAN"
  }), /*#__PURE__*/React__default.createElement(PersonalCredit, null), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginTop: "5rem",
      marginBottom: "1.5rem"
    }
  }, "For at vi skal kunne utbetale l\xE5net p\xE5 ", /*#__PURE__*/React__default.createElement("b", null, creditAdjustedAmount, ",-"), " m\xE5 du fullf\xF8re disse stegene:")), buildStateBasedStepItems());
}
SigningStepList.propTypes = {
  submitPaymentAuthorization: PropTypes.func.isRequired,
  isMainApplicant: PropTypes.bool.isRequired,
  chooseIdentificationMethod: PropTypes.func.isRequired,
  uploadDocumentMultiple: PropTypes.func.isRequired,
  getAltinnConsent: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  creditors: PropTypes.array,
  fetchCreditors: PropTypes.func.isRequired,
  documentsSigned: PropTypes.bool.isRequired,
  paymentAuthorizationRequired: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  loansToRefinance: PropTypes.array,
  accountNumber: PropTypes.string,
  customerDocuments: PropTypes.arrayOf(PropTypes.objectOf({
    type: PropTypes.string.isRequired,
    documentState: PropTypes.string.isRequired
  })),
  nextStep: PropTypes.string.isRequired,
  creditAdjustedAmount: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  validateKidAndAccount: PropTypes.func.isRequired,
  trafficLightColor: PropTypes.string
};
SigningStepList.defaultProps = {
  creditors: [],
  loansToRefinance: [],
  accountNumber: "",
  customerDocuments: [],
  trafficLightColor: null
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$6() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var SigningnWrapper = createStyled("div", "development" === "production" ? {
  target: "e1in86ho0"
} : {
  target: "e1in86ho0",
  label: "SigningnWrapper"
})("development" === "production" ? {
  name: "16bh8k8",
  styles: "margin:20px auto;max-width:800px"
} : {
  name: "16bh8k8",
  styles: "margin:20px auto;max-width:800px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$6
});
var NEXT_STEP$1 = {
  INSURANCE: "insurance",
  // Show insurance (only mainApplicant)
  SIGN_DOCUMENTS: "sign_documents",
  // Show the three steps
  PAYMENT_AUTHORIZATION: "payment_authorization",
  // Show the three steps
  DOCUMENTATION: "documentation",
  // Show the three steps
  SUBSIDARY_START: "subsidiary_start",
  // <GoToSubsidarePage/> and then the three steps
  COMPLETE: "complete" // <ThankYouPage/>
};

function SigningPageRenderer(props) {
  var nextStep = props.nextStep,
    isMainApplicant = props.isMainApplicant,
    name = props.name,
    accountNumber = props.accountNumber,
    chooseInsurance = props.chooseInsurance,
    insuranceTermsLink = props.insuranceTermsLink,
    termsOfPurchaseLink = props.termsOfPurchaseLink,
    submitPaymentAuthorization = props.submitPaymentAuthorization,
    uploadDocumentMultiple = props.uploadDocumentMultiple,
    chooseIdentificationMethod = props.chooseIdentificationMethod,
    registerDocumentsUploadedExternally = props.registerDocumentsUploadedExternally,
    getAltinnConsent = props.getAltinnConsent,
    creditors = props.creditors,
    fetchCreditors = props.fetchCreditors,
    documentsSigned = props.documentsSigned,
    paymentAuthorizationRequired = props.paymentAuthorizationRequired,
    loansToRefinance = props.loansToRefinance,
    customerDocuments = props.customerDocuments,
    creditAdjustedAmount = props.creditAdjustedAmount,
    showEndPage = props.showEndPage,
    setShowEndPage = props.setShowEndPage,
    insuranceIsMandatory = props.insuranceIsMandatory,
    validateKidAndAccount = props.validateKidAndAccount,
    trafficLightColor = props.trafficLightColor;
  var getContentToRender = function getContentToRender() {
    if (nextStep === NEXT_STEP$1.SUBSIDARY_START && showEndPage) {
      return /*#__PURE__*/React__default.createElement(GoToSubsidaryPage, {
        name: name
      });
    }
    if (nextStep === NEXT_STEP$1.COMPLETE && showEndPage) {
      return /*#__PURE__*/React__default.createElement(ThankYouPage, {
        accountNumber: accountNumber,
        name: name
      });
    }
    if (nextStep === NEXT_STEP$1.INSURANCE) {
      return /*#__PURE__*/React__default.createElement(Insurance$1, {
        chooseInsurance: chooseInsurance,
        insuranceTermsLink: insuranceTermsLink,
        termsOfPurchaseLink: termsOfPurchaseLink,
        insuranceIsMandatory: insuranceIsMandatory
      });
    }
    if ([NEXT_STEP$1.SIGN_DOCUMENTS, NEXT_STEP$1.PAYMENT_AUTHORIZATION, NEXT_STEP$1.DOCUMENTATION, NEXT_STEP$1.SUBSIDARY_START, NEXT_STEP$1.COMPLETE].includes(nextStep)) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SigningStepList, {
        submitPaymentAuthorization: submitPaymentAuthorization,
        uploadDocumentMultiple: uploadDocumentMultiple,
        isMainApplicant: isMainApplicant,
        chooseIdentificationMethod: chooseIdentificationMethod,
        registerDocumentsUploadedExternally: registerDocumentsUploadedExternally,
        getAltinnConsent: getAltinnConsent,
        creditors: creditors,
        fetchCreditors: fetchCreditors,
        documentsSigned: documentsSigned,
        paymentAuthorizationRequired: paymentAuthorizationRequired,
        loansToRefinance: loansToRefinance,
        accountNumber: accountNumber,
        customerDocuments: customerDocuments,
        nextStep: nextStep,
        creditAdjustedAmount: creditAdjustedAmount,
        name: name,
        validateKidAndAccount: validateKidAndAccount,
        trafficLightColor: trafficLightColor
      }), /*#__PURE__*/React__default.createElement(BigButton, {
        onClick: setShowEndPage,
        disabled: ![NEXT_STEP$1.COMPLETE, NEXT_STEP$1.SUBSIDARY_START].includes(nextStep),
        type: "button",
        style: {
          marginRight: 0
        }
      }, "Fullf\xF8r"));
    }
    return null;
  };
  return /*#__PURE__*/React__default.createElement(SigningnWrapper, null, getContentToRender());
}
SigningPageRenderer.propTypes = {
  nextStep: PropTypes.oneOf(Object.values(NEXT_STEP$1)).isRequired,
  isMainApplicant: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  accountNumber: PropTypes.string,
  chooseInsurance: PropTypes.func.isRequired,
  insuranceTermsLink: PropTypes.string.isRequired,
  termsOfPurchaseLink: PropTypes.string.isRequired,
  submitPaymentAuthorization: PropTypes.func.isRequired,
  uploadDocumentMultiple: PropTypes.func.isRequired,
  chooseIdentificationMethod: PropTypes.func.isRequired,
  registerDocumentsUploadedExternally: PropTypes.func.isRequired,
  getAltinnConsent: PropTypes.func.isRequired,
  creditors: PropTypes.arrayOf(PropTypes.shape({
    accountId: PropTypes.number,
    accountNumber: PropTypes.string,
    creditorId: PropTypes.number,
    creditorName: PropTypes.string
  })),
  fetchCreditors: PropTypes.func.isRequired,
  documentsSigned: PropTypes.bool.isRequired,
  paymentAuthorizationRequired: PropTypes.bool.isRequired,
  loansToRefinance: PropTypes.arrayOf(PropTypes.shape({
    accountNr: PropTypes.string,
    bank: PropTypes.string,
    creditAdjustmentExistingLoanId: PropTypes.number,
    debt: PropTypes.number,
    kidOrMessage: PropTypes.string,
    kidRequired: PropTypes.bool,
    locked: PropTypes.bool
  })),
  customerDocuments: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    documentState: PropTypes.string
  })),
  creditAdjustedAmount: PropTypes.number.isRequired,
  showEndPage: PropTypes.bool.isRequired,
  setShowEndPage: PropTypes.func.isRequired,
  insuranceIsMandatory: PropTypes.bool.isRequired,
  validateKidAndAccount: PropTypes.func.isRequired,
  trafficLightColor: PropTypes.string
};
SigningPageRenderer.defaultProps = {
  accountNumber: null,
  creditors: [],
  loansToRefinance: [],
  customerDocuments: [],
  trafficLightColor: null
};

var useErrorsToDisplay = function useErrorsToDisplay() {
  var _useState = useState({}),
    _useState2 = _slicedToArray$2(_useState, 2),
    errorsToDisplay = _useState2[0],
    setErrorsToDisplay = _useState2[1];
  var temporarilySetErrorsToDisplay = function temporarilySetErrorsToDisplay(functionName) {
    var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Teknisk feil";
    var secondsBeforeClear = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
    setErrorsToDisplay(function (prev) {
      return _objectSpread2$4(_objectSpread2$4({}, prev), {}, _defineProperty$5({}, functionName, errorMessage));
    });
    setTimeout(function () {
      setErrorsToDisplay(function (prev) {
        return _objectSpread2$4(_objectSpread2$4({}, prev), {}, _defineProperty$5({}, functionName, null));
      });
    }, secondsBeforeClear * 1000);
  };
  var setPaymentAuthorizationError = function setPaymentAuthorizationError(paymentAuthorizationError) {
    setErrorsToDisplay(function (prev) {
      return _objectSpread2$4(_objectSpread2$4({}, prev), {}, {
        paymentAuthorizationError: paymentAuthorizationError
      });
    });
  };
  return {
    errorsToDisplay: errorsToDisplay,
    temporarilySetErrorsToDisplay: temporarilySetErrorsToDisplay,
    setPaymentAuthorizationError: setPaymentAuthorizationError
  };
};

var fetchConsentDetails = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(consentApiUrl, ssn, channel, consentName, headers) {
    var customerConsentsResponse, _jsonBody$consentDeta, jsonBody, consentDetails, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch("".concat(consentApiUrl, "/customer/").concat(ssn, "/SSN/").concat(channel), {
              headers: headers
            });
          case 2:
            customerConsentsResponse = _context.sent;
            if (!customerConsentsResponse.ok) {
              _context.next = 15;
              break;
            }
            _context.prev = 4;
            _context.next = 7;
            return customerConsentsResponse.json();
          case 7:
            jsonBody = _context.sent;
            consentDetails = jsonBody === null || jsonBody === void 0 ? void 0 : (_jsonBody$consentDeta = jsonBody.consentDetailsMap) === null || _jsonBody$consentDeta === void 0 ? void 0 : _jsonBody$consentDeta[consentName];
            return _context.abrupt("return", consentDetails);
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](4);
            console.warn("Unexpected response");
          case 15:
            if (!(customerConsentsResponse.status === 404)) {
              _context.next = 29;
              break;
            }
            _context.next = 18;
            return fetch("".concat(consentApiUrl, "/").concat(consentName), {
              headers: headers
            });
          case 18:
            response = _context.sent;
            if (!response.ok) {
              _context.next = 29;
              break;
            }
            _context.prev = 20;
            _context.next = 23;
            return response.json();
          case 23:
            return _context.abrupt("return", _context.sent);
          case 26:
            _context.prev = 26;
            _context.t1 = _context["catch"](20);
            console.warn("Unexpected response");
          case 29:
            console.warn("Did not find any customer consent nor any details on it. Or some other error happened.");
            return _context.abrupt("return", {});
          case 31:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 12], [20, 26]]);
  }));
  return function fetchConsentDetails(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();
var postConsent = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(consentApiUrl, headers, ssn, consentName, consentIndicator, channel) {
    var extendedHeaders, body, response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            extendedHeaders = _objectSpread2$4(_objectSpread2$4({}, headers), {}, {
              "Content-Type": "application/json"
            });
            body = JSON.stringify({
              identifier: {
                identifier: ssn,
                identifierType: "SSN",
                consentTypesChannel: channel
              },
              consentIndicatorsToCreateOrUpdate: _defineProperty$5({}, consentName, consentIndicator)
            });
            _context2.next = 4;
            return fetch(consentApiUrl, {
              method: "POST",
              headers: extendedHeaders,
              body: body
            });
          case 4:
            response = _context2.sent;
            return _context2.abrupt("return", response.ok);
          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function postConsent(_x6, _x7, _x8, _x9, _x10, _x11) {
    return _ref2.apply(this, arguments);
  };
}();

// If the page where the hook resides is loaded more than once the consent will be shown
// again since there is no data if the question has been answered or not. We patch that
// with using the session storage until the ConsentManager is clever enough to remember.
var setHasAskedSession = function setHasAskedSession() {
  return window.sessionStorage.setItem("asked-for-marketing", true);
};
var hasAskedSession = function hasAskedSession() {
  return window.sessionStorage.getItem("asked-for-marketing");
};
var useMarketingConsent = function useMarketingConsent(_ref3) {
  var consentManagerUrl = _ref3.consentManagerUrl,
    keycloakToken = _ref3.keycloakToken,
    _ref3$channel = _ref3.channel,
    channel = _ref3$channel === void 0 ? "ya" : _ref3$channel,
    ssn = _ref3.ssn,
    isUserVerified = _ref3.isUserVerified;
  var _useState = useState({}),
    _useState2 = _slicedToArray$2(_useState, 2),
    consentDetails = _useState2[0],
    setConsentDetails = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray$2(_useState3, 2),
    hasRegistredConsent = _useState4[0],
    setHasRegistredConsent = _useState4[1];
  useEffect(function () {
    if (consentManagerUrl && keycloakToken && channel && ssn && isUserVerified && !hasAskedSession()) {
      var consentName = channel === "yx" ? "MARKETING_YX" : "MARKETING";
      var asyncFetcher = /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          var commonHeaders, consentApiUrl, registerConsent, response;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  commonHeaders = {
                    Accept: "application/json",
                    securityrealm: "public",
                    Authorization: "Bearer ".concat(keycloakToken)
                  };
                  consentApiUrl = "".concat(consentManagerUrl, "/consentmanager/api/consents/consent");
                  registerConsent = function registerConsent(value) {
                    postConsent(consentApiUrl, commonHeaders, ssn, consentName, value, channel);
                    setHasRegistredConsent(true);
                  };
                  _context3.next = 5;
                  return fetchConsentDetails(consentApiUrl, ssn, channel, consentName, commonHeaders);
                case 5:
                  response = _context3.sent;
                  setConsentDetails(_objectSpread2$4(_objectSpread2$4({}, response), {}, {
                    isLoading: false,
                    registerConsent: registerConsent
                  }));
                  setHasAskedSession();
                case 8:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
        return function asyncFetcher() {
          return _ref4.apply(this, arguments);
        };
      }();
      setConsentDetails({
        isLoading: true
      });
      asyncFetcher();
    }
  }, [channel, consentManagerUrl, isUserVerified, keycloakToken, ssn]);

  // Ask for consent if the indicator is false since we can't know if it's the default value or an actual no.
  var shouldAskForConsent = !hasRegistredConsent && consentDetails.description && !consentDetails.consentIndicator;
  return _objectSpread2$4(_objectSpread2$4({}, consentDetails), {}, {
    shouldAskForConsent: shouldAskForConsent
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$5() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Container$1 = createStyled("div", "development" === "production" ? {
  target: "e3njukw1"
} : {
  target: "e3njukw1",
  label: "Container"
})("development" === "production" ? {
  name: "ihv00n",
  styles: "max-width:610px"
} : {
  name: "ihv00n",
  styles: "max-width:610px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbnNlbnQtdmlldy5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTTRCIiwiZmlsZSI6ImNvbnNlbnQtdmlldy5qc3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiBlc2xpbnQtZGlzYWJsZSByZWFjdC9uby1kYW5nZXIgKi9cbmltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiO1xuaW1wb3J0IHsgQmlnQnV0dG9uLCBMZWdlbmQgfSBmcm9tIFwiLi4vdWlcIjtcblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgbWF4LXdpZHRoOiA2MTBweDtcbmA7XG5cbmNvbnN0IEJ1dHRvbldyYXBwZXIgPSBzdHlsZWQuZGl2YFxuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbmA7XG5cbmZ1bmN0aW9uIENvbnNlbnRWaWV3KHsgbmFtZSwgZGVzY3JpcHRpb24sIGNvbnNlbnRUZXh0LCByZWdpc3RlckNvbnNlbnQsIGJyYW5kU3R5bGUgfSkge1xuICByZXR1cm4gKFxuICAgIDxDb250YWluZXI+XG4gICAgICA8TGVnZW5kPklkZW50aWZpc2VyaW5nOiB7bmFtZX08L0xlZ2VuZD5cbiAgICAgIDxwIGRhbmdlcm91c2x5U2V0SW5uZXJIVE1MPXt7IF9faHRtbDogZGVzY3JpcHRpb24gfX0gLz5cbiAgICAgIDxwPntjb25zZW50VGV4dH08L3A+XG4gICAgICA8QnV0dG9uV3JhcHBlcj5cbiAgICAgICAgPEJpZ0J1dHRvblxuICAgICAgICAgIGJyYW5kU3R5bGU9e2JyYW5kU3R5bGV9XG4gICAgICAgICAgc3R5bGU9e3sgbWFyZ2luUmlnaHQ6IFwiNHJlbVwiIH19XG4gICAgICAgICAgb25DbGljaz17KCkgPT4gcmVnaXN0ZXJDb25zZW50KHRydWUpfVxuICAgICAgICA+XG4gICAgICAgICAgSmEgdGFrayFcbiAgICAgICAgPC9CaWdCdXR0b24+XG4gICAgICAgIDxCaWdCdXR0b24gYnJhbmRTdHlsZT17YnJhbmRTdHlsZX0gb25DbGljaz17KCkgPT4gcmVnaXN0ZXJDb25zZW50KGZhbHNlKX0+XG4gICAgICAgICAgTmVpIHRha2tcbiAgICAgICAgPC9CaWdCdXR0b24+XG4gICAgICA8L0J1dHRvbldyYXBwZXI+XG4gICAgPC9Db250YWluZXI+XG4gICk7XG59XG5cbkNvbnNlbnRWaWV3LnByb3BUeXBlcyA9IHtcbiAgbmFtZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBkZXNjcmlwdGlvbjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBjb25zZW50VGV4dDogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICByZWdpc3RlckNvbnNlbnQ6IFByb3BUeXBlcy5mdW5jLmlzUmVxdWlyZWQsXG4gIGJyYW5kU3R5bGU6IFByb3BUeXBlcy5vbmVPZihbXCJ5YVwiLCBcInl4XCJdKSxcbn07XG5cbkNvbnNlbnRWaWV3LmRlZmF1bHRQcm9wcyA9IHtcbiAgYnJhbmRTdHlsZTogXCJ5YVwiLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgQ29uc2VudFZpZXc7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
});
var ButtonWrapper = createStyled("div", "development" === "production" ? {
  target: "e3njukw0"
} : {
  target: "e3njukw0",
  label: "ButtonWrapper"
})("development" === "production" ? {
  name: "zl1inp",
  styles: "display:flex;justify-content:center"
} : {
  name: "zl1inp",
  styles: "display:flex;justify-content:center",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbnNlbnQtdmlldy5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBVWdDIiwiZmlsZSI6ImNvbnNlbnQtdmlldy5qc3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiBlc2xpbnQtZGlzYWJsZSByZWFjdC9uby1kYW5nZXIgKi9cbmltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiO1xuaW1wb3J0IHsgQmlnQnV0dG9uLCBMZWdlbmQgfSBmcm9tIFwiLi4vdWlcIjtcblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgbWF4LXdpZHRoOiA2MTBweDtcbmA7XG5cbmNvbnN0IEJ1dHRvbldyYXBwZXIgPSBzdHlsZWQuZGl2YFxuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbmA7XG5cbmZ1bmN0aW9uIENvbnNlbnRWaWV3KHsgbmFtZSwgZGVzY3JpcHRpb24sIGNvbnNlbnRUZXh0LCByZWdpc3RlckNvbnNlbnQsIGJyYW5kU3R5bGUgfSkge1xuICByZXR1cm4gKFxuICAgIDxDb250YWluZXI+XG4gICAgICA8TGVnZW5kPklkZW50aWZpc2VyaW5nOiB7bmFtZX08L0xlZ2VuZD5cbiAgICAgIDxwIGRhbmdlcm91c2x5U2V0SW5uZXJIVE1MPXt7IF9faHRtbDogZGVzY3JpcHRpb24gfX0gLz5cbiAgICAgIDxwPntjb25zZW50VGV4dH08L3A+XG4gICAgICA8QnV0dG9uV3JhcHBlcj5cbiAgICAgICAgPEJpZ0J1dHRvblxuICAgICAgICAgIGJyYW5kU3R5bGU9e2JyYW5kU3R5bGV9XG4gICAgICAgICAgc3R5bGU9e3sgbWFyZ2luUmlnaHQ6IFwiNHJlbVwiIH19XG4gICAgICAgICAgb25DbGljaz17KCkgPT4gcmVnaXN0ZXJDb25zZW50KHRydWUpfVxuICAgICAgICA+XG4gICAgICAgICAgSmEgdGFrayFcbiAgICAgICAgPC9CaWdCdXR0b24+XG4gICAgICAgIDxCaWdCdXR0b24gYnJhbmRTdHlsZT17YnJhbmRTdHlsZX0gb25DbGljaz17KCkgPT4gcmVnaXN0ZXJDb25zZW50KGZhbHNlKX0+XG4gICAgICAgICAgTmVpIHRha2tcbiAgICAgICAgPC9CaWdCdXR0b24+XG4gICAgICA8L0J1dHRvbldyYXBwZXI+XG4gICAgPC9Db250YWluZXI+XG4gICk7XG59XG5cbkNvbnNlbnRWaWV3LnByb3BUeXBlcyA9IHtcbiAgbmFtZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBkZXNjcmlwdGlvbjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBjb25zZW50VGV4dDogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICByZWdpc3RlckNvbnNlbnQ6IFByb3BUeXBlcy5mdW5jLmlzUmVxdWlyZWQsXG4gIGJyYW5kU3R5bGU6IFByb3BUeXBlcy5vbmVPZihbXCJ5YVwiLCBcInl4XCJdKSxcbn07XG5cbkNvbnNlbnRWaWV3LmRlZmF1bHRQcm9wcyA9IHtcbiAgYnJhbmRTdHlsZTogXCJ5YVwiLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgQ29uc2VudFZpZXc7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
});
function ConsentView(_ref) {
  var name = _ref.name,
    description = _ref.description,
    consentText = _ref.consentText,
    registerConsent = _ref.registerConsent,
    brandStyle = _ref.brandStyle;
  return /*#__PURE__*/React__default.createElement(Container$1, null, /*#__PURE__*/React__default.createElement(Legend, null, "Identifisering: ", name), /*#__PURE__*/React__default.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: description
    }
  }), /*#__PURE__*/React__default.createElement("p", null, consentText), /*#__PURE__*/React__default.createElement(ButtonWrapper, null, /*#__PURE__*/React__default.createElement(BigButton, {
    brandStyle: brandStyle,
    style: {
      marginRight: "4rem"
    },
    onClick: function onClick() {
      return registerConsent(true);
    }
  }, "Ja takk!"), /*#__PURE__*/React__default.createElement(BigButton, {
    brandStyle: brandStyle,
    onClick: function onClick() {
      return registerConsent(false);
    }
  }, "Nei takk")));
}
ConsentView.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  consentText: PropTypes.string.isRequired,
  registerConsent: PropTypes.func.isRequired,
  brandStyle: PropTypes.oneOf(["ya", "yx"])
};
ConsentView.defaultProps = {
  brandStyle: "ya"
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$4() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Box = createStyled("div", "development" === "production" ? {
  target: "eozvra94"
} : {
  target: "eozvra94",
  label: "Box"
})("width:80vw;max-width:100rem;min-height:30vh;border-top:12px solid ", colors$1.primaryGreen, ";border-radius:2px;padding:5rem;background:", colors$1.lightGrey, ";border-radius:2px;display:grid;grid-auto-flow:row;place-items:", function (props) {
  return props.centerContent ? "center" : "unset";
}, ";color:", function (props) {
  return props.isError ? colors$1.errorRed : "unset";
}, ";" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Container = createStyled("div", "development" === "production" ? {
  target: "eozvra93"
} : {
  target: "eozvra93",
  label: "Container"
})("development" === "production" ? {
  name: "1111yk7",
  styles: "display:grid;place-items:center;height:70vh"
} : {
  name: "1111yk7",
  styles: "display:grid;place-items:center;height:70vh",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
});
var Title$1 = createStyled("h1", "development" === "production" ? {
  target: "eozvra92"
} : {
  target: "eozvra92",
  label: "Title"
})("development" === "production" ? {
  name: "1smerdt",
  styles: "padding:1rem 0"
} : {
  name: "1smerdt",
  styles: "padding:1rem 0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
});
var Subtitle = createStyled("h3", "development" === "production" ? {
  target: "eozvra91"
} : {
  target: "eozvra91",
  label: "Subtitle"
})("development" === "production" ? {
  name: "1pstb25",
  styles: "font-weight:450;padding:1rem 0"
} : {
  name: "1pstb25",
  styles: "font-weight:450;padding:1rem 0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
});
var Text = createStyled("p", "development" === "production" ? {
  target: "eozvra90"
} : {
  target: "eozvra90",
  label: "Text"
})("development" === "production" ? {
  name: "1smerdt",
  styles: "padding:1rem 0"
} : {
  name: "1smerdt",
  styles: "padding:1rem 0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
});
function DeadEndTextBox(props) {
  var title = props.title,
    titleProps = props.titleProps,
    subtitle = props.subtitle,
    subtitleProps = props.subtitleProps,
    text = props.text,
    textProps = props.textProps,
    customJsx = props.customJsx,
    isError = props.isError;
  var willRenderMultipleElements = [title, subtitle, text, customJsx].filter(function (element) {
    return element !== undefined;
  }).length > 1;
  return /*#__PURE__*/React__default.createElement(Container, null, /*#__PURE__*/React__default.createElement(Box, {
    centerContent: !willRenderMultipleElements,
    isError: isError
  }, title && /*#__PURE__*/React__default.createElement(Title$1, titleProps, title), subtitle && /*#__PURE__*/React__default.createElement(Subtitle, subtitleProps, subtitle), text && /*#__PURE__*/React__default.createElement(Text, textProps, text), customJsx || null));
}
DeadEndTextBox.propTypes = {
  title: PropTypes.string,
  titleProps: PropTypes.object,
  subtitle: PropTypes.string,
  subtitleProps: PropTypes.object,
  text: PropTypes.string,
  textProps: PropTypes.object,
  customJsx: PropTypes.node,
  isError: PropTypes.bool
};
DeadEndTextBox.defaultProps = {
  title: undefined,
  titleProps: {},
  subtitle: undefined,
  subtitleProps: {},
  text: undefined,
  textProps: {},
  customJsx: undefined,
  isError: false
};

function useInitialInfo(ssn, errorCallback, workingCallback, requestService) {
  var _useState = useState(null),
    _useState2 = _slicedToArray$2(_useState, 2),
    isMainApplicant = _useState2[0],
    setIsMainApplicant = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray$2(_useState3, 2),
    userVerified = _useState4[0],
    setUserVerified = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray$2(_useState5, 2),
    applicationStateId = _useState6[0],
    setApplicationStateId = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray$2(_useState7, 2),
    productType = _useState8[0],
    setProductType = _useState8[1];
  useEffect(function () {
    var verifyUser = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var checkApplicationResponse, mainSsn, mainApplicant, verifySsnResponse, _error$response$data, _error$response, _ref2, message, application, code;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                workingCallback(true);
                _context.prev = 1;
                _context.next = 4;
                return requestService.checkApplication();
              case 4:
                checkApplicationResponse = _context.sent;
                mainSsn = checkApplicationResponse.data.application.mainApplicantApplication.applicant.ssn;
                mainApplicant = mainSsn === ssn;
                setIsMainApplicant(mainApplicant);
                setApplicationStateId(checkApplicationResponse.data.application.applicationStateId);
                setProductType(checkApplicationResponse.data.application.productType);

                // VERIFY SSN
                _context.next = 12;
                return requestService.verifySsn(ssn, mainApplicant);
              case 12:
                verifySsnResponse = _context.sent;
                setUserVerified(verifySsnResponse.status === 200);
                _context.next = 21;
                break;
              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](1);
                _ref2 = (_error$response$data = (_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.data) !== null && _error$response$data !== void 0 ? _error$response$data : {}, message = _ref2.message, application = _ref2.application;
                code = _context.t0.response.status;
                errorCallback({
                  code: code,
                  message: message,
                  productType: application === null || application === void 0 ? void 0 : application.productType
                });
              case 21:
                _context.prev = 21;
                workingCallback(false);
                return _context.finish(21);
              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 16, 21, 24]]);
      }));
      return function verifyUser() {
        return _ref.apply(this, arguments);
      };
    }();
    verifyUser();
  }, [ssn, errorCallback, workingCallback, requestService]);
  return {
    isMainApplicant: isMainApplicant,
    userVerified: userVerified,
    applicationStateId: applicationStateId,
    productType: productType
  };
}

function useDeadEndApplicationState(applicationStateId, productType) {
  var productNames = {
    HIGHINTERESTACCOUNT: "yA Høyrentekonto",
    YX_CARD: "YX Visa-kort",
    YX_MOT_CARD: "YX Visa-kort",
    YX_MICRO_CARD: "YX Visa-kort",
    YX_CONVERT_CARD: "YX Visa-kort",
    CREDIT_CARD: "yA Kredittkort",
    ACCOUNT: "yA Brukskonto",
    UNSECURED_LOAN: "yA Forbrukslån",
    REFINANCE_LOAN: "yA Forbrukslån",
    REFURBISH_LOAN: "yA Forbrukslån"
  };
  var APPLICATION_STATE_DEAD_END_TEXTS = {
    CUSTOMER_REJECTED: {
      title: "Utdatert applikasjon",
      subtitle: "Du har valgt \xE5 takke nei til ".concat(productNames[productType] || "vårt tilbud", "."),
      text: "Vi beklager at vi ikke kunne tilby deg et godt nok tilbud, men håper å se deg tilbake en annen gang.\nTakk for din interesse i Resurs Bank."
    },
    NEW_CASE: {
      text: "Kjære kunde.\nDu har allerede identifisert deg så du kan se bort fra denne lenken.\nDin søknad er under behandling."
    }
  };
  var isDeadEnd = APPLICATION_STATE_DEAD_END_TEXTS[applicationStateId] !== undefined;
  var deadEndTextBoxProps = isDeadEnd ? APPLICATION_STATE_DEAD_END_TEXTS[applicationStateId] : {};
  return {
    isDeadEnd: isDeadEnd,
    deadEndTextBoxProps: deadEndTextBoxProps
  };
}

/**
 * This functions manages the state of the Identification and Signing flow.
 *
 * Two URL parameters are used: 'isMainApplicant' and 'applicationId'.
 *
 * The current state/NEXT_STEP is provided from backend and regularily updated through
 * checkApplicationSigningStatus().
 */
var DisplayErrorsSigningContext = /*#__PURE__*/createContext({});
function SigningActive(props) {
  var _applicationSigningSt2;
  // props to set baseUrls
  var sblDomain = props.sblDomain,
    cmsDomain = props.cmsDomain;
  // props with links, later used as follows: <a href={someLink}/>
  var insuranceTermsLink = props.insuranceTermsLink,
    termsOfPurchaseLink = props.termsOfPurchaseLink,
    consentManagerUrl = props.consentManagerUrl;
  var _useState = useState({}),
    _useState2 = _slicedToArray$2(_useState, 2),
    applicationSigningStatus = _useState2[0],
    setApplicationSigningStatus = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray$2(_useState3, 2),
    showSpinner = _useState4[0],
    setShowSpinner = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray$2(_useState5, 2),
    creditors = _useState6[0],
    setCreditors = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray$2(_useState7, 2),
    fetchCreditorsRetryCount = _useState8[0],
    setFetchCreditorsRetryCount = _useState8[1];
  var _useState9 = useState({}),
    _useState10 = _slicedToArray$2(_useState9, 2),
    blockingError = _useState10[0],
    setBlockingError = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray$2(_useState11, 2),
    showEndPage = _useState12[0],
    _setShowEndPage = _useState12[1];
  var keycloakResult = useContext(AuthContext);
  var _useState13 = useState(null),
    _useState14 = _slicedToArray$2(_useState13, 2),
    trafficLightColor = _useState14[0],
    setTrafficLightColor = _useState14[1];
  var _useErrorsToDisplay = useErrorsToDisplay(),
    errorsToDisplay = _useErrorsToDisplay.errorsToDisplay,
    temporarilySetErrorsToDisplay = _useErrorsToDisplay.temporarilySetErrorsToDisplay,
    setPaymentAuthorizationError = _useErrorsToDisplay.setPaymentAuthorizationError;
  var isSSR = typeof window === "undefined"; // Server-side rendering doesn't have any window object
  var applicationId = isSSR ? "" : getParam("applicationId");
  var requestService = useMemo(function () {
    return Requests(applicationId, sblDomain, cmsDomain, keycloakResult);
  }, [applicationId, cmsDomain, keycloakResult, sblDomain]);
  var _useInitialInfo = useInitialInfo(keycloakResult.ssn, setBlockingError, setShowSpinner, requestService),
    isMainApplicant = _useInitialInfo.isMainApplicant,
    userVerified = _useInitialInfo.userVerified,
    applicationStateId = _useInitialInfo.applicationStateId,
    productType = _useInitialInfo.productType;
  var consentDetails = useMarketingConsent({
    consentManagerUrl: consentManagerUrl,
    keycloakToken: keycloakResult.token,
    channel: "ya",
    ssn: keycloakResult.ssn,
    isUserVerified: userVerified
  });
  var _useDeadEndApplicatio = useDeadEndApplicationState(applicationStateId, productType),
    isDeadEnd = _useDeadEndApplicatio.isDeadEnd,
    deadEndTextBoxProps = _useDeadEndApplicatio.deadEndTextBoxProps;
  var mainOrCoApplicantObjectKey = isMainApplicant ? "mainApplicantApplication" : "subsidiaryApplicantApplication";
  var chooseIdentificationMethod = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(identificationMethod) {
      var redirectUrlCancel, redirectUrlCompleted, redirectUrlRejected, response, redirectUrl, _error$response$data, _error$response, _ref2, message;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              redirectUrlCancel = getUrlWithAppendedParams({
                identified: "canceled"
              });
              redirectUrlCompleted = getUrlWithAppendedParams({
                identified: "completed"
              });
              redirectUrlRejected = getUrlWithAppendedParams({
                identified: "rejected"
              });
              setShowSpinner(true);
              _context.prev = 4;
              _context.next = 7;
              return requestService.chooseIdentificationMethod(isMainApplicant, identificationMethod, redirectUrlCancel, redirectUrlCompleted, redirectUrlRejected);
            case 7:
              response = _context.sent;
              redirectUrl = response.data.redirectUrl;
              window.location.href = redirectUrl;
              _context.next = 17;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](4);
              console.error(_context.t0);
              _ref2 = (_error$response$data = (_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.data) !== null && _error$response$data !== void 0 ? _error$response$data : {}, message = _ref2.message;
              temporarilySetErrorsToDisplay("chooseIdentificationMethod", message, 5);
            case 17:
              _context.prev = 17;
              setShowSpinner(false);
              return _context.finish(17);
            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 12, 17, 20]]);
    }));
    return function chooseIdentificationMethod(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var checkApplicationSigningStatus = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var response, message, code;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            setBlockingError({});
            setShowSpinner(true);
            _context2.prev = 2;
            _context2.next = 5;
            return requestService.checkApplicationSigningStatus(isMainApplicant);
          case 5:
            response = _context2.sent;
            setApplicationSigningStatus(response.data);
            _context2.next = 15;
            break;
          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](2);
            console.log("SigningActive::checkApplicationSigningStatus error: ", _context2.t0);
            message = _context2.t0.response.data.message;
            code = _context2.t0.response.status;
            setBlockingError({
              code: code,
              message: message
            });
          case 15:
            _context2.prev = 15;
            setShowSpinner(false);
            return _context2.finish(15);
          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 9, 15, 18]]);
  })), [requestService, isMainApplicant]);
  var submitPaymentAuthorization = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(accountNr) {
      var existingLoans,
        message,
        code,
        _error$response2,
        _args3 = arguments;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              existingLoans = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : [];
              setShowSpinner(true);
              _context3.prev = 2;
              _context3.next = 5;
              return requestService.submitPaymentAuthorization(accountNr, existingLoans);
            case 5:
              checkApplicationSigningStatus();
              _context3.next = 14;
              break;
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](2);
              console.error(_context3.t0);
              message = _context3.t0.response.data.message;
              code = _context3.t0.response.status;
              if (code === 400 && message === "Valideringsfeil") {
                setPaymentAuthorizationError((_error$response2 = _context3.t0.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data);
              }
            case 14:
              _context3.prev = 14;
              setShowSpinner(false);
              return _context3.finish(14);
            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 8, 14, 17]]);
    }));
    return function submitPaymentAuthorization(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var uploadDocumentMultiple = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(uploadDocumentParamsList) {
      var _iterator, _step, docParams, _docParams, file, documentType, _docParams$, documentPassword;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setShowSpinner(true);

              // We use a regular for loop to allow the await to enforce synchronous calls.
              // eslint-disable-next-line no-restricted-syntax
              _iterator = _createForOfIteratorHelper(uploadDocumentParamsList);
              _context4.prev = 2;
              _iterator.s();
            case 4:
              if ((_step = _iterator.n()).done) {
                _context4.next = 11;
                break;
              }
              docParams = _step.value;
              _docParams = _slicedToArray$2(docParams, 3), file = _docParams[0], documentType = _docParams[1], _docParams$ = _docParams[2], documentPassword = _docParams$ === void 0 ? "" : _docParams$; // eslint-disable-next-line no-await-in-loop
              _context4.next = 9;
              return requestService.uploadDocument(isMainApplicant, file, documentType, documentPassword).then(function (response) {
                setApplicationSigningStatus(function (prev) {
                  return _objectSpread2$4(_objectSpread2$4({}, prev), response.data);
                });
              }).catch(function (error) {
                var _error$response$data2, _error$response3;
                console.error(error);
                var _ref6 = (_error$response$data2 = (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.data) !== null && _error$response$data2 !== void 0 ? _error$response$data2 : {},
                  message = _ref6.message;
                temporarilySetErrorsToDisplay("uploadDocument", message, 5);
              });
            case 9:
              _context4.next = 4;
              break;
            case 11:
              _context4.next = 16;
              break;
            case 13:
              _context4.prev = 13;
              _context4.t0 = _context4["catch"](2);
              _iterator.e(_context4.t0);
            case 16:
              _context4.prev = 16;
              _iterator.f();
              return _context4.finish(16);
            case 19:
              setShowSpinner(false);
              checkApplicationSigningStatus();
            case 21:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 13, 16, 19]]);
    }));
    return function uploadDocumentMultiple(_x3) {
      return _ref5.apply(this, arguments);
    };
  }();
  var registerDocumentsUploadedExternally = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(documentType) {
      var response, _error$response$data3, _error$response4, _ref8, message;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              setShowSpinner(true);
              _context5.prev = 1;
              _context5.next = 4;
              return requestService.registerDocumentsUploadedExternally(isMainApplicant, documentType);
            case 4:
              response = _context5.sent;
              setApplicationSigningStatus(function (prev) {
                return _objectSpread2$4(_objectSpread2$4({}, prev), response.data);
              });
              _context5.next = 12;
              break;
            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](1);
              _ref8 = (_error$response$data3 = (_error$response4 = _context5.t0.response) === null || _error$response4 === void 0 ? void 0 : _error$response4.data) !== null && _error$response$data3 !== void 0 ? _error$response$data3 : {}, message = _ref8.message;
              temporarilySetErrorsToDisplay("uploadDocument", message, 5);
            case 12:
              _context5.prev = 12;
              setShowSpinner(false);
              return _context5.finish(12);
            case 15:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 8, 12, 15]]);
    }));
    return function registerDocumentsUploadedExternally(_x4) {
      return _ref7.apply(this, arguments);
    };
  }();
  var getAltinnConsent = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var ssn, fullName, possibleLastNames, getAltinnConsentRequests;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              ssn = applicationSigningStatus.application[mainOrCoApplicantObjectKey].applicant.ssn;
              fullName = applicationSigningStatus.application[mainOrCoApplicantObjectKey].applicant.name; // The last name could be more than one
              possibleLastNames = fullName.split(" ").filter(function (_, i) {
                return i !== 0;
              }).map(function (_, i, array) {
                return array.slice(i).join(" ");
              }).reverse(); // "FirstName Middlename af Lastname" > ["Lastname", "af Lastname", "Midlename af Lastname"]
              getAltinnConsentRequests = possibleLastNames.map(function (lastName) {
                return requestService.getAltinnConsent(ssn, lastName);
              });
              setShowSpinner(true);
              Promise.any(getAltinnConsentRequests).then(function (response) {
                window.location.href = response.data.consent;
              }).catch(function (error) {
                var _error$response$data4, _error$response5;
                console.error(error);
                var _ref10 = (_error$response$data4 = (_error$response5 = error.response) === null || _error$response5 === void 0 ? void 0 : _error$response5.data) !== null && _error$response$data4 !== void 0 ? _error$response$data4 : {},
                  message = _ref10.message;
                temporarilySetErrorsToDisplay("getAltinnConsent", message, 5);
                setShowSpinner(false);
              });
            case 6:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return function getAltinnConsent() {
      return _ref9.apply(this, arguments);
    };
  }();
  var fetchAltinnTaxReturnsAndIncomeAndRegisterUploadeded = useCallback(function (authCode) {
    return requestService.fetchAltinnTaxReturnsAndIncome(authCode).then( /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(response) {
        var typesToRegister, _iterator2, _step2, type;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                typesToRegister = [].concat(_toConsumableArray$3(response.data.receivedPaycheck ? ["paycheck"] : []), _toConsumableArray$3(response.data.receivedTaxReturns ? ["taxreturn"] : [])); // eslint-disable-next-line no-restricted-syntax
                _iterator2 = _createForOfIteratorHelper(typesToRegister);
                _context7.prev = 2;
                _iterator2.s();
              case 4:
                if ((_step2 = _iterator2.n()).done) {
                  _context7.next = 10;
                  break;
                }
                type = _step2.value;
                _context7.next = 8;
                return requestService.registerDocumentsUploadedExternally(isMainApplicant, type);
              case 8:
                _context7.next = 4;
                break;
              case 10:
                _context7.next = 15;
                break;
              case 12:
                _context7.prev = 12;
                _context7.t0 = _context7["catch"](2);
                _iterator2.e(_context7.t0);
              case 15:
                _context7.prev = 15;
                _iterator2.f();
                return _context7.finish(15);
              case 18:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[2, 12, 15, 18]]);
      }));
      return function (_x5) {
        return _ref11.apply(this, arguments);
      };
    }());
  }, [requestService, isMainApplicant]);
  var chooseInsurance = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(acceptTerms, wantInsurance) {
      var ssn, response, _error$response$data5, _error$response6, _ref13, message;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              ssn = applicationSigningStatus.application.mainApplicantApplication.applicant.ssn;
              setShowSpinner(true);
              _context8.prev = 2;
              _context8.next = 5;
              return requestService.chooseInsurance(isMainApplicant, acceptTerms, wantInsurance, ssn);
            case 5:
              response = _context8.sent;
              setApplicationSigningStatus(function (prev) {
                return _objectSpread2$4(_objectSpread2$4({}, prev), response.data);
              });
              _context8.next = 14;
              break;
            case 9:
              _context8.prev = 9;
              _context8.t0 = _context8["catch"](2);
              console.error(_context8.t0);
              _ref13 = (_error$response$data5 = (_error$response6 = _context8.t0.response) === null || _error$response6 === void 0 ? void 0 : _error$response6.data) !== null && _error$response$data5 !== void 0 ? _error$response$data5 : {}, message = _ref13.message;
              temporarilySetErrorsToDisplay("chooseInsurance", message, 5);
            case 14:
              _context8.prev = 14;
              setShowSpinner(false);
              return _context8.finish(14);
            case 17:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[2, 9, 14, 17]]);
    }));
    return function chooseInsurance(_x6, _x7) {
      return _ref12.apply(this, arguments);
    };
  }();
  var fetchCreditors = /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
      var response;
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (!(creditors.length || fetchCreditorsRetryCount >= 3)) {
                _context9.next = 2;
                break;
              }
              return _context9.abrupt("return");
            case 2:
              _context9.prev = 2;
              _context9.next = 5;
              return requestService.fetchCreditors();
            case 5:
              response = _context9.sent;
              setCreditors(response.data);
              _context9.next = 12;
              break;
            case 9:
              _context9.prev = 9;
              _context9.t0 = _context9["catch"](2);
              console.error(_context9.t0);
            case 12:
              _context9.prev = 12;
              setFetchCreditorsRetryCount(fetchCreditorsRetryCount + 1);
              return _context9.finish(12);
            case 15:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[2, 9, 12, 15]]);
    }));
    return function fetchCreditors() {
      return _ref14.apply(this, arguments);
    };
  }();
  var fetchTrafficLightColor = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
    var response;
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            if (productType.endsWith("LOAN")) {
              _context10.next = 2;
              break;
            }
            return _context10.abrupt("return");
          case 2:
            _context10.prev = 2;
            _context10.next = 5;
            return requestService.fetchTrafficLightColor();
          case 5:
            response = _context10.sent;
            setTrafficLightColor(response.data);
            _context10.next = 12;
            break;
          case 9:
            _context10.prev = 9;
            _context10.t0 = _context10["catch"](2);
            console.error(_context10.t0);
          case 12:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[2, 9]]);
  })), [requestService, productType]);
  var validateKidAndAccount = /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(account, kid) {
      var response;
      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              _context11.next = 3;
              return requestService.validateKidAndAccount(account, kid);
            case 3:
              response = _context11.sent;
              return _context11.abrupt("return", {
                data: response.data,
                statusOk: true
              });
            case 7:
              _context11.prev = 7;
              _context11.t0 = _context11["catch"](0);
              console.log(_context11.t0);
              return _context11.abrupt("return", {
                statusOk: false
              });
            case 11:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[0, 7]]);
    }));
    return function validateKidAndAccount(_x8, _x9) {
      return _ref16.apply(this, arguments);
    };
  }();
  useEffect(function () {
    var _applicationSigningSt;
    if (!(applicationSigningStatus !== null && applicationSigningStatus !== void 0 && (_applicationSigningSt = applicationSigningStatus.application) !== null && _applicationSigningSt !== void 0 && _applicationSigningSt.applicationState)) return;
    var isStepFour = applicationSigningStatus.application.applicationState === "Tilbud sendt";

    // the applicationStateId !== 'DOC_RECEIVED' prevents duplicated push of this event
    var isStepFive = applicationStateId !== "DOC_RECEIVED" && applicationSigningStatus.application.applicationState === "All dokumentasjon mottatt";
    if (isStepFour) {
      gtmEventService().signing(productType, applicationId).pushStepFour();
    } else if (isStepFive) {
      gtmEventService().signing(productType, applicationId).pushStepFive();
    }
  }, [applicationId, applicationSigningStatus === null || applicationSigningStatus === void 0 ? void 0 : (_applicationSigningSt2 = applicationSigningStatus.application) === null || _applicationSigningSt2 === void 0 ? void 0 : _applicationSigningSt2.applicationState, applicationStateId, productType]);
  useEffect(function () {
    if (!userVerified) {
      return;
    }
    // The 'identified' search param is set after user has been redirected from BankID login
    if (hasParam("identified")) {
      setShowSpinner(true);
      var verifySignatureAndRemoveParam = /*#__PURE__*/function () {
        var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
          var _error$response$data6, _error$response7, _ref18, message, application, code;
          return regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  setBlockingError({});
                  _context12.prev = 1;
                  _context12.next = 4;
                  return requestService.verifySignature(isMainApplicant);
                case 4:
                  // Inform backend to check if logged in through BankId
                  removeIdentifiedUrlParameter();
                  checkApplicationSigningStatus();
                  _context12.next = 15;
                  break;
                case 8:
                  _context12.prev = 8;
                  _context12.t0 = _context12["catch"](1);
                  // handle 412 & 500 and render dynamic content from props
                  console.log("SigningActive::verifySignatureAndRemoveParam error: ", _context12.t0);
                  _ref18 = (_error$response$data6 = (_error$response7 = _context12.t0.response) === null || _error$response7 === void 0 ? void 0 : _error$response7.data) !== null && _error$response$data6 !== void 0 ? _error$response$data6 : {}, message = _ref18.message, application = _ref18.application;
                  code = _context12.t0.response.status;
                  setBlockingError({
                    code: code,
                    message: message,
                    productType: application === null || application === void 0 ? void 0 : application.productType
                  });
                  setTimeout(function () {
                    removeIdentifiedUrlParameter();
                    checkApplicationSigningStatus();
                  }, 3000);
                case 15:
                  _context12.prev = 15;
                  setShowSpinner(false);
                  return _context12.finish(15);
                case 18:
                case "end":
                  return _context12.stop();
              }
            }
          }, _callee12, null, [[1, 8, 15, 18]]);
        }));
        return function verifySignatureAndRemoveParam() {
          return _ref17.apply(this, arguments);
        };
      }();
      // When a user has signed in via BankID, the backend needs some time to process that before we ask to verify.
      setTimeout(verifySignatureAndRemoveParam, 5000);
    }
    // Redirected from Altinn login service
    else if (hasParam("AuthorizationCode")) {
      setShowSpinner(true);
      var getSsnThenFetchTaxAndIncomeThenRegisterUpload = /*#__PURE__*/function () {
        var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
          return regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  _context13.prev = 0;
                  _context13.next = 3;
                  return fetchAltinnTaxReturnsAndIncomeAndRegisterUploadeded(getParam("AuthorizationCode"));
                case 3:
                  removeAuthCodeParameter();
                  checkApplicationSigningStatus();
                  _context13.next = 10;
                  break;
                case 7:
                  _context13.prev = 7;
                  _context13.t0 = _context13["catch"](0);
                  console.log("got error in Altinn fetch", _context13.t0);
                case 10:
                  _context13.prev = 10;
                  setShowSpinner(false);
                  return _context13.finish(10);
                case 13:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13, null, [[0, 7, 10, 13]]);
        }));
        return function getSsnThenFetchTaxAndIncomeThenRegisterUpload() {
          return _ref19.apply(this, arguments);
        };
      }();
      getSsnThenFetchTaxAndIncomeThenRegisterUpload();
    } else if (!applicationSigningStatus.code) {
      // normal initial call
      checkApplicationSigningStatus();
      fetchTrafficLightColor();
    }
  }, [checkApplicationSigningStatus, fetchAltinnTaxReturnsAndIncomeAndRegisterUploadeded, fetchTrafficLightColor, mainOrCoApplicantObjectKey, requestService, isMainApplicant, userVerified, applicationSigningStatus.code]);
  if (isDeadEnd) {
    var title = deadEndTextBoxProps.title,
      subtitle = deadEndTextBoxProps.subtitle,
      text = deadEndTextBoxProps.text;
    return /*#__PURE__*/React__default.createElement(DeadEndTextBox, {
      title: title,
      subtitle: subtitle,
      text: text
    });
  }
  if (blockingError.code) {
    return /*#__PURE__*/React__default.createElement(DeadEndTextBox, {
      title: blockingError.message,
      titleProps: {
        style: {
          fontWeight: "400"
        }
      },
      isError: true
    });
  }
  var getContentToRender = function getContentToRender() {
    var _applicationSigningSt3, _applicationSigningSt4;
    if (consentDetails.shouldAskForConsent) {
      return /*#__PURE__*/React__default.createElement(ConsentView, {
        name: applicationSigningStatus.application[mainOrCoApplicantObjectKey].applicant.name,
        description: consentDetails.description,
        consentText: consentDetails.consentText,
        registerConsent: consentDetails.registerConsent,
        brandStyle: "ya"
      });
    }
    var mainOrCoApplicantapplication = applicationSigningStatus.application[mainOrCoApplicantObjectKey];
    var insuranceIsMandatory = (_applicationSigningSt3 = applicationSigningStatus === null || applicationSigningStatus === void 0 ? void 0 : (_applicationSigningSt4 = applicationSigningStatus.application) === null || _applicationSigningSt4 === void 0 ? void 0 : _applicationSigningSt4.insuranceIsMandatory) !== null && _applicationSigningSt3 !== void 0 ? _applicationSigningSt3 : false;
    return /*#__PURE__*/React__default.createElement(SigningPageRenderer, {
      nextStep: applicationSigningStatus.nextStep,
      isMainApplicant: isMainApplicant,
      name: mainOrCoApplicantapplication.applicant.name,
      accountNumber: applicationSigningStatus.application.accountNumber,
      chooseInsurance: chooseInsurance,
      insuranceTermsLink: insuranceTermsLink,
      termsOfPurchaseLink: termsOfPurchaseLink,
      submitPaymentAuthorization: submitPaymentAuthorization,
      uploadDocumentMultiple: uploadDocumentMultiple,
      chooseIdentificationMethod: chooseIdentificationMethod,
      registerDocumentsUploadedExternally: registerDocumentsUploadedExternally,
      getAltinnConsent: getAltinnConsent,
      creditors: creditors,
      fetchCreditors: fetchCreditors,
      documentsSigned: mainOrCoApplicantapplication.applicant.documentsSigned,
      paymentAuthorizationRequired: applicationSigningStatus.application.paymentAuthorizationRequired,
      loansToRefinance: applicationSigningStatus.loansToRefinance,
      customerDocuments: mainOrCoApplicantapplication.customerDocuments,
      creditAdjustedAmount: applicationSigningStatus.application.creditAdjustedAmount,
      showEndPage: showEndPage,
      setShowEndPage: function setShowEndPage() {
        _setShowEndPage(true);
      },
      insuranceIsMandatory: insuranceIsMandatory,
      validateKidAndAccount: validateKidAndAccount,
      trafficLightColor: trafficLightColor
    });
  };
  var shouldShowSpinner = !Object.keys(applicationSigningStatus).length || showSpinner || consentDetails.isLoading;
  return /*#__PURE__*/React__default.createElement(DisplayErrorsSigningContext.Provider, {
    value: errorsToDisplay
  }, Object.keys(applicationSigningStatus).length ? getContentToRender() : null, shouldShowSpinner ? /*#__PURE__*/React__default.createElement(LoadingOverlay, null) : null);
}
SigningActive.propTypes = {
  sblDomain: PropTypes.string.isRequired,
  cmsDomain: PropTypes.string.isRequired,
  insuranceTermsLink: PropTypes.string.isRequired,
  termsOfPurchaseLink: PropTypes.string.isRequired,
  consentManagerUrl: PropTypes.string.isRequired
};

function SecuredSigningActive$1(_ref) {
  var signingActiveData = _ref.signingActiveData,
    keycloakData = _ref.keycloakData;
  return /*#__PURE__*/React__default.createElement(SystemStatus, {
    cmsHelperUrl: signingActiveData.cmsDomain
  }, /*#__PURE__*/React__default.createElement(Auth, {
    url: keycloakData.url,
    realm: keycloakData.realm,
    clientId: keycloakData.clientId,
    targetPage: "SigningActive"
  }, /*#__PURE__*/React__default.createElement(SigningActive, {
    sblDomain: signingActiveData.sblDomain,
    cmsDomain: signingActiveData.cmsDomain,
    insuranceTermsLink: signingActiveData.insuranceTermsLink,
    termsOfPurchaseLink: signingActiveData.termsOfPurchaseLink,
    consentManagerUrl: signingActiveData.consentManagerUrl
  })));
}
SecuredSigningActive$1.propTypes = {
  signingActiveData: PropTypes.shape({
    sblDomain: PropTypes.string.isRequired,
    cmsDomain: PropTypes.string.isRequired,
    termsOfPurchaseLink: PropTypes.string.isRequired,
    insuranceTermsLink: PropTypes.string.isRequired,
    consentManagerUrl: PropTypes.string.isRequired
  }).isRequired,
  keycloakData: PropTypes.shape({
    url: PropTypes.string.isRequired,
    realm: PropTypes.string.isRequired,
    clientId: PropTypes.string.isRequired
  }).isRequired
};

var ErrorContext = /*#__PURE__*/createContext();
var useErrorContext = function useErrorContext() {
  return useContext(ErrorContext);
};
function ErrorProvider(_ref) {
  var children = _ref.children;
  var _useState = useState({}),
    _useState2 = _slicedToArray$2(_useState, 2),
    errorsToDisplay = _useState2[0],
    setErrorsToDisplay = _useState2[1];
  var temporarilySetErrorsToDisplay = function temporarilySetErrorsToDisplay(functionName) {
    var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Teknisk feil";
    var secondsBeforeClear = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
    setErrorsToDisplay(function (prev) {
      return _objectSpread2$4(_objectSpread2$4({}, prev), {}, _defineProperty$5({}, functionName, errorMessage));
    });
    setTimeout(function () {
      setErrorsToDisplay(function (prev) {
        return _objectSpread2$4(_objectSpread2$4({}, prev), {}, _defineProperty$5({}, functionName, null));
      });
    }, secondsBeforeClear * 1000);
  };
  var setPaymentAuthorizationError = function setPaymentAuthorizationError(paymentAuthorizationError) {
    setErrorsToDisplay(function (prev) {
      return _objectSpread2$4(_objectSpread2$4({}, prev), {}, {
        paymentAuthorizationError: paymentAuthorizationError
      });
    });
  };
  return /*#__PURE__*/React__default.createElement(ErrorContext.Provider, {
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    value: {
      errorsToDisplay: errorsToDisplay,
      temporarilySetErrorsToDisplay: temporarilySetErrorsToDisplay,
      setPaymentAuthorizationError: setPaymentAuthorizationError
    }
  }, children);
}
ErrorProvider.propTypes = {
  children: PropTypes.node
};
ErrorProvider.defaultProps = {
  children: undefined
};

function Insurance(props) {
  var termsOfPurchaseLink = props.termsOfPurchaseLink,
    insuranceTermsLink = props.insuranceTermsLink,
    chooseInsurance = props.chooseInsurance,
    name = props.name,
    insuranceIsMandatory = props.insuranceIsMandatory,
    brandStyle = props.brandStyle;
  var _useState = useState(false),
    _useState2 = _slicedToArray$2(_useState, 2),
    acceptTerms = _useState2[0],
    setAcceptTerms = _useState2[1];
  var _useState3 = useState(insuranceIsMandatory),
    _useState4 = _slicedToArray$2(_useState3, 2),
    wantInsurance = _useState4[0],
    setWantInsurance = _useState4[1];
  var displayErrorContext = useErrorContext();
  return /*#__PURE__*/React__default.createElement(RevertedGlobalResets, null, /*#__PURE__*/React__default.createElement("h2", null, "Identifisering: ", name), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
    id: "want-insurance-checkbox",
    disabled: insuranceIsMandatory,
    checked: wantInsurance,
    onchange: function onchange(e) {
      var checked = e.target.checked;
      setWantInsurance(checked);
      if (!checked) {
        setAcceptTerms(false);
      }
    }
  }, "Ja, jeg \xF8nsker yA Betalingsforsikring p\xE5 kredittkortet", insuranceIsMandatory && /*#__PURE__*/React__default.createElement("div", null, "(Du har allerede forsikring p\xE5 ditt eksisterende l\xE5n)"))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
    id: "insurance-accept-terms-checkbox",
    checked: acceptTerms,
    onchange: function onchange(e) {
      setAcceptTerms(e.target.checked);
    },
    disabled: !wantInsurance
  }, "Jeg har lest og forst\xE5tt", " ", /*#__PURE__*/React__default.createElement("a", {
    href: termsOfPurchaseLink,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "forkj\xF8psinformasjonen"), " ", "for", " ", /*#__PURE__*/React__default.createElement("a", {
    href: insuranceTermsLink,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "yA Betalingsforsikring"), " ", "og erkl\xE6rer at jeg:", /*#__PURE__*/React__default.createElement("ul", null, /*#__PURE__*/React__default.createElement("li", null, "er over 18 \xE5r men under 67 \xE5r, og p\xE5 forsikringes startdato har fats bosted i Norge, og er medlem av norsk folketrygd"), /*#__PURE__*/React__default.createElement("li", null, "er fast ansatt i minimum 50% stilling eller er selvstendig n\xE6ringsdrivende som ikke mottar sykepenger, dagpenger, uf\xF8retrygd eller lignende st\xF8nad eller erstatning (forsikringsdekningen som ytes under denne forsikringen kan variere ut i fra Forsikredes konkrete jobbstatus, i henhold til hva som er beskrevet heretter), og"), /*#__PURE__*/React__default.createElement("li", null, "ikke er kjent med, eller burde hatt grunn til \xE5 regne med, forest\xE5ende ufrivillig tap av arbeid"), /*#__PURE__*/React__default.createElement("li", null, "ikke er kjent med eksisterende sykdom, eller tilstand som kan medf\xF8re arbeidsuf\xF8rhet eller sykehusinnlegging")))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(BigButton, {
    type: "button",
    brandStyle: brandStyle,
    disabled: wantInsurance && !acceptTerms,
    onClick: function onClick() {
      chooseInsurance(acceptTerms, wantInsurance);
    }
  }, "G\xE5 vidare"), /*#__PURE__*/React__default.createElement(SimpleErrorLabel, {
    errorText: displayErrorContext.errorsToDisplay.chooseInsurance,
    positionAbsoluteHorizontallyCenter: true
  }));
}
Insurance.propTypes = {
  name: PropTypes.string.isRequired,
  termsOfPurchaseLink: PropTypes.string.isRequired,
  insuranceTermsLink: PropTypes.string.isRequired,
  chooseInsurance: PropTypes.func.isRequired,
  insuranceIsMandatory: PropTypes.bool.isRequired,
  brandStyle: PropTypes.oneOf(["ya", "yx"]).isRequired
};

var BankIDDesktopImage = "data:image/png;base64,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";

var HIGHINTERESTACCOUNT = {
	textAboveMethodList: {
		title: null,
		text: "På grunn av reglene i hvitvaskingsloven må du identifisere deg før du kan bli bankkunde.\nFor å signere kontrakten må du identifisere deg. Du kan identifisere deg på følgende måter:"
	},
	textAboveMethodListSigned: {
		title: null,
		text: "På grunn av reglene i hvitvaskingsloven må du identifisere deg før du kan bli bankkunde.\nFor å signere kontrakten må du identifisere deg. Du kan identifisere deg på følgende måter:"
	},
	identificationMethodButtonText: {
		BANKID: {
			title: "BankID"
		},
		BANKID_MOBILE: {
			title: "Bankid på mobil (gratis)",
			text: "Har du norsk BankID på mobil, kan du identifisere deg med denne. Bruker du smartmobil eller nettbrett, kan du oppleve at disse ikke støtter signering med BankID. Vi har derfor sendt deg en e-post med lenke du kan følge fra PC/mac. Ta kontakt med vårt kundesenter på telefon 23 20 46 00 eller pr e-post post@ya.no om du har spørsmål. "
		},
		LATER: {
			title: "Senere",
			text: "Har du ikke tilgang til BankID nå kan du komme tilbake og identifisere deg senere. Vi sender deg en påminnelse via e-post."
		}
	},
	contentEndPageSuccess: {
		title: "Gratulerer, du er innvilget yA Høyrentekonto!",
		text: "Nettbanken tilknyttet din nye konto vil være tilgjengelig i løpet av neste virkedag.\n\nVi skal gjøre vårt ytterste for at du skal bli en fornøyd yA-kunde!",
		creditCardTitle: "Vi tilbyr også et av Norges beste kredittkort",
		buttonLabel: "Gå videre till kredittkort",
		greeting: "Vennlig hilsen\nyA – en del av Resurs Bank"
	},
	contentEndPageLater: {
		title: "Kvittering",
		text: "Du er innvilget yA Høyrentekonto!\nDu får nå en e-post om valg av identifiseringsmåte.\nVennlig hilsen\nyA Bank"
	},
	contentEndPageInvalidState: {
		title: null,
		text: "Kjære kunde.\n\nDu har allerede identifisert deg så du kan se bort fra denne lenken.\n\nDin søknad er under behandling."
	},
	contentEndPageTechnicalError: {
		title: null,
		text: "Feil"
	}
};
var HIGHINTERESTACCOUNTPLUSS = {
	textAboveMethodList: {
		title: null,
		text: "På grunn av reglene i hvitvaskingsloven må du identifisere deg før du kan bli bankkunde.\nFor å signere kontrakten må du identifisere deg. Du kan identifisere deg på følgende måter:"
	},
	textAboveMethodListSigned: {
		title: null,
		text: "På grunn av reglene i hvitvaskingsloven må du identifisere deg før du kan bli bankkunde.\nFor å signere kontrakten må du identifisere deg. Du kan identifisere deg på følgende måter:"
	},
	identificationMethodButtonText: {
		BANKID: {
			title: "BankID"
		},
		BANKID_MOBILE: {
			title: "Bankid på mobil (gratis)",
			text: "Har du norsk BankID på mobil, kan du identifisere deg med denne. Bruker du smartmobil eller nettbrett, kan du oppleve at disse ikke støtter signering med BankID. Vi har derfor sendt deg en e-post med lenke du kan følge fra PC/mac. Ta kontakt med vårt kundesenter på telefon 23 20 46 00 eller pr e-post post@ya.no om du har spørsmål. "
		},
		LATER: {
			title: "Senere",
			text: "Har du ikke tilgang til BankID nå kan du komme tilbake og identifisere deg senere. Vi sender deg en påminnelse via e-post."
		}
	},
	contentEndPageSuccess: {
		title: "Gratulerer, du er innvilget yA Høyrentekonto Pluss!",
		text: "Nettbanken tilknyttet din nye konto vil være tilgjengelig i løpet av neste virkedag.\n\nVi skal gjøre vårt ytterste for at du skal bli en fornøyd yA-kunde!",
		creditCardTitle: "Vi tilbyr også et av Norges beste kredittkort",
		buttonLabel: "Gå videre till kredittkort",
		greeting: "Vennlig hilsen\nyA – en del av Resurs Bank"
	},
	contentEndPageLater: {
		title: "Kvittering",
		text: "Du er innvilget yA Høyrentekonto Pluss!\nDu får nå en e-post om valg av identifiseringsmåte.\nVennlig hilsen\nyA Bank"
	},
	contentEndPageInvalidState: {
		title: null,
		text: "Kjære kunde.\n\nDu har allerede identifisert deg så du kan se bort fra denne lenken.\n\nDin søknad er under behandling."
	},
	contentEndPageTechnicalError: {
		title: null,
		text: "Feil"
	}
};
var YX_CARD = {
	textAboveMethodList: {
		title: null,
		text: "Du er innvilget YX kredittkort. \nNeste steg er å signere avtalen med BankID. Når du har signert, vil du få tilgang til nettbanken din i løpet av 1-2 virkedager. Gå videre til signering ved å trykke på «BankID» under."
	},
	textAboveMethodListSigned: {
		title: null,
		text: "Du har nå signert avtalen, og kan gå videre til steg 2."
	},
	identificationMethodButtonText: {
		BANKID: {
			title: "BankID"
		},
		BANKID_MOBILE: {
			title: "Bankid på mobil (gratis)",
			text: "Har du norsk BankID på mobil, kan du identifisere deg med denne. Bruker du smartmobil eller nettbrett, kan du oppleve at disse ikke støtter signering med BankID. Vi har derfor sendt deg en e-post med lenke du kan følge fra PC/mac. Ta kontakt med vårt kundesenter på telefon 23 20 46 00 eller pr e-post post@ya.no om du har spørsmål. "
		},
		LATER: {
			title: "Senere",
			text: "Har du ikke tilgang til BankID nå kan du komme tilbake og identifisere deg senere. Vi sender deg en påminnelse via e-post."
		}
	},
	contentEndPagePendingMain: {
		title: null,
		text: "Gratulerer!\nDu er nå identifisert i våre systemer.\nKort og PIN-koder sendes så snart også hovedkortinnehaver identifiserer seg.\nVennlig hilsen\nYX Visa"
	},
	contentEndPagePendingSubsidary: {
		title: null,
		text: "Gratulerer!\nDu er nå identifisert i våre systemer.\nKort og PIN-koder sendes så snart også tilleggskortinnehaver identifiserer seg.\nVennlig hilsen\nYX Visa"
	},
	contentEndPageSuccess: {
		title: "Kvittering",
		text: "Gratulerer! Du er innvilget YX Visa-kort!\nKredittrammen er gitt under forutsetning av at de opplysninger du har oppgitt er korrekte.\nNettbanken din vil være tilgjengelig om 1-2 arbeidsdager – her kan du betale regninger og overføre penger til deg selv.\nVennlig hilsen\nYX Visa"
	},
	contentEndPageLater: {
		title: "Kvittering",
		text: "Du er innvilget YX Visa-kort!\nDu får nå en e-post om valg av identifiseringsmåte.\nVennlig hilsen\nYX Visa"
	},
	contentEndPageInvalidState: {
		title: null,
		text: "Kjære kunde.\n\nDu har allerede identifisert deg så du kan se bort fra denne lenken.\n\nDin søknad er under behandling."
	},
	contentEndPageTechnicalError: {
		title: null,
		text: "Feil"
	},
	contentEndPageSblHasNoInfo: {
		title: "Takk for din søknad om YX Visa.",
		text: "På bakgrunn av manglende opplysninger fra offentlige register (f.eks. skatteetaten) kan vi dessverre ikke innvilge din søknad.\n\nVi takker for din interesse.\n\nMed vennlig hilsen\nResurs og YX"
	}
};
var CREDIT_CARD = {
	textAboveMethodList: {
		title: null,
		text: "Du er innvilget yA Kredittkort.\nNår du har signert vil du få tilgang til nettbanken din i løpet av 1-2 arbeidsdager. Her kan du betale regninger og overføre penger til deg selv.\nFor å signere kontrakten må du identifisere deg. Du kan identifisere deg på følgende måter:"
	},
	textAboveMethodListSigned: {
		title: null,
		text: "Du er innvilget yA Kredittkort.\nNår du har signert vil du få tilgang til nettbanken din i løpet av 1-2 arbeidsdager. Her kan du betale regninger og overføre penger til deg selv.\nFor å signere kontrakten må du identifisere deg. Du kan identifisere deg på følgende måter:"
	},
	identificationMethodButtonText: {
		BANKID: {
			title: "BankID"
		},
		BANKID_MOBILE: {
			title: "Bankid på mobil (gratis)",
			text: "Har du norsk BankID på mobil, kan du identifisere deg med denne. Bruker du smartmobil eller nettbrett, kan du oppleve at disse ikke støtter signering med BankID. Vi har derfor sendt deg en e-post med lenke du kan følge fra PC/mac. Ta kontakt med vårt kundesenter på telefon 23 20 46 00 eller pr e-post post@ya.no om du har spørsmål. "
		},
		LATER: {
			title: "Senere",
			text: "Har du ikke tilgang til BankID nå kan du komme tilbake og identifisere deg senere. Vi sender deg en påminnelse via e-post."
		}
	},
	contentEndPageSuccess: {
		title: "Kvittering",
		text: "Gratulerer! Du er innvilget yA Kredittkort!\nKredittrammen er gitt under forutsetning av at de opplysninger du har oppgitt er korrekte.\nNettbanken din vil være tilgjengelig om 1-2 arbeidsdager – her kan du betale regninger og overføre penger til deg selv.\nVennlig hilsen\nyA Bank"
	},
	contentEndPageLater: {
		title: "Kvittering",
		text: "Du er innvilget yA Kredittkort!\nDu får nå en e-post om valg av identifiseringsmåte.\nVennlig hilsen\nyA Bank"
	},
	contentEndPageInvalidState: {
		title: null,
		text: "Kjære kunde.\n\nDu har allerede identifisert deg så du kan se bort fra denne lenken.\n\nDin søknad er under behandling."
	},
	contentEndPageTechnicalError: {
		title: null,
		text: "Feil"
	}
};
var ACCOUNT = {
	textAboveMethodList: {
		title: null,
		text: "På grunn av reglene i hvitvaskingsloven må du identifisere deg før du kan bli bankkunde.\nFor å signere kontrakten må du identifisere deg. Du kan identifisere deg på følgende måter:"
	},
	textAboveMethodListSigned: {
		title: null,
		text: "På grunn av reglene i hvitvaskingsloven må du identifisere deg før du kan bli bankkunde.\nFor å signere kontrakten må du identifisere deg. Du kan identifisere deg på følgende måter:"
	},
	identificationMethodButtonText: {
		BANKID: {
			title: "BankID"
		},
		BANKID_MOBILE: {
			title: "Bankid på mobil (gratis)",
			text: "Har du norsk BankID på mobil, kan du identifisere deg med denne. Bruker du smartmobil eller nettbrett, kan du oppleve at disse ikke støtter signering med BankID. Vi har derfor sendt deg en e-post med lenke du kan følge fra PC/mac. Ta kontakt med vårt kundesenter på telefon 23 20 46 00 eller pr e-post post@ya.no om du har spørsmål. "
		},
		LATER: {
			title: "Senere",
			text: "Har du ikke tilgang til BankID nå kan du komme tilbake og identifisere deg senere. Vi sender deg en påminnelse via e-post."
		}
	},
	contentEndPageSuccess: {
		title: "Gratulerer, du er innvilget yA Brukskonto!",
		text: "Du vil i løpet av få dager få tilsendt ditt nye kort og PIN- kode. Bruk av yA Mastercard-kort er gebyrfritt! Årsavgiften på Mastercard-kortet er kun kr 250,-.\n\nNettbanken tilknyttet din nye konto vil være tilgjengelig i løpet av neste virkedag.\n\nVi skal gjøre vårt ytterste for at du skal bli en fornøyd yA-kunde!",
		creditCardTitle: "Vi tilbyr også et av Norges beste kredittkort",
		buttonLabel: "Gå videre till kredittkort",
		greeting: "Vennlig hilsen\nyA – en del av Resurs Bank"
	},
	contentEndPageLater: {
		title: "Kvittering",
		text: "Du er innvilget yA Brukskonto!\nDu får nå en e-post om valg av identifiseringsmåte.\nVennlig hilsen\nyA Bank"
	},
	contentEndPageInvalidState: {
		title: null,
		text: "Kjære kunde.\n\nDu har allerede identifisert deg så du kan se bort fra denne lenken.\n\nDin søknad er under behandling."
	},
	contentEndPageTechnicalError: {
		title: null,
		text: "Feil"
	}
};
var texts = {
	HIGHINTERESTACCOUNT: HIGHINTERESTACCOUNT,
	HIGHINTERESTACCOUNTPLUSS: HIGHINTERESTACCOUNTPLUSS,
	YX_CARD: YX_CARD,
	CREDIT_CARD: CREDIT_CARD,
	ACCOUNT: ACCOUNT
};

var TextContext = /*#__PURE__*/createContext(texts);
var useTextContext = function useTextContext() {
  return useContext(TextContext);
};
function TextProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(TextContext.Provider, {
    value: texts
  }, children);
}
TextProvider.propTypes = {
  children: PropTypes.node
};
TextProvider.defaultProps = {
  children: undefined
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var IdentificationMethodItemContainer = createStyled("div", "development" === "production" ? {
  target: "e16v0o7z0"
} : {
  target: "e16v0o7z0",
  label: "IdentificationMethodItemContainer"
})("development" === "production" ? {
  name: "166ho7v",
  styles: "display:inline-flex;justify-content:space-between;cursor:pointer;margin:0px;width:45rem;background-color:white;align-items:center;padding:0rem 3rem 0rem 3rem;min-height:150px;border:solid lightgray 1px;border-radius:15px;.option-item-image{max-width:250px;img,svg{width:100%;}}.regular-size-image{max-width:250px;}.small-size-image{max-width:80px;}.option-item-title{color:#656565;font-size:3rem;}@media only screen and (max-width: 650px){grid-template-columns:auto-fit 50px;grid-template-rows:0.8fr 1fr;grid-template-areas:\"image image arrow\" \"title-and-text title-and-text arrow\";h2,p{margin:0 5px;}.option-item-image{margin:auto;img,svg{max-height:80px;margin:10px;}}}"
} : {
  name: "166ho7v",
  styles: "display:inline-flex;justify-content:space-between;cursor:pointer;margin:0px;width:45rem;background-color:white;align-items:center;padding:0rem 3rem 0rem 3rem;min-height:150px;border:solid lightgray 1px;border-radius:15px;.option-item-image{max-width:250px;img,svg{width:100%;}}.regular-size-image{max-width:250px;}.small-size-image{max-width:80px;}.option-item-title{color:#656565;font-size:3rem;}@media only screen and (max-width: 650px){grid-template-columns:auto-fit 50px;grid-template-rows:0.8fr 1fr;grid-template-areas:\"image image arrow\" \"title-and-text title-and-text arrow\";h2,p{margin:0 5px;}.option-item-image{margin:auto;img,svg{max-height:80px;margin:10px;}}}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
});
function OptionItem(_ref) {
  var imageJsx = _ref.imageJsx,
    title = _ref.title,
    identificationMethod = _ref.identificationMethod,
    brandStyle = _ref.brandStyle,
    chooseIdentificationMethod = _ref.chooseIdentificationMethod,
    style = _ref.style,
    smallImage = _ref.smallImage;
  var brandColor = brandStyle === "yx" ? colors$1.freshRed : colors$1.primaryGreen;
  var imageSizeClass = smallImage ? "option-item-image small-size-image" : "option-item-image regular-size-image";
  var displayErrorContext = useErrorContext();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(IdentificationMethodItemContainer, {
    style: style,
    onClick: function onClick() {
      return chooseIdentificationMethod(identificationMethod);
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: imageSizeClass
  }, imageJsx), /*#__PURE__*/React__default.createElement("div", {
    className: "option-item-title"
  }, /*#__PURE__*/React__default.createElement("h2", null, title)), /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    className: "option-item-arrow",
    icon: faChevronRight,
    size: "4x",
    color: brandColor
  })), /*#__PURE__*/React__default.createElement(SimpleErrorLabel, {
    errorText: displayErrorContext.errorsToDisplay.chooseIdentificationMethod,
    positionAbsoluteHorizontallyCenter: true
  }));
}
OptionItem.propTypes = {
  imageJsx: PropTypes.element.isRequired,
  identificationMethod: PropTypes.oneOf(["BANKID", "LATER"]).isRequired,
  brandStyle: PropTypes.oneOf(["ya", "yx"]).isRequired,
  chooseIdentificationMethod: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
  title: PropTypes.string,
  smallImage: PropTypes.bool
};
OptionItem.defaultProps = {
  style: {},
  title: undefined,
  smallImage: false
};
function MethodsList(props) {
  var chooseIdentificationMethod = props.chooseIdentificationMethod,
    productType = props.productType,
    brandStyle = props.brandStyle;
  var content = useTextContext();
  var identificationMethodButtonText = content[productType].identificationMethodButtonText;
  var IDENTIFICATION_METHOD = {
    BANKID: "BANKID",
    LATER: "LATER"
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OptionItem, {
    chooseIdentificationMethod: chooseIdentificationMethod,
    brandStyle: brandStyle,
    style: {
      marginTop: "2rem",
      marginBottom: "2rem"
    },
    imageJsx: /*#__PURE__*/React__default.createElement("img", {
      style: {
        filter: "grayscale()"
      },
      src: BankIDDesktopImage,
      alt: "bank id brikke"
    }),
    identificationMethod: IDENTIFICATION_METHOD.BANKID
  }), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(OptionItem, {
    chooseIdentificationMethod: chooseIdentificationMethod,
    brandStyle: brandStyle,
    smallImage: true,
    imageJsx: /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
      icon: faClock,
      size: "7x",
      color: "lightgrey"
    }),
    title: identificationMethodButtonText[IDENTIFICATION_METHOD.LATER].title,
    identificationMethod: IDENTIFICATION_METHOD.LATER
  }));
}
MethodsList.propTypes = {
  chooseIdentificationMethod: PropTypes.func.isRequired,
  brandStyle: PropTypes.oneOf(["ya", "yx"]).isRequired,
  productType: PropTypes.string.isRequired
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var primaryGreen = colors$1.primaryGreen,
  secondaryGreen = colors$1.secondaryGreen,
  white = colors$1.white;
var Paragraph = createStyled("p", "development" === "production" ? {
  target: "ec8uk9a3"
} : {
  target: "ec8uk9a3",
  label: "Paragraph"
})("development" === "production" ? {
  name: "17vfndq",
  styles: "white-space:pre-wrap;margin-top:3rem"
} : {
  name: "17vfndq",
  styles: "white-space:pre-wrap;margin-top:3rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});
var Title = createStyled("span", "development" === "production" ? {
  target: "ec8uk9a2"
} : {
  target: "ec8uk9a2",
  label: "Title"
})("development" === "production" ? {
  name: "hysfgu",
  styles: "font-size:1.5em;font-weight:800"
} : {
  name: "hysfgu",
  styles: "font-size:1.5em;font-weight:800",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});
var StepNumberIcon = createStyled("span", "development" === "production" ? {
  target: "ec8uk9a1"
} : {
  target: "ec8uk9a1",
  label: "StepNumberIcon"
})("display:inline-block;box-sizing:border-box;border-radius:50%;width:45px;height:45px;background:", function (props) {
  return props.completed ? secondaryGreen : white;
}, ";border:1px solid ", primaryGreen, ";color:", function (props) {
  return props.completed ? white : primaryGreen;
}, ";text-align:center;font-size:200%;line-height:45px;font-weight:bold;margin-right:10px;" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var FlexContainer = createStyled("div", "development" === "production" ? {
  target: "ec8uk9a0"
} : {
  target: "ec8uk9a0",
  label: "FlexContainer"
})("development" === "production" ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : {
  name: "s5xdrg",
  styles: "display:flex;align-items:center",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});
function TitleAndText(props) {
  var title = props.title,
    stepNumber = props.stepNumber,
    completed = props.completed,
    showStep = props.showStep,
    children = props.children;
  var titlePart = /*#__PURE__*/React__default.createElement(Title, null, title);
  if (showStep) {
    titlePart = /*#__PURE__*/React__default.createElement(FlexContainer, null, /*#__PURE__*/React__default.createElement(StepNumberIcon, {
      completed: completed
    }, stepNumber), /*#__PURE__*/React__default.createElement(Title, null, title));
  }
  var childrenPart = /*#__PURE__*/React__default.createElement(Paragraph, null, children);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, title && titlePart, children && childrenPart);
}
TitleAndText.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  stepNumber: PropTypes.string,
  completed: PropTypes.bool,
  showStep: PropTypes.bool
};
TitleAndText.defaultProps = {
  title: undefined,
  children: undefined,
  stepNumber: undefined,
  completed: false,
  showStep: false
};

function GoToCoApplicantButton(props) {
  var productType = props.productType,
    brandStyle = props.brandStyle;
  var keycloakResult = useContext(AuthContext);
  var isCard = productType.includes("_CARD");
  return /*#__PURE__*/React__default.createElement(Button, {
    label: isCard ? "Tilleggskortinnehaver" : "Medlåntaker",
    onclick: keycloakResult.logout,
    textAlign: "center",
    brandStyle: brandStyle
  });
}
GoToCoApplicantButton.propTypes = {
  productType: PropTypes.string.isRequired,
  brandStyle: PropTypes.oneOf(["ya", "yx"]).isRequired
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var stepContainerWidthInPx = 700;
var stepContainerWidth = "".concat(stepContainerWidthInPx, "px");
var FetchFromAltinnBtnContainer = createStyled("div", "development" === "production" ? {
  target: "eilu9mk3"
} : {
  target: "eilu9mk3",
  label: "FetchFromAltinnBtnContainer"
})("development" === "production" ? {
  name: "1ns8ucd",
  styles: "text-align:left;button{font-size:18px;}"
} : {
  name: "1ns8ucd",
  styles: "text-align:left;button{font-size:18px;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});
var StepContentContainer = createStyled("div", "development" === "production" ? {
  target: "eilu9mk2"
} : {
  target: "eilu9mk2",
  label: "StepContentContainer"
})("development" === "production" ? {
  name: "1okb6a7",
  styles: "padding-bottom:30px;padding-top:10px"
} : {
  name: "1okb6a7",
  styles: "padding-bottom:30px;padding-top:10px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZldGNoRG9jdW1lbnRzLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFtQnVDIiwiZmlsZSI6IkZldGNoRG9jdW1lbnRzLmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiO1xuLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIGltcG9ydC9uby11bnJlc29sdmVkXG5pbXBvcnQgeyBCdXR0b24gYXMgRm9ybVVpQnV0dG9uIH0gZnJvbSBcIi4uL3VpXCI7XG5cbmltcG9ydCBTaW1wbGVFcnJvckxhYmVsIGZyb20gXCIuLi9zaGFyZWQvU2ltcGxlRXJyb3JMYWJlbFwiO1xuaW1wb3J0IHsgdXNlRXJyb3JDb250ZXh0IH0gZnJvbSBcIi4vc2hhcmVkL0Vycm9yUHJvdmlkZXJcIjtcblxuY29uc3Qgc3RlcENvbnRhaW5lcldpZHRoSW5QeCA9IDcwMDtcbmNvbnN0IHN0ZXBDb250YWluZXJXaWR0aCA9IGAke3N0ZXBDb250YWluZXJXaWR0aEluUHh9cHhgO1xuXG5jb25zdCBGZXRjaEZyb21BbHRpbm5CdG5Db250YWluZXIgPSBzdHlsZWQuZGl2YFxuICB0ZXh0LWFsaWduOiBsZWZ0O1xuICBidXR0b24ge1xuICAgIGZvbnQtc2l6ZTogMThweDtcbiAgfVxuYDtcblxuY29uc3QgU3RlcENvbnRlbnRDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICBwYWRkaW5nLWJvdHRvbTogMzBweDtcbiAgcGFkZGluZy10b3A6IDEwcHg7XG5gO1xuXG5jb25zdCBTdGVwU2VjdGlvbkhlYWRlciA9IHN0eWxlZC5oNGBcbiAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gIHRleHQtYWxpZ246IGxlZnQ7XG4gIGNvbG9yOiBibGFjaztcbiAgbWFyZ2luLWJvdHRvbTogMXJlbTtcbmA7XG5cbmNvbnN0IFN0ZXBTZWN0aW9uUGFyYWdyYXBoID0gc3R5bGVkLnBgXG4gIG1heC13aWR0aDogJHtzdGVwQ29udGFpbmVyV2lkdGh9O1xuICB3aWR0aDogODAlO1xuICBwYWRkaW5nLXRvcDogMnB4O1xuICBwYWRkaW5nLWJvdHRvbTogNXB4O1xuYDtcblxuZnVuY3Rpb24gRmV0Y2hEb2N1bWVudHMocHJvcHMpIHtcbiAgY29uc3QgeyBnZXRBbHRpbm5Db25zZW50IH0gPSBwcm9wcztcbiAgY29uc3QgZGlzcGxheUVycm9yQ29udGV4dCA9IHVzZUVycm9yQ29udGV4dCgpO1xuXG4gIHJldHVybiAoXG4gICAgPFN0ZXBDb250ZW50Q29udGFpbmVyPlxuICAgICAgPFN0ZXBTZWN0aW9uSGVhZGVyPkhlbnQgZG9rdW1lbnRhc2pvbiBmcmEgc2thdHRlZXRhdGVuPC9TdGVwU2VjdGlvbkhlYWRlcj5cbiAgICAgIDxTdGVwU2VjdGlvblBhcmFncmFwaD5cbiAgICAgICAgRXR0ZXIgYXQgZHUgaGFyIGdpdHQgZGl0dCBzYW10eWtrZSwgbGV2ZXJlciBTa2F0dGVldGF0ZW4gb3BwbHlzbmluZ2VyIG9tIGRpdHQgc2thdHRlZ3J1bm5sYWdcbiAgICAgICAgb2cgaW5udGVrdCBkaXJla3RlIHRpbCBSZXN1cnMgQmFuay4gT3BwbHlzbmluZ2VuZSBza2FsIGJydWtlcyDDqW4gZ2FuZyB0aWwgYmVoYW5kbGluZyBhdiBkaW5cbiAgICAgICAgbMOlbmVzw7hrbmFkLlxuICAgICAgPC9TdGVwU2VjdGlvblBhcmFncmFwaD5cblxuICAgICAgPEZldGNoRnJvbUFsdGlubkJ0bkNvbnRhaW5lcj5cbiAgICAgICAgPEZvcm1VaUJ1dHRvblxuICAgICAgICAgIGxhYmVsPVwiSGVudCBkb2t1bWVudGFzam9uIGZyYSBBbHRpbm5cIlxuICAgICAgICAgIG9uY2xpY2s9e2dldEFsdGlubkNvbnNlbnR9XG4gICAgICAgICAgdGV4dEFsaWduPVwiY2VudGVyXCJcbiAgICAgICAgICBtYXhXaWR0aD1cIjIyZW1cIlxuICAgICAgICAvPlxuICAgICAgPC9GZXRjaEZyb21BbHRpbm5CdG5Db250YWluZXI+XG4gICAgICA8U2ltcGxlRXJyb3JMYWJlbFxuICAgICAgICBlcnJvclRleHQ9e2Rpc3BsYXlFcnJvckNvbnRleHQuZXJyb3JzVG9EaXNwbGF5LmdldEFsdGlubkNvbnNlbnR9XG4gICAgICAgIHBvc2l0aW9uQWJzb2x1dGVIb3Jpem9udGFsbHlDZW50ZXJcbiAgICAgIC8+XG4gICAgPC9TdGVwQ29udGVudENvbnRhaW5lcj5cbiAgKTtcbn1cblxuRmV0Y2hEb2N1bWVudHMucHJvcFR5cGVzID0ge1xuICAvLyBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgcmVhY3QvZm9yYmlkLXByb3AtdHlwZXNcbiAgZ2V0QWx0aW5uQ29uc2VudDogUHJvcFR5cGVzLmZ1bmMuaXNSZXF1aXJlZCxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IEZldGNoRG9jdW1lbnRzO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});
var StepSectionHeader = createStyled("h4", "development" === "production" ? {
  target: "eilu9mk1"
} : {
  target: "eilu9mk1",
  label: "StepSectionHeader"
})("development" === "production" ? {
  name: "k39itr",
  styles: "font-weight:bold;text-align:left;color:black;margin-bottom:1rem"
} : {
  name: "k39itr",
  styles: "font-weight:bold;text-align:left;color:black;margin-bottom:1rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});
var StepSectionParagraph = createStyled("p", "development" === "production" ? {
  target: "eilu9mk0"
} : {
  target: "eilu9mk0",
  label: "StepSectionParagraph"
})("max-width:", stepContainerWidth, ";width:80%;padding-top:2px;padding-bottom:5px;" + ("development" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
function FetchDocuments(props) {
  var getAltinnConsent = props.getAltinnConsent;
  var displayErrorContext = useErrorContext();
  return /*#__PURE__*/React__default.createElement(StepContentContainer, null, /*#__PURE__*/React__default.createElement(StepSectionHeader, null, "Hent dokumentasjon fra skatteetaten"), /*#__PURE__*/React__default.createElement(StepSectionParagraph, null, "Etter at du har gitt ditt samtykke, leverer Skatteetaten opplysninger om ditt skattegrunnlag og inntekt direkte til Resurs Bank. Opplysningene skal brukes \xE9n gang til behandling av din l\xE5nes\xF8knad."), /*#__PURE__*/React__default.createElement(FetchFromAltinnBtnContainer, null, /*#__PURE__*/React__default.createElement(Button, {
    label: "Hent dokumentasjon fra Altinn",
    onclick: getAltinnConsent,
    textAlign: "center",
    maxWidth: "22em"
  })), /*#__PURE__*/React__default.createElement(SimpleErrorLabel, {
    errorText: displayErrorContext.errorsToDisplay.getAltinnConsent,
    positionAbsoluteHorizontallyCenter: true
  }));
}
FetchDocuments.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  getAltinnConsent: PropTypes.func.isRequired
};

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var NEXT_STEP = {
  INSURACE: "insurance",
  METHOD: "method",
  DOCUMENTATION: "documentation",
  CONFIRMATION: "confirmation",
  COMPLETE: "complete"
};
var SIGNATUR_PROCESS_STATE = {
  PENDING_SUBSIDIARY: "PENDING_SUBSIDIARY",
  PENDING_MAIN: "PENDING_MAIN",
  PENDING_BOTH: "PENDING_BOTH",
  COMPLETE: "COMPLETE",
  USER_CANCELLED: "USER_CANCELLED",
  UNKNOWN_ERROR: "UNKNOWN_ERROR",
  WRONG_USER: "WRONG_USER",
  TIMEOUT: "TIMEOUT"
};
var PAGE = {
  INSURANCE: "INSURANCE",
  LATER: "LATER",
  METHOD: "METHOD",
  PENDING_MAIN: "PENDING_MAIN",
  PENDING_SUBSIDIARY: "PENDING_SUBSIDIARY",
  SUCCESS: "SUCCESS",
  ACCOUNT_SUCCESS: "ACCOUNT_SUCCESS",
  YX_SUCCESS: "YX_SUCCESS",
  ERROR: "ERROR",
  MISSING: "MISSING",
  PENDING_MAIN_UPLOAD_DOC: "PENDING_MAIN_UPLOAD_DOC",
  SBL_HAS_NO_INFO: "SBL_HAS_NO_INFO"
};
var IdentificationWrapper = createStyled("div", "development" === "production" ? {
  target: "e11rp34s2"
} : {
  target: "e11rp34s2",
  label: "IdentificationWrapper"
})("development" === "production" ? {
  name: "16bh8k8",
  styles: "margin:20px auto;max-width:800px"
} : {
  name: "16bh8k8",
  styles: "margin:20px auto;max-width:800px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var H3 = createStyled("h3", "development" === "production" ? {
  target: "e11rp34s1"
} : {
  target: "e11rp34s1",
  label: "H3"
})("development" === "production" ? {
  name: "16wxvjy",
  styles: "padding:revert;margin:revert"
} : {
  name: "16wxvjy",
  styles: "padding:revert;margin:revert",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var ParagraphDivider = createStyled("div", "development" === "production" ? {
  target: "e11rp34s0"
} : {
  target: "e11rp34s0",
  label: "ParagraphDivider"
})("development" === "production" ? {
  name: "163ewy1",
  styles: "height:5rem"
} : {
  name: "163ewy1",
  styles: "height:5rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
function IdentificationPageRenderer(props) {
  var nextStep = props.nextStep,
    signatureProcessState = props.signatureProcessState,
    name = props.name,
    amountInKr = props.amountInKr,
    productType = props.productType,
    willIdentifyLater = props.willIdentifyLater,
    insuranceTermsLink = props.insuranceTermsLink,
    termsOfPurchaseLink = props.termsOfPurchaseLink,
    chooseInsurance = props.chooseInsurance,
    chooseIdentificationMethod = props.chooseIdentificationMethod,
    insuranceIsMandatory = props.insuranceIsMandatory,
    trafficLightColor = props.trafficLightColor,
    getAltinnConsent = props.getAltinnConsent,
    customerDocuments = props.customerDocuments,
    applicationState = props.applicationState,
    isMainApplicant = props.isMainApplicant,
    sblHasNoInfo = props.sblHasNoInfo,
    campaignId = props.campaignId;
  var extendedProductType = productType;
  if (productType === "HIGHINTERESTACCOUNT" && campaignId === "yahoyrentekonotpluss") {
    extendedProductType = "HIGHINTERESTACCOUNTPLUSS";
  }
  var content = useTextContext();
  var productIsYxvisa = productType.includes("YX_");
  var productIsAccount = productType.includes("ACCOUNT");
  var documentsSigned = applicationState === "SIGNED_PENDING_DOC" || applicationState === "DOC_RECEIVED" || isMainApplicant && signatureProcessState === "PENDING_SUBSIDIARY" || !isMainApplicant && signatureProcessState === "PENDING_MAIN";
  var brandStyle = productType.includes("YX_") ? "yx" : "ya";
  var uploadDocumentsReceived = customerDocuments.filter(function (_ref) {
    var documentState = _ref.documentState;
    return documentState === "Received";
  });
  var sblNeeded = customerDocuments.length > 0;
  var allDocumentsUploaded = uploadDocumentsReceived.length === customerDocuments.length;
  var getRegularSuccessPage = function getRegularSuccessPage() {
    var contentEndPageSuccess = content[productType].contentEndPageSuccess;
    return /*#__PURE__*/React__default.createElement(TitleAndText, {
      title: contentEndPageSuccess.title
    }, contentEndPageSuccess.text);
  };
  var getYxSuccessPage = function getYxSuccessPage() {
    // Redirect to yx-page
    window.location.href = "https://yx.no/takk-for-din-bestilling/";
    return null;
  };
  var isErrorState = function isErrorState(nextStep) {
    switch (nextStep) {
      case SIGNATUR_PROCESS_STATE.UNKNOWN_ERROR:
      case SIGNATUR_PROCESS_STATE.WRONG_USER:
      case SIGNATUR_PROCESS_STATE.PENDING_BOTH:
      case SIGNATUR_PROCESS_STATE.USER_CANCELLED:
      case SIGNATUR_PROCESS_STATE.TIMEOUT:
        return true;
      default:
        return false;
    }
  };
  var getPageToShowGeneric = function getPageToShowGeneric(willIdentifyLater, nextStep, signatureProcessState) {
    if (willIdentifyLater) {
      return PAGE.LATER;
    }
    if (nextStep === NEXT_STEP.INSURACE) {
      return PAGE.INSURANCE;
    }
    if (nextStep === NEXT_STEP.METHOD) {
      return PAGE.METHOD;
    }
    if (nextStep === NEXT_STEP.CONFIRMATION && signatureProcessState === SIGNATUR_PROCESS_STATE.COMPLETE) {
      if (productIsAccount) {
        return PAGE.ACCOUNT_SUCCESS;
      }
      return PAGE.SUCCESS;
    }
    return PAGE.ERROR;
  };
  var getPageToShowYxVisa = function getPageToShowYxVisa(willIdentifyLater, nextStep, signatureProcessState, applicationState, isMainApplicant, sblHasNoInfo) {
    var mainSigningComplete = signatureProcessState === SIGNATUR_PROCESS_STATE.PENDING_SUBSIDIARY || signatureProcessState === SIGNATUR_PROCESS_STATE.COMPLETE;
    var subsidiarySigningComplete = signatureProcessState === SIGNATUR_PROCESS_STATE.PENDING_MAIN || signatureProcessState === SIGNATUR_PROCESS_STATE.COMPLETE;
    if (willIdentifyLater) {
      return PAGE.LATER;
    }
    if (nextStep === NEXT_STEP.INSURACE) {
      return PAGE.INSURANCE;
    }
    if (applicationState === "DOC_RECEIVED") {
      return PAGE.YX_SUCCESS;
    }
    if (isErrorState(nextStep)) {
      return PAGE.ERROR;
    }
    if (isMainApplicant) {
      if (sblHasNoInfo.current) {
        return PAGE.SBL_HAS_NO_INFO;
      }
      if (mainSigningComplete && allDocumentsUploaded) {
        return PAGE.PENDING_SUBSIDIARY;
      }
      return PAGE.METHOD;
    }

    // Subsidiary
    if (subsidiarySigningComplete) {
      if (!mainSigningComplete) {
        return PAGE.PENDING_MAIN;
      }
      return PAGE.PENDING_MAIN_UPLOAD_DOC;
    }
    return PAGE.METHOD;
  };
  var getPageToShow = function getPageToShow(willIdentifyLater, nextStep, signatureProcessState, applicationState, isMainApplicant, sblHasNoInfo) {
    if (productIsYxvisa) {
      return getPageToShowYxVisa(willIdentifyLater, nextStep, signatureProcessState, applicationState, isMainApplicant, sblHasNoInfo);
    }
    return getPageToShowGeneric(willIdentifyLater, nextStep, signatureProcessState);
  };
  var getContentToRender = function getContentToRender(page) {
    var _content$extendedProd = content[extendedProductType],
      textAboveMethodList = _content$extendedProd.textAboveMethodList,
      textAboveMethodListSigned = _content$extendedProd.textAboveMethodListSigned,
      contentEndPagePendingMain = _content$extendedProd.contentEndPagePendingMain,
      contentEndPagePendingSubsidary = _content$extendedProd.contentEndPagePendingSubsidary,
      contentEndPageSuccess = _content$extendedProd.contentEndPageSuccess,
      contentEndPageLater = _content$extendedProd.contentEndPageLater,
      contentEndPageSblHasNoInfo = _content$extendedProd.contentEndPageSblHasNoInfo;
    switch (page) {
      case PAGE.INSURANCE:
        {
          return /*#__PURE__*/React__default.createElement(Insurance, {
            name: name,
            insuranceTermsLink: insuranceTermsLink,
            termsOfPurchaseLink: termsOfPurchaseLink,
            chooseInsurance: chooseInsurance,
            insuranceIsMandatory: insuranceIsMandatory,
            brandStyle: brandStyle
          });
        }
      case PAGE.LATER:
        {
          return /*#__PURE__*/React__default.createElement(TitleAndText, {
            title: contentEndPageLater.title
          }, contentEndPageLater.text);
        }
      case PAGE.METHOD:
        {
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, productType.includes("CARD") && /*#__PURE__*/React__default.createElement("i", {
            style: {
              float: "right"
            }
          }, "Kredittramme: ", /*#__PURE__*/React__default.createElement("b", null, amountInKr, "kr")), trafficLightColor && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TitleAndText, {
            title: "Kredittvurdering",
            style: {
              marginBottom: "2rem"
            }
          }), /*#__PURE__*/React__default.createElement(TrafficLightSection, {
            trafficLightColor: trafficLightColor,
            type: "CREDIT"
          }), /*#__PURE__*/React__default.createElement(PersonalCredit, null)), /*#__PURE__*/React__default.createElement(ParagraphDivider, null), /*#__PURE__*/React__default.createElement(TitleAndText, {
            stepNumber: "1",
            showStep: sblNeeded,
            completed: documentsSigned,
            title: "Signering: ".concat(name)
          }, documentsSigned ? textAboveMethodListSigned.text : textAboveMethodList.text), !documentsSigned && /*#__PURE__*/React__default.createElement(MethodsList, {
            chooseIdentificationMethod: chooseIdentificationMethod,
            brandStyle: brandStyle,
            productType: productType
          }), sblNeeded && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ParagraphDivider, null), /*#__PURE__*/React__default.createElement(TitleAndText, {
            stepNumber: "2",
            showStep: sblNeeded,
            completed: allDocumentsUploaded,
            title: "Dokumentasjon"
          }), /*#__PURE__*/React__default.createElement(FetchDocuments, {
            getAltinnConsent: getAltinnConsent
          })));
        }
      case PAGE.PENDING_SUBSIDIARY:
        {
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TitleAndText, {
            title: contentEndPagePendingSubsidary.title
          }, contentEndPagePendingSubsidary.text), /*#__PURE__*/React__default.createElement(GoToCoApplicantButton, {
            productType: productType,
            brandStyle: brandStyle
          }));
        }
      case PAGE.PENDING_MAIN:
        {
          return /*#__PURE__*/React__default.createElement(TitleAndText, {
            title: contentEndPagePendingMain.title
          }, contentEndPagePendingMain.text);
        }
      case PAGE.SUCCESS:
        {
          return getRegularSuccessPage();
        }
      case PAGE.ACCOUNT_SUCCESS:
        {
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TitleAndText, {
            title: contentEndPageSuccess.title
          }, contentEndPageSuccess.text), /*#__PURE__*/React__default.createElement(H3, null, contentEndPageSuccess.creditCardTitle), /*#__PURE__*/React__default.createElement(Button, {
            label: contentEndPageSuccess.buttonLabel,
            maxWidth: "380px",
            onclick: function onclick() {
              window.location.href = "https://www.resursbank.no/kredittkort";
            },
            brandStyle: brandStyle
          }), /*#__PURE__*/React__default.createElement(TitleAndText, null, contentEndPageSuccess.greeting));
        }
      case PAGE.ERROR:
        {
          return "Teknisk feil.";
        }
      case PAGE.YX_SUCCESS:
        {
          return getYxSuccessPage();
        }
      case PAGE.PENDING_MAIN_UPLOAD_DOC:
        {
          return /*#__PURE__*/React__default.createElement(TitleAndText, {
            title: contentEndPagePendingMain.title
          }, contentEndPagePendingMain.text);
        }
      case PAGE.SBL_HAS_NO_INFO:
        {
          return /*#__PURE__*/React__default.createElement(TitleAndText, {
            title: contentEndPageSblHasNoInfo.title
          }, contentEndPageSblHasNoInfo.text);
        }
      case PAGE.MISSING:
      default:
        {
          return /*#__PURE__*/React__default.createElement("h1", null, "missing ", productType, " / ", nextStep);
        }
    }
  };
  var pageToShow = getPageToShow(willIdentifyLater, nextStep, signatureProcessState, applicationState, isMainApplicant, sblHasNoInfo);
  return /*#__PURE__*/React__default.createElement(IdentificationWrapper, null, getContentToRender(pageToShow));
}
IdentificationPageRenderer.propTypes = {
  nextStep: PropTypes.oneOf(["insurance", "method", "confirmation"]).isRequired,
  signatureProcessState: PropTypes.oneOf(["PENDING_SUBSIDIARY", "PENDING_MAIN", "COMPLETE", "PENDING_BOTH", "USER_CANCELLED", "TIMEOUT", "WRONG_USER", "UNKNOWN_ERROR"]),
  name: PropTypes.string.isRequired,
  amountInKr: PropTypes.number,
  productType: PropTypes.oneOf(["HIGHINTERESTACCOUNT", "YX_CARD", "YX_MOT_CARD", "YX_MICRO_CARD", "YX_CONVERT_CARD", "CREDIT_CARD", "ACCOUNT", "UNSECURED_LOAN", "REFINANCE_LOAN", "REFURBISH_LOAN"]).isRequired,
  willIdentifyLater: PropTypes.bool.isRequired,
  insuranceTermsLink: PropTypes.string.isRequired,
  termsOfPurchaseLink: PropTypes.string.isRequired,
  chooseInsurance: PropTypes.func.isRequired,
  chooseIdentificationMethod: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  insuranceIsMandatory: PropTypes.bool.isRequired,
  trafficLightColor: PropTypes.string,
  getAltinnConsent: PropTypes.func.isRequired,
  customerDocuments: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    documentState: PropTypes.string
  })),
  applicationState: PropTypes.string.isRequired,
  isMainApplicant: PropTypes.bool.isRequired,
  sblHasNoInfo: PropTypes.shape({
    current: PropTypes.bool
  }).isRequired,
  campaignId: PropTypes.string
};
IdentificationPageRenderer.defaultProps = {
  signatureProcessState: null,
  trafficLightColor: null,
  customerDocuments: [],
  amountInKr: null,
  campaignId: ""
};

function useIdentified(userVerified, setApplicationStatus, loadingCallback, errorCallback, isMainApplicant, requestService, sblHasNoInfo, signatureVerified) {
  var fetchAltinnTaxReturnsAndIncomeAndRegisterUploadeded = useCallback(function (authCode) {
    return requestService.fetchAltinnTaxReturnsAndIncome(authCode).then( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
        var typesToRegister, _iterator, _step, type;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                typesToRegister = [].concat(_toConsumableArray$3(response.data.receivedPaycheck ? ["paycheck"] : []), _toConsumableArray$3(response.data.receivedTaxReturns ? ["taxreturn"] : []));
                if (typesToRegister.length === 0) {
                  // eslint-disable-next-line no-param-reassign
                  sblHasNoInfo.current = true;
                }

                // eslint-disable-next-line no-restricted-syntax
                _iterator = _createForOfIteratorHelper(typesToRegister);
                _context.prev = 3;
                _iterator.s();
              case 5:
                if ((_step = _iterator.n()).done) {
                  _context.next = 11;
                  break;
                }
                type = _step.value;
                _context.next = 9;
                return requestService.registerDocumentsUploadedExternally(isMainApplicant, type);
              case 9:
                _context.next = 5;
                break;
              case 11:
                _context.next = 16;
                break;
              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](3);
                _iterator.e(_context.t0);
              case 16:
                _context.prev = 16;
                _iterator.f();
                return _context.finish(16);
              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 13, 16, 19]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }, [requestService, sblHasNoInfo, isMainApplicant]);
  var checkApplicationSigningStatus = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var response, _error$response$data, _error$response, _ref3, message, application, code;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            errorCallback({});
            loadingCallback(true);
            _context2.prev = 2;
            _context2.next = 5;
            return requestService.checkApplicationSigningStatus(isMainApplicant);
          case 5:
            response = _context2.sent;
            setApplicationStatus(response.data);
            _context2.next = 14;
            break;
          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](2);
            // handle 412 & 500 and render dynamic content from props
            _ref3 = (_error$response$data = (_error$response = _context2.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.data) !== null && _error$response$data !== void 0 ? _error$response$data : {}, message = _ref3.message, application = _ref3.application;
            code = _context2.t0.response.status;
            errorCallback({
              code: code,
              message: message,
              productType: application === null || application === void 0 ? void 0 : application.productType
            });
          case 14:
            _context2.prev = 14;
            loadingCallback(false);
            return _context2.finish(14);
          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 9, 14, 17]]);
  })), [errorCallback, loadingCallback, requestService, isMainApplicant, setApplicationStatus]);
  var handleIdentified = useCallback(function () {
    loadingCallback(true);
    var verifySignatureAndRemoveParam = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response, _error$response$data2, _error$response2, _ref5, message, application, code;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                errorCallback({});
                _context3.prev = 1;
                _context3.next = 4;
                return requestService.verifySignature(isMainApplicant);
              case 4:
                response = _context3.sent;
                // Inform backend to check if logged in through BankId
                setApplicationStatus(response.data);
                // eslint-disable-next-line no-param-reassign
                signatureVerified.current = true;
                removeIdentifiedUrlParameter();
                _context3.next = 10;
                return checkApplicationSigningStatus();
              case 10:
                _context3.next = 17;
                break;
              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](1);
                // handle 412 & 500 and render dynamic content from props
                _ref5 = (_error$response$data2 = (_error$response2 = _context3.t0.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data) !== null && _error$response$data2 !== void 0 ? _error$response$data2 : {}, message = _ref5.message, application = _ref5.application;
                code = _context3.t0.response.status;
                errorCallback({
                  code: code,
                  message: message,
                  productType: application === null || application === void 0 ? void 0 : application.productType
                });
              case 17:
                _context3.prev = 17;
                loadingCallback(false);
                return _context3.finish(17);
              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 12, 17, 20]]);
      }));
      return function verifySignatureAndRemoveParam() {
        return _ref4.apply(this, arguments);
      };
    }();
    // When a user has signed in via BankID, the backend needs some time to process that before we ask to verify.
    setTimeout(verifySignatureAndRemoveParam, 5000);
  }, [loadingCallback, errorCallback, requestService, isMainApplicant, setApplicationStatus, signatureVerified, checkApplicationSigningStatus]);
  useEffect(function () {
    if (!userVerified) return;
    // The 'identified' search param is set after user has been redirected from BankID login
    if (hasParam("identified")) {
      handleIdentified();
    } else if (hasParam("AuthorizationCode")) {
      // Redirected from Altinn login service
      loadingCallback(true);
      var getSsnThenFetchTaxAndIncomeThenRegisterUpload = /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
          var signingStatusResp, message, code;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.prev = 0;
                  _context4.next = 3;
                  return requestService.checkApplicationSigningStatus(isMainApplicant);
                case 3:
                  signingStatusResp = _context4.sent;
                  setApplicationStatus(signingStatusResp.data);
                  _context4.next = 15;
                  break;
                case 7:
                  _context4.prev = 7;
                  _context4.t0 = _context4["catch"](0);
                  // eslint-disable-next-line no-console
                  console.log("SigningActive::getSsnThenFetchTaxAndIncomeThenRegisterUpload error: ", _context4.t0);
                  message = _context4.t0.response.data.message;
                  code = _context4.t0.response.status;
                  errorCallback({
                    code: code,
                    message: message
                  });
                  loadingCallback(false);
                  return _context4.abrupt("return");
                case 15:
                  _context4.prev = 15;
                  _context4.next = 18;
                  return fetchAltinnTaxReturnsAndIncomeAndRegisterUploadeded(getParam("AuthorizationCode"));
                case 18:
                  removeAuthCodeParameter();
                  _context4.next = 21;
                  return checkApplicationSigningStatus();
                case 21:
                  _context4.next = 26;
                  break;
                case 23:
                  _context4.prev = 23;
                  _context4.t1 = _context4["catch"](15);
                  // eslint-disable-next-line no-console
                  console.log("got error in Altinn fetch", _context4.t1);
                case 26:
                  _context4.prev = 26;
                  loadingCallback(false);
                  return _context4.finish(26);
                case 29:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, null, [[0, 7], [15, 23, 26, 29]]);
        }));
        return function getSsnThenFetchTaxAndIncomeThenRegisterUpload() {
          return _ref6.apply(this, arguments);
        };
      }();
      getSsnThenFetchTaxAndIncomeThenRegisterUpload();
    } else {
      checkApplicationSigningStatus();
    }
  }, [checkApplicationSigningStatus, errorCallback, fetchAltinnTaxReturnsAndIncomeAndRegisterUploadeded, handleIdentified, isMainApplicant, loadingCallback, requestService, setApplicationStatus, userVerified]);
}

function IdentificationActive(props) {
  var sblDomain = props.sblDomain,
    cmsDomain = props.cmsDomain,
    insuranceTermsLink = props.insuranceTermsLink,
    termsOfPurchaseLink = props.termsOfPurchaseLink,
    consentManagerUrl = props.consentManagerUrl;
  var content = useTextContext();
  var _useState = useState({}),
    _useState2 = _slicedToArray$2(_useState, 2),
    applicationStatus = _useState2[0],
    setApplicationStatus = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray$2(_useState3, 2),
    showSpinner = _useState4[0],
    setShowSpinner = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray$2(_useState5, 2),
    blockingError = _useState6[0],
    setBlockingError = _useState6[1];
  var _useErrorContext = useErrorContext(),
    temporarilySetErrorsToDisplay = _useErrorContext.temporarilySetErrorsToDisplay;
  var sblHasNoInfo = useRef(false);
  var signatureVerified = useRef(true);
  var _useState7 = useState(false),
    _useState8 = _slicedToArray$2(_useState7, 2),
    willIdentifyLater = _useState8[0],
    setWillIdentifyLater = _useState8[1]; // server will not tell if "later" is selected, client needs to keep track of it

  var keycloakResult = useContext(AuthContext);
  var _useState9 = useState(null),
    _useState10 = _slicedToArray$2(_useState9, 2),
    trafficLightColor = _useState10[0],
    setTrafficLightColor = _useState10[1];
  var isSSR = typeof window === "undefined"; // Server-side rendering doesn't have any window object

  var applicationId = isSSR ? "" : getParam("applicationId");
  var requestService = useMemo(function () {
    return Requests(applicationId, sblDomain, cmsDomain, keycloakResult);
  }, [applicationId, cmsDomain, keycloakResult, sblDomain]);
  var isBlockingError = useCallback(function (errorData) {
    if (!errorData || errorData.code !== 412) {
      return true;
    }
    return !sblHasNoInfo.current && !signatureVerified.current;
  }, []);
  var handleBlockingError = useCallback(function (errorData) {
    if (isBlockingError(errorData)) {
      setBlockingError(errorData);
    }
  }, [isBlockingError]);
  var _useInitialInfo = useInitialInfo(keycloakResult.ssn, handleBlockingError, setShowSpinner, requestService),
    isMainApplicant = _useInitialInfo.isMainApplicant,
    userVerified = _useInitialInfo.userVerified,
    applicationStateId = _useInitialInfo.applicationStateId,
    productType = _useInitialInfo.productType;
  var _useDeadEndApplicatio = useDeadEndApplicationState(applicationStateId, productType),
    isDeadEnd = _useDeadEndApplicatio.isDeadEnd,
    deadEndTextBoxProps = _useDeadEndApplicatio.deadEndTextBoxProps;
  var fetchTrafficLightColor = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return requestService.fetchTrafficLightColor();
            case 3:
              response = _context.sent;
              setTrafficLightColor(response.data);
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function fetchTrafficLightColor() {
      return _ref.apply(this, arguments);
    };
  }();
  var haveToFetchTrafficLightColor = function haveToFetchTrafficLightColor(product) {
    return product.endsWith("_CARD") || product.endsWith("_LOAN");
  };
  useEffect(function () {
    if (productType && haveToFetchTrafficLightColor(productType)) {
      fetchTrafficLightColor();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productType]);
  useIdentified(userVerified, setApplicationStatus, setShowSpinner, handleBlockingError, isMainApplicant, requestService, sblHasNoInfo, signatureVerified);
  var brandStyle = productType !== null && productType !== void 0 && productType.includes("YX_") ? "yx" : "ya";
  var consentDetails = useMarketingConsent({
    consentManagerUrl: consentManagerUrl,
    keycloakToken: keycloakResult.token,
    channel: brandStyle,
    ssn: keycloakResult.ssn,
    isUserVerified: userVerified
  });
  var handleIdentifyLater = function handleIdentifyLater() {
    setWillIdentifyLater(true);
  };
  var chooseIdentificationMethod = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(identificationMethod) {
      var redirectUrlCancel, redirectUrlCompleted, redirectUrlRejected, response, redirectUrl, _error$response$data, _error$response, _ref3, message;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              redirectUrlCancel = getUrlWithAppendedParams({
                identified: "canceled"
              });
              redirectUrlCompleted = getUrlWithAppendedParams({
                identified: "completed"
              });
              redirectUrlRejected = getUrlWithAppendedParams({
                identified: "rejected"
              });
              setShowSpinner(true);
              _context2.prev = 4;
              _context2.next = 7;
              return requestService.chooseIdentificationMethod(isMainApplicant, identificationMethod, redirectUrlCancel, redirectUrlCompleted, redirectUrlRejected);
            case 7:
              response = _context2.sent;
              if (identificationMethod !== "LATER" && window !== "undefined") {
                redirectUrl = response.data.redirectUrl;
                window.location.href = redirectUrl;
              } else {
                // todo, what to do here?
                // I think the response should be used to setApplicationStatus and that the interpreted response should result in EndPage..
                handleIdentifyLater();
              }
              _context2.next = 15;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](4);
              _ref3 = (_error$response$data = (_error$response = _context2.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.data) !== null && _error$response$data !== void 0 ? _error$response$data : {}, message = _ref3.message;
              temporarilySetErrorsToDisplay("chooseIdentificationMethod", message, 10);
            case 15:
              _context2.prev = 15;
              setShowSpinner(false);
              return _context2.finish(15);
            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 11, 15, 18]]);
    }));
    return function chooseIdentificationMethod(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  if (isDeadEnd) {
    var title = deadEndTextBoxProps.title,
      subtitle = deadEndTextBoxProps.subtitle,
      text = deadEndTextBoxProps.text;
    return /*#__PURE__*/React__default.createElement(DeadEndTextBox, {
      title: title,
      subtitle: subtitle,
      text: text
    });
  }
  if (blockingError.code) {
    if (!blockingError.productType) {
      return /*#__PURE__*/React__default.createElement(DeadEndTextBox, {
        text: blockingError.message,
        isError: true
      });
    }
    if (blockingError.code === 412) {
      return /*#__PURE__*/React__default.createElement(DeadEndTextBox, {
        title: content[blockingError.productType].contentEndPageInvalidState.title,
        text: content[blockingError.productType].contentEndPageInvalidState.text,
        isError: true
      });
    }
    if (blockingError.code === 500) {
      return /*#__PURE__*/React__default.createElement(DeadEndTextBox, {
        title: content[blockingError.productType].contentEndPageTechnicalError.title,
        text: content[blockingError.productType].contentEndPageTechnicalError.text
      });
    }
    return /*#__PURE__*/React__default.createElement(DeadEndTextBox, {
      text: blockingError.message,
      isError: true
    });
  }
  var getContentToRender = function getContentToRender() {
    var _applicationStatus$ap, _applicationStatus$ap2, _applicationStatus$ap3;
    var application = (_applicationStatus$ap = applicationStatus.application) === null || _applicationStatus$ap === void 0 ? void 0 : _applicationStatus$ap[isMainApplicant ? "mainApplicantApplication" : "subsidiaryApplicantApplication"];
    var applicant = application.applicant;
    var getAltinnConsent = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var ssn, fullName, possibleLastNames, getAltinnConsentRequests;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                ssn = applicant.ssn, fullName = applicant.name; // The last name could be more than one
                possibleLastNames = fullName.split(" ").filter(function (_, i) {
                  return i !== 0;
                }).map(function (_, i, array) {
                  return array.slice(i).join(" ");
                }).reverse(); // "FirstName Middlename af Lastname" > ["Lastname", "af Lastname", "Midlename af Lastname"]
                getAltinnConsentRequests = possibleLastNames.map(function (lastName) {
                  return requestService.getAltinnConsent(ssn, lastName);
                });
                setShowSpinner(true);
                Promise.any(getAltinnConsentRequests).then(function (response) {
                  window.location.href = response.data.consent;
                }).catch(function (error) {
                  var _error$response$data2, _error$response2;
                  console.error(error);
                  var _ref5 = (_error$response$data2 = (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data) !== null && _error$response$data2 !== void 0 ? _error$response$data2 : {},
                    message = _ref5.message;
                  temporarilySetErrorsToDisplay("getAltinnConsent", message, 5);
                  setShowSpinner(false);
                });
              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return function getAltinnConsent() {
        return _ref4.apply(this, arguments);
      };
    }();
    var chooseInsurance = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(acceptTerms, wantInsurance) {
        var response, _error$response$data3, _error$response3, _ref7, message;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                setShowSpinner(true);
                _context4.prev = 1;
                _context4.next = 4;
                return requestService.chooseInsurance(isMainApplicant, acceptTerms, wantInsurance, applicant.ssn);
              case 4:
                response = _context4.sent;
                setApplicationStatus(function (prev) {
                  return _objectSpread2$4(_objectSpread2$4({}, prev), response.data);
                });
                _context4.next = 12;
                break;
              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](1);
                _ref7 = (_error$response$data3 = (_error$response3 = _context4.t0.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.data) !== null && _error$response$data3 !== void 0 ? _error$response$data3 : {}, message = _ref7.message;
                temporarilySetErrorsToDisplay("chooseInsurance", message, 5);
              case 12:
                _context4.prev = 12;
                setShowSpinner(false);
                return _context4.finish(12);
              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 8, 12, 15]]);
      }));
      return function chooseInsurance(_x2, _x3) {
        return _ref6.apply(this, arguments);
      };
    }();
    if (consentDetails.shouldAskForConsent) {
      return /*#__PURE__*/React__default.createElement(ConsentView, {
        name: applicant.name,
        description: consentDetails.description,
        consentText: consentDetails.consentText,
        registerConsent: consentDetails.registerConsent,
        brandStyle: brandStyle
      });
    }
    var insuranceIsMandatory = (_applicationStatus$ap2 = applicationStatus === null || applicationStatus === void 0 ? void 0 : (_applicationStatus$ap3 = applicationStatus.application) === null || _applicationStatus$ap3 === void 0 ? void 0 : _applicationStatus$ap3.insuranceIsMandatory) !== null && _applicationStatus$ap2 !== void 0 ? _applicationStatus$ap2 : false;
    var applicationState = applicationStatus.application.applicationStateId;
    var campaignId = applicationStatus.application.campaignId;
    return /*#__PURE__*/React__default.createElement(IdentificationPageRenderer, {
      nextStep: applicationStatus.nextStep,
      signatureProcessState: applicationStatus.signatureProcessState,
      name: applicant.name,
      amountInKr: applicationStatus.application.appliedAmount,
      productType: productType,
      willIdentifyLater: willIdentifyLater,
      insuranceTermsLink: insuranceTermsLink,
      termsOfPurchaseLink: termsOfPurchaseLink,
      chooseInsurance: chooseInsurance,
      chooseIdentificationMethod: chooseIdentificationMethod,
      insuranceIsMandatory: insuranceIsMandatory,
      trafficLightColor: trafficLightColor,
      getAltinnConsent: getAltinnConsent,
      customerDocuments: application.customerDocuments,
      applicationState: applicationState,
      isMainApplicant: isMainApplicant,
      sblHasNoInfo: sblHasNoInfo,
      campaignId: campaignId
    });
  };
  var shouldShowSpinner = !Object.keys(applicationStatus).length || showSpinner || consentDetails.isLoading;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, Object.keys(applicationStatus).length ? getContentToRender() : null, shouldShowSpinner ? /*#__PURE__*/React__default.createElement(LoadingOverlay, {
    brandStyle: brandStyle
  }) : null);
}
IdentificationActive.propTypes = {
  sblDomain: PropTypes.string.isRequired,
  cmsDomain: PropTypes.string.isRequired,
  insuranceTermsLink: PropTypes.string.isRequired,
  termsOfPurchaseLink: PropTypes.string.isRequired,
  consentManagerUrl: PropTypes.string.isRequired
};

function SecuredIdentificationActive$1(_ref) {
  var identificationActiveData = _ref.identificationActiveData,
    keycloakData = _ref.keycloakData;
  return /*#__PURE__*/React__default.createElement(SystemStatus, {
    cmsHelperUrl: identificationActiveData.cmsDomain
  }, /*#__PURE__*/React__default.createElement(Auth, {
    url: keycloakData.url,
    realm: keycloakData.realm,
    clientId: keycloakData.clientId,
    targetPage: "IdentificationActive"
  }, /*#__PURE__*/React__default.createElement(TextProvider, null, /*#__PURE__*/React__default.createElement(ErrorProvider, null, /*#__PURE__*/React__default.createElement(IdentificationActive, {
    sblDomain: identificationActiveData.sblDomain,
    cmsDomain: identificationActiveData.cmsDomain,
    insuranceTermsLink: identificationActiveData.insuranceTermsLink,
    termsOfPurchaseLink: identificationActiveData.termsOfPurchaseLink,
    consentManagerUrl: identificationActiveData.consentManagerUrl
  })))));
}
SecuredIdentificationActive$1.propTypes = {
  identificationActiveData: PropTypes.shape({
    sblDomain: PropTypes.string.isRequired,
    cmsDomain: PropTypes.string.isRequired,
    insuranceTermsLink: PropTypes.string.isRequired,
    termsOfPurchaseLink: PropTypes.string.isRequired,
    consentManagerUrl: PropTypes.string.isRequired
  }).isRequired,
  keycloakData: PropTypes.shape({
    url: PropTypes.string.isRequired,
    realm: PropTypes.string.isRequired,
    clientId: PropTypes.string.isRequired
  }).isRequired
};

var _overridablePropsSets;
var PropsSets = Object.freeze({
  Forms: Symbol("forms"),
  Loan: Symbol("loan"),
  Calculator: Symbol("calculator"),
  Consents: Symbol("consents"),
  Signing: Symbol("signing"),
  Identification: Symbol("identification")
});

// These props can be overriden by test options in a test environment.
var overridablePropsSets = (_overridablePropsSets = {}, _defineProperty$5(_overridablePropsSets, PropsSets.Forms, {
  baseApiUrl: "cmshelperUrl"
}), _defineProperty$5(_overridablePropsSets, PropsSets.Loan, {
  baseApiUrl: "cmshelperUrl",
  calculatorEndpointURL: "calculatorserviceUrl"
}), _defineProperty$5(_overridablePropsSets, PropsSets.Calculator, {
  endpointURL: "calculatorserviceUrl"
}), _defineProperty$5(_overridablePropsSets, PropsSets.Consents, {
  endpointUrl: "consentmanagerUrl",
  cmsHelperUrl: "cmshelperUrl",
  "keycloakData.url": "keycloakUrl"
}), _defineProperty$5(_overridablePropsSets, PropsSets.Signing, {
  "keycloakData.url": "keycloakUrl",
  "signingActiveData.cmsDomain": "cmshelperUrl",
  "signingActiveData.sblDomain": "sblbinUrl",
  "signingActiveData.consentManagerUrl": "consentmanagerUrl"
}), _defineProperty$5(_overridablePropsSets, PropsSets.Identification, {
  "keycloakData.url": "keycloakUrl",
  "identificationActiveData.cmsDomain": "cmshelperUrl",
  "identificationActiveData.sblDomain": "sblbinUrl"
}), _overridablePropsSets);
function getPropNameAndParentByPath(obj, propPath) {
  var pathSteps = propPath.split(".");
  var propName = pathSteps.pop();
  var propObj = obj;
  pathSteps.forEach(function (step) {
    var _propObj;
    propObj = (_propObj = propObj) === null || _propObj === void 0 ? void 0 : _propObj[step];
  });
  return [propName, propObj];
}
function getPropByPath(obj, propPath) {
  var _getPropNameAndParent = getPropNameAndParentByPath(obj, propPath),
    _getPropNameAndParent2 = _slicedToArray$2(_getPropNameAndParent, 2),
    propName = _getPropNameAndParent2[0],
    propObj = _getPropNameAndParent2[1];
  return propObj === null || propObj === void 0 ? void 0 : propObj[propName];
}
function setPropByPath(obj, propPath, value) {
  var _getPropNameAndParent3 = getPropNameAndParentByPath(obj, propPath),
    _getPropNameAndParent4 = _slicedToArray$2(_getPropNameAndParent3, 2),
    propName = _getPropNameAndParent4[0],
    propObj = _getPropNameAndParent4[1];
  if (propObj) {
    propObj[propName] = value;
  }
}
var testOptions = getTestOptions();

// Return a new component function where incoming properties
// are overridden by testOptions.
function overrideFactory(OrigComponent, propSet) {
  if (!testOptions) {
    return OrigComponent;
  }
  return function OverriddenComponent(props) {
    var newProps = JSON.parse(JSON.stringify(props));
    var overridables = overridablePropsSets[propSet];
    Object.entries(overridables).forEach(function (_ref) {
      var _ref2 = _slicedToArray$2(_ref, 2),
        propPath = _ref2[0],
        option = _ref2[1];
      if (Object.hasOwn(testOptions, option)) {
        // Override url/prop if option provided
        setPropByPath(newProps, propPath, testOptions[option]);
      } else if (typeof testOptions.inUrlReplace === "string") {
        // Override url/prop if pattern matches
        var _testOptions$inUrlRep = testOptions.inUrlReplace.split("|"),
          _testOptions$inUrlRep2 = _slicedToArray$2(_testOptions$inUrlRep, 2),
          pattern = _testOptions$inUrlRep2[0],
          replace = _testOptions$inUrlRep2[1];
        var currentUrl = getPropByPath(newProps, propPath);
        if (pattern && replace && currentUrl) {
          var newUrl = currentUrl.replace(pattern, replace);
          setPropByPath(newProps, propPath, newUrl);
        }
      }
    });

    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/React__default.createElement(OrigComponent, newProps);
  };
}

var Brukskonto = overrideFactory(Brukskonto$1, PropsSets.Forms);
var Hoyrentekonto = overrideFactory(Hoyrentekonto$1, PropsSets.Forms);
var KreditKort = overrideFactory(KredittKort, PropsSets.Forms);
var YXVisa = overrideFactory(YXVisa$1, PropsSets.Forms);
var PrivateLoan = overrideFactory(Form, PropsSets.Loan);
var CalculatorActive = overrideFactory(Calculator, PropsSets.Calculator);
var SecuredCustomerCenterConsents = overrideFactory(SecuredCustomerCenterConsents$1, PropsSets.Consents);
var SecuredCustomerConsents = overrideFactory(SecuredCustomerConsents$1, PropsSets.Consents);
var SecuredMarketingConsents = overrideFactory(SecuredMarketingConsents$1, PropsSets.Consents);
var SecuredSigningActive = overrideFactory(SecuredSigningActive$1, PropsSets.Signing);
var SecuredIdentificationActive = overrideFactory(SecuredIdentificationActive$1, PropsSets.Identification);

export { Auth, AuthContext, Brukskonto, CalculatorActive, Hoyrentekonto, KreditKort, PrivateLoan, SecuredCustomerCenterConsents, SecuredCustomerConsents, SecuredIdentificationActive, SecuredMarketingConsents, SecuredSigningActive, YXVisa };
